//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface ICustomWebDocumentViewerService {
    invokePOST(): Observable<FileResponse>;
    invokeGET(): Observable<FileResponse>;
    invokeOPTIONS(): Observable<FileResponse>;
    getLocalization(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomWebDocumentViewerService implements ICustomWebDocumentViewerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    invokePOST(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXRDV";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvokePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvokePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInvokePOST(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    invokeGET(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXRDV";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvokeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvokeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInvokeGET(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    invokeOPTIONS(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXRDV";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvokeOPTIONS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvokeOPTIONS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInvokeOPTIONS(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLocalization(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXRDV/GetLocalization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLocalization(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomReportDesignerService {
    invoke(): Observable<FileResponse>;
    getLocalization(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomReportDesignerService implements ICustomReportDesignerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    invoke(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXRD";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInvoke(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLocalization(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXRD/GetLocalization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLocalization(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomQueryBuilderService {
    invoke(): Observable<FileResponse>;
    getLocalization(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomQueryBuilderService implements ICustomQueryBuilderService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    invoke(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXQB";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInvoke(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLocalization(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXQB/GetLocalization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLocalization(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAddressService {
    /**
     * Get Address
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<AddressModel>;
    /**
     * Get Address
     * @param entityId (optional) 
     * @param type (optional) 
     */
    getByType(entityId?: string | undefined, type?: AddressType | undefined): Observable<AddressModel[]>;
    /**
     * Get Address
     * @param entityId (optional) 
     */
    getByEntity(entityId?: string | undefined): Observable<AddressModel[]>;
    /**
     * Get Address by Supplier
     */
    getAll(): Observable<AddressModel[]>;
    /**
     * Add or update Address
     */
    post(model: AddressModel): Observable<AddressModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class AddressService implements IAddressService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Address
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<AddressModel> {
        let url_ = this.baseUrl + "/api/Address/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AddressModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Address
     * @param entityId (optional) 
     * @param type (optional) 
     */
    getByType(entityId?: string | undefined, type?: AddressType | undefined): Observable<AddressModel[]> {
        let url_ = this.baseUrl + "/api/Address/GetByType?";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressModel[]>;
        }));
    }

    protected processGetByType(response: HttpResponseBase): Observable<AddressModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Address
     * @param entityId (optional) 
     */
    getByEntity(entityId?: string | undefined): Observable<AddressModel[]> {
        let url_ = this.baseUrl + "/api/Address/GetByEntity?";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressModel[]>;
        }));
    }

    protected processGetByEntity(response: HttpResponseBase): Observable<AddressModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Address by Supplier
     */
    getAll(): Observable<AddressModel[]> {
        let url_ = this.baseUrl + "/api/Address/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AddressModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Address
     */
    post(model: AddressModel): Observable<AddressModel> {
        let url_ = this.baseUrl + "/api/Address/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<AddressModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Address/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAgreementService {
    getLocations(): Observable<AgreementLocationModel[]>;
    get(customerId?: string | undefined): Observable<AgreementModel>;
    getAgreementById(id?: string | undefined): Observable<AgreementModel>;
    getAllForCustomer(customerId?: string | undefined): Observable<AgreementModel[]>;
    createOrUpdateAgreement(agreement: AgreementModel): Observable<AgreementModel>;
    postAgreementLocation(model: AgreementLocationModel): Observable<AgreementLocationModel>;
    getReport(type?: string | null | undefined, id?: string | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class AgreementService implements IAgreementService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLocations(): Observable<AgreementLocationModel[]> {
        let url_ = this.baseUrl + "/api/Agreement/GetLocations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementLocationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementLocationModel[]>;
        }));
    }

    protected processGetLocations(response: HttpResponseBase): Observable<AgreementLocationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgreementLocationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(customerId?: string | undefined): Observable<AgreementModel> {
        let url_ = this.baseUrl + "/api/Agreement/Get?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AgreementModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAgreementById(id?: string | undefined): Observable<AgreementModel> {
        let url_ = this.baseUrl + "/api/Agreement/GetAgreementById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgreementById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgreementById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementModel>;
        }));
    }

    protected processGetAgreementById(response: HttpResponseBase): Observable<AgreementModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllForCustomer(customerId?: string | undefined): Observable<AgreementModel[]> {
        let url_ = this.baseUrl + "/api/Agreement/GetAllForCustomer?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementModel[]>;
        }));
    }

    protected processGetAllForCustomer(response: HttpResponseBase): Observable<AgreementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgreementModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrUpdateAgreement(agreement: AgreementModel): Observable<AgreementModel> {
        let url_ = this.baseUrl + "/api/Agreement/CreateOrUpdateAgreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agreement);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAgreement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementModel>;
        }));
    }

    protected processCreateOrUpdateAgreement(response: HttpResponseBase): Observable<AgreementModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postAgreementLocation(model: AgreementLocationModel): Observable<AgreementLocationModel> {
        let url_ = this.baseUrl + "/api/Agreement/PostAgreementLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAgreementLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAgreementLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementLocationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementLocationModel>;
        }));
    }

    protected processPostAgreementLocation(response: HttpResponseBase): Observable<AgreementLocationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementLocationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(type?: string | null | undefined, id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Agreement/GetReport?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAuditService {
    getHistory(entityId?: string | undefined): Observable<HistoryModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class AuditService implements IAuditService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getHistory(entityId?: string | undefined): Observable<HistoryModel[]> {
        let url_ = this.baseUrl + "/api/Audit/GetHistory?";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoryModel[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<HistoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HistoryModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAuditRouteService {
    getAll(): Observable<AuditRouteModel[]>;
    get(id?: string | undefined): Observable<AuditRouteModel>;
    updateAuditVisitViewsIndexes(visits: AuditVisitViewModel[], routeId?: string | undefined): Observable<AuditVisitViewModel[]>;
    updateAuditRoutWithVisits(model: AuditRouteModelDTO): Observable<AuditRouteModelDTO>;
    post(model: AuditRouteModel): Observable<AuditRouteModel>;
    delete(id?: string | undefined): Observable<AuditRouteModel>;
    getReport(type?: string | null | undefined, routeId?: string | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class AuditRouteService implements IAuditRouteService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<AuditRouteModel[]> {
        let url_ = this.baseUrl + "/api/AuditRoute/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditRouteModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditRouteModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AuditRouteModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditRouteModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id?: string | undefined): Observable<AuditRouteModel> {
        let url_ = this.baseUrl + "/api/AuditRoute/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditRouteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditRouteModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AuditRouteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditRouteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAuditVisitViewsIndexes(visits: AuditVisitViewModel[], routeId?: string | undefined): Observable<AuditVisitViewModel[]> {
        let url_ = this.baseUrl + "/api/AuditRoute/UpdateAuditVisitViewsIndexes?";
        if (routeId === null)
            throw new globalThis.Error("The parameter 'routeId' cannot be null.");
        else if (routeId !== undefined)
            url_ += "routeId=" + encodeURIComponent("" + routeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(visits);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAuditVisitViewsIndexes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAuditVisitViewsIndexes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditVisitViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditVisitViewModel[]>;
        }));
    }

    protected processUpdateAuditVisitViewsIndexes(response: HttpResponseBase): Observable<AuditVisitViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditVisitViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAuditRoutWithVisits(model: AuditRouteModelDTO): Observable<AuditRouteModelDTO> {
        let url_ = this.baseUrl + "/api/AuditRoute/UpdateAuditRoutWithVisits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAuditRoutWithVisits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAuditRoutWithVisits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditRouteModelDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditRouteModelDTO>;
        }));
    }

    protected processUpdateAuditRoutWithVisits(response: HttpResponseBase): Observable<AuditRouteModelDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditRouteModelDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: AuditRouteModel): Observable<AuditRouteModel> {
        let url_ = this.baseUrl + "/api/AuditRoute/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditRouteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditRouteModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<AuditRouteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditRouteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<AuditRouteModel> {
        let url_ = this.baseUrl + "/api/AuditRoute/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditRouteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditRouteModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<AuditRouteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditRouteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(type?: string | null | undefined, routeId?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/AuditRoute/GetReport?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (routeId === null)
            throw new globalThis.Error("The parameter 'routeId' cannot be null.");
        else if (routeId !== undefined)
            url_ += "routeId=" + encodeURIComponent("" + routeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAuditVisitService {
    getAll(): Observable<AuditVisitModel[]>;
    getByOrganization(organizationId?: string | undefined): Observable<AuditVisitModel[]>;
    getAllViews(): Observable<AuditVisitViewModel[]>;
    get(id?: string | undefined): Observable<AuditVisitModel>;
    getView(id?: string | undefined): Observable<AuditVisitViewModel>;
    getViewsByRouteId(routeId?: string | undefined): Observable<AuditVisitViewModel[]>;
    updateDuration(auditVisitId?: string | undefined, duration?: number | undefined): Observable<AuditVisitModel>;
    post(model: AuditVisitModel): Observable<AuditVisitModel>;
    deleteVisit(id?: string | undefined): Observable<AuditVisitModel>;
    generateRoute(model: AuditRouteModel): Observable<DirectionsResult>;
    getPlaceIdFromAddress(address: AddressModel): Observable<string>;
    getReport(type?: string | null | undefined, visitId?: string | undefined): Observable<FileResponse>;
    getVisitNotificationSettings(): Observable<PropertyGroupDataModel[]>;
    sendNotification(model: SendVisitNotificationModel): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class AuditVisitService implements IAuditVisitService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<AuditVisitModel[]> {
        let url_ = this.baseUrl + "/api/AuditVisit/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditVisitModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditVisitModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AuditVisitModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditVisitModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByOrganization(organizationId?: string | undefined): Observable<AuditVisitModel[]> {
        let url_ = this.baseUrl + "/api/AuditVisit/GetByOrganization?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditVisitModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditVisitModel[]>;
        }));
    }

    protected processGetByOrganization(response: HttpResponseBase): Observable<AuditVisitModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditVisitModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllViews(): Observable<AuditVisitViewModel[]> {
        let url_ = this.baseUrl + "/api/AuditVisit/GetAllViews";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllViews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllViews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditVisitViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditVisitViewModel[]>;
        }));
    }

    protected processGetAllViews(response: HttpResponseBase): Observable<AuditVisitViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditVisitViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id?: string | undefined): Observable<AuditVisitModel> {
        let url_ = this.baseUrl + "/api/AuditVisit/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditVisitModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditVisitModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AuditVisitModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditVisitModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getView(id?: string | undefined): Observable<AuditVisitViewModel> {
        let url_ = this.baseUrl + "/api/AuditVisit/GetView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditVisitViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditVisitViewModel>;
        }));
    }

    protected processGetView(response: HttpResponseBase): Observable<AuditVisitViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditVisitViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getViewsByRouteId(routeId?: string | undefined): Observable<AuditVisitViewModel[]> {
        let url_ = this.baseUrl + "/api/AuditVisit/GetViewsByRouteId?";
        if (routeId === null)
            throw new globalThis.Error("The parameter 'routeId' cannot be null.");
        else if (routeId !== undefined)
            url_ += "routeId=" + encodeURIComponent("" + routeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViewsByRouteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViewsByRouteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditVisitViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditVisitViewModel[]>;
        }));
    }

    protected processGetViewsByRouteId(response: HttpResponseBase): Observable<AuditVisitViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditVisitViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDuration(auditVisitId?: string | undefined, duration?: number | undefined): Observable<AuditVisitModel> {
        let url_ = this.baseUrl + "/api/AuditVisit/UpdateDuration?";
        if (auditVisitId === null)
            throw new globalThis.Error("The parameter 'auditVisitId' cannot be null.");
        else if (auditVisitId !== undefined)
            url_ += "auditVisitId=" + encodeURIComponent("" + auditVisitId) + "&";
        if (duration === null)
            throw new globalThis.Error("The parameter 'duration' cannot be null.");
        else if (duration !== undefined)
            url_ += "duration=" + encodeURIComponent("" + duration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDuration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDuration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditVisitModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditVisitModel>;
        }));
    }

    protected processUpdateDuration(response: HttpResponseBase): Observable<AuditVisitModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditVisitModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: AuditVisitModel): Observable<AuditVisitModel> {
        let url_ = this.baseUrl + "/api/AuditVisit/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditVisitModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditVisitModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<AuditVisitModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditVisitModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVisit(id?: string | undefined): Observable<AuditVisitModel> {
        let url_ = this.baseUrl + "/api/AuditVisit/DeleteVisit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVisit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVisit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditVisitModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditVisitModel>;
        }));
    }

    protected processDeleteVisit(response: HttpResponseBase): Observable<AuditVisitModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditVisitModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateRoute(model: AuditRouteModel): Observable<DirectionsResult> {
        let url_ = this.baseUrl + "/api/AuditVisit/GenerateRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DirectionsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DirectionsResult>;
        }));
    }

    protected processGenerateRoute(response: HttpResponseBase): Observable<DirectionsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DirectionsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPlaceIdFromAddress(address: AddressModel): Observable<string> {
        let url_ = this.baseUrl + "/api/AuditVisit/GetPlaceIdFromAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(address);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlaceIdFromAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlaceIdFromAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPlaceIdFromAddress(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(type?: string | null | undefined, visitId?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/AuditVisit/GetReport?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (visitId === null)
            throw new globalThis.Error("The parameter 'visitId' cannot be null.");
        else if (visitId !== undefined)
            url_ += "visitId=" + encodeURIComponent("" + visitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVisitNotificationSettings(): Observable<PropertyGroupDataModel[]> {
        let url_ = this.baseUrl + "/api/AuditVisit/GetVisitNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisitNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisitNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyGroupDataModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyGroupDataModel[]>;
        }));
    }

    protected processGetVisitNotificationSettings(response: HttpResponseBase): Observable<PropertyGroupDataModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyGroupDataModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendNotification(model: SendVisitNotificationModel): Observable<string> {
        let url_ = this.baseUrl + "/api/AuditVisit/SendNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendNotification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICalendarService {
    getAll(): Observable<CalendarModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CalendarService implements ICalendarService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<CalendarModel[]> {
        let url_ = this.baseUrl + "/api/Calendar/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CalendarModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICapabilityService {
    /**
     * Get Capability
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CapabilityModel>;
    /**
     * Get Capability by Supplier
     */
    getAll(): Observable<CapabilityModel[]>;
    /**
     * Add or update Capability
     */
    post(model: CapabilityModel): Observable<CapabilityModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CapabilityService implements ICapabilityService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Capability
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CapabilityModel> {
        let url_ = this.baseUrl + "/api/Capability/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CapabilityModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CapabilityModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CapabilityModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CapabilityModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Capability by Supplier
     */
    getAll(): Observable<CapabilityModel[]> {
        let url_ = this.baseUrl + "/api/Capability/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CapabilityModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CapabilityModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CapabilityModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CapabilityModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Capability
     */
    post(model: CapabilityModel): Observable<CapabilityModel> {
        let url_ = this.baseUrl + "/api/Capability/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CapabilityModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CapabilityModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<CapabilityModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CapabilityModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Capability/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICarrierService {
    get(id?: string | undefined): Observable<CarrierModel>;
    getAll(): Observable<CarrierModel[]>;
    /**
     * Add or update RiskAnalysis
     */
    post(model: CarrierModel): Observable<CarrierModel>;
}

@Injectable({
    providedIn: 'root'
})
export class CarrierService implements ICarrierService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id?: string | undefined): Observable<CarrierModel> {
        let url_ = this.baseUrl + "/api/Carrier/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarrierModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarrierModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CarrierModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<CarrierModel[]> {
        let url_ = this.baseUrl + "/api/Carrier/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarrierModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarrierModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CarrierModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CarrierModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    post(model: CarrierModel): Observable<CarrierModel> {
        let url_ = this.baseUrl + "/api/Carrier/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarrierModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarrierModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<CarrierModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICcpService {
    /**
     * Get Ccp
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CcpModel>;
    /**
     * Get Ccp by RiskFactor
     * @param isDeleted (optional) 
     */
    getAll(isDeleted?: boolean | undefined): Observable<CcpModel[]>;
    /**
     * Get Ccp by RiskFactor
     * @param startTime (optional) 
     */
    getScheduled(startTime?: Date | null | undefined): Observable<CcpModel[]>;
    getGroupedSchedule(startDate?: Date | null | undefined, coming?: boolean | undefined, departmentId?: string | null | undefined): Observable<CcpScheduleOverview[]>;
    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getScheduledByGroup(id?: string | undefined): Observable<CcpModel[]>;
    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getChildrenByParentId(id?: string | undefined): Observable<CcpModel[]>;
    removeChildFromParent(parentId?: string | undefined, childId?: string | undefined): Observable<string>;
    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getChildrenByGroupId(id?: string | undefined): Observable<CcpModel[]>;
    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getRelationsByGroupId(id?: string | undefined): Observable<CcpRelationModel[]>;
    getRelationsByParentId(id?: string | undefined): Observable<CcpRelationModel[]>;
    saveSort(relations: CcpRelationModel[]): Observable<CcpRelationModel[]>;
    getCcpScheduleOverview(groupId?: string | undefined, startDateUtc?: Date | undefined, recalculate?: boolean | undefined): Observable<CcpScheduleOverview[]>;
    sendLateNotification(receivers: string[], organizationId?: string | undefined): Observable<void>;
    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getByRiskFactor(id?: string | undefined): Observable<CcpModel[]>;
    /**
     * Get Ccp by RiskAnalysis
     * @param id (optional) 
     */
    getByRiskAnalysis(id?: string | undefined): Observable<CcpModel[]>;
    /**
     * Get Ccp by Department
     * @param id (optional) 
     */
    getByDepartment(id?: string | undefined): Observable<CcpModel[]>;
    /**
     * Get Ccps by filter values
     * @param id (optional) 
     * @param isDeleted (optional) 
     */
    getCcpsByFilter(id?: string | null | undefined, isDeleted?: boolean | null | undefined): Observable<CcpModel[]>;
    /**
     * Get Ccp by RiskCategory
     * @param id (optional) 
     */
    getByRecipe(id?: string | undefined): Observable<CcpModel[]>;
    /**
     * Get Ccp by RiskCategory
     * @param id (optional) 
     */
    getByProcess(id?: string | undefined): Observable<CcpModel[]>;
    /**
     * Get Ccp by Product Variant
     * @param id (optional) 
     */
    getByProductVariant(id?: string | undefined): Observable<CcpModel[]>;
    /**
     * Add or update Ccp
     */
    postRecipeLimits(model: CcpModel): Observable<CcpModel>;
    /**
     * Add or update Ccp
     */
    post(model: CcpModel): Observable<CcpModel>;
    getReport(type?: string | null | undefined, id?: string | undefined): Observable<FileResponse>;
    /**
     * Get RiskCategory by RiskAnalysis
     * @param id (optional) 
     */
    getByOrganization(id?: string | undefined): Observable<CcpModel[]>;
    copy(ccpId?: string | undefined, newName?: string | null | undefined, targetDepartmentId?: string | null | undefined): Observable<CcpModel>;
    delete(id?: string | undefined): Observable<string>;
    unDelete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CcpService implements ICcpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Ccp
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CcpModel> {
        let url_ = this.baseUrl + "/api/Ccp/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CcpModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskFactor
     * @param isDeleted (optional) 
     */
    getAll(isDeleted?: boolean | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetAll?";
        if (isDeleted === null)
            throw new globalThis.Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskFactor
     * @param startTime (optional) 
     */
    getScheduled(startTime?: Date | null | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetScheduled?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetScheduled(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGroupedSchedule(startDate?: Date | null | undefined, coming?: boolean | undefined, departmentId?: string | null | undefined): Observable<CcpScheduleOverview[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetGroupedSchedule?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (coming === null)
            throw new globalThis.Error("The parameter 'coming' cannot be null.");
        else if (coming !== undefined)
            url_ += "coming=" + encodeURIComponent("" + coming) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupedSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupedSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpScheduleOverview[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpScheduleOverview[]>;
        }));
    }

    protected processGetGroupedSchedule(response: HttpResponseBase): Observable<CcpScheduleOverview[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpScheduleOverview.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getScheduledByGroup(id?: string | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetScheduledByGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduledByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduledByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetScheduledByGroup(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getChildrenByParentId(id?: string | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetChildrenByParentId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChildrenByParentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChildrenByParentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetChildrenByParentId(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeChildFromParent(parentId?: string | undefined, childId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Ccp/RemoveChildFromParent?";
        if (parentId === null)
            throw new globalThis.Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (childId === null)
            throw new globalThis.Error("The parameter 'childId' cannot be null.");
        else if (childId !== undefined)
            url_ += "childId=" + encodeURIComponent("" + childId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveChildFromParent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveChildFromParent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRemoveChildFromParent(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getChildrenByGroupId(id?: string | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetChildrenByGroupId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChildrenByGroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChildrenByGroupId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetChildrenByGroupId(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getRelationsByGroupId(id?: string | undefined): Observable<CcpRelationModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetRelationsByGroupId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelationsByGroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelationsByGroupId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpRelationModel[]>;
        }));
    }

    protected processGetRelationsByGroupId(response: HttpResponseBase): Observable<CcpRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRelationsByParentId(id?: string | undefined): Observable<CcpRelationModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetRelationsByParentId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelationsByParentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelationsByParentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpRelationModel[]>;
        }));
    }

    protected processGetRelationsByParentId(response: HttpResponseBase): Observable<CcpRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveSort(relations: CcpRelationModel[]): Observable<CcpRelationModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/SaveSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(relations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpRelationModel[]>;
        }));
    }

    protected processSaveSort(response: HttpResponseBase): Observable<CcpRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCcpScheduleOverview(groupId?: string | undefined, startDateUtc?: Date | undefined, recalculate?: boolean | undefined): Observable<CcpScheduleOverview[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetCcpScheduleOverview?";
        if (groupId === null)
            throw new globalThis.Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (startDateUtc === null)
            throw new globalThis.Error("The parameter 'startDateUtc' cannot be null.");
        else if (startDateUtc !== undefined)
            url_ += "startDateUtc=" + encodeURIComponent(startDateUtc ? "" + startDateUtc.toISOString() : "") + "&";
        if (recalculate === null)
            throw new globalThis.Error("The parameter 'recalculate' cannot be null.");
        else if (recalculate !== undefined)
            url_ += "recalculate=" + encodeURIComponent("" + recalculate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCcpScheduleOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCcpScheduleOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpScheduleOverview[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpScheduleOverview[]>;
        }));
    }

    protected processGetCcpScheduleOverview(response: HttpResponseBase): Observable<CcpScheduleOverview[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpScheduleOverview.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendLateNotification(receivers: string[], organizationId?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Ccp/SendLateNotification?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(receivers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendLateNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendLateNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendLateNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getByRiskFactor(id?: string | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetByRiskFactor?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByRiskFactor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByRiskFactor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetByRiskFactor(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskAnalysis
     * @param id (optional) 
     */
    getByRiskAnalysis(id?: string | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetByRiskAnalysis?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByRiskAnalysis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByRiskAnalysis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetByRiskAnalysis(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by Department
     * @param id (optional) 
     */
    getByDepartment(id?: string | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetByDepartment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetByDepartment(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccps by filter values
     * @param id (optional) 
     * @param isDeleted (optional) 
     */
    getCcpsByFilter(id?: string | null | undefined, isDeleted?: boolean | null | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetCcpsByFilter?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isDeleted !== undefined && isDeleted !== null)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCcpsByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCcpsByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetCcpsByFilter(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskCategory
     * @param id (optional) 
     */
    getByRecipe(id?: string | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetByRecipe?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetByRecipe(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskCategory
     * @param id (optional) 
     */
    getByProcess(id?: string | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetByProcess?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetByProcess(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by Product Variant
     * @param id (optional) 
     */
    getByProductVariant(id?: string | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetByProductVariant?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetByProductVariant(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Ccp
     */
    postRecipeLimits(model: CcpModel): Observable<CcpModel> {
        let url_ = this.baseUrl + "/api/Ccp/PostRecipeLimits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostRecipeLimits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostRecipeLimits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel>;
        }));
    }

    protected processPostRecipeLimits(response: HttpResponseBase): Observable<CcpModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Ccp
     */
    post(model: CcpModel): Observable<CcpModel> {
        let url_ = this.baseUrl + "/api/Ccp/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<CcpModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(type?: string | null | undefined, id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Ccp/GetReport?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RiskCategory by RiskAnalysis
     * @param id (optional) 
     */
    getByOrganization(id?: string | undefined): Observable<CcpModel[]> {
        let url_ = this.baseUrl + "/api/Ccp/GetByOrganization?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel[]>;
        }));
    }

    protected processGetByOrganization(response: HttpResponseBase): Observable<CcpModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copy(ccpId?: string | undefined, newName?: string | null | undefined, targetDepartmentId?: string | null | undefined): Observable<CcpModel> {
        let url_ = this.baseUrl + "/api/Ccp/Copy?";
        if (ccpId === null)
            throw new globalThis.Error("The parameter 'ccpId' cannot be null.");
        else if (ccpId !== undefined)
            url_ += "ccpId=" + encodeURIComponent("" + ccpId) + "&";
        if (newName !== undefined && newName !== null)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        if (targetDepartmentId !== undefined && targetDepartmentId !== null)
            url_ += "targetDepartmentId=" + encodeURIComponent("" + targetDepartmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<CcpModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Ccp/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unDelete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Ccp/UnDelete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUnDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICcpGroupService {
    /**
     * Get CcpGroup
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CcpGroupModel>;
    /**
     * Get Ccp by RiskFactor
     */
    getAll(): Observable<CcpGroupModel[]>;
    getByOrganization(organizationId?: string | undefined): Observable<CcpGroupModel[]>;
    /**
     * Add or update Ccp
     */
    post(model: CcpGroupModel): Observable<CcpGroupModel>;
    copy(id?: string | undefined, newName?: string | null | undefined, targetDepartmentId?: string | undefined): Observable<CcpGroupModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CcpGroupService implements ICcpGroupService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get CcpGroup
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CcpGroupModel> {
        let url_ = this.baseUrl + "/api/CcpGroup/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpGroupModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CcpGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskFactor
     */
    getAll(): Observable<CcpGroupModel[]> {
        let url_ = this.baseUrl + "/api/CcpGroup/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpGroupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpGroupModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CcpGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpGroupModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByOrganization(organizationId?: string | undefined): Observable<CcpGroupModel[]> {
        let url_ = this.baseUrl + "/api/CcpGroup/GetByOrganization?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpGroupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpGroupModel[]>;
        }));
    }

    protected processGetByOrganization(response: HttpResponseBase): Observable<CcpGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpGroupModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Ccp
     */
    post(model: CcpGroupModel): Observable<CcpGroupModel> {
        let url_ = this.baseUrl + "/api/CcpGroup/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpGroupModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<CcpGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copy(id?: string | undefined, newName?: string | null | undefined, targetDepartmentId?: string | undefined): Observable<CcpGroupModel> {
        let url_ = this.baseUrl + "/api/CcpGroup/Copy?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newName !== undefined && newName !== null)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        if (targetDepartmentId === null)
            throw new globalThis.Error("The parameter 'targetDepartmentId' cannot be null.");
        else if (targetDepartmentId !== undefined)
            url_ += "targetDepartmentId=" + encodeURIComponent("" + targetDepartmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpGroupModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<CcpGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CcpGroup/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICcpMeasurementService {
    /**
     * Get Ccp
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CcpMeasurementModel>;
    /**
     * Get Ccp by CCP
     * @param id (optional) 
     * @param startDate (optional) 
     * @param parentId (optional) 
     */
    getByCcp(id?: string | undefined, startDate?: Date | null | undefined, parentId?: string | null | undefined): Observable<CcpMeasurementModel[]>;
    /**
     * Get Ccp by ProductionOrder
     * @param id (optional) 
     */
    getByProductionOrder(id?: string | undefined): Observable<CcpMeasurementModel[]>;
    /**
     * Get Ccp by Orderline
     * @param id (optional) 
     */
    getByOrderline(id?: string | undefined): Observable<CcpMeasurementModel[]>;
    /**
     * Add or update Ccp
     */
    post(model: CcpMeasurementModel): Observable<CcpMeasurementModel>;
    postMultiple(model: CcpMeasurementModel[]): Observable<void>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CcpMeasurementService implements ICcpMeasurementService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Ccp
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CcpMeasurementModel> {
        let url_ = this.baseUrl + "/api/CcpMeasurement/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpMeasurementModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpMeasurementModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CcpMeasurementModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpMeasurementModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by CCP
     * @param id (optional) 
     * @param startDate (optional) 
     * @param parentId (optional) 
     */
    getByCcp(id?: string | undefined, startDate?: Date | null | undefined, parentId?: string | null | undefined): Observable<CcpMeasurementModel[]> {
        let url_ = this.baseUrl + "/api/CcpMeasurement/GetByCcp?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCcp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCcp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpMeasurementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpMeasurementModel[]>;
        }));
    }

    protected processGetByCcp(response: HttpResponseBase): Observable<CcpMeasurementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpMeasurementModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by ProductionOrder
     * @param id (optional) 
     */
    getByProductionOrder(id?: string | undefined): Observable<CcpMeasurementModel[]> {
        let url_ = this.baseUrl + "/api/CcpMeasurement/GetByProductionOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductionOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductionOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpMeasurementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpMeasurementModel[]>;
        }));
    }

    protected processGetByProductionOrder(response: HttpResponseBase): Observable<CcpMeasurementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpMeasurementModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by Orderline
     * @param id (optional) 
     */
    getByOrderline(id?: string | undefined): Observable<CcpMeasurementModel[]> {
        let url_ = this.baseUrl + "/api/CcpMeasurement/GetByOrderline?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrderline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrderline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpMeasurementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpMeasurementModel[]>;
        }));
    }

    protected processGetByOrderline(response: HttpResponseBase): Observable<CcpMeasurementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpMeasurementModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Ccp
     */
    post(model: CcpMeasurementModel): Observable<CcpMeasurementModel> {
        let url_ = this.baseUrl + "/api/CcpMeasurement/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpMeasurementModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpMeasurementModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<CcpMeasurementModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpMeasurementModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postMultiple(model: CcpMeasurementModel[]): Observable<void> {
        let url_ = this.baseUrl + "/api/CcpMeasurement/PostMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostMultiple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostMultiple(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostMultiple(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CcpMeasurement/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICcpNonComplianceService {
    get(id?: string | undefined): Observable<CcpNonComplianceModel>;
    getByCcp(id?: string | undefined): Observable<CcpNonComplianceModel[]>;
    getByCcpDepartment(id?: string | undefined): Observable<CcpNonComplianceModel[]>;
    getAll(): Observable<CcpNonComplianceModel[]>;
    getAllPaged(query: PagedQuery): Observable<PagedResultOfCcpNonComplianceModel>;
    getTasksByNonCompliance(id?: string | undefined): Observable<CtrTaskModel[]>;
    deleteTask(id?: string | undefined): Observable<void>;
    post(model: CcpNonComplianceModel): Observable<CcpNonComplianceModel>;
    copy(id?: string | undefined, newName?: string | null | undefined): Observable<CcpNonComplianceModel>;
    delete(id?: string | undefined): Observable<string>;
    getNonConformanceTypes(): Observable<NonConformanceTypeModel[]>;
    postType(model: NonConformanceTypeModel): Observable<NonConformanceTypeModel>;
    deleteType(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CcpNonComplianceService implements ICcpNonComplianceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id?: string | undefined): Observable<CcpNonComplianceModel> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpNonComplianceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpNonComplianceModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CcpNonComplianceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpNonComplianceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByCcp(id?: string | undefined): Observable<CcpNonComplianceModel[]> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/GetByCcp?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCcp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCcp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpNonComplianceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpNonComplianceModel[]>;
        }));
    }

    protected processGetByCcp(response: HttpResponseBase): Observable<CcpNonComplianceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpNonComplianceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByCcpDepartment(id?: string | undefined): Observable<CcpNonComplianceModel[]> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/GetByCcpDepartment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCcpDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCcpDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpNonComplianceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpNonComplianceModel[]>;
        }));
    }

    protected processGetByCcpDepartment(response: HttpResponseBase): Observable<CcpNonComplianceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpNonComplianceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<CcpNonComplianceModel[]> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpNonComplianceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpNonComplianceModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CcpNonComplianceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpNonComplianceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPaged(query: PagedQuery): Observable<PagedResultOfCcpNonComplianceModel> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/GetAllPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfCcpNonComplianceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfCcpNonComplianceModel>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<PagedResultOfCcpNonComplianceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfCcpNonComplianceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTasksByNonCompliance(id?: string | undefined): Observable<CtrTaskModel[]> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/GetTasksByNonCompliance?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksByNonCompliance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksByNonCompliance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrTaskModel[]>;
        }));
    }

    protected processGetTasksByNonCompliance(response: HttpResponseBase): Observable<CtrTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrTaskModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteTask(id?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/DeleteTask?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: CcpNonComplianceModel): Observable<CcpNonComplianceModel> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpNonComplianceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpNonComplianceModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<CcpNonComplianceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpNonComplianceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copy(id?: string | undefined, newName?: string | null | undefined): Observable<CcpNonComplianceModel> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/Copy?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newName !== undefined && newName !== null)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpNonComplianceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpNonComplianceModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<CcpNonComplianceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpNonComplianceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNonConformanceTypes(): Observable<NonConformanceTypeModel[]> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/GetNonConformanceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNonConformanceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonConformanceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonConformanceTypeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonConformanceTypeModel[]>;
        }));
    }

    protected processGetNonConformanceTypes(response: HttpResponseBase): Observable<NonConformanceTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NonConformanceTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postType(model: NonConformanceTypeModel): Observable<NonConformanceTypeModel> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/PostType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonConformanceTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonConformanceTypeModel>;
        }));
    }

    protected processPostType(response: HttpResponseBase): Observable<NonConformanceTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NonConformanceTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteType(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CcpNonCompliance/DeleteType?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICcpRelationService {
    /**
     * Get CcpGroup
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CcpRelationModel>;
    /**
     * Get Ccp by RiskFactor
     */
    getAll(): Observable<CcpRelationModel[]>;
    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getByEntity(id?: string | undefined): Observable<CcpRelationModel[]>;
    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getByRecipe(id?: string | undefined): Observable<CcpRelationModel[]>;
    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getByCcp(id?: string | undefined): Observable<CcpRelationModel[]>;
    post(model: CcpRelationModel): Observable<CcpRelationModel>;
    fixCcpRelations(): Observable<string>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CcpRelationService implements ICcpRelationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get CcpGroup
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CcpRelationModel> {
        let url_ = this.baseUrl + "/api/CcpRelation/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpRelationModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CcpRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskFactor
     */
    getAll(): Observable<CcpRelationModel[]> {
        let url_ = this.baseUrl + "/api/CcpRelation/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpRelationModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CcpRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getByEntity(id?: string | undefined): Observable<CcpRelationModel[]> {
        let url_ = this.baseUrl + "/api/CcpRelation/GetByEntity?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpRelationModel[]>;
        }));
    }

    protected processGetByEntity(response: HttpResponseBase): Observable<CcpRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getByRecipe(id?: string | undefined): Observable<CcpRelationModel[]> {
        let url_ = this.baseUrl + "/api/CcpRelation/GetByRecipe?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpRelationModel[]>;
        }));
    }

    protected processGetByRecipe(response: HttpResponseBase): Observable<CcpRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ccp by RiskFactor
     * @param id (optional) 
     */
    getByCcp(id?: string | undefined): Observable<CcpRelationModel[]> {
        let url_ = this.baseUrl + "/api/CcpRelation/GetByCcp?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCcp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCcp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpRelationModel[]>;
        }));
    }

    protected processGetByCcp(response: HttpResponseBase): Observable<CcpRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: CcpRelationModel): Observable<CcpRelationModel> {
        let url_ = this.baseUrl + "/api/CcpRelation/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpRelationModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<CcpRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fixCcpRelations(): Observable<string> {
        let url_ = this.baseUrl + "/api/CcpRelation/FixCcpRelations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixCcpRelations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixCcpRelations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFixCcpRelations(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CcpRelation/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICollectionService {
    /**
     * Add or update Collection
     */
    postSection(model: CollectionModel): Observable<CollectionModel>;
    copyFiles(fromEntityId?: string | undefined, toEntityId?: string | undefined): Observable<CollectionModel>;
    updateSortOrders(parentId?: string | undefined, collectionId?: string | undefined, newSortOrder?: number | undefined): Observable<void>;
    adjustRootNodes(collectionId?: string | null | undefined): Observable<CollectionModel>;
    /**
     * Add or update Document
     * @param organizationId (optional) 
     */
    postDocument(model: CollectionModel, organizationId?: string | null | undefined): Observable<CollectionModel>;
    postDocuments(models: CollectionModel[]): Observable<CollectionModel[]>;
    asyncUploadDocument(files?: FileParameter[] | null | undefined): Observable<FileResponse>;
    getFileStream(id?: string | undefined): Observable<FileResponse>;
    /**
     * Get files
     * @param id (optional) 
     * @param type (optional) 
     * @param orgId (optional) 
     */
    getFiles(id?: string | undefined, type?: string | null | undefined, orgId?: string | null | undefined): Observable<CollectionModel[]>;
    deleteFile(id?: string | undefined): Observable<FileResponse>;
    copyFileFromUrl(url?: string | null | undefined, id?: string | undefined): Observable<FileResponse>;
    asyncUpload(files?: FileParameter[] | null | undefined): Observable<FileResponse>;
    asyncUploadTempFile(file?: FileParameter | null | undefined): Observable<FileResponse>;
    uploadFile(): Observable<FileResponse>;
    uploadTempFile(): Observable<FileResponse>;
    /**
     * Sort Sections
     */
    saveSort(model: CollectionModel): Observable<CollectionModel>;
    getSingleCollection(id?: string | undefined): Observable<CollectionModel>;
    getSettingsRoot(): Observable<CollectionModel>;
    getCollectionRoot(typeId?: string | undefined): Observable<CollectionModel>;
    /**
     * Add or update Collection
     */
    postSettingsGroup(model: CollectionModel): Observable<CollectionModel>;
    /**
     * Delete Collection
     * @param id (optional) 
     */
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CollectionService implements ICollectionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Add or update Collection
     */
    postSection(model: CollectionModel): Observable<CollectionModel> {
        let url_ = this.baseUrl + "/api/Collection/PostSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel>;
        }));
    }

    protected processPostSection(response: HttpResponseBase): Observable<CollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyFiles(fromEntityId?: string | undefined, toEntityId?: string | undefined): Observable<CollectionModel> {
        let url_ = this.baseUrl + "/api/Collection/CopyFiles?";
        if (fromEntityId === null)
            throw new globalThis.Error("The parameter 'fromEntityId' cannot be null.");
        else if (fromEntityId !== undefined)
            url_ += "fromEntityId=" + encodeURIComponent("" + fromEntityId) + "&";
        if (toEntityId === null)
            throw new globalThis.Error("The parameter 'toEntityId' cannot be null.");
        else if (toEntityId !== undefined)
            url_ += "toEntityId=" + encodeURIComponent("" + toEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel>;
        }));
    }

    protected processCopyFiles(response: HttpResponseBase): Observable<CollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSortOrders(parentId?: string | undefined, collectionId?: string | undefined, newSortOrder?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Collection/UpdateSortOrders?";
        if (parentId === null)
            throw new globalThis.Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (collectionId === null)
            throw new globalThis.Error("The parameter 'collectionId' cannot be null.");
        else if (collectionId !== undefined)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        if (newSortOrder === null)
            throw new globalThis.Error("The parameter 'newSortOrder' cannot be null.");
        else if (newSortOrder !== undefined)
            url_ += "newSortOrder=" + encodeURIComponent("" + newSortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSortOrders(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    adjustRootNodes(collectionId?: string | null | undefined): Observable<CollectionModel> {
        let url_ = this.baseUrl + "/api/Collection/AdjustRootNodes?";
        if (collectionId !== undefined && collectionId !== null)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdjustRootNodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustRootNodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel>;
        }));
    }

    protected processAdjustRootNodes(response: HttpResponseBase): Observable<CollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Document
     * @param organizationId (optional) 
     */
    postDocument(model: CollectionModel, organizationId?: string | null | undefined): Observable<CollectionModel> {
        let url_ = this.baseUrl + "/api/Collection/PostDocument?";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel>;
        }));
    }

    protected processPostDocument(response: HttpResponseBase): Observable<CollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postDocuments(models: CollectionModel[]): Observable<CollectionModel[]> {
        let url_ = this.baseUrl + "/api/Collection/PostDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel[]>;
        }));
    }

    protected processPostDocuments(response: HttpResponseBase): Observable<CollectionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CollectionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    asyncUploadDocument(files?: FileParameter[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Collection/AsyncUploadDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAsyncUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAsyncUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAsyncUploadDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFileStream(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Collection/GetFileStream?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFileStream(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get files
     * @param id (optional) 
     * @param type (optional) 
     * @param orgId (optional) 
     */
    getFiles(id?: string | undefined, type?: string | null | undefined, orgId?: string | null | undefined): Observable<CollectionModel[]> {
        let url_ = this.baseUrl + "/api/Collection/GetFiles?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel[]>;
        }));
    }

    protected processGetFiles(response: HttpResponseBase): Observable<CollectionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CollectionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFile(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Collection/DeleteFile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyFileFromUrl(url?: string | null | undefined, id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Collection/CopyFileFromUrl?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyFileFromUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyFileFromUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCopyFileFromUrl(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    asyncUpload(files?: FileParameter[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Collection/AsyncUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAsyncUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAsyncUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAsyncUpload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    asyncUploadTempFile(file?: FileParameter | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Collection/AsyncUploadTempFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAsyncUploadTempFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAsyncUploadTempFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAsyncUploadTempFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadFile(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Collection/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadTempFile(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Collection/UploadTempFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTempFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTempFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUploadTempFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sort Sections
     */
    saveSort(model: CollectionModel): Observable<CollectionModel> {
        let url_ = this.baseUrl + "/api/Collection/SaveSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel>;
        }));
    }

    protected processSaveSort(response: HttpResponseBase): Observable<CollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSingleCollection(id?: string | undefined): Observable<CollectionModel> {
        let url_ = this.baseUrl + "/api/Collection/GetSingleCollection?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSingleCollection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSingleCollection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel>;
        }));
    }

    protected processGetSingleCollection(response: HttpResponseBase): Observable<CollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSettingsRoot(): Observable<CollectionModel> {
        let url_ = this.baseUrl + "/api/Collection/GetSettingsRoot";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingsRoot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingsRoot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel>;
        }));
    }

    protected processGetSettingsRoot(response: HttpResponseBase): Observable<CollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCollectionRoot(typeId?: string | undefined): Observable<CollectionModel> {
        let url_ = this.baseUrl + "/api/Collection/GetCollectionRoot?";
        if (typeId === null)
            throw new globalThis.Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollectionRoot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollectionRoot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel>;
        }));
    }

    protected processGetCollectionRoot(response: HttpResponseBase): Observable<CollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Collection
     */
    postSettingsGroup(model: CollectionModel): Observable<CollectionModel> {
        let url_ = this.baseUrl + "/api/Collection/PostSettingsGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSettingsGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSettingsGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel>;
        }));
    }

    protected processPostSettingsGroup(response: HttpResponseBase): Observable<CollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Collection
     * @param id (optional) 
     */
    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Collection/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IConfigurationItemService {
    getAll(): Observable<ConfigurationItemModelOfString[]>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationItemService implements IConfigurationItemService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<ConfigurationItemModelOfString[]> {
        let url_ = this.baseUrl + "/api/ConfigurationItem/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationItemModelOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationItemModelOfString[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ConfigurationItemModelOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfigurationItemModelOfString.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ConfigurationItem/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IContactPersonService {
    /**
     * Get ContactPerson
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ContactPersonModel>;
    /**
     * Get ContactPerson by Supplier
     * @param id (optional) 
     */
    getByCustomer(id?: string | undefined): Observable<ContactPersonModel[]>;
    getByOrganization(organizationId?: string | undefined): Observable<ContactPersonModel[]>;
    /**
     * Get ContactPerson by Supplier
     */
    getAll(): Observable<ContactPersonModel[]>;
    /**
     * Add or update ContactPerson
     */
    post(model: ContactPersonModel): Observable<ContactPersonModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ContactPersonService implements IContactPersonService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get ContactPerson
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ContactPersonModel> {
        let url_ = this.baseUrl + "/api/ContactPerson/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactPersonModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactPersonModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ContactPersonModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactPersonModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ContactPerson by Supplier
     * @param id (optional) 
     */
    getByCustomer(id?: string | undefined): Observable<ContactPersonModel[]> {
        let url_ = this.baseUrl + "/api/ContactPerson/GetByCustomer?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactPersonModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactPersonModel[]>;
        }));
    }

    protected processGetByCustomer(response: HttpResponseBase): Observable<ContactPersonModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactPersonModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByOrganization(organizationId?: string | undefined): Observable<ContactPersonModel[]> {
        let url_ = this.baseUrl + "/api/ContactPerson/GetByOrganization?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactPersonModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactPersonModel[]>;
        }));
    }

    protected processGetByOrganization(response: HttpResponseBase): Observable<ContactPersonModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactPersonModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ContactPerson by Supplier
     */
    getAll(): Observable<ContactPersonModel[]> {
        let url_ = this.baseUrl + "/api/ContactPerson/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactPersonModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactPersonModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ContactPersonModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactPersonModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update ContactPerson
     */
    post(model: ContactPersonModel): Observable<ContactPersonModel> {
        let url_ = this.baseUrl + "/api/ContactPerson/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactPersonModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactPersonModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ContactPersonModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactPersonModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ContactPerson/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IContractService {
    getContractItems(): Observable<ContractItemModel[]>;
    get(organizationId?: string | undefined): Observable<ContractModel>;
    getAll(organizationId?: string | undefined): Observable<ContractModel[]>;
    getContractById(id?: string | undefined): Observable<ContractModel>;
    createOrUpdateContract(contract: ContractModel): Observable<ContractModel>;
    migrateProductServices(): Observable<ContractModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ContractService implements IContractService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getContractItems(): Observable<ContractItemModel[]> {
        let url_ = this.baseUrl + "/api/Contract/GetContractItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractItemModel[]>;
        }));
    }

    protected processGetContractItems(response: HttpResponseBase): Observable<ContractItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(organizationId?: string | undefined): Observable<ContractModel> {
        let url_ = this.baseUrl + "/api/Contract/Get?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ContractModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(organizationId?: string | undefined): Observable<ContractModel[]> {
        let url_ = this.baseUrl + "/api/Contract/GetAll?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ContractModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContractById(id?: string | undefined): Observable<ContractModel> {
        let url_ = this.baseUrl + "/api/Contract/GetContractById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractModel>;
        }));
    }

    protected processGetContractById(response: HttpResponseBase): Observable<ContractModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrUpdateContract(contract: ContractModel): Observable<ContractModel> {
        let url_ = this.baseUrl + "/api/Contract/CreateOrUpdateContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contract);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractModel>;
        }));
    }

    protected processCreateOrUpdateContract(response: HttpResponseBase): Observable<ContractModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    migrateProductServices(): Observable<ContractModel[]> {
        let url_ = this.baseUrl + "/api/Contract/MigrateProductServices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrateProductServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrateProductServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractModel[]>;
        }));
    }

    protected processMigrateProductServices(response: HttpResponseBase): Observable<ContractModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IControlMeasureService {
    get(id?: string | undefined): Observable<ControlMeasureModel>;
    getAll(includeDeleted?: boolean | undefined): Observable<ControlMeasureModel[]>;
    getByDepartment(departmentId?: string | undefined, includeDeleted?: boolean | undefined): Observable<ControlMeasureModel[]>;
    post(model: ControlMeasureModel): Observable<ControlMeasureModel>;
    delete(id?: string | undefined): Observable<FileResponse>;
    getLanguages(controlMeasureId?: string | undefined): Observable<ControlMeasureLanguageModel[]>;
    createFromCcp(model: CcpModel): Observable<ControlMeasureModel>;
    upsertLanguage(model: ControlMeasureLanguageModel): Observable<ControlMeasureLanguageModel>;
    getRiskFactorRelations(controlMeasureId?: string | undefined): Observable<ControlMeasureRelationModel[]>;
    getRiskFactorRelationsByRiskFactor(riskFactorId?: string | undefined): Observable<ControlMeasureRelationModel[]>;
    upsertRiskFactorRelation(model: ControlMeasureRelationModel): Observable<ControlMeasureRelationModel>;
    deleteRiskFactorRelation(id?: string | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ControlMeasureService implements IControlMeasureService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id?: string | undefined): Observable<ControlMeasureModel> {
        let url_ = this.baseUrl + "/api/ControlMeasure/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlMeasureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlMeasureModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ControlMeasureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlMeasureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(includeDeleted?: boolean | undefined): Observable<ControlMeasureModel[]> {
        let url_ = this.baseUrl + "/api/ControlMeasure/GetAll?";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlMeasureModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlMeasureModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ControlMeasureModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlMeasureModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByDepartment(departmentId?: string | undefined, includeDeleted?: boolean | undefined): Observable<ControlMeasureModel[]> {
        let url_ = this.baseUrl + "/api/ControlMeasure/GetByDepartment?";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlMeasureModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlMeasureModel[]>;
        }));
    }

    protected processGetByDepartment(response: HttpResponseBase): Observable<ControlMeasureModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlMeasureModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: ControlMeasureModel): Observable<ControlMeasureModel> {
        let url_ = this.baseUrl + "/api/ControlMeasure/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlMeasureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlMeasureModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ControlMeasureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlMeasureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ControlMeasure/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLanguages(controlMeasureId?: string | undefined): Observable<ControlMeasureLanguageModel[]> {
        let url_ = this.baseUrl + "/api/ControlMeasure/GetLanguages?";
        if (controlMeasureId === null)
            throw new globalThis.Error("The parameter 'controlMeasureId' cannot be null.");
        else if (controlMeasureId !== undefined)
            url_ += "controlMeasureId=" + encodeURIComponent("" + controlMeasureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlMeasureLanguageModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlMeasureLanguageModel[]>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<ControlMeasureLanguageModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlMeasureLanguageModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createFromCcp(model: CcpModel): Observable<ControlMeasureModel> {
        let url_ = this.baseUrl + "/api/ControlMeasure/CreateFromCcp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFromCcp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFromCcp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlMeasureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlMeasureModel>;
        }));
    }

    protected processCreateFromCcp(response: HttpResponseBase): Observable<ControlMeasureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlMeasureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsertLanguage(model: ControlMeasureLanguageModel): Observable<ControlMeasureLanguageModel> {
        let url_ = this.baseUrl + "/api/ControlMeasure/UpsertLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlMeasureLanguageModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlMeasureLanguageModel>;
        }));
    }

    protected processUpsertLanguage(response: HttpResponseBase): Observable<ControlMeasureLanguageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlMeasureLanguageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRiskFactorRelations(controlMeasureId?: string | undefined): Observable<ControlMeasureRelationModel[]> {
        let url_ = this.baseUrl + "/api/ControlMeasure/GetRiskFactorRelations?";
        if (controlMeasureId === null)
            throw new globalThis.Error("The parameter 'controlMeasureId' cannot be null.");
        else if (controlMeasureId !== undefined)
            url_ += "controlMeasureId=" + encodeURIComponent("" + controlMeasureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRiskFactorRelations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRiskFactorRelations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlMeasureRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlMeasureRelationModel[]>;
        }));
    }

    protected processGetRiskFactorRelations(response: HttpResponseBase): Observable<ControlMeasureRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlMeasureRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRiskFactorRelationsByRiskFactor(riskFactorId?: string | undefined): Observable<ControlMeasureRelationModel[]> {
        let url_ = this.baseUrl + "/api/ControlMeasure/GetRiskFactorRelationsByRiskFactor?";
        if (riskFactorId === null)
            throw new globalThis.Error("The parameter 'riskFactorId' cannot be null.");
        else if (riskFactorId !== undefined)
            url_ += "riskFactorId=" + encodeURIComponent("" + riskFactorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRiskFactorRelationsByRiskFactor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRiskFactorRelationsByRiskFactor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlMeasureRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlMeasureRelationModel[]>;
        }));
    }

    protected processGetRiskFactorRelationsByRiskFactor(response: HttpResponseBase): Observable<ControlMeasureRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlMeasureRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsertRiskFactorRelation(model: ControlMeasureRelationModel): Observable<ControlMeasureRelationModel> {
        let url_ = this.baseUrl + "/api/ControlMeasure/UpsertRiskFactorRelation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertRiskFactorRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertRiskFactorRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlMeasureRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlMeasureRelationModel>;
        }));
    }

    protected processUpsertRiskFactorRelation(response: HttpResponseBase): Observable<ControlMeasureRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlMeasureRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRiskFactorRelation(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ControlMeasure/DeleteRiskFactorRelation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRiskFactorRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRiskFactorRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteRiskFactorRelation(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IControlPlanService {
    get(id?: string | undefined): Observable<ControlPlanModel>;
    getAll(includeDeleted?: boolean | undefined): Observable<ControlPlanModel[]>;
    getByDepartment(departmentId?: string | undefined, includeDeleted?: boolean | undefined): Observable<ControlPlanModel[]>;
    post(model: ControlPlanModel): Observable<ControlPlanModel>;
    createControlMeasurePlanRelation(controlPlanId?: string | undefined, controlMeasureId?: string | undefined, sortOrder?: number | undefined): Observable<string>;
    getReport(type?: string | null | undefined, id?: string | undefined, fileType?: string | null | undefined, reportType?: string | null | undefined, language?: string | null | undefined): Observable<FileResponse>;
    delete(id?: string | undefined): Observable<FileResponse>;
    getLanguages(controlPlanId?: string | undefined): Observable<ControlPlanLanguageModel[]>;
    upsertLanguage(model: ControlPlanLanguageModel): Observable<ControlPlanLanguageModel>;
}

@Injectable({
    providedIn: 'root'
})
export class ControlPlanService implements IControlPlanService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id?: string | undefined): Observable<ControlPlanModel> {
        let url_ = this.baseUrl + "/api/ControlPlan/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPlanModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPlanModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ControlPlanModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlPlanModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(includeDeleted?: boolean | undefined): Observable<ControlPlanModel[]> {
        let url_ = this.baseUrl + "/api/ControlPlan/GetAll?";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPlanModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPlanModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ControlPlanModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlPlanModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByDepartment(departmentId?: string | undefined, includeDeleted?: boolean | undefined): Observable<ControlPlanModel[]> {
        let url_ = this.baseUrl + "/api/ControlPlan/GetByDepartment?";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPlanModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPlanModel[]>;
        }));
    }

    protected processGetByDepartment(response: HttpResponseBase): Observable<ControlPlanModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlPlanModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: ControlPlanModel): Observable<ControlPlanModel> {
        let url_ = this.baseUrl + "/api/ControlPlan/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPlanModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPlanModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ControlPlanModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlPlanModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createControlMeasurePlanRelation(controlPlanId?: string | undefined, controlMeasureId?: string | undefined, sortOrder?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ControlPlan/CreateControlMeasurePlanRelation?";
        if (controlPlanId === null)
            throw new globalThis.Error("The parameter 'controlPlanId' cannot be null.");
        else if (controlPlanId !== undefined)
            url_ += "controlPlanId=" + encodeURIComponent("" + controlPlanId) + "&";
        if (controlMeasureId === null)
            throw new globalThis.Error("The parameter 'controlMeasureId' cannot be null.");
        else if (controlMeasureId !== undefined)
            url_ += "controlMeasureId=" + encodeURIComponent("" + controlMeasureId) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateControlMeasurePlanRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateControlMeasurePlanRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateControlMeasurePlanRelation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(type?: string | null | undefined, id?: string | undefined, fileType?: string | null | undefined, reportType?: string | null | undefined, language?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ControlPlan/GetReport?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (fileType !== undefined && fileType !== null)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (reportType !== undefined && reportType !== null)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ControlPlan/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLanguages(controlPlanId?: string | undefined): Observable<ControlPlanLanguageModel[]> {
        let url_ = this.baseUrl + "/api/ControlPlan/GetLanguages?";
        if (controlPlanId === null)
            throw new globalThis.Error("The parameter 'controlPlanId' cannot be null.");
        else if (controlPlanId !== undefined)
            url_ += "controlPlanId=" + encodeURIComponent("" + controlPlanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPlanLanguageModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPlanLanguageModel[]>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<ControlPlanLanguageModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlPlanLanguageModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsertLanguage(model: ControlPlanLanguageModel): Observable<ControlPlanLanguageModel> {
        let url_ = this.baseUrl + "/api/ControlPlan/UpsertLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPlanLanguageModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPlanLanguageModel>;
        }));
    }

    protected processUpsertLanguage(response: HttpResponseBase): Observable<ControlPlanLanguageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlPlanLanguageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICounterService {
    get(counterName?: string | null | undefined): Observable<CounterModel>;
    getNextNumber(counterName?: string | null | undefined): Observable<number>;
    getAll(): Observable<CounterModel[]>;
    delete(id?: string | undefined): Observable<string>;
    save(model: CounterModel): Observable<CounterModel>;
}

@Injectable({
    providedIn: 'root'
})
export class CounterService implements ICounterService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(counterName?: string | null | undefined): Observable<CounterModel> {
        let url_ = this.baseUrl + "/api/Counter/Get?";
        if (counterName !== undefined && counterName !== null)
            url_ += "counterName=" + encodeURIComponent("" + counterName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CounterModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CounterModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CounterModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CounterModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNextNumber(counterName?: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Counter/GetNextNumber?";
        if (counterName !== undefined && counterName !== null)
            url_ += "counterName=" + encodeURIComponent("" + counterName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNextNumber(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<CounterModel[]> {
        let url_ = this.baseUrl + "/api/Counter/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CounterModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CounterModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CounterModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CounterModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Counter/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: CounterModel): Observable<CounterModel> {
        let url_ = this.baseUrl + "/api/Counter/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CounterModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CounterModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<CounterModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CounterModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomerComplaintService {
    get(id?: string | undefined): Observable<CustomerComplaintModel>;
    getAll(): Observable<CustomerComplaintModel[]>;
    getAllPaged(query: PagedQuery): Observable<PagedResultOfCustomerComplaintModel>;
    getTasksByCustomerComplaint(id?: string | undefined): Observable<CtrTaskModel[]>;
    deleteTask(id?: string | undefined): Observable<void>;
    post(model: CustomerComplaintModel): Observable<CustomerComplaintModel>;
    copy(id?: string | undefined, newName?: string | null | undefined): Observable<CustomerComplaintModel>;
    delete(id?: string | undefined): Observable<string>;
    getCustomerComplaintTypes(): Observable<CustomerComplaintTypeModel[]>;
    postType(model: CustomerComplaintTypeModel): Observable<CustomerComplaintTypeModel>;
    deleteType(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerComplaintService implements ICustomerComplaintService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id?: string | undefined): Observable<CustomerComplaintModel> {
        let url_ = this.baseUrl + "/api/CustomerComplaint/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerComplaintModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerComplaintModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerComplaintModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerComplaintModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<CustomerComplaintModel[]> {
        let url_ = this.baseUrl + "/api/CustomerComplaint/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerComplaintModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerComplaintModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomerComplaintModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerComplaintModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPaged(query: PagedQuery): Observable<PagedResultOfCustomerComplaintModel> {
        let url_ = this.baseUrl + "/api/CustomerComplaint/GetAllPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfCustomerComplaintModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfCustomerComplaintModel>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<PagedResultOfCustomerComplaintModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfCustomerComplaintModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTasksByCustomerComplaint(id?: string | undefined): Observable<CtrTaskModel[]> {
        let url_ = this.baseUrl + "/api/CustomerComplaint/GetTasksByCustomerComplaint?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksByCustomerComplaint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksByCustomerComplaint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrTaskModel[]>;
        }));
    }

    protected processGetTasksByCustomerComplaint(response: HttpResponseBase): Observable<CtrTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrTaskModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteTask(id?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/CustomerComplaint/DeleteTask?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: CustomerComplaintModel): Observable<CustomerComplaintModel> {
        let url_ = this.baseUrl + "/api/CustomerComplaint/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerComplaintModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerComplaintModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<CustomerComplaintModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerComplaintModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copy(id?: string | undefined, newName?: string | null | undefined): Observable<CustomerComplaintModel> {
        let url_ = this.baseUrl + "/api/CustomerComplaint/Copy?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newName !== undefined && newName !== null)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerComplaintModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerComplaintModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<CustomerComplaintModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerComplaintModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CustomerComplaint/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerComplaintTypes(): Observable<CustomerComplaintTypeModel[]> {
        let url_ = this.baseUrl + "/api/CustomerComplaint/GetCustomerComplaintTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerComplaintTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerComplaintTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerComplaintTypeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerComplaintTypeModel[]>;
        }));
    }

    protected processGetCustomerComplaintTypes(response: HttpResponseBase): Observable<CustomerComplaintTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerComplaintTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postType(model: CustomerComplaintTypeModel): Observable<CustomerComplaintTypeModel> {
        let url_ = this.baseUrl + "/api/CustomerComplaint/PostType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerComplaintTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerComplaintTypeModel>;
        }));
    }

    protected processPostType(response: HttpResponseBase): Observable<CustomerComplaintTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerComplaintTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteType(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CustomerComplaint/DeleteType?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomerService {
    /**
     * Get Customer
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CustomerModel>;
    /**
     * Get Customer
     * @param id (optional) 
     */
    getByGroup(id?: string | undefined): Observable<CustomerModel[]>;
    /**
     * Get Customer
     * @param id (optional) 
     */
    getContactPersons(id?: string | undefined): Observable<IdNameModel[]>;
    copyCustomerToSupplier(model: CustomerModel): Observable<SupplierModel>;
    /**
     * Get All Customers
     */
    getAll(): Observable<CustomerModel[]>;
    getAllPaged(query: PagedQuery): Observable<PagedResultOfCustomerModel>;
    searchCustomers(searchText?: string | null | undefined): Observable<CustomerModel[]>;
    /**
     * Get All Customers
     */
    getShopCustomers(): Observable<CustomerModel[]>;
    /**
     * Get All Customers
     * @param customerId (optional) 
     */
    removeShopCustomer(customerId?: string | undefined): Observable<string>;
    /**
     * Add or update Customer
     */
    bulkChangeLanguage(model: CustomerBulkChangeModel): Observable<string>;
    bulkSendToShop(model: CustomerBulkChangeModel): Observable<string>;
    /**
     * Add or update Customer
     */
    bulkChangeCustomerGroup(model: CustomerBulkChangeModel): Observable<string>;
    /**
     * Add or update Customer
     */
    post(model: CustomerModel): Observable<CustomerModel>;
    /**
     * Import Customers
     * @param fileName (optional) 
     */
    import(fileName?: string | null | undefined): Observable<string>;
    /**
     * Get Customer
     * @param id (optional) 
     */
    syncCustomer(id?: string | undefined): Observable<string>;
    delete(id?: string | undefined): Observable<string>;
    unDelete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerService implements ICustomerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Customer
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CustomerModel> {
        let url_ = this.baseUrl + "/api/Customer/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Customer
     * @param id (optional) 
     */
    getByGroup(id?: string | undefined): Observable<CustomerModel[]> {
        let url_ = this.baseUrl + "/api/Customer/GetByGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModel[]>;
        }));
    }

    protected processGetByGroup(response: HttpResponseBase): Observable<CustomerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Customer
     * @param id (optional) 
     */
    getContactPersons(id?: string | undefined): Observable<IdNameModel[]> {
        let url_ = this.baseUrl + "/api/Customer/GetContactPersons?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdNameModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdNameModel[]>;
        }));
    }

    protected processGetContactPersons(response: HttpResponseBase): Observable<IdNameModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdNameModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyCustomerToSupplier(model: CustomerModel): Observable<SupplierModel> {
        let url_ = this.baseUrl + "/api/Customer/CopyCustomerToSupplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyCustomerToSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyCustomerToSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierModel>;
        }));
    }

    protected processCopyCustomerToSupplier(response: HttpResponseBase): Observable<SupplierModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Customers
     */
    getAll(): Observable<CustomerModel[]> {
        let url_ = this.baseUrl + "/api/Customer/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPaged(query: PagedQuery): Observable<PagedResultOfCustomerModel> {
        let url_ = this.baseUrl + "/api/Customer/GetAllPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfCustomerModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfCustomerModel>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<PagedResultOfCustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfCustomerModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchCustomers(searchText?: string | null | undefined): Observable<CustomerModel[]> {
        let url_ = this.baseUrl + "/api/Customer/SearchCustomers?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModel[]>;
        }));
    }

    protected processSearchCustomers(response: HttpResponseBase): Observable<CustomerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Customers
     */
    getShopCustomers(): Observable<CustomerModel[]> {
        let url_ = this.baseUrl + "/api/Customer/GetShopCustomers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShopCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModel[]>;
        }));
    }

    protected processGetShopCustomers(response: HttpResponseBase): Observable<CustomerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Customers
     * @param customerId (optional) 
     */
    removeShopCustomer(customerId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Customer/RemoveShopCustomer?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveShopCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveShopCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRemoveShopCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Customer
     */
    bulkChangeLanguage(model: CustomerBulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Customer/BulkChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeLanguage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkSendToShop(model: CustomerBulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Customer/BulkSendToShop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkSendToShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkSendToShop(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkSendToShop(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Customer
     */
    bulkChangeCustomerGroup(model: CustomerBulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Customer/BulkChangeCustomerGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeCustomerGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeCustomerGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeCustomerGroup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Customer
     */
    post(model: CustomerModel): Observable<CustomerModel> {
        let url_ = this.baseUrl + "/api/Customer/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<CustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Import Customers
     * @param fileName (optional) 
     */
    import(fileName?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Customer/Import?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Customer
     * @param id (optional) 
     */
    syncCustomer(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Customer/SyncCustomer?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSyncCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Customer/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unDelete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Customer/UnDelete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUnDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomerGroupService {
    /**
     * Get CustomerGroup
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CustomerGroupModel>;
    /**
     * Get CustomerGroup by Supplier
     */
    getAll(): Observable<CustomerGroupModel[]>;
    searchCustomerGroups(searchText?: string | null | undefined): Observable<CustomerGroupModel[]>;
    /**
     * Add or update CustomerGroup
     */
    post(model: CustomerGroupModel): Observable<CustomerGroupModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerGroupService implements ICustomerGroupService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get CustomerGroup
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<CustomerGroupModel> {
        let url_ = this.baseUrl + "/api/CustomerGroup/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerGroupModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get CustomerGroup by Supplier
     */
    getAll(): Observable<CustomerGroupModel[]> {
        let url_ = this.baseUrl + "/api/CustomerGroup/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerGroupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerGroupModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomerGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerGroupModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchCustomerGroups(searchText?: string | null | undefined): Observable<CustomerGroupModel[]> {
        let url_ = this.baseUrl + "/api/CustomerGroup/SearchCustomerGroups?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCustomerGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCustomerGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerGroupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerGroupModel[]>;
        }));
    }

    protected processSearchCustomerGroups(response: HttpResponseBase): Observable<CustomerGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerGroupModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update CustomerGroup
     */
    post(model: CustomerGroupModel): Observable<CustomerGroupModel> {
        let url_ = this.baseUrl + "/api/CustomerGroup/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerGroupModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<CustomerGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CustomerGroup/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDashboardService {
    /**
     * Get Capability
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<DashboardWidgetModel>;
    /**
     * Get Capability by Supplier
     * @param dashboardId (optional) 
     */
    getByDashboard(dashboardId?: string | undefined): Observable<DashboardWidgetModel[]>;
    /**
     * Add or update Capability
     */
    post(model: DashboardWidgetModel): Observable<DashboardWidgetModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class DashboardService implements IDashboardService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Capability
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<DashboardWidgetModel> {
        let url_ = this.baseUrl + "/api/Dashboard/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardWidgetModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardWidgetModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DashboardWidgetModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardWidgetModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Capability by Supplier
     * @param dashboardId (optional) 
     */
    getByDashboard(dashboardId?: string | undefined): Observable<DashboardWidgetModel[]> {
        let url_ = this.baseUrl + "/api/Dashboard/GetByDashboard?";
        if (dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' cannot be null.");
        else if (dashboardId !== undefined)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardWidgetModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardWidgetModel[]>;
        }));
    }

    protected processGetByDashboard(response: HttpResponseBase): Observable<DashboardWidgetModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardWidgetModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Capability
     */
    post(model: DashboardWidgetModel): Observable<DashboardWidgetModel> {
        let url_ = this.baseUrl + "/api/Dashboard/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardWidgetModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardWidgetModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<DashboardWidgetModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardWidgetModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Dashboard/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDepartmentService {
    /**
     * Get RiskAnalysis
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<DepartmentModel>;
    getByOrganizationId(organizationId?: string | undefined): Observable<DepartmentModel[]>;
    /**
     * Get all RiskAnalysis
     */
    getAll(): Observable<DepartmentModel[]>;
    /**
     * Add or update RiskAnalysis
     */
    post(model: DepartmentModel): Observable<DepartmentModel>;
    copyControlPlan(sourceDepartmentId?: string | undefined, targetDepartmentId?: string | undefined): Observable<string>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class DepartmentService implements IDepartmentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get RiskAnalysis
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<DepartmentModel> {
        let url_ = this.baseUrl + "/api/Department/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DepartmentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByOrganizationId(organizationId?: string | undefined): Observable<DepartmentModel[]> {
        let url_ = this.baseUrl + "/api/Department/GetByOrganizationId?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrganizationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrganizationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentModel[]>;
        }));
    }

    protected processGetByOrganizationId(response: HttpResponseBase): Observable<DepartmentModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all RiskAnalysis
     */
    getAll(): Observable<DepartmentModel[]> {
        let url_ = this.baseUrl + "/api/Department/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DepartmentModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    post(model: DepartmentModel): Observable<DepartmentModel> {
        let url_ = this.baseUrl + "/api/Department/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<DepartmentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyControlPlan(sourceDepartmentId?: string | undefined, targetDepartmentId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Department/CopyControlPlan?";
        if (sourceDepartmentId === null)
            throw new globalThis.Error("The parameter 'sourceDepartmentId' cannot be null.");
        else if (sourceDepartmentId !== undefined)
            url_ += "sourceDepartmentId=" + encodeURIComponent("" + sourceDepartmentId) + "&";
        if (targetDepartmentId === null)
            throw new globalThis.Error("The parameter 'targetDepartmentId' cannot be null.");
        else if (targetDepartmentId !== undefined)
            url_ += "targetDepartmentId=" + encodeURIComponent("" + targetDepartmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyControlPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyControlPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCopyControlPlan(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Department/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDictionaryService {
    /**
     * Get Supplier
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<DictionaryItemModel>;
    /**
     * Get all Suppliers
     */
    getAll(): Observable<DictionaryItemModel[]>;
    /**
     * Get all Suppliers
     * @param lang (optional) 
     */
    getUiDictionary(lang?: string | null | undefined): Observable<{ [key: string]: string; }>;
    /**
     * Add or update Supplier
     */
    post(model: DictionaryItemModel): Observable<DictionaryItemModel>;
    delete(id?: string | undefined): Observable<string>;
    exportDictionary(lang?: string | null | undefined): Observable<FileResponse>;
    /**
     * Import Langauges
     * @param fileName (optional) 
     */
    importDictionaryItems(fileName?: string | null | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class DictionaryService implements IDictionaryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Supplier
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<DictionaryItemModel> {
        let url_ = this.baseUrl + "/api/Dictionary/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryItemModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DictionaryItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DictionaryItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Suppliers
     */
    getAll(): Observable<DictionaryItemModel[]> {
        let url_ = this.baseUrl + "/api/Dictionary/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryItemModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Suppliers
     * @param lang (optional) 
     */
    getUiDictionary(lang?: string | null | undefined): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/Dictionary/GetUiDictionary?";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiDictionary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiDictionary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processGetUiDictionary(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Supplier
     */
    post(model: DictionaryItemModel): Observable<DictionaryItemModel> {
        let url_ = this.baseUrl + "/api/Dictionary/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryItemModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<DictionaryItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DictionaryItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Dictionary/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportDictionary(lang?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Dictionary/ExportDictionary?";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDictionary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDictionary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportDictionary(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Import Langauges
     * @param fileName (optional) 
     */
    importDictionaryItems(fileName?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Dictionary/ImportDictionaryItems?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportDictionaryItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportDictionaryItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportDictionaryItems(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDocumentApprovalService {
    getByEntityId(id?: string | undefined): Observable<DocumentApprovalModel>;
    getPossibleApprovers(organizationId?: string | undefined, documentId?: string | undefined): Observable<DocumentApprovalUserModel[]>;
    saveApprovers(approvers: DocumentApprovalUserModel[]): Observable<boolean>;
    getApprovers(documentRevisionId?: string | undefined): Observable<DocumentApprovalModel[]>;
    saveDocumentApproval(documentApproval: DocumentApprovalModel): Observable<boolean>;
    approveDocumentRevision(model: DocumentRevisionModel, validDate?: Date | undefined, comment?: string | null | undefined): Observable<DocumentRevisionModel>;
    rejectDocumentRevision(model: DocumentRevisionModel): Observable<DocumentRevisionModel>;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentApprovalService implements IDocumentApprovalService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getByEntityId(id?: string | undefined): Observable<DocumentApprovalModel> {
        let url_ = this.baseUrl + "/api/DocumentApproval/GetByEntityId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEntityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEntityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentApprovalModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentApprovalModel>;
        }));
    }

    protected processGetByEntityId(response: HttpResponseBase): Observable<DocumentApprovalModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentApprovalModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPossibleApprovers(organizationId?: string | undefined, documentId?: string | undefined): Observable<DocumentApprovalUserModel[]> {
        let url_ = this.baseUrl + "/api/DocumentApproval/GetPossibleApprovers?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (documentId === null)
            throw new globalThis.Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPossibleApprovers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPossibleApprovers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentApprovalUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentApprovalUserModel[]>;
        }));
    }

    protected processGetPossibleApprovers(response: HttpResponseBase): Observable<DocumentApprovalUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentApprovalUserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveApprovers(approvers: DocumentApprovalUserModel[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/DocumentApproval/SaveApprovers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(approvers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveApprovers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveApprovers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveApprovers(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApprovers(documentRevisionId?: string | undefined): Observable<DocumentApprovalModel[]> {
        let url_ = this.baseUrl + "/api/DocumentApproval/GetApprovers?";
        if (documentRevisionId === null)
            throw new globalThis.Error("The parameter 'documentRevisionId' cannot be null.");
        else if (documentRevisionId !== undefined)
            url_ += "documentRevisionId=" + encodeURIComponent("" + documentRevisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentApprovalModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentApprovalModel[]>;
        }));
    }

    protected processGetApprovers(response: HttpResponseBase): Observable<DocumentApprovalModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentApprovalModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveDocumentApproval(documentApproval: DocumentApprovalModel): Observable<boolean> {
        let url_ = this.baseUrl + "/api/DocumentApproval/SaveDocumentApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentApproval);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveDocumentApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveDocumentApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveDocumentApproval(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveDocumentRevision(model: DocumentRevisionModel, validDate?: Date | undefined, comment?: string | null | undefined): Observable<DocumentRevisionModel> {
        let url_ = this.baseUrl + "/api/DocumentApproval/ApproveDocumentRevision?";
        if (validDate === null)
            throw new globalThis.Error("The parameter 'validDate' cannot be null.");
        else if (validDate !== undefined)
            url_ += "validDate=" + encodeURIComponent(validDate ? "" + validDate.toISOString() : "") + "&";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveDocumentRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveDocumentRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentRevisionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentRevisionModel>;
        }));
    }

    protected processApproveDocumentRevision(response: HttpResponseBase): Observable<DocumentRevisionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentRevisionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rejectDocumentRevision(model: DocumentRevisionModel): Observable<DocumentRevisionModel> {
        let url_ = this.baseUrl + "/api/DocumentApproval/RejectDocumentRevision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectDocumentRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectDocumentRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentRevisionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentRevisionModel>;
        }));
    }

    protected processRejectDocumentRevision(response: HttpResponseBase): Observable<DocumentRevisionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentRevisionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDocumentationCollectionService {
    get(id?: string | undefined): Observable<DocumentationCollectionModel>;
    getAll(): Observable<DocumentationCollectionModel[]>;
    post(model: DocumentationCollectionModel): Observable<DocumentationCollectionModel>;
    postRelation(model: DocumentationRelationModel): Observable<DocumentationRelationModel>;
    delete(id?: string | undefined): Observable<DocumentationCollectionModel>;
    deleteRelation(model: DocumentationRelation): Observable<DocumentationRelationModel>;
    getReport(collectionId?: string | undefined, type?: string | null | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentationCollectionService implements IDocumentationCollectionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id?: string | undefined): Observable<DocumentationCollectionModel> {
        let url_ = this.baseUrl + "/api/DocumentationCollection/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentationCollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentationCollectionModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentationCollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentationCollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<DocumentationCollectionModel[]> {
        let url_ = this.baseUrl + "/api/DocumentationCollection/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentationCollectionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentationCollectionModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentationCollectionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentationCollectionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: DocumentationCollectionModel): Observable<DocumentationCollectionModel> {
        let url_ = this.baseUrl + "/api/DocumentationCollection/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentationCollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentationCollectionModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<DocumentationCollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentationCollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postRelation(model: DocumentationRelationModel): Observable<DocumentationRelationModel> {
        let url_ = this.baseUrl + "/api/DocumentationCollection/PostRelation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentationRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentationRelationModel>;
        }));
    }

    protected processPostRelation(response: HttpResponseBase): Observable<DocumentationRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentationRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<DocumentationCollectionModel> {
        let url_ = this.baseUrl + "/api/DocumentationCollection/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentationCollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentationCollectionModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DocumentationCollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentationCollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRelation(model: DocumentationRelation): Observable<DocumentationRelationModel> {
        let url_ = this.baseUrl + "/api/DocumentationCollection/DeleteRelation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentationRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentationRelationModel>;
        }));
    }

    protected processDeleteRelation(response: HttpResponseBase): Observable<DocumentationRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentationRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(collectionId?: string | undefined, type?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DocumentationCollection/GetReport?";
        if (collectionId === null)
            throw new globalThis.Error("The parameter 'collectionId' cannot be null.");
        else if (collectionId !== undefined)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDocumentationService {
    getAll(): Observable<DocumentationNodeModel[]>;
    getByTag(tag?: string | null | undefined): Observable<DocumentationNodeModel[]>;
    getByPath(path?: string | null | undefined): Observable<DocumentationNodeModel[]>;
    post(nodeModel: DocumentationNodeModel): Observable<DocumentationNodeModel>;
    getById(id?: string | undefined): Observable<DocumentationNodeModel>;
    delete(id?: string | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentationService implements IDocumentationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<DocumentationNodeModel[]> {
        let url_ = this.baseUrl + "/api/Documentation/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentationNodeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentationNodeModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentationNodeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentationNodeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByTag(tag?: string | null | undefined): Observable<DocumentationNodeModel[]> {
        let url_ = this.baseUrl + "/api/Documentation/GetByTag?";
        if (tag !== undefined && tag !== null)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentationNodeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentationNodeModel[]>;
        }));
    }

    protected processGetByTag(response: HttpResponseBase): Observable<DocumentationNodeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentationNodeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByPath(path?: string | null | undefined): Observable<DocumentationNodeModel[]> {
        let url_ = this.baseUrl + "/api/Documentation/GetByPath?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentationNodeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentationNodeModel[]>;
        }));
    }

    protected processGetByPath(response: HttpResponseBase): Observable<DocumentationNodeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentationNodeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(nodeModel: DocumentationNodeModel): Observable<DocumentationNodeModel> {
        let url_ = this.baseUrl + "/api/Documentation/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nodeModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentationNodeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentationNodeModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<DocumentationNodeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentationNodeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id?: string | undefined): Observable<DocumentationNodeModel> {
        let url_ = this.baseUrl + "/api/Documentation/GetById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentationNodeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentationNodeModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DocumentationNodeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentationNodeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Documentation/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDocumentService {
    get(id?: string | undefined): Observable<DocumentModel>;
    /**
     * Add or update RiskAnalysis
     */
    post(model: DocumentModel): Observable<DocumentModel>;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentService implements IDocumentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id?: string | undefined): Observable<DocumentModel> {
        let url_ = this.baseUrl + "/api/Document/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    post(model: DocumentModel): Observable<DocumentModel> {
        let url_ = this.baseUrl + "/api/Document/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<DocumentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDocumentResourceService {
    get(id?: string | undefined): Observable<DocumentResourceModel>;
    getAll(): Observable<DocumentResourceModel[]>;
    post(model: DocumentResourceModel): Observable<DocumentResourceModel>;
    postLanguage(model: DocumentResourceLanguageModel): Observable<DocumentResourceLanguageModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentResourceService implements IDocumentResourceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id?: string | undefined): Observable<DocumentResourceModel> {
        let url_ = this.baseUrl + "/api/DocumentResource/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResourceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResourceModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentResourceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentResourceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<DocumentResourceModel[]> {
        let url_ = this.baseUrl + "/api/DocumentResource/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResourceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResourceModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentResourceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentResourceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: DocumentResourceModel): Observable<DocumentResourceModel> {
        let url_ = this.baseUrl + "/api/DocumentResource/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResourceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResourceModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<DocumentResourceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentResourceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postLanguage(model: DocumentResourceLanguageModel): Observable<DocumentResourceLanguageModel> {
        let url_ = this.baseUrl + "/api/DocumentResource/PostLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResourceLanguageModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResourceLanguageModel>;
        }));
    }

    protected processPostLanguage(response: HttpResponseBase): Observable<DocumentResourceLanguageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentResourceLanguageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/DocumentResource/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDocumentRevisionService {
    /**
     * Get RiskAnalysis
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<DocumentRevisionModel>;
    getByEntity(id?: string | undefined): Observable<DocumentRevisionModel>;
    getHistory(id?: string | undefined): Observable<DocumentRevisionModel[]>;
    /**
     * Add or update RiskAnalysis
     */
    post(model: DocumentRevisionModel): Observable<DocumentRevisionModel>;
    /**
     * Add or update RiskAnalysis
     */
    createNewVersion(model: DocumentRevisionModel): Observable<DocumentRevisionModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentRevisionService implements IDocumentRevisionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get RiskAnalysis
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<DocumentRevisionModel> {
        let url_ = this.baseUrl + "/api/DocumentRevision/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentRevisionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentRevisionModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentRevisionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentRevisionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByEntity(id?: string | undefined): Observable<DocumentRevisionModel> {
        let url_ = this.baseUrl + "/api/DocumentRevision/GetByEntity?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentRevisionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentRevisionModel>;
        }));
    }

    protected processGetByEntity(response: HttpResponseBase): Observable<DocumentRevisionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentRevisionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHistory(id?: string | undefined): Observable<DocumentRevisionModel[]> {
        let url_ = this.baseUrl + "/api/DocumentRevision/GetHistory?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentRevisionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentRevisionModel[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<DocumentRevisionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentRevisionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    post(model: DocumentRevisionModel): Observable<DocumentRevisionModel> {
        let url_ = this.baseUrl + "/api/DocumentRevision/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentRevisionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentRevisionModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<DocumentRevisionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentRevisionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    createNewVersion(model: DocumentRevisionModel): Observable<DocumentRevisionModel> {
        let url_ = this.baseUrl + "/api/DocumentRevision/CreateNewVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentRevisionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentRevisionModel>;
        }));
    }

    protected processCreateNewVersion(response: HttpResponseBase): Observable<DocumentRevisionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentRevisionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/DocumentRevision/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEdiConfigurationService {
    getAll(): Observable<EdiConfigModel[]>;
    post(configModel: EdiConfigModel): Observable<EdiConfigModel>;
    postEntityConfig(entityConfig: EdiEntityConfigModel): Observable<EdiEntityConfigModel>;
    postEntityFieldConfig(entityFieldConfig: EdiEntityFieldConfigModel, ediConfigId?: string | undefined): Observable<EdiEntityFieldConfigModel>;
    getAllByType(type?: EdiType | undefined): Observable<EdiConfigModel[]>;
    getById(id?: string | undefined): Observable<EdiConfigModel>;
    getEntityConfigById(entityConfigId?: string | undefined, configId?: string | undefined): Observable<EdiEntityConfigModel>;
    delete(id?: string | undefined): Observable<boolean>;
    deleteEntityConfig(configId?: string | undefined, entityConfigId?: string | undefined): Observable<boolean>;
    deleteEntityFieldConfig(configId?: string | undefined, entityConfigId?: string | undefined, entityFieldConfigId?: string | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class EdiConfigurationService implements IEdiConfigurationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<EdiConfigModel[]> {
        let url_ = this.baseUrl + "/api/EdiConfiguration/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EdiConfigModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EdiConfigModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EdiConfigModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EdiConfigModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(configModel: EdiConfigModel): Observable<EdiConfigModel> {
        let url_ = this.baseUrl + "/api/EdiConfiguration/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EdiConfigModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EdiConfigModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<EdiConfigModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EdiConfigModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postEntityConfig(entityConfig: EdiEntityConfigModel): Observable<EdiEntityConfigModel> {
        let url_ = this.baseUrl + "/api/EdiConfiguration/PostEntityConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entityConfig);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEntityConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEntityConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EdiEntityConfigModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EdiEntityConfigModel>;
        }));
    }

    protected processPostEntityConfig(response: HttpResponseBase): Observable<EdiEntityConfigModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EdiEntityConfigModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postEntityFieldConfig(entityFieldConfig: EdiEntityFieldConfigModel, ediConfigId?: string | undefined): Observable<EdiEntityFieldConfigModel> {
        let url_ = this.baseUrl + "/api/EdiConfiguration/PostEntityFieldConfig?";
        if (ediConfigId === null)
            throw new globalThis.Error("The parameter 'ediConfigId' cannot be null.");
        else if (ediConfigId !== undefined)
            url_ += "ediConfigId=" + encodeURIComponent("" + ediConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entityFieldConfig);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEntityFieldConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEntityFieldConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EdiEntityFieldConfigModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EdiEntityFieldConfigModel>;
        }));
    }

    protected processPostEntityFieldConfig(response: HttpResponseBase): Observable<EdiEntityFieldConfigModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EdiEntityFieldConfigModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllByType(type?: EdiType | undefined): Observable<EdiConfigModel[]> {
        let url_ = this.baseUrl + "/api/EdiConfiguration/GetAllByType?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EdiConfigModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EdiConfigModel[]>;
        }));
    }

    protected processGetAllByType(response: HttpResponseBase): Observable<EdiConfigModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EdiConfigModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id?: string | undefined): Observable<EdiConfigModel> {
        let url_ = this.baseUrl + "/api/EdiConfiguration/GetById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EdiConfigModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EdiConfigModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<EdiConfigModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EdiConfigModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEntityConfigById(entityConfigId?: string | undefined, configId?: string | undefined): Observable<EdiEntityConfigModel> {
        let url_ = this.baseUrl + "/api/EdiConfiguration/GetEntityConfigById?";
        if (entityConfigId === null)
            throw new globalThis.Error("The parameter 'entityConfigId' cannot be null.");
        else if (entityConfigId !== undefined)
            url_ += "entityConfigId=" + encodeURIComponent("" + entityConfigId) + "&";
        if (configId === null)
            throw new globalThis.Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EdiEntityConfigModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EdiEntityConfigModel>;
        }));
    }

    protected processGetEntityConfigById(response: HttpResponseBase): Observable<EdiEntityConfigModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EdiEntityConfigModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/EdiConfiguration/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEntityConfig(configId?: string | undefined, entityConfigId?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/EdiConfiguration/DeleteEntityConfig?";
        if (configId === null)
            throw new globalThis.Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (entityConfigId === null)
            throw new globalThis.Error("The parameter 'entityConfigId' cannot be null.");
        else if (entityConfigId !== undefined)
            url_ += "entityConfigId=" + encodeURIComponent("" + entityConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEntityConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEntityConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteEntityConfig(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEntityFieldConfig(configId?: string | undefined, entityConfigId?: string | undefined, entityFieldConfigId?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/EdiConfiguration/DeleteEntityFieldConfig?";
        if (configId === null)
            throw new globalThis.Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (entityConfigId === null)
            throw new globalThis.Error("The parameter 'entityConfigId' cannot be null.");
        else if (entityConfigId !== undefined)
            url_ += "entityConfigId=" + encodeURIComponent("" + entityConfigId) + "&";
        if (entityFieldConfigId === null)
            throw new globalThis.Error("The parameter 'entityFieldConfigId' cannot be null.");
        else if (entityFieldConfigId !== undefined)
            url_ += "entityFieldConfigId=" + encodeURIComponent("" + entityFieldConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEntityFieldConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEntityFieldConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteEntityFieldConfig(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IExcelService {
    getWorkSheetNames(filename?: string | null | undefined): Observable<string[]>;
    previewExport(pagedQuery: PagedQuery): Observable<string[][]>;
    exportBalances(pagedQuery: PagedQuery, id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, fullProduct?: boolean | undefined, onlyOrganic?: boolean | undefined, forceRecalculate?: boolean | undefined, searchText?: string | null | undefined, productGroup?: string | null | undefined, productType?: string | null | undefined, calculateInputOutput?: boolean | undefined): Observable<FileResponse>;
    previewImport(filename?: string | null | undefined, configId?: string | null | undefined): Observable<string[][][]>;
    importRecipes(fileName?: string | null | undefined, sheetIndex?: number | undefined): Observable<string>;
    importForecastData(forecastId?: string | undefined, filename?: string | null | undefined, sheetIndex?: number | undefined, skippedLines?: number | undefined): Observable<string>;
    importProducts(filename?: string | null | undefined, configId?: string | undefined, sheetIndex?: number | undefined): Observable<string>;
    importStock(filename?: string | null | undefined, configId?: string | undefined, orderId?: string | undefined): Observable<string>;
    exportProductionOrders(pagedQuery: PagedQuery): Observable<FileResponse>;
    exportRecipes(pagedQuery: PagedQuery): Observable<FileResponse>;
    exportProducts(pagedQuery: PagedQuery): Observable<FileResponse>;
    exportStock(pagedQuery: PagedQuery): Observable<FileResponse>;
    exportStatistics(pagedQuery: PagedQuery): Observable<FileResponse>;
    exportPlanning(orders: ProductionOrderModel[]): Observable<FileResponse>;
    exportSuppliers(pagedQuery: PagedQuery): Observable<FileResponse>;
    exportCustomers(pagedQuery: PagedQuery): Observable<FileResponse>;
    exportSales(pagedQuery: PagedQuery): Observable<FileResponse>;
    exportPurchases(pagedQuery: PagedQuery): Observable<FileResponse>;
    exportCCPMeasurements(groupId?: string | undefined, startDate?: Date | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ExcelService implements IExcelService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getWorkSheetNames(filename?: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Excel/GetWorkSheetNames?";
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkSheetNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkSheetNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetWorkSheetNames(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    previewExport(pagedQuery: PagedQuery): Observable<string[][]> {
        let url_ = this.baseUrl + "/api/Excel/PreviewExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[][]>;
        }));
    }

    protected processPreviewExport(response: HttpResponseBase): Observable<string[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportBalances(pagedQuery: PagedQuery, id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, fullProduct?: boolean | undefined, onlyOrganic?: boolean | undefined, forceRecalculate?: boolean | undefined, searchText?: string | null | undefined, productGroup?: string | null | undefined, productType?: string | null | undefined, calculateInputOutput?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Excel/ExportBalances?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (includeEquivalents === null)
            throw new globalThis.Error("The parameter 'includeEquivalents' cannot be null.");
        else if (includeEquivalents !== undefined)
            url_ += "includeEquivalents=" + encodeURIComponent("" + includeEquivalents) + "&";
        if (fullProduct === null)
            throw new globalThis.Error("The parameter 'fullProduct' cannot be null.");
        else if (fullProduct !== undefined)
            url_ += "fullProduct=" + encodeURIComponent("" + fullProduct) + "&";
        if (onlyOrganic === null)
            throw new globalThis.Error("The parameter 'onlyOrganic' cannot be null.");
        else if (onlyOrganic !== undefined)
            url_ += "onlyOrganic=" + encodeURIComponent("" + onlyOrganic) + "&";
        if (forceRecalculate === null)
            throw new globalThis.Error("The parameter 'forceRecalculate' cannot be null.");
        else if (forceRecalculate !== undefined)
            url_ += "forceRecalculate=" + encodeURIComponent("" + forceRecalculate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (productGroup !== undefined && productGroup !== null)
            url_ += "productGroup=" + encodeURIComponent("" + productGroup) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (calculateInputOutput === null)
            throw new globalThis.Error("The parameter 'calculateInputOutput' cannot be null.");
        else if (calculateInputOutput !== undefined)
            url_ += "calculateInputOutput=" + encodeURIComponent("" + calculateInputOutput) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBalances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBalances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportBalances(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    previewImport(filename?: string | null | undefined, configId?: string | null | undefined): Observable<string[][][]> {
        let url_ = this.baseUrl + "/api/Excel/PreviewImport?";
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (configId !== undefined && configId !== null)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[][][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[][][]>;
        }));
    }

    protected processPreviewImport(response: HttpResponseBase): Observable<string[][][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importRecipes(fileName?: string | null | undefined, sheetIndex?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Excel/ImportRecipes?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (sheetIndex === null)
            throw new globalThis.Error("The parameter 'sheetIndex' cannot be null.");
        else if (sheetIndex !== undefined)
            url_ += "sheetIndex=" + encodeURIComponent("" + sheetIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportRecipes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportRecipes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportRecipes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importForecastData(forecastId?: string | undefined, filename?: string | null | undefined, sheetIndex?: number | undefined, skippedLines?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Excel/ImportForecastData?";
        if (forecastId === null)
            throw new globalThis.Error("The parameter 'forecastId' cannot be null.");
        else if (forecastId !== undefined)
            url_ += "forecastId=" + encodeURIComponent("" + forecastId) + "&";
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (sheetIndex === null)
            throw new globalThis.Error("The parameter 'sheetIndex' cannot be null.");
        else if (sheetIndex !== undefined)
            url_ += "sheetIndex=" + encodeURIComponent("" + sheetIndex) + "&";
        if (skippedLines === null)
            throw new globalThis.Error("The parameter 'skippedLines' cannot be null.");
        else if (skippedLines !== undefined)
            url_ += "skippedLines=" + encodeURIComponent("" + skippedLines) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportForecastData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportForecastData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportForecastData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importProducts(filename?: string | null | undefined, configId?: string | undefined, sheetIndex?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Excel/ImportProducts?";
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (configId === null)
            throw new globalThis.Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (sheetIndex === null)
            throw new globalThis.Error("The parameter 'sheetIndex' cannot be null.");
        else if (sheetIndex !== undefined)
            url_ += "sheetIndex=" + encodeURIComponent("" + sheetIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportProducts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importStock(filename?: string | null | undefined, configId?: string | undefined, orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Excel/ImportStock?";
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (configId === null)
            throw new globalThis.Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportStock(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportProductionOrders(pagedQuery: PagedQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Excel/ExportProductionOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProductionOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProductionOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportProductionOrders(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportRecipes(pagedQuery: PagedQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Excel/ExportRecipes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRecipes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRecipes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportRecipes(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportProducts(pagedQuery: PagedQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Excel/ExportProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportProducts(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportStock(pagedQuery: PagedQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Excel/ExportStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportStock(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportStatistics(pagedQuery: PagedQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Excel/ExportStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportStatistics(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPlanning(orders: ProductionOrderModel[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Excel/ExportPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orders);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportPlanning(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportSuppliers(pagedQuery: PagedQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Excel/ExportSuppliers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSuppliers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportSuppliers(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCustomers(pagedQuery: PagedQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Excel/ExportCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportCustomers(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportSales(pagedQuery: PagedQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Excel/ExportSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportSales(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPurchases(pagedQuery: PagedQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Excel/ExportPurchases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPurchases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPurchases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportPurchases(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCCPMeasurements(groupId?: string | undefined, startDate?: Date | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Excel/ExportCCPMeasurements?";
        if (groupId === null)
            throw new globalThis.Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCCPMeasurements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCCPMeasurements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportCCPMeasurements(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFindSmileyDataService {
    getByNavnelbnr(lbnr?: number | undefined): Observable<FindSmileyDataModel>;
    getAllByCVR(cvr?: string | null | undefined): Observable<FindSmileyDataModel[]>;
    getAllByCVRForOrganization(cvr?: string | null | undefined, pnr?: string | null | undefined): Observable<DepartmentFindSmileyDataModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class FindSmileyDataService implements IFindSmileyDataService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getByNavnelbnr(lbnr?: number | undefined): Observable<FindSmileyDataModel> {
        let url_ = this.baseUrl + "/api/FindSmileyData/GetByNavnelbnr?";
        if (lbnr === null)
            throw new globalThis.Error("The parameter 'lbnr' cannot be null.");
        else if (lbnr !== undefined)
            url_ += "lbnr=" + encodeURIComponent("" + lbnr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByNavnelbnr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByNavnelbnr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FindSmileyDataModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FindSmileyDataModel>;
        }));
    }

    protected processGetByNavnelbnr(response: HttpResponseBase): Observable<FindSmileyDataModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FindSmileyDataModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllByCVR(cvr?: string | null | undefined): Observable<FindSmileyDataModel[]> {
        let url_ = this.baseUrl + "/api/FindSmileyData/GetAllByCVR?";
        if (cvr !== undefined && cvr !== null)
            url_ += "cvr=" + encodeURIComponent("" + cvr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByCVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByCVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FindSmileyDataModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FindSmileyDataModel[]>;
        }));
    }

    protected processGetAllByCVR(response: HttpResponseBase): Observable<FindSmileyDataModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FindSmileyDataModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllByCVRForOrganization(cvr?: string | null | undefined, pnr?: string | null | undefined): Observable<DepartmentFindSmileyDataModel[]> {
        let url_ = this.baseUrl + "/api/FindSmileyData/GetAllByCVRForOrganization?";
        if (cvr !== undefined && cvr !== null)
            url_ += "cvr=" + encodeURIComponent("" + cvr) + "&";
        if (pnr !== undefined && pnr !== null)
            url_ += "pnr=" + encodeURIComponent("" + pnr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByCVRForOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByCVRForOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentFindSmileyDataModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentFindSmileyDataModel[]>;
        }));
    }

    protected processGetAllByCVRForOrganization(response: HttpResponseBase): Observable<DepartmentFindSmileyDataModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentFindSmileyDataModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFoodAnalysisService {
    getAll(): Observable<FoodAnalysisModel[]>;
    getAllViews(): Observable<FoodAnalysisViewModel[]>;
    getByVisit(visitId?: string | undefined): Observable<FoodAnalysisModel[]>;
    getViewsByVisit(visitId?: string | undefined): Observable<FoodAnalysisViewModel[]>;
    get(id?: string | undefined): Observable<FoodAnalysisModel>;
    getView(id?: string | undefined): Observable<FoodAnalysisViewModel>;
    post(model: FoodAnalysisModel): Observable<FoodAnalysisModel>;
    delete(id?: string | undefined): Observable<FoodAnalysisModel>;
    getReport(type?: string | null | undefined, analysisId?: string | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class FoodAnalysisService implements IFoodAnalysisService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<FoodAnalysisModel[]> {
        let url_ = this.baseUrl + "/api/FoodAnalysis/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodAnalysisModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodAnalysisModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FoodAnalysisModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodAnalysisModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllViews(): Observable<FoodAnalysisViewModel[]> {
        let url_ = this.baseUrl + "/api/FoodAnalysis/GetAllViews";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllViews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllViews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodAnalysisViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodAnalysisViewModel[]>;
        }));
    }

    protected processGetAllViews(response: HttpResponseBase): Observable<FoodAnalysisViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodAnalysisViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByVisit(visitId?: string | undefined): Observable<FoodAnalysisModel[]> {
        let url_ = this.baseUrl + "/api/FoodAnalysis/GetByVisit?";
        if (visitId === null)
            throw new globalThis.Error("The parameter 'visitId' cannot be null.");
        else if (visitId !== undefined)
            url_ += "visitId=" + encodeURIComponent("" + visitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByVisit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByVisit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodAnalysisModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodAnalysisModel[]>;
        }));
    }

    protected processGetByVisit(response: HttpResponseBase): Observable<FoodAnalysisModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodAnalysisModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getViewsByVisit(visitId?: string | undefined): Observable<FoodAnalysisViewModel[]> {
        let url_ = this.baseUrl + "/api/FoodAnalysis/GetViewsByVisit?";
        if (visitId === null)
            throw new globalThis.Error("The parameter 'visitId' cannot be null.");
        else if (visitId !== undefined)
            url_ += "visitId=" + encodeURIComponent("" + visitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViewsByVisit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViewsByVisit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodAnalysisViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodAnalysisViewModel[]>;
        }));
    }

    protected processGetViewsByVisit(response: HttpResponseBase): Observable<FoodAnalysisViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodAnalysisViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id?: string | undefined): Observable<FoodAnalysisModel> {
        let url_ = this.baseUrl + "/api/FoodAnalysis/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodAnalysisModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FoodAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getView(id?: string | undefined): Observable<FoodAnalysisViewModel> {
        let url_ = this.baseUrl + "/api/FoodAnalysis/GetView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodAnalysisViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodAnalysisViewModel>;
        }));
    }

    protected processGetView(response: HttpResponseBase): Observable<FoodAnalysisViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodAnalysisViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: FoodAnalysisModel): Observable<FoodAnalysisModel> {
        let url_ = this.baseUrl + "/api/FoodAnalysis/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodAnalysisModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FoodAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<FoodAnalysisModel> {
        let url_ = this.baseUrl + "/api/FoodAnalysis/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodAnalysisModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FoodAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(type?: string | null | undefined, analysisId?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/FoodAnalysis/GetReport?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (analysisId === null)
            throw new globalThis.Error("The parameter 'analysisId' cannot be null.");
        else if (analysisId !== undefined)
            url_ += "analysisId=" + encodeURIComponent("" + analysisId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFoodAnalysisTypeService {
    getAll(): Observable<FoodAnalysisType[]>;
    get(id?: string | undefined): Observable<FoodAnalysisType>;
    post(model: FoodAnalysisType): Observable<FoodAnalysisType>;
    delete(id?: string | undefined): Observable<FoodAnalysisType>;
}

@Injectable({
    providedIn: 'root'
})
export class FoodAnalysisTypeService implements IFoodAnalysisTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<FoodAnalysisType[]> {
        let url_ = this.baseUrl + "/api/FoodAnalysisType/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodAnalysisType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodAnalysisType[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FoodAnalysisType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodAnalysisType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id?: string | undefined): Observable<FoodAnalysisType> {
        let url_ = this.baseUrl + "/api/FoodAnalysisType/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodAnalysisType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodAnalysisType>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FoodAnalysisType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodAnalysisType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: FoodAnalysisType): Observable<FoodAnalysisType> {
        let url_ = this.baseUrl + "/api/FoodAnalysisType/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodAnalysisType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodAnalysisType>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FoodAnalysisType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodAnalysisType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<FoodAnalysisType> {
        let url_ = this.baseUrl + "/api/FoodAnalysisType/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodAnalysisType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodAnalysisType>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FoodAnalysisType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodAnalysisType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFoodStandardService {
    get(id?: string | undefined): Observable<FoodStandardModel>;
    getAll(): Observable<FoodStandardModel[]>;
    getRequirementLinksByEntityId(entityId?: string | undefined, entityType?: EntityType | undefined): Observable<FoodStandardRequirementLinkModel[]>;
    post(model: FoodStandardModel): Observable<FoodStandardModel>;
    postRequirement(model: FoodStandardRequirementModel): Observable<FoodStandardRequirementModel>;
    postRequirementLink(model: FoodStandardRequirementLinkModel): Observable<FoodStandardRequirementLinkModel>;
    delete(id?: string | undefined): Observable<string>;
    deleteRequirement(id?: string | undefined): Observable<string>;
    deleteRequirementLink(id?: string | undefined): Observable<string>;
    importFoodStandards(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class FoodStandardService implements IFoodStandardService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id?: string | undefined): Observable<FoodStandardModel> {
        let url_ = this.baseUrl + "/api/FoodStandard/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodStandardModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodStandardModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FoodStandardModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodStandardModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<FoodStandardModel[]> {
        let url_ = this.baseUrl + "/api/FoodStandard/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodStandardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodStandardModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FoodStandardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodStandardModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRequirementLinksByEntityId(entityId?: string | undefined, entityType?: EntityType | undefined): Observable<FoodStandardRequirementLinkModel[]> {
        let url_ = this.baseUrl + "/api/FoodStandard/GetRequirementLinksByEntityId?";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new globalThis.Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequirementLinksByEntityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequirementLinksByEntityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodStandardRequirementLinkModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodStandardRequirementLinkModel[]>;
        }));
    }

    protected processGetRequirementLinksByEntityId(response: HttpResponseBase): Observable<FoodStandardRequirementLinkModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodStandardRequirementLinkModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: FoodStandardModel): Observable<FoodStandardModel> {
        let url_ = this.baseUrl + "/api/FoodStandard/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodStandardModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodStandardModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FoodStandardModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodStandardModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postRequirement(model: FoodStandardRequirementModel): Observable<FoodStandardRequirementModel> {
        let url_ = this.baseUrl + "/api/FoodStandard/PostRequirement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostRequirement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostRequirement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodStandardRequirementModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodStandardRequirementModel>;
        }));
    }

    protected processPostRequirement(response: HttpResponseBase): Observable<FoodStandardRequirementModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodStandardRequirementModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postRequirementLink(model: FoodStandardRequirementLinkModel): Observable<FoodStandardRequirementLinkModel> {
        let url_ = this.baseUrl + "/api/FoodStandard/PostRequirementLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostRequirementLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostRequirementLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodStandardRequirementLinkModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodStandardRequirementLinkModel>;
        }));
    }

    protected processPostRequirementLink(response: HttpResponseBase): Observable<FoodStandardRequirementLinkModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodStandardRequirementLinkModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FoodStandard/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRequirement(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FoodStandard/DeleteRequirement?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRequirement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRequirement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteRequirement(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRequirementLink(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FoodStandard/DeleteRequirementLink?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRequirementLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRequirementLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteRequirementLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importFoodStandards(): Observable<string> {
        let url_ = this.baseUrl + "/api/FoodStandard/ImportFoodStandards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportFoodStandards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportFoodStandards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportFoodStandards(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IForecastService {
    getAllByOrganization(): Observable<ForecastModel[]>;
    getById(id?: string | undefined, forecastLevel?: ForecastLevel | null | undefined, productGroupId?: string | null | undefined, productVariantId?: string | null | undefined, customerGroupId?: string | null | undefined, customerId?: string | null | undefined): Observable<ForecastModel>;
    forecastCreateOrUpdate(forecast: ForecastModel): Observable<ForecastModel>;
    deleteForecast(id?: string | undefined): Observable<boolean>;
    restoreForecast(id?: string | undefined): Observable<boolean>;
    getForecastData(forecastId?: string | undefined, forecastLevel?: ForecastLevel | null | undefined, productGroupId?: string | null | undefined, productVariantId?: string | null | undefined, customerGroupId?: string | null | undefined, customerId?: string | null | undefined): Observable<ForecastGridRow[]>;
    updateForecastData(data: ForecastGridRow[], forecastId?: string | undefined): Observable<ForecastGridRow[]>;
    getForecastDatasource(): Observable<ForecastDatasource>;
    getDatasourceItems(): Observable<ForecastItemDatasource[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ForecastService implements IForecastService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllByOrganization(): Observable<ForecastModel[]> {
        let url_ = this.baseUrl + "/api/Forecast/GetAllByOrganization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastModel[]>;
        }));
    }

    protected processGetAllByOrganization(response: HttpResponseBase): Observable<ForecastModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ForecastModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id?: string | undefined, forecastLevel?: ForecastLevel | null | undefined, productGroupId?: string | null | undefined, productVariantId?: string | null | undefined, customerGroupId?: string | null | undefined, customerId?: string | null | undefined): Observable<ForecastModel> {
        let url_ = this.baseUrl + "/api/Forecast/GetById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (forecastLevel !== undefined && forecastLevel !== null)
            url_ += "forecastLevel=" + encodeURIComponent("" + forecastLevel) + "&";
        if (productGroupId !== undefined && productGroupId !== null)
            url_ += "productGroupId=" + encodeURIComponent("" + productGroupId) + "&";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (customerGroupId !== undefined && customerGroupId !== null)
            url_ += "customerGroupId=" + encodeURIComponent("" + customerGroupId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ForecastModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForecastModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forecastCreateOrUpdate(forecast: ForecastModel): Observable<ForecastModel> {
        let url_ = this.baseUrl + "/api/Forecast/ForecastCreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forecast);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForecastCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForecastCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastModel>;
        }));
    }

    protected processForecastCreateOrUpdate(response: HttpResponseBase): Observable<ForecastModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForecastModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteForecast(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Forecast/DeleteForecast?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteForecast(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteForecast(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteForecast(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    restoreForecast(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Forecast/RestoreForecast?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreForecast(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreForecast(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRestoreForecast(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getForecastData(forecastId?: string | undefined, forecastLevel?: ForecastLevel | null | undefined, productGroupId?: string | null | undefined, productVariantId?: string | null | undefined, customerGroupId?: string | null | undefined, customerId?: string | null | undefined): Observable<ForecastGridRow[]> {
        let url_ = this.baseUrl + "/api/Forecast/GetForecastData?";
        if (forecastId === null)
            throw new globalThis.Error("The parameter 'forecastId' cannot be null.");
        else if (forecastId !== undefined)
            url_ += "forecastId=" + encodeURIComponent("" + forecastId) + "&";
        if (forecastLevel !== undefined && forecastLevel !== null)
            url_ += "forecastLevel=" + encodeURIComponent("" + forecastLevel) + "&";
        if (productGroupId !== undefined && productGroupId !== null)
            url_ += "productGroupId=" + encodeURIComponent("" + productGroupId) + "&";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (customerGroupId !== undefined && customerGroupId !== null)
            url_ += "customerGroupId=" + encodeURIComponent("" + customerGroupId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastGridRow[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastGridRow[]>;
        }));
    }

    protected processGetForecastData(response: HttpResponseBase): Observable<ForecastGridRow[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ForecastGridRow.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateForecastData(data: ForecastGridRow[], forecastId?: string | undefined): Observable<ForecastGridRow[]> {
        let url_ = this.baseUrl + "/api/Forecast/UpdateForecastData?";
        if (forecastId === null)
            throw new globalThis.Error("The parameter 'forecastId' cannot be null.");
        else if (forecastId !== undefined)
            url_ += "forecastId=" + encodeURIComponent("" + forecastId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForecastData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForecastData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastGridRow[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastGridRow[]>;
        }));
    }

    protected processUpdateForecastData(response: HttpResponseBase): Observable<ForecastGridRow[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ForecastGridRow.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getForecastDatasource(): Observable<ForecastDatasource> {
        let url_ = this.baseUrl + "/api/Forecast/GetForecastDatasource";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastDatasource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastDatasource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastDatasource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastDatasource>;
        }));
    }

    protected processGetForecastDatasource(response: HttpResponseBase): Observable<ForecastDatasource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForecastDatasource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDatasourceItems(): Observable<ForecastItemDatasource[]> {
        let url_ = this.baseUrl + "/api/Forecast/GetDatasourceItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatasourceItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatasourceItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemDatasource[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemDatasource[]>;
        }));
    }

    protected processGetDatasourceItems(response: HttpResponseBase): Observable<ForecastItemDatasource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ForecastItemDatasource.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IGlobalSearchService {
    search(searchTerm?: string | null | undefined): Observable<string[][]>;
}

@Injectable({
    providedIn: 'root'
})
export class GlobalSearchService implements IGlobalSearchService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    search(searchTerm?: string | null | undefined): Observable<string[][]> {
        let url_ = this.baseUrl + "/api/GlobalSearch/Search?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[][]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<string[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IGroupRelationService {
    getByEntity(id?: string | undefined): Observable<GroupRelationModel[]>;
    post(model: GroupRelationModel): Observable<GroupRelationModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class GroupRelationService implements IGroupRelationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getByEntity(id?: string | undefined): Observable<GroupRelationModel[]> {
        let url_ = this.baseUrl + "/api/GroupRelation/GetByEntity?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupRelationModel[]>;
        }));
    }

    protected processGetByEntity(response: HttpResponseBase): Observable<GroupRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: GroupRelationModel): Observable<GroupRelationModel> {
        let url_ = this.baseUrl + "/api/GroupRelation/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupRelationModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<GroupRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/GroupRelation/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IIntegrationService {
    moveShopOrders(organizationId?: string | undefined): Observable<string>;
    handleWebhook(): Observable<FileResponse>;
    scheduleSensoHiveDataImport(organizationId?: string | undefined): Observable<string>;
    scheduleSensoristDataImport(organizationId?: string | undefined): Observable<string>;
    scheduleImportAllThermItMeasurements(organizationId?: string | undefined): Observable<string>;
    importAllThermItMeasurements(organizationId?: string | undefined): Observable<string>;
    scheduleSendLateNotification(receivers: string[], organizationId?: string | undefined): Observable<string>;
    importDankost(): Observable<string>;
    importFoodOp(): Observable<string>;
    importFoodInfo(): Observable<string>;
    importTuris(): Observable<string>;
    importUniconta(syncDays?: number | undefined): Observable<string>;
    scheduleUniconta(): Observable<string>;
    scheduleTuris(): Observable<string>;
    importEsmileyProgram(): Observable<string>;
    importAnticimex(): Observable<string>;
    importAnticimexValuesForOrganization(organizationId?: string | undefined): Observable<string>;
    importAnticimexForOrganization(organizationId?: string | undefined): Observable<string>;
    importEmporioProductData(organizationId?: string | undefined, full?: boolean | undefined): Observable<string>;
    scheduleImportCompassData(organizationId?: string | undefined): Observable<string>;
    scheduleImportEmporioProductData(organizationId?: string | undefined): Observable<string>;
    scheduleImportEmporioProductData2(organizationId?: string | undefined): Observable<string>;
    scheduleImportEmporioPurchaseOrderData(organizationId?: string | undefined): Observable<string>;
    scheduleCheckEconomicOrders(organizationId?: string | undefined): Observable<string>;
    importEmporioPurchaseOrdersTestTrigger(organizationId?: string | undefined): Observable<string>;
    importEDI(organizationId?: string | undefined): Observable<string>;
    importEDIOrder(organizationId?: string | undefined, orderId?: string | undefined): Observable<string>;
    importOioUblOrder(organizationId?: string | undefined, orderId?: string | null | undefined): Observable<string>;
    importOioUblOrders(organizationId?: string | undefined): Observable<string>;
    importDagrofaOrders(organizationId?: string | undefined, startDate?: Date | null | undefined): Observable<string>;
    importDagrofaOrder(organizationId?: string | undefined, orderId?: string | null | undefined): Observable<string>;
    exportEDIInvoice(organizationId?: string | undefined, orderId?: string | undefined): Observable<string>;
    importMySupply(organizationId?: string | undefined): Observable<string>;
    sendInvoiceMySupply(organizationId?: string | undefined, orderId?: string | undefined): Observable<string>;
    sendDespatchAdviceMySupply(organizationId?: string | undefined, orderId?: string | undefined): Observable<string>;
    scheduleMySupplyDocuments(organizationId?: string | undefined): Observable<string>;
    getGs1Data(organizationId?: string | undefined, date?: Date | null | undefined): Observable<string>;
    updateEconomicData(organizationId?: string | undefined): Observable<string>;
    updateEconomicOrder(organizationId?: string | undefined, orderNumber?: number | null | undefined, oldNumber?: number | null | undefined): Observable<string>;
    updateEconomicSentOrder(organizationId?: string | undefined, orderNumber?: number | null | undefined, oldNumber?: number | null | undefined): Observable<string>;
    updateEconomicArchivedOrder(organizationId?: string | undefined, orderNumber?: number | null | undefined, oldNumber?: number | null | undefined): Observable<string>;
    updateEconomicInvoice(organizationId?: string | undefined, invoiceNumber?: number | null | undefined, oldNumber?: number | null | undefined): Observable<string>;
    bookEconomicInvoice(organizationId?: string | undefined, invoiceNumber?: number | undefined): Observable<string>;
    bulkInvoice(organizationId?: string | undefined, emails?: string | null | undefined): Observable<string>;
    updateEconomicProduct(organizationId?: string | undefined, productNumber?: number | null | undefined): Observable<string>;
    getEconomicUnits(organizationId?: string | undefined): Observable<string>;
    updateEconomicCustomer(organizationId?: string | undefined, customerNumber?: number | null | undefined, oldNumber?: number | null | undefined): Observable<string>;
    updateEconomicSupplier(organizationId?: string | undefined, supplierNumber?: number | null | undefined, oldNumber?: number | null | undefined): Observable<string>;
    sendProductsToEconomic(organizationId?: string | undefined): Observable<string>;
    sendCustomersToEconomic(organizationId?: string | undefined): Observable<string>;
    scheduleEconomicCustomerImport(organizationId?: string | undefined): Observable<string>;
    scheduleDagrofaImport(organizationId?: string | undefined): Observable<string>;
    scheduleEDIImport(organizationId?: string | undefined): Observable<string>;
    shopifyOrder(order: ShopifyOrderModel): Observable<string>;
    shopifyGetOrder(orderId?: number | undefined): Observable<string>;
    scheduleMoveShopOrders(organizationId?: string | undefined): Observable<string>;
    scheduleUpdateLotStatus(organizationId?: string | undefined): Observable<string>;
    scheduleCalculateAllRecipeCosts(organizationId?: string | undefined): Observable<string>;
    scheduleStockCheck(organizationId?: string | undefined, emails?: string | null | undefined): Observable<string>;
    scheduleCustomerFollowUpCheck(organizationId?: string | undefined, emails?: string | null | undefined): Observable<string>;
    scheduleGetGormsInvoices(organizationId?: string | undefined, customerNumber?: number | undefined): Observable<string>;
    scheduleCreateOrdersForSubscriptions(organizationId?: string | undefined, customerNumber?: number | undefined): Observable<string>;
    scheduleAutomaticRefill(organizationId?: string | undefined, emails?: string | null | undefined): Observable<string>;
    scheduleBulkInvoice(organizationId?: string | undefined, emails?: string | null | undefined): Observable<string>;
    fixStockPositionLocation(organizationId?: string | undefined): Observable<string>;
    fixQSPlanningAndGithubIssues(): Observable<string>;
    bookOpterTransport(orderId?: string | undefined): Observable<string>;
    importFindSmileyData(): Observable<string>;
    importCompassXmlData(): Observable<string>;
    importCompassData(): Observable<string>;
    importCompassPurchaseOrders(): Observable<string>;
    importCompassPurchaseCreditOrders(): Observable<string>;
    exportCompassPurchaseOrder(orderId?: string | undefined): Observable<string>;
    exportCompassSalesOrder(orderId?: string | undefined): Observable<string>;
    exportCompassInventory(orderId?: string | undefined): Observable<string>;
    exportCompassSalesStatistics(orderId?: string | undefined): Observable<string>;
    importDanskCaterProducts(productId?: string | undefined): Observable<string>;
    importDagrofaProducts(): Observable<string>;
    importSensorist(organizationId?: string | undefined): Observable<string>;
    getCompanyDetailsByCvr(cvr?: string | null | undefined): Observable<VirkCompanyModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class IntegrationService implements IIntegrationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    moveShopOrders(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/MoveShopOrders?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveShopOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveShopOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMoveShopOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    handleWebhook(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Integration/HandleWebhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHandleWebhook(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleSensoHiveDataImport(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleSensoHiveDataImport?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleSensoHiveDataImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleSensoHiveDataImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleSensoHiveDataImport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleSensoristDataImport(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleSensoristDataImport?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleSensoristDataImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleSensoristDataImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleSensoristDataImport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleImportAllThermItMeasurements(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleImportAllThermItMeasurements?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleImportAllThermItMeasurements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleImportAllThermItMeasurements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleImportAllThermItMeasurements(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importAllThermItMeasurements(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportAllThermItMeasurements?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportAllThermItMeasurements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportAllThermItMeasurements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportAllThermItMeasurements(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleSendLateNotification(receivers: string[], organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleSendLateNotification?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(receivers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleSendLateNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleSendLateNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleSendLateNotification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importDankost(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportDankost";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportDankost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportDankost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportDankost(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importFoodOp(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportFoodOp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportFoodOp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportFoodOp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportFoodOp(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importFoodInfo(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportFoodInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportFoodInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportFoodInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportFoodInfo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importTuris(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportTuris";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportTuris(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportTuris(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportTuris(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importUniconta(syncDays?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportUniconta?";
        if (syncDays === null)
            throw new globalThis.Error("The parameter 'syncDays' cannot be null.");
        else if (syncDays !== undefined)
            url_ += "syncDays=" + encodeURIComponent("" + syncDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportUniconta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportUniconta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportUniconta(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleUniconta(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleUniconta";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleUniconta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleUniconta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleUniconta(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleTuris(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleTuris";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleTuris(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleTuris(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleTuris(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importEsmileyProgram(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportEsmileyProgram";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEsmileyProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEsmileyProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportEsmileyProgram(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importAnticimex(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportAnticimex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportAnticimex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportAnticimex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportAnticimex(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importAnticimexValuesForOrganization(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportAnticimexValuesForOrganization?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportAnticimexValuesForOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportAnticimexValuesForOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportAnticimexValuesForOrganization(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importAnticimexForOrganization(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportAnticimexForOrganization?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportAnticimexForOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportAnticimexForOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportAnticimexForOrganization(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importEmporioProductData(organizationId?: string | undefined, full?: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportEmporioProductData?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (full === null)
            throw new globalThis.Error("The parameter 'full' cannot be null.");
        else if (full !== undefined)
            url_ += "full=" + encodeURIComponent("" + full) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEmporioProductData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEmporioProductData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportEmporioProductData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleImportCompassData(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleImportCompassData?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleImportCompassData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleImportCompassData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleImportCompassData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleImportEmporioProductData(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleImportEmporioProductData?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleImportEmporioProductData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleImportEmporioProductData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleImportEmporioProductData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleImportEmporioProductData2(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleImportEmporioProductData2?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleImportEmporioProductData2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleImportEmporioProductData2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleImportEmporioProductData2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleImportEmporioPurchaseOrderData(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleImportEmporioPurchaseOrderData?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleImportEmporioPurchaseOrderData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleImportEmporioPurchaseOrderData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleImportEmporioPurchaseOrderData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleCheckEconomicOrders(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleCheckEconomicOrders?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleCheckEconomicOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleCheckEconomicOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleCheckEconomicOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importEmporioPurchaseOrdersTestTrigger(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportEmporioPurchaseOrdersTestTrigger?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEmporioPurchaseOrdersTestTrigger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEmporioPurchaseOrdersTestTrigger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportEmporioPurchaseOrdersTestTrigger(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importEDI(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportEDI?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEDI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEDI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportEDI(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importEDIOrder(organizationId?: string | undefined, orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportEDIOrder?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEDIOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEDIOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportEDIOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importOioUblOrder(organizationId?: string | undefined, orderId?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportOioUblOrder?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportOioUblOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportOioUblOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportOioUblOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importOioUblOrders(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportOioUblOrders?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportOioUblOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportOioUblOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportOioUblOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importDagrofaOrders(organizationId?: string | undefined, startDate?: Date | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportDagrofaOrders?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportDagrofaOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportDagrofaOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportDagrofaOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importDagrofaOrder(organizationId?: string | undefined, orderId?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportDagrofaOrder?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportDagrofaOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportDagrofaOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportDagrofaOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportEDIInvoice(organizationId?: string | undefined, orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ExportEDIInvoice?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportEDIInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportEDIInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportEDIInvoice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importMySupply(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportMySupply?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportMySupply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportMySupply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportMySupply(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendInvoiceMySupply(organizationId?: string | undefined, orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/SendInvoiceMySupply?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendInvoiceMySupply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInvoiceMySupply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendInvoiceMySupply(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendDespatchAdviceMySupply(organizationId?: string | undefined, orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/SendDespatchAdviceMySupply?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDespatchAdviceMySupply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDespatchAdviceMySupply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendDespatchAdviceMySupply(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleMySupplyDocuments(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleMySupplyDocuments?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleMySupplyDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleMySupplyDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleMySupplyDocuments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGs1Data(organizationId?: string | undefined, date?: Date | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/GetGs1Data?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGs1Data(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGs1Data(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetGs1Data(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEconomicData(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/UpdateEconomicData?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEconomicData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEconomicData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateEconomicData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEconomicOrder(organizationId?: string | undefined, orderNumber?: number | null | undefined, oldNumber?: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/UpdateEconomicOrder?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (orderNumber !== undefined && orderNumber !== null)
            url_ += "orderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        if (oldNumber !== undefined && oldNumber !== null)
            url_ += "oldNumber=" + encodeURIComponent("" + oldNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEconomicOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEconomicOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateEconomicOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEconomicSentOrder(organizationId?: string | undefined, orderNumber?: number | null | undefined, oldNumber?: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/UpdateEconomicSentOrder?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (orderNumber !== undefined && orderNumber !== null)
            url_ += "orderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        if (oldNumber !== undefined && oldNumber !== null)
            url_ += "oldNumber=" + encodeURIComponent("" + oldNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEconomicSentOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEconomicSentOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateEconomicSentOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEconomicArchivedOrder(organizationId?: string | undefined, orderNumber?: number | null | undefined, oldNumber?: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/UpdateEconomicArchivedOrder?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (orderNumber !== undefined && orderNumber !== null)
            url_ += "orderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        if (oldNumber !== undefined && oldNumber !== null)
            url_ += "oldNumber=" + encodeURIComponent("" + oldNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEconomicArchivedOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEconomicArchivedOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateEconomicArchivedOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEconomicInvoice(organizationId?: string | undefined, invoiceNumber?: number | null | undefined, oldNumber?: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/UpdateEconomicInvoice?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (invoiceNumber !== undefined && invoiceNumber !== null)
            url_ += "invoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (oldNumber !== undefined && oldNumber !== null)
            url_ += "oldNumber=" + encodeURIComponent("" + oldNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEconomicInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEconomicInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateEconomicInvoice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bookEconomicInvoice(organizationId?: string | undefined, invoiceNumber?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/BookEconomicInvoice?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (invoiceNumber === null)
            throw new globalThis.Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "invoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookEconomicInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookEconomicInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBookEconomicInvoice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkInvoice(organizationId?: string | undefined, emails?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/BulkInvoice?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (emails !== undefined && emails !== null)
            url_ += "emails=" + encodeURIComponent("" + emails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkInvoice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEconomicProduct(organizationId?: string | undefined, productNumber?: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/UpdateEconomicProduct?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (productNumber !== undefined && productNumber !== null)
            url_ += "productNumber=" + encodeURIComponent("" + productNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEconomicProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEconomicProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateEconomicProduct(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEconomicUnits(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/GetEconomicUnits?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEconomicUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEconomicUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEconomicUnits(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEconomicCustomer(organizationId?: string | undefined, customerNumber?: number | null | undefined, oldNumber?: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/UpdateEconomicCustomer?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (customerNumber !== undefined && customerNumber !== null)
            url_ += "customerNumber=" + encodeURIComponent("" + customerNumber) + "&";
        if (oldNumber !== undefined && oldNumber !== null)
            url_ += "oldNumber=" + encodeURIComponent("" + oldNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEconomicCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEconomicCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateEconomicCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEconomicSupplier(organizationId?: string | undefined, supplierNumber?: number | null | undefined, oldNumber?: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/UpdateEconomicSupplier?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (supplierNumber !== undefined && supplierNumber !== null)
            url_ += "supplierNumber=" + encodeURIComponent("" + supplierNumber) + "&";
        if (oldNumber !== undefined && oldNumber !== null)
            url_ += "oldNumber=" + encodeURIComponent("" + oldNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEconomicSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEconomicSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateEconomicSupplier(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendProductsToEconomic(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/SendProductsToEconomic?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendProductsToEconomic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendProductsToEconomic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendProductsToEconomic(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendCustomersToEconomic(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/SendCustomersToEconomic?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendCustomersToEconomic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendCustomersToEconomic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendCustomersToEconomic(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleEconomicCustomerImport(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleEconomicCustomerImport?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleEconomicCustomerImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleEconomicCustomerImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleEconomicCustomerImport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleDagrofaImport(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleDagrofaImport?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleDagrofaImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleDagrofaImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleDagrofaImport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleEDIImport(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleEDIImport?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleEDIImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleEDIImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleEDIImport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    shopifyOrder(order: ShopifyOrderModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ShopifyOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(order);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShopifyOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShopifyOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processShopifyOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    shopifyGetOrder(orderId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ShopifyGetOrder?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShopifyGetOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShopifyGetOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processShopifyGetOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleMoveShopOrders(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleMoveShopOrders?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleMoveShopOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleMoveShopOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleMoveShopOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleUpdateLotStatus(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleUpdateLotStatus?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleUpdateLotStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleUpdateLotStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleUpdateLotStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleCalculateAllRecipeCosts(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleCalculateAllRecipeCosts?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleCalculateAllRecipeCosts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleCalculateAllRecipeCosts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleCalculateAllRecipeCosts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleStockCheck(organizationId?: string | undefined, emails?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleStockCheck?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (emails !== undefined && emails !== null)
            url_ += "emails=" + encodeURIComponent("" + emails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleStockCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleStockCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleStockCheck(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleCustomerFollowUpCheck(organizationId?: string | undefined, emails?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleCustomerFollowUpCheck?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (emails !== undefined && emails !== null)
            url_ += "emails=" + encodeURIComponent("" + emails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleCustomerFollowUpCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleCustomerFollowUpCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleCustomerFollowUpCheck(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleGetGormsInvoices(organizationId?: string | undefined, customerNumber?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleGetGormsInvoices?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (customerNumber === null)
            throw new globalThis.Error("The parameter 'customerNumber' cannot be null.");
        else if (customerNumber !== undefined)
            url_ += "customerNumber=" + encodeURIComponent("" + customerNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleGetGormsInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleGetGormsInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleGetGormsInvoices(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleCreateOrdersForSubscriptions(organizationId?: string | undefined, customerNumber?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleCreateOrdersForSubscriptions?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (customerNumber === null)
            throw new globalThis.Error("The parameter 'customerNumber' cannot be null.");
        else if (customerNumber !== undefined)
            url_ += "customerNumber=" + encodeURIComponent("" + customerNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleCreateOrdersForSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleCreateOrdersForSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleCreateOrdersForSubscriptions(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleAutomaticRefill(organizationId?: string | undefined, emails?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleAutomaticRefill?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (emails !== undefined && emails !== null)
            url_ += "emails=" + encodeURIComponent("" + emails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleAutomaticRefill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleAutomaticRefill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleAutomaticRefill(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleBulkInvoice(organizationId?: string | undefined, emails?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ScheduleBulkInvoice?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (emails !== undefined && emails !== null)
            url_ += "emails=" + encodeURIComponent("" + emails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleBulkInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleBulkInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleBulkInvoice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fixStockPositionLocation(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/FixStockPositionLocation?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixStockPositionLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixStockPositionLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFixStockPositionLocation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fixQSPlanningAndGithubIssues(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/FixQSPlanningAndGithubIssues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixQSPlanningAndGithubIssues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixQSPlanningAndGithubIssues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFixQSPlanningAndGithubIssues(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bookOpterTransport(orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/BookOpterTransport?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookOpterTransport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookOpterTransport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBookOpterTransport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importFindSmileyData(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportFindSmileyData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportFindSmileyData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportFindSmileyData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportFindSmileyData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importCompassXmlData(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportCompassXmlData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCompassXmlData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCompassXmlData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportCompassXmlData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importCompassData(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportCompassData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCompassData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCompassData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportCompassData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importCompassPurchaseOrders(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportCompassPurchaseOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCompassPurchaseOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCompassPurchaseOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportCompassPurchaseOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importCompassPurchaseCreditOrders(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportCompassPurchaseCreditOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCompassPurchaseCreditOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCompassPurchaseCreditOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportCompassPurchaseCreditOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCompassPurchaseOrder(orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ExportCompassPurchaseOrder?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCompassPurchaseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCompassPurchaseOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportCompassPurchaseOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCompassSalesOrder(orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ExportCompassSalesOrder?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCompassSalesOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCompassSalesOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportCompassSalesOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCompassInventory(orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ExportCompassInventory?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCompassInventory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCompassInventory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportCompassInventory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCompassSalesStatistics(orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ExportCompassSalesStatistics?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCompassSalesStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCompassSalesStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportCompassSalesStatistics(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importDanskCaterProducts(productId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportDanskCaterProducts?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportDanskCaterProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportDanskCaterProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportDanskCaterProducts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importDagrofaProducts(): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportDagrofaProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportDagrofaProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportDagrofaProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportDagrofaProducts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importSensorist(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/ImportSensorist?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportSensorist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportSensorist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportSensorist(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCompanyDetailsByCvr(cvr?: string | null | undefined): Observable<VirkCompanyModel[]> {
        let url_ = this.baseUrl + "/api/Integration/GetCompanyDetailsByCvr?";
        if (cvr !== undefined && cvr !== null)
            url_ += "cvr=" + encodeURIComponent("" + cvr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDetailsByCvr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDetailsByCvr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VirkCompanyModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VirkCompanyModel[]>;
        }));
    }

    protected processGetCompanyDetailsByCvr(response: HttpResponseBase): Observable<VirkCompanyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VirkCompanyModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMaintenanceTaskService {
    get(id?: string | undefined): Observable<MaintenanceTaskModel>;
    getAll(): Observable<MaintenanceTaskModel[]>;
    getAllPaged(query: PagedQuery): Observable<PagedResultOfMaintenanceTaskModel>;
    getTasksByMaintenance(id?: string | undefined): Observable<CtrTaskModel[]>;
    deleteTask(id?: string | undefined): Observable<void>;
    post(model: MaintenanceTaskModel): Observable<MaintenanceTaskModel>;
    copy(id?: string | undefined, newName?: string | null | undefined): Observable<MaintenanceTaskModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class MaintenanceTaskService implements IMaintenanceTaskService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id?: string | undefined): Observable<MaintenanceTaskModel> {
        let url_ = this.baseUrl + "/api/MaintenanceTask/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceTaskModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MaintenanceTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<MaintenanceTaskModel[]> {
        let url_ = this.baseUrl + "/api/MaintenanceTask/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceTaskModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MaintenanceTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintenanceTaskModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPaged(query: PagedQuery): Observable<PagedResultOfMaintenanceTaskModel> {
        let url_ = this.baseUrl + "/api/MaintenanceTask/GetAllPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfMaintenanceTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfMaintenanceTaskModel>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<PagedResultOfMaintenanceTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfMaintenanceTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTasksByMaintenance(id?: string | undefined): Observable<CtrTaskModel[]> {
        let url_ = this.baseUrl + "/api/MaintenanceTask/GetTasksByMaintenance?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksByMaintenance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksByMaintenance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrTaskModel[]>;
        }));
    }

    protected processGetTasksByMaintenance(response: HttpResponseBase): Observable<CtrTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrTaskModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteTask(id?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/MaintenanceTask/DeleteTask?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: MaintenanceTaskModel): Observable<MaintenanceTaskModel> {
        let url_ = this.baseUrl + "/api/MaintenanceTask/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceTaskModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<MaintenanceTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copy(id?: string | undefined, newName?: string | null | undefined): Observable<MaintenanceTaskModel> {
        let url_ = this.baseUrl + "/api/MaintenanceTask/Copy?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newName !== undefined && newName !== null)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceTaskModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<MaintenanceTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/MaintenanceTask/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INotificationService {
    getActiveConnectionsSignalR(): Observable<SignalRConnectionDetails>;
    /**
     * Get Notification
     * @param id (optional) 
     */
    getSubscription(id?: string | undefined): Observable<NotificationSubscriptionModel>;
    /**
     * Get Notification by Supplier
     * @param maxItems (optional) 
     */
    getUnread(maxItems?: number | undefined): Observable<NotificationModel[]>;
    getByType(type?: NotificationType | undefined): Observable<NotificationModel[]>;
    markAsDismissed(id?: string | undefined): Observable<string>;
    markAllAsDismissed(): Observable<string>;
    /**
     * Get Notification by Supplier
     */
    getAllSubscriptions(): Observable<NotificationSubscriptionModel[]>;
    /**
     * Get Notification by Supplier
     * @param id (optional) 
     */
    getSubscriptionsByEntityId(id?: string | undefined): Observable<NotificationSubscriptionModel[]>;
    postNotification(model: NotificationModel, eventGroup?: EventGroup | null | undefined): Observable<string>;
    deleteNotification(id?: string | undefined): Observable<boolean>;
    /**
     * Add or update Notification
     */
    postSubscription(model: NotificationSubscriptionModel): Observable<NotificationSubscriptionModel>;
    sendNotifications(): Observable<string>;
    deleteSubscription(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationService implements INotificationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getActiveConnectionsSignalR(): Observable<SignalRConnectionDetails> {
        let url_ = this.baseUrl + "/api/Notification/GetActiveConnectionsSignalR";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveConnectionsSignalR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveConnectionsSignalR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SignalRConnectionDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SignalRConnectionDetails>;
        }));
    }

    protected processGetActiveConnectionsSignalR(response: HttpResponseBase): Observable<SignalRConnectionDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignalRConnectionDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Notification
     * @param id (optional) 
     */
    getSubscription(id?: string | undefined): Observable<NotificationSubscriptionModel> {
        let url_ = this.baseUrl + "/api/Notification/GetSubscription?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationSubscriptionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationSubscriptionModel>;
        }));
    }

    protected processGetSubscription(response: HttpResponseBase): Observable<NotificationSubscriptionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSubscriptionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Notification by Supplier
     * @param maxItems (optional) 
     */
    getUnread(maxItems?: number | undefined): Observable<NotificationModel[]> {
        let url_ = this.baseUrl + "/api/Notification/GetUnread?";
        if (maxItems === null)
            throw new globalThis.Error("The parameter 'maxItems' cannot be null.");
        else if (maxItems !== undefined)
            url_ += "maxItems=" + encodeURIComponent("" + maxItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationModel[]>;
        }));
    }

    protected processGetUnread(response: HttpResponseBase): Observable<NotificationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByType(type?: NotificationType | undefined): Observable<NotificationModel[]> {
        let url_ = this.baseUrl + "/api/Notification/GetByType?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationModel[]>;
        }));
    }

    protected processGetByType(response: HttpResponseBase): Observable<NotificationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markAsDismissed(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Notification/MarkAsDismissed?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsDismissed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsDismissed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMarkAsDismissed(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markAllAsDismissed(): Observable<string> {
        let url_ = this.baseUrl + "/api/Notification/MarkAllAsDismissed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllAsDismissed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllAsDismissed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMarkAllAsDismissed(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Notification by Supplier
     */
    getAllSubscriptions(): Observable<NotificationSubscriptionModel[]> {
        let url_ = this.baseUrl + "/api/Notification/GetAllSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationSubscriptionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationSubscriptionModel[]>;
        }));
    }

    protected processGetAllSubscriptions(response: HttpResponseBase): Observable<NotificationSubscriptionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationSubscriptionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Notification by Supplier
     * @param id (optional) 
     */
    getSubscriptionsByEntityId(id?: string | undefined): Observable<NotificationSubscriptionModel[]> {
        let url_ = this.baseUrl + "/api/Notification/GetSubscriptionsByEntityId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionsByEntityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionsByEntityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationSubscriptionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationSubscriptionModel[]>;
        }));
    }

    protected processGetSubscriptionsByEntityId(response: HttpResponseBase): Observable<NotificationSubscriptionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationSubscriptionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postNotification(model: NotificationModel, eventGroup?: EventGroup | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Notification/PostNotification?";
        if (eventGroup !== undefined && eventGroup !== null)
            url_ += "eventGroup=" + encodeURIComponent("" + eventGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPostNotification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteNotification(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Notification/DeleteNotification?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Notification
     */
    postSubscription(model: NotificationSubscriptionModel): Observable<NotificationSubscriptionModel> {
        let url_ = this.baseUrl + "/api/Notification/PostSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationSubscriptionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationSubscriptionModel>;
        }));
    }

    protected processPostSubscription(response: HttpResponseBase): Observable<NotificationSubscriptionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSubscriptionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendNotifications(): Observable<string> {
        let url_ = this.baseUrl + "/api/Notification/SendNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendNotifications(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSubscription(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Notification/DeleteSubscription?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteSubscription(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOrderService {
    searchOrders(searchText?: string | null | undefined): Observable<OrderModel[]>;
    /**
     * Get Order
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<OrderModel>;
    /**
     * Get all orders for User
     * @param type (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param orderStatus (optional) 
     */
    getByType(type?: OrderType | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, orderStatus?: OrderStatus | null | undefined): Observable<OrderModel[]>;
    /**
     * Get all orders for User
     */
    getAll(): Observable<OrderModel[]>;
    /**
     * Get all orders
     */
    getAllPaged(query: PagedQuery): Observable<PagedResultOfOrderModel>;
    /**
     * Get all orders with specified status
     * @param status (optional) 
     * @param type (optional) 
     */
    getByStatus(status?: OrderStatus | undefined, type?: OrderType | undefined): Observable<OrderModel[]>;
    /**
     * Get all orders for User
     * @param id (optional) 
     */
    getBySupplier(id?: string | undefined): Observable<OrderModel[]>;
    /**
     * Get all orders for User
     * @param id (optional) 
     * @param orderStatus (optional) 
     */
    getByCustomer(id?: string | undefined, orderStatus?: OrderStatus | null | undefined): Observable<OrderModel[]>;
    /**
     * Get all orders for User
     * @param id (optional) 
     * @param orderStatus (optional) 
     */
    getByCustomerGroup(id?: string | undefined, orderStatus?: OrderStatus | null | undefined): Observable<OrderModel[]>;
    /**
     * Send order
     * @param id (optional) 
     */
    sendOrder(id?: string | undefined): Observable<OrderModel>;
    /**
     * Send order
     * @param id (optional) 
     */
    readyForDelivery(id?: string | undefined): Observable<OrderModel>;
    /**
     * Remove empty lines in order
     * @param id (optional) 
     */
    removeEmptyLines(id?: string | undefined): Observable<OrderModel>;
    splitPurchaseCosts(orderId?: string | undefined, splitMethod?: number | undefined): Observable<string>;
    bookCostPrice(orderId?: string | undefined): Observable<string>;
    /**
     * Add or update Order
     */
    post(model: OrderModel): Observable<OrderModel>;
    createCreditNote(id?: string | undefined): Observable<OrderModel>;
    /**
     * Copy Order
     * @param id (optional) 
     * @param status (optional) 
     * @param newName (optional) 
     * @return Copy of order
     */
    copyOrder(id?: string | undefined, status?: OrderStatus | undefined, newName?: string | null | undefined): Observable<OrderModel>;
    /**
     * Add or update Order
     */
    editDeliveryDate(model: OrderModel): Observable<OrderModel>;
    delete(id?: string | undefined): Observable<string>;
    checkAll(): Observable<string>;
    fillPurchaseOrderLotNumbers(id?: string | undefined): Observable<string>;
    createMissingProducts(id?: string | undefined): Observable<string>;
    getPdf(id?: string | undefined): Observable<FileResponse>;
    getPalletLabels(model: LabelInfoModel[]): Observable<FileResponse>;
    getProductLabels(model: LabelInfoModel[]): Observable<FileResponse>;
    getCaseLabels(model: LabelInfoModel[]): Observable<FileResponse>;
    getPalletLabel(type?: string | null | undefined, id?: string | undefined, language?: string | null | undefined, date?: Date | null | undefined, productionDate?: Date | null | undefined, labelId?: string | null | undefined, batch?: string | null | undefined, lines?: string | null | undefined): Observable<string>;
    getOrderAndProductionDocument(id?: string | undefined, lines?: string | null | undefined, type?: string | null | undefined, configId?: string | null | undefined, documentType?: OrderStatus | undefined): Observable<FileResponse>;
    getOrderDocument(id?: string | undefined, lines?: string | null | undefined, type?: string | null | undefined, configId?: string | null | undefined, documentType?: OrderStatus | undefined): Observable<FileResponse>;
    bulkOrderDocuments(ids: string[], type?: string | null | undefined, configId?: string | null | undefined, documentType?: OrderStatus | undefined): Observable<FileResponse>;
    getOrderNotificationSettings(orderType?: OrderType | undefined): Observable<PropertyGroupDataModel[]>;
    sendNotification(model: SendNotificationModel): Observable<string>;
    createShipmentLabel(orderId?: string | undefined): Observable<FileResponse>;
    /**
     * Export All Suppliers
     */
    export(query: PagedQuery): Observable<string>;
    /**
     * Get all production orders for User
     */
    createPurchaseOrders(model: CreatePurchaseOrdersModel): Observable<OrderModel[]>;
    /**
     * Get all production orders for User
     */
    createPurchaseOrdersFromForecast(model: CreatePurchaseOrdersFromForecastModel): Observable<OrderModel[]>;
    createProductionOrders(id?: string | undefined): Observable<string>;
    convertToInvoice(id?: string | undefined): Observable<string>;
    bulkCreateInvoice(model: BulkInvoiceModel): Observable<string>;
    bulkConfirmOrders(model: BulkInvoiceModel): Observable<string>;
    bulkGetFinishedForOrders(model: BulkInvoiceModel): Observable<StockItemModel[]>;
    bulkCreateProductionOrders(model: BulkInvoiceModel): Observable<string>;
    bulkDeliverOrders(model: BulkInvoiceModel): Observable<string>;
    bulkInvoicedOrders(model: BulkInvoiceModel): Observable<string>;
    bulkReceiveOrders(model: BulkInvoiceModel): Observable<string>;
    bulkReadyToDeliverOrders(model: BulkInvoiceModel): Observable<string>;
    bulkChangeCarrier(model: BulkInvoiceModel): Observable<string>;
    bulkBookTransport(model: BulkInvoiceModel): Observable<string>;
    bookTransport(orderId?: string | undefined): Observable<string>;
    bulkPrintPickingLists(model: BulkInvoiceModel): Observable<FileResponse>;
    bulkPrintDeliveryNotes(model: BulkInvoiceModel): Observable<FileResponse>;
    bulkSendDeliveryNotes(model: BulkSendNotificationModel): Observable<string>;
    bulkChangeResponsibleUser(model: BulkInvoiceModel): Observable<string>;
    bulkResetSalesPrices(model: BulkInvoiceModel): Observable<string>;
    bulkCheckFinance(model: BulkInvoiceModel): Observable<string>;
    checkOrder(id?: string | undefined): Observable<string>;
    convertQuoteToOrder(orderId?: string | undefined): Observable<string>;
    generateDeliveryPlan(model: BulkInvoiceModel): Observable<DirectionsResult>;
    getPlaceIdFromAddress(address: AddressModel): Observable<string>;
    getSalesMatrix(startDate?: Date | undefined, endDate?: Date | undefined, productGroupId?: string | undefined, includeBaskets?: boolean | null | undefined): Observable<SalesMatrixModel>;
    updateAllOrderSummaries(): Observable<string>;
    updateProductionForecast(forecastId?: string | undefined, startDate?: Date | undefined, endDate?: Date | undefined, daysPerPeriod?: number | undefined, includeCurrentStock?: boolean | undefined): Observable<number>;
    getRawMaterialForecast(productionForecastId?: string | undefined, productGroupId?: string | undefined, supplierId?: string | undefined, startDate?: Date | undefined, endDate?: Date | undefined, daysPerItem?: number | undefined): Observable<PurchaseForecastItem[]>;
}

@Injectable({
    providedIn: 'root'
})
export class OrderService implements IOrderService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    searchOrders(searchText?: string | null | undefined): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/SearchOrders?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel[]>;
        }));
    }

    protected processSearchOrders(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Order
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders for User
     * @param type (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param orderStatus (optional) 
     */
    getByType(type?: OrderType | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, orderStatus?: OrderStatus | null | undefined): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetByType?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (orderStatus !== undefined && orderStatus !== null)
            url_ += "orderStatus=" + encodeURIComponent("" + orderStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel[]>;
        }));
    }

    protected processGetByType(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders for User
     */
    getAll(): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders
     */
    getAllPaged(query: PagedQuery): Observable<PagedResultOfOrderModel> {
        let url_ = this.baseUrl + "/api/Order/GetAllPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfOrderModel>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<PagedResultOfOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders with specified status
     * @param status (optional) 
     * @param type (optional) 
     */
    getByStatus(status?: OrderStatus | undefined, type?: OrderType | undefined): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetByStatus?";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel[]>;
        }));
    }

    protected processGetByStatus(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders for User
     * @param id (optional) 
     */
    getBySupplier(id?: string | undefined): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetBySupplier?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBySupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel[]>;
        }));
    }

    protected processGetBySupplier(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders for User
     * @param id (optional) 
     * @param orderStatus (optional) 
     */
    getByCustomer(id?: string | undefined, orderStatus?: OrderStatus | null | undefined): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetByCustomer?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (orderStatus !== undefined && orderStatus !== null)
            url_ += "orderStatus=" + encodeURIComponent("" + orderStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel[]>;
        }));
    }

    protected processGetByCustomer(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders for User
     * @param id (optional) 
     * @param orderStatus (optional) 
     */
    getByCustomerGroup(id?: string | undefined, orderStatus?: OrderStatus | null | undefined): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetByCustomerGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (orderStatus !== undefined && orderStatus !== null)
            url_ += "orderStatus=" + encodeURIComponent("" + orderStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCustomerGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCustomerGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel[]>;
        }));
    }

    protected processGetByCustomerGroup(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send order
     * @param id (optional) 
     */
    sendOrder(id?: string | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/SendOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processSendOrder(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send order
     * @param id (optional) 
     */
    readyForDelivery(id?: string | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/ReadyForDelivery?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadyForDelivery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadyForDelivery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processReadyForDelivery(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove empty lines in order
     * @param id (optional) 
     */
    removeEmptyLines(id?: string | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/RemoveEmptyLines?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveEmptyLines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveEmptyLines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processRemoveEmptyLines(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    splitPurchaseCosts(orderId?: string | undefined, splitMethod?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/SplitPurchaseCosts?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (splitMethod === null)
            throw new globalThis.Error("The parameter 'splitMethod' cannot be null.");
        else if (splitMethod !== undefined)
            url_ += "splitMethod=" + encodeURIComponent("" + splitMethod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSplitPurchaseCosts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSplitPurchaseCosts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSplitPurchaseCosts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bookCostPrice(orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BookCostPrice?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookCostPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookCostPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBookCostPrice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Order
     */
    post(model: OrderModel): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCreditNote(id?: string | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/CreateCreditNote?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCreditNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCreditNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processCreateCreditNote(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Copy Order
     * @param id (optional) 
     * @param status (optional) 
     * @param newName (optional) 
     * @return Copy of order
     */
    copyOrder(id?: string | undefined, status?: OrderStatus | undefined, newName?: string | null | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/CopyOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (newName !== undefined && newName !== null)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processCopyOrder(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Order
     */
    editDeliveryDate(model: OrderModel): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/EditDeliveryDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditDeliveryDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditDeliveryDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processEditDeliveryDate(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkAll(): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/CheckAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckAll(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fillPurchaseOrderLotNumbers(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/FillPurchaseOrderLotNumbers?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFillPurchaseOrderLotNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFillPurchaseOrderLotNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFillPurchaseOrderLotNumbers(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createMissingProducts(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/CreateMissingProducts?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMissingProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMissingProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateMissingProducts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPdf(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Order/GetPdf?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPalletLabels(model: LabelInfoModel[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Order/GetPalletLabels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPalletLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPalletLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPalletLabels(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProductLabels(model: LabelInfoModel[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Order/GetProductLabels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetProductLabels(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCaseLabels(model: LabelInfoModel[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Order/GetCaseLabels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCaseLabels(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPalletLabel(type?: string | null | undefined, id?: string | undefined, language?: string | null | undefined, date?: Date | null | undefined, productionDate?: Date | null | undefined, labelId?: string | null | undefined, batch?: string | null | undefined, lines?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/GetPalletLabel?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (productionDate !== undefined && productionDate !== null)
            url_ += "productionDate=" + encodeURIComponent(productionDate ? "" + productionDate.toISOString() : "") + "&";
        if (labelId !== undefined && labelId !== null)
            url_ += "labelId=" + encodeURIComponent("" + labelId) + "&";
        if (batch !== undefined && batch !== null)
            url_ += "batch=" + encodeURIComponent("" + batch) + "&";
        if (lines !== undefined && lines !== null)
            url_ += "lines=" + encodeURIComponent("" + lines) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPalletLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPalletLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPalletLabel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrderAndProductionDocument(id?: string | undefined, lines?: string | null | undefined, type?: string | null | undefined, configId?: string | null | undefined, documentType?: OrderStatus | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Order/GetOrderAndProductionDocument?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (lines !== undefined && lines !== null)
            url_ += "lines=" + encodeURIComponent("" + lines) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (configId !== undefined && configId !== null)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (documentType === null)
            throw new globalThis.Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderAndProductionDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderAndProductionDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetOrderAndProductionDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrderDocument(id?: string | undefined, lines?: string | null | undefined, type?: string | null | undefined, configId?: string | null | undefined, documentType?: OrderStatus | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Order/GetOrderDocument?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (lines !== undefined && lines !== null)
            url_ += "lines=" + encodeURIComponent("" + lines) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (configId !== undefined && configId !== null)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (documentType === null)
            throw new globalThis.Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetOrderDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkOrderDocuments(ids: string[], type?: string | null | undefined, configId?: string | null | undefined, documentType?: OrderStatus | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Order/BulkOrderDocuments?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (configId !== undefined && configId !== null)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (documentType === null)
            throw new globalThis.Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkOrderDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkOrderDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBulkOrderDocuments(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrderNotificationSettings(orderType?: OrderType | undefined): Observable<PropertyGroupDataModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetOrderNotificationSettings?";
        if (orderType === null)
            throw new globalThis.Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "orderType=" + encodeURIComponent("" + orderType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyGroupDataModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyGroupDataModel[]>;
        }));
    }

    protected processGetOrderNotificationSettings(response: HttpResponseBase): Observable<PropertyGroupDataModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyGroupDataModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendNotification(model: SendNotificationModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/SendNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendNotification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createShipmentLabel(orderId?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Order/CreateShipmentLabel?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShipmentLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShipmentLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreateShipmentLabel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export All Suppliers
     */
    export(query: PagedQuery): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     */
    createPurchaseOrders(model: CreatePurchaseOrdersModel): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/CreatePurchaseOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePurchaseOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePurchaseOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel[]>;
        }));
    }

    protected processCreatePurchaseOrders(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     */
    createPurchaseOrdersFromForecast(model: CreatePurchaseOrdersFromForecastModel): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/CreatePurchaseOrdersFromForecast";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePurchaseOrdersFromForecast(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePurchaseOrdersFromForecast(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel[]>;
        }));
    }

    protected processCreatePurchaseOrdersFromForecast(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createProductionOrders(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/CreateProductionOrders?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductionOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductionOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateProductionOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    convertToInvoice(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/ConvertToInvoice?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertToInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertToInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processConvertToInvoice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkCreateInvoice(model: BulkInvoiceModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkCreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkCreateInvoice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkConfirmOrders(model: BulkInvoiceModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkConfirmOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkConfirmOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkConfirmOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkConfirmOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkGetFinishedForOrders(model: BulkInvoiceModel): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/Order/BulkGetFinishedForOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkGetFinishedForOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkGetFinishedForOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processBulkGetFinishedForOrders(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkCreateProductionOrders(model: BulkInvoiceModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkCreateProductionOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkCreateProductionOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkCreateProductionOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkCreateProductionOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkDeliverOrders(model: BulkInvoiceModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkDeliverOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkDeliverOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkDeliverOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkDeliverOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkInvoicedOrders(model: BulkInvoiceModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkInvoicedOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkInvoicedOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkInvoicedOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkInvoicedOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkReceiveOrders(model: BulkInvoiceModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkReceiveOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkReceiveOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkReceiveOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkReceiveOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkReadyToDeliverOrders(model: BulkInvoiceModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkReadyToDeliverOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkReadyToDeliverOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkReadyToDeliverOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkReadyToDeliverOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkChangeCarrier(model: BulkInvoiceModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkChangeCarrier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeCarrier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeCarrier(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkBookTransport(model: BulkInvoiceModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkBookTransport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkBookTransport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkBookTransport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkBookTransport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bookTransport(orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BookTransport?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookTransport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookTransport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBookTransport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkPrintPickingLists(model: BulkInvoiceModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Order/BulkPrintPickingLists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkPrintPickingLists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkPrintPickingLists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBulkPrintPickingLists(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkPrintDeliveryNotes(model: BulkInvoiceModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Order/BulkPrintDeliveryNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkPrintDeliveryNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkPrintDeliveryNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBulkPrintDeliveryNotes(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkSendDeliveryNotes(model: BulkSendNotificationModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkSendDeliveryNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkSendDeliveryNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkSendDeliveryNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkSendDeliveryNotes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkChangeResponsibleUser(model: BulkInvoiceModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkChangeResponsibleUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeResponsibleUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeResponsibleUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeResponsibleUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkResetSalesPrices(model: BulkInvoiceModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkResetSalesPrices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkResetSalesPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkResetSalesPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkResetSalesPrices(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkCheckFinance(model: BulkInvoiceModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/BulkCheckFinance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkCheckFinance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkCheckFinance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkCheckFinance(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkOrder(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/CheckOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    convertQuoteToOrder(orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/ConvertQuoteToOrder?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertQuoteToOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertQuoteToOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processConvertQuoteToOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateDeliveryPlan(model: BulkInvoiceModel): Observable<DirectionsResult> {
        let url_ = this.baseUrl + "/api/Order/GenerateDeliveryPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateDeliveryPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateDeliveryPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DirectionsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DirectionsResult>;
        }));
    }

    protected processGenerateDeliveryPlan(response: HttpResponseBase): Observable<DirectionsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DirectionsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPlaceIdFromAddress(address: AddressModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/GetPlaceIdFromAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(address);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlaceIdFromAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlaceIdFromAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPlaceIdFromAddress(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSalesMatrix(startDate?: Date | undefined, endDate?: Date | undefined, productGroupId?: string | undefined, includeBaskets?: boolean | null | undefined): Observable<SalesMatrixModel> {
        let url_ = this.baseUrl + "/api/Order/GetSalesMatrix?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (productGroupId === null)
            throw new globalThis.Error("The parameter 'productGroupId' cannot be null.");
        else if (productGroupId !== undefined)
            url_ += "productGroupId=" + encodeURIComponent("" + productGroupId) + "&";
        if (includeBaskets !== undefined && includeBaskets !== null)
            url_ += "includeBaskets=" + encodeURIComponent("" + includeBaskets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesMatrix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesMatrix(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesMatrixModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesMatrixModel>;
        }));
    }

    protected processGetSalesMatrix(response: HttpResponseBase): Observable<SalesMatrixModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesMatrixModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAllOrderSummaries(): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/UpdateAllOrderSummaries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllOrderSummaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllOrderSummaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateAllOrderSummaries(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProductionForecast(forecastId?: string | undefined, startDate?: Date | undefined, endDate?: Date | undefined, daysPerPeriod?: number | undefined, includeCurrentStock?: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Order/UpdateProductionForecast?";
        if (forecastId === null)
            throw new globalThis.Error("The parameter 'forecastId' cannot be null.");
        else if (forecastId !== undefined)
            url_ += "forecastId=" + encodeURIComponent("" + forecastId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (daysPerPeriod === null)
            throw new globalThis.Error("The parameter 'daysPerPeriod' cannot be null.");
        else if (daysPerPeriod !== undefined)
            url_ += "daysPerPeriod=" + encodeURIComponent("" + daysPerPeriod) + "&";
        if (includeCurrentStock === null)
            throw new globalThis.Error("The parameter 'includeCurrentStock' cannot be null.");
        else if (includeCurrentStock !== undefined)
            url_ += "includeCurrentStock=" + encodeURIComponent("" + includeCurrentStock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductionForecast(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductionForecast(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateProductionForecast(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRawMaterialForecast(productionForecastId?: string | undefined, productGroupId?: string | undefined, supplierId?: string | undefined, startDate?: Date | undefined, endDate?: Date | undefined, daysPerItem?: number | undefined): Observable<PurchaseForecastItem[]> {
        let url_ = this.baseUrl + "/api/Order/GetRawMaterialForecast?";
        if (productionForecastId === null)
            throw new globalThis.Error("The parameter 'productionForecastId' cannot be null.");
        else if (productionForecastId !== undefined)
            url_ += "productionForecastId=" + encodeURIComponent("" + productionForecastId) + "&";
        if (productGroupId === null)
            throw new globalThis.Error("The parameter 'productGroupId' cannot be null.");
        else if (productGroupId !== undefined)
            url_ += "productGroupId=" + encodeURIComponent("" + productGroupId) + "&";
        if (supplierId === null)
            throw new globalThis.Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (daysPerItem === null)
            throw new globalThis.Error("The parameter 'daysPerItem' cannot be null.");
        else if (daysPerItem !== undefined)
            url_ += "daysPerItem=" + encodeURIComponent("" + daysPerItem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRawMaterialForecast(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRawMaterialForecast(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseForecastItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseForecastItem[]>;
        }));
    }

    protected processGetRawMaterialForecast(response: HttpResponseBase): Observable<PurchaseForecastItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PurchaseForecastItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOrderlineService {
    /**
     * Get Orderline
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<OrderlineModel>;
    /**
     * Get Orderline by Order
     * @param orderId (optional) 
     */
    getByOrder(orderId?: string | undefined): Observable<OrderlineModel[]>;
    /**
     * Get all Products
     */
    getAllPaged(query: PagedQuery): Observable<PagedResultOfOrderlineModel>;
    /**
     * Get Orderline by Order
     * @param status (optional) 
     * @param type (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param cumulative (optional) 
     */
    getByStatus(status?: OrderlineStatus | undefined, type?: OrderType | undefined, startTime?: Date | null | undefined, endTime?: Date | null | undefined, cumulative?: boolean | undefined): Observable<OrderlineModel[]>;
    /**
     * Add or update Orderline
     */
    post(model: OrderlineModel): Observable<OrderlineModel>;
    delete(id?: string | undefined): Observable<string>;
    fixMissingStockLocation(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class OrderlineService implements IOrderlineService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Orderline
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<OrderlineModel> {
        let url_ = this.baseUrl + "/api/Orderline/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderlineModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderlineModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderlineModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderlineModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Orderline by Order
     * @param orderId (optional) 
     */
    getByOrder(orderId?: string | undefined): Observable<OrderlineModel[]> {
        let url_ = this.baseUrl + "/api/Orderline/GetByOrder?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderlineModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderlineModel[]>;
        }));
    }

    protected processGetByOrder(response: HttpResponseBase): Observable<OrderlineModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderlineModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Products
     */
    getAllPaged(query: PagedQuery): Observable<PagedResultOfOrderlineModel> {
        let url_ = this.baseUrl + "/api/Orderline/GetAllPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfOrderlineModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfOrderlineModel>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<PagedResultOfOrderlineModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfOrderlineModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Orderline by Order
     * @param status (optional) 
     * @param type (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param cumulative (optional) 
     */
    getByStatus(status?: OrderlineStatus | undefined, type?: OrderType | undefined, startTime?: Date | null | undefined, endTime?: Date | null | undefined, cumulative?: boolean | undefined): Observable<OrderlineModel[]> {
        let url_ = this.baseUrl + "/api/Orderline/GetByStatus?";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (cumulative === null)
            throw new globalThis.Error("The parameter 'cumulative' cannot be null.");
        else if (cumulative !== undefined)
            url_ += "cumulative=" + encodeURIComponent("" + cumulative) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderlineModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderlineModel[]>;
        }));
    }

    protected processGetByStatus(response: HttpResponseBase): Observable<OrderlineModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderlineModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Orderline
     */
    post(model: OrderlineModel): Observable<OrderlineModel> {
        let url_ = this.baseUrl + "/api/Orderline/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderlineModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderlineModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<OrderlineModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderlineModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Orderline/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fixMissingStockLocation(): Observable<string> {
        let url_ = this.baseUrl + "/api/Orderline/FixMissingStockLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixMissingStockLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixMissingStockLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFixMissingStockLocation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOrganizationService {
    /**
     * Get Organization
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<OrganizationModel>;
    /**
     * Get all Organizations
     */
    getAll(): Observable<OrganizationModel[]>;
    /**
     * Get all Products
     */
    getAllPaged(query: PagedQuery): Observable<PagedResultOfOrganizationModel>;
    getByTimeRegId(timeRegId?: string | undefined): Observable<OrganizationModel[]>;
    /**
     * Add or update Organization
     */
    createDemoOrganization(model: OrganizationModel): Observable<OrganizationModel>;
    /**
     * Add or update Organization
     */
    createDemoData(model: OrganizationModel): Observable<OrganizationModel>;
    /**
     * Add or update Organization
     */
    post(model: OrganizationModel): Observable<OrganizationModel>;
    /**
     * Add or update Organization
     */
    createPropertyValues(model: OrganizationModel): Observable<OrganizationModel>;
    delete(id?: string | undefined): Observable<string>;
    exportOrganizationAsXml(id?: string | undefined): Observable<string>;
    getAnticimexUsers(): Observable<string>;
    updateDriving(): Observable<string>;
    updateDistance(organizationId?: string | undefined): Observable<string>;
    getPlaceIdFromAddress(address: QsAddress): Observable<string>;
    getPrice(organizationId?: string | undefined): Observable<OrganizationPriceModel[]>;
    createEconomicCustomer(organizationId?: string | undefined): Observable<string>;
    mapFsOrganizations(): Observable<string>;
    updateDocuments(organization: QsOrganization): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationService implements IOrganizationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Organization
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<OrganizationModel> {
        let url_ = this.baseUrl + "/api/Organization/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrganizationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Organizations
     */
    getAll(): Observable<OrganizationModel[]> {
        let url_ = this.baseUrl + "/api/Organization/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrganizationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Products
     */
    getAllPaged(query: PagedQuery): Observable<PagedResultOfOrganizationModel> {
        let url_ = this.baseUrl + "/api/Organization/GetAllPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfOrganizationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfOrganizationModel>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<PagedResultOfOrganizationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfOrganizationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByTimeRegId(timeRegId?: string | undefined): Observable<OrganizationModel[]> {
        let url_ = this.baseUrl + "/api/Organization/GetByTimeRegId?";
        if (timeRegId === null)
            throw new globalThis.Error("The parameter 'timeRegId' cannot be null.");
        else if (timeRegId !== undefined)
            url_ += "timeRegId=" + encodeURIComponent("" + timeRegId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByTimeRegId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByTimeRegId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationModel[]>;
        }));
    }

    protected processGetByTimeRegId(response: HttpResponseBase): Observable<OrganizationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Organization
     */
    createDemoOrganization(model: OrganizationModel): Observable<OrganizationModel> {
        let url_ = this.baseUrl + "/api/Organization/CreateDemoOrganization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDemoOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDemoOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationModel>;
        }));
    }

    protected processCreateDemoOrganization(response: HttpResponseBase): Observable<OrganizationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Organization
     */
    createDemoData(model: OrganizationModel): Observable<OrganizationModel> {
        let url_ = this.baseUrl + "/api/Organization/CreateDemoData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDemoData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDemoData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationModel>;
        }));
    }

    protected processCreateDemoData(response: HttpResponseBase): Observable<OrganizationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Organization
     */
    post(model: OrganizationModel): Observable<OrganizationModel> {
        let url_ = this.baseUrl + "/api/Organization/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<OrganizationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Organization
     */
    createPropertyValues(model: OrganizationModel): Observable<OrganizationModel> {
        let url_ = this.baseUrl + "/api/Organization/CreatePropertyValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePropertyValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePropertyValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationModel>;
        }));
    }

    protected processCreatePropertyValues(response: HttpResponseBase): Observable<OrganizationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Organization/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportOrganizationAsXml(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Organization/ExportOrganizationAsXml?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportOrganizationAsXml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportOrganizationAsXml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportOrganizationAsXml(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAnticimexUsers(): Observable<string> {
        let url_ = this.baseUrl + "/api/Organization/GetAnticimexUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnticimexUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnticimexUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAnticimexUsers(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDriving(): Observable<string> {
        let url_ = this.baseUrl + "/api/Organization/UpdateDriving";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDriving(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDriving(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateDriving(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDistance(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Organization/UpdateDistance?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDistance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateDistance(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPlaceIdFromAddress(address: QsAddress): Observable<string> {
        let url_ = this.baseUrl + "/api/Organization/GetPlaceIdFromAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(address);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlaceIdFromAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlaceIdFromAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPlaceIdFromAddress(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPrice(organizationId?: string | undefined): Observable<OrganizationPriceModel[]> {
        let url_ = this.baseUrl + "/api/Organization/GetPrice?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationPriceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationPriceModel[]>;
        }));
    }

    protected processGetPrice(response: HttpResponseBase): Observable<OrganizationPriceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationPriceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEconomicCustomer(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Organization/CreateEconomicCustomer?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEconomicCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEconomicCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateEconomicCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mapFsOrganizations(): Observable<string> {
        let url_ = this.baseUrl + "/api/Organization/MapFsOrganizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMapFsOrganizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMapFsOrganizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMapFsOrganizations(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDocuments(organization: QsOrganization): Observable<string> {
        let url_ = this.baseUrl + "/api/Organization/UpdateDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organization);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateDocuments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOverviewService {
    /**
     * Get Overview
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<OverviewModel>;
    /**
     * Get all Overviews
     * @param includeCollection (optional) 
     */
    getAll(includeCollection?: boolean | undefined): Observable<OverviewModel[]>;
    getCollectionWithRevisionInfo(collectionId?: string | undefined): Observable<CollectionModel>;
    downloadAll(): Observable<FileResponse>;
    getByOrganization(organiztionId?: string | undefined): Observable<OverviewModel[]>;
    /**
     * Add or update Overview
     */
    post(model: OverviewModel): Observable<OverviewModel>;
    getReport(type?: string | null | undefined, id?: string | undefined): Observable<string>;
    copy(id?: string | undefined): Observable<OverviewModel>;
    /**
     * Delete Overview
     * @param id (optional) 
     */
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class OverviewService implements IOverviewService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Overview
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<OverviewModel> {
        let url_ = this.baseUrl + "/api/Overview/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OverviewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OverviewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OverviewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OverviewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Overviews
     * @param includeCollection (optional) 
     */
    getAll(includeCollection?: boolean | undefined): Observable<OverviewModel[]> {
        let url_ = this.baseUrl + "/api/Overview/GetAll?";
        if (includeCollection === null)
            throw new globalThis.Error("The parameter 'includeCollection' cannot be null.");
        else if (includeCollection !== undefined)
            url_ += "includeCollection=" + encodeURIComponent("" + includeCollection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OverviewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OverviewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OverviewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OverviewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCollectionWithRevisionInfo(collectionId?: string | undefined): Observable<CollectionModel> {
        let url_ = this.baseUrl + "/api/Overview/GetCollectionWithRevisionInfo?";
        if (collectionId === null)
            throw new globalThis.Error("The parameter 'collectionId' cannot be null.");
        else if (collectionId !== undefined)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollectionWithRevisionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollectionWithRevisionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel>;
        }));
    }

    protected processGetCollectionWithRevisionInfo(response: HttpResponseBase): Observable<CollectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAll(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Overview/DownloadAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAll(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByOrganization(organiztionId?: string | undefined): Observable<OverviewModel[]> {
        let url_ = this.baseUrl + "/api/Overview/GetByOrganization?";
        if (organiztionId === null)
            throw new globalThis.Error("The parameter 'organiztionId' cannot be null.");
        else if (organiztionId !== undefined)
            url_ += "organiztionId=" + encodeURIComponent("" + organiztionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OverviewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OverviewModel[]>;
        }));
    }

    protected processGetByOrganization(response: HttpResponseBase): Observable<OverviewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OverviewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Overview
     */
    post(model: OverviewModel): Observable<OverviewModel> {
        let url_ = this.baseUrl + "/api/Overview/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OverviewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OverviewModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<OverviewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OverviewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(type?: string | null | undefined, id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Overview/GetReport?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copy(id?: string | undefined): Observable<OverviewModel> {
        let url_ = this.baseUrl + "/api/Overview/Copy?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OverviewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OverviewModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<OverviewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OverviewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Overview
     * @param id (optional) 
     */
    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Overview/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPermissionService {
    /**
     * Get User
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<PermissionModel>;
    /**
     * Get all Users
     */
    getAll(): Observable<PermissionModel[]>;
    /**
     * Add or update User
     */
    post(model: PermissionModel): Observable<PermissionModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class PermissionService implements IPermissionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get User
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<PermissionModel> {
        let url_ = this.baseUrl + "/api/Permission/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PermissionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Users
     */
    getAll(): Observable<PermissionModel[]> {
        let url_ = this.baseUrl + "/api/Permission/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PermissionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermissionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update User
     */
    post(model: PermissionModel): Observable<PermissionModel> {
        let url_ = this.baseUrl + "/api/Permission/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<PermissionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Permission/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPriceService {
    getPricesForVariant(productVariantId?: string | undefined): Observable<PriceModel[]>;
    getPricesForCustomer(productVariantId?: string | null | undefined, customerId?: string | undefined, onlyCustomerSpecific?: boolean | undefined): Observable<PriceModel[]>;
    getPrice(productVariantId?: string | undefined, customerId?: string | undefined, quantity?: number | undefined, currency?: string | null | undefined, date?: Date | null | undefined): Observable<PriceDiscountModel>;
    /**
     * Export All Products
     */
    export(): Observable<FileResponse>;
    /**
     * Add or update Capability
     */
    post(model: PriceModel): Observable<PriceModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class PriceService implements IPriceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPricesForVariant(productVariantId?: string | undefined): Observable<PriceModel[]> {
        let url_ = this.baseUrl + "/api/Price/GetPricesForVariant?";
        if (productVariantId === null)
            throw new globalThis.Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPricesForVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPricesForVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceModel[]>;
        }));
    }

    protected processGetPricesForVariant(response: HttpResponseBase): Observable<PriceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PriceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPricesForCustomer(productVariantId?: string | null | undefined, customerId?: string | undefined, onlyCustomerSpecific?: boolean | undefined): Observable<PriceModel[]> {
        let url_ = this.baseUrl + "/api/Price/GetPricesForCustomer?";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (onlyCustomerSpecific === null)
            throw new globalThis.Error("The parameter 'onlyCustomerSpecific' cannot be null.");
        else if (onlyCustomerSpecific !== undefined)
            url_ += "onlyCustomerSpecific=" + encodeURIComponent("" + onlyCustomerSpecific) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPricesForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPricesForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceModel[]>;
        }));
    }

    protected processGetPricesForCustomer(response: HttpResponseBase): Observable<PriceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PriceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPrice(productVariantId?: string | undefined, customerId?: string | undefined, quantity?: number | undefined, currency?: string | null | undefined, date?: Date | null | undefined): Observable<PriceDiscountModel> {
        let url_ = this.baseUrl + "/api/Price/GetPrice?";
        if (productVariantId === null)
            throw new globalThis.Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (quantity === null)
            throw new globalThis.Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceDiscountModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceDiscountModel>;
        }));
    }

    protected processGetPrice(response: HttpResponseBase): Observable<PriceDiscountModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriceDiscountModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export All Products
     */
    export(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Price/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Capability
     */
    post(model: PriceModel): Observable<PriceModel> {
        let url_ = this.baseUrl + "/api/Price/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<PriceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Price/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProcedureService {
    convertToV2(procedureId?: string | undefined): Observable<ProcedureModel>;
    addLanguage(procedureId?: string | undefined, language?: string | null | undefined, translate?: boolean | undefined): Observable<ProcedureModel>;
    updateProcedureLanguage(model: ProcedureLanguageModel): Observable<ProcedureModel>;
    updateStepLanguage(model: ProcedureStepLanguageModel): Observable<ProcedureModel>;
    updateStepMain(model: ProcedureStepModel): Observable<ProcedureModel>;
    addStep(model: ProcedureStepModel): Observable<ProcedureModel>;
    translateProcedureStep(model: ProcedureStepLanguageModel): Observable<ProcedureStepLanguageModel>;
    /**
     * Get RiskCategory
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ProcedureModel>;
    /**
     * Get RiskCategory by RiskAnalysis
     */
    getAll(): Observable<ProcedureModel[]>;
    /**
     * Get RiskCategory by RiskAnalysis
     * @param id (optional) 
     * @param includeObsolete (optional) 
     * @param includeDeleted (optional) 
     */
    getByDepartment(id?: string | undefined, includeObsolete?: boolean | undefined, includeDeleted?: boolean | undefined): Observable<ProcedureModel[]>;
    /**
     * Get RiskCategory by RiskAnalysis
     * @param id (optional) 
     */
    getByOrganization(id?: string | undefined): Observable<ProcedureModel[]>;
    /**
     * Add or update RiskAnalysis
     */
    post(model: ProcedureModel): Observable<ProcedureModel>;
    copy(id?: string | undefined, departmentId?: string | undefined): Observable<ProcedureModel>;
    /**
     * Add or update RiskAnalysis
     */
    createNewVersion(model: ProcedureModel): Observable<ProcedureModel>;
    upgradeProcedures(): Observable<void>;
    /**
     * Add or update RiskAnalysis
     */
    saveSort(model: ProcedureModel): Observable<ProcedureModel>;
    saveSortLegacy(model: ProcedureModel): Observable<ProcedureModel>;
    /**
     * Add or update RiskAnalysis
     * @param id (optional) 
     */
    newVersion(id?: string | undefined): Observable<ProcedureModel>;
    undelete(model: ProcedureModel): Observable<string>;
    delete(id?: string | undefined): Observable<string>;
    deleteProcedureStep(id?: string | undefined): Observable<string>;
    getReport(type?: string | null | undefined, id?: string | undefined, language?: string | null | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ProcedureService implements IProcedureService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    convertToV2(procedureId?: string | undefined): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/ConvertToV2?";
        if (procedureId === null)
            throw new globalThis.Error("The parameter 'procedureId' cannot be null.");
        else if (procedureId !== undefined)
            url_ += "procedureId=" + encodeURIComponent("" + procedureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertToV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertToV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processConvertToV2(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addLanguage(procedureId?: string | undefined, language?: string | null | undefined, translate?: boolean | undefined): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/AddLanguage?";
        if (procedureId === null)
            throw new globalThis.Error("The parameter 'procedureId' cannot be null.");
        else if (procedureId !== undefined)
            url_ += "procedureId=" + encodeURIComponent("" + procedureId) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (translate === null)
            throw new globalThis.Error("The parameter 'translate' cannot be null.");
        else if (translate !== undefined)
            url_ += "translate=" + encodeURIComponent("" + translate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processAddLanguage(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProcedureLanguage(model: ProcedureLanguageModel): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/UpdateProcedureLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProcedureLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProcedureLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processUpdateProcedureLanguage(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStepLanguage(model: ProcedureStepLanguageModel): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/UpdateStepLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStepLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStepLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processUpdateStepLanguage(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStepMain(model: ProcedureStepModel): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/UpdateStepMain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStepMain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStepMain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processUpdateStepMain(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addStep(model: ProcedureStepModel): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/AddStep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processAddStep(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    translateProcedureStep(model: ProcedureStepLanguageModel): Observable<ProcedureStepLanguageModel> {
        let url_ = this.baseUrl + "/api/Procedure/TranslateProcedureStep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTranslateProcedureStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTranslateProcedureStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureStepLanguageModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureStepLanguageModel>;
        }));
    }

    protected processTranslateProcedureStep(response: HttpResponseBase): Observable<ProcedureStepLanguageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureStepLanguageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RiskCategory
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RiskCategory by RiskAnalysis
     */
    getAll(): Observable<ProcedureModel[]> {
        let url_ = this.baseUrl + "/api/Procedure/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProcedureModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcedureModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RiskCategory by RiskAnalysis
     * @param id (optional) 
     * @param includeObsolete (optional) 
     * @param includeDeleted (optional) 
     */
    getByDepartment(id?: string | undefined, includeObsolete?: boolean | undefined, includeDeleted?: boolean | undefined): Observable<ProcedureModel[]> {
        let url_ = this.baseUrl + "/api/Procedure/GetByDepartment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (includeObsolete === null)
            throw new globalThis.Error("The parameter 'includeObsolete' cannot be null.");
        else if (includeObsolete !== undefined)
            url_ += "includeObsolete=" + encodeURIComponent("" + includeObsolete) + "&";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel[]>;
        }));
    }

    protected processGetByDepartment(response: HttpResponseBase): Observable<ProcedureModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcedureModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RiskCategory by RiskAnalysis
     * @param id (optional) 
     */
    getByOrganization(id?: string | undefined): Observable<ProcedureModel[]> {
        let url_ = this.baseUrl + "/api/Procedure/GetByOrganization?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel[]>;
        }));
    }

    protected processGetByOrganization(response: HttpResponseBase): Observable<ProcedureModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcedureModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    post(model: ProcedureModel): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copy(id?: string | undefined, departmentId?: string | undefined): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/Copy?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    createNewVersion(model: ProcedureModel): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/CreateNewVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processCreateNewVersion(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upgradeProcedures(): Observable<void> {
        let url_ = this.baseUrl + "/api/Procedure/UpgradeProcedures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeProcedures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeProcedures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpgradeProcedures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    saveSort(model: ProcedureModel): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/SaveSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processSaveSort(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveSortLegacy(model: ProcedureModel): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/SaveSortLegacy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSortLegacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSortLegacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processSaveSortLegacy(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     * @param id (optional) 
     */
    newVersion(id?: string | undefined): Observable<ProcedureModel> {
        let url_ = this.baseUrl + "/api/Procedure/NewVersion?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureModel>;
        }));
    }

    protected processNewVersion(response: HttpResponseBase): Observable<ProcedureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    undelete(model: ProcedureModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Procedure/Undelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUndelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Procedure/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProcedureStep(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Procedure/DeleteProcedureStep?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProcedureStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProcedureStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteProcedureStep(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(type?: string | null | undefined, id?: string | undefined, language?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Procedure/GetReport?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProcedureStepService {
    /**
     * Get RiskCategory
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ProcedureStepRelationModel>;
    /**
     * Get RiskCategory by RiskAnalysis
     * @param id (optional) 
     */
    getByProcedure(id?: string | undefined): Observable<ProcedureStepRelationModel[]>;
    /**
     * Get RiskCategory by RiskAnalysis
     * @param id (optional) 
     */
    getHistory(id?: string | undefined): Observable<HistoryModel[]>;
    /**
     * Add or update RiskAnalysis
     */
    post(model: ProcedureStepRelationModel): Observable<ProcedureStepRelationModel>;
    /**
     * Copy ProcedureStep
     * @param stepId (optional) 
     * @param procedureId (optional) 
     */
    copy(stepId?: string | undefined, procedureId?: string | undefined): Observable<ProcedureStepRelationModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ProcedureStepService implements IProcedureStepService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get RiskCategory
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ProcedureStepRelationModel> {
        let url_ = this.baseUrl + "/api/ProcedureStep/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureStepRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureStepRelationModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProcedureStepRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureStepRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RiskCategory by RiskAnalysis
     * @param id (optional) 
     */
    getByProcedure(id?: string | undefined): Observable<ProcedureStepRelationModel[]> {
        let url_ = this.baseUrl + "/api/ProcedureStep/GetByProcedure?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProcedure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProcedure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureStepRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureStepRelationModel[]>;
        }));
    }

    protected processGetByProcedure(response: HttpResponseBase): Observable<ProcedureStepRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcedureStepRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RiskCategory by RiskAnalysis
     * @param id (optional) 
     */
    getHistory(id?: string | undefined): Observable<HistoryModel[]> {
        let url_ = this.baseUrl + "/api/ProcedureStep/GetHistory?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoryModel[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<HistoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HistoryModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    post(model: ProcedureStepRelationModel): Observable<ProcedureStepRelationModel> {
        let url_ = this.baseUrl + "/api/ProcedureStep/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureStepRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureStepRelationModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ProcedureStepRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureStepRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Copy ProcedureStep
     * @param stepId (optional) 
     * @param procedureId (optional) 
     */
    copy(stepId?: string | undefined, procedureId?: string | undefined): Observable<ProcedureStepRelationModel> {
        let url_ = this.baseUrl + "/api/ProcedureStep/Copy?";
        if (stepId === null)
            throw new globalThis.Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        if (procedureId === null)
            throw new globalThis.Error("The parameter 'procedureId' cannot be null.");
        else if (procedureId !== undefined)
            url_ += "procedureId=" + encodeURIComponent("" + procedureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureStepRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureStepRelationModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<ProcedureStepRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureStepRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ProcedureStep/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProcessService {
    convertToV2(processId?: string | undefined): Observable<ProcessModel>;
    addLanguage(processId?: string | undefined, language?: string | null | undefined, translate?: boolean | undefined): Observable<ProcessModel>;
    updateProcessLanguage(model: ProcessLanguageModel): Observable<ProcessModel>;
    updateStepLanguage(model: ProcessStepLanguageModel): Observable<ProcessModel>;
    updateStepMain(model: ProcessStepModel): Observable<ProcessModel>;
    createStepDependency(model: ProcessStepDependencyModel): Observable<ProcessStepDependencyModel>;
    updateStepDependency(model: ProcessStepDependencyModel): Observable<ProcessStepDependencyModel>;
    /**
     * Get RiskCategory
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ProcessModel>;
    /**
     * Get all Processes
     */
    getAll(): Observable<ProcessModel[]>;
    searchProcesses(searchText?: string | null | undefined): Observable<ProcessModel[]>;
    /**
     * Get Processes by Organization
     * @param id (optional) 
     */
    getByOrganization(id?: string | undefined): Observable<ProcessModel[]>;
    /**
     * Get RiskCategory by RiskAnalysis
     * @param id (optional) 
     */
    getByDepartment(id?: string | undefined): Observable<ProcessModel[]>;
    /**
     * Copy Processes and Steps
     * @param id (optional) 
     * @param departmentId (optional) 
     */
    copy(id?: string | undefined, departmentId?: string | undefined): Observable<ProcessModel>;
    /**
     * Add or update RiskAnalysis
     */
    post(model: ProcessModel): Observable<ProcessModel>;
    createProcessStepRelation(model: ProcessStepRelationModel): Observable<ProcessStepRelationModel>;
    updateProcessStepRelation(model: ProcessStepRelationModel): Observable<ProcessStepRelationModel>;
    updateStepDependencies(dependencies: ProcessStepDependencyRelationModel[]): Observable<ProcessStepDependencyRelationModel[]>;
    createStepDependencyRelation(model: ProcessStepDependencyRelationModel): Observable<ProcessStepDependencyRelationModel>;
    updateStepDependencyRelation(model: ProcessStepDependencyRelationModel): Observable<ProcessStepDependencyRelationModel>;
    /**
     * Add or update RiskAnalysis
     * @param id (optional) 
     */
    createNewVersion(id?: string | undefined): Observable<ProcessModel>;
    /**
     * Add or update RiskAnalysis
     */
    saveSort(model: ProcessModel): Observable<ProcessModel>;
    /**
     * Add or update RiskAnalysis
     */
    saveImage(model: ProcessModel): Observable<ProcessModel>;
    getReport(type?: string | null | undefined, id?: string | undefined, language?: string | null | undefined): Observable<FileResponse>;
    delete(id?: string | undefined): Observable<string>;
    deleteProcessStepRelation(id?: string | undefined, processId?: string | undefined): Observable<string>;
    deleteProcessStepDependencyRelation(id?: string | undefined, processId?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ProcessService implements IProcessService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    convertToV2(processId?: string | undefined): Observable<ProcessModel> {
        let url_ = this.baseUrl + "/api/Process/ConvertToV2?";
        if (processId === null)
            throw new globalThis.Error("The parameter 'processId' cannot be null.");
        else if (processId !== undefined)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertToV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertToV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel>;
        }));
    }

    protected processConvertToV2(response: HttpResponseBase): Observable<ProcessModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addLanguage(processId?: string | undefined, language?: string | null | undefined, translate?: boolean | undefined): Observable<ProcessModel> {
        let url_ = this.baseUrl + "/api/Process/AddLanguage?";
        if (processId === null)
            throw new globalThis.Error("The parameter 'processId' cannot be null.");
        else if (processId !== undefined)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (translate === null)
            throw new globalThis.Error("The parameter 'translate' cannot be null.");
        else if (translate !== undefined)
            url_ += "translate=" + encodeURIComponent("" + translate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel>;
        }));
    }

    protected processAddLanguage(response: HttpResponseBase): Observable<ProcessModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProcessLanguage(model: ProcessLanguageModel): Observable<ProcessModel> {
        let url_ = this.baseUrl + "/api/Process/UpdateProcessLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProcessLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProcessLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel>;
        }));
    }

    protected processUpdateProcessLanguage(response: HttpResponseBase): Observable<ProcessModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStepLanguage(model: ProcessStepLanguageModel): Observable<ProcessModel> {
        let url_ = this.baseUrl + "/api/Process/UpdateStepLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStepLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStepLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel>;
        }));
    }

    protected processUpdateStepLanguage(response: HttpResponseBase): Observable<ProcessModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStepMain(model: ProcessStepModel): Observable<ProcessModel> {
        let url_ = this.baseUrl + "/api/Process/UpdateStepMain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStepMain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStepMain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel>;
        }));
    }

    protected processUpdateStepMain(response: HttpResponseBase): Observable<ProcessModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createStepDependency(model: ProcessStepDependencyModel): Observable<ProcessStepDependencyModel> {
        let url_ = this.baseUrl + "/api/Process/CreateStepDependency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStepDependency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStepDependency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessStepDependencyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessStepDependencyModel>;
        }));
    }

    protected processCreateStepDependency(response: HttpResponseBase): Observable<ProcessStepDependencyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessStepDependencyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStepDependency(model: ProcessStepDependencyModel): Observable<ProcessStepDependencyModel> {
        let url_ = this.baseUrl + "/api/Process/UpdateStepDependency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStepDependency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStepDependency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessStepDependencyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessStepDependencyModel>;
        }));
    }

    protected processUpdateStepDependency(response: HttpResponseBase): Observable<ProcessStepDependencyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessStepDependencyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RiskCategory
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ProcessModel> {
        let url_ = this.baseUrl + "/api/Process/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProcessModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Processes
     */
    getAll(): Observable<ProcessModel[]> {
        let url_ = this.baseUrl + "/api/Process/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProcessModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchProcesses(searchText?: string | null | undefined): Observable<ProcessModel[]> {
        let url_ = this.baseUrl + "/api/Process/SearchProcesses?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProcesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProcesses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel[]>;
        }));
    }

    protected processSearchProcesses(response: HttpResponseBase): Observable<ProcessModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Processes by Organization
     * @param id (optional) 
     */
    getByOrganization(id?: string | undefined): Observable<ProcessModel[]> {
        let url_ = this.baseUrl + "/api/Process/GetByOrganization?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel[]>;
        }));
    }

    protected processGetByOrganization(response: HttpResponseBase): Observable<ProcessModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RiskCategory by RiskAnalysis
     * @param id (optional) 
     */
    getByDepartment(id?: string | undefined): Observable<ProcessModel[]> {
        let url_ = this.baseUrl + "/api/Process/GetByDepartment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel[]>;
        }));
    }

    protected processGetByDepartment(response: HttpResponseBase): Observable<ProcessModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Copy Processes and Steps
     * @param id (optional) 
     * @param departmentId (optional) 
     */
    copy(id?: string | undefined, departmentId?: string | undefined): Observable<ProcessModel> {
        let url_ = this.baseUrl + "/api/Process/Copy?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<ProcessModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    post(model: ProcessModel): Observable<ProcessModel> {
        let url_ = this.baseUrl + "/api/Process/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ProcessModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createProcessStepRelation(model: ProcessStepRelationModel): Observable<ProcessStepRelationModel> {
        let url_ = this.baseUrl + "/api/Process/CreateProcessStepRelation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProcessStepRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProcessStepRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessStepRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessStepRelationModel>;
        }));
    }

    protected processCreateProcessStepRelation(response: HttpResponseBase): Observable<ProcessStepRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessStepRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProcessStepRelation(model: ProcessStepRelationModel): Observable<ProcessStepRelationModel> {
        let url_ = this.baseUrl + "/api/Process/UpdateProcessStepRelation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProcessStepRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProcessStepRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessStepRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessStepRelationModel>;
        }));
    }

    protected processUpdateProcessStepRelation(response: HttpResponseBase): Observable<ProcessStepRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessStepRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStepDependencies(dependencies: ProcessStepDependencyRelationModel[]): Observable<ProcessStepDependencyRelationModel[]> {
        let url_ = this.baseUrl + "/api/Process/UpdateStepDependencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dependencies);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStepDependencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStepDependencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessStepDependencyRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessStepDependencyRelationModel[]>;
        }));
    }

    protected processUpdateStepDependencies(response: HttpResponseBase): Observable<ProcessStepDependencyRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessStepDependencyRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createStepDependencyRelation(model: ProcessStepDependencyRelationModel): Observable<ProcessStepDependencyRelationModel> {
        let url_ = this.baseUrl + "/api/Process/CreateStepDependencyRelation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStepDependencyRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStepDependencyRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessStepDependencyRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessStepDependencyRelationModel>;
        }));
    }

    protected processCreateStepDependencyRelation(response: HttpResponseBase): Observable<ProcessStepDependencyRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessStepDependencyRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStepDependencyRelation(model: ProcessStepDependencyRelationModel): Observable<ProcessStepDependencyRelationModel> {
        let url_ = this.baseUrl + "/api/Process/UpdateStepDependencyRelation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStepDependencyRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStepDependencyRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessStepDependencyRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessStepDependencyRelationModel>;
        }));
    }

    protected processUpdateStepDependencyRelation(response: HttpResponseBase): Observable<ProcessStepDependencyRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessStepDependencyRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     * @param id (optional) 
     */
    createNewVersion(id?: string | undefined): Observable<ProcessModel> {
        let url_ = this.baseUrl + "/api/Process/CreateNewVersion?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel>;
        }));
    }

    protected processCreateNewVersion(response: HttpResponseBase): Observable<ProcessModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    saveSort(model: ProcessModel): Observable<ProcessModel> {
        let url_ = this.baseUrl + "/api/Process/SaveSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel>;
        }));
    }

    protected processSaveSort(response: HttpResponseBase): Observable<ProcessModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    saveImage(model: ProcessModel): Observable<ProcessModel> {
        let url_ = this.baseUrl + "/api/Process/SaveImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessModel>;
        }));
    }

    protected processSaveImage(response: HttpResponseBase): Observable<ProcessModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(type?: string | null | undefined, id?: string | undefined, language?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Process/GetReport?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Process/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProcessStepRelation(id?: string | undefined, processId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Process/DeleteProcessStepRelation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (processId === null)
            throw new globalThis.Error("The parameter 'processId' cannot be null.");
        else if (processId !== undefined)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProcessStepRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProcessStepRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteProcessStepRelation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProcessStepDependencyRelation(id?: string | undefined, processId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Process/DeleteProcessStepDependencyRelation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (processId === null)
            throw new globalThis.Error("The parameter 'processId' cannot be null.");
        else if (processId !== undefined)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProcessStepDependencyRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProcessStepDependencyRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteProcessStepDependencyRelation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProductService {
    get(id?: string | undefined): Observable<ProductModel>;
    /**
     * Get all Products
     */
    getAll(): Observable<ProductModel[]>;
    /**
     * Get all Products
     */
    getAllPaged(query: PagedQuery): Observable<PagedResultOfProductModel>;
    /**
     * Get all Products
     * @param id (optional) 
     */
    getByProductGroup(id?: string | undefined): Observable<ProductModel[]>;
    /**
     * Get by ProductVariant
     * @param id (optional) 
     */
    getByProductVariant(id?: string | undefined): Observable<ProductModel>;
    checkProduct(id?: string | undefined): Observable<string>;
    calculateProduct(productId?: string | undefined, recipeId?: string | undefined, calculateDescription?: boolean | undefined, calculateNutrition?: boolean | undefined, calculateAllergens?: boolean | undefined, calculateCostPrice?: boolean | undefined): Observable<string>;
    /**
     * Get all Products
     * @param searchText (optional) 
     * @param supplier (optional) 
     * @param group (optional) 
     * @param type (optional) 
     * @param showObsolete (optional) 
     * @param showOnlyOrganic (optional) 
     */
    searchProducts(searchText?: string | null | undefined, supplier?: string | undefined, group?: string | undefined, type?: string | null | undefined, showObsolete?: boolean | undefined, showOnlyOrganic?: boolean | undefined): Observable<ProductModel[]>;
    /**
     * Get all Products
     * @param searchText (optional) 
     * @param customer (optional) 
     */
    searchProductsForCustomer(searchText?: string | null | undefined, customer?: string | undefined): Observable<ProductModel[]>;
    /**
     * Add or update Product
     */
    post(model: ProductModel): Observable<ProductModel>;
    bulkChangeStockLocation(model: BulkChangeModel): Observable<string>;
    bulkChangeProductGroup(model: BulkChangeModel): Observable<string>;
    bulkAddToProductGroup(model: BulkChangeModel): Observable<string>;
    bulkChangeProductType(model: BulkChangeModel): Observable<string>;
    bulkChangeSupplier(model: BulkChangeModel): Observable<string>;
    bulkChangeStockOwner(model: BulkChangeModel): Observable<string>;
    setOrganicProducts(model: BulkChangeModel): Observable<string>;
    setTraceableProducts(model: BulkChangeModel): Observable<string>;
    setOriginProducts(model: BulkChangeModel): Observable<string>;
    bulkApproveProducts(model: BulkChangeModel): Observable<string>;
    bulkObsoleteProducts(model: BulkChangeModel): Observable<string>;
    /**
     * Preview Exports (Excel)
     */
    previewExcelExport(pagedQuery: PagedQuery): Observable<string[][]>;
    /**
     * Export All Products
     */
    export(pagedQuery: PagedQuery): Observable<string>;
    /**
     * Export All Products
     */
    exportPrices(pagedQuery: PagedQuery): Observable<string>;
    importCustomerPrices(fileName?: string | null | undefined, customerId?: string | undefined, validFrom?: Date | undefined): Observable<string>;
    importPrices(fileName?: string | null | undefined): Observable<string>;
    /**
     * Export All Products
     * @param id (optional) 
     * @param lang (optional) 
     */
    exportLanguagesByGroup(id?: string | undefined, lang?: string | null | undefined): Observable<string>;
    /**
     * Import Langauges
     * @param fileName (optional) 
     */
    importLanguagesByGroup(fileName?: string | null | undefined): Observable<string>;
    createCasePackingLists(model: BulkChangeModel): Observable<string>;
    /**
     * Import Langauges
     * @param filename (optional) 
     */
    previewExcelImport(filename?: string | null | undefined): Observable<string[][]>;
    unDelete(id?: string | undefined): Observable<string>;
    copy(productId?: string | undefined): Observable<ProductModel>;
    delete(id?: string | undefined): Observable<string>;
    fixProductUpdated(): Observable<string>;
    fixStockLocation(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductService implements IProductService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id?: string | undefined): Observable<ProductModel> {
        let url_ = this.baseUrl + "/api/Product/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Products
     */
    getAll(): Observable<ProductModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProductModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Products
     */
    getAllPaged(query: PagedQuery): Observable<PagedResultOfProductModel> {
        let url_ = this.baseUrl + "/api/Product/GetAllPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfProductModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfProductModel>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<PagedResultOfProductModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfProductModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Products
     * @param id (optional) 
     */
    getByProductGroup(id?: string | undefined): Observable<ProductModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetByProductGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel[]>;
        }));
    }

    protected processGetByProductGroup(response: HttpResponseBase): Observable<ProductModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get by ProductVariant
     * @param id (optional) 
     */
    getByProductVariant(id?: string | undefined): Observable<ProductModel> {
        let url_ = this.baseUrl + "/api/Product/GetByProductVariant?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel>;
        }));
    }

    protected processGetByProductVariant(response: HttpResponseBase): Observable<ProductModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkProduct(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/CheckProduct?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckProduct(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateProduct(productId?: string | undefined, recipeId?: string | undefined, calculateDescription?: boolean | undefined, calculateNutrition?: boolean | undefined, calculateAllergens?: boolean | undefined, calculateCostPrice?: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/CalculateProduct?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (recipeId === null)
            throw new globalThis.Error("The parameter 'recipeId' cannot be null.");
        else if (recipeId !== undefined)
            url_ += "recipeId=" + encodeURIComponent("" + recipeId) + "&";
        if (calculateDescription === null)
            throw new globalThis.Error("The parameter 'calculateDescription' cannot be null.");
        else if (calculateDescription !== undefined)
            url_ += "calculateDescription=" + encodeURIComponent("" + calculateDescription) + "&";
        if (calculateNutrition === null)
            throw new globalThis.Error("The parameter 'calculateNutrition' cannot be null.");
        else if (calculateNutrition !== undefined)
            url_ += "calculateNutrition=" + encodeURIComponent("" + calculateNutrition) + "&";
        if (calculateAllergens === null)
            throw new globalThis.Error("The parameter 'calculateAllergens' cannot be null.");
        else if (calculateAllergens !== undefined)
            url_ += "calculateAllergens=" + encodeURIComponent("" + calculateAllergens) + "&";
        if (calculateCostPrice === null)
            throw new globalThis.Error("The parameter 'calculateCostPrice' cannot be null.");
        else if (calculateCostPrice !== undefined)
            url_ += "calculateCostPrice=" + encodeURIComponent("" + calculateCostPrice) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCalculateProduct(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Products
     * @param searchText (optional) 
     * @param supplier (optional) 
     * @param group (optional) 
     * @param type (optional) 
     * @param showObsolete (optional) 
     * @param showOnlyOrganic (optional) 
     */
    searchProducts(searchText?: string | null | undefined, supplier?: string | undefined, group?: string | undefined, type?: string | null | undefined, showObsolete?: boolean | undefined, showOnlyOrganic?: boolean | undefined): Observable<ProductModel[]> {
        let url_ = this.baseUrl + "/api/Product/SearchProducts?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (supplier === null)
            throw new globalThis.Error("The parameter 'supplier' cannot be null.");
        else if (supplier !== undefined)
            url_ += "supplier=" + encodeURIComponent("" + supplier) + "&";
        if (group === null)
            throw new globalThis.Error("The parameter 'group' cannot be null.");
        else if (group !== undefined)
            url_ += "group=" + encodeURIComponent("" + group) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (showObsolete === null)
            throw new globalThis.Error("The parameter 'showObsolete' cannot be null.");
        else if (showObsolete !== undefined)
            url_ += "showObsolete=" + encodeURIComponent("" + showObsolete) + "&";
        if (showOnlyOrganic === null)
            throw new globalThis.Error("The parameter 'showOnlyOrganic' cannot be null.");
        else if (showOnlyOrganic !== undefined)
            url_ += "showOnlyOrganic=" + encodeURIComponent("" + showOnlyOrganic) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel[]>;
        }));
    }

    protected processSearchProducts(response: HttpResponseBase): Observable<ProductModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Products
     * @param searchText (optional) 
     * @param customer (optional) 
     */
    searchProductsForCustomer(searchText?: string | null | undefined, customer?: string | undefined): Observable<ProductModel[]> {
        let url_ = this.baseUrl + "/api/Product/SearchProductsForCustomer?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (customer === null)
            throw new globalThis.Error("The parameter 'customer' cannot be null.");
        else if (customer !== undefined)
            url_ += "customer=" + encodeURIComponent("" + customer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProductsForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProductsForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel[]>;
        }));
    }

    protected processSearchProductsForCustomer(response: HttpResponseBase): Observable<ProductModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Product
     */
    post(model: ProductModel): Observable<ProductModel> {
        let url_ = this.baseUrl + "/api/Product/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ProductModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkChangeStockLocation(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/BulkChangeStockLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeStockLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeStockLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeStockLocation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkChangeProductGroup(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/BulkChangeProductGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeProductGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeProductGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeProductGroup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkAddToProductGroup(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/BulkAddToProductGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkAddToProductGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkAddToProductGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkAddToProductGroup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkChangeProductType(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/BulkChangeProductType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeProductType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeProductType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeProductType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkChangeSupplier(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/BulkChangeSupplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeSupplier(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkChangeStockOwner(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/BulkChangeStockOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeStockOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeStockOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeStockOwner(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setOrganicProducts(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/SetOrganicProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOrganicProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOrganicProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSetOrganicProducts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setTraceableProducts(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/SetTraceableProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTraceableProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTraceableProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSetTraceableProducts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setOriginProducts(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/SetOriginProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOriginProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOriginProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSetOriginProducts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkApproveProducts(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/BulkApproveProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkApproveProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkApproveProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkApproveProducts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkObsoleteProducts(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/BulkObsoleteProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkObsoleteProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkObsoleteProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkObsoleteProducts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Preview Exports (Excel)
     */
    previewExcelExport(pagedQuery: PagedQuery): Observable<string[][]> {
        let url_ = this.baseUrl + "/api/Product/PreviewExcelExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewExcelExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewExcelExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[][]>;
        }));
    }

    protected processPreviewExcelExport(response: HttpResponseBase): Observable<string[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export All Products
     */
    export(pagedQuery: PagedQuery): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export All Products
     */
    exportPrices(pagedQuery: PagedQuery): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/ExportPrices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportPrices(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importCustomerPrices(fileName?: string | null | undefined, customerId?: string | undefined, validFrom?: Date | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/ImportCustomerPrices?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (validFrom === null)
            throw new globalThis.Error("The parameter 'validFrom' cannot be null.");
        else if (validFrom !== undefined)
            url_ += "validFrom=" + encodeURIComponent(validFrom ? "" + validFrom.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCustomerPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCustomerPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportCustomerPrices(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importPrices(fileName?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/ImportPrices?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportPrices(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export All Products
     * @param id (optional) 
     * @param lang (optional) 
     */
    exportLanguagesByGroup(id?: string | undefined, lang?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/ExportLanguagesByGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLanguagesByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLanguagesByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportLanguagesByGroup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Import Langauges
     * @param fileName (optional) 
     */
    importLanguagesByGroup(fileName?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/ImportLanguagesByGroup?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportLanguagesByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportLanguagesByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportLanguagesByGroup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCasePackingLists(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/CreateCasePackingLists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCasePackingLists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCasePackingLists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateCasePackingLists(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Import Langauges
     * @param filename (optional) 
     */
    previewExcelImport(filename?: string | null | undefined): Observable<string[][]> {
        let url_ = this.baseUrl + "/api/Product/PreviewExcelImport?";
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewExcelImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewExcelImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[][]>;
        }));
    }

    protected processPreviewExcelImport(response: HttpResponseBase): Observable<string[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unDelete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/UnDelete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUnDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copy(productId?: string | undefined): Observable<ProductModel> {
        let url_ = this.baseUrl + "/api/Product/Copy?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<ProductModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fixProductUpdated(): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/FixProductUpdated";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixProductUpdated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixProductUpdated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFixProductUpdated(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fixStockLocation(): Observable<string> {
        let url_ = this.baseUrl + "/api/Product/FixStockLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixStockLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixStockLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFixStockLocation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProductGroupService {
    /**
     * Get ProductGroup
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ProductGroupModel>;
    /**
     * Get ProductGroup by Supplier
     */
    getAll(): Observable<ProductGroupModel[]>;
    /**
     * Get ProductGroup by Supplier
     * @param type (optional) 
     */
    getByType(type?: number | undefined): Observable<ProductGroupModel[]>;
    searchProductGroups(searchText?: string | null | undefined): Observable<ProductGroupModel[]>;
    attachProductToGroup(productId?: string | undefined, groupId?: string | undefined): Observable<GroupRelationModel>;
    detachProductFromGroup(productId?: string | undefined, groupId?: string | undefined): Observable<GroupRelationModel>;
    /**
     * Add or update ProductGroup
     */
    post(model: ProductGroupModel): Observable<ProductGroupModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductGroupService implements IProductGroupService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get ProductGroup
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ProductGroupModel> {
        let url_ = this.baseUrl + "/api/ProductGroup/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ProductGroup by Supplier
     */
    getAll(): Observable<ProductGroupModel[]> {
        let url_ = this.baseUrl + "/api/ProductGroup/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProductGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductGroupModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ProductGroup by Supplier
     * @param type (optional) 
     */
    getByType(type?: number | undefined): Observable<ProductGroupModel[]> {
        let url_ = this.baseUrl + "/api/ProductGroup/GetByType?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupModel[]>;
        }));
    }

    protected processGetByType(response: HttpResponseBase): Observable<ProductGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductGroupModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchProductGroups(searchText?: string | null | undefined): Observable<ProductGroupModel[]> {
        let url_ = this.baseUrl + "/api/ProductGroup/SearchProductGroups?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProductGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProductGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupModel[]>;
        }));
    }

    protected processSearchProductGroups(response: HttpResponseBase): Observable<ProductGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductGroupModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    attachProductToGroup(productId?: string | undefined, groupId?: string | undefined): Observable<GroupRelationModel> {
        let url_ = this.baseUrl + "/api/ProductGroup/AttachProductToGroup?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (groupId === null)
            throw new globalThis.Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachProductToGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachProductToGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupRelationModel>;
        }));
    }

    protected processAttachProductToGroup(response: HttpResponseBase): Observable<GroupRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    detachProductFromGroup(productId?: string | undefined, groupId?: string | undefined): Observable<GroupRelationModel> {
        let url_ = this.baseUrl + "/api/ProductGroup/DetachProductFromGroup?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (groupId === null)
            throw new globalThis.Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetachProductFromGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetachProductFromGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupRelationModel>;
        }));
    }

    protected processDetachProductFromGroup(response: HttpResponseBase): Observable<GroupRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update ProductGroup
     */
    post(model: ProductGroupModel): Observable<ProductGroupModel> {
        let url_ = this.baseUrl + "/api/ProductGroup/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ProductGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductGroup/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProductionOrderService {
    /**
     * Get Production Order
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ProductionOrderModel>;
    getWithRecipe(id?: string | undefined): Observable<ProductionOrderWithRecipeModel>;
    getPdf(id?: string | undefined): Observable<FileResponse>;
    /**
     * Get all production orders for User
     */
    getPdfForOrders(orders: ProductionOrderModel[]): Observable<FileResponse>;
    scheduleOrders(orders: ProductionOrderModel[]): Observable<string>;
    /**
     * Get Recipe
     * @param id (optional) 
     */
    getRecipe(id?: string | undefined): Observable<RecipeModel>;
    /**
     * Get all production orders for User
     * @param id (optional) 
     */
    getByUser(id?: string | undefined): Observable<ProductionOrderModel[]>;
    /**
     * Get all production orders for User
     * @param pageSize (optional) 
     * @param pageNo (optional) 
     */
    getAll(pageSize?: number | undefined, pageNo?: number | undefined): Observable<ProductionOrderModel[]>;
    /**
     * Get all production orders for User
     * @param pageSize (optional) 
     * @param pageNo (optional) 
     */
    getAllOpen(pageSize?: number | undefined, pageNo?: number | undefined): Observable<ProductionOrderModel[]>;
    /**
     * Get all production orders for User
     * @param status (optional) 
     * @param pageSize (optional) 
     * @param pageNo (optional) 
     */
    getByStatus(status?: ProductionOrderStatus | undefined, pageSize?: number | undefined, pageNo?: number | undefined): Observable<ProductionOrderModel[]>;
    /**
     * Get all production orders for User
     * @param id (optional) 
     */
    getOrderlineWarnings(id?: string | undefined): Observable<OrderlineWarningModel[]>;
    /**
     * Get all orders
     */
    getAllPaged(query: PagedQuery): Observable<PagedResultOfProductionOrderModel>;
    /**
     * Get all production orders for User
     * @param startTime (optional) 
     * @param endTime (optional) 
     */
    getByDateRange(startTime?: Date | undefined, endTime?: Date | undefined): Observable<ProductionOrderModel[]>;
    getForPlanning(startTime?: Date | undefined, endTime?: Date | undefined): Observable<ProductionOrderPlanningModel[]>;
    /**
     * Get all production orders for User
     * @param id (optional) 
     */
    getBySalesOrder(id?: string | undefined): Observable<ProductionOrderWithRecipeModel[]>;
    /**
     * Get all production orders for User
     * @param pageNo (optional) 
     * @param pageSize (optional) 
     */
    getPaged(pageNo?: number | undefined, pageSize?: number | undefined): Observable<PagedResultOfProductionOrderModel>;
    /**
     * Get all production orders for User
     */
    getIngredientsForOrders(orders: ProductionOrderModel[]): Observable<StockItemModel[]>;
    /**
     * Get all production orders for User
     */
    getPackagingForOrders(orders: ProductionOrderModel[]): Observable<StockItemModel[]>;
    /**
     * Get all production orders for User
     */
    getSemiFinishedForOrders(orders: ProductionOrderModel[]): Observable<StockItemModel[]>;
    getSemiFinishedDemand(productGroupIds: string[], startDate?: Date | undefined, endDate?: Date | undefined): Observable<StockItemModel[]>;
    getVariantsByDemand(startTime?: Date | undefined, endTime?: Date | undefined, includeBaskets?: boolean | null | undefined, productGroupId?: string | null | undefined, productType?: string | null | undefined): Observable<StockItemModel[]>;
    getVariantDemand(variantId?: string | undefined, startTime?: Date | undefined, endTime?: Date | undefined, force?: boolean | undefined): Observable<StockItemModel>;
    getPdfForFinishedOrders(startTime?: Date | undefined, endTime?: Date | undefined, includeBaskets?: boolean | null | undefined, productGroupId?: string | null | undefined): Observable<FileResponse>;
    getPdfForPlan(startTime?: Date | undefined, endTime?: Date | undefined, type?: number | null | undefined, status?: ProductionOrderStatus | null | undefined): Observable<FileResponse>;
    /**
     * Get all production orders for User
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param includeBaskets (optional) 
     * @param productGroupId (optional) 
     */
    getFinishedForOrders(startTime?: Date | undefined, endTime?: Date | undefined, includeBaskets?: boolean | null | undefined, productGroupId?: string | null | undefined): Observable<StockItemModel[]>;
    bulkCreateFinishedProductionOrders(model: ProductionOrderBulkChangeModel): Observable<ProductionOrderModel[]>;
    /**
     * Get all child production orders for production order
     * @param id (optional) 
     */
    getChildren(id?: string | undefined): Observable<ProductionOrderModel[]>;
    /**
     * Delete production order
     * @param id (optional) 
     */
    delete(id?: string | undefined): Observable<string>;
    /**
     * Pick products for production order
     * @param id (optional) 
     */
    pickOrder(id?: string | undefined): Observable<ProductionOrderModel>;
    scheduleOrder(id?: string | undefined): Observable<ProductionOrderModel>;
    planOrder(model: AllocateOrderModel): Observable<ResourceAllocationModel[]>;
    reserveOrder(id?: string | undefined): Observable<ProductionOrderModel>;
    duplicateOrder(model: ProductionOrderModel): Observable<string>;
    estimateOrder(id?: string | undefined): Observable<ProductionOrderModel>;
    resetOrder(id?: string | undefined): Observable<ProductionOrderModel>;
    bookOrder(id?: string | undefined): Observable<ProductionOrderModel>;
    scheduleAllOpenOrders(): Observable<string>;
    calculateByOutput(productVariantId?: string | undefined, quantity?: number | undefined, unit?: string | null | undefined, finishTime?: Date | null | undefined): Observable<ProductionOrderModel[]>;
    fillLotNumbers(orders: ProductionOrderModel[]): Observable<string>;
    fillLotNumberForIngredient(model: FillLotModel): Observable<string>;
    /**
     * Add or update production order
     */
    post(model: ProductionOrderModel): Observable<ProductionOrderModel>;
    /**
     * Add or update production order
     */
    startProduction(model: ProductionOrderModel): Observable<ProductionOrderModel>;
    /**
     * Add or update production order
     */
    finishProduction(model: ProductionOrderModel): Observable<ProductionOrderModel>;
    /**
     * Add or update production order
     */
    editStartTime(model: ProductionOrderModel): Observable<ProductionOrderModel>;
    /**
     * Add or update production orderline
     */
    updateOrderline(model: ProductionOrderlineModel): Observable<OrderlineModel>;
    /**
     * Get all production orders for User
     */
    checkAll(): Observable<string>;
    checkProductionOrder(id?: string | undefined): Observable<string>;
    exportPlanningData(): Observable<ProductionPlannerModel>;
    importPlanningData(model: ProductionPlannerModel): Observable<string>;
    fixFinishedProductionOrderOrderlines(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductionOrderService implements IProductionOrderService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Production Order
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWithRecipe(id?: string | undefined): Observable<ProductionOrderWithRecipeModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetWithRecipe?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWithRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWithRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderWithRecipeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderWithRecipeModel>;
        }));
    }

    protected processGetWithRecipe(response: HttpResponseBase): Observable<ProductionOrderWithRecipeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionOrderWithRecipeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPdf(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetPdf?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     */
    getPdfForOrders(orders: ProductionOrderModel[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetPdfForOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orders);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfForOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfForOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdfForOrders(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleOrders(orders: ProductionOrderModel[]): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductionOrder/ScheduleOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orders);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Recipe
     * @param id (optional) 
     */
    getRecipe(id?: string | undefined): Observable<RecipeModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetRecipe?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel>;
        }));
    }

    protected processGetRecipe(response: HttpResponseBase): Observable<RecipeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     * @param id (optional) 
     */
    getByUser(id?: string | undefined): Observable<ProductionOrderModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetByUser?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel[]>;
        }));
    }

    protected processGetByUser(response: HttpResponseBase): Observable<ProductionOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     * @param pageSize (optional) 
     * @param pageNo (optional) 
     */
    getAll(pageSize?: number | undefined, pageNo?: number | undefined): Observable<ProductionOrderModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetAll?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNo === null)
            throw new globalThis.Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProductionOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     * @param pageSize (optional) 
     * @param pageNo (optional) 
     */
    getAllOpen(pageSize?: number | undefined, pageNo?: number | undefined): Observable<ProductionOrderModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetAllOpen?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNo === null)
            throw new globalThis.Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOpen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOpen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel[]>;
        }));
    }

    protected processGetAllOpen(response: HttpResponseBase): Observable<ProductionOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     * @param status (optional) 
     * @param pageSize (optional) 
     * @param pageNo (optional) 
     */
    getByStatus(status?: ProductionOrderStatus | undefined, pageSize?: number | undefined, pageNo?: number | undefined): Observable<ProductionOrderModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetByStatus?";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNo === null)
            throw new globalThis.Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel[]>;
        }));
    }

    protected processGetByStatus(response: HttpResponseBase): Observable<ProductionOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     * @param id (optional) 
     */
    getOrderlineWarnings(id?: string | undefined): Observable<OrderlineWarningModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetOrderlineWarnings?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderlineWarnings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderlineWarnings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderlineWarningModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderlineWarningModel[]>;
        }));
    }

    protected processGetOrderlineWarnings(response: HttpResponseBase): Observable<OrderlineWarningModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderlineWarningModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders
     */
    getAllPaged(query: PagedQuery): Observable<PagedResultOfProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetAllPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfProductionOrderModel>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<PagedResultOfProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     * @param startTime (optional) 
     * @param endTime (optional) 
     */
    getByDateRange(startTime?: Date | undefined, endTime?: Date | undefined): Observable<ProductionOrderModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetByDateRange?";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel[]>;
        }));
    }

    protected processGetByDateRange(response: HttpResponseBase): Observable<ProductionOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getForPlanning(startTime?: Date | undefined, endTime?: Date | undefined): Observable<ProductionOrderPlanningModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetForPlanning?";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderPlanningModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderPlanningModel[]>;
        }));
    }

    protected processGetForPlanning(response: HttpResponseBase): Observable<ProductionOrderPlanningModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderPlanningModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     * @param id (optional) 
     */
    getBySalesOrder(id?: string | undefined): Observable<ProductionOrderWithRecipeModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetBySalesOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBySalesOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySalesOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderWithRecipeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderWithRecipeModel[]>;
        }));
    }

    protected processGetBySalesOrder(response: HttpResponseBase): Observable<ProductionOrderWithRecipeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderWithRecipeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     * @param pageNo (optional) 
     * @param pageSize (optional) 
     */
    getPaged(pageNo?: number | undefined, pageSize?: number | undefined): Observable<PagedResultOfProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetPaged?";
        if (pageNo === null)
            throw new globalThis.Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfProductionOrderModel>;
        }));
    }

    protected processGetPaged(response: HttpResponseBase): Observable<PagedResultOfProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     */
    getIngredientsForOrders(orders: ProductionOrderModel[]): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetIngredientsForOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orders);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIngredientsForOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngredientsForOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetIngredientsForOrders(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     */
    getPackagingForOrders(orders: ProductionOrderModel[]): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetPackagingForOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orders);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackagingForOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackagingForOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetPackagingForOrders(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     */
    getSemiFinishedForOrders(orders: ProductionOrderModel[]): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetSemiFinishedForOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orders);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSemiFinishedForOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSemiFinishedForOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetSemiFinishedForOrders(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSemiFinishedDemand(productGroupIds: string[], startDate?: Date | undefined, endDate?: Date | undefined): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetSemiFinishedDemand?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productGroupIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSemiFinishedDemand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSemiFinishedDemand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetSemiFinishedDemand(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVariantsByDemand(startTime?: Date | undefined, endTime?: Date | undefined, includeBaskets?: boolean | null | undefined, productGroupId?: string | null | undefined, productType?: string | null | undefined): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetVariantsByDemand?";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (includeBaskets !== undefined && includeBaskets !== null)
            url_ += "includeBaskets=" + encodeURIComponent("" + includeBaskets) + "&";
        if (productGroupId !== undefined && productGroupId !== null)
            url_ += "productGroupId=" + encodeURIComponent("" + productGroupId) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVariantsByDemand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVariantsByDemand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetVariantsByDemand(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVariantDemand(variantId?: string | undefined, startTime?: Date | undefined, endTime?: Date | undefined, force?: boolean | undefined): Observable<StockItemModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetVariantDemand?";
        if (variantId === null)
            throw new globalThis.Error("The parameter 'variantId' cannot be null.");
        else if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (force === null)
            throw new globalThis.Error("The parameter 'force' cannot be null.");
        else if (force !== undefined)
            url_ += "force=" + encodeURIComponent("" + force) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVariantDemand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVariantDemand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel>;
        }));
    }

    protected processGetVariantDemand(response: HttpResponseBase): Observable<StockItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPdfForFinishedOrders(startTime?: Date | undefined, endTime?: Date | undefined, includeBaskets?: boolean | null | undefined, productGroupId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetPdfForFinishedOrders?";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (includeBaskets !== undefined && includeBaskets !== null)
            url_ += "includeBaskets=" + encodeURIComponent("" + includeBaskets) + "&";
        if (productGroupId !== undefined && productGroupId !== null)
            url_ += "productGroupId=" + encodeURIComponent("" + productGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfForFinishedOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfForFinishedOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdfForFinishedOrders(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPdfForPlan(startTime?: Date | undefined, endTime?: Date | undefined, type?: number | null | undefined, status?: ProductionOrderStatus | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetPdfForPlan?";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfForPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfForPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdfForPlan(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param includeBaskets (optional) 
     * @param productGroupId (optional) 
     */
    getFinishedForOrders(startTime?: Date | undefined, endTime?: Date | undefined, includeBaskets?: boolean | null | undefined, productGroupId?: string | null | undefined): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetFinishedForOrders?";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (includeBaskets !== undefined && includeBaskets !== null)
            url_ += "includeBaskets=" + encodeURIComponent("" + includeBaskets) + "&";
        if (productGroupId !== undefined && productGroupId !== null)
            url_ += "productGroupId=" + encodeURIComponent("" + productGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinishedForOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinishedForOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetFinishedForOrders(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkCreateFinishedProductionOrders(model: ProductionOrderBulkChangeModel): Observable<ProductionOrderModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/BulkCreateFinishedProductionOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkCreateFinishedProductionOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkCreateFinishedProductionOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel[]>;
        }));
    }

    protected processBulkCreateFinishedProductionOrders(response: HttpResponseBase): Observable<ProductionOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all child production orders for production order
     * @param id (optional) 
     */
    getChildren(id?: string | undefined): Observable<ProductionOrderModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/GetChildren?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChildren(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChildren(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel[]>;
        }));
    }

    protected processGetChildren(response: HttpResponseBase): Observable<ProductionOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete production order
     * @param id (optional) 
     */
    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductionOrder/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pick products for production order
     * @param id (optional) 
     */
    pickOrder(id?: string | undefined): Observable<ProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/PickOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPickOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPickOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel>;
        }));
    }

    protected processPickOrder(response: HttpResponseBase): Observable<ProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleOrder(id?: string | undefined): Observable<ProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/ScheduleOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel>;
        }));
    }

    protected processScheduleOrder(response: HttpResponseBase): Observable<ProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    planOrder(model: AllocateOrderModel): Observable<ResourceAllocationModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/PlanOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlanOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlanOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceAllocationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceAllocationModel[]>;
        }));
    }

    protected processPlanOrder(response: HttpResponseBase): Observable<ResourceAllocationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceAllocationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reserveOrder(id?: string | undefined): Observable<ProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/ReserveOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReserveOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReserveOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel>;
        }));
    }

    protected processReserveOrder(response: HttpResponseBase): Observable<ProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    duplicateOrder(model: ProductionOrderModel): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductionOrder/DuplicateOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDuplicateOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    estimateOrder(id?: string | undefined): Observable<ProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/EstimateOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel>;
        }));
    }

    protected processEstimateOrder(response: HttpResponseBase): Observable<ProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetOrder(id?: string | undefined): Observable<ProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/ResetOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel>;
        }));
    }

    protected processResetOrder(response: HttpResponseBase): Observable<ProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bookOrder(id?: string | undefined): Observable<ProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/BookOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel>;
        }));
    }

    protected processBookOrder(response: HttpResponseBase): Observable<ProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleAllOpenOrders(): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductionOrder/ScheduleAllOpenOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleAllOpenOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleAllOpenOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleAllOpenOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateByOutput(productVariantId?: string | undefined, quantity?: number | undefined, unit?: string | null | undefined, finishTime?: Date | null | undefined): Observable<ProductionOrderModel[]> {
        let url_ = this.baseUrl + "/api/ProductionOrder/CalculateByOutput?";
        if (productVariantId === null)
            throw new globalThis.Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (quantity === null)
            throw new globalThis.Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (unit !== undefined && unit !== null)
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        if (finishTime !== undefined && finishTime !== null)
            url_ += "finishTime=" + encodeURIComponent(finishTime ? "" + finishTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateByOutput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateByOutput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel[]>;
        }));
    }

    protected processCalculateByOutput(response: HttpResponseBase): Observable<ProductionOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fillLotNumbers(orders: ProductionOrderModel[]): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductionOrder/FillLotNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orders);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFillLotNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFillLotNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFillLotNumbers(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fillLotNumberForIngredient(model: FillLotModel): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductionOrder/FillLotNumberForIngredient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFillLotNumberForIngredient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFillLotNumberForIngredient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFillLotNumberForIngredient(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update production order
     */
    post(model: ProductionOrderModel): Observable<ProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update production order
     */
    startProduction(model: ProductionOrderModel): Observable<ProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/StartProduction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartProduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartProduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel>;
        }));
    }

    protected processStartProduction(response: HttpResponseBase): Observable<ProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update production order
     */
    finishProduction(model: ProductionOrderModel): Observable<ProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/FinishProduction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishProduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishProduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel>;
        }));
    }

    protected processFinishProduction(response: HttpResponseBase): Observable<ProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update production order
     */
    editStartTime(model: ProductionOrderModel): Observable<ProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/EditStartTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditStartTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditStartTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionOrderModel>;
        }));
    }

    protected processEditStartTime(response: HttpResponseBase): Observable<ProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update production orderline
     */
    updateOrderline(model: ProductionOrderlineModel): Observable<OrderlineModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/UpdateOrderline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderlineModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderlineModel>;
        }));
    }

    protected processUpdateOrderline(response: HttpResponseBase): Observable<OrderlineModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderlineModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all production orders for User
     */
    checkAll(): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductionOrder/CheckAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckAll(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkProductionOrder(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductionOrder/CheckProductionOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckProductionOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckProductionOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckProductionOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPlanningData(): Observable<ProductionPlannerModel> {
        let url_ = this.baseUrl + "/api/ProductionOrder/ExportPlanningData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPlanningData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPlanningData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionPlannerModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionPlannerModel>;
        }));
    }

    protected processExportPlanningData(response: HttpResponseBase): Observable<ProductionPlannerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionPlannerModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importPlanningData(model: ProductionPlannerModel): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductionOrder/ImportPlanningData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPlanningData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPlanningData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportPlanningData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fixFinishedProductionOrderOrderlines(): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductionOrder/FixFinishedProductionOrderOrderlines";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixFinishedProductionOrderOrderlines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixFinishedProductionOrderOrderlines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFixFinishedProductionOrderOrderlines(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProductionShiftService {
    getShifts(productionOrderId?: string | undefined): Observable<ProductionShiftModel[]>;
    /**
     * Add or update RiskAnalysis
     */
    post(model: ProductionShiftModel): Observable<ProductionShiftModel>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductionShiftService implements IProductionShiftService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getShifts(productionOrderId?: string | undefined): Observable<ProductionShiftModel[]> {
        let url_ = this.baseUrl + "/api/ProductionShift/GetShifts?";
        if (productionOrderId === null)
            throw new globalThis.Error("The parameter 'productionOrderId' cannot be null.");
        else if (productionOrderId !== undefined)
            url_ += "productionOrderId=" + encodeURIComponent("" + productionOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionShiftModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionShiftModel[]>;
        }));
    }

    protected processGetShifts(response: HttpResponseBase): Observable<ProductionShiftModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionShiftModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    post(model: ProductionShiftModel): Observable<ProductionShiftModel> {
        let url_ = this.baseUrl + "/api/ProductionShift/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductionShiftModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductionShiftModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ProductionShiftModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductionShiftModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProductVariantService {
    bulkChangeLabel(model: BulkChangeModel): Observable<string>;
    bulkChangeLogo(model: BulkChangeModel): Observable<string>;
    /**
     * Get ProductVariants
     * @param id (optional) 
     * @return ProductVariant
     */
    get(id?: string | undefined): Observable<ProductVariantModel>;
    getAll(): Observable<ProductVariantModel[]>;
    /**
     * Get ProductVariants
     * @param id (optional) 
     * @return ProductVariant
     */
    getFromGS1(id?: string | undefined): Observable<string>;
    /**
     * Get ProductVariants
     * @param id (optional) 
     * @return ProductVariant
     */
    exportToGS1(id?: string | undefined): Observable<EdiResponseOfString>;
    /**
     * Get ProductVariants
     * @param barcode (optional) 
     * @return ProductVariant
     */
    getByBarcode(barcode?: string | null | undefined): Observable<ProductVariantModel>;
    /**
     * Get ProductVariants by Product
     * @param productId (optional) 
     * @param includeDeleted (optional) 
     * @return ProductVariant
     */
    getByProduct(productId?: string | undefined, includeDeleted?: boolean | undefined): Observable<ProductVariantModel[]>;
    /**
     * Get ProductVariant by LotId
     * @param lotId (optional) 
     * @return ProductVariantModel
     */
    getByLotId(lotId?: string | undefined): Observable<ProductVariantModel>;
    /**
     * Get ProductVariants by Product
     * @param productId (optional) 
     * @return ProductVariant
     */
    getByProductBundle(productId?: string | undefined): Observable<ProductVariantModel[]>;
    /**
     * Add or update a ProductVariant
     * @return ProductVariant after update
     */
    post(model: ProductVariantModel): Observable<ProductVariantModel>;
    /**
     * Get all Products
     * @param searchText (optional) 
     * @param sourceType (optional) 
     */
    searchFoodComp(searchText?: string | null | undefined, sourceType?: string | null | undefined): Observable<NutritionDataModel[]>;
    /**
     * Get all Products
     * @param productId (optional) 
     * @param itemId (optional) 
     * @param sourceType (optional) 
     */
    updateNutritionFromFoodComp(productId?: string | undefined, itemId?: string | null | undefined, sourceType?: string | null | undefined): Observable<NutritionModel>;
    getNutritionData(id?: string | undefined, nutritionQuantity?: number | undefined): Observable<NutritionModel>;
    calculateEnergy(model: NutritionModel): Observable<NutritionModel>;
    getCharacteristics(id?: string | undefined): Observable<CharacteristicsModel>;
    postNutritionData(model: NutritionModel): Observable<NutritionModel>;
    postCharacteristics(model: CharacteristicsModel): Observable<CharacteristicsModel>;
    getProductDescription(id?: string | undefined, language?: string | null | undefined): Observable<ProductDescriptionModel>;
    postProductDescription(model: ProductDescriptionModel): Observable<ProductDescriptionModel>;
    getAllergens(id?: string | undefined): Observable<AllergensModel>;
    getClaims(id?: string | undefined): Observable<ClaimsModel>;
    postAllergens(model: AllergensModel): Observable<AllergensModel>;
    postClaims(model: ClaimsModel): Observable<ClaimsModel>;
    unDelete(id?: string | undefined): Observable<string>;
    /**
     * Delete product variant
     * @param id (optional) 
     */
    delete(id?: string | undefined): Observable<string>;
    /**
     * Get files
     * @param id (optional) 
     * @param showInput (optional) 
     * @param showOutput (optional) 
     */
    getRecipes(id?: string | undefined, showInput?: boolean | undefined, showOutput?: boolean | undefined): Observable<RecipeModel[]>;
    /**
     * Get files
     * @param id (optional) 
     */
    getFiles(id?: string | undefined): Observable<CollectionModel[]>;
    /**
     * Get suppliers
     * @param id (optional) 
     */
    getSuppliers(id?: string | undefined): Observable<ProductVariantSupplierModel[]>;
    deleteFile(id?: string | undefined): Observable<FileResponse>;
    uploadFile(): Observable<FileResponse>;
    updateDatasheets(model: GetDatasheetsModel): Observable<string>;
    getCaseLabels(model: LabelInfoModel[]): Observable<FileResponse>;
    getDatasheet(type?: string | null | undefined, id?: string | undefined, language?: string | null | undefined, date?: Date | null | undefined, productionDate?: Date | null | undefined, labelId?: string | null | undefined, batch?: string | null | undefined): Observable<FileResponse>;
    getDatasheets(model: GetDatasheetsModel): Observable<FileResponse>;
    getExpirationDate(variantId?: string | undefined, productionDate?: Date | undefined): Observable<Date>;
    getDatasheetTypeByGroup(id?: string | undefined): Observable<DatasheetModel[]>;
    getDatasheetsByGroup(type?: string | null | undefined, id?: string | undefined, language?: string | null | undefined, template?: string | null | undefined): Observable<string>;
    splitVariantIntoNewProduct(productVariantId?: string | undefined): Observable<ProductVariantModel>;
    moveLot(lotId?: string | undefined, productVariantId?: string | undefined): Observable<string>;
    mergeLots(lotId?: string | undefined, otherLotId?: string | undefined): Observable<string>;
    refreshDatasheetsByGroup(id?: string | undefined): Observable<string>;
    getEquivalentProductVariants(id?: string | undefined): Observable<ProductVariantModel[]>;
    addEquivalentProductVariant(id?: string | undefined, alternativeId?: string | undefined): Observable<ProductVariantModel[]>;
    addSupplier(model: ProductVariantSupplierModel): Observable<ProductVariantModel[]>;
    removeSupplier(id?: string | undefined): Observable<ProductVariantModel[]>;
    removeEquivalentProductVariant(id?: string | undefined, alternativeId?: string | undefined): Observable<ProductVariantModel[]>;
    fixFiles(): Observable<string>;
    fixMissingSkus(organizationId?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductVariantService implements IProductVariantService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    bulkChangeLabel(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductVariant/BulkChangeLabel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeLabel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkChangeLogo(model: BulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductVariant/BulkChangeLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeLogo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ProductVariants
     * @param id (optional) 
     * @return ProductVariant
     */
    get(id?: string | undefined): Observable<ProductVariantModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductVariantModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductVariantModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<ProductVariantModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProductVariantModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductVariantModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ProductVariants
     * @param id (optional) 
     * @return ProductVariant
     */
    getFromGS1(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetFromGS1?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromGS1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromGS1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFromGS1(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ProductVariants
     * @param id (optional) 
     * @return ProductVariant
     */
    exportToGS1(id?: string | undefined): Observable<EdiResponseOfString> {
        let url_ = this.baseUrl + "/api/ProductVariant/ExportToGS1?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportToGS1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToGS1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EdiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EdiResponseOfString>;
        }));
    }

    protected processExportToGS1(response: HttpResponseBase): Observable<EdiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EdiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ProductVariants
     * @param barcode (optional) 
     * @return ProductVariant
     */
    getByBarcode(barcode?: string | null | undefined): Observable<ProductVariantModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetByBarcode?";
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByBarcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByBarcode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel>;
        }));
    }

    protected processGetByBarcode(response: HttpResponseBase): Observable<ProductVariantModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductVariantModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ProductVariants by Product
     * @param productId (optional) 
     * @param includeDeleted (optional) 
     * @return ProductVariant
     */
    getByProduct(productId?: string | undefined, includeDeleted?: boolean | undefined): Observable<ProductVariantModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetByProduct?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel[]>;
        }));
    }

    protected processGetByProduct(response: HttpResponseBase): Observable<ProductVariantModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductVariantModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ProductVariant by LotId
     * @param lotId (optional) 
     * @return ProductVariantModel
     */
    getByLotId(lotId?: string | undefined): Observable<ProductVariantModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetByLotId?";
        if (lotId === null)
            throw new globalThis.Error("The parameter 'lotId' cannot be null.");
        else if (lotId !== undefined)
            url_ += "lotId=" + encodeURIComponent("" + lotId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByLotId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByLotId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel>;
        }));
    }

    protected processGetByLotId(response: HttpResponseBase): Observable<ProductVariantModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductVariantModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ProductVariants by Product
     * @param productId (optional) 
     * @return ProductVariant
     */
    getByProductBundle(productId?: string | undefined): Observable<ProductVariantModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetByProductBundle?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductBundle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductBundle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel[]>;
        }));
    }

    protected processGetByProductBundle(response: HttpResponseBase): Observable<ProductVariantModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductVariantModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update a ProductVariant
     * @return ProductVariant after update
     */
    post(model: ProductVariantModel): Observable<ProductVariantModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ProductVariantModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductVariantModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Products
     * @param searchText (optional) 
     * @param sourceType (optional) 
     */
    searchFoodComp(searchText?: string | null | undefined, sourceType?: string | null | undefined): Observable<NutritionDataModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/SearchFoodComp?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (sourceType !== undefined && sourceType !== null)
            url_ += "sourceType=" + encodeURIComponent("" + sourceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFoodComp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFoodComp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionDataModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionDataModel[]>;
        }));
    }

    protected processSearchFoodComp(response: HttpResponseBase): Observable<NutritionDataModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NutritionDataModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Products
     * @param productId (optional) 
     * @param itemId (optional) 
     * @param sourceType (optional) 
     */
    updateNutritionFromFoodComp(productId?: string | undefined, itemId?: string | null | undefined, sourceType?: string | null | undefined): Observable<NutritionModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/UpdateNutritionFromFoodComp?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (sourceType !== undefined && sourceType !== null)
            url_ += "sourceType=" + encodeURIComponent("" + sourceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNutritionFromFoodComp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNutritionFromFoodComp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionModel>;
        }));
    }

    protected processUpdateNutritionFromFoodComp(response: HttpResponseBase): Observable<NutritionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NutritionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNutritionData(id?: string | undefined, nutritionQuantity?: number | undefined): Observable<NutritionModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetNutritionData?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (nutritionQuantity === null)
            throw new globalThis.Error("The parameter 'nutritionQuantity' cannot be null.");
        else if (nutritionQuantity !== undefined)
            url_ += "nutritionQuantity=" + encodeURIComponent("" + nutritionQuantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutritionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutritionData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionModel>;
        }));
    }

    protected processGetNutritionData(response: HttpResponseBase): Observable<NutritionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NutritionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateEnergy(model: NutritionModel): Observable<NutritionModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/CalculateEnergy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateEnergy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateEnergy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionModel>;
        }));
    }

    protected processCalculateEnergy(response: HttpResponseBase): Observable<NutritionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NutritionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCharacteristics(id?: string | undefined): Observable<CharacteristicsModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetCharacteristics?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCharacteristics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCharacteristics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CharacteristicsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CharacteristicsModel>;
        }));
    }

    protected processGetCharacteristics(response: HttpResponseBase): Observable<CharacteristicsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CharacteristicsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postNutritionData(model: NutritionModel): Observable<NutritionModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/PostNutritionData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostNutritionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostNutritionData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionModel>;
        }));
    }

    protected processPostNutritionData(response: HttpResponseBase): Observable<NutritionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NutritionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postCharacteristics(model: CharacteristicsModel): Observable<CharacteristicsModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/PostCharacteristics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCharacteristics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCharacteristics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CharacteristicsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CharacteristicsModel>;
        }));
    }

    protected processPostCharacteristics(response: HttpResponseBase): Observable<CharacteristicsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CharacteristicsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProductDescription(id?: string | undefined, language?: string | null | undefined): Observable<ProductDescriptionModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetProductDescription?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDescriptionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDescriptionModel>;
        }));
    }

    protected processGetProductDescription(response: HttpResponseBase): Observable<ProductDescriptionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDescriptionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postProductDescription(model: ProductDescriptionModel): Observable<ProductDescriptionModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/PostProductDescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostProductDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostProductDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDescriptionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDescriptionModel>;
        }));
    }

    protected processPostProductDescription(response: HttpResponseBase): Observable<ProductDescriptionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDescriptionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllergens(id?: string | undefined): Observable<AllergensModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetAllergens?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllergens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllergens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllergensModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllergensModel>;
        }));
    }

    protected processGetAllergens(response: HttpResponseBase): Observable<AllergensModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllergensModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClaims(id?: string | undefined): Observable<ClaimsModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetClaims?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimsModel>;
        }));
    }

    protected processGetClaims(response: HttpResponseBase): Observable<ClaimsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postAllergens(model: AllergensModel): Observable<AllergensModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/PostAllergens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAllergens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAllergens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllergensModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllergensModel>;
        }));
    }

    protected processPostAllergens(response: HttpResponseBase): Observable<AllergensModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllergensModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postClaims(model: ClaimsModel): Observable<ClaimsModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/PostClaims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimsModel>;
        }));
    }

    protected processPostClaims(response: HttpResponseBase): Observable<ClaimsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unDelete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductVariant/UnDelete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUnDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete product variant
     * @param id (optional) 
     */
    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductVariant/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get files
     * @param id (optional) 
     * @param showInput (optional) 
     * @param showOutput (optional) 
     */
    getRecipes(id?: string | undefined, showInput?: boolean | undefined, showOutput?: boolean | undefined): Observable<RecipeModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetRecipes?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (showInput === null)
            throw new globalThis.Error("The parameter 'showInput' cannot be null.");
        else if (showInput !== undefined)
            url_ += "showInput=" + encodeURIComponent("" + showInput) + "&";
        if (showOutput === null)
            throw new globalThis.Error("The parameter 'showOutput' cannot be null.");
        else if (showOutput !== undefined)
            url_ += "showOutput=" + encodeURIComponent("" + showOutput) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecipes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecipes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel[]>;
        }));
    }

    protected processGetRecipes(response: HttpResponseBase): Observable<RecipeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get files
     * @param id (optional) 
     */
    getFiles(id?: string | undefined): Observable<CollectionModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetFiles?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectionModel[]>;
        }));
    }

    protected processGetFiles(response: HttpResponseBase): Observable<CollectionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CollectionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get suppliers
     * @param id (optional) 
     */
    getSuppliers(id?: string | undefined): Observable<ProductVariantSupplierModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetSuppliers?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuppliers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantSupplierModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantSupplierModel[]>;
        }));
    }

    protected processGetSuppliers(response: HttpResponseBase): Observable<ProductVariantSupplierModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductVariantSupplierModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFile(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ProductVariant/DeleteFile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadFile(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ProductVariant/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDatasheets(model: GetDatasheetsModel): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductVariant/UpdateDatasheets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDatasheets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDatasheets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateDatasheets(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCaseLabels(model: LabelInfoModel[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetCaseLabels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCaseLabels(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDatasheet(type?: string | null | undefined, id?: string | undefined, language?: string | null | undefined, date?: Date | null | undefined, productionDate?: Date | null | undefined, labelId?: string | null | undefined, batch?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetDatasheet?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (productionDate !== undefined && productionDate !== null)
            url_ += "productionDate=" + encodeURIComponent(productionDate ? "" + productionDate.toISOString() : "") + "&";
        if (labelId !== undefined && labelId !== null)
            url_ += "labelId=" + encodeURIComponent("" + labelId) + "&";
        if (batch !== undefined && batch !== null)
            url_ += "batch=" + encodeURIComponent("" + batch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatasheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatasheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDatasheet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDatasheets(model: GetDatasheetsModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetDatasheets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatasheets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatasheets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDatasheets(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExpirationDate(variantId?: string | undefined, productionDate?: Date | undefined): Observable<Date> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetExpirationDate?";
        if (variantId === null)
            throw new globalThis.Error("The parameter 'variantId' cannot be null.");
        else if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&";
        if (productionDate === null)
            throw new globalThis.Error("The parameter 'productionDate' cannot be null.");
        else if (productionDate !== undefined)
            url_ += "productionDate=" + encodeURIComponent(productionDate ? "" + productionDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpirationDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpirationDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date>;
        }));
    }

    protected processGetExpirationDate(response: HttpResponseBase): Observable<Date> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDatasheetTypeByGroup(id?: string | undefined): Observable<DatasheetModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetDatasheetTypeByGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatasheetTypeByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatasheetTypeByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DatasheetModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DatasheetModel[]>;
        }));
    }

    protected processGetDatasheetTypeByGroup(response: HttpResponseBase): Observable<DatasheetModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DatasheetModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDatasheetsByGroup(type?: string | null | undefined, id?: string | undefined, language?: string | null | undefined, template?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetDatasheetsByGroup?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (template !== undefined && template !== null)
            url_ += "template=" + encodeURIComponent("" + template) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatasheetsByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatasheetsByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDatasheetsByGroup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    splitVariantIntoNewProduct(productVariantId?: string | undefined): Observable<ProductVariantModel> {
        let url_ = this.baseUrl + "/api/ProductVariant/SplitVariantIntoNewProduct?";
        if (productVariantId === null)
            throw new globalThis.Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSplitVariantIntoNewProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSplitVariantIntoNewProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel>;
        }));
    }

    protected processSplitVariantIntoNewProduct(response: HttpResponseBase): Observable<ProductVariantModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductVariantModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveLot(lotId?: string | undefined, productVariantId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductVariant/MoveLot?";
        if (lotId === null)
            throw new globalThis.Error("The parameter 'lotId' cannot be null.");
        else if (lotId !== undefined)
            url_ += "lotId=" + encodeURIComponent("" + lotId) + "&";
        if (productVariantId === null)
            throw new globalThis.Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveLot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveLot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMoveLot(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mergeLots(lotId?: string | undefined, otherLotId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductVariant/MergeLots?";
        if (lotId === null)
            throw new globalThis.Error("The parameter 'lotId' cannot be null.");
        else if (lotId !== undefined)
            url_ += "lotId=" + encodeURIComponent("" + lotId) + "&";
        if (otherLotId === null)
            throw new globalThis.Error("The parameter 'otherLotId' cannot be null.");
        else if (otherLotId !== undefined)
            url_ += "otherLotId=" + encodeURIComponent("" + otherLotId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMergeLots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMergeLots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMergeLots(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshDatasheetsByGroup(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductVariant/RefreshDatasheetsByGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshDatasheetsByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshDatasheetsByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRefreshDatasheetsByGroup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEquivalentProductVariants(id?: string | undefined): Observable<ProductVariantModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/GetEquivalentProductVariants?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEquivalentProductVariants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEquivalentProductVariants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel[]>;
        }));
    }

    protected processGetEquivalentProductVariants(response: HttpResponseBase): Observable<ProductVariantModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductVariantModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addEquivalentProductVariant(id?: string | undefined, alternativeId?: string | undefined): Observable<ProductVariantModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/AddEquivalentProductVariant?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (alternativeId === null)
            throw new globalThis.Error("The parameter 'alternativeId' cannot be null.");
        else if (alternativeId !== undefined)
            url_ += "alternativeId=" + encodeURIComponent("" + alternativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEquivalentProductVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEquivalentProductVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel[]>;
        }));
    }

    protected processAddEquivalentProductVariant(response: HttpResponseBase): Observable<ProductVariantModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductVariantModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addSupplier(model: ProductVariantSupplierModel): Observable<ProductVariantModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/AddSupplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel[]>;
        }));
    }

    protected processAddSupplier(response: HttpResponseBase): Observable<ProductVariantModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductVariantModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeSupplier(id?: string | undefined): Observable<ProductVariantModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/RemoveSupplier?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel[]>;
        }));
    }

    protected processRemoveSupplier(response: HttpResponseBase): Observable<ProductVariantModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductVariantModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeEquivalentProductVariant(id?: string | undefined, alternativeId?: string | undefined): Observable<ProductVariantModel[]> {
        let url_ = this.baseUrl + "/api/ProductVariant/RemoveEquivalentProductVariant?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (alternativeId === null)
            throw new globalThis.Error("The parameter 'alternativeId' cannot be null.");
        else if (alternativeId !== undefined)
            url_ += "alternativeId=" + encodeURIComponent("" + alternativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveEquivalentProductVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveEquivalentProductVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductVariantModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductVariantModel[]>;
        }));
    }

    protected processRemoveEquivalentProductVariant(response: HttpResponseBase): Observable<ProductVariantModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductVariantModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fixFiles(): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductVariant/FixFiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFixFiles(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fixMissingSkus(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ProductVariant/FixMissingSkus?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixMissingSkus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixMissingSkus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFixMissingSkus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPropertyService {
    getOrganizationPropertyDataByAlias(alias?: string | null | undefined): Observable<PropertyDataModel>;
    getPropertyGroupData(id?: string | undefined): Observable<PropertyGroupDataModel>;
    getPropertyGroupDataByAlias(alias?: string | null | undefined): Observable<PropertyGroupDataModel[]>;
    getPropertyGroupDataByAliasAndEntity(alias?: string | null | undefined, entityId?: string | undefined): Observable<PropertyGroupDataModel>;
    getPropertyGroupDataByName(name?: string | null | undefined): Observable<PropertyGroupDataModel>;
    getPropertyDataByAlias(alias?: string | null | undefined, groupAlias?: string | null | undefined): Observable<PropertyDataModel[]>;
    getPropertyGroups(includeGlobal?: boolean | undefined): Observable<PropertyTypeGroupModel[]>;
    getPropertyGroup(alias?: string | null | undefined, includeGlobal?: boolean | undefined): Observable<PropertyTypeGroupModel>;
    getPropertyGroupById(id?: string | undefined, includeGlobal?: boolean | undefined): Observable<PropertyTypeGroupModel>;
    postPropertyGroupData(model: PropertyGroupDataModel): Observable<PropertyGroupDataModel>;
    getOptionsByPropertyValueType(type?: PropertyValueType | undefined): Observable<IdNameModel[]>;
    postPropertyType(model: PropertyTypeModel): Observable<PropertyTypeModel>;
    postPropertyTypeGroup(model: PropertyTypeGroupModel): Observable<PropertyTypeGroupModel>;
    deletePropertyType(id?: string | undefined): Observable<string>;
    deletePropertyTypeGroup(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class PropertyService implements IPropertyService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getOrganizationPropertyDataByAlias(alias?: string | null | undefined): Observable<PropertyDataModel> {
        let url_ = this.baseUrl + "/api/Property/GetOrganizationPropertyDataByAlias?";
        if (alias !== undefined && alias !== null)
            url_ += "alias=" + encodeURIComponent("" + alias) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationPropertyDataByAlias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationPropertyDataByAlias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyDataModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyDataModel>;
        }));
    }

    protected processGetOrganizationPropertyDataByAlias(response: HttpResponseBase): Observable<PropertyDataModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDataModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPropertyGroupData(id?: string | undefined): Observable<PropertyGroupDataModel> {
        let url_ = this.baseUrl + "/api/Property/GetPropertyGroupData?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyGroupDataModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyGroupDataModel>;
        }));
    }

    protected processGetPropertyGroupData(response: HttpResponseBase): Observable<PropertyGroupDataModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyGroupDataModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPropertyGroupDataByAlias(alias?: string | null | undefined): Observable<PropertyGroupDataModel[]> {
        let url_ = this.baseUrl + "/api/Property/GetPropertyGroupDataByAlias?";
        if (alias !== undefined && alias !== null)
            url_ += "alias=" + encodeURIComponent("" + alias) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyGroupDataByAlias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyGroupDataByAlias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyGroupDataModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyGroupDataModel[]>;
        }));
    }

    protected processGetPropertyGroupDataByAlias(response: HttpResponseBase): Observable<PropertyGroupDataModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyGroupDataModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPropertyGroupDataByAliasAndEntity(alias?: string | null | undefined, entityId?: string | undefined): Observable<PropertyGroupDataModel> {
        let url_ = this.baseUrl + "/api/Property/GetPropertyGroupDataByAliasAndEntity?";
        if (alias !== undefined && alias !== null)
            url_ += "alias=" + encodeURIComponent("" + alias) + "&";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyGroupDataByAliasAndEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyGroupDataByAliasAndEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyGroupDataModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyGroupDataModel>;
        }));
    }

    protected processGetPropertyGroupDataByAliasAndEntity(response: HttpResponseBase): Observable<PropertyGroupDataModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyGroupDataModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPropertyGroupDataByName(name?: string | null | undefined): Observable<PropertyGroupDataModel> {
        let url_ = this.baseUrl + "/api/Property/GetPropertyGroupDataByName?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyGroupDataByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyGroupDataByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyGroupDataModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyGroupDataModel>;
        }));
    }

    protected processGetPropertyGroupDataByName(response: HttpResponseBase): Observable<PropertyGroupDataModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyGroupDataModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPropertyDataByAlias(alias?: string | null | undefined, groupAlias?: string | null | undefined): Observable<PropertyDataModel[]> {
        let url_ = this.baseUrl + "/api/Property/GetPropertyDataByAlias?";
        if (alias !== undefined && alias !== null)
            url_ += "alias=" + encodeURIComponent("" + alias) + "&";
        if (groupAlias !== undefined && groupAlias !== null)
            url_ += "groupAlias=" + encodeURIComponent("" + groupAlias) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyDataByAlias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyDataByAlias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyDataModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyDataModel[]>;
        }));
    }

    protected processGetPropertyDataByAlias(response: HttpResponseBase): Observable<PropertyDataModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyDataModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPropertyGroups(includeGlobal?: boolean | undefined): Observable<PropertyTypeGroupModel[]> {
        let url_ = this.baseUrl + "/api/Property/GetPropertyGroups?";
        if (includeGlobal === null)
            throw new globalThis.Error("The parameter 'includeGlobal' cannot be null.");
        else if (includeGlobal !== undefined)
            url_ += "includeGlobal=" + encodeURIComponent("" + includeGlobal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyTypeGroupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyTypeGroupModel[]>;
        }));
    }

    protected processGetPropertyGroups(response: HttpResponseBase): Observable<PropertyTypeGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyTypeGroupModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPropertyGroup(alias?: string | null | undefined, includeGlobal?: boolean | undefined): Observable<PropertyTypeGroupModel> {
        let url_ = this.baseUrl + "/api/Property/GetPropertyGroup?";
        if (alias !== undefined && alias !== null)
            url_ += "alias=" + encodeURIComponent("" + alias) + "&";
        if (includeGlobal === null)
            throw new globalThis.Error("The parameter 'includeGlobal' cannot be null.");
        else if (includeGlobal !== undefined)
            url_ += "includeGlobal=" + encodeURIComponent("" + includeGlobal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyTypeGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyTypeGroupModel>;
        }));
    }

    protected processGetPropertyGroup(response: HttpResponseBase): Observable<PropertyTypeGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyTypeGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPropertyGroupById(id?: string | undefined, includeGlobal?: boolean | undefined): Observable<PropertyTypeGroupModel> {
        let url_ = this.baseUrl + "/api/Property/GetPropertyGroupById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (includeGlobal === null)
            throw new globalThis.Error("The parameter 'includeGlobal' cannot be null.");
        else if (includeGlobal !== undefined)
            url_ += "includeGlobal=" + encodeURIComponent("" + includeGlobal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyGroupById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyGroupById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyTypeGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyTypeGroupModel>;
        }));
    }

    protected processGetPropertyGroupById(response: HttpResponseBase): Observable<PropertyTypeGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyTypeGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postPropertyGroupData(model: PropertyGroupDataModel): Observable<PropertyGroupDataModel> {
        let url_ = this.baseUrl + "/api/Property/PostPropertyGroupData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPropertyGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPropertyGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyGroupDataModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyGroupDataModel>;
        }));
    }

    protected processPostPropertyGroupData(response: HttpResponseBase): Observable<PropertyGroupDataModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyGroupDataModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOptionsByPropertyValueType(type?: PropertyValueType | undefined): Observable<IdNameModel[]> {
        let url_ = this.baseUrl + "/api/Property/GetOptionsByPropertyValueType?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOptionsByPropertyValueType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOptionsByPropertyValueType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdNameModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdNameModel[]>;
        }));
    }

    protected processGetOptionsByPropertyValueType(response: HttpResponseBase): Observable<IdNameModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdNameModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postPropertyType(model: PropertyTypeModel): Observable<PropertyTypeModel> {
        let url_ = this.baseUrl + "/api/Property/PostPropertyType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPropertyType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPropertyType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyTypeModel>;
        }));
    }

    protected processPostPropertyType(response: HttpResponseBase): Observable<PropertyTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postPropertyTypeGroup(model: PropertyTypeGroupModel): Observable<PropertyTypeGroupModel> {
        let url_ = this.baseUrl + "/api/Property/PostPropertyTypeGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPropertyTypeGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPropertyTypeGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyTypeGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyTypeGroupModel>;
        }));
    }

    protected processPostPropertyTypeGroup(response: HttpResponseBase): Observable<PropertyTypeGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyTypeGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePropertyType(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Property/DeletePropertyType?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePropertyType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePropertyType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeletePropertyType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePropertyTypeGroup(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Property/DeletePropertyTypeGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePropertyTypeGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePropertyTypeGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeletePropertyTypeGroup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRecipeService {
    /**
     * Get Recipe
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<RecipeModel>;
    /**
     * Get all Products
     */
    getAllPaged(query: PagedQuery): Observable<PagedResultOfRecipeModel>;
    /**
     * Get all Products
     * @param searchText (optional) 
     * @param type (optional) 
     * @param onlyApproved (optional) 
     */
    searchRecipes(searchText?: string | null | undefined, type?: number | undefined, onlyApproved?: boolean | undefined): Observable<RecipeModel[]>;
    /**
     * Get all Recipes
     * @param includeChildren (optional) 
     * @param onlyLatest (optional) 
     */
    getAll(includeChildren?: boolean | undefined, onlyLatest?: boolean | undefined): Observable<RecipeModel[]>;
    /**
     * Get all child recipes for recipe
     * @param id (optional) 
     */
    getChildren(id?: string | undefined): Observable<RecipeModel[]>;
    /**
     * Get all recipes that produces the given product
     * @param id (optional) 
     */
    getByOutput(id?: string | undefined): Observable<RecipeModel[]>;
    /**
     * Get all recipes in the group
     * @param id (optional) 
     */
    getByGroup(id?: string | null | undefined): Observable<RecipeModel[]>;
    /**
     * Get all recipes that uses the given product
     * @param id (optional) 
     */
    getByIngredient(id?: string | undefined): Observable<RecipeModel[]>;
    /**
     * Get all recipes that uses the given product order
     * @param id (optional) 
     */
    getByProductionOrder(id?: string | undefined): Observable<RecipeModel>;
    getRecipeTree(id?: string | undefined): Observable<RecipeModel>;
    getReverseRecipeTree(id?: string | undefined): Observable<RecipeModel>;
    generateIngredientList(id?: string | undefined, collapse?: boolean | undefined, language?: string | null | undefined, includeName?: boolean | undefined): Observable<string>;
    getCalculatedQuantity(id?: string | undefined, productVariantId?: string | undefined, outputUnit?: string | null | undefined): Observable<number>;
    checkRecipe(id?: string | undefined): Observable<string>;
    checkRecipes(model: RecipeBulkModel): Observable<string>;
    /**
     * Get Recipe
     * @param id (optional) 
     * @param collapse (optional) 
     * @param language (optional) 
     */
    getNutrition(id?: string | undefined, collapse?: boolean | undefined, language?: string | null | undefined): Observable<RecipeModel>;
    /**
     * Preview Exports (Excel)
     */
    previewExcelExport(pagedQuery: PagedQuery): Observable<string[][]>;
    exportExcel(pagedQuery: PagedQuery): Observable<string>;
    previewExcelImport(filename?: string | null | undefined): Observable<string[][]>;
    /**
     * Import Suppliers
     * @param fileName (optional) 
     */
    importExcel(fileName?: string | null | undefined): Observable<string>;
    /**
     * Add or update Recipe
     */
    post(model: RecipeModel): Observable<RecipeModel>;
    /**
     * Add or update Recipe
     */
    saveIngredientsSortOrder(model: RecipeModel): Observable<boolean>;
    /**
     * Copy Recipe
     * @param id (optional) 
     * @param newVersion (optional) 
     */
    copy(id?: string | undefined, newVersion?: boolean | undefined): Observable<RecipeModel>;
    getAllIngredientsByRecipe(id?: string | undefined): Observable<RecipeIngredientsModel[]>;
    getIngredients(id?: string | undefined, collapse?: boolean | undefined, language?: string | null | undefined): Observable<RecipeIngredientsModel[]>;
    calculateAllRecipes(organizationId?: string | undefined): Observable<string>;
    setAllRecipesCalculationDirty(organizationId?: string | undefined): Observable<string>;
    calculateRecipeCost(id?: string | undefined): Observable<RecipeCalculationModel>;
    calculateRecipeCost2(id?: string | undefined, flatten?: boolean | undefined): Observable<RecipeCalculationModel>;
    bulkChangeRecipeGroup(model: RecipeBulkChangeModel): Observable<string>;
    bulkChangeProcess(model: RecipeBulkChangeModel): Observable<string>;
    bulkChangeRecipeType(model: RecipeBulkChangeModel): Observable<string>;
    bulkApproveRecipes(model: RecipeBulkChangeModel): Observable<string>;
    bulkObsoleteRecipes(model: RecipeBulkChangeModel): Observable<string>;
    bulkSetOrganic(model: RecipeBulkChangeModel): Observable<string>;
    exportRawProducts(model: RecipeBulkModel): Observable<string>;
    delete(id?: string | undefined): Observable<string>;
    fixDocTypes(): Observable<string>;
    getPdf(id?: string | undefined): Observable<FileResponse>;
    getCostCalculationReport(id?: string | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class RecipeService implements IRecipeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Recipe
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<RecipeModel> {
        let url_ = this.baseUrl + "/api/Recipe/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RecipeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Products
     */
    getAllPaged(query: PagedQuery): Observable<PagedResultOfRecipeModel> {
        let url_ = this.baseUrl + "/api/Recipe/GetAllPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfRecipeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfRecipeModel>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<PagedResultOfRecipeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfRecipeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Products
     * @param searchText (optional) 
     * @param type (optional) 
     * @param onlyApproved (optional) 
     */
    searchRecipes(searchText?: string | null | undefined, type?: number | undefined, onlyApproved?: boolean | undefined): Observable<RecipeModel[]> {
        let url_ = this.baseUrl + "/api/Recipe/SearchRecipes?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (onlyApproved === null)
            throw new globalThis.Error("The parameter 'onlyApproved' cannot be null.");
        else if (onlyApproved !== undefined)
            url_ += "onlyApproved=" + encodeURIComponent("" + onlyApproved) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchRecipes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchRecipes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel[]>;
        }));
    }

    protected processSearchRecipes(response: HttpResponseBase): Observable<RecipeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Recipes
     * @param includeChildren (optional) 
     * @param onlyLatest (optional) 
     */
    getAll(includeChildren?: boolean | undefined, onlyLatest?: boolean | undefined): Observable<RecipeModel[]> {
        let url_ = this.baseUrl + "/api/Recipe/GetAll?";
        if (includeChildren === null)
            throw new globalThis.Error("The parameter 'includeChildren' cannot be null.");
        else if (includeChildren !== undefined)
            url_ += "includeChildren=" + encodeURIComponent("" + includeChildren) + "&";
        if (onlyLatest === null)
            throw new globalThis.Error("The parameter 'onlyLatest' cannot be null.");
        else if (onlyLatest !== undefined)
            url_ += "onlyLatest=" + encodeURIComponent("" + onlyLatest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RecipeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all child recipes for recipe
     * @param id (optional) 
     */
    getChildren(id?: string | undefined): Observable<RecipeModel[]> {
        let url_ = this.baseUrl + "/api/Recipe/GetChildren?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChildren(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChildren(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel[]>;
        }));
    }

    protected processGetChildren(response: HttpResponseBase): Observable<RecipeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all recipes that produces the given product
     * @param id (optional) 
     */
    getByOutput(id?: string | undefined): Observable<RecipeModel[]> {
        let url_ = this.baseUrl + "/api/Recipe/GetByOutput?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOutput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOutput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel[]>;
        }));
    }

    protected processGetByOutput(response: HttpResponseBase): Observable<RecipeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all recipes in the group
     * @param id (optional) 
     */
    getByGroup(id?: string | null | undefined): Observable<RecipeModel[]> {
        let url_ = this.baseUrl + "/api/Recipe/GetByGroup?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel[]>;
        }));
    }

    protected processGetByGroup(response: HttpResponseBase): Observable<RecipeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all recipes that uses the given product
     * @param id (optional) 
     */
    getByIngredient(id?: string | undefined): Observable<RecipeModel[]> {
        let url_ = this.baseUrl + "/api/Recipe/GetByIngredient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByIngredient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByIngredient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel[]>;
        }));
    }

    protected processGetByIngredient(response: HttpResponseBase): Observable<RecipeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all recipes that uses the given product order
     * @param id (optional) 
     */
    getByProductionOrder(id?: string | undefined): Observable<RecipeModel> {
        let url_ = this.baseUrl + "/api/Recipe/GetByProductionOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductionOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductionOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel>;
        }));
    }

    protected processGetByProductionOrder(response: HttpResponseBase): Observable<RecipeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRecipeTree(id?: string | undefined): Observable<RecipeModel> {
        let url_ = this.baseUrl + "/api/Recipe/GetRecipeTree?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecipeTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecipeTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel>;
        }));
    }

    protected processGetRecipeTree(response: HttpResponseBase): Observable<RecipeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReverseRecipeTree(id?: string | undefined): Observable<RecipeModel> {
        let url_ = this.baseUrl + "/api/Recipe/GetReverseRecipeTree?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReverseRecipeTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReverseRecipeTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel>;
        }));
    }

    protected processGetReverseRecipeTree(response: HttpResponseBase): Observable<RecipeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateIngredientList(id?: string | undefined, collapse?: boolean | undefined, language?: string | null | undefined, includeName?: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/GenerateIngredientList?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (collapse === null)
            throw new globalThis.Error("The parameter 'collapse' cannot be null.");
        else if (collapse !== undefined)
            url_ += "collapse=" + encodeURIComponent("" + collapse) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (includeName === null)
            throw new globalThis.Error("The parameter 'includeName' cannot be null.");
        else if (includeName !== undefined)
            url_ += "includeName=" + encodeURIComponent("" + includeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateIngredientList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateIngredientList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateIngredientList(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCalculatedQuantity(id?: string | undefined, productVariantId?: string | undefined, outputUnit?: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Recipe/GetCalculatedQuantity?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (productVariantId === null)
            throw new globalThis.Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (outputUnit !== undefined && outputUnit !== null)
            url_ += "outputUnit=" + encodeURIComponent("" + outputUnit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculatedQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculatedQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCalculatedQuantity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkRecipe(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/CheckRecipe?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckRecipe(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkRecipes(model: RecipeBulkModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/CheckRecipes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckRecipes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckRecipes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckRecipes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Recipe
     * @param id (optional) 
     * @param collapse (optional) 
     * @param language (optional) 
     */
    getNutrition(id?: string | undefined, collapse?: boolean | undefined, language?: string | null | undefined): Observable<RecipeModel> {
        let url_ = this.baseUrl + "/api/Recipe/GetNutrition?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (collapse === null)
            throw new globalThis.Error("The parameter 'collapse' cannot be null.");
        else if (collapse !== undefined)
            url_ += "collapse=" + encodeURIComponent("" + collapse) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutrition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutrition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel>;
        }));
    }

    protected processGetNutrition(response: HttpResponseBase): Observable<RecipeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Preview Exports (Excel)
     */
    previewExcelExport(pagedQuery: PagedQuery): Observable<string[][]> {
        let url_ = this.baseUrl + "/api/Recipe/PreviewExcelExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewExcelExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewExcelExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[][]>;
        }));
    }

    protected processPreviewExcelExport(response: HttpResponseBase): Observable<string[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportExcel(pagedQuery: PagedQuery): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/ExportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    previewExcelImport(filename?: string | null | undefined): Observable<string[][]> {
        let url_ = this.baseUrl + "/api/Recipe/PreviewExcelImport?";
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewExcelImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewExcelImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[][]>;
        }));
    }

    protected processPreviewExcelImport(response: HttpResponseBase): Observable<string[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Import Suppliers
     * @param fileName (optional) 
     */
    importExcel(fileName?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/ImportExcel?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Recipe
     */
    post(model: RecipeModel): Observable<RecipeModel> {
        let url_ = this.baseUrl + "/api/Recipe/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<RecipeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Recipe
     */
    saveIngredientsSortOrder(model: RecipeModel): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Recipe/SaveIngredientsSortOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveIngredientsSortOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveIngredientsSortOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveIngredientsSortOrder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Copy Recipe
     * @param id (optional) 
     * @param newVersion (optional) 
     */
    copy(id?: string | undefined, newVersion?: boolean | undefined): Observable<RecipeModel> {
        let url_ = this.baseUrl + "/api/Recipe/Copy?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (newVersion === null)
            throw new globalThis.Error("The parameter 'newVersion' cannot be null.");
        else if (newVersion !== undefined)
            url_ += "NewVersion=" + encodeURIComponent("" + newVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<RecipeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllIngredientsByRecipe(id?: string | undefined): Observable<RecipeIngredientsModel[]> {
        let url_ = this.baseUrl + "/api/Recipe/GetAllIngredientsByRecipe?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIngredientsByRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIngredientsByRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeIngredientsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeIngredientsModel[]>;
        }));
    }

    protected processGetAllIngredientsByRecipe(response: HttpResponseBase): Observable<RecipeIngredientsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeIngredientsModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIngredients(id?: string | undefined, collapse?: boolean | undefined, language?: string | null | undefined): Observable<RecipeIngredientsModel[]> {
        let url_ = this.baseUrl + "/api/Recipe/GetIngredients?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (collapse === null)
            throw new globalThis.Error("The parameter 'collapse' cannot be null.");
        else if (collapse !== undefined)
            url_ += "collapse=" + encodeURIComponent("" + collapse) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIngredients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngredients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeIngredientsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeIngredientsModel[]>;
        }));
    }

    protected processGetIngredients(response: HttpResponseBase): Observable<RecipeIngredientsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeIngredientsModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateAllRecipes(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/CalculateAllRecipes?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateAllRecipes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateAllRecipes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCalculateAllRecipes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setAllRecipesCalculationDirty(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/SetAllRecipesCalculationDirty?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllRecipesCalculationDirty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllRecipesCalculationDirty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSetAllRecipesCalculationDirty(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateRecipeCost(id?: string | undefined): Observable<RecipeCalculationModel> {
        let url_ = this.baseUrl + "/api/Recipe/CalculateRecipeCost?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateRecipeCost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateRecipeCost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeCalculationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeCalculationModel>;
        }));
    }

    protected processCalculateRecipeCost(response: HttpResponseBase): Observable<RecipeCalculationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeCalculationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateRecipeCost2(id?: string | undefined, flatten?: boolean | undefined): Observable<RecipeCalculationModel> {
        let url_ = this.baseUrl + "/api/Recipe/CalculateRecipeCost2?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (flatten === null)
            throw new globalThis.Error("The parameter 'flatten' cannot be null.");
        else if (flatten !== undefined)
            url_ += "flatten=" + encodeURIComponent("" + flatten) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateRecipeCost2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateRecipeCost2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeCalculationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeCalculationModel>;
        }));
    }

    protected processCalculateRecipeCost2(response: HttpResponseBase): Observable<RecipeCalculationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeCalculationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkChangeRecipeGroup(model: RecipeBulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/BulkChangeRecipeGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeRecipeGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeRecipeGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeRecipeGroup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkChangeProcess(model: RecipeBulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/BulkChangeProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeProcess(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkChangeRecipeType(model: RecipeBulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/BulkChangeRecipeType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeRecipeType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeRecipeType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkChangeRecipeType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkApproveRecipes(model: RecipeBulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/BulkApproveRecipes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkApproveRecipes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkApproveRecipes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkApproveRecipes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkObsoleteRecipes(model: RecipeBulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/BulkObsoleteRecipes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkObsoleteRecipes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkObsoleteRecipes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkObsoleteRecipes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkSetOrganic(model: RecipeBulkChangeModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/BulkSetOrganic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkSetOrganic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkSetOrganic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBulkSetOrganic(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportRawProducts(model: RecipeBulkModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/ExportRawProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRawProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRawProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportRawProducts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fixDocTypes(): Observable<string> {
        let url_ = this.baseUrl + "/api/Recipe/FixDocTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixDocTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixDocTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFixDocTypes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPdf(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Recipe/GetPdf?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCostCalculationReport(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Recipe/GetCostCalculationReport?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostCalculationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostCalculationReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCostCalculationReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRecipeGroupService {
    /**
     * Get RecipeGroup
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<RecipeGroupModel>;
    /**
     * Get RecipeGroup by Supplier
     */
    getAll(): Observable<RecipeGroupModel[]>;
    /**
     * Add or update RecipeGroup
     */
    post(model: RecipeGroupModel): Observable<RecipeGroupModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class RecipeGroupService implements IRecipeGroupService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get RecipeGroup
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<RecipeGroupModel> {
        let url_ = this.baseUrl + "/api/RecipeGroup/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeGroupModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RecipeGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RecipeGroup by Supplier
     */
    getAll(): Observable<RecipeGroupModel[]> {
        let url_ = this.baseUrl + "/api/RecipeGroup/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeGroupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeGroupModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RecipeGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeGroupModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RecipeGroup
     */
    post(model: RecipeGroupModel): Observable<RecipeGroupModel> {
        let url_ = this.baseUrl + "/api/RecipeGroup/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeGroupModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<RecipeGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/RecipeGroup/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRecipeIngredientsService {
    /**
     * Get RecipeIngredient
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<RecipeIngredientsModel[]>;
    /**
     * Get RecipeIngredient
     * @param recipeId (optional) 
     */
    getByRecipe(recipeId?: string | undefined): Observable<RecipeIngredientsModel[]>;
    /**
     * Get RecipeIngredient
     * @param recipeId (optional) 
     */
    getOutputByRecipe(recipeId?: string | undefined): Observable<RecipeIngredientsModel[]>;
    /**
     * Add or update RecipeIngredient
     */
    post(model: RecipeIngredientsModel): Observable<RecipeIngredientsModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class RecipeIngredientsService implements IRecipeIngredientsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get RecipeIngredient
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<RecipeIngredientsModel[]> {
        let url_ = this.baseUrl + "/api/RecipeIngredients/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeIngredientsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeIngredientsModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RecipeIngredientsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeIngredientsModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RecipeIngredient
     * @param recipeId (optional) 
     */
    getByRecipe(recipeId?: string | undefined): Observable<RecipeIngredientsModel[]> {
        let url_ = this.baseUrl + "/api/RecipeIngredients/GetByRecipe?";
        if (recipeId === null)
            throw new globalThis.Error("The parameter 'recipeId' cannot be null.");
        else if (recipeId !== undefined)
            url_ += "recipeId=" + encodeURIComponent("" + recipeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeIngredientsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeIngredientsModel[]>;
        }));
    }

    protected processGetByRecipe(response: HttpResponseBase): Observable<RecipeIngredientsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeIngredientsModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RecipeIngredient
     * @param recipeId (optional) 
     */
    getOutputByRecipe(recipeId?: string | undefined): Observable<RecipeIngredientsModel[]> {
        let url_ = this.baseUrl + "/api/RecipeIngredients/GetOutputByRecipe?";
        if (recipeId === null)
            throw new globalThis.Error("The parameter 'recipeId' cannot be null.");
        else if (recipeId !== undefined)
            url_ += "recipeId=" + encodeURIComponent("" + recipeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutputByRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutputByRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeIngredientsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeIngredientsModel[]>;
        }));
    }

    protected processGetOutputByRecipe(response: HttpResponseBase): Observable<RecipeIngredientsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipeIngredientsModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RecipeIngredient
     */
    post(model: RecipeIngredientsModel): Observable<RecipeIngredientsModel> {
        let url_ = this.baseUrl + "/api/RecipeIngredients/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeIngredientsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeIngredientsModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<RecipeIngredientsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeIngredientsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/RecipeIngredients/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportService {
    /**
     * Get Resource
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ReportModel>;
    /**
     * Get Resource by Supplier
     */
    getAll(): Observable<ReportModel[]>;
    getAllDashboards(): Observable<ReportModel[]>;
    /**
     * Get Resource
     * @param id (optional) 
     */
    copy(id?: string | undefined): Observable<ReportModel>;
    /**
     * Add or update Resource
     */
    post(model: ReportModel): Observable<ReportModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportService implements IReportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Resource
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ReportModel> {
        let url_ = this.baseUrl + "/api/Report/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReportModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource by Supplier
     */
    getAll(): Observable<ReportModel[]> {
        let url_ = this.baseUrl + "/api/Report/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReportModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllDashboards(): Observable<ReportModel[]> {
        let url_ = this.baseUrl + "/api/Report/GetAllDashboards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportModel[]>;
        }));
    }

    protected processGetAllDashboards(response: HttpResponseBase): Observable<ReportModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource
     * @param id (optional) 
     */
    copy(id?: string | undefined): Observable<ReportModel> {
        let url_ = this.baseUrl + "/api/Report/Copy?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<ReportModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Resource
     */
    post(model: ReportModel): Observable<ReportModel> {
        let url_ = this.baseUrl + "/api/Report/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ReportModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Report/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEndUserReportDesignerService {
    getReportDesignerModel(reportUrl?: string | null | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class EndUserReportDesignerService implements IEndUserReportDesignerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getReportDesignerModel(reportUrl?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/EndUserReportDesigner/GetReportDesignerModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (reportUrl !== null && reportUrl !== undefined)
            content_.append("reportUrl", reportUrl.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportDesignerModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportDesignerModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReportDesignerModel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomMVCWebDocumentViewerService {
    invoke(): Observable<FileResponse>;
    getLocalization(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomMVCWebDocumentViewerService implements ICustomMVCWebDocumentViewerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    invoke(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CustomMVCWebDocumentViewer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInvoke(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLocalization(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CustomMVCWebDocumentViewer/GetLocalization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLocalization(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomMVCQueryBuilderService {
    invoke(): Observable<FileResponse>;
    getLocalization(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomMVCQueryBuilderService implements ICustomMVCQueryBuilderService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    invoke(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CustomMVCQueryBuilder";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInvoke(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLocalization(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CustomMVCQueryBuilder/GetLocalization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLocalization(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomMVCReportDesignerService {
    invoke(): Observable<FileResponse>;
    getLocalization(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomMVCReportDesignerService implements ICustomMVCReportDesignerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    invoke(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CustomMVCReportDesigner";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInvoke(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLocalization(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CustomMVCReportDesigner/GetLocalization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLocalization(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IResourceAllocationService {
    /**
     * Get Resource
     */
    updatePlan(): Observable<string>;
    /**
     * Get Resource
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ResourceAllocationModel>;
    /**
     * Get Resource by Supplier
     */
    getAll(): Observable<ResourceAllocationModel[]>;
    /**
     * Get Resource by Supplier
     * @param startDate (optional) 
     * @param endDate (optional) 
     */
    getByDateRange(startDate?: Date | undefined, endDate?: Date | undefined): Observable<ResourceAllocationModel[]>;
    /**
     * Get Resource by Supplier
     * @param id (optional) 
     */
    getByProductionOrder(id?: string | undefined): Observable<ResourceAllocationModel[]>;
    /**
     * Get Resource by Supplier
     * @param id (optional) 
     */
    getByProductionOrderWithRequirements(id?: string | undefined): Observable<ResourceRequirementAllocationModel[]>;
    /**
     * Add or update Resource
     */
    post(model: ResourceAllocationModel): Observable<ResourceAllocationModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ResourceAllocationService implements IResourceAllocationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Resource
     */
    updatePlan(): Observable<string> {
        let url_ = this.baseUrl + "/api/ResourceAllocation/UpdatePlan";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdatePlan(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ResourceAllocationModel> {
        let url_ = this.baseUrl + "/api/ResourceAllocation/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceAllocationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceAllocationModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResourceAllocationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceAllocationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource by Supplier
     */
    getAll(): Observable<ResourceAllocationModel[]> {
        let url_ = this.baseUrl + "/api/ResourceAllocation/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceAllocationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceAllocationModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ResourceAllocationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceAllocationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource by Supplier
     * @param startDate (optional) 
     * @param endDate (optional) 
     */
    getByDateRange(startDate?: Date | undefined, endDate?: Date | undefined): Observable<ResourceAllocationModel[]> {
        let url_ = this.baseUrl + "/api/ResourceAllocation/GetByDateRange?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceAllocationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceAllocationModel[]>;
        }));
    }

    protected processGetByDateRange(response: HttpResponseBase): Observable<ResourceAllocationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceAllocationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource by Supplier
     * @param id (optional) 
     */
    getByProductionOrder(id?: string | undefined): Observable<ResourceAllocationModel[]> {
        let url_ = this.baseUrl + "/api/ResourceAllocation/GetByProductionOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductionOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductionOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceAllocationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceAllocationModel[]>;
        }));
    }

    protected processGetByProductionOrder(response: HttpResponseBase): Observable<ResourceAllocationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceAllocationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource by Supplier
     * @param id (optional) 
     */
    getByProductionOrderWithRequirements(id?: string | undefined): Observable<ResourceRequirementAllocationModel[]> {
        let url_ = this.baseUrl + "/api/ResourceAllocation/GetByProductionOrderWithRequirements?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductionOrderWithRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductionOrderWithRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceRequirementAllocationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceRequirementAllocationModel[]>;
        }));
    }

    protected processGetByProductionOrderWithRequirements(response: HttpResponseBase): Observable<ResourceRequirementAllocationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceRequirementAllocationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Resource
     */
    post(model: ResourceAllocationModel): Observable<ResourceAllocationModel> {
        let url_ = this.baseUrl + "/api/ResourceAllocation/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceAllocationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceAllocationModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResourceAllocationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceAllocationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ResourceAllocation/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IResourceCapabilityService {
    /**
     * Get Resource
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ResourceCapabilityModel>;
    /**
     * Get Resource by Supplier
     */
    getAll(): Observable<ResourceCapabilityModel[]>;
    /**
     * Add or update Resource
     */
    post(model: ResourceCapabilityModel): Observable<ResourceCapabilityModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ResourceCapabilityService implements IResourceCapabilityService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Resource
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ResourceCapabilityModel> {
        let url_ = this.baseUrl + "/api/ResourceCapability/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceCapabilityModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceCapabilityModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResourceCapabilityModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceCapabilityModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource by Supplier
     */
    getAll(): Observable<ResourceCapabilityModel[]> {
        let url_ = this.baseUrl + "/api/ResourceCapability/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceCapabilityModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceCapabilityModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ResourceCapabilityModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceCapabilityModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Resource
     */
    post(model: ResourceCapabilityModel): Observable<ResourceCapabilityModel> {
        let url_ = this.baseUrl + "/api/ResourceCapability/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceCapabilityModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceCapabilityModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResourceCapabilityModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceCapabilityModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ResourceCapability/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IResourceService {
    /**
     * Get Resource
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ResourceModel>;
    /**
     * Get Resource by Supplier
     */
    getAll(): Observable<ResourceModel[]>;
    /**
     * Add or update Resource
     */
    post(model: ResourceModel): Observable<ResourceModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ResourceService implements IResourceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Resource
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ResourceModel> {
        let url_ = this.baseUrl + "/api/Resource/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResourceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource by Supplier
     */
    getAll(): Observable<ResourceModel[]> {
        let url_ = this.baseUrl + "/api/Resource/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ResourceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Resource
     */
    post(model: ResourceModel): Observable<ResourceModel> {
        let url_ = this.baseUrl + "/api/Resource/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResourceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Resource/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IResourceRequirementService {
    /**
     * Get Resource
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ResourceRequirementModel>;
    /**
     * Get Resource by Supplier
     */
    getAll(): Observable<ResourceRequirementModel[]>;
    /**
     * Get Resource by Supplier
     * @param id (optional) 
     */
    getByRecipe(id?: string | undefined): Observable<ResourceRequirementModel[]>;
    /**
     * Get Resource by Supplier
     * @param id (optional) 
     */
    getByProcessStep(id?: string | undefined): Observable<ResourceRequirementModel[]>;
    /**
     * Add or update Resource
     */
    post(model: ResourceRequirementModel): Observable<ResourceRequirementModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ResourceRequirementService implements IResourceRequirementService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Resource
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<ResourceRequirementModel> {
        let url_ = this.baseUrl + "/api/ResourceRequirement/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceRequirementModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceRequirementModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResourceRequirementModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceRequirementModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource by Supplier
     */
    getAll(): Observable<ResourceRequirementModel[]> {
        let url_ = this.baseUrl + "/api/ResourceRequirement/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceRequirementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceRequirementModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ResourceRequirementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceRequirementModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource by Supplier
     * @param id (optional) 
     */
    getByRecipe(id?: string | undefined): Observable<ResourceRequirementModel[]> {
        let url_ = this.baseUrl + "/api/ResourceRequirement/GetByRecipe?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceRequirementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceRequirementModel[]>;
        }));
    }

    protected processGetByRecipe(response: HttpResponseBase): Observable<ResourceRequirementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceRequirementModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource by Supplier
     * @param id (optional) 
     */
    getByProcessStep(id?: string | undefined): Observable<ResourceRequirementModel[]> {
        let url_ = this.baseUrl + "/api/ResourceRequirement/GetByProcessStep?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProcessStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProcessStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceRequirementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceRequirementModel[]>;
        }));
    }

    protected processGetByProcessStep(response: HttpResponseBase): Observable<ResourceRequirementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceRequirementModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Resource
     */
    post(model: ResourceRequirementModel): Observable<ResourceRequirementModel> {
        let url_ = this.baseUrl + "/api/ResourceRequirement/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourceRequirementModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourceRequirementModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ResourceRequirementModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceRequirementModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ResourceRequirement/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRiskAnalysisService {
    convertToV2(analysisId?: string | undefined): Observable<RiskAnalysisModel>;
    addLanguage(analysisId?: string | undefined, language?: string | null | undefined, translate?: boolean | undefined): Observable<RiskAnalysisModel>;
    updateFactorLanguage(model: RiskFactorLanguageModel): Observable<RiskAnalysisModel>;
    updateFactorMain(model: RiskFactorModel): Observable<RiskAnalysisModel>;
    addFactor(model: RiskFactorModel): Observable<RiskAnalysisModel>;
    /**
     * Get RiskAnalysis
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<RiskAnalysisModel>;
    /**
     * Get all RiskAnalysis
     */
    getAll(): Observable<RiskAnalysisModel[]>;
    /**
     * Get RiskAnalysis by Organization
     * @param id (optional) 
     */
    getByOrganization(id?: string | undefined): Observable<RiskAnalysisModel[]>;
    /**
     * Get all RiskAnalysis
     * @param id (optional) 
     */
    getByDepartment(id?: string | undefined): Observable<RiskAnalysisSimpleModel[]>;
    check(id?: string | undefined): Observable<string>;
    /**
     * Copy RiskAnalysis and RiskFactors
     * @param id (optional) 
     * @param departmentId (optional) 
     */
    copy(id?: string | undefined, departmentId?: string | undefined): Observable<RiskAnalysisModel>;
    copyRiskFactor(model: RiskFactorModel): Observable<RiskFactorModel>;
    /**
     * Add or update RiskAnalysis
     */
    post(model: RiskAnalysisModel): Observable<RiskAnalysisModel>;
    /**
     * Add or update RiskAnalysis
     */
    createNewVersion(model: RiskAnalysisModel): Observable<RiskAnalysisModel>;
    deleteDuplicatedRiskFactorRelations(): Observable<void>;
    /**
     * Populate RiskFactor from ProcessStep
     * @param id (optional) 
     */
    populateRiskFactorFromProcessStep(id?: string | undefined): Observable<RiskAnalysisModel>;
    getDecisionTrees(id?: string | undefined): Observable<RiskAnalysisReportModel>;
    getControlPoints(id?: string | undefined, type?: string | null | undefined): Observable<ControlPlanReportModel>;
    getReport(type?: string | null | undefined, id?: string | undefined, fileType?: string | null | undefined, reportType?: string | null | undefined, language?: string | null | undefined): Observable<FileResponse>;
    delete(id?: string | undefined): Observable<string>;
    deleteRiskFactor(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class RiskAnalysisService implements IRiskAnalysisService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    convertToV2(analysisId?: string | undefined): Observable<RiskAnalysisModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/ConvertToV2?";
        if (analysisId === null)
            throw new globalThis.Error("The parameter 'analysisId' cannot be null.");
        else if (analysisId !== undefined)
            url_ += "analysisId=" + encodeURIComponent("" + analysisId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertToV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertToV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisModel>;
        }));
    }

    protected processConvertToV2(response: HttpResponseBase): Observable<RiskAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addLanguage(analysisId?: string | undefined, language?: string | null | undefined, translate?: boolean | undefined): Observable<RiskAnalysisModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/AddLanguage?";
        if (analysisId === null)
            throw new globalThis.Error("The parameter 'analysisId' cannot be null.");
        else if (analysisId !== undefined)
            url_ += "analysisId=" + encodeURIComponent("" + analysisId) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (translate === null)
            throw new globalThis.Error("The parameter 'translate' cannot be null.");
        else if (translate !== undefined)
            url_ += "translate=" + encodeURIComponent("" + translate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisModel>;
        }));
    }

    protected processAddLanguage(response: HttpResponseBase): Observable<RiskAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFactorLanguage(model: RiskFactorLanguageModel): Observable<RiskAnalysisModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/UpdateFactorLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFactorLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFactorLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisModel>;
        }));
    }

    protected processUpdateFactorLanguage(response: HttpResponseBase): Observable<RiskAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFactorMain(model: RiskFactorModel): Observable<RiskAnalysisModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/UpdateFactorMain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFactorMain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFactorMain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisModel>;
        }));
    }

    protected processUpdateFactorMain(response: HttpResponseBase): Observable<RiskAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addFactor(model: RiskFactorModel): Observable<RiskAnalysisModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/AddFactor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFactor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFactor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisModel>;
        }));
    }

    protected processAddFactor(response: HttpResponseBase): Observable<RiskAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RiskAnalysis
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<RiskAnalysisModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RiskAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all RiskAnalysis
     */
    getAll(): Observable<RiskAnalysisModel[]> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RiskAnalysisModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RiskAnalysisModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RiskAnalysis by Organization
     * @param id (optional) 
     */
    getByOrganization(id?: string | undefined): Observable<RiskAnalysisModel[]> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/GetByOrganization?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisModel[]>;
        }));
    }

    protected processGetByOrganization(response: HttpResponseBase): Observable<RiskAnalysisModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RiskAnalysisModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all RiskAnalysis
     * @param id (optional) 
     */
    getByDepartment(id?: string | undefined): Observable<RiskAnalysisSimpleModel[]> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/GetByDepartment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisSimpleModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisSimpleModel[]>;
        }));
    }

    protected processGetByDepartment(response: HttpResponseBase): Observable<RiskAnalysisSimpleModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RiskAnalysisSimpleModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    check(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/Check?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheck(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Copy RiskAnalysis and RiskFactors
     * @param id (optional) 
     * @param departmentId (optional) 
     */
    copy(id?: string | undefined, departmentId?: string | undefined): Observable<RiskAnalysisModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/Copy?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<RiskAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyRiskFactor(model: RiskFactorModel): Observable<RiskFactorModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/CopyRiskFactor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyRiskFactor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyRiskFactor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskFactorModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskFactorModel>;
        }));
    }

    protected processCopyRiskFactor(response: HttpResponseBase): Observable<RiskFactorModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskFactorModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    post(model: RiskAnalysisModel): Observable<RiskAnalysisModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<RiskAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskAnalysis
     */
    createNewVersion(model: RiskAnalysisModel): Observable<RiskAnalysisModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/CreateNewVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisModel>;
        }));
    }

    protected processCreateNewVersion(response: HttpResponseBase): Observable<RiskAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDuplicatedRiskFactorRelations(): Observable<void> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/DeleteDuplicatedRiskFactorRelations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDuplicatedRiskFactorRelations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDuplicatedRiskFactorRelations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDuplicatedRiskFactorRelations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Populate RiskFactor from ProcessStep
     * @param id (optional) 
     */
    populateRiskFactorFromProcessStep(id?: string | undefined): Observable<RiskAnalysisModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/PopulateRiskFactorFromProcessStep?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPopulateRiskFactorFromProcessStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPopulateRiskFactorFromProcessStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisModel>;
        }));
    }

    protected processPopulateRiskFactorFromProcessStep(response: HttpResponseBase): Observable<RiskAnalysisModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskAnalysisModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDecisionTrees(id?: string | undefined): Observable<RiskAnalysisReportModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/GetDecisionTrees?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDecisionTrees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDecisionTrees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskAnalysisReportModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskAnalysisReportModel>;
        }));
    }

    protected processGetDecisionTrees(response: HttpResponseBase): Observable<RiskAnalysisReportModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskAnalysisReportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getControlPoints(id?: string | undefined, type?: string | null | undefined): Observable<ControlPlanReportModel> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/GetControlPoints?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetControlPoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetControlPoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControlPlanReportModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControlPlanReportModel>;
        }));
    }

    protected processGetControlPoints(response: HttpResponseBase): Observable<ControlPlanReportModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControlPlanReportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(type?: string | null | undefined, id?: string | undefined, fileType?: string | null | undefined, reportType?: string | null | undefined, language?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/GetReport?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (fileType !== undefined && fileType !== null)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (reportType !== undefined && reportType !== null)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRiskFactor(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/RiskAnalysis/DeleteRiskFactor?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRiskFactor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRiskFactor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteRiskFactor(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRiskFactorService {
    /**
     * Get RiskFactor
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<RiskFactorRelationModel>;
    /**
     * Get RiskFactor by RiskCategory
     */
    getByAnalysis(query: PagedQuery): Observable<PagedResultOfRiskFactorRelationModel>;
    /**
     * Copy RiskFactor
     * @param factorId (optional) 
     * @param analysisId (optional) 
     */
    copy(factorId?: string | undefined, analysisId?: string | undefined): Observable<RiskFactorRelationModel>;
    /**
     * Add or update RiskFactor
     */
    post(model: RiskFactorRelationModel): Observable<RiskFactorRelationModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class RiskFactorService implements IRiskFactorService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get RiskFactor
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<RiskFactorRelationModel> {
        let url_ = this.baseUrl + "/api/RiskFactor/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskFactorRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskFactorRelationModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RiskFactorRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskFactorRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get RiskFactor by RiskCategory
     */
    getByAnalysis(query: PagedQuery): Observable<PagedResultOfRiskFactorRelationModel> {
        let url_ = this.baseUrl + "/api/RiskFactor/GetByAnalysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByAnalysis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByAnalysis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfRiskFactorRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfRiskFactorRelationModel>;
        }));
    }

    protected processGetByAnalysis(response: HttpResponseBase): Observable<PagedResultOfRiskFactorRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfRiskFactorRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Copy RiskFactor
     * @param factorId (optional) 
     * @param analysisId (optional) 
     */
    copy(factorId?: string | undefined, analysisId?: string | undefined): Observable<RiskFactorRelationModel> {
        let url_ = this.baseUrl + "/api/RiskFactor/Copy?";
        if (factorId === null)
            throw new globalThis.Error("The parameter 'factorId' cannot be null.");
        else if (factorId !== undefined)
            url_ += "factorId=" + encodeURIComponent("" + factorId) + "&";
        if (analysisId === null)
            throw new globalThis.Error("The parameter 'analysisId' cannot be null.");
        else if (analysisId !== undefined)
            url_ += "analysisId=" + encodeURIComponent("" + analysisId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskFactorRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskFactorRelationModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<RiskFactorRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskFactorRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update RiskFactor
     */
    post(model: RiskFactorRelationModel): Observable<RiskFactorRelationModel> {
        let url_ = this.baseUrl + "/api/RiskFactor/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskFactorRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskFactorRelationModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<RiskFactorRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskFactorRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/RiskFactor/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IScheduledProductionOrderService {
    getScheduledProductionOrders(): Observable<PagedResultOfScheduledProductionOrderModel>;
    getScheduledProductionOrdersInDateRange(startDate?: Date | undefined, endDate?: Date | undefined): Observable<PagedResultOfScheduledProductionOrderOccurenceModel>;
    post(model: ScheduledProductionOrderModel): Observable<ScheduledProductionOrderModel>;
    /**
     * Delete production order
     * @param id (optional) 
     */
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ScheduledProductionOrderService implements IScheduledProductionOrderService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getScheduledProductionOrders(): Observable<PagedResultOfScheduledProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ScheduledProductionOrder/GetScheduledProductionOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduledProductionOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduledProductionOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfScheduledProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfScheduledProductionOrderModel>;
        }));
    }

    protected processGetScheduledProductionOrders(response: HttpResponseBase): Observable<PagedResultOfScheduledProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfScheduledProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getScheduledProductionOrdersInDateRange(startDate?: Date | undefined, endDate?: Date | undefined): Observable<PagedResultOfScheduledProductionOrderOccurenceModel> {
        let url_ = this.baseUrl + "/api/ScheduledProductionOrder/GetScheduledProductionOrdersInDateRange?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduledProductionOrdersInDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduledProductionOrdersInDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfScheduledProductionOrderOccurenceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfScheduledProductionOrderOccurenceModel>;
        }));
    }

    protected processGetScheduledProductionOrdersInDateRange(response: HttpResponseBase): Observable<PagedResultOfScheduledProductionOrderOccurenceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfScheduledProductionOrderOccurenceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: ScheduledProductionOrderModel): Observable<ScheduledProductionOrderModel> {
        let url_ = this.baseUrl + "/api/ScheduledProductionOrder/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledProductionOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledProductionOrderModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ScheduledProductionOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledProductionOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete production order
     * @param id (optional) 
     */
    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ScheduledProductionOrder/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISchedulePauseService {
    getAll(): Observable<CcpSchedulePauseModel[]>;
    getByOrganization(): Observable<CcpSchedulePauseModel[]>;
    getById(id?: string | undefined): Observable<CcpSchedulePauseModel>;
    getScheduleByDay(day?: Date | undefined): Observable<CcpSchedulePauseModel>;
    updateSchedulePause(model: CcpSchedulePauseModel): Observable<CcpSchedulePauseModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class SchedulePauseService implements ISchedulePauseService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<CcpSchedulePauseModel[]> {
        let url_ = this.baseUrl + "/api/SchedulePause/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpSchedulePauseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpSchedulePauseModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CcpSchedulePauseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpSchedulePauseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByOrganization(): Observable<CcpSchedulePauseModel[]> {
        let url_ = this.baseUrl + "/api/SchedulePause/GetByOrganization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpSchedulePauseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpSchedulePauseModel[]>;
        }));
    }

    protected processGetByOrganization(response: HttpResponseBase): Observable<CcpSchedulePauseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CcpSchedulePauseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id?: string | undefined): Observable<CcpSchedulePauseModel> {
        let url_ = this.baseUrl + "/api/SchedulePause/GetById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpSchedulePauseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpSchedulePauseModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CcpSchedulePauseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpSchedulePauseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getScheduleByDay(day?: Date | undefined): Observable<CcpSchedulePauseModel> {
        let url_ = this.baseUrl + "/api/SchedulePause/GetScheduleByDay?";
        if (day === null)
            throw new globalThis.Error("The parameter 'day' cannot be null.");
        else if (day !== undefined)
            url_ += "day=" + encodeURIComponent(day ? "" + day.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduleByDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduleByDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpSchedulePauseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpSchedulePauseModel>;
        }));
    }

    protected processGetScheduleByDay(response: HttpResponseBase): Observable<CcpSchedulePauseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpSchedulePauseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSchedulePause(model: CcpSchedulePauseModel): Observable<CcpSchedulePauseModel> {
        let url_ = this.baseUrl + "/api/SchedulePause/UpdateSchedulePause";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSchedulePause(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSchedulePause(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CcpSchedulePauseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CcpSchedulePauseModel>;
        }));
    }

    protected processUpdateSchedulePause(response: HttpResponseBase): Observable<CcpSchedulePauseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CcpSchedulePauseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/SchedulePause/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISensorService {
    newMeasurement(data: MeasurementData, organizationId?: string | undefined): Observable<string>;
    getMeasurements(sensorId?: string | undefined, startTime?: Date | undefined, endTime?: Date | undefined): Observable<SensorMeasurementModel[]>;
    importMeasurementsForSensor(sensorId?: string | undefined): Observable<string>;
    getActiveSensors(): Observable<SensorModel[]>;
    getSensors(): Observable<SensorModel[]>;
    post(model: SensorModel): Observable<SensorModel>;
    delete(id?: string | undefined): Observable<string>;
    getThermItDepartments(): Observable<ThermItDepartment[]>;
    getThermItAreasByDepartmentId(departmentId?: number | undefined): Observable<ThermItArea[]>;
    getThermItSensorsByDepartment(departmentId?: number | undefined): Observable<ThermITSensor[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SensorService implements ISensorService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    newMeasurement(data: MeasurementData, organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/umbraco/api/sensor/newmeasurement?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewMeasurement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewMeasurement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processNewMeasurement(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMeasurements(sensorId?: string | undefined, startTime?: Date | undefined, endTime?: Date | undefined): Observable<SensorMeasurementModel[]> {
        let url_ = this.baseUrl + "/api/Sensor/GetMeasurements?";
        if (sensorId === null)
            throw new globalThis.Error("The parameter 'sensorId' cannot be null.");
        else if (sensorId !== undefined)
            url_ += "sensorId=" + encodeURIComponent("" + sensorId) + "&";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SensorMeasurementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SensorMeasurementModel[]>;
        }));
    }

    protected processGetMeasurements(response: HttpResponseBase): Observable<SensorMeasurementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SensorMeasurementModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importMeasurementsForSensor(sensorId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Sensor/ImportMeasurementsForSensor?";
        if (sensorId === null)
            throw new globalThis.Error("The parameter 'sensorId' cannot be null.");
        else if (sensorId !== undefined)
            url_ += "sensorId=" + encodeURIComponent("" + sensorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportMeasurementsForSensor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportMeasurementsForSensor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportMeasurementsForSensor(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveSensors(): Observable<SensorModel[]> {
        let url_ = this.baseUrl + "/api/Sensor/GetActiveSensors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveSensors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveSensors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SensorModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SensorModel[]>;
        }));
    }

    protected processGetActiveSensors(response: HttpResponseBase): Observable<SensorModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SensorModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSensors(): Observable<SensorModel[]> {
        let url_ = this.baseUrl + "/api/Sensor/GetSensors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSensors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSensors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SensorModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SensorModel[]>;
        }));
    }

    protected processGetSensors(response: HttpResponseBase): Observable<SensorModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SensorModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: SensorModel): Observable<SensorModel> {
        let url_ = this.baseUrl + "/api/Sensor/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SensorModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SensorModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<SensorModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SensorModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Sensor/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getThermItDepartments(): Observable<ThermItDepartment[]> {
        let url_ = this.baseUrl + "/api/Sensor/GetThermItDepartments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThermItDepartments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThermItDepartments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThermItDepartment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThermItDepartment[]>;
        }));
    }

    protected processGetThermItDepartments(response: HttpResponseBase): Observable<ThermItDepartment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThermItDepartment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getThermItAreasByDepartmentId(departmentId?: number | undefined): Observable<ThermItArea[]> {
        let url_ = this.baseUrl + "/api/Sensor/GetThermItAreasByDepartmentId?";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThermItAreasByDepartmentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThermItAreasByDepartmentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThermItArea[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThermItArea[]>;
        }));
    }

    protected processGetThermItAreasByDepartmentId(response: HttpResponseBase): Observable<ThermItArea[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThermItArea.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getThermItSensorsByDepartment(departmentId?: number | undefined): Observable<ThermITSensor[]> {
        let url_ = this.baseUrl + "/api/Sensor/GetThermItSensorsByDepartment?";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThermItSensorsByDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThermItSensorsByDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThermITSensor[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThermITSensor[]>;
        }));
    }

    protected processGetThermItSensorsByDepartment(response: HttpResponseBase): Observable<ThermITSensor[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThermITSensor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IShopService {
    createSalesTemplateFromBasket(customerId?: string | undefined): Observable<OrderModel>;
    postSubscription(model: ShopSubscriptionModel): Observable<ShopSubscriptionModel>;
    getSubscription(id?: string | undefined): Observable<ShopSubscriptionModel>;
    getAllSubscriptions(): Observable<ShopSubscriptionModel[]>;
    getSubscriptionsForCustomer(id?: string | undefined): Observable<ShopSubscriptionModel[]>;
    deleteSubscription(id?: string | undefined): Observable<string>;
    sendOrder(customerId?: string | undefined): Observable<string>;
    removeUser(userId?: string | undefined): Observable<string>;
    addUser(model: UserModel): Observable<UserModel>;
    getUsers(customerId?: string | undefined): Observable<UserModel[]>;
    getOrders(customerId?: string | undefined): Observable<OrderModel[]>;
    getPriceList(customerId?: string | undefined, date?: Date | undefined): Observable<FileResponse>;
    getProducts(customerId?: string | undefined): Observable<ShopCategoryModel[]>;
    addProductsWithPrices(customerId?: string | undefined): Observable<string>;
    addProductForCustomer(customerId?: string | undefined, productVariantId?: string | undefined): Observable<string>;
    addCategoryForCustomer(customerId?: string | undefined, categoryId?: string | undefined): Observable<string>;
    removeCategoryFromCustomer(customerId?: string | undefined, categoryId?: string | undefined): Observable<string>;
    removeProductFromCustomer(customerId?: string | undefined, productVariantId?: string | undefined): Observable<string>;
    removeAllProductsFromCustomer(customerId?: string | undefined): Observable<string>;
    saveProductSortOrder(model: ShopCategoryModel): Observable<string>;
    getBasket(customerId?: string | undefined): Observable<OrderModel>;
    updateBasketLine(line: OrderlineModel): Observable<OrderModel>;
    addToBasket(basketId?: string | undefined, productVariantId?: string | undefined, quantity?: number | undefined, unit?: string | null | undefined): Observable<OrderModel>;
    sendNotification(model: SendNotificationModel): Observable<string>;
    importProductsForCustomer(fileName?: string | null | undefined, customerId?: string | undefined): Observable<string>;
    post(model: OrderModel): Observable<OrderModel>;
    automaticRefillShopOrders(): Observable<string>;
    findFirstDelivery(deliveryDays: ShopDeliveryDeadlineModel[]): Observable<ShopDeliveryDeadlineModel>;
    getDeliveryDays(customerId?: string | undefined): Observable<ShopDeliveryDeadlineModel[]>;
    postDeliveryDays(model: ShopDeliveryDeadlineModel): Observable<ShopDeliveryDeadlineModel>;
    removeDeliveryDay(id?: string | undefined): Observable<string>;
    emptyBasket(customerId?: string | undefined): Observable<string>;
    delete(id?: string | undefined): Observable<string>;
    createShopOrderFromTemplate(templateId?: string | undefined, customerId?: string | undefined, deliveryDate?: Date | undefined): Observable<OrderModel>;
    createOrdersForSubscriptions(organizationId?: string | undefined): Observable<string>;
    copyOrderToBasket(orderId?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ShopService implements IShopService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createSalesTemplateFromBasket(customerId?: string | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Shop/CreateSalesTemplateFromBasket?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSalesTemplateFromBasket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSalesTemplateFromBasket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processCreateSalesTemplateFromBasket(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postSubscription(model: ShopSubscriptionModel): Observable<ShopSubscriptionModel> {
        let url_ = this.baseUrl + "/api/Shop/PostSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopSubscriptionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopSubscriptionModel>;
        }));
    }

    protected processPostSubscription(response: HttpResponseBase): Observable<ShopSubscriptionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopSubscriptionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubscription(id?: string | undefined): Observable<ShopSubscriptionModel> {
        let url_ = this.baseUrl + "/api/Shop/GetSubscription?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopSubscriptionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopSubscriptionModel>;
        }));
    }

    protected processGetSubscription(response: HttpResponseBase): Observable<ShopSubscriptionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopSubscriptionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllSubscriptions(): Observable<ShopSubscriptionModel[]> {
        let url_ = this.baseUrl + "/api/Shop/GetAllSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopSubscriptionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopSubscriptionModel[]>;
        }));
    }

    protected processGetAllSubscriptions(response: HttpResponseBase): Observable<ShopSubscriptionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShopSubscriptionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubscriptionsForCustomer(id?: string | undefined): Observable<ShopSubscriptionModel[]> {
        let url_ = this.baseUrl + "/api/Shop/GetSubscriptionsForCustomer?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionsForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionsForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopSubscriptionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopSubscriptionModel[]>;
        }));
    }

    protected processGetSubscriptionsForCustomer(response: HttpResponseBase): Observable<ShopSubscriptionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShopSubscriptionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSubscription(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/DeleteSubscription?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteSubscription(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendOrder(customerId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/SendOrder?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeUser(userId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/RemoveUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRemoveUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUser(model: UserModel): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Shop/AddUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsers(customerId?: string | undefined): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/Shop/GetUsers?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrders(customerId?: string | undefined): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Shop/GetOrders?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel[]>;
        }));
    }

    protected processGetOrders(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPriceList(customerId?: string | undefined, date?: Date | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Shop/GetPriceList?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPriceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPriceList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPriceList(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProducts(customerId?: string | undefined): Observable<ShopCategoryModel[]> {
        let url_ = this.baseUrl + "/api/Shop/GetProducts?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopCategoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopCategoryModel[]>;
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<ShopCategoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShopCategoryModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addProductsWithPrices(customerId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/AddProductsWithPrices?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProductsWithPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProductsWithPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddProductsWithPrices(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addProductForCustomer(customerId?: string | undefined, productVariantId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/AddProductForCustomer?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (productVariantId === null)
            throw new globalThis.Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProductForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProductForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddProductForCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addCategoryForCustomer(customerId?: string | undefined, categoryId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/AddCategoryForCustomer?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCategoryForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCategoryForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddCategoryForCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeCategoryFromCustomer(customerId?: string | undefined, categoryId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/RemoveCategoryFromCustomer?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCategoryFromCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCategoryFromCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRemoveCategoryFromCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeProductFromCustomer(customerId?: string | undefined, productVariantId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/RemoveProductFromCustomer?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (productVariantId === null)
            throw new globalThis.Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveProductFromCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveProductFromCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRemoveProductFromCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeAllProductsFromCustomer(customerId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/RemoveAllProductsFromCustomer?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAllProductsFromCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAllProductsFromCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRemoveAllProductsFromCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveProductSortOrder(model: ShopCategoryModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/SaveProductSortOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProductSortOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProductSortOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveProductSortOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBasket(customerId?: string | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Shop/GetBasket?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBasket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processGetBasket(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateBasketLine(line: OrderlineModel): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Shop/UpdateBasketLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(line);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBasketLine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBasketLine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processUpdateBasketLine(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addToBasket(basketId?: string | undefined, productVariantId?: string | undefined, quantity?: number | undefined, unit?: string | null | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Shop/AddToBasket?";
        if (basketId === null)
            throw new globalThis.Error("The parameter 'basketId' cannot be null.");
        else if (basketId !== undefined)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        if (productVariantId === null)
            throw new globalThis.Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (quantity === null)
            throw new globalThis.Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (unit !== undefined && unit !== null)
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddToBasket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddToBasket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processAddToBasket(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendNotification(model: SendNotificationModel): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/SendNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendNotification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importProductsForCustomer(fileName?: string | null | undefined, customerId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/ImportProductsForCustomer?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportProductsForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportProductsForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportProductsForCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: OrderModel): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Shop/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    automaticRefillShopOrders(): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/AutomaticRefillShopOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutomaticRefillShopOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutomaticRefillShopOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAutomaticRefillShopOrders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findFirstDelivery(deliveryDays: ShopDeliveryDeadlineModel[]): Observable<ShopDeliveryDeadlineModel> {
        let url_ = this.baseUrl + "/api/Shop/FindFirstDelivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryDays);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindFirstDelivery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindFirstDelivery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopDeliveryDeadlineModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopDeliveryDeadlineModel>;
        }));
    }

    protected processFindFirstDelivery(response: HttpResponseBase): Observable<ShopDeliveryDeadlineModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopDeliveryDeadlineModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDeliveryDays(customerId?: string | undefined): Observable<ShopDeliveryDeadlineModel[]> {
        let url_ = this.baseUrl + "/api/Shop/GetDeliveryDays?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopDeliveryDeadlineModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopDeliveryDeadlineModel[]>;
        }));
    }

    protected processGetDeliveryDays(response: HttpResponseBase): Observable<ShopDeliveryDeadlineModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShopDeliveryDeadlineModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postDeliveryDays(model: ShopDeliveryDeadlineModel): Observable<ShopDeliveryDeadlineModel> {
        let url_ = this.baseUrl + "/api/Shop/PostDeliveryDays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostDeliveryDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDeliveryDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopDeliveryDeadlineModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopDeliveryDeadlineModel>;
        }));
    }

    protected processPostDeliveryDays(response: HttpResponseBase): Observable<ShopDeliveryDeadlineModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopDeliveryDeadlineModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeDeliveryDay(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/RemoveDeliveryDay?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDeliveryDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDeliveryDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRemoveDeliveryDay(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    emptyBasket(customerId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/EmptyBasket?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmptyBasket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmptyBasket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEmptyBasket(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createShopOrderFromTemplate(templateId?: string | undefined, customerId?: string | undefined, deliveryDate?: Date | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Shop/CreateShopOrderFromTemplate?";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (deliveryDate === null)
            throw new globalThis.Error("The parameter 'deliveryDate' cannot be null.");
        else if (deliveryDate !== undefined)
            url_ += "deliveryDate=" + encodeURIComponent(deliveryDate ? "" + deliveryDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShopOrderFromTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShopOrderFromTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processCreateShopOrderFromTemplate(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrdersForSubscriptions(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/CreateOrdersForSubscriptions?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrdersForSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrdersForSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrdersForSubscriptions(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyOrderToBasket(orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Shop/CopyOrderToBasket?";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyOrderToBasket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyOrderToBasket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCopyOrderToBasket(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IShopCustomerService {
    getAll(): Observable<ShopCustomerRelationModel[]>;
    get(id?: string | undefined): Observable<ShopCustomerRelationModel>;
    getRelationByCustomerAndUser(customerId?: string | undefined, userId?: string | undefined): Observable<ShopCustomerRelationModel>;
    getAllRelationsForUser(userId?: string | undefined): Observable<ShopCustomerRelationModel[]>;
    getRelationsByCustomerId(customerId?: string | undefined): Observable<ShopCustomerRelationModel[]>;
    getUsersWithRelation(organizationId?: string | undefined): Observable<UserModel[]>;
    post(model: ShopCustomerRelationModel): Observable<ShopCustomerRelationModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ShopCustomerService implements IShopCustomerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<ShopCustomerRelationModel[]> {
        let url_ = this.baseUrl + "/api/ShopCustomer/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopCustomerRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopCustomerRelationModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ShopCustomerRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShopCustomerRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id?: string | undefined): Observable<ShopCustomerRelationModel> {
        let url_ = this.baseUrl + "/api/ShopCustomer/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopCustomerRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopCustomerRelationModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ShopCustomerRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopCustomerRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRelationByCustomerAndUser(customerId?: string | undefined, userId?: string | undefined): Observable<ShopCustomerRelationModel> {
        let url_ = this.baseUrl + "/api/ShopCustomer/GetRelationByCustomerAndUser?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelationByCustomerAndUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelationByCustomerAndUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopCustomerRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopCustomerRelationModel>;
        }));
    }

    protected processGetRelationByCustomerAndUser(response: HttpResponseBase): Observable<ShopCustomerRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopCustomerRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllRelationsForUser(userId?: string | undefined): Observable<ShopCustomerRelationModel[]> {
        let url_ = this.baseUrl + "/api/ShopCustomer/GetAllRelationsForUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRelationsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRelationsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopCustomerRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopCustomerRelationModel[]>;
        }));
    }

    protected processGetAllRelationsForUser(response: HttpResponseBase): Observable<ShopCustomerRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShopCustomerRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRelationsByCustomerId(customerId?: string | undefined): Observable<ShopCustomerRelationModel[]> {
        let url_ = this.baseUrl + "/api/ShopCustomer/GetRelationsByCustomerId?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelationsByCustomerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelationsByCustomerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopCustomerRelationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopCustomerRelationModel[]>;
        }));
    }

    protected processGetRelationsByCustomerId(response: HttpResponseBase): Observable<ShopCustomerRelationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShopCustomerRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersWithRelation(organizationId?: string | undefined): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/ShopCustomer/GetUsersWithRelation?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersWithRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersWithRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetUsersWithRelation(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: ShopCustomerRelationModel): Observable<ShopCustomerRelationModel> {
        let url_ = this.baseUrl + "/api/ShopCustomer/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShopCustomerRelationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShopCustomerRelationModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ShopCustomerRelationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopCustomerRelationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ShopCustomer/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStockItemService {
    getLabel(id?: string | undefined): Observable<FileResponse>;
    calculateProductVariantStock(id?: string | undefined, stockLocationId?: string | null | undefined): Observable<StockItemModel>;
    getAll(startDate?: Date | null | undefined, endDate?: Date | null | undefined, showFinishedLots?: boolean | undefined): Observable<StockItemModel[]>;
    getStockOrders(type?: OrderType | undefined): Observable<StockOrderModel[]>;
    getStockOrdersForProductionOrder(id?: string | undefined): Observable<StockOrderModel[]>;
    getByProductGroup(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, showFinishedLots?: boolean | undefined): Observable<StockItemModel[]>;
    getByStockLocation(id?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, showFinishedLots?: boolean | undefined): Observable<StockItemModel[]>;
    exportByProductType(type?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined): Observable<string>;
    exportByProductGroup(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined): Observable<string>;
    exportByStockLocation(id?: string | null | undefined, startDate?: string | undefined, endDate?: string | undefined, supplierId?: string | null | undefined, productGroupId?: string | null | undefined, productType?: string | null | undefined, searchText?: string | null | undefined, isQuantity?: boolean | undefined, onlyCurrentLocation?: boolean | undefined): Observable<string>;
    previewExcelImport(filename?: string | null | undefined): Observable<string[][]>;
    importExcel(filename?: string | null | undefined, configId?: string | undefined, orderId?: string | undefined): Observable<string>;
    previewExcelExport(pagedQuery: PagedQuery): Observable<string[][]>;
    exportAll(startDate?: Date | null | undefined, endDate?: Date | null | undefined): Observable<string>;
    recalculateActualCostPrices(startDate?: Date | undefined): Observable<PagedResultOfStockItemModel>;
    getContributionRatio(startDate?: Date | undefined): Observable<ChartValue[]>;
    exportExcel(pagedQuery: PagedQuery): Observable<string>;
    getByProductType(type?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined): Observable<StockItemModel[]>;
    getByProductType2(type?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, showFinishedLots?: boolean | undefined): Observable<StockItemModel[]>;
    getByLocation(id?: string | null | undefined, startOrderId?: string | undefined, endOrderId?: string | undefined, showFinishedLots?: boolean | undefined, onlyCurrentLocation?: boolean | undefined): Observable<StockItemModel[]>;
    getStatisticsReport(query: PagedQuery): Observable<FileResponse>;
    getStatisticsPaged(query: PagedQuery, type?: OrderType | undefined): Observable<PagedResultOfStockItemModel>;
    getCustomerStatisticsPaged(query: PagedQuery): Observable<PagedResultOfStockItemModel>;
    getByLocationPaged(query: PagedQuery): Observable<PagedResultOfStockItemModel>;
    getProductVariantLotsWithoutQuantities(productVariantId?: string | undefined, stockLocationId?: string | null | undefined, showFinished?: boolean | undefined): Observable<StockItemModel>;
    getProductVariantLots(productVariantId?: string | undefined, stockLocationId?: string | null | undefined, showFinished?: boolean | undefined, unit?: string | null | undefined, includeLotId?: string | null | undefined): Observable<StockItemModel>;
    cacheProductVariant(productVariant?: string | undefined, stockLocationId?: string | null | undefined): Observable<number>;
    getLotsByProductVariantId(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, showFinished?: boolean | undefined, stockLocationId?: string | null | undefined, unit?: string | null | undefined, includeLotId?: string | null | undefined): Observable<StockItemModel>;
    searchLots(productVariantId?: string | undefined, searchText?: string | null | undefined, includeFinished?: boolean | undefined): Observable<LotModel[]>;
    getLotById(id?: string | undefined): Observable<StockItemModel[]>;
    getCustomersByLotId(id?: string | undefined): Observable<CustomerModel[]>;
    getByProductVariantId(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, stockLocationId?: string | null | undefined): Observable<StockItemModel>;
    getBalances(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, fullProduct?: boolean | undefined, stockLocationId?: string | null | undefined): Observable<StockBalanceModel>;
    getSpisemaerkeBalance(startDate?: Date | undefined, endDate?: Date | undefined): Observable<SpisemaerkeBalanceModel>;
    getSpisemaerkeBalanceReport(startDate?: Date | undefined, endDate?: Date | undefined, type?: string | null | undefined): Observable<FileResponse>;
    getProductOrdersForRawProduct(id?: string | undefined, startDate?: Date | undefined, endDate?: Date | undefined): Observable<StockBalanceModel>;
    getBalancesByProductType(type?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, fullProduct?: boolean | undefined, onlyOrganic?: boolean | undefined, forceRecalculate?: boolean | undefined, searchText?: string | null | undefined, productGroup?: string | null | undefined, productType?: string | null | undefined, calculateInputOutput?: boolean | undefined): Observable<StockBalanceModel[]>;
    getBalancesByProductGroup(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, fullProduct?: boolean | undefined, onlyOrganic?: boolean | undefined, forceRecalculate?: boolean | undefined, searchText?: string | null | undefined, productGroup?: string | null | undefined, productType?: string | null | undefined, calculateInputOutput?: boolean | undefined): Observable<StockBalanceModel[]>;
    getBalancesByStockLocation(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, fullProduct?: boolean | undefined, onlyOrganic?: boolean | undefined, forceRecalculate?: boolean | undefined, searchText?: string | null | undefined, productGroup?: string | null | undefined, productType?: string | null | undefined, calculateInputOutput?: boolean | undefined): Observable<StockBalanceModel[]>;
    getAllBalances(startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, fullProduct?: boolean | undefined, onlyOrganic?: boolean | undefined, forceRecalculate?: boolean | undefined, searchText?: string | null | undefined, productGroup?: string | null | undefined, productType?: string | null | undefined, calculateInputOutput?: boolean | undefined): Observable<StockBalanceModel[]>;
    createMissingStockItems(productGroupId?: string | undefined): Observable<StockItemModel>;
    addLot(model: AddLotModel): Observable<LotModel>;
    updateLot(model: LotModel): Observable<string>;
    updateQuantity(stockItems: StockItemModels): Observable<string>;
    updateLotQuantity(stockItems: StockItemModels): Observable<string>;
    updateStatusForVariant(id?: string | undefined): Observable<string>;
    updateLotStatusAllProducts(): Observable<string>;
    getStockLevelWarnings(query?: PagedQuery | undefined): Observable<PagedResultOfStockItemModel>;
    recalculateTransactions(id?: string | undefined): Observable<string>;
    deleteLot(id?: string | undefined): Observable<string>;
    barLot(id?: string | undefined): Observable<string>;
    releaseLot(id?: string | undefined): Observable<string>;
    finishLot(id?: string | undefined): Observable<string>;
    activateLot(id?: string | undefined): Observable<string>;
    getForecast(): Observable<string[]>;
    stockTakeFillZeroes(query: PagedQuery): Observable<string>;
    exportByProductTypePdf(type?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined): Observable<string>;
    exportBalancePdf(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, fullProduct?: boolean | undefined): Observable<FileResponse>;
    exportBalanceListPdf(id?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, fullProduct?: boolean | undefined, onlyOrganic?: boolean | undefined, productType?: string | null | undefined, threshold?: number | undefined, productGroupId?: string | null | undefined): Observable<FileResponse>;
    fixDuplicateLots(organizationId?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class StockItemService implements IStockItemService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLabel(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/StockItem/GetLabel?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLabel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateProductVariantStock(id?: string | undefined, stockLocationId?: string | null | undefined): Observable<StockItemModel> {
        let url_ = this.baseUrl + "/api/StockItem/CalculateProductVariantStock?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (stockLocationId !== undefined && stockLocationId !== null)
            url_ += "stockLocationId=" + encodeURIComponent("" + stockLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateProductVariantStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateProductVariantStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel>;
        }));
    }

    protected processCalculateProductVariantStock(response: HttpResponseBase): Observable<StockItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(startDate?: Date | null | undefined, endDate?: Date | null | undefined, showFinishedLots?: boolean | undefined): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetAll?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (showFinishedLots === null)
            throw new globalThis.Error("The parameter 'showFinishedLots' cannot be null.");
        else if (showFinishedLots !== undefined)
            url_ += "showFinishedLots=" + encodeURIComponent("" + showFinishedLots) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStockOrders(type?: OrderType | undefined): Observable<StockOrderModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetStockOrders?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockOrderModel[]>;
        }));
    }

    protected processGetStockOrders(response: HttpResponseBase): Observable<StockOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStockOrdersForProductionOrder(id?: string | undefined): Observable<StockOrderModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetStockOrdersForProductionOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockOrdersForProductionOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockOrdersForProductionOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockOrderModel[]>;
        }));
    }

    protected processGetStockOrdersForProductionOrder(response: HttpResponseBase): Observable<StockOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByProductGroup(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, showFinishedLots?: boolean | undefined): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetByProductGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (showFinishedLots === null)
            throw new globalThis.Error("The parameter 'showFinishedLots' cannot be null.");
        else if (showFinishedLots !== undefined)
            url_ += "showFinishedLots=" + encodeURIComponent("" + showFinishedLots) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetByProductGroup(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByStockLocation(id?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, showFinishedLots?: boolean | undefined): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetByStockLocation?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (showFinishedLots === null)
            throw new globalThis.Error("The parameter 'showFinishedLots' cannot be null.");
        else if (showFinishedLots !== undefined)
            url_ += "showFinishedLots=" + encodeURIComponent("" + showFinishedLots) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByStockLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByStockLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetByStockLocation(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportByProductType(type?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/ExportByProductType?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportByProductType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportByProductType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportByProductType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportByProductGroup(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/ExportByProductGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportByProductGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportByProductGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportByProductGroup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportByStockLocation(id?: string | null | undefined, startDate?: string | undefined, endDate?: string | undefined, supplierId?: string | null | undefined, productGroupId?: string | null | undefined, productType?: string | null | undefined, searchText?: string | null | undefined, isQuantity?: boolean | undefined, onlyCurrentLocation?: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/ExportByStockLocation?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (supplierId !== undefined && supplierId !== null)
            url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (productGroupId !== undefined && productGroupId !== null)
            url_ += "productGroupId=" + encodeURIComponent("" + productGroupId) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (isQuantity === null)
            throw new globalThis.Error("The parameter 'isQuantity' cannot be null.");
        else if (isQuantity !== undefined)
            url_ += "isQuantity=" + encodeURIComponent("" + isQuantity) + "&";
        if (onlyCurrentLocation === null)
            throw new globalThis.Error("The parameter 'onlyCurrentLocation' cannot be null.");
        else if (onlyCurrentLocation !== undefined)
            url_ += "onlyCurrentLocation=" + encodeURIComponent("" + onlyCurrentLocation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportByStockLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportByStockLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportByStockLocation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    previewExcelImport(filename?: string | null | undefined): Observable<string[][]> {
        let url_ = this.baseUrl + "/api/StockItem/PreviewExcelImport?";
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewExcelImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewExcelImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[][]>;
        }));
    }

    protected processPreviewExcelImport(response: HttpResponseBase): Observable<string[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importExcel(filename?: string | null | undefined, configId?: string | undefined, orderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/ImportExcel?";
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (configId === null)
            throw new globalThis.Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (orderId === null)
            throw new globalThis.Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    previewExcelExport(pagedQuery: PagedQuery): Observable<string[][]> {
        let url_ = this.baseUrl + "/api/StockItem/PreviewExcelExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewExcelExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewExcelExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[][]>;
        }));
    }

    protected processPreviewExcelExport(response: HttpResponseBase): Observable<string[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportAll(startDate?: Date | null | undefined, endDate?: Date | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/ExportAll?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportAll(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recalculateActualCostPrices(startDate?: Date | undefined): Observable<PagedResultOfStockItemModel> {
        let url_ = this.baseUrl + "/api/StockItem/RecalculateActualCostPrices?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecalculateActualCostPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecalculateActualCostPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfStockItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfStockItemModel>;
        }));
    }

    protected processRecalculateActualCostPrices(response: HttpResponseBase): Observable<PagedResultOfStockItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfStockItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContributionRatio(startDate?: Date | undefined): Observable<ChartValue[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetContributionRatio?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContributionRatio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContributionRatio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChartValue[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChartValue[]>;
        }));
    }

    protected processGetContributionRatio(response: HttpResponseBase): Observable<ChartValue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChartValue.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportExcel(pagedQuery: PagedQuery): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/ExportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagedQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByProductType(type?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetByProductType?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetByProductType(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByProductType2(type?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, showFinishedLots?: boolean | undefined): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetByProductType2?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (showFinishedLots === null)
            throw new globalThis.Error("The parameter 'showFinishedLots' cannot be null.");
        else if (showFinishedLots !== undefined)
            url_ += "showFinishedLots=" + encodeURIComponent("" + showFinishedLots) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductType2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductType2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetByProductType2(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByLocation(id?: string | null | undefined, startOrderId?: string | undefined, endOrderId?: string | undefined, showFinishedLots?: boolean | undefined, onlyCurrentLocation?: boolean | undefined): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetByLocation?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startOrderId === null)
            throw new globalThis.Error("The parameter 'startOrderId' cannot be null.");
        else if (startOrderId !== undefined)
            url_ += "startOrderId=" + encodeURIComponent("" + startOrderId) + "&";
        if (endOrderId === null)
            throw new globalThis.Error("The parameter 'endOrderId' cannot be null.");
        else if (endOrderId !== undefined)
            url_ += "endOrderId=" + encodeURIComponent("" + endOrderId) + "&";
        if (showFinishedLots === null)
            throw new globalThis.Error("The parameter 'showFinishedLots' cannot be null.");
        else if (showFinishedLots !== undefined)
            url_ += "showFinishedLots=" + encodeURIComponent("" + showFinishedLots) + "&";
        if (onlyCurrentLocation === null)
            throw new globalThis.Error("The parameter 'onlyCurrentLocation' cannot be null.");
        else if (onlyCurrentLocation !== undefined)
            url_ += "onlyCurrentLocation=" + encodeURIComponent("" + onlyCurrentLocation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetByLocation(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatisticsReport(query: PagedQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/StockItem/GetStatisticsReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatisticsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatisticsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetStatisticsReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatisticsPaged(query: PagedQuery, type?: OrderType | undefined): Observable<PagedResultOfStockItemModel> {
        let url_ = this.baseUrl + "/api/StockItem/GetStatisticsPaged?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatisticsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatisticsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfStockItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfStockItemModel>;
        }));
    }

    protected processGetStatisticsPaged(response: HttpResponseBase): Observable<PagedResultOfStockItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfStockItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerStatisticsPaged(query: PagedQuery): Observable<PagedResultOfStockItemModel> {
        let url_ = this.baseUrl + "/api/StockItem/GetCustomerStatisticsPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerStatisticsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerStatisticsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfStockItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfStockItemModel>;
        }));
    }

    protected processGetCustomerStatisticsPaged(response: HttpResponseBase): Observable<PagedResultOfStockItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfStockItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByLocationPaged(query: PagedQuery): Observable<PagedResultOfStockItemModel> {
        let url_ = this.baseUrl + "/api/StockItem/GetByLocationPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByLocationPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByLocationPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfStockItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfStockItemModel>;
        }));
    }

    protected processGetByLocationPaged(response: HttpResponseBase): Observable<PagedResultOfStockItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfStockItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProductVariantLotsWithoutQuantities(productVariantId?: string | undefined, stockLocationId?: string | null | undefined, showFinished?: boolean | undefined): Observable<StockItemModel> {
        let url_ = this.baseUrl + "/api/StockItem/GetProductVariantLotsWithoutQuantities?";
        if (productVariantId === null)
            throw new globalThis.Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (stockLocationId !== undefined && stockLocationId !== null)
            url_ += "stockLocationId=" + encodeURIComponent("" + stockLocationId) + "&";
        if (showFinished === null)
            throw new globalThis.Error("The parameter 'showFinished' cannot be null.");
        else if (showFinished !== undefined)
            url_ += "showFinished=" + encodeURIComponent("" + showFinished) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductVariantLotsWithoutQuantities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductVariantLotsWithoutQuantities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel>;
        }));
    }

    protected processGetProductVariantLotsWithoutQuantities(response: HttpResponseBase): Observable<StockItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProductVariantLots(productVariantId?: string | undefined, stockLocationId?: string | null | undefined, showFinished?: boolean | undefined, unit?: string | null | undefined, includeLotId?: string | null | undefined): Observable<StockItemModel> {
        let url_ = this.baseUrl + "/api/StockItem/GetProductVariantLots?";
        if (productVariantId === null)
            throw new globalThis.Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (stockLocationId !== undefined && stockLocationId !== null)
            url_ += "stockLocationId=" + encodeURIComponent("" + stockLocationId) + "&";
        if (showFinished === null)
            throw new globalThis.Error("The parameter 'showFinished' cannot be null.");
        else if (showFinished !== undefined)
            url_ += "showFinished=" + encodeURIComponent("" + showFinished) + "&";
        if (unit !== undefined && unit !== null)
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        if (includeLotId !== undefined && includeLotId !== null)
            url_ += "includeLotId=" + encodeURIComponent("" + includeLotId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductVariantLots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductVariantLots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel>;
        }));
    }

    protected processGetProductVariantLots(response: HttpResponseBase): Observable<StockItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cacheProductVariant(productVariant?: string | undefined, stockLocationId?: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/StockItem/CacheProductVariant?";
        if (productVariant === null)
            throw new globalThis.Error("The parameter 'productVariant' cannot be null.");
        else if (productVariant !== undefined)
            url_ += "productVariant=" + encodeURIComponent("" + productVariant) + "&";
        if (stockLocationId !== undefined && stockLocationId !== null)
            url_ += "StockLocationId=" + encodeURIComponent("" + stockLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCacheProductVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCacheProductVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCacheProductVariant(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLotsByProductVariantId(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, showFinished?: boolean | undefined, stockLocationId?: string | null | undefined, unit?: string | null | undefined, includeLotId?: string | null | undefined): Observable<StockItemModel> {
        let url_ = this.baseUrl + "/api/StockItem/GetLotsByProductVariantId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (showFinished === null)
            throw new globalThis.Error("The parameter 'showFinished' cannot be null.");
        else if (showFinished !== undefined)
            url_ += "showFinished=" + encodeURIComponent("" + showFinished) + "&";
        if (stockLocationId !== undefined && stockLocationId !== null)
            url_ += "stockLocationId=" + encodeURIComponent("" + stockLocationId) + "&";
        if (unit !== undefined && unit !== null)
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        if (includeLotId !== undefined && includeLotId !== null)
            url_ += "includeLotId=" + encodeURIComponent("" + includeLotId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLotsByProductVariantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLotsByProductVariantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel>;
        }));
    }

    protected processGetLotsByProductVariantId(response: HttpResponseBase): Observable<StockItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchLots(productVariantId?: string | undefined, searchText?: string | null | undefined, includeFinished?: boolean | undefined): Observable<LotModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/SearchLots?";
        if (productVariantId === null)
            throw new globalThis.Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (includeFinished === null)
            throw new globalThis.Error("The parameter 'includeFinished' cannot be null.");
        else if (includeFinished !== undefined)
            url_ += "includeFinished=" + encodeURIComponent("" + includeFinished) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchLots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchLots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LotModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LotModel[]>;
        }));
    }

    protected processSearchLots(response: HttpResponseBase): Observable<LotModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LotModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLotById(id?: string | undefined): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetLotById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLotById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLotById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetLotById(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomersByLotId(id?: string | undefined): Observable<CustomerModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetCustomersByLotId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomersByLotId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomersByLotId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModel[]>;
        }));
    }

    protected processGetCustomersByLotId(response: HttpResponseBase): Observable<CustomerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByProductVariantId(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, stockLocationId?: string | null | undefined): Observable<StockItemModel> {
        let url_ = this.baseUrl + "/api/StockItem/GetByProductVariantId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (includeEquivalents === null)
            throw new globalThis.Error("The parameter 'includeEquivalents' cannot be null.");
        else if (includeEquivalents !== undefined)
            url_ += "includeEquivalents=" + encodeURIComponent("" + includeEquivalents) + "&";
        if (stockLocationId !== undefined && stockLocationId !== null)
            url_ += "stockLocationId=" + encodeURIComponent("" + stockLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductVariantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductVariantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel>;
        }));
    }

    protected processGetByProductVariantId(response: HttpResponseBase): Observable<StockItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBalances(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, fullProduct?: boolean | undefined, stockLocationId?: string | null | undefined): Observable<StockBalanceModel> {
        let url_ = this.baseUrl + "/api/StockItem/GetBalances?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (includeEquivalents === null)
            throw new globalThis.Error("The parameter 'includeEquivalents' cannot be null.");
        else if (includeEquivalents !== undefined)
            url_ += "includeEquivalents=" + encodeURIComponent("" + includeEquivalents) + "&";
        if (fullProduct === null)
            throw new globalThis.Error("The parameter 'fullProduct' cannot be null.");
        else if (fullProduct !== undefined)
            url_ += "fullProduct=" + encodeURIComponent("" + fullProduct) + "&";
        if (stockLocationId !== undefined && stockLocationId !== null)
            url_ += "stockLocationId=" + encodeURIComponent("" + stockLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBalances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBalances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockBalanceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockBalanceModel>;
        }));
    }

    protected processGetBalances(response: HttpResponseBase): Observable<StockBalanceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockBalanceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSpisemaerkeBalance(startDate?: Date | undefined, endDate?: Date | undefined): Observable<SpisemaerkeBalanceModel> {
        let url_ = this.baseUrl + "/api/StockItem/GetSpisemaerkeBalance?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpisemaerkeBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpisemaerkeBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpisemaerkeBalanceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpisemaerkeBalanceModel>;
        }));
    }

    protected processGetSpisemaerkeBalance(response: HttpResponseBase): Observable<SpisemaerkeBalanceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpisemaerkeBalanceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSpisemaerkeBalanceReport(startDate?: Date | undefined, endDate?: Date | undefined, type?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/StockItem/GetSpisemaerkeBalanceReport?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpisemaerkeBalanceReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpisemaerkeBalanceReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetSpisemaerkeBalanceReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProductOrdersForRawProduct(id?: string | undefined, startDate?: Date | undefined, endDate?: Date | undefined): Observable<StockBalanceModel> {
        let url_ = this.baseUrl + "/api/StockItem/GetProductOrdersForRawProduct?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductOrdersForRawProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductOrdersForRawProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockBalanceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockBalanceModel>;
        }));
    }

    protected processGetProductOrdersForRawProduct(response: HttpResponseBase): Observable<StockBalanceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockBalanceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBalancesByProductType(type?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, fullProduct?: boolean | undefined, onlyOrganic?: boolean | undefined, forceRecalculate?: boolean | undefined, searchText?: string | null | undefined, productGroup?: string | null | undefined, productType?: string | null | undefined, calculateInputOutput?: boolean | undefined): Observable<StockBalanceModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetBalancesByProductType?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (includeEquivalents === null)
            throw new globalThis.Error("The parameter 'includeEquivalents' cannot be null.");
        else if (includeEquivalents !== undefined)
            url_ += "includeEquivalents=" + encodeURIComponent("" + includeEquivalents) + "&";
        if (fullProduct === null)
            throw new globalThis.Error("The parameter 'fullProduct' cannot be null.");
        else if (fullProduct !== undefined)
            url_ += "fullProduct=" + encodeURIComponent("" + fullProduct) + "&";
        if (onlyOrganic === null)
            throw new globalThis.Error("The parameter 'onlyOrganic' cannot be null.");
        else if (onlyOrganic !== undefined)
            url_ += "onlyOrganic=" + encodeURIComponent("" + onlyOrganic) + "&";
        if (forceRecalculate === null)
            throw new globalThis.Error("The parameter 'forceRecalculate' cannot be null.");
        else if (forceRecalculate !== undefined)
            url_ += "forceRecalculate=" + encodeURIComponent("" + forceRecalculate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (productGroup !== undefined && productGroup !== null)
            url_ += "productGroup=" + encodeURIComponent("" + productGroup) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (calculateInputOutput === null)
            throw new globalThis.Error("The parameter 'calculateInputOutput' cannot be null.");
        else if (calculateInputOutput !== undefined)
            url_ += "calculateInputOutput=" + encodeURIComponent("" + calculateInputOutput) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBalancesByProductType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBalancesByProductType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockBalanceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockBalanceModel[]>;
        }));
    }

    protected processGetBalancesByProductType(response: HttpResponseBase): Observable<StockBalanceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockBalanceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBalancesByProductGroup(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, fullProduct?: boolean | undefined, onlyOrganic?: boolean | undefined, forceRecalculate?: boolean | undefined, searchText?: string | null | undefined, productGroup?: string | null | undefined, productType?: string | null | undefined, calculateInputOutput?: boolean | undefined): Observable<StockBalanceModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetBalancesByProductGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (includeEquivalents === null)
            throw new globalThis.Error("The parameter 'includeEquivalents' cannot be null.");
        else if (includeEquivalents !== undefined)
            url_ += "includeEquivalents=" + encodeURIComponent("" + includeEquivalents) + "&";
        if (fullProduct === null)
            throw new globalThis.Error("The parameter 'fullProduct' cannot be null.");
        else if (fullProduct !== undefined)
            url_ += "fullProduct=" + encodeURIComponent("" + fullProduct) + "&";
        if (onlyOrganic === null)
            throw new globalThis.Error("The parameter 'onlyOrganic' cannot be null.");
        else if (onlyOrganic !== undefined)
            url_ += "onlyOrganic=" + encodeURIComponent("" + onlyOrganic) + "&";
        if (forceRecalculate === null)
            throw new globalThis.Error("The parameter 'forceRecalculate' cannot be null.");
        else if (forceRecalculate !== undefined)
            url_ += "forceRecalculate=" + encodeURIComponent("" + forceRecalculate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (productGroup !== undefined && productGroup !== null)
            url_ += "productGroup=" + encodeURIComponent("" + productGroup) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (calculateInputOutput === null)
            throw new globalThis.Error("The parameter 'calculateInputOutput' cannot be null.");
        else if (calculateInputOutput !== undefined)
            url_ += "calculateInputOutput=" + encodeURIComponent("" + calculateInputOutput) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBalancesByProductGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBalancesByProductGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockBalanceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockBalanceModel[]>;
        }));
    }

    protected processGetBalancesByProductGroup(response: HttpResponseBase): Observable<StockBalanceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockBalanceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBalancesByStockLocation(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, fullProduct?: boolean | undefined, onlyOrganic?: boolean | undefined, forceRecalculate?: boolean | undefined, searchText?: string | null | undefined, productGroup?: string | null | undefined, productType?: string | null | undefined, calculateInputOutput?: boolean | undefined): Observable<StockBalanceModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetBalancesByStockLocation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (includeEquivalents === null)
            throw new globalThis.Error("The parameter 'includeEquivalents' cannot be null.");
        else if (includeEquivalents !== undefined)
            url_ += "includeEquivalents=" + encodeURIComponent("" + includeEquivalents) + "&";
        if (fullProduct === null)
            throw new globalThis.Error("The parameter 'fullProduct' cannot be null.");
        else if (fullProduct !== undefined)
            url_ += "fullProduct=" + encodeURIComponent("" + fullProduct) + "&";
        if (onlyOrganic === null)
            throw new globalThis.Error("The parameter 'onlyOrganic' cannot be null.");
        else if (onlyOrganic !== undefined)
            url_ += "onlyOrganic=" + encodeURIComponent("" + onlyOrganic) + "&";
        if (forceRecalculate === null)
            throw new globalThis.Error("The parameter 'forceRecalculate' cannot be null.");
        else if (forceRecalculate !== undefined)
            url_ += "forceRecalculate=" + encodeURIComponent("" + forceRecalculate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (productGroup !== undefined && productGroup !== null)
            url_ += "productGroup=" + encodeURIComponent("" + productGroup) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (calculateInputOutput === null)
            throw new globalThis.Error("The parameter 'calculateInputOutput' cannot be null.");
        else if (calculateInputOutput !== undefined)
            url_ += "calculateInputOutput=" + encodeURIComponent("" + calculateInputOutput) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBalancesByStockLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBalancesByStockLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockBalanceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockBalanceModel[]>;
        }));
    }

    protected processGetBalancesByStockLocation(response: HttpResponseBase): Observable<StockBalanceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockBalanceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllBalances(startDate?: Date | null | undefined, endDate?: Date | null | undefined, includeEquivalents?: boolean | undefined, fullProduct?: boolean | undefined, onlyOrganic?: boolean | undefined, forceRecalculate?: boolean | undefined, searchText?: string | null | undefined, productGroup?: string | null | undefined, productType?: string | null | undefined, calculateInputOutput?: boolean | undefined): Observable<StockBalanceModel[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetAllBalances?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (includeEquivalents === null)
            throw new globalThis.Error("The parameter 'includeEquivalents' cannot be null.");
        else if (includeEquivalents !== undefined)
            url_ += "includeEquivalents=" + encodeURIComponent("" + includeEquivalents) + "&";
        if (fullProduct === null)
            throw new globalThis.Error("The parameter 'fullProduct' cannot be null.");
        else if (fullProduct !== undefined)
            url_ += "fullProduct=" + encodeURIComponent("" + fullProduct) + "&";
        if (onlyOrganic === null)
            throw new globalThis.Error("The parameter 'onlyOrganic' cannot be null.");
        else if (onlyOrganic !== undefined)
            url_ += "onlyOrganic=" + encodeURIComponent("" + onlyOrganic) + "&";
        if (forceRecalculate === null)
            throw new globalThis.Error("The parameter 'forceRecalculate' cannot be null.");
        else if (forceRecalculate !== undefined)
            url_ += "forceRecalculate=" + encodeURIComponent("" + forceRecalculate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (productGroup !== undefined && productGroup !== null)
            url_ += "productGroup=" + encodeURIComponent("" + productGroup) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (calculateInputOutput === null)
            throw new globalThis.Error("The parameter 'calculateInputOutput' cannot be null.");
        else if (calculateInputOutput !== undefined)
            url_ += "calculateInputOutput=" + encodeURIComponent("" + calculateInputOutput) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBalances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBalances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockBalanceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockBalanceModel[]>;
        }));
    }

    protected processGetAllBalances(response: HttpResponseBase): Observable<StockBalanceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockBalanceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createMissingStockItems(productGroupId?: string | undefined): Observable<StockItemModel> {
        let url_ = this.baseUrl + "/api/StockItem/CreateMissingStockItems?";
        if (productGroupId === null)
            throw new globalThis.Error("The parameter 'productGroupId' cannot be null.");
        else if (productGroupId !== undefined)
            url_ += "productGroupId=" + encodeURIComponent("" + productGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMissingStockItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMissingStockItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel>;
        }));
    }

    protected processCreateMissingStockItems(response: HttpResponseBase): Observable<StockItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addLot(model: AddLotModel): Observable<LotModel> {
        let url_ = this.baseUrl + "/api/StockItem/AddLot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LotModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LotModel>;
        }));
    }

    protected processAddLot(response: HttpResponseBase): Observable<LotModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LotModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLot(model: LotModel): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/UpdateLot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateLot(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateQuantity(stockItems: StockItemModels): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/UpdateQuantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockItems);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateQuantity(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLotQuantity(stockItems: StockItemModels): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/UpdateLotQuantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockItems);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLotQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLotQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateLotQuantity(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStatusForVariant(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/UpdateStatusForVariant?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusForVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusForVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateStatusForVariant(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLotStatusAllProducts(): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/UpdateLotStatusAllProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLotStatusAllProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLotStatusAllProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateLotStatusAllProducts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStockLevelWarnings(query?: PagedQuery | undefined): Observable<PagedResultOfStockItemModel> {
        let url_ = this.baseUrl + "/api/StockItem/GetStockLevelWarnings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockLevelWarnings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockLevelWarnings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfStockItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfStockItemModel>;
        }));
    }

    protected processGetStockLevelWarnings(response: HttpResponseBase): Observable<PagedResultOfStockItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfStockItemModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recalculateTransactions(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/RecalculateTransactions?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecalculateTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecalculateTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRecalculateTransactions(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteLot(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/DeleteLot?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteLot(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    barLot(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/BarLot?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBarLot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBarLot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBarLot(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releaseLot(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/ReleaseLot?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseLot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseLot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processReleaseLot(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    finishLot(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/FinishLot?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishLot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishLot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFinishLot(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateLot(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/ActivateLot?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateLot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateLot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processActivateLot(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getForecast(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/StockItem/GetForecast";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecast(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecast(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetForecast(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    stockTakeFillZeroes(query: PagedQuery): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/StockTakeFillZeroes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStockTakeFillZeroes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStockTakeFillZeroes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStockTakeFillZeroes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportByProductTypePdf(type?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/ExportByProductTypePdf?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportByProductTypePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportByProductTypePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportByProductTypePdf(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportBalancePdf(id?: string | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, fullProduct?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/StockItem/ExportBalancePdf?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (fullProduct === null)
            throw new globalThis.Error("The parameter 'fullProduct' cannot be null.");
        else if (fullProduct !== undefined)
            url_ += "fullProduct=" + encodeURIComponent("" + fullProduct) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBalancePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBalancePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportBalancePdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportBalanceListPdf(id?: string | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, fullProduct?: boolean | undefined, onlyOrganic?: boolean | undefined, productType?: string | null | undefined, threshold?: number | undefined, productGroupId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/StockItem/ExportBalanceListPdf?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (fullProduct === null)
            throw new globalThis.Error("The parameter 'fullProduct' cannot be null.");
        else if (fullProduct !== undefined)
            url_ += "fullProduct=" + encodeURIComponent("" + fullProduct) + "&";
        if (onlyOrganic === null)
            throw new globalThis.Error("The parameter 'onlyOrganic' cannot be null.");
        else if (onlyOrganic !== undefined)
            url_ += "onlyOrganic=" + encodeURIComponent("" + onlyOrganic) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (threshold === null)
            throw new globalThis.Error("The parameter 'threshold' cannot be null.");
        else if (threshold !== undefined)
            url_ += "threshold=" + encodeURIComponent("" + threshold) + "&";
        if (productGroupId !== undefined && productGroupId !== null)
            url_ += "productGroupId=" + encodeURIComponent("" + productGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBalanceListPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBalanceListPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportBalanceListPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fixDuplicateLots(organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockItem/FixDuplicateLots?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixDuplicateLots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixDuplicateLots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFixDuplicateLots(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStockLocationService {
    /**
     * Get StockLocation
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<StockLocationModel>;
    /**
     * Get StockLocation by Supplier
     */
    getAll(): Observable<StockLocationModel[]>;
    /**
     * Add or update StockLocation
     */
    post(model: StockLocationModel): Observable<StockLocationModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class StockLocationService implements IStockLocationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get StockLocation
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<StockLocationModel> {
        let url_ = this.baseUrl + "/api/StockLocation/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockLocationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockLocationModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StockLocationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockLocationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get StockLocation by Supplier
     */
    getAll(): Observable<StockLocationModel[]> {
        let url_ = this.baseUrl + "/api/StockLocation/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockLocationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockLocationModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StockLocationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockLocationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update StockLocation
     */
    post(model: StockLocationModel): Observable<StockLocationModel> {
        let url_ = this.baseUrl + "/api/StockLocation/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockLocationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockLocationModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<StockLocationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockLocationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockLocation/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStockOrderService {
    /**
     * Get Order
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<StockOrderModel>;
    /**
     * Get all orders for User
     * @param type (optional) 
     */
    getByType(type?: OrderType | undefined): Observable<StockOrderModel[]>;
    /**
     * Get all orders for User
     */
    getAll(): Observable<StockOrderModel[]>;
    /**
     * Get all orders with specified status
     * @param status (optional) 
     * @param type (optional) 
     */
    getByStatus(status?: OrderStatus | undefined, type?: OrderType | undefined): Observable<StockOrderModel[]>;
    /**
     * Get all orders with specified status
     * @param stockLocationId (optional) 
     * @param orderType (optional) 
     */
    getByStockLocation(stockLocationId?: string | null | undefined, orderType?: OrderType | null | undefined): Observable<StockOrderModel[]>;
    checkStockOrder(id?: string | undefined): Observable<string>;
    calculateLotTotals(id?: string | undefined): Observable<string>;
    import(fileName?: string | null | undefined, stockOrderId?: string | undefined): Observable<string>;
    getPdf(id?: string | undefined): Observable<FileResponse>;
    getDeliveryNote(id?: string | undefined, lines?: string | null | undefined): Observable<FileResponse>;
    getOrderDocument(id?: string | undefined, lines?: string | null | undefined, type?: string | null | undefined, configId?: string | null | undefined, documentType?: OrderStatus | undefined): Observable<FileResponse>;
    /**
     * Add or update Order
     */
    post(model: StockOrderModel): Observable<StockOrderModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class StockOrderService implements IStockOrderService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Order
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<StockOrderModel> {
        let url_ = this.baseUrl + "/api/StockOrder/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockOrderModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StockOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders for User
     * @param type (optional) 
     */
    getByType(type?: OrderType | undefined): Observable<StockOrderModel[]> {
        let url_ = this.baseUrl + "/api/StockOrder/GetByType?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockOrderModel[]>;
        }));
    }

    protected processGetByType(response: HttpResponseBase): Observable<StockOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders for User
     */
    getAll(): Observable<StockOrderModel[]> {
        let url_ = this.baseUrl + "/api/StockOrder/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockOrderModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StockOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders with specified status
     * @param status (optional) 
     * @param type (optional) 
     */
    getByStatus(status?: OrderStatus | undefined, type?: OrderType | undefined): Observable<StockOrderModel[]> {
        let url_ = this.baseUrl + "/api/StockOrder/GetByStatus?";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockOrderModel[]>;
        }));
    }

    protected processGetByStatus(response: HttpResponseBase): Observable<StockOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders with specified status
     * @param stockLocationId (optional) 
     * @param orderType (optional) 
     */
    getByStockLocation(stockLocationId?: string | null | undefined, orderType?: OrderType | null | undefined): Observable<StockOrderModel[]> {
        let url_ = this.baseUrl + "/api/StockOrder/GetByStockLocation?";
        if (stockLocationId !== undefined && stockLocationId !== null)
            url_ += "stockLocationId=" + encodeURIComponent("" + stockLocationId) + "&";
        if (orderType !== undefined && orderType !== null)
            url_ += "orderType=" + encodeURIComponent("" + orderType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByStockLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByStockLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockOrderModel[]>;
        }));
    }

    protected processGetByStockLocation(response: HttpResponseBase): Observable<StockOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOrderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkStockOrder(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockOrder/CheckStockOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckStockOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckStockOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckStockOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateLotTotals(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockOrder/CalculateLotTotals?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateLotTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateLotTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCalculateLotTotals(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(fileName?: string | null | undefined, stockOrderId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockOrder/Import?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (stockOrderId === null)
            throw new globalThis.Error("The parameter 'stockOrderId' cannot be null.");
        else if (stockOrderId !== undefined)
            url_ += "stockOrderId=" + encodeURIComponent("" + stockOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPdf(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/StockOrder/GetPdf?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDeliveryNote(id?: string | undefined, lines?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/StockOrder/GetDeliveryNote?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (lines !== undefined && lines !== null)
            url_ += "lines=" + encodeURIComponent("" + lines) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDeliveryNote(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrderDocument(id?: string | undefined, lines?: string | null | undefined, type?: string | null | undefined, configId?: string | null | undefined, documentType?: OrderStatus | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/StockOrder/GetOrderDocument?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (lines !== undefined && lines !== null)
            url_ += "lines=" + encodeURIComponent("" + lines) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (configId !== undefined && configId !== null)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (documentType === null)
            throw new globalThis.Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetOrderDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Order
     */
    post(model: StockOrderModel): Observable<StockOrderModel> {
        let url_ = this.baseUrl + "/api/StockOrder/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockOrderModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<StockOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockOrder/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStockPositionService {
    /**
     * Get StockLocation
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<StockPositionModel>;
    getPositionText(id?: string | undefined): Observable<StockPositionModel>;
    /**
     * Get StockLocation by Supplier
     */
    getAll(): Observable<StockPositionModel[]>;
    getByLocation(id?: string | undefined, parentId?: string | null | undefined): Observable<StockPositionModel[]>;
    getByProductVariant(id?: string | undefined): Observable<StockPositionModel[]>;
    getByProductVariantLot(id?: string | undefined): Observable<StockPositionModel[]>;
    getAvailable(typeId?: string | undefined, stockLocationId?: string | undefined): Observable<StockPositionModel[]>;
    getItemsByPosition(positionId?: string | undefined): Observable<StockItemModel[]>;
    getLabel(id?: string | undefined): Observable<FileResponse>;
    /**
     * Add or update StockLocation
     */
    post(model: StockPositionModel): Observable<StockPositionModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class StockPositionService implements IStockPositionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get StockLocation
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<StockPositionModel> {
        let url_ = this.baseUrl + "/api/StockPosition/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockPositionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockPositionModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StockPositionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockPositionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionText(id?: string | undefined): Observable<StockPositionModel> {
        let url_ = this.baseUrl + "/api/StockPosition/GetPositionText?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockPositionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockPositionModel>;
        }));
    }

    protected processGetPositionText(response: HttpResponseBase): Observable<StockPositionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockPositionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get StockLocation by Supplier
     */
    getAll(): Observable<StockPositionModel[]> {
        let url_ = this.baseUrl + "/api/StockPosition/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockPositionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockPositionModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StockPositionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockPositionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByLocation(id?: string | undefined, parentId?: string | null | undefined): Observable<StockPositionModel[]> {
        let url_ = this.baseUrl + "/api/StockPosition/GetByLocation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockPositionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockPositionModel[]>;
        }));
    }

    protected processGetByLocation(response: HttpResponseBase): Observable<StockPositionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockPositionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByProductVariant(id?: string | undefined): Observable<StockPositionModel[]> {
        let url_ = this.baseUrl + "/api/StockPosition/GetByProductVariant?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockPositionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockPositionModel[]>;
        }));
    }

    protected processGetByProductVariant(response: HttpResponseBase): Observable<StockPositionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockPositionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByProductVariantLot(id?: string | undefined): Observable<StockPositionModel[]> {
        let url_ = this.baseUrl + "/api/StockPosition/GetByProductVariantLot?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProductVariantLot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductVariantLot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockPositionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockPositionModel[]>;
        }));
    }

    protected processGetByProductVariantLot(response: HttpResponseBase): Observable<StockPositionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockPositionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailable(typeId?: string | undefined, stockLocationId?: string | undefined): Observable<StockPositionModel[]> {
        let url_ = this.baseUrl + "/api/StockPosition/GetAvailable?";
        if (typeId === null)
            throw new globalThis.Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        if (stockLocationId === null)
            throw new globalThis.Error("The parameter 'stockLocationId' cannot be null.");
        else if (stockLocationId !== undefined)
            url_ += "stockLocationId=" + encodeURIComponent("" + stockLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockPositionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockPositionModel[]>;
        }));
    }

    protected processGetAvailable(response: HttpResponseBase): Observable<StockPositionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockPositionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getItemsByPosition(positionId?: string | undefined): Observable<StockItemModel[]> {
        let url_ = this.baseUrl + "/api/StockPosition/GetItemsByPosition?";
        if (positionId === null)
            throw new globalThis.Error("The parameter 'positionId' cannot be null.");
        else if (positionId !== undefined)
            url_ += "positionId=" + encodeURIComponent("" + positionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItemsByPosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemsByPosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockItemModel[]>;
        }));
    }

    protected processGetItemsByPosition(response: HttpResponseBase): Observable<StockItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLabel(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/StockPosition/GetLabel?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLabel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update StockLocation
     */
    post(model: StockPositionModel): Observable<StockPositionModel> {
        let url_ = this.baseUrl + "/api/StockPosition/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockPositionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockPositionModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<StockPositionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockPositionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockPosition/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStockPositionTypeService {
    /**
     * Get StockLocation
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<StockPositionTypeModel>;
    /**
     * Get StockLocation by Supplier
     */
    getAll(): Observable<StockPositionTypeModel[]>;
    /**
     * Add or update StockLocation
     */
    post(model: StockPositionTypeModel): Observable<StockPositionTypeModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class StockPositionTypeService implements IStockPositionTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get StockLocation
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<StockPositionTypeModel> {
        let url_ = this.baseUrl + "/api/StockPositionType/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockPositionTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockPositionTypeModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StockPositionTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockPositionTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get StockLocation by Supplier
     */
    getAll(): Observable<StockPositionTypeModel[]> {
        let url_ = this.baseUrl + "/api/StockPositionType/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockPositionTypeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockPositionTypeModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StockPositionTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockPositionTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update StockLocation
     */
    post(model: StockPositionTypeModel): Observable<StockPositionTypeModel> {
        let url_ = this.baseUrl + "/api/StockPositionType/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockPositionTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockPositionTypeModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<StockPositionTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockPositionTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/StockPositionType/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISupplierService {
    /**
     * Get Supplier
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<SupplierModel>;
    /**
     * Get Supplier
     * @param id (optional) 
     */
    getByGroup(id?: string | undefined): Observable<SupplierModel[]>;
    /**
     * Get all Suppliers
     */
    getAll(): Observable<SupplierModel[]>;
    getAllPaged(query: PagedQuery): Observable<PagedResultOfSupplierModel>;
    searchSuppliers(searchText?: string | null | undefined): Observable<SupplierModel[]>;
    /**
     * Add or update Supplier
     */
    post(model: SupplierModel): Observable<SupplierModel>;
    delete(id?: string | undefined): Observable<string>;
    getOrganicCertificate(supplierId?: string | undefined): Observable<string>;
    /**
     * Import Suppliers
     * @param fileName (optional) 
     */
    import(fileName?: string | null | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class SupplierService implements ISupplierService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Supplier
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<SupplierModel> {
        let url_ = this.baseUrl + "/api/Supplier/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SupplierModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Supplier
     * @param id (optional) 
     */
    getByGroup(id?: string | undefined): Observable<SupplierModel[]> {
        let url_ = this.baseUrl + "/api/Supplier/GetByGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierModel[]>;
        }));
    }

    protected processGetByGroup(response: HttpResponseBase): Observable<SupplierModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Suppliers
     */
    getAll(): Observable<SupplierModel[]> {
        let url_ = this.baseUrl + "/api/Supplier/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SupplierModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPaged(query: PagedQuery): Observable<PagedResultOfSupplierModel> {
        let url_ = this.baseUrl + "/api/Supplier/GetAllPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfSupplierModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfSupplierModel>;
        }));
    }

    protected processGetAllPaged(response: HttpResponseBase): Observable<PagedResultOfSupplierModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfSupplierModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchSuppliers(searchText?: string | null | undefined): Observable<SupplierModel[]> {
        let url_ = this.baseUrl + "/api/Supplier/SearchSuppliers?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSuppliers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierModel[]>;
        }));
    }

    protected processSearchSuppliers(response: HttpResponseBase): Observable<SupplierModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Supplier
     */
    post(model: SupplierModel): Observable<SupplierModel> {
        let url_ = this.baseUrl + "/api/Supplier/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<SupplierModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Supplier/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrganicCertificate(supplierId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Supplier/GetOrganicCertificate?";
        if (supplierId === null)
            throw new globalThis.Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganicCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganicCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetOrganicCertificate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Import Suppliers
     * @param fileName (optional) 
     */
    import(fileName?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Supplier/Import?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISupplierGroupService {
    /**
     * Get SupplierGroup
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<SupplierGroupModel>;
    /**
     * Get SupplierGroup by Supplier
     */
    getAll(): Observable<SupplierGroupModel[]>;
    /**
     * Add or update SupplierGroup
     */
    post(model: SupplierGroupModel): Observable<SupplierGroupModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class SupplierGroupService implements ISupplierGroupService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get SupplierGroup
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<SupplierGroupModel> {
        let url_ = this.baseUrl + "/api/SupplierGroup/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierGroupModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SupplierGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get SupplierGroup by Supplier
     */
    getAll(): Observable<SupplierGroupModel[]> {
        let url_ = this.baseUrl + "/api/SupplierGroup/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierGroupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierGroupModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SupplierGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierGroupModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update SupplierGroup
     */
    post(model: SupplierGroupModel): Observable<SupplierGroupModel> {
        let url_ = this.baseUrl + "/api/SupplierGroup/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierGroupModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<SupplierGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/SupplierGroup/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISupportService {
    getUsersInSessions(): Observable<UserModel[]>;
    getResponsibleUsersInSessions(): Observable<UserModel[]>;
    getOrganizationsInSessions(): Observable<OrganizationModel[]>;
    getSupportSession(id?: string | undefined): Observable<SupportSessionModel>;
    getAllSupportSessions(organizationId?: string | null | undefined, userId?: string | null | undefined, responsibleUserId?: string | null | undefined, status?: SupportSessionStatusEnum | null | undefined, isDeleted?: boolean | null | undefined, category?: SupportSessionCategoryEnum | null | undefined, priority?: SupportSessionPriorityEnum | null | undefined): Observable<SupportSessionModel[]>;
    getSupportSessionActivitiesBySessionId(sessionId?: string | undefined): Observable<SupportSessionActivityModel[]>;
    createOrUpdateSupportSession(model: SupportSessionModel): Observable<SupportSessionModel>;
}

@Injectable({
    providedIn: 'root'
})
export class SupportService implements ISupportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUsersInSessions(): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/Support/GetUsersInSessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersInSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersInSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetUsersInSessions(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getResponsibleUsersInSessions(): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/Support/GetResponsibleUsersInSessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResponsibleUsersInSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResponsibleUsersInSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetResponsibleUsersInSessions(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrganizationsInSessions(): Observable<OrganizationModel[]> {
        let url_ = this.baseUrl + "/api/Support/GetOrganizationsInSessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationsInSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationsInSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationModel[]>;
        }));
    }

    protected processGetOrganizationsInSessions(response: HttpResponseBase): Observable<OrganizationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSupportSession(id?: string | undefined): Observable<SupportSessionModel> {
        let url_ = this.baseUrl + "/api/Support/GetSupportSession?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportSessionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportSessionModel>;
        }));
    }

    protected processGetSupportSession(response: HttpResponseBase): Observable<SupportSessionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportSessionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllSupportSessions(organizationId?: string | null | undefined, userId?: string | null | undefined, responsibleUserId?: string | null | undefined, status?: SupportSessionStatusEnum | null | undefined, isDeleted?: boolean | null | undefined, category?: SupportSessionCategoryEnum | null | undefined, priority?: SupportSessionPriorityEnum | null | undefined): Observable<SupportSessionModel[]> {
        let url_ = this.baseUrl + "/api/Support/GetAllSupportSessions?";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (responsibleUserId !== undefined && responsibleUserId !== null)
            url_ += "responsibleUserId=" + encodeURIComponent("" + responsibleUserId) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (isDeleted !== undefined && isDeleted !== null)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (category !== undefined && category !== null)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (priority !== undefined && priority !== null)
            url_ += "priority=" + encodeURIComponent("" + priority) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSupportSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSupportSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportSessionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportSessionModel[]>;
        }));
    }

    protected processGetAllSupportSessions(response: HttpResponseBase): Observable<SupportSessionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupportSessionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSupportSessionActivitiesBySessionId(sessionId?: string | undefined): Observable<SupportSessionActivityModel[]> {
        let url_ = this.baseUrl + "/api/Support/GetSupportSessionActivitiesBySessionId?";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportSessionActivitiesBySessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportSessionActivitiesBySessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportSessionActivityModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportSessionActivityModel[]>;
        }));
    }

    protected processGetSupportSessionActivitiesBySessionId(response: HttpResponseBase): Observable<SupportSessionActivityModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupportSessionActivityModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrUpdateSupportSession(model: SupportSessionModel): Observable<SupportSessionModel> {
        let url_ = this.baseUrl + "/api/Support/CreateOrUpdateSupportSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateSupportSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateSupportSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportSessionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportSessionModel>;
        }));
    }

    protected processCreateOrUpdateSupportSession(response: HttpResponseBase): Observable<SupportSessionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportSessionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISurveyAnswerService {
    getAll(): Observable<SurveyResultModel[]>;
    get(id?: string | undefined): Observable<SurveyResultModel>;
    getNewestByOrganizationId(organizationId?: string | undefined): Observable<SurveyResultModel>;
    getAnswersForSurvey(surveyId?: string | undefined): Observable<SurveyResultModel[]>;
    getData(model: SurveyAnswerModel[]): Observable<QsSurveyAnswer[]>;
    post(surveyResult: SurveyResultModel): Observable<SurveyResultModel>;
    getReport(type?: string | null | undefined, answerId?: string | undefined): Observable<FileResponse>;
    delete(id?: string | undefined): Observable<string>;
    deleteAnswer(id?: string | undefined): Observable<string>;
    setAsFinished(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class SurveyAnswerService implements ISurveyAnswerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<SurveyResultModel[]> {
        let url_ = this.baseUrl + "/api/SurveyAnswer/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyResultModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyResultModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SurveyResultModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyResultModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id?: string | undefined): Observable<SurveyResultModel> {
        let url_ = this.baseUrl + "/api/SurveyAnswer/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyResultModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SurveyResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNewestByOrganizationId(organizationId?: string | undefined): Observable<SurveyResultModel> {
        let url_ = this.baseUrl + "/api/SurveyAnswer/GetNewestByOrganizationId?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewestByOrganizationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewestByOrganizationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyResultModel>;
        }));
    }

    protected processGetNewestByOrganizationId(response: HttpResponseBase): Observable<SurveyResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAnswersForSurvey(surveyId?: string | undefined): Observable<SurveyResultModel[]> {
        let url_ = this.baseUrl + "/api/SurveyAnswer/GetAnswersForSurvey?";
        if (surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' cannot be null.");
        else if (surveyId !== undefined)
            url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnswersForSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnswersForSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyResultModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyResultModel[]>;
        }));
    }

    protected processGetAnswersForSurvey(response: HttpResponseBase): Observable<SurveyResultModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyResultModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getData(model: SurveyAnswerModel[]): Observable<QsSurveyAnswer[]> {
        let url_ = this.baseUrl + "/api/SurveyAnswer/GetData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QsSurveyAnswer[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QsSurveyAnswer[]>;
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<QsSurveyAnswer[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QsSurveyAnswer.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(surveyResult: SurveyResultModel): Observable<SurveyResultModel> {
        let url_ = this.baseUrl + "/api/SurveyAnswer/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyResult);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyResultModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<SurveyResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(type?: string | null | undefined, answerId?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SurveyAnswer/GetReport?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (answerId === null)
            throw new globalThis.Error("The parameter 'answerId' cannot be null.");
        else if (answerId !== undefined)
            url_ += "answerId=" + encodeURIComponent("" + answerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/SurveyAnswer/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAnswer(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/SurveyAnswer/DeleteAnswer?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAnswer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAnswer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteAnswer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setAsFinished(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/SurveyAnswer/SetAsFinished?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAsFinished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAsFinished(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSetAsFinished(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISurveyService {
    /**
     * Get Resource
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<SurveyModel>;
    /**
     * Get Resource by Supplier
     */
    getAll(): Observable<SurveyModel[]>;
    getByOrganization(organizationId?: string | undefined): Observable<SurveyModel[]>;
    /**
     * Get Resource
     * @param id (optional) 
     */
    copy(id?: string | undefined): Observable<SurveyModel>;
    /**
     * Add or update Resource
     */
    post(model: SurveyModel): Observable<SurveyModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class SurveyService implements ISurveyService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Resource
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<SurveyModel> {
        let url_ = this.baseUrl + "/api/Survey/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SurveyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource by Supplier
     */
    getAll(): Observable<SurveyModel[]> {
        let url_ = this.baseUrl + "/api/Survey/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SurveyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByOrganization(organizationId?: string | undefined): Observable<SurveyModel[]> {
        let url_ = this.baseUrl + "/api/Survey/GetByOrganization?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyModel[]>;
        }));
    }

    protected processGetByOrganization(response: HttpResponseBase): Observable<SurveyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Resource
     * @param id (optional) 
     */
    copy(id?: string | undefined): Observable<SurveyModel> {
        let url_ = this.baseUrl + "/api/Survey/Copy?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<SurveyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update Resource
     */
    post(model: SurveyModel): Observable<SurveyModel> {
        let url_ = this.baseUrl + "/api/Survey/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<SurveyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Survey/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISurveyQuestionService {
    getAll(): Observable<SurveyQuestionModel[]>;
    get(id?: string | undefined): Observable<SurveyQuestionModel>;
    post(model: SurveyQuestionModel): Observable<SurveyQuestionModel>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class SurveyQuestionService implements ISurveyQuestionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<SurveyQuestionModel[]> {
        let url_ = this.baseUrl + "/api/SurveyQuestion/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyQuestionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyQuestionModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SurveyQuestionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyQuestionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id?: string | undefined): Observable<SurveyQuestionModel> {
        let url_ = this.baseUrl + "/api/SurveyQuestion/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyQuestionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyQuestionModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SurveyQuestionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyQuestionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: SurveyQuestionModel): Observable<SurveyQuestionModel> {
        let url_ = this.baseUrl + "/api/SurveyQuestion/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyQuestionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyQuestionModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<SurveyQuestionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyQuestionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/SurveyQuestion/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISurveySectionService {
    getAll(): Observable<SurveySectionModel[]>;
    get(id?: string | undefined): Observable<SurveySectionModel>;
    post(model: SurveySectionModel): Observable<SurveySectionModel>;
    delete(id?: string | undefined): Observable<string>;
    saveSort(model: SurveySectionModel): Observable<SurveySectionModel>;
}

@Injectable({
    providedIn: 'root'
})
export class SurveySectionService implements ISurveySectionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<SurveySectionModel[]> {
        let url_ = this.baseUrl + "/api/SurveySection/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveySectionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveySectionModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SurveySectionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveySectionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id?: string | undefined): Observable<SurveySectionModel> {
        let url_ = this.baseUrl + "/api/SurveySection/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveySectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveySectionModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SurveySectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveySectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: SurveySectionModel): Observable<SurveySectionModel> {
        let url_ = this.baseUrl + "/api/SurveySection/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveySectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveySectionModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<SurveySectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveySectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/SurveySection/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveSort(model: SurveySectionModel): Observable<SurveySectionModel> {
        let url_ = this.baseUrl + "/api/SurveySection/SaveSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveySectionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveySectionModel>;
        }));
    }

    protected processSaveSort(response: HttpResponseBase): Observable<SurveySectionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveySectionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISurveyUIService {
    getSurveyConfigurations(model: SurveyModel): Observable<SurveyUIModel>;
}

@Injectable({
    providedIn: 'root'
})
export class SurveyUIService implements ISurveyUIService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSurveyConfigurations(model: SurveyModel): Observable<SurveyUIModel> {
        let url_ = this.baseUrl + "/api/SurveyUI/getSurveyConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyUIModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyUIModel>;
        }));
    }

    protected processGetSurveyConfigurations(response: HttpResponseBase): Observable<SurveyUIModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyUIModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITimeRegistrationService {
    getTimeRegistrationUsers(): Observable<UserModel[]>;
    getTimeRegistrationsByUser(id?: string | undefined): Observable<TimeRegistrationModel[]>;
    getCalculatedTimeRegistrationsByUser(id?: string | undefined, startDate?: Date | undefined, endDate?: Date | undefined, pin?: string | null | undefined): Observable<TimeRegistrationModel[]>;
    exportRegistrations(startDate?: Date | undefined, endDate?: Date | undefined): Observable<string>;
    postTimeRegistration(model: TimeRegistrationModel): Observable<string>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class TimeRegistrationService implements ITimeRegistrationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTimeRegistrationUsers(): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/TimeRegistration/GetTimeRegistrationUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeRegistrationUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeRegistrationUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetTimeRegistrationUsers(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTimeRegistrationsByUser(id?: string | undefined): Observable<TimeRegistrationModel[]> {
        let url_ = this.baseUrl + "/api/TimeRegistration/GetTimeRegistrationsByUser?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeRegistrationsByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeRegistrationsByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeRegistrationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeRegistrationModel[]>;
        }));
    }

    protected processGetTimeRegistrationsByUser(response: HttpResponseBase): Observable<TimeRegistrationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeRegistrationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCalculatedTimeRegistrationsByUser(id?: string | undefined, startDate?: Date | undefined, endDate?: Date | undefined, pin?: string | null | undefined): Observable<TimeRegistrationModel[]> {
        let url_ = this.baseUrl + "/api/TimeRegistration/GetCalculatedTimeRegistrationsByUser?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pin !== undefined && pin !== null)
            url_ += "pin=" + encodeURIComponent("" + pin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculatedTimeRegistrationsByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculatedTimeRegistrationsByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeRegistrationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeRegistrationModel[]>;
        }));
    }

    protected processGetCalculatedTimeRegistrationsByUser(response: HttpResponseBase): Observable<TimeRegistrationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeRegistrationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportRegistrations(startDate?: Date | undefined, endDate?: Date | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TimeRegistration/ExportRegistrations?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRegistrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRegistrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportRegistrations(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postTimeRegistration(model: TimeRegistrationModel): Observable<string> {
        let url_ = this.baseUrl + "/api/TimeRegistration/PostTimeRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTimeRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTimeRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPostTimeRegistration(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TimeRegistration/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITranslateTextService {
    translateText(textToTranslate?: string | null | undefined, language?: string | null | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class TranslateTextService implements ITranslateTextService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    translateText(textToTranslate?: string | null | undefined, language?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TranslateText/TranslateText?";
        if (textToTranslate !== undefined && textToTranslate !== null)
            url_ += "textToTranslate=" + encodeURIComponent("" + textToTranslate) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTranslateText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTranslateText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTranslateText(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUnitService {
    get(id?: string | undefined): Observable<UnitModel>;
    getAll(): Observable<UnitModel[]>;
    post(model: UnitModel): Observable<UnitModel>;
}

@Injectable({
    providedIn: 'root'
})
export class UnitService implements IUnitService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id?: string | undefined): Observable<UnitModel> {
        let url_ = this.baseUrl + "/api/Unit/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UnitModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<UnitModel[]> {
        let url_ = this.baseUrl + "/api/Unit/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UnitModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(model: UnitModel): Observable<UnitModel> {
        let url_ = this.baseUrl + "/api/Unit/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<UnitModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserService {
    /**
     * Get User
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<UserModel>;
    getUsersWithPermission(permissionName?: string | null | undefined, organizationId?: string | undefined): Observable<UserModel[]>;
    /**
     * Get User
     * @param email (optional) 
     */
    getByEmail(email?: string | null | undefined): Observable<UserModel>;
    /**
     * Get User
     * @param username (optional) 
     */
    getByUsername(username?: string | null | undefined): Observable<UserModel>;
    /**
     * Get currently logged in User
     */
    getCurrentUser(): Observable<UserModel>;
    /**
     * Get all Users
     */
    getAll(): Observable<UserModel[]>;
    /**
     * Get all Users
     */
    getResponsibleUserOptions(): Observable<UserModel[]>;
    /**
     * Get all Users
     */
    getComidaUserOptions(): Observable<UserModel[]>;
    searchUsers(searchText?: string | null | undefined): Observable<UserModel[]>;
    getByTimeRegId(timeRegId?: string | null | undefined): Observable<UserModel[]>;
    /**
     * Add or update User
     */
    post(model: UserModel): Observable<UserModel>;
    createLogin(userId?: string | undefined, htmlTemplate?: string | null | undefined, returnUrl?: string | null | undefined): Observable<string>;
    updateADB2CUserPassword(userId?: string | undefined, password?: string | null | undefined): Observable<string>;
    updateADB2CUsername(userId?: string | undefined): Observable<string>;
    updateADB2CUsers(): Observable<string>;
    addComidaUserToOrganization(userId?: string | undefined, organizationId?: string | undefined, addOrganizationToUser?: boolean | undefined): Observable<boolean>;
    dismissNotification(notificationId?: string | null | undefined): Observable<boolean>;
    delete(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class UserService implements IUserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get User
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/User/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersWithPermission(permissionName?: string | null | undefined, organizationId?: string | undefined): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/User/GetUsersWithPermission?";
        if (permissionName !== undefined && permissionName !== null)
            url_ += "permissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersWithPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersWithPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetUsersWithPermission(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get User
     * @param email (optional) 
     */
    getByEmail(email?: string | null | undefined): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/User/GetByEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processGetByEmail(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get User
     * @param username (optional) 
     */
    getByUsername(username?: string | null | undefined): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/User/GetByUsername?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUsername(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUsername(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processGetByUsername(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get currently logged in User
     */
    getCurrentUser(): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/User/GetCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Users
     */
    getAll(): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/User/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Users
     */
    getResponsibleUserOptions(): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/User/GetResponsibleUserOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResponsibleUserOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResponsibleUserOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetResponsibleUserOptions(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Users
     */
    getComidaUserOptions(): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/User/GetComidaUserOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComidaUserOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComidaUserOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetComidaUserOptions(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchUsers(searchText?: string | null | undefined): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/User/SearchUsers?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processSearchUsers(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByTimeRegId(timeRegId?: string | null | undefined): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/User/GetByTimeRegId?";
        if (timeRegId !== undefined && timeRegId !== null)
            url_ += "timeRegId=" + encodeURIComponent("" + timeRegId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByTimeRegId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByTimeRegId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetByTimeRegId(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update User
     */
    post(model: UserModel): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/User/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createLogin(userId?: string | undefined, htmlTemplate?: string | null | undefined, returnUrl?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/User/CreateLogin?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (htmlTemplate !== undefined && htmlTemplate !== null)
            url_ += "htmlTemplate=" + encodeURIComponent("" + htmlTemplate) + "&";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateLogin(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateADB2CUserPassword(userId?: string | undefined, password?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/User/UpdateADB2CUserPassword?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateADB2CUserPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateADB2CUserPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateADB2CUserPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateADB2CUsername(userId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/User/UpdateADB2CUsername?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateADB2CUsername(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateADB2CUsername(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateADB2CUsername(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateADB2CUsers(): Observable<string> {
        let url_ = this.baseUrl + "/api/User/UpdateADB2CUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateADB2CUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateADB2CUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateADB2CUsers(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addComidaUserToOrganization(userId?: string | undefined, organizationId?: string | undefined, addOrganizationToUser?: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/AddComidaUserToOrganization?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (addOrganizationToUser === null)
            throw new globalThis.Error("The parameter 'addOrganizationToUser' cannot be null.");
        else if (addOrganizationToUser !== undefined)
            url_ += "addOrganizationToUser=" + encodeURIComponent("" + addOrganizationToUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddComidaUserToOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddComidaUserToOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddComidaUserToOrganization(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dismissNotification(notificationId?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/DismissNotification?";
        if (notificationId !== undefined && notificationId !== null)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDismissNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDismissNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDismissNotification(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/User/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserPermissionsService {
    /**
     * Get User
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<UserPermissionsModel>;
    /**
     * Get all Users
     */
    getAll(): Observable<UserPermissionsModel[]>;
    /**
     * Add or update User
     */
    post(modelList: UserPermissionsModel[]): Observable<UserPermissionsModel[]>;
    delete(id?: string | undefined): Observable<string>;
    /**
     * Add or update User
     * @param userId (optional) 
     * @param organizationId (optional) 
     */
    removeUserFromOrganization(userId?: string | undefined, organizationId?: string | undefined): Observable<string>;
    /**
     * Get UserPermissionsModel
     * @param permissionUserId (optional) 
     * @param permissionOrganizationId (optional) 
     */
    getByUserId(permissionUserId?: string | undefined, permissionOrganizationId?: string | undefined): Observable<UserPermissionsModel[]>;
    /**
     * Get UserPermissionsModel
     * @param userId (optional) 
     * @param organizationId (optional) 
     */
    getAllPermissions(userId?: string | undefined, organizationId?: string | undefined): Observable<UserPermissionsModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class UserPermissionsService implements IUserPermissionsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get User
     * @param id (optional) 
     */
    get(id?: string | undefined): Observable<UserPermissionsModel> {
        let url_ = this.baseUrl + "/api/UserPermissions/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionsModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserPermissionsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPermissionsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Users
     */
    getAll(): Observable<UserPermissionsModel[]> {
        let url_ = this.baseUrl + "/api/UserPermissions/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionsModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserPermissionsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionsModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update User
     */
    post(modelList: UserPermissionsModel[]): Observable<UserPermissionsModel[]> {
        let url_ = this.baseUrl + "/api/UserPermissions/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionsModel[]>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<UserPermissionsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionsModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/UserPermissions/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update User
     * @param userId (optional) 
     * @param organizationId (optional) 
     */
    removeUserFromOrganization(userId?: string | undefined, organizationId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/UserPermissions/RemoveUserFromOrganization?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRemoveUserFromOrganization(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get UserPermissionsModel
     * @param permissionUserId (optional) 
     * @param permissionOrganizationId (optional) 
     */
    getByUserId(permissionUserId?: string | undefined, permissionOrganizationId?: string | undefined): Observable<UserPermissionsModel[]> {
        let url_ = this.baseUrl + "/api/UserPermissions/GetByUserId?";
        if (permissionUserId === null)
            throw new globalThis.Error("The parameter 'permissionUserId' cannot be null.");
        else if (permissionUserId !== undefined)
            url_ += "permissionUserId=" + encodeURIComponent("" + permissionUserId) + "&";
        if (permissionOrganizationId === null)
            throw new globalThis.Error("The parameter 'permissionOrganizationId' cannot be null.");
        else if (permissionOrganizationId !== undefined)
            url_ += "permissionOrganizationId=" + encodeURIComponent("" + permissionOrganizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionsModel[]>;
        }));
    }

    protected processGetByUserId(response: HttpResponseBase): Observable<UserPermissionsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionsModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get UserPermissionsModel
     * @param userId (optional) 
     * @param organizationId (optional) 
     */
    getAllPermissions(userId?: string | undefined, organizationId?: string | undefined): Observable<UserPermissionsModel[]> {
        let url_ = this.baseUrl + "/api/UserPermissions/GetAllPermissions?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionsModel[]>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<UserPermissionsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionsModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVisitOverviewService {
    getAll(): Observable<VisitOverviewModel[]>;
    getByResponsibleComidaUser(comidaId?: string | undefined): Observable<VisitOverviewModel[]>;
    getByZipInterval(min?: number | undefined, max?: number | undefined): Observable<VisitOverviewModel[]>;
    getByComidaUserZipInterval(comidaId?: string | undefined, zipMin?: number | undefined, zipMax?: number | undefined): Observable<VisitOverviewModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class VisitOverviewService implements IVisitOverviewService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<VisitOverviewModel[]> {
        let url_ = this.baseUrl + "/api/VisitOverview/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VisitOverviewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VisitOverviewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VisitOverviewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitOverviewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByResponsibleComidaUser(comidaId?: string | undefined): Observable<VisitOverviewModel[]> {
        let url_ = this.baseUrl + "/api/VisitOverview/GetByResponsibleComidaUser?";
        if (comidaId === null)
            throw new globalThis.Error("The parameter 'comidaId' cannot be null.");
        else if (comidaId !== undefined)
            url_ += "comidaId=" + encodeURIComponent("" + comidaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByResponsibleComidaUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByResponsibleComidaUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VisitOverviewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VisitOverviewModel[]>;
        }));
    }

    protected processGetByResponsibleComidaUser(response: HttpResponseBase): Observable<VisitOverviewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitOverviewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByZipInterval(min?: number | undefined, max?: number | undefined): Observable<VisitOverviewModel[]> {
        let url_ = this.baseUrl + "/api/VisitOverview/GetByZipInterval?";
        if (min === null)
            throw new globalThis.Error("The parameter 'min' cannot be null.");
        else if (min !== undefined)
            url_ += "min=" + encodeURIComponent("" + min) + "&";
        if (max === null)
            throw new globalThis.Error("The parameter 'max' cannot be null.");
        else if (max !== undefined)
            url_ += "max=" + encodeURIComponent("" + max) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByZipInterval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByZipInterval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VisitOverviewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VisitOverviewModel[]>;
        }));
    }

    protected processGetByZipInterval(response: HttpResponseBase): Observable<VisitOverviewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitOverviewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByComidaUserZipInterval(comidaId?: string | undefined, zipMin?: number | undefined, zipMax?: number | undefined): Observable<VisitOverviewModel[]> {
        let url_ = this.baseUrl + "/api/VisitOverview/GetByComidaUserZipInterval?";
        if (comidaId === null)
            throw new globalThis.Error("The parameter 'comidaId' cannot be null.");
        else if (comidaId !== undefined)
            url_ += "comidaId=" + encodeURIComponent("" + comidaId) + "&";
        if (zipMin === null)
            throw new globalThis.Error("The parameter 'zipMin' cannot be null.");
        else if (zipMin !== undefined)
            url_ += "zipMin=" + encodeURIComponent("" + zipMin) + "&";
        if (zipMax === null)
            throw new globalThis.Error("The parameter 'zipMax' cannot be null.");
        else if (zipMax !== undefined)
            url_ += "zipMax=" + encodeURIComponent("" + zipMax) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByComidaUserZipInterval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByComidaUserZipInterval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VisitOverviewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VisitOverviewModel[]>;
        }));
    }

    protected processGetByComidaUserZipInterval(response: HttpResponseBase): Observable<VisitOverviewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VisitOverviewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICtrContactPersonService {
    importContactPersons(): Observable<CtrContactPersonModel[]>;
    getAll(): Observable<CtrContactPersonModel[]>;
    getContactPersons(id?: string | undefined): Observable<CtrContactPersonModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CtrContactPersonService implements ICtrContactPersonService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    importContactPersons(): Observable<CtrContactPersonModel[]> {
        let url_ = this.baseUrl + "/api/CtrContactPerson/ImportContactPersons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrContactPersonModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrContactPersonModel[]>;
        }));
    }

    protected processImportContactPersons(response: HttpResponseBase): Observable<CtrContactPersonModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrContactPersonModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<CtrContactPersonModel[]> {
        let url_ = this.baseUrl + "/api/CtrContactPerson/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrContactPersonModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrContactPersonModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CtrContactPersonModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrContactPersonModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContactPersons(id?: string | undefined): Observable<CtrContactPersonModel[]> {
        let url_ = this.baseUrl + "/api/CtrContactPerson/GetContactPersons?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrContactPersonModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrContactPersonModel[]>;
        }));
    }

    protected processGetContactPersons(response: HttpResponseBase): Observable<CtrContactPersonModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrContactPersonModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICtrCustomerService {
    importCustomers(customerGroupNumber?: number | undefined): Observable<CtrCustomerModel[]>;
    getCustomers(includeAll?: boolean | undefined): Observable<CtrCustomerModel[]>;
    getCustomersWithTasks(includeAll?: boolean | undefined): Observable<CtrCustomerModel[]>;
    getByInvoiceFrequency(frequency?: number | undefined, endDate?: Date | null | undefined): Observable<CtrCustomerModel[]>;
    get(id?: string | undefined): Observable<CtrCustomerModel>;
    getComidaUsers(): Observable<CtrUserModel[]>;
    saveCustomer(customer: CtrCustomerModel): Observable<string>;
    getAllSubscriptionHosting(): Observable<CtrSubscriptionHostingModel[]>;
    getSubscriptionHosting(customerId?: string | undefined): Observable<CtrSubscriptionHostingModel>;
    saveSubscriptionHosting(subscription: CtrSubscriptionHostingModel): Observable<string>;
    deleteSubscriptionHosting(id?: string | undefined): Observable<string>;
    getAllSubscriptionFS(): Observable<AgreementModel[]>;
    getAllSubscriptionQS(): Observable<CtrSubscriptionQSModel[]>;
    getSubscriptionQS(customerId?: string | undefined): Observable<CtrSubscriptionQSModel>;
    deleteSubscriptionQS(id?: string | undefined): Observable<string>;
    saveSubscriptionQS(subscription: CtrSubscriptionQSModel): Observable<string>;
    getCreateCustomer(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CtrCustomerService implements ICtrCustomerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    importCustomers(customerGroupNumber?: number | undefined): Observable<CtrCustomerModel[]> {
        let url_ = this.baseUrl + "/api/CtrCustomer/ImportCustomers?";
        if (customerGroupNumber === null)
            throw new globalThis.Error("The parameter 'customerGroupNumber' cannot be null.");
        else if (customerGroupNumber !== undefined)
            url_ += "customerGroupNumber=" + encodeURIComponent("" + customerGroupNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrCustomerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrCustomerModel[]>;
        }));
    }

    protected processImportCustomers(response: HttpResponseBase): Observable<CtrCustomerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrCustomerModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomers(includeAll?: boolean | undefined): Observable<CtrCustomerModel[]> {
        let url_ = this.baseUrl + "/api/CtrCustomer/GetCustomers?";
        if (includeAll === null)
            throw new globalThis.Error("The parameter 'includeAll' cannot be null.");
        else if (includeAll !== undefined)
            url_ += "includeAll=" + encodeURIComponent("" + includeAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrCustomerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrCustomerModel[]>;
        }));
    }

    protected processGetCustomers(response: HttpResponseBase): Observable<CtrCustomerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrCustomerModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomersWithTasks(includeAll?: boolean | undefined): Observable<CtrCustomerModel[]> {
        let url_ = this.baseUrl + "/api/CtrCustomer/GetCustomersWithTasks?";
        if (includeAll === null)
            throw new globalThis.Error("The parameter 'includeAll' cannot be null.");
        else if (includeAll !== undefined)
            url_ += "includeAll=" + encodeURIComponent("" + includeAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomersWithTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomersWithTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrCustomerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrCustomerModel[]>;
        }));
    }

    protected processGetCustomersWithTasks(response: HttpResponseBase): Observable<CtrCustomerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrCustomerModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByInvoiceFrequency(frequency?: number | undefined, endDate?: Date | null | undefined): Observable<CtrCustomerModel[]> {
        let url_ = this.baseUrl + "/api/CtrCustomer/GetByInvoiceFrequency?";
        if (frequency === null)
            throw new globalThis.Error("The parameter 'frequency' cannot be null.");
        else if (frequency !== undefined)
            url_ += "frequency=" + encodeURIComponent("" + frequency) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByInvoiceFrequency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByInvoiceFrequency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrCustomerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrCustomerModel[]>;
        }));
    }

    protected processGetByInvoiceFrequency(response: HttpResponseBase): Observable<CtrCustomerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrCustomerModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id?: string | undefined): Observable<CtrCustomerModel> {
        let url_ = this.baseUrl + "/api/CtrCustomer/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrCustomerModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrCustomerModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CtrCustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrCustomerModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getComidaUsers(): Observable<CtrUserModel[]> {
        let url_ = this.baseUrl + "/api/CtrCustomer/GetComidaUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComidaUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComidaUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrUserModel[]>;
        }));
    }

    protected processGetComidaUsers(response: HttpResponseBase): Observable<CtrUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrUserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveCustomer(customer: CtrCustomerModel): Observable<string> {
        let url_ = this.baseUrl + "/api/CtrCustomer/SaveCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllSubscriptionHosting(): Observable<CtrSubscriptionHostingModel[]> {
        let url_ = this.baseUrl + "/api/CtrCustomer/GetAllSubscriptionHosting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptionHosting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptionHosting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrSubscriptionHostingModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrSubscriptionHostingModel[]>;
        }));
    }

    protected processGetAllSubscriptionHosting(response: HttpResponseBase): Observable<CtrSubscriptionHostingModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrSubscriptionHostingModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubscriptionHosting(customerId?: string | undefined): Observable<CtrSubscriptionHostingModel> {
        let url_ = this.baseUrl + "/api/CtrCustomer/GetSubscriptionHosting?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionHosting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionHosting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrSubscriptionHostingModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrSubscriptionHostingModel>;
        }));
    }

    protected processGetSubscriptionHosting(response: HttpResponseBase): Observable<CtrSubscriptionHostingModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrSubscriptionHostingModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveSubscriptionHosting(subscription: CtrSubscriptionHostingModel): Observable<string> {
        let url_ = this.baseUrl + "/api/CtrCustomer/SaveSubscriptionHosting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscription);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSubscriptionHosting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSubscriptionHosting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveSubscriptionHosting(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSubscriptionHosting(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CtrCustomer/DeleteSubscriptionHosting?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubscriptionHosting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubscriptionHosting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteSubscriptionHosting(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllSubscriptionFS(): Observable<AgreementModel[]> {
        let url_ = this.baseUrl + "/api/CtrCustomer/GetAllSubscriptionFS";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptionFS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptionFS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementModel[]>;
        }));
    }

    protected processGetAllSubscriptionFS(response: HttpResponseBase): Observable<AgreementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgreementModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllSubscriptionQS(): Observable<CtrSubscriptionQSModel[]> {
        let url_ = this.baseUrl + "/api/CtrCustomer/GetAllSubscriptionQS";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptionQS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptionQS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrSubscriptionQSModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrSubscriptionQSModel[]>;
        }));
    }

    protected processGetAllSubscriptionQS(response: HttpResponseBase): Observable<CtrSubscriptionQSModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrSubscriptionQSModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubscriptionQS(customerId?: string | undefined): Observable<CtrSubscriptionQSModel> {
        let url_ = this.baseUrl + "/api/CtrCustomer/GetSubscriptionQS?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionQS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionQS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrSubscriptionQSModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrSubscriptionQSModel>;
        }));
    }

    protected processGetSubscriptionQS(response: HttpResponseBase): Observable<CtrSubscriptionQSModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrSubscriptionQSModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSubscriptionQS(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CtrCustomer/DeleteSubscriptionQS?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubscriptionQS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubscriptionQS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteSubscriptionQS(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveSubscriptionQS(subscription: CtrSubscriptionQSModel): Observable<string> {
        let url_ = this.baseUrl + "/api/CtrCustomer/SaveSubscriptionQS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscription);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSubscriptionQS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSubscriptionQS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveSubscriptionQS(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCreateCustomer(): Observable<string> {
        let url_ = this.baseUrl + "/api/CtrCustomer/GetCreateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCreateCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICtrInvoiceService {
    createFsInvoice(agreementId?: string | undefined): Observable<CtrInvoiceModel>;
    createHostingInvoice(customerId?: number | undefined, date?: Date | null | undefined): Observable<CtrInvoiceModel>;
    createQsInvoice(customerId?: number | undefined, date?: Date | null | undefined): Observable<CtrInvoiceModel>;
    getOpenInvoices(): Observable<CtrInvoiceModel[]>;
    updateInvoiceStatus(): Observable<string>;
    getOverDueInvoices(): Observable<CtrInvoiceModel[]>;
    getRecentBookedInvoices(): Observable<CtrInvoiceModel[]>;
    getDraftInvoices(): Observable<CtrInvoiceModel[]>;
    getByCustomerId(customerId?: string | undefined): Observable<CtrInvoiceModel[]>;
    bookInvoice(id?: string | undefined): Observable<CtrInvoiceModel>;
    sendInvoice(id?: string | undefined, isComidaQs?: boolean | undefined): Observable<CtrInvoiceModel>;
    sendReminder(id?: string | undefined): Observable<CtrInvoiceModel>;
    deleteInvoice(id?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CtrInvoiceService implements ICtrInvoiceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createFsInvoice(agreementId?: string | undefined): Observable<CtrInvoiceModel> {
        let url_ = this.baseUrl + "/api/CtrInvoice/CreateFsInvoice?";
        if (agreementId === null)
            throw new globalThis.Error("The parameter 'agreementId' cannot be null.");
        else if (agreementId !== undefined)
            url_ += "agreementId=" + encodeURIComponent("" + agreementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFsInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFsInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrInvoiceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrInvoiceModel>;
        }));
    }

    protected processCreateFsInvoice(response: HttpResponseBase): Observable<CtrInvoiceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrInvoiceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createHostingInvoice(customerId?: number | undefined, date?: Date | null | undefined): Observable<CtrInvoiceModel> {
        let url_ = this.baseUrl + "/api/CtrInvoice/CreateHostingInvoice?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHostingInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHostingInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrInvoiceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrInvoiceModel>;
        }));
    }

    protected processCreateHostingInvoice(response: HttpResponseBase): Observable<CtrInvoiceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrInvoiceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createQsInvoice(customerId?: number | undefined, date?: Date | null | undefined): Observable<CtrInvoiceModel> {
        let url_ = this.baseUrl + "/api/CtrInvoice/CreateQsInvoice?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateQsInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQsInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrInvoiceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrInvoiceModel>;
        }));
    }

    protected processCreateQsInvoice(response: HttpResponseBase): Observable<CtrInvoiceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrInvoiceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOpenInvoices(): Observable<CtrInvoiceModel[]> {
        let url_ = this.baseUrl + "/api/CtrInvoice/GetOpenInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpenInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpenInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrInvoiceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrInvoiceModel[]>;
        }));
    }

    protected processGetOpenInvoices(response: HttpResponseBase): Observable<CtrInvoiceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrInvoiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateInvoiceStatus(): Observable<string> {
        let url_ = this.baseUrl + "/api/CtrInvoice/UpdateInvoiceStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInvoiceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInvoiceStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateInvoiceStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOverDueInvoices(): Observable<CtrInvoiceModel[]> {
        let url_ = this.baseUrl + "/api/CtrInvoice/GetOverDueInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverDueInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverDueInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrInvoiceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrInvoiceModel[]>;
        }));
    }

    protected processGetOverDueInvoices(response: HttpResponseBase): Observable<CtrInvoiceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrInvoiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRecentBookedInvoices(): Observable<CtrInvoiceModel[]> {
        let url_ = this.baseUrl + "/api/CtrInvoice/GetRecentBookedInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentBookedInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentBookedInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrInvoiceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrInvoiceModel[]>;
        }));
    }

    protected processGetRecentBookedInvoices(response: HttpResponseBase): Observable<CtrInvoiceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrInvoiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDraftInvoices(): Observable<CtrInvoiceModel[]> {
        let url_ = this.baseUrl + "/api/CtrInvoice/GetDraftInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDraftInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDraftInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrInvoiceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrInvoiceModel[]>;
        }));
    }

    protected processGetDraftInvoices(response: HttpResponseBase): Observable<CtrInvoiceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrInvoiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByCustomerId(customerId?: string | undefined): Observable<CtrInvoiceModel[]> {
        let url_ = this.baseUrl + "/api/CtrInvoice/GetByCustomerId?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCustomerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCustomerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrInvoiceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrInvoiceModel[]>;
        }));
    }

    protected processGetByCustomerId(response: HttpResponseBase): Observable<CtrInvoiceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrInvoiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bookInvoice(id?: string | undefined): Observable<CtrInvoiceModel> {
        let url_ = this.baseUrl + "/api/CtrInvoice/BookInvoice?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrInvoiceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrInvoiceModel>;
        }));
    }

    protected processBookInvoice(response: HttpResponseBase): Observable<CtrInvoiceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrInvoiceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendInvoice(id?: string | undefined, isComidaQs?: boolean | undefined): Observable<CtrInvoiceModel> {
        let url_ = this.baseUrl + "/api/CtrInvoice/SendInvoice?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isComidaQs === null)
            throw new globalThis.Error("The parameter 'isComidaQs' cannot be null.");
        else if (isComidaQs !== undefined)
            url_ += "isComidaQs=" + encodeURIComponent("" + isComidaQs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrInvoiceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrInvoiceModel>;
        }));
    }

    protected processSendInvoice(response: HttpResponseBase): Observable<CtrInvoiceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrInvoiceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendReminder(id?: string | undefined): Observable<CtrInvoiceModel> {
        let url_ = this.baseUrl + "/api/CtrInvoice/SendReminder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrInvoiceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrInvoiceModel>;
        }));
    }

    protected processSendReminder(response: HttpResponseBase): Observable<CtrInvoiceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrInvoiceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteInvoice(id?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CtrInvoice/DeleteInvoice?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteInvoice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICtrPlanningBoardService {
    getBoard(id?: string | undefined): Observable<VlBoardDto>;
    getBoardByOrg(): Observable<VlBoardDto>;
    getBoardsByTask(taskId?: string | null | undefined): Observable<VlBoardDto[]>;
    getBoards(includeGlobal?: boolean | undefined): Observable<VlBoardDto[]>;
    postBoard(board: VlBoardDto): Observable<VlBoard>;
    getRelationsByBoard(boardId?: string | null | undefined): Observable<VlRelationDto[]>;
    saveRelation(taskId?: string | null | undefined, boardId?: string | null | undefined, sortOrder?: number | undefined): Observable<VlRelationDto>;
    removeRelationBetweenTaskAndBoard(boardId?: string | null | undefined, task?: CtrTaskModel | undefined): Observable<FileResponse>;
    deleteBoard(boardId?: string | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CtrPlanningBoardService implements ICtrPlanningBoardService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getBoard(id?: string | undefined): Observable<VlBoardDto> {
        let url_ = this.baseUrl + "/api/CtrPlanningBoard/GetBoard?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBoard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBoard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VlBoardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VlBoardDto>;
        }));
    }

    protected processGetBoard(response: HttpResponseBase): Observable<VlBoardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VlBoardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBoardByOrg(): Observable<VlBoardDto> {
        let url_ = this.baseUrl + "/api/CtrPlanningBoard/GetBoardByOrg";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBoardByOrg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBoardByOrg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VlBoardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VlBoardDto>;
        }));
    }

    protected processGetBoardByOrg(response: HttpResponseBase): Observable<VlBoardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VlBoardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBoardsByTask(taskId?: string | null | undefined): Observable<VlBoardDto[]> {
        let url_ = this.baseUrl + "/api/CtrPlanningBoard/GetBoardsByTask?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBoardsByTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBoardsByTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VlBoardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VlBoardDto[]>;
        }));
    }

    protected processGetBoardsByTask(response: HttpResponseBase): Observable<VlBoardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VlBoardDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBoards(includeGlobal?: boolean | undefined): Observable<VlBoardDto[]> {
        let url_ = this.baseUrl + "/api/CtrPlanningBoard/GetBoards?";
        if (includeGlobal === null)
            throw new globalThis.Error("The parameter 'includeGlobal' cannot be null.");
        else if (includeGlobal !== undefined)
            url_ += "includeGlobal=" + encodeURIComponent("" + includeGlobal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBoards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBoards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VlBoardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VlBoardDto[]>;
        }));
    }

    protected processGetBoards(response: HttpResponseBase): Observable<VlBoardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VlBoardDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postBoard(board: VlBoardDto): Observable<VlBoard> {
        let url_ = this.baseUrl + "/api/CtrPlanningBoard/PostBoard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(board);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBoard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBoard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VlBoard>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VlBoard>;
        }));
    }

    protected processPostBoard(response: HttpResponseBase): Observable<VlBoard> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VlBoard.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRelationsByBoard(boardId?: string | null | undefined): Observable<VlRelationDto[]> {
        let url_ = this.baseUrl + "/api/CtrPlanningBoard/GetRelationsByBoard?";
        if (boardId !== undefined && boardId !== null)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelationsByBoard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelationsByBoard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VlRelationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VlRelationDto[]>;
        }));
    }

    protected processGetRelationsByBoard(response: HttpResponseBase): Observable<VlRelationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VlRelationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveRelation(taskId?: string | null | undefined, boardId?: string | null | undefined, sortOrder?: number | undefined): Observable<VlRelationDto> {
        let url_ = this.baseUrl + "/api/CtrPlanningBoard/SaveRelation?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (boardId !== undefined && boardId !== null)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VlRelationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VlRelationDto>;
        }));
    }

    protected processSaveRelation(response: HttpResponseBase): Observable<VlRelationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VlRelationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeRelationBetweenTaskAndBoard(boardId?: string | null | undefined, task?: CtrTaskModel | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CtrPlanningBoard/RemoveRelationBetweenTaskAndBoard?";
        if (boardId !== undefined && boardId !== null)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(task);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRelationBetweenTaskAndBoard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRelationBetweenTaskAndBoard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRemoveRelationBetweenTaskAndBoard(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteBoard(boardId?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CtrPlanningBoard/DeleteBoard?";
        if (boardId === null)
            throw new globalThis.Error("The parameter 'boardId' cannot be null.");
        else if (boardId !== undefined)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBoard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBoard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteBoard(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICtrRegistrationService {
    post(model: CtrRegistrationModel): Observable<CtrRegistrationModel>;
    get(id?: string | undefined): Observable<CtrRegistrationModel>;
    delete(id?: string | undefined): Observable<void>;
    getAll(user?: CtrUserModel | undefined, startDate?: Date | null | undefined): Observable<CtrRegistrationModel[]>;
    getCustomerOverview(): Observable<CtrCustomerModel[]>;
    getByCustomer(customerId?: string | undefined, showInvoiced?: boolean | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined): Observable<CtrRegistrationModel[]>;
    getByEmployee(): Observable<CtrRegistrationGroupModel[]>;
    getGitHubIssues(): Observable<number>;
    /**
     * @param orgId (optional) 
     * @deprecated
     */
    fixComidaPlanning(orgId?: string | null | undefined): Observable<string>;
    createInvoice(customerId?: string | undefined, date?: Date | null | undefined): Observable<CtrInvoiceModel>;
    markCustomerInvoiced(customerId?: string | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CtrRegistrationService implements ICtrRegistrationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(model: CtrRegistrationModel): Observable<CtrRegistrationModel> {
        let url_ = this.baseUrl + "/api/CtrRegistration/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrRegistrationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrRegistrationModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<CtrRegistrationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrRegistrationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id?: string | undefined): Observable<CtrRegistrationModel> {
        let url_ = this.baseUrl + "/api/CtrRegistration/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrRegistrationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrRegistrationModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CtrRegistrationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrRegistrationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/CtrRegistration/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(user?: CtrUserModel | undefined, startDate?: Date | null | undefined): Observable<CtrRegistrationModel[]> {
        let url_ = this.baseUrl + "/api/CtrRegistration/GetAll?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrRegistrationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrRegistrationModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CtrRegistrationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrRegistrationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerOverview(): Observable<CtrCustomerModel[]> {
        let url_ = this.baseUrl + "/api/CtrRegistration/GetCustomerOverview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrCustomerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrCustomerModel[]>;
        }));
    }

    protected processGetCustomerOverview(response: HttpResponseBase): Observable<CtrCustomerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrCustomerModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByCustomer(customerId?: string | undefined, showInvoiced?: boolean | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined): Observable<CtrRegistrationModel[]> {
        let url_ = this.baseUrl + "/api/CtrRegistration/GetByCustomer?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (showInvoiced === null)
            throw new globalThis.Error("The parameter 'showInvoiced' cannot be null.");
        else if (showInvoiced !== undefined)
            url_ += "showInvoiced=" + encodeURIComponent("" + showInvoiced) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrRegistrationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrRegistrationModel[]>;
        }));
    }

    protected processGetByCustomer(response: HttpResponseBase): Observable<CtrRegistrationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrRegistrationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByEmployee(): Observable<CtrRegistrationGroupModel[]> {
        let url_ = this.baseUrl + "/api/CtrRegistration/GetByEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrRegistrationGroupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrRegistrationGroupModel[]>;
        }));
    }

    protected processGetByEmployee(response: HttpResponseBase): Observable<CtrRegistrationGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrRegistrationGroupModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGitHubIssues(): Observable<number> {
        let url_ = this.baseUrl + "/api/CtrRegistration/GetGitHubIssues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGitHubIssues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGitHubIssues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetGitHubIssues(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orgId (optional) 
     * @deprecated
     */
    fixComidaPlanning(orgId?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CtrRegistration/FixComidaPlanning?";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFixComidaPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixComidaPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFixComidaPlanning(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createInvoice(customerId?: string | undefined, date?: Date | null | undefined): Observable<CtrInvoiceModel> {
        let url_ = this.baseUrl + "/api/CtrRegistration/CreateInvoice?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrInvoiceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrInvoiceModel>;
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<CtrInvoiceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrInvoiceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markCustomerInvoiced(customerId?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CtrRegistration/MarkCustomerInvoiced?";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkCustomerInvoiced(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkCustomerInvoiced(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMarkCustomerInvoiced(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICtrTaskService {
    getTaskByEntityId(entityId?: string | undefined): Observable<CtrTaskModel[]>;
    getTask(id?: string | undefined): Observable<VlTask>;
    saveTask(task: CtrTaskModel, boardIds?: (string | undefined)[] | null | undefined): Observable<CtrTaskModel>;
    sendTaskToGithub(task: CtrTaskModel): Observable<CtrTaskModel>;
    getRelationsByTask(taskId?: string | null | undefined): Observable<VlRelationDto[]>;
    updateTaskInPlanning(task: CtrTaskModel, boardId?: string | null | undefined): Observable<CtrTaskModel>;
    updateManyTaskInPlanning(tasks: CtrTaskModel[]): Observable<CtrTaskModel[]>;
    getAllActiveTasks(customerId?: string | null | undefined, boardId?: string | null | undefined, responsibleUser?: string | null | undefined, type?: CtrTaskType | null | undefined, priority?: number | null | undefined, includeDefaultBoard?: boolean | undefined, includeArchived?: boolean | undefined): Observable<CtrTaskModel[]>;
    getActiveTasks(customerId?: string | null | undefined, type?: CtrTaskType | undefined, organizationId?: string | null | undefined): Observable<CtrTaskModel[]>;
    updateTask(task: VlTask): Observable<FileResponse>;
    deleteTask(id?: string | undefined): Observable<FileResponse>;
    /**
     * @param taskId (optional) 
     * @deprecated
     */
    archiveTask(taskId?: string | null | undefined): Observable<FileResponse>;
    unarchiveTask(taskId?: string | null | undefined): Observable<FileResponse>;
    asyncUpload(files?: FileParameter[] | null | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CtrTaskService implements ICtrTaskService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTaskByEntityId(entityId?: string | undefined): Observable<CtrTaskModel[]> {
        let url_ = this.baseUrl + "/api/CtrTask/GetTaskByEntityId?";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskByEntityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskByEntityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrTaskModel[]>;
        }));
    }

    protected processGetTaskByEntityId(response: HttpResponseBase): Observable<CtrTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrTaskModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTask(id?: string | undefined): Observable<VlTask> {
        let url_ = this.baseUrl + "/api/CtrTask/GetTask?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VlTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VlTask>;
        }));
    }

    protected processGetTask(response: HttpResponseBase): Observable<VlTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VlTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveTask(task: CtrTaskModel, boardIds?: (string | undefined)[] | null | undefined): Observable<CtrTaskModel> {
        let url_ = this.baseUrl + "/api/CtrTask/SaveTask?";
        if (boardIds !== undefined && boardIds !== null)
            boardIds && boardIds.forEach(item => { url_ += "boardIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(task);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrTaskModel>;
        }));
    }

    protected processSaveTask(response: HttpResponseBase): Observable<CtrTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendTaskToGithub(task: CtrTaskModel): Observable<CtrTaskModel> {
        let url_ = this.baseUrl + "/api/CtrTask/SendTaskToGithub";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(task);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTaskToGithub(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTaskToGithub(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrTaskModel>;
        }));
    }

    protected processSendTaskToGithub(response: HttpResponseBase): Observable<CtrTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRelationsByTask(taskId?: string | null | undefined): Observable<VlRelationDto[]> {
        let url_ = this.baseUrl + "/api/CtrTask/GetRelationsByTask?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelationsByTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelationsByTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VlRelationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VlRelationDto[]>;
        }));
    }

    protected processGetRelationsByTask(response: HttpResponseBase): Observable<VlRelationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VlRelationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTaskInPlanning(task: CtrTaskModel, boardId?: string | null | undefined): Observable<CtrTaskModel> {
        let url_ = this.baseUrl + "/api/CtrTask/UpdateTaskInPlanning?";
        if (boardId !== undefined && boardId !== null)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(task);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskInPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskInPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrTaskModel>;
        }));
    }

    protected processUpdateTaskInPlanning(response: HttpResponseBase): Observable<CtrTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateManyTaskInPlanning(tasks: CtrTaskModel[]): Observable<CtrTaskModel[]> {
        let url_ = this.baseUrl + "/api/CtrTask/UpdateManyTaskInPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tasks);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateManyTaskInPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateManyTaskInPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrTaskModel[]>;
        }));
    }

    protected processUpdateManyTaskInPlanning(response: HttpResponseBase): Observable<CtrTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrTaskModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllActiveTasks(customerId?: string | null | undefined, boardId?: string | null | undefined, responsibleUser?: string | null | undefined, type?: CtrTaskType | null | undefined, priority?: number | null | undefined, includeDefaultBoard?: boolean | undefined, includeArchived?: boolean | undefined): Observable<CtrTaskModel[]> {
        let url_ = this.baseUrl + "/api/CtrTask/GetAllActiveTasks?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (boardId !== undefined && boardId !== null)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        if (responsibleUser !== undefined && responsibleUser !== null)
            url_ += "responsibleUser=" + encodeURIComponent("" + responsibleUser) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (priority !== undefined && priority !== null)
            url_ += "priority=" + encodeURIComponent("" + priority) + "&";
        if (includeDefaultBoard === null)
            throw new globalThis.Error("The parameter 'includeDefaultBoard' cannot be null.");
        else if (includeDefaultBoard !== undefined)
            url_ += "includeDefaultBoard=" + encodeURIComponent("" + includeDefaultBoard) + "&";
        if (includeArchived === null)
            throw new globalThis.Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrTaskModel[]>;
        }));
    }

    protected processGetAllActiveTasks(response: HttpResponseBase): Observable<CtrTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrTaskModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveTasks(customerId?: string | null | undefined, type?: CtrTaskType | undefined, organizationId?: string | null | undefined): Observable<CtrTaskModel[]> {
        let url_ = this.baseUrl + "/api/CtrTask/GetActiveTasks?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrTaskModel[]>;
        }));
    }

    protected processGetActiveTasks(response: HttpResponseBase): Observable<CtrTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrTaskModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTask(task: VlTask): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CtrTask/UpdateTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(task);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdateTask(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteTask(id?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CtrTask/DeleteTask?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteTask(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @deprecated
     */
    archiveTask(taskId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CtrTask/ArchiveTask?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processArchiveTask(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unarchiveTask(taskId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CtrTask/UnarchiveTask?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnarchiveTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnarchiveTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUnarchiveTask(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    asyncUpload(files?: FileParameter[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CtrTask/AsyncUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAsyncUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAsyncUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAsyncUpload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICtrUserService {
    getAll(): Observable<CtrUserModel[]>;
    getCurrentUser(): Observable<CtrUserModel>;
    setPhoneResponsible(responsibleId?: number | undefined): Observable<number>;
    getPhoneResponsible(): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class CtrUserService implements ICtrUserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Observable<CtrUserModel[]> {
        let url_ = this.baseUrl + "/api/CtrUser/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrUserModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CtrUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtrUserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentUser(): Observable<CtrUserModel> {
        let url_ = this.baseUrl + "/api/CtrUser/GetCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtrUserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtrUserModel>;
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<CtrUserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtrUserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setPhoneResponsible(responsibleId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/CtrUser/SetPhoneResponsible?";
        if (responsibleId === null)
            throw new globalThis.Error("The parameter 'responsibleId' cannot be null.");
        else if (responsibleId !== undefined)
            url_ += "responsibleId=" + encodeURIComponent("" + responsibleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPhoneResponsible(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPhoneResponsible(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetPhoneResponsible(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPhoneResponsible(): Observable<number> {
        let url_ = this.baseUrl + "/api/CtrUser/GetPhoneResponsible";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhoneResponsible(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhoneResponsible(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPhoneResponsible(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AddressModel implements IAddressModel {
    id?: string;
    address1?: string | undefined;
    address2?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    type?: AddressType;
    entityId?: string;
    sortOrder?: number;
    name?: string | undefined;
    externalId?: string | undefined;
    gln?: string | undefined;
    endpoint?: string | undefined;
    cvr?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.type = _data["type"];
            this.entityId = _data["entityId"];
            this.sortOrder = _data["sortOrder"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.gln = _data["gln"];
            this.endpoint = _data["endpoint"];
            this.cvr = _data["cvr"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): AddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["type"] = this.type;
        data["entityId"] = this.entityId;
        data["sortOrder"] = this.sortOrder;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["gln"] = this.gln;
        data["endpoint"] = this.endpoint;
        data["cvr"] = this.cvr;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): AddressModel {
        const json = this.toJSON();
        let result = new AddressModel();
        result.init(json);
        return result;
    }
}

export interface IAddressModel {
    id?: string;
    address1?: string | undefined;
    address2?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    type?: AddressType;
    entityId?: string;
    sortOrder?: number;
    name?: string | undefined;
    externalId?: string | undefined;
    gln?: string | undefined;
    endpoint?: string | undefined;
    cvr?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum AddressType {
    Organization = 0,
    Supplier = 1,
    Customer = 2,
    Delivery = 3,
    Invoice = 4,
}

export class AgreementLocationModel implements IAgreementLocationModel {
    id?: string;
    agreementId?: string;
    contractId?: string;
    sortOrder?: number;
    organizationName?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    userId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IAgreementLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agreementId = _data["agreementId"];
            this.contractId = _data["contractId"];
            this.sortOrder = _data["sortOrder"];
            this.organizationName = _data["organizationName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): AgreementLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementLocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agreementId"] = this.agreementId;
        data["contractId"] = this.contractId;
        data["sortOrder"] = this.sortOrder;
        data["organizationName"] = this.organizationName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        return data;
    }

    clone(): AgreementLocationModel {
        const json = this.toJSON();
        let result = new AgreementLocationModel();
        result.init(json);
        return result;
    }
}

export interface IAgreementLocationModel {
    id?: string;
    agreementId?: string;
    contractId?: string;
    sortOrder?: number;
    organizationName?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    userId?: string | undefined;
    organizationId?: string | undefined;
}

export class AgreementModel implements IAgreementModel {
    id?: string | undefined;
    vlCustomerId?: string;
    name?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    extendedDate?: Date | undefined;
    signingDate?: Date | undefined;
    showPricePerLocation?: boolean;
    status?: AgreementStatus;
    isDeleted?: boolean;
    created?: Date | undefined;
    updated?: Date | undefined;
    organizationId?: string | undefined;
    locations?: AgreementLocationModel[] | undefined;
    introText?: string | undefined;
    servicesText?: string | undefined;
    closingText?: string | undefined;
    invoicePeriod?: number;
    invoiceMonth?: number;
    discountPercentage?: number;
    startFee?: number;
    durationText?: string | undefined;
    nextInvoiceDate?: Date | undefined;
    lastIndexedDate?: Date | undefined;
    originalInvoiceTotal?: number;
    currentInvoiceTotal?: number;
    vlCustomer?: CtrCustomerModel | undefined;

    constructor(data?: IAgreementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vlCustomerId = _data["vlCustomerId"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.extendedDate = _data["extendedDate"] ? new Date(_data["extendedDate"].toString()) : undefined as any;
            this.signingDate = _data["signingDate"] ? new Date(_data["signingDate"].toString()) : undefined as any;
            this.showPricePerLocation = _data["showPricePerLocation"];
            this.status = _data["status"];
            this.isDeleted = _data["isDeleted"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.organizationId = _data["organizationId"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(AgreementLocationModel.fromJS(item));
            }
            this.introText = _data["introText"];
            this.servicesText = _data["servicesText"];
            this.closingText = _data["closingText"];
            this.invoicePeriod = _data["invoicePeriod"];
            this.invoiceMonth = _data["invoiceMonth"];
            this.discountPercentage = _data["discountPercentage"];
            this.startFee = _data["startFee"];
            this.durationText = _data["durationText"];
            this.nextInvoiceDate = _data["nextInvoiceDate"] ? new Date(_data["nextInvoiceDate"].toString()) : undefined as any;
            this.lastIndexedDate = _data["lastIndexedDate"] ? new Date(_data["lastIndexedDate"].toString()) : undefined as any;
            this.originalInvoiceTotal = _data["originalInvoiceTotal"];
            this.currentInvoiceTotal = _data["currentInvoiceTotal"];
            this.vlCustomer = _data["vlCustomer"] ? CtrCustomerModel.fromJS(_data["vlCustomer"]) : undefined as any;
        }
    }

    static fromJS(data: any): AgreementModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vlCustomerId"] = this.vlCustomerId;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["extendedDate"] = this.extendedDate ? this.extendedDate.toISOString() : undefined as any;
        data["signingDate"] = this.signingDate ? this.signingDate.toISOString() : undefined as any;
        data["showPricePerLocation"] = this.showPricePerLocation;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["organizationId"] = this.organizationId;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : undefined as any);
        }
        data["introText"] = this.introText;
        data["servicesText"] = this.servicesText;
        data["closingText"] = this.closingText;
        data["invoicePeriod"] = this.invoicePeriod;
        data["invoiceMonth"] = this.invoiceMonth;
        data["discountPercentage"] = this.discountPercentage;
        data["startFee"] = this.startFee;
        data["durationText"] = this.durationText;
        data["nextInvoiceDate"] = this.nextInvoiceDate ? this.nextInvoiceDate.toISOString() : undefined as any;
        data["lastIndexedDate"] = this.lastIndexedDate ? this.lastIndexedDate.toISOString() : undefined as any;
        data["originalInvoiceTotal"] = this.originalInvoiceTotal;
        data["currentInvoiceTotal"] = this.currentInvoiceTotal;
        data["vlCustomer"] = this.vlCustomer ? this.vlCustomer.toJSON() : undefined as any;
        return data;
    }

    clone(): AgreementModel {
        const json = this.toJSON();
        let result = new AgreementModel();
        result.init(json);
        return result;
    }
}

export interface IAgreementModel {
    id?: string | undefined;
    vlCustomerId?: string;
    name?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    extendedDate?: Date | undefined;
    signingDate?: Date | undefined;
    showPricePerLocation?: boolean;
    status?: AgreementStatus;
    isDeleted?: boolean;
    created?: Date | undefined;
    updated?: Date | undefined;
    organizationId?: string | undefined;
    locations?: AgreementLocationModel[] | undefined;
    introText?: string | undefined;
    servicesText?: string | undefined;
    closingText?: string | undefined;
    invoicePeriod?: number;
    invoiceMonth?: number;
    discountPercentage?: number;
    startFee?: number;
    durationText?: string | undefined;
    nextInvoiceDate?: Date | undefined;
    lastIndexedDate?: Date | undefined;
    originalInvoiceTotal?: number;
    currentInvoiceTotal?: number;
    vlCustomer?: CtrCustomerModel | undefined;
}

export enum AgreementStatus {
    Draft = 0,
    Sent = 1,
    Approved = 2,
    Rejected = 3,
    Expired = 4,
    Terminated = 5,
}

export class CtrCustomerModel implements ICtrCustomerModel {
    id?: string;
    customerNumber?: number;
    customerName?: string | undefined;
    standardSku?: number | undefined;
    totalDuration?: number;
    transportSku?: number | undefined;
    transportDistance?: number | undefined;
    transportFixedPrice?: number;
    standardHeadingText?: string | undefined;
    invoiceEmail?: string | undefined;
    invoiceEmailCC?: string | undefined;
    invoiceFrequency?: number;
    lastInvoiceDate?: Date | undefined;
    isActive?: boolean;
    address1?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    cvr?: string | undefined;
    invoices?: CtrInvoiceModel[] | undefined;

    constructor(data?: ICtrCustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerNumber = _data["customerNumber"];
            this.customerName = _data["customerName"];
            this.standardSku = _data["standardSku"];
            this.totalDuration = _data["totalDuration"];
            this.transportSku = _data["transportSku"];
            this.transportDistance = _data["transportDistance"];
            this.transportFixedPrice = _data["transportFixedPrice"];
            this.standardHeadingText = _data["standardHeadingText"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.invoiceEmailCC = _data["invoiceEmailCC"];
            this.invoiceFrequency = _data["invoiceFrequency"];
            this.lastInvoiceDate = _data["lastInvoiceDate"] ? new Date(_data["lastInvoiceDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.address1 = _data["address1"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.cvr = _data["cvr"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(CtrInvoiceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CtrCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new CtrCustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerNumber"] = this.customerNumber;
        data["customerName"] = this.customerName;
        data["standardSku"] = this.standardSku;
        data["totalDuration"] = this.totalDuration;
        data["transportSku"] = this.transportSku;
        data["transportDistance"] = this.transportDistance;
        data["transportFixedPrice"] = this.transportFixedPrice;
        data["standardHeadingText"] = this.standardHeadingText;
        data["invoiceEmail"] = this.invoiceEmail;
        data["invoiceEmailCC"] = this.invoiceEmailCC;
        data["invoiceFrequency"] = this.invoiceFrequency;
        data["lastInvoiceDate"] = this.lastInvoiceDate ? this.lastInvoiceDate.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["address1"] = this.address1;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["country"] = this.country;
        data["cvr"] = this.cvr;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CtrCustomerModel {
        const json = this.toJSON();
        let result = new CtrCustomerModel();
        result.init(json);
        return result;
    }
}

export interface ICtrCustomerModel {
    id?: string;
    customerNumber?: number;
    customerName?: string | undefined;
    standardSku?: number | undefined;
    totalDuration?: number;
    transportSku?: number | undefined;
    transportDistance?: number | undefined;
    transportFixedPrice?: number;
    standardHeadingText?: string | undefined;
    invoiceEmail?: string | undefined;
    invoiceEmailCC?: string | undefined;
    invoiceFrequency?: number;
    lastInvoiceDate?: Date | undefined;
    isActive?: boolean;
    address1?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    cvr?: string | undefined;
    invoices?: CtrInvoiceModel[] | undefined;
}

export class CtrInvoiceModel implements ICtrInvoiceModel {
    id?: string;
    draftNumber?: number;
    bookedNumber?: number;
    status?: InvoiceStatus;
    date?: Date | undefined;
    dueDate?: Date | undefined;
    lastFollowUp?: Date | undefined;
    heading?: string | undefined;
    netAmount?: number;
    remainder?: number;
    customerId?: string;
    customerName?: string | undefined;
    customerEmail?: string | undefined;

    constructor(data?: ICtrInvoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.draftNumber = _data["draftNumber"];
            this.bookedNumber = _data["bookedNumber"];
            this.status = _data["status"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.lastFollowUp = _data["lastFollowUp"] ? new Date(_data["lastFollowUp"].toString()) : undefined as any;
            this.heading = _data["heading"];
            this.netAmount = _data["netAmount"];
            this.remainder = _data["remainder"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.customerEmail = _data["customerEmail"];
        }
    }

    static fromJS(data: any): CtrInvoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new CtrInvoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["draftNumber"] = this.draftNumber;
        data["bookedNumber"] = this.bookedNumber;
        data["status"] = this.status;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["lastFollowUp"] = this.lastFollowUp ? this.lastFollowUp.toISOString() : undefined as any;
        data["heading"] = this.heading;
        data["netAmount"] = this.netAmount;
        data["remainder"] = this.remainder;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["customerEmail"] = this.customerEmail;
        return data;
    }

    clone(): CtrInvoiceModel {
        const json = this.toJSON();
        let result = new CtrInvoiceModel();
        result.init(json);
        return result;
    }
}

export interface ICtrInvoiceModel {
    id?: string;
    draftNumber?: number;
    bookedNumber?: number;
    status?: InvoiceStatus;
    date?: Date | undefined;
    dueDate?: Date | undefined;
    lastFollowUp?: Date | undefined;
    heading?: string | undefined;
    netAmount?: number;
    remainder?: number;
    customerId?: string;
    customerName?: string | undefined;
    customerEmail?: string | undefined;
}

export enum InvoiceStatus {
    Draft = 1,
    Invoiced = 2,
    Sent = 3,
    Overdue = 4,
    Paid = 5,
    Reminder1 = 6,
    Reminder2 = 7,
    Reminder3 = 8,
}

export class HistoryModel implements IHistoryModel {
    id?: number;
    userName?: string | undefined;
    date?: Date;
    content?: string | undefined;

    constructor(data?: IHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): HistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["content"] = this.content;
        return data;
    }

    clone(): HistoryModel {
        const json = this.toJSON();
        let result = new HistoryModel();
        result.init(json);
        return result;
    }
}

export interface IHistoryModel {
    id?: number;
    userName?: string | undefined;
    date?: Date;
    content?: string | undefined;
}

export class BasicEntity implements IBasicEntity {
    id?: string;
    userId?: string;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IBasicEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): BasicEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BasicEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): BasicEntity {
        const json = this.toJSON();
        let result = new BasicEntity();
        result.init(json);
        return result;
    }
}

export interface IBasicEntity {
    id?: string;
    userId?: string;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class AuditRouteModel extends BasicEntity implements IAuditRouteModel {
    date?: Date | undefined;
    auditUserId?: string | undefined;
    name?: string | undefined;
    visits?: AuditVisitModel[] | undefined;

    constructor(data?: IAuditRouteModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.auditUserId = _data["auditUserId"];
            this.name = _data["name"];
            if (Array.isArray(_data["visits"])) {
                this.visits = [] as any;
                for (let item of _data["visits"])
                    this.visits!.push(AuditVisitModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditRouteModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditRouteModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["auditUserId"] = this.auditUserId;
        data["name"] = this.name;
        if (Array.isArray(this.visits)) {
            data["visits"] = [];
            for (let item of this.visits)
                data["visits"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AuditRouteModel {
        const json = this.toJSON();
        let result = new AuditRouteModel();
        result.init(json);
        return result;
    }
}

export interface IAuditRouteModel extends IBasicEntity {
    date?: Date | undefined;
    auditUserId?: string | undefined;
    name?: string | undefined;
    visits?: AuditVisitModel[] | undefined;
}

export class AuditVisitModel extends BasicEntity implements IAuditVisitModel {
    routeId?: string | undefined;
    auditOrganizationId?: string;
    departmentId?: string | undefined;
    contactPersonId?: string | undefined;
    auditUserId?: string;
    surveyId?: string | undefined;
    time?: Date;
    duration?: string | undefined;
    surveyResultId?: string | undefined;
    status?: AuditVisitStatus;
    sortOrder?: number;

    constructor(data?: IAuditVisitModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.routeId = _data["routeId"];
            this.auditOrganizationId = _data["auditOrganizationId"];
            this.departmentId = _data["departmentId"];
            this.contactPersonId = _data["contactPersonId"];
            this.auditUserId = _data["auditUserId"];
            this.surveyId = _data["surveyId"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.surveyResultId = _data["surveyResultId"];
            this.status = _data["status"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static override fromJS(data: any): AuditVisitModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditVisitModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeId"] = this.routeId;
        data["auditOrganizationId"] = this.auditOrganizationId;
        data["departmentId"] = this.departmentId;
        data["contactPersonId"] = this.contactPersonId;
        data["auditUserId"] = this.auditUserId;
        data["surveyId"] = this.surveyId;
        data["time"] = this.time ? this.time.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["surveyResultId"] = this.surveyResultId;
        data["status"] = this.status;
        data["sortOrder"] = this.sortOrder;
        super.toJSON(data);
        return data;
    }

    clone(): AuditVisitModel {
        const json = this.toJSON();
        let result = new AuditVisitModel();
        result.init(json);
        return result;
    }
}

export interface IAuditVisitModel extends IBasicEntity {
    routeId?: string | undefined;
    auditOrganizationId?: string;
    departmentId?: string | undefined;
    contactPersonId?: string | undefined;
    auditUserId?: string;
    surveyId?: string | undefined;
    time?: Date;
    duration?: string | undefined;
    surveyResultId?: string | undefined;
    status?: AuditVisitStatus;
    sortOrder?: number;
}

export enum AuditVisitStatus {
    Draft = 0,
    Planned = 1,
    Done = 2,
    Finished = 3,
}

export abstract class BaseEntity implements IBaseEntity {
    id?: string;
    userId?: string;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): BaseEntity {
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }
}

export interface IBaseEntity {
    id?: string;
    userId?: string;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class AuditVisitViewModel extends BaseEntity implements IAuditVisitViewModel {
    auditVisitId?: string;
    organizationName?: string | undefined;
    organizationWebsiteUrl?: string | undefined;
    address?: AddressModel | undefined;
    routeId?: string | undefined;
    auditOrganizationId?: string;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    contactPersonId?: string | undefined;
    contactPersonName?: string | undefined;
    contactPersonPhone?: string | undefined;
    contactPersonEmail?: string | undefined;
    auditUserId?: string;
    auditUserName?: string | undefined;
    surveyId?: string | undefined;
    time?: Date;
    duration?: string | undefined;
    surveyResultId?: string | undefined;
    status?: AuditVisitStatus;
    sortOrder?: number;

    constructor(data?: IAuditVisitViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.auditVisitId = _data["auditVisitId"];
            this.organizationName = _data["organizationName"];
            this.organizationWebsiteUrl = _data["organizationWebsiteUrl"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : undefined as any;
            this.routeId = _data["routeId"];
            this.auditOrganizationId = _data["auditOrganizationId"];
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.contactPersonId = _data["contactPersonId"];
            this.contactPersonName = _data["contactPersonName"];
            this.contactPersonPhone = _data["contactPersonPhone"];
            this.contactPersonEmail = _data["contactPersonEmail"];
            this.auditUserId = _data["auditUserId"];
            this.auditUserName = _data["auditUserName"];
            this.surveyId = _data["surveyId"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.surveyResultId = _data["surveyResultId"];
            this.status = _data["status"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static override fromJS(data: any): AuditVisitViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditVisitViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditVisitId"] = this.auditVisitId;
        data["organizationName"] = this.organizationName;
        data["organizationWebsiteUrl"] = this.organizationWebsiteUrl;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["routeId"] = this.routeId;
        data["auditOrganizationId"] = this.auditOrganizationId;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["contactPersonId"] = this.contactPersonId;
        data["contactPersonName"] = this.contactPersonName;
        data["contactPersonPhone"] = this.contactPersonPhone;
        data["contactPersonEmail"] = this.contactPersonEmail;
        data["auditUserId"] = this.auditUserId;
        data["auditUserName"] = this.auditUserName;
        data["surveyId"] = this.surveyId;
        data["time"] = this.time ? this.time.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["surveyResultId"] = this.surveyResultId;
        data["status"] = this.status;
        data["sortOrder"] = this.sortOrder;
        super.toJSON(data);
        return data;
    }

    clone(): AuditVisitViewModel {
        const json = this.toJSON();
        let result = new AuditVisitViewModel();
        result.init(json);
        return result;
    }
}

export interface IAuditVisitViewModel extends IBaseEntity {
    auditVisitId?: string;
    organizationName?: string | undefined;
    organizationWebsiteUrl?: string | undefined;
    address?: AddressModel | undefined;
    routeId?: string | undefined;
    auditOrganizationId?: string;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    contactPersonId?: string | undefined;
    contactPersonName?: string | undefined;
    contactPersonPhone?: string | undefined;
    contactPersonEmail?: string | undefined;
    auditUserId?: string;
    auditUserName?: string | undefined;
    surveyId?: string | undefined;
    time?: Date;
    duration?: string | undefined;
    surveyResultId?: string | undefined;
    status?: AuditVisitStatus;
    sortOrder?: number;
}

export class AuditRouteModelDTO implements IAuditRouteModelDTO {
    id?: string;
    userId?: string | undefined;
    organizationId?: string | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean | undefined;
    date?: Date | undefined;
    auditUserId?: string | undefined;
    name?: string | undefined;
    visits?: AuditVisitModelDTO[] | undefined;

    constructor(data?: IAuditRouteModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.auditUserId = _data["auditUserId"];
            this.name = _data["name"];
            if (Array.isArray(_data["visits"])) {
                this.visits = [] as any;
                for (let item of _data["visits"])
                    this.visits!.push(AuditVisitModelDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditRouteModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuditRouteModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["auditUserId"] = this.auditUserId;
        data["name"] = this.name;
        if (Array.isArray(this.visits)) {
            data["visits"] = [];
            for (let item of this.visits)
                data["visits"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): AuditRouteModelDTO {
        const json = this.toJSON();
        let result = new AuditRouteModelDTO();
        result.init(json);
        return result;
    }
}

export interface IAuditRouteModelDTO {
    id?: string;
    userId?: string | undefined;
    organizationId?: string | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean | undefined;
    date?: Date | undefined;
    auditUserId?: string | undefined;
    name?: string | undefined;
    visits?: AuditVisitModelDTO[] | undefined;
}

export class AuditVisitModelDTO implements IAuditVisitModelDTO {
    id?: string;
    contractName?: string | undefined;
    userId?: string | undefined;
    organizationId?: string | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean | undefined;
    routeId?: string | undefined;
    auditOrganizationId?: string | undefined;
    departmentId?: string | undefined;
    contactPersonId?: string | undefined;
    auditUserId?: string | undefined;
    surveyId?: string | undefined;
    time?: Date | undefined;
    surveyResultId?: string | undefined;
    status?: AuditVisitStatus | undefined;

    constructor(data?: IAuditVisitModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractName = _data["contractName"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.routeId = _data["routeId"];
            this.auditOrganizationId = _data["auditOrganizationId"];
            this.departmentId = _data["departmentId"];
            this.contactPersonId = _data["contactPersonId"];
            this.auditUserId = _data["auditUserId"];
            this.surveyId = _data["surveyId"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : undefined as any;
            this.surveyResultId = _data["surveyResultId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AuditVisitModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuditVisitModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractName"] = this.contractName;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["routeId"] = this.routeId;
        data["auditOrganizationId"] = this.auditOrganizationId;
        data["departmentId"] = this.departmentId;
        data["contactPersonId"] = this.contactPersonId;
        data["auditUserId"] = this.auditUserId;
        data["surveyId"] = this.surveyId;
        data["time"] = this.time ? this.time.toISOString() : undefined as any;
        data["surveyResultId"] = this.surveyResultId;
        data["status"] = this.status;
        return data;
    }

    clone(): AuditVisitModelDTO {
        const json = this.toJSON();
        let result = new AuditVisitModelDTO();
        result.init(json);
        return result;
    }
}

export interface IAuditVisitModelDTO {
    id?: string;
    contractName?: string | undefined;
    userId?: string | undefined;
    organizationId?: string | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean | undefined;
    routeId?: string | undefined;
    auditOrganizationId?: string | undefined;
    departmentId?: string | undefined;
    contactPersonId?: string | undefined;
    auditUserId?: string | undefined;
    surveyId?: string | undefined;
    time?: Date | undefined;
    surveyResultId?: string | undefined;
    status?: AuditVisitStatus | undefined;
}

export class DirectionsResult implements IDirectionsResult {
    geocoded_waypoints?: GeocodedWaypoint[] | undefined;
    routes?: Route[] | undefined;
    status?: string | undefined;

    constructor(data?: IDirectionsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["geocoded_waypoints"])) {
                this.geocoded_waypoints = [] as any;
                for (let item of _data["geocoded_waypoints"])
                    this.geocoded_waypoints!.push(GeocodedWaypoint.fromJS(item));
            }
            if (Array.isArray(_data["routes"])) {
                this.routes = [] as any;
                for (let item of _data["routes"])
                    this.routes!.push(Route.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DirectionsResult {
        data = typeof data === 'object' ? data : {};
        let result = new DirectionsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.geocoded_waypoints)) {
            data["geocoded_waypoints"] = [];
            for (let item of this.geocoded_waypoints)
                data["geocoded_waypoints"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.routes)) {
            data["routes"] = [];
            for (let item of this.routes)
                data["routes"].push(item ? item.toJSON() : undefined as any);
        }
        data["status"] = this.status;
        return data;
    }

    clone(): DirectionsResult {
        const json = this.toJSON();
        let result = new DirectionsResult();
        result.init(json);
        return result;
    }
}

export interface IDirectionsResult {
    geocoded_waypoints?: GeocodedWaypoint[] | undefined;
    routes?: Route[] | undefined;
    status?: string | undefined;
}

export class GeocodedWaypoint implements IGeocodedWaypoint {
    geocoder_status?: string | undefined;
    place_id?: string | undefined;
    types?: string[] | undefined;

    constructor(data?: IGeocodedWaypoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geocoder_status = _data["geocoder_status"];
            this.place_id = _data["place_id"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static fromJS(data: any): GeocodedWaypoint {
        data = typeof data === 'object' ? data : {};
        let result = new GeocodedWaypoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geocoder_status"] = this.geocoder_status;
        data["place_id"] = this.place_id;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }

    clone(): GeocodedWaypoint {
        const json = this.toJSON();
        let result = new GeocodedWaypoint();
        result.init(json);
        return result;
    }
}

export interface IGeocodedWaypoint {
    geocoder_status?: string | undefined;
    place_id?: string | undefined;
    types?: string[] | undefined;
}

export class Route implements IRoute {
    bounds?: Bounds | undefined;
    copyrights?: string | undefined;
    legs?: Leg[] | undefined;
    overview_polyline?: OverviewPolyline | undefined;
    summary?: string | undefined;
    warnings?: any[] | undefined;
    waypoint_order?: number[] | undefined;

    constructor(data?: IRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bounds = _data["bounds"] ? Bounds.fromJS(_data["bounds"]) : undefined as any;
            this.copyrights = _data["copyrights"];
            if (Array.isArray(_data["legs"])) {
                this.legs = [] as any;
                for (let item of _data["legs"])
                    this.legs!.push(Leg.fromJS(item));
            }
            this.overview_polyline = _data["overview_polyline"] ? OverviewPolyline.fromJS(_data["overview_polyline"]) : undefined as any;
            this.summary = _data["summary"];
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            if (Array.isArray(_data["waypoint_order"])) {
                this.waypoint_order = [] as any;
                for (let item of _data["waypoint_order"])
                    this.waypoint_order!.push(item);
            }
        }
    }

    static fromJS(data: any): Route {
        data = typeof data === 'object' ? data : {};
        let result = new Route();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bounds"] = this.bounds ? this.bounds.toJSON() : undefined as any;
        data["copyrights"] = this.copyrights;
        if (Array.isArray(this.legs)) {
            data["legs"] = [];
            for (let item of this.legs)
                data["legs"].push(item ? item.toJSON() : undefined as any);
        }
        data["overview_polyline"] = this.overview_polyline ? this.overview_polyline.toJSON() : undefined as any;
        data["summary"] = this.summary;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        if (Array.isArray(this.waypoint_order)) {
            data["waypoint_order"] = [];
            for (let item of this.waypoint_order)
                data["waypoint_order"].push(item);
        }
        return data;
    }

    clone(): Route {
        const json = this.toJSON();
        let result = new Route();
        result.init(json);
        return result;
    }
}

export interface IRoute {
    bounds?: Bounds | undefined;
    copyrights?: string | undefined;
    legs?: Leg[] | undefined;
    overview_polyline?: OverviewPolyline | undefined;
    summary?: string | undefined;
    warnings?: any[] | undefined;
    waypoint_order?: number[] | undefined;
}

export class Bounds implements IBounds {
    northeast?: Northeast | undefined;
    southwest?: Southwest | undefined;

    constructor(data?: IBounds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.northeast = _data["northeast"] ? Northeast.fromJS(_data["northeast"]) : undefined as any;
            this.southwest = _data["southwest"] ? Southwest.fromJS(_data["southwest"]) : undefined as any;
        }
    }

    static fromJS(data: any): Bounds {
        data = typeof data === 'object' ? data : {};
        let result = new Bounds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["northeast"] = this.northeast ? this.northeast.toJSON() : undefined as any;
        data["southwest"] = this.southwest ? this.southwest.toJSON() : undefined as any;
        return data;
    }

    clone(): Bounds {
        const json = this.toJSON();
        let result = new Bounds();
        result.init(json);
        return result;
    }
}

export interface IBounds {
    northeast?: Northeast | undefined;
    southwest?: Southwest | undefined;
}

export class Northeast implements INortheast {
    lat?: number;
    lng?: number;

    constructor(data?: INortheast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): Northeast {
        data = typeof data === 'object' ? data : {};
        let result = new Northeast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data;
    }

    clone(): Northeast {
        const json = this.toJSON();
        let result = new Northeast();
        result.init(json);
        return result;
    }
}

export interface INortheast {
    lat?: number;
    lng?: number;
}

export class Southwest implements ISouthwest {
    lat?: number;
    lng?: number;

    constructor(data?: ISouthwest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): Southwest {
        data = typeof data === 'object' ? data : {};
        let result = new Southwest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data;
    }

    clone(): Southwest {
        const json = this.toJSON();
        let result = new Southwest();
        result.init(json);
        return result;
    }
}

export interface ISouthwest {
    lat?: number;
    lng?: number;
}

export class Leg implements ILeg {
    distance?: Distance | undefined;
    duration?: Duration | undefined;
    end_address?: string | undefined;
    end_location?: EndLocation | undefined;
    start_address?: string | undefined;
    start_location?: StartLocation | undefined;
    steps?: Step[] | undefined;
    traffic_speed_entry?: any[] | undefined;
    via_waypoint?: any[] | undefined;

    constructor(data?: ILeg) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distance = _data["distance"] ? Distance.fromJS(_data["distance"]) : undefined as any;
            this.duration = _data["duration"] ? Duration.fromJS(_data["duration"]) : undefined as any;
            this.end_address = _data["end_address"];
            this.end_location = _data["end_location"] ? EndLocation.fromJS(_data["end_location"]) : undefined as any;
            this.start_address = _data["start_address"];
            this.start_location = _data["start_location"] ? StartLocation.fromJS(_data["start_location"]) : undefined as any;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(Step.fromJS(item));
            }
            if (Array.isArray(_data["traffic_speed_entry"])) {
                this.traffic_speed_entry = [] as any;
                for (let item of _data["traffic_speed_entry"])
                    this.traffic_speed_entry!.push(item);
            }
            if (Array.isArray(_data["via_waypoint"])) {
                this.via_waypoint = [] as any;
                for (let item of _data["via_waypoint"])
                    this.via_waypoint!.push(item);
            }
        }
    }

    static fromJS(data: any): Leg {
        data = typeof data === 'object' ? data : {};
        let result = new Leg();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distance"] = this.distance ? this.distance.toJSON() : undefined as any;
        data["duration"] = this.duration ? this.duration.toJSON() : undefined as any;
        data["end_address"] = this.end_address;
        data["end_location"] = this.end_location ? this.end_location.toJSON() : undefined as any;
        data["start_address"] = this.start_address;
        data["start_location"] = this.start_location ? this.start_location.toJSON() : undefined as any;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.traffic_speed_entry)) {
            data["traffic_speed_entry"] = [];
            for (let item of this.traffic_speed_entry)
                data["traffic_speed_entry"].push(item);
        }
        if (Array.isArray(this.via_waypoint)) {
            data["via_waypoint"] = [];
            for (let item of this.via_waypoint)
                data["via_waypoint"].push(item);
        }
        return data;
    }

    clone(): Leg {
        const json = this.toJSON();
        let result = new Leg();
        result.init(json);
        return result;
    }
}

export interface ILeg {
    distance?: Distance | undefined;
    duration?: Duration | undefined;
    end_address?: string | undefined;
    end_location?: EndLocation | undefined;
    start_address?: string | undefined;
    start_location?: StartLocation | undefined;
    steps?: Step[] | undefined;
    traffic_speed_entry?: any[] | undefined;
    via_waypoint?: any[] | undefined;
}

export class Distance implements IDistance {
    text?: string | undefined;
    value?: number;

    constructor(data?: IDistance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Distance {
        data = typeof data === 'object' ? data : {};
        let result = new Distance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }

    clone(): Distance {
        const json = this.toJSON();
        let result = new Distance();
        result.init(json);
        return result;
    }
}

export interface IDistance {
    text?: string | undefined;
    value?: number;
}

export class Duration implements IDuration {
    text?: string | undefined;
    value?: number;

    constructor(data?: IDuration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Duration {
        data = typeof data === 'object' ? data : {};
        let result = new Duration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }

    clone(): Duration {
        const json = this.toJSON();
        let result = new Duration();
        result.init(json);
        return result;
    }
}

export interface IDuration {
    text?: string | undefined;
    value?: number;
}

export class EndLocation implements IEndLocation {
    lat?: number;
    lng?: number;

    constructor(data?: IEndLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): EndLocation {
        data = typeof data === 'object' ? data : {};
        let result = new EndLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data;
    }

    clone(): EndLocation {
        const json = this.toJSON();
        let result = new EndLocation();
        result.init(json);
        return result;
    }
}

export interface IEndLocation {
    lat?: number;
    lng?: number;
}

export class StartLocation implements IStartLocation {
    lat?: number;
    lng?: number;

    constructor(data?: IStartLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): StartLocation {
        data = typeof data === 'object' ? data : {};
        let result = new StartLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data;
    }

    clone(): StartLocation {
        const json = this.toJSON();
        let result = new StartLocation();
        result.init(json);
        return result;
    }
}

export interface IStartLocation {
    lat?: number;
    lng?: number;
}

export class Step implements IStep {
    distance?: Distance | undefined;
    duration?: Duration | undefined;
    end_location?: EndLocation | undefined;
    html_instructions?: string | undefined;
    polyline?: Polyline | undefined;
    start_location?: StartLocation | undefined;
    travel_mode?: string | undefined;
    maneuver?: string | undefined;

    constructor(data?: IStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distance = _data["distance"] ? Distance.fromJS(_data["distance"]) : undefined as any;
            this.duration = _data["duration"] ? Duration.fromJS(_data["duration"]) : undefined as any;
            this.end_location = _data["end_location"] ? EndLocation.fromJS(_data["end_location"]) : undefined as any;
            this.html_instructions = _data["html_instructions"];
            this.polyline = _data["polyline"] ? Polyline.fromJS(_data["polyline"]) : undefined as any;
            this.start_location = _data["start_location"] ? StartLocation.fromJS(_data["start_location"]) : undefined as any;
            this.travel_mode = _data["travel_mode"];
            this.maneuver = _data["maneuver"];
        }
    }

    static fromJS(data: any): Step {
        data = typeof data === 'object' ? data : {};
        let result = new Step();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distance"] = this.distance ? this.distance.toJSON() : undefined as any;
        data["duration"] = this.duration ? this.duration.toJSON() : undefined as any;
        data["end_location"] = this.end_location ? this.end_location.toJSON() : undefined as any;
        data["html_instructions"] = this.html_instructions;
        data["polyline"] = this.polyline ? this.polyline.toJSON() : undefined as any;
        data["start_location"] = this.start_location ? this.start_location.toJSON() : undefined as any;
        data["travel_mode"] = this.travel_mode;
        data["maneuver"] = this.maneuver;
        return data;
    }

    clone(): Step {
        const json = this.toJSON();
        let result = new Step();
        result.init(json);
        return result;
    }
}

export interface IStep {
    distance?: Distance | undefined;
    duration?: Duration | undefined;
    end_location?: EndLocation | undefined;
    html_instructions?: string | undefined;
    polyline?: Polyline | undefined;
    start_location?: StartLocation | undefined;
    travel_mode?: string | undefined;
    maneuver?: string | undefined;
}

export class Polyline implements IPolyline {
    points?: string | undefined;

    constructor(data?: IPolyline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.points = _data["points"];
        }
    }

    static fromJS(data: any): Polyline {
        data = typeof data === 'object' ? data : {};
        let result = new Polyline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["points"] = this.points;
        return data;
    }

    clone(): Polyline {
        const json = this.toJSON();
        let result = new Polyline();
        result.init(json);
        return result;
    }
}

export interface IPolyline {
    points?: string | undefined;
}

export class OverviewPolyline implements IOverviewPolyline {
    points?: string | undefined;

    constructor(data?: IOverviewPolyline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.points = _data["points"];
        }
    }

    static fromJS(data: any): OverviewPolyline {
        data = typeof data === 'object' ? data : {};
        let result = new OverviewPolyline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["points"] = this.points;
        return data;
    }

    clone(): OverviewPolyline {
        const json = this.toJSON();
        let result = new OverviewPolyline();
        result.init(json);
        return result;
    }
}

export interface IOverviewPolyline {
    points?: string | undefined;
}

export class BasicModel implements IBasicModel {
    id?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: IBasicModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): BasicModel {
        data = typeof data === 'object' ? data : {};
        let result = new BasicModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): BasicModel {
        const json = this.toJSON();
        let result = new BasicModel();
        result.init(json);
        return result;
    }
}

export interface IBasicModel {
    id?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
}

export class PropertyGroupDataModel extends BasicModel implements IPropertyGroupDataModel {
    entityId?: string;
    parentCollectionId?: string;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    propertyTypeGroupId?: string;
    propertyTypeGroupAlias?: string | undefined;
    propertyData?: PropertyDataModel[] | undefined;

    constructor(data?: IPropertyGroupDataModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entityId = _data["entityId"];
            this.parentCollectionId = _data["parentCollectionId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.propertyTypeGroupId = _data["propertyTypeGroupId"];
            this.propertyTypeGroupAlias = _data["propertyTypeGroupAlias"];
            if (Array.isArray(_data["propertyData"])) {
                this.propertyData = [] as any;
                for (let item of _data["propertyData"])
                    this.propertyData!.push(PropertyDataModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PropertyGroupDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyGroupDataModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["parentCollectionId"] = this.parentCollectionId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["propertyTypeGroupId"] = this.propertyTypeGroupId;
        data["propertyTypeGroupAlias"] = this.propertyTypeGroupAlias;
        if (Array.isArray(this.propertyData)) {
            data["propertyData"] = [];
            for (let item of this.propertyData)
                data["propertyData"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PropertyGroupDataModel {
        const json = this.toJSON();
        let result = new PropertyGroupDataModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyGroupDataModel extends IBasicModel {
    entityId?: string;
    parentCollectionId?: string;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    propertyTypeGroupId?: string;
    propertyTypeGroupAlias?: string | undefined;
    propertyData?: PropertyDataModel[] | undefined;
}

export class PropertyDataModel extends BasicModel implements IPropertyDataModel {
    entityId?: string;
    propertyTypeId?: string;
    propertyTypeAlias?: string | undefined;
    valueText?: string | undefined;
    valueInt?: number | undefined;
    valueDecimal?: number | undefined;
    valueBool?: boolean | undefined;
    valueDateTime?: Date | undefined;
    valueGuid?: string | undefined;
    extraInfo?: string | undefined;
    propertyOptions?: IdNameModel[] | undefined;
    propertyType?: PropertyTypeModel | undefined;

    constructor(data?: IPropertyDataModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entityId = _data["entityId"];
            this.propertyTypeId = _data["propertyTypeId"];
            this.propertyTypeAlias = _data["propertyTypeAlias"];
            this.valueText = _data["valueText"];
            this.valueInt = _data["valueInt"];
            this.valueDecimal = _data["valueDecimal"];
            this.valueBool = _data["valueBool"];
            this.valueDateTime = _data["valueDateTime"] ? new Date(_data["valueDateTime"].toString()) : undefined as any;
            this.valueGuid = _data["valueGuid"];
            this.extraInfo = _data["extraInfo"];
            if (Array.isArray(_data["propertyOptions"])) {
                this.propertyOptions = [] as any;
                for (let item of _data["propertyOptions"])
                    this.propertyOptions!.push(IdNameModel.fromJS(item));
            }
            this.propertyType = _data["propertyType"] ? PropertyTypeModel.fromJS(_data["propertyType"]) : undefined as any;
        }
    }

    static override fromJS(data: any): PropertyDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDataModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["propertyTypeId"] = this.propertyTypeId;
        data["propertyTypeAlias"] = this.propertyTypeAlias;
        data["valueText"] = this.valueText;
        data["valueInt"] = this.valueInt;
        data["valueDecimal"] = this.valueDecimal;
        data["valueBool"] = this.valueBool;
        data["valueDateTime"] = this.valueDateTime ? this.valueDateTime.toISOString() : undefined as any;
        data["valueGuid"] = this.valueGuid;
        data["extraInfo"] = this.extraInfo;
        if (Array.isArray(this.propertyOptions)) {
            data["propertyOptions"] = [];
            for (let item of this.propertyOptions)
                data["propertyOptions"].push(item ? item.toJSON() : undefined as any);
        }
        data["propertyType"] = this.propertyType ? this.propertyType.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): PropertyDataModel {
        const json = this.toJSON();
        let result = new PropertyDataModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyDataModel extends IBasicModel {
    entityId?: string;
    propertyTypeId?: string;
    propertyTypeAlias?: string | undefined;
    valueText?: string | undefined;
    valueInt?: number | undefined;
    valueDecimal?: number | undefined;
    valueBool?: boolean | undefined;
    valueDateTime?: Date | undefined;
    valueGuid?: string | undefined;
    extraInfo?: string | undefined;
    propertyOptions?: IdNameModel[] | undefined;
    propertyType?: PropertyTypeModel | undefined;
}

export class IdNameModel implements IIdNameModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IIdNameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IdNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): IdNameModel {
        const json = this.toJSON();
        let result = new IdNameModel();
        result.init(json);
        return result;
    }
}

export interface IIdNameModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class PropertyTypeModel extends BasicModel implements IPropertyTypeModel {
    name?: string | undefined;
    description?: string | undefined;
    alias?: string | undefined;
    sortOrder?: number;
    isVisible?: boolean;
    propertyValueType?: PropertyValueType;
    propertyTypeGroupId?: string;

    constructor(data?: IPropertyTypeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.alias = _data["alias"];
            this.sortOrder = _data["sortOrder"];
            this.isVisible = _data["isVisible"];
            this.propertyValueType = _data["propertyValueType"];
            this.propertyTypeGroupId = _data["propertyTypeGroupId"];
        }
    }

    static override fromJS(data: any): PropertyTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["alias"] = this.alias;
        data["sortOrder"] = this.sortOrder;
        data["isVisible"] = this.isVisible;
        data["propertyValueType"] = this.propertyValueType;
        data["propertyTypeGroupId"] = this.propertyTypeGroupId;
        super.toJSON(data);
        return data;
    }

    clone(): PropertyTypeModel {
        const json = this.toJSON();
        let result = new PropertyTypeModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyTypeModel extends IBasicModel {
    name?: string | undefined;
    description?: string | undefined;
    alias?: string | undefined;
    sortOrder?: number;
    isVisible?: boolean;
    propertyValueType?: PropertyValueType;
    propertyTypeGroupId?: string;
}

export enum PropertyValueType {
    Text = 1,
    Int = 2,
    Decimal = 3,
    Bool = 4,
    DateTime = 5,
    Guid = 6,
    RichText = 7,
    Dimension = 8,
    Logo = 9,
    EndUserReport = 10,
    File = 11,
    LetterTemplate = 12,
    Heading = 99,
}

export class SendVisitNotificationModel implements ISendVisitNotificationModel {
    visitId?: string;
    emails?: AddressModel[] | undefined;
    bccEmails?: AddressModel[] | undefined;
    templateId?: string;
    emailSubject?: string | undefined;
    emailBody?: string | undefined;
    lines?: string | undefined;

    constructor(data?: ISendVisitNotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visitId = _data["visitId"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(AddressModel.fromJS(item));
            }
            if (Array.isArray(_data["bccEmails"])) {
                this.bccEmails = [] as any;
                for (let item of _data["bccEmails"])
                    this.bccEmails!.push(AddressModel.fromJS(item));
            }
            this.templateId = _data["templateId"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.lines = _data["lines"];
        }
    }

    static fromJS(data: any): SendVisitNotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendVisitNotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitId"] = this.visitId;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bccEmails)) {
            data["bccEmails"] = [];
            for (let item of this.bccEmails)
                data["bccEmails"].push(item ? item.toJSON() : undefined as any);
        }
        data["templateId"] = this.templateId;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["lines"] = this.lines;
        return data;
    }

    clone(): SendVisitNotificationModel {
        const json = this.toJSON();
        let result = new SendVisitNotificationModel();
        result.init(json);
        return result;
    }
}

export interface ISendVisitNotificationModel {
    visitId?: string;
    emails?: AddressModel[] | undefined;
    bccEmails?: AddressModel[] | undefined;
    templateId?: string;
    emailSubject?: string | undefined;
    emailBody?: string | undefined;
    lines?: string | undefined;
}

export class CalendarModel extends BasicEntity implements ICalendarModel {
    name?: string | undefined;
    type?: number;

    constructor(data?: ICalendarModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): CalendarModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }

    clone(): CalendarModel {
        const json = this.toJSON();
        let result = new CalendarModel();
        result.init(json);
        return result;
    }
}

export interface ICalendarModel extends IBasicEntity {
    name?: string | undefined;
    type?: number;
}

export class CapabilityModel implements ICapabilityModel {
    id?: string;
    name?: string | undefined;
    level?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    departmentId?: string | undefined;

    constructor(data?: ICapabilityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.level = _data["level"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): CapabilityModel {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["level"] = this.level;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["departmentId"] = this.departmentId;
        return data;
    }

    clone(): CapabilityModel {
        const json = this.toJSON();
        let result = new CapabilityModel();
        result.init(json);
        return result;
    }
}

export interface ICapabilityModel {
    id?: string;
    name?: string | undefined;
    level?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    departmentId?: string | undefined;
}

export class CarrierModel implements ICarrierModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    bookingChannel?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: ICarrierModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.bookingChannel = _data["bookingChannel"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CarrierModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["bookingChannel"] = this.bookingChannel;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CarrierModel {
        const json = this.toJSON();
        let result = new CarrierModel();
        result.init(json);
        return result;
    }
}

export interface ICarrierModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    bookingChannel?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class CcpModel implements ICcpModel {
    id?: string;
    name?: string | undefined;
    parentCcpId?: string | undefined;
    recipeId?: string | undefined;
    riskFactorId?: string | undefined;
    riskFactorName?: string | undefined;
    riskAnalysisId?: string;
    riskAnalysisName?: string | undefined;
    ccpNo?: string | undefined;
    risk?: string | undefined;
    controllingAction?: string | undefined;
    criticalLimit?: string | undefined;
    monitoring?: string | undefined;
    responsibilityDocumentation?: string | undefined;
    frequency?: string | undefined;
    verification?: string | undefined;
    correctiveAction?: string | undefined;
    responsibilityCorrectiveAction?: string | undefined;
    criticalValueMin?: number | undefined;
    criticalValueTarget?: number | undefined;
    criticalValueMax?: number | undefined;
    criticalValueType?: CcpValueType | undefined;
    criticalValueUnit?: string | undefined;
    criticalValueDuration?: string | undefined;
    processStepName?: string | undefined;
    type?: CcpType;
    description?: string | undefined;
    cronSchedule?: string | undefined;
    cronRepeatEvery?: number;
    cronFirstOccurence?: Date | undefined;
    cronLastOccurence?: Date | undefined;
    nextMeasurement?: Date | undefined;
    expirationMeasurement?: Date | undefined;
    measurementStatus?: number;
    originText?: string | undefined;
    valueText?: string | undefined;
    lotName?: string | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    source?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: ICcpModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentCcpId = _data["parentCcpId"];
            this.recipeId = _data["recipeId"];
            this.riskFactorId = _data["riskFactorId"];
            this.riskFactorName = _data["riskFactorName"];
            this.riskAnalysisId = _data["riskAnalysisId"];
            this.riskAnalysisName = _data["riskAnalysisName"];
            this.ccpNo = _data["ccpNo"];
            this.risk = _data["risk"];
            this.controllingAction = _data["controllingAction"];
            this.criticalLimit = _data["criticalLimit"];
            this.monitoring = _data["monitoring"];
            this.responsibilityDocumentation = _data["responsibilityDocumentation"];
            this.frequency = _data["frequency"];
            this.verification = _data["verification"];
            this.correctiveAction = _data["correctiveAction"];
            this.responsibilityCorrectiveAction = _data["responsibilityCorrectiveAction"];
            this.criticalValueMin = _data["criticalValueMin"];
            this.criticalValueTarget = _data["criticalValueTarget"];
            this.criticalValueMax = _data["criticalValueMax"];
            this.criticalValueType = _data["criticalValueType"];
            this.criticalValueUnit = _data["criticalValueUnit"];
            this.criticalValueDuration = _data["criticalValueDuration"];
            this.processStepName = _data["processStepName"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.cronSchedule = _data["cronSchedule"];
            this.cronRepeatEvery = _data["cronRepeatEvery"];
            this.cronFirstOccurence = _data["cronFirstOccurence"] ? new Date(_data["cronFirstOccurence"].toString()) : undefined as any;
            this.cronLastOccurence = _data["cronLastOccurence"] ? new Date(_data["cronLastOccurence"].toString()) : undefined as any;
            this.nextMeasurement = _data["nextMeasurement"] ? new Date(_data["nextMeasurement"].toString()) : undefined as any;
            this.expirationMeasurement = _data["expirationMeasurement"] ? new Date(_data["expirationMeasurement"].toString()) : undefined as any;
            this.measurementStatus = _data["measurementStatus"];
            this.originText = _data["originText"];
            this.valueText = _data["valueText"];
            this.lotName = _data["lotName"];
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.source = _data["source"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CcpModel {
        data = typeof data === 'object' ? data : {};
        let result = new CcpModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentCcpId"] = this.parentCcpId;
        data["recipeId"] = this.recipeId;
        data["riskFactorId"] = this.riskFactorId;
        data["riskFactorName"] = this.riskFactorName;
        data["riskAnalysisId"] = this.riskAnalysisId;
        data["riskAnalysisName"] = this.riskAnalysisName;
        data["ccpNo"] = this.ccpNo;
        data["risk"] = this.risk;
        data["controllingAction"] = this.controllingAction;
        data["criticalLimit"] = this.criticalLimit;
        data["monitoring"] = this.monitoring;
        data["responsibilityDocumentation"] = this.responsibilityDocumentation;
        data["frequency"] = this.frequency;
        data["verification"] = this.verification;
        data["correctiveAction"] = this.correctiveAction;
        data["responsibilityCorrectiveAction"] = this.responsibilityCorrectiveAction;
        data["criticalValueMin"] = this.criticalValueMin;
        data["criticalValueTarget"] = this.criticalValueTarget;
        data["criticalValueMax"] = this.criticalValueMax;
        data["criticalValueType"] = this.criticalValueType;
        data["criticalValueUnit"] = this.criticalValueUnit;
        data["criticalValueDuration"] = this.criticalValueDuration;
        data["processStepName"] = this.processStepName;
        data["type"] = this.type;
        data["description"] = this.description;
        data["cronSchedule"] = this.cronSchedule;
        data["cronRepeatEvery"] = this.cronRepeatEvery;
        data["cronFirstOccurence"] = this.cronFirstOccurence ? this.cronFirstOccurence.toISOString() : undefined as any;
        data["cronLastOccurence"] = this.cronLastOccurence ? this.cronLastOccurence.toISOString() : undefined as any;
        data["nextMeasurement"] = this.nextMeasurement ? this.nextMeasurement.toISOString() : undefined as any;
        data["expirationMeasurement"] = this.expirationMeasurement ? this.expirationMeasurement.toISOString() : undefined as any;
        data["measurementStatus"] = this.measurementStatus;
        data["originText"] = this.originText;
        data["valueText"] = this.valueText;
        data["lotName"] = this.lotName;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["source"] = this.source;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CcpModel {
        const json = this.toJSON();
        let result = new CcpModel();
        result.init(json);
        return result;
    }
}

export interface ICcpModel {
    id?: string;
    name?: string | undefined;
    parentCcpId?: string | undefined;
    recipeId?: string | undefined;
    riskFactorId?: string | undefined;
    riskFactorName?: string | undefined;
    riskAnalysisId?: string;
    riskAnalysisName?: string | undefined;
    ccpNo?: string | undefined;
    risk?: string | undefined;
    controllingAction?: string | undefined;
    criticalLimit?: string | undefined;
    monitoring?: string | undefined;
    responsibilityDocumentation?: string | undefined;
    frequency?: string | undefined;
    verification?: string | undefined;
    correctiveAction?: string | undefined;
    responsibilityCorrectiveAction?: string | undefined;
    criticalValueMin?: number | undefined;
    criticalValueTarget?: number | undefined;
    criticalValueMax?: number | undefined;
    criticalValueType?: CcpValueType | undefined;
    criticalValueUnit?: string | undefined;
    criticalValueDuration?: string | undefined;
    processStepName?: string | undefined;
    type?: CcpType;
    description?: string | undefined;
    cronSchedule?: string | undefined;
    cronRepeatEvery?: number;
    cronFirstOccurence?: Date | undefined;
    cronLastOccurence?: Date | undefined;
    nextMeasurement?: Date | undefined;
    expirationMeasurement?: Date | undefined;
    measurementStatus?: number;
    originText?: string | undefined;
    valueText?: string | undefined;
    lotName?: string | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    source?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum CcpValueType {
    Target = 1,
    Min = 2,
    Max = 3,
    Range = 4,
    Text = 5,
    Confirmation = 6,
    Date = 7,
    Sampling = 8,
    Cooling = 9,
    ConfirmationDouble = 10,
    DateRangeBelow = 11,
    DateRangeAbove = 12,
    ConfirmationNegative = 13,
    AllergensOrganic = 20,
    Supplier = 100,
    Customer = 101,
    ShiftMatrix = 800,
    CountMatrix = 801,
    Description = 998,
    Heading = 999,
}

export enum CcpType {
    CCP = 0,
    OPRP = 1,
    CP = 2,
    Optional = 3,
    Tracking = 4,
    TrackingCompleted = 5,
    Group = 6,
    Combined = 7,
    PRP = 8,
}

export class CcpScheduleOverview implements ICcpScheduleOverview {
    ccpSchedules?: CcpSchedule[] | undefined;
    ccpGroup?: CcpGroupModel | undefined;

    constructor(data?: ICcpScheduleOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ccpSchedules"])) {
                this.ccpSchedules = [] as any;
                for (let item of _data["ccpSchedules"])
                    this.ccpSchedules!.push(CcpSchedule.fromJS(item));
            }
            this.ccpGroup = _data["ccpGroup"] ? CcpGroupModel.fromJS(_data["ccpGroup"]) : undefined as any;
        }
    }

    static fromJS(data: any): CcpScheduleOverview {
        data = typeof data === 'object' ? data : {};
        let result = new CcpScheduleOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ccpSchedules)) {
            data["ccpSchedules"] = [];
            for (let item of this.ccpSchedules)
                data["ccpSchedules"].push(item ? item.toJSON() : undefined as any);
        }
        data["ccpGroup"] = this.ccpGroup ? this.ccpGroup.toJSON() : undefined as any;
        return data;
    }

    clone(): CcpScheduleOverview {
        const json = this.toJSON();
        let result = new CcpScheduleOverview();
        result.init(json);
        return result;
    }
}

export interface ICcpScheduleOverview {
    ccpSchedules?: CcpSchedule[] | undefined;
    ccpGroup?: CcpGroupModel | undefined;
}

export class CcpSchedule implements ICcpSchedule {
    days?: CcpScheduleDay[] | undefined;
    ccp?: CcpModel | undefined;

    constructor(data?: ICcpSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(CcpScheduleDay.fromJS(item));
            }
            this.ccp = _data["ccp"] ? CcpModel.fromJS(_data["ccp"]) : undefined as any;
        }
    }

    static fromJS(data: any): CcpSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new CcpSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item ? item.toJSON() : undefined as any);
        }
        data["ccp"] = this.ccp ? this.ccp.toJSON() : undefined as any;
        return data;
    }

    clone(): CcpSchedule {
        const json = this.toJSON();
        let result = new CcpSchedule();
        result.init(json);
        return result;
    }
}

export interface ICcpSchedule {
    days?: CcpScheduleDay[] | undefined;
    ccp?: CcpModel | undefined;
}

export class CcpScheduleDay implements ICcpScheduleDay {
    date?: Date;
    scheduled?: number;
    measurements?: CcpMeasurementModel[] | undefined;
    status?: number;

    constructor(data?: ICcpScheduleDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.scheduled = _data["scheduled"];
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [] as any;
                for (let item of _data["measurements"])
                    this.measurements!.push(CcpMeasurementModel.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CcpScheduleDay {
        data = typeof data === 'object' ? data : {};
        let result = new CcpScheduleDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["scheduled"] = this.scheduled;
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item ? item.toJSON() : undefined as any);
        }
        data["status"] = this.status;
        return data;
    }

    clone(): CcpScheduleDay {
        const json = this.toJSON();
        let result = new CcpScheduleDay();
        result.init(json);
        return result;
    }
}

export interface ICcpScheduleDay {
    date?: Date;
    scheduled?: number;
    measurements?: CcpMeasurementModel[] | undefined;
    status?: number;
}

export class CcpMeasurementModel implements ICcpMeasurementModel {
    id?: string;
    measurementValue?: number | undefined;
    measurementValue2?: number | undefined;
    measurementTime?: Date;
    measurementString?: string | undefined;
    measurementBool?: boolean | undefined;
    measurementGuid?: string | undefined;
    measurementTimeFrom?: Date | undefined;
    measurementTimeTo?: Date | undefined;
    notRelevant?: boolean;
    comment?: string | undefined;
    status?: CcpMeasurementStatus;
    plannedTime?: Date | undefined;
    plannedDeadline?: Date | undefined;
    ccpId?: string;
    productionOrderId?: string;
    orderlineId?: string;
    ccp?: CcpModel | undefined;
    userId?: string;
    parentMeasurementId?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: ICcpMeasurementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.measurementValue = _data["measurementValue"];
            this.measurementValue2 = _data["measurementValue2"];
            this.measurementTime = _data["measurementTime"] ? new Date(_data["measurementTime"].toString()) : undefined as any;
            this.measurementString = _data["measurementString"];
            this.measurementBool = _data["measurementBool"];
            this.measurementGuid = _data["measurementGuid"];
            this.measurementTimeFrom = _data["measurementTimeFrom"] ? new Date(_data["measurementTimeFrom"].toString()) : undefined as any;
            this.measurementTimeTo = _data["measurementTimeTo"] ? new Date(_data["measurementTimeTo"].toString()) : undefined as any;
            this.notRelevant = _data["notRelevant"];
            this.comment = _data["comment"];
            this.status = _data["status"];
            this.plannedTime = _data["plannedTime"] ? new Date(_data["plannedTime"].toString()) : undefined as any;
            this.plannedDeadline = _data["plannedDeadline"] ? new Date(_data["plannedDeadline"].toString()) : undefined as any;
            this.ccpId = _data["ccpId"];
            this.productionOrderId = _data["productionOrderId"];
            this.orderlineId = _data["orderlineId"];
            this.ccp = _data["ccp"] ? CcpModel.fromJS(_data["ccp"]) : undefined as any;
            this.userId = _data["userId"];
            this.parentMeasurementId = _data["parentMeasurementId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CcpMeasurementModel {
        data = typeof data === 'object' ? data : {};
        let result = new CcpMeasurementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["measurementValue"] = this.measurementValue;
        data["measurementValue2"] = this.measurementValue2;
        data["measurementTime"] = this.measurementTime ? this.measurementTime.toISOString() : undefined as any;
        data["measurementString"] = this.measurementString;
        data["measurementBool"] = this.measurementBool;
        data["measurementGuid"] = this.measurementGuid;
        data["measurementTimeFrom"] = this.measurementTimeFrom ? this.measurementTimeFrom.toISOString() : undefined as any;
        data["measurementTimeTo"] = this.measurementTimeTo ? this.measurementTimeTo.toISOString() : undefined as any;
        data["notRelevant"] = this.notRelevant;
        data["comment"] = this.comment;
        data["status"] = this.status;
        data["plannedTime"] = this.plannedTime ? this.plannedTime.toISOString() : undefined as any;
        data["plannedDeadline"] = this.plannedDeadline ? this.plannedDeadline.toISOString() : undefined as any;
        data["ccpId"] = this.ccpId;
        data["productionOrderId"] = this.productionOrderId;
        data["orderlineId"] = this.orderlineId;
        data["ccp"] = this.ccp ? this.ccp.toJSON() : undefined as any;
        data["userId"] = this.userId;
        data["parentMeasurementId"] = this.parentMeasurementId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CcpMeasurementModel {
        const json = this.toJSON();
        let result = new CcpMeasurementModel();
        result.init(json);
        return result;
    }
}

export interface ICcpMeasurementModel {
    id?: string;
    measurementValue?: number | undefined;
    measurementValue2?: number | undefined;
    measurementTime?: Date;
    measurementString?: string | undefined;
    measurementBool?: boolean | undefined;
    measurementGuid?: string | undefined;
    measurementTimeFrom?: Date | undefined;
    measurementTimeTo?: Date | undefined;
    notRelevant?: boolean;
    comment?: string | undefined;
    status?: CcpMeasurementStatus;
    plannedTime?: Date | undefined;
    plannedDeadline?: Date | undefined;
    ccpId?: string;
    productionOrderId?: string;
    orderlineId?: string;
    ccp?: CcpModel | undefined;
    userId?: string;
    parentMeasurementId?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum CcpMeasurementStatus {
    Draft = 0,
    Planned = 1,
    Started = 2,
    Completed = 3,
}

export class CcpGroupModel implements ICcpGroupModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    sortOrder?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    ccpRelations?: CcpRelationModel[] | undefined;

    constructor(data?: ICcpGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.sortOrder = _data["sortOrder"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["ccpRelations"])) {
                this.ccpRelations = [] as any;
                for (let item of _data["ccpRelations"])
                    this.ccpRelations!.push(CcpRelationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CcpGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new CcpGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["sortOrder"] = this.sortOrder;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.ccpRelations)) {
            data["ccpRelations"] = [];
            for (let item of this.ccpRelations)
                data["ccpRelations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CcpGroupModel {
        const json = this.toJSON();
        let result = new CcpGroupModel();
        result.init(json);
        return result;
    }
}

export interface ICcpGroupModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    sortOrder?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    ccpRelations?: CcpRelationModel[] | undefined;
}

export class CcpRelationModel implements ICcpRelationModel {
    id?: string;
    entityType?: EntityType;
    entityId?: string | undefined;
    entityName?: string | undefined;
    ccpId?: string | undefined;
    ccpName?: string | undefined;
    ccpGroupId?: string | undefined;
    sortOrder?: number;
    headingText?: string | undefined;
    valueText?: string | undefined;
    step?: number;
    relationType?: number;
    ccp?: CcpModel | undefined;
    ccpGroup?: CcpGroupModel | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: ICcpRelationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.entityName = _data["entityName"];
            this.ccpId = _data["ccpId"];
            this.ccpName = _data["ccpName"];
            this.ccpGroupId = _data["ccpGroupId"];
            this.sortOrder = _data["sortOrder"];
            this.headingText = _data["headingText"];
            this.valueText = _data["valueText"];
            this.step = _data["step"];
            this.relationType = _data["relationType"];
            this.ccp = _data["ccp"] ? CcpModel.fromJS(_data["ccp"]) : undefined as any;
            this.ccpGroup = _data["ccpGroup"] ? CcpGroupModel.fromJS(_data["ccpGroup"]) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CcpRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CcpRelationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["entityName"] = this.entityName;
        data["ccpId"] = this.ccpId;
        data["ccpName"] = this.ccpName;
        data["ccpGroupId"] = this.ccpGroupId;
        data["sortOrder"] = this.sortOrder;
        data["headingText"] = this.headingText;
        data["valueText"] = this.valueText;
        data["step"] = this.step;
        data["relationType"] = this.relationType;
        data["ccp"] = this.ccp ? this.ccp.toJSON() : undefined as any;
        data["ccpGroup"] = this.ccpGroup ? this.ccpGroup.toJSON() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CcpRelationModel {
        const json = this.toJSON();
        let result = new CcpRelationModel();
        result.init(json);
        return result;
    }
}

export interface ICcpRelationModel {
    id?: string;
    entityType?: EntityType;
    entityId?: string | undefined;
    entityName?: string | undefined;
    ccpId?: string | undefined;
    ccpName?: string | undefined;
    ccpGroupId?: string | undefined;
    sortOrder?: number;
    headingText?: string | undefined;
    valueText?: string | undefined;
    step?: number;
    relationType?: number;
    ccp?: CcpModel | undefined;
    ccpGroup?: CcpGroupModel | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum EntityType {
    Ccp = 0,
    CcpGroup = 1,
    Product = 2,
    ProductGroup = 3,
    Orderline = 4,
    RiskFactor = 5,
    Recipe = 6,
    Process = 7,
    ProcessStep = 8,
    ProductLot = 9,
    Department = 10,
    Organization = 11,
    RiskAnalysis = 12,
    Procedure = 13,
    ProcedureStep = 14,
    Heading = 999,
}

export class CcpNonComplianceModel implements ICcpNonComplianceModel {
    id?: string;
    ccpMeasurementId?: string | undefined;
    correctiveAction?: string | undefined;
    preventiveAction?: string | undefined;
    date?: Date | undefined;
    description?: string | undefined;
    productsAffected?: string | undefined;
    rootCause?: string | undefined;
    nonComplianceNumber?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    type?: NonConformanceTypeEnum;
    nonConformanceType?: NonConformanceType | undefined;
    nonConformanceTypeId?: string | undefined;
    verification?: string | undefined;
    status?: NonConformanceStatus;
    closedDate?: Date | undefined;
    closedByUserId?: string | undefined;
    closedByUser?: IdNameModel | undefined;
    openedByUserId?: string | undefined;
    openedByUser?: IdNameModel | undefined;
    ccpId?: string | undefined;
    userId?: string;
    ccpMeasurement?: CcpMeasurementModel | undefined;
    ccp?: CcpModel | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: ICcpNonComplianceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ccpMeasurementId = _data["ccpMeasurementId"];
            this.correctiveAction = _data["correctiveAction"];
            this.preventiveAction = _data["preventiveAction"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.description = _data["description"];
            this.productsAffected = _data["productsAffected"];
            this.rootCause = _data["rootCause"];
            this.nonComplianceNumber = _data["nonComplianceNumber"];
            this.responsibleUser = _data["responsibleUser"] ? IdNameModel.fromJS(_data["responsibleUser"]) : undefined as any;
            this.type = _data["type"];
            this.nonConformanceType = _data["nonConformanceType"] ? NonConformanceType.fromJS(_data["nonConformanceType"]) : undefined as any;
            this.nonConformanceTypeId = _data["nonConformanceTypeId"];
            this.verification = _data["verification"];
            this.status = _data["status"];
            this.closedDate = _data["closedDate"] ? new Date(_data["closedDate"].toString()) : undefined as any;
            this.closedByUserId = _data["closedByUserId"];
            this.closedByUser = _data["closedByUser"] ? IdNameModel.fromJS(_data["closedByUser"]) : undefined as any;
            this.openedByUserId = _data["openedByUserId"];
            this.openedByUser = _data["openedByUser"] ? IdNameModel.fromJS(_data["openedByUser"]) : undefined as any;
            this.ccpId = _data["ccpId"];
            this.userId = _data["userId"];
            this.ccpMeasurement = _data["ccpMeasurement"] ? CcpMeasurementModel.fromJS(_data["ccpMeasurement"]) : undefined as any;
            this.ccp = _data["ccp"] ? CcpModel.fromJS(_data["ccp"]) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CcpNonComplianceModel {
        data = typeof data === 'object' ? data : {};
        let result = new CcpNonComplianceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ccpMeasurementId"] = this.ccpMeasurementId;
        data["correctiveAction"] = this.correctiveAction;
        data["preventiveAction"] = this.preventiveAction;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["description"] = this.description;
        data["productsAffected"] = this.productsAffected;
        data["rootCause"] = this.rootCause;
        data["nonComplianceNumber"] = this.nonComplianceNumber;
        data["responsibleUser"] = this.responsibleUser ? this.responsibleUser.toJSON() : undefined as any;
        data["type"] = this.type;
        data["nonConformanceType"] = this.nonConformanceType ? this.nonConformanceType.toJSON() : undefined as any;
        data["nonConformanceTypeId"] = this.nonConformanceTypeId;
        data["verification"] = this.verification;
        data["status"] = this.status;
        data["closedDate"] = this.closedDate ? this.closedDate.toISOString() : undefined as any;
        data["closedByUserId"] = this.closedByUserId;
        data["closedByUser"] = this.closedByUser ? this.closedByUser.toJSON() : undefined as any;
        data["openedByUserId"] = this.openedByUserId;
        data["openedByUser"] = this.openedByUser ? this.openedByUser.toJSON() : undefined as any;
        data["ccpId"] = this.ccpId;
        data["userId"] = this.userId;
        data["ccpMeasurement"] = this.ccpMeasurement ? this.ccpMeasurement.toJSON() : undefined as any;
        data["ccp"] = this.ccp ? this.ccp.toJSON() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CcpNonComplianceModel {
        const json = this.toJSON();
        let result = new CcpNonComplianceModel();
        result.init(json);
        return result;
    }
}

export interface ICcpNonComplianceModel {
    id?: string;
    ccpMeasurementId?: string | undefined;
    correctiveAction?: string | undefined;
    preventiveAction?: string | undefined;
    date?: Date | undefined;
    description?: string | undefined;
    productsAffected?: string | undefined;
    rootCause?: string | undefined;
    nonComplianceNumber?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    type?: NonConformanceTypeEnum;
    nonConformanceType?: NonConformanceType | undefined;
    nonConformanceTypeId?: string | undefined;
    verification?: string | undefined;
    status?: NonConformanceStatus;
    closedDate?: Date | undefined;
    closedByUserId?: string | undefined;
    closedByUser?: IdNameModel | undefined;
    openedByUserId?: string | undefined;
    openedByUser?: IdNameModel | undefined;
    ccpId?: string | undefined;
    userId?: string;
    ccpMeasurement?: CcpMeasurementModel | undefined;
    ccp?: CcpModel | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum NonConformanceTypeEnum {
    CCP = 0,
    Raw = 1,
    Product = 2,
    Cleaning = 3,
    Maintenance = 4,
    PestControl = 5,
    Packaging = 6,
    Labels = 7,
    Other = 99,
}

export class NonConformanceType extends BaseEntity implements INonConformanceType {
    name?: string;
    description?: string;
    sortOrder?: number;

    constructor(data?: INonConformanceType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static override fromJS(data: any): NonConformanceType {
        data = typeof data === 'object' ? data : {};
        let result = new NonConformanceType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        super.toJSON(data);
        return data;
    }

    clone(): NonConformanceType {
        const json = this.toJSON();
        let result = new NonConformanceType();
        result.init(json);
        return result;
    }
}

export interface INonConformanceType extends IBaseEntity {
    name?: string;
    description?: string;
    sortOrder?: number;
}

export enum NonConformanceStatus {
    Draft = 0,
    Closed = 1,
    Approved = 2,
}

export abstract class PagedResultBase implements IPagedResultBase {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    sortColumn?: string;
    sortDirection?: string;
    filters?: FilterModel[];
    firstRowOnPage?: number;
    lastRowOnPage?: number;

    constructor(data?: IPagedResultBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterModel.fromJS(item));
            }
            this.firstRowOnPage = _data["firstRowOnPage"];
            this.lastRowOnPage = _data["lastRowOnPage"];
        }
    }

    static fromJS(data: any): PagedResultBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PagedResultBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        data["firstRowOnPage"] = this.firstRowOnPage;
        data["lastRowOnPage"] = this.lastRowOnPage;
        return data;
    }

    clone(): PagedResultBase {
        throw new Error("The abstract class 'PagedResultBase' cannot be instantiated.");
    }
}

export interface IPagedResultBase {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    sortColumn?: string;
    sortDirection?: string;
    filters?: FilterModel[];
    firstRowOnPage?: number;
    lastRowOnPage?: number;
}

export class PagedResultOfCcpNonComplianceModel extends PagedResultBase implements IPagedResultOfCcpNonComplianceModel {
    results?: CcpNonComplianceModel[];

    constructor(data?: IPagedResultOfCcpNonComplianceModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CcpNonComplianceModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfCcpNonComplianceModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfCcpNonComplianceModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfCcpNonComplianceModel {
        const json = this.toJSON();
        let result = new PagedResultOfCcpNonComplianceModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfCcpNonComplianceModel extends IPagedResultBase {
    results?: CcpNonComplianceModel[];
}

export class FilterModel implements IFilterModel {
    name?: string | undefined;
    values?: string[] | undefined;

    constructor(data?: IFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): FilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }

    clone(): FilterModel {
        const json = this.toJSON();
        let result = new FilterModel();
        result.init(json);
        return result;
    }
}

export interface IFilterModel {
    name?: string | undefined;
    values?: string[] | undefined;
}

export class PagedQuery implements IPagedQuery {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filters?: FilterModel[] | undefined;

    constructor(data?: IPagedQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.rowCount = _data["rowCount"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PagedQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["rowCount"] = this.rowCount;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PagedQuery {
        const json = this.toJSON();
        let result = new PagedQuery();
        result.init(json);
        return result;
    }
}

export interface IPagedQuery {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filters?: FilterModel[] | undefined;
}

export class CtrTaskModel implements ICtrTaskModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    memberId?: number;
    customer?: CtrCustomerModel | undefined;
    contactPersonId?: string | undefined;
    responsibleMember?: CtrUserModel | undefined;
    departmentId?: string | undefined;
    isDeleted?: boolean;
    type?: CtrTaskType;
    status?: CtrTaskStatus;
    sortOrder?: number;
    priority?: number;
    estimatedHours?: number;
    registeredHours?: number;
    deadline?: Date | undefined;
    gitHubIssue?: string | undefined;
    entityId?: string;
    organizationId?: string;
    taskState?: CtrTaskState;
    tags?: CtrTagModel[] | undefined;

    constructor(data?: ICtrTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.memberId = _data["memberId"];
            this.customer = _data["customer"] ? CtrCustomerModel.fromJS(_data["customer"]) : undefined as any;
            this.contactPersonId = _data["contactPersonId"];
            this.responsibleMember = _data["responsibleMember"] ? CtrUserModel.fromJS(_data["responsibleMember"]) : undefined as any;
            this.departmentId = _data["departmentId"];
            this.isDeleted = _data["isDeleted"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.sortOrder = _data["sortOrder"];
            this.priority = _data["priority"];
            this.estimatedHours = _data["estimatedHours"];
            this.registeredHours = _data["registeredHours"];
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : undefined as any;
            this.gitHubIssue = _data["gitHubIssue"];
            this.entityId = _data["entityId"];
            this.organizationId = _data["organizationId"];
            this.taskState = _data["taskState"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(CtrTagModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CtrTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new CtrTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["memberId"] = this.memberId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["contactPersonId"] = this.contactPersonId;
        data["responsibleMember"] = this.responsibleMember ? this.responsibleMember.toJSON() : undefined as any;
        data["departmentId"] = this.departmentId;
        data["isDeleted"] = this.isDeleted;
        data["type"] = this.type;
        data["status"] = this.status;
        data["sortOrder"] = this.sortOrder;
        data["priority"] = this.priority;
        data["estimatedHours"] = this.estimatedHours;
        data["registeredHours"] = this.registeredHours;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : undefined as any;
        data["gitHubIssue"] = this.gitHubIssue;
        data["entityId"] = this.entityId;
        data["organizationId"] = this.organizationId;
        data["taskState"] = this.taskState;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CtrTaskModel {
        const json = this.toJSON();
        let result = new CtrTaskModel();
        result.init(json);
        return result;
    }
}

export interface ICtrTaskModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    memberId?: number;
    customer?: CtrCustomerModel | undefined;
    contactPersonId?: string | undefined;
    responsibleMember?: CtrUserModel | undefined;
    departmentId?: string | undefined;
    isDeleted?: boolean;
    type?: CtrTaskType;
    status?: CtrTaskStatus;
    sortOrder?: number;
    priority?: number;
    estimatedHours?: number;
    registeredHours?: number;
    deadline?: Date | undefined;
    gitHubIssue?: string | undefined;
    entityId?: string;
    organizationId?: string;
    taskState?: CtrTaskState;
    tags?: CtrTagModel[] | undefined;
}

export class CtrUserModel implements ICtrUserModel {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    userNumber?: number;
    isAdmin?: boolean;
    relatelId?: number;

    constructor(data?: ICtrUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.userNumber = _data["userNumber"];
            this.isAdmin = _data["isAdmin"];
            this.relatelId = _data["relatelId"];
        }
    }

    static fromJS(data: any): CtrUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new CtrUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["userNumber"] = this.userNumber;
        data["isAdmin"] = this.isAdmin;
        data["relatelId"] = this.relatelId;
        return data;
    }

    clone(): CtrUserModel {
        const json = this.toJSON();
        let result = new CtrUserModel();
        result.init(json);
        return result;
    }
}

export interface ICtrUserModel {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    userNumber?: number;
    isAdmin?: boolean;
    relatelId?: number;
}

export enum CtrTaskType {
    Legacy = 0,
    Task = 1,
    Support = 2,
    ComidaQSSupport = 3,
    NonConformance = 4,
    Maintenance = 5,
    QSDevelopment = 6,
    SoftwareDevelopment = 7,
    TimeRegistration = 8,
}

export enum CtrTaskStatus {
    Draft = 0,
    Offer = 1,
    OnGoing = 2,
    Done = 3,
    Review = 4,
    Scheduled = 5,
    Paused = 6,
}

export enum CtrTaskState {
    Active = 0,
    Archived = 1,
}

export class CtrTagModel implements ICtrTagModel {
    id?: string;
    name?: string | undefined;
    githubId?: number | undefined;
    githubColor?: string | undefined;
    isDeleted?: boolean;
    created?: Date;
    organizationId?: string;
    userId?: string | undefined;
    entityId?: string | undefined;

    constructor(data?: ICtrTagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.githubId = _data["githubId"];
            this.githubColor = _data["githubColor"];
            this.isDeleted = _data["isDeleted"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): CtrTagModel {
        data = typeof data === 'object' ? data : {};
        let result = new CtrTagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["githubId"] = this.githubId;
        data["githubColor"] = this.githubColor;
        data["isDeleted"] = this.isDeleted;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["entityId"] = this.entityId;
        return data;
    }

    clone(): CtrTagModel {
        const json = this.toJSON();
        let result = new CtrTagModel();
        result.init(json);
        return result;
    }
}

export interface ICtrTagModel {
    id?: string;
    name?: string | undefined;
    githubId?: number | undefined;
    githubColor?: string | undefined;
    isDeleted?: boolean;
    created?: Date;
    organizationId?: string;
    userId?: string | undefined;
    entityId?: string | undefined;
}

export class NonConformanceTypeModel implements INonConformanceTypeModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    isDeleted?: boolean;

    constructor(data?: INonConformanceTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): NonConformanceTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new NonConformanceTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): NonConformanceTypeModel {
        const json = this.toJSON();
        let result = new NonConformanceTypeModel();
        result.init(json);
        return result;
    }
}

export interface INonConformanceTypeModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    isDeleted?: boolean;
}

export class CollectionModel implements ICollectionModel {
    id?: string;
    value?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    typeId?: string;
    parentCollectionId?: string | undefined;
    entityId?: string;
    blobEntityId?: string | undefined;
    revision?: DocumentRevisionModel | undefined;
    languageValue?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    url?: string | undefined;
    children?: CollectionModel[] | undefined;

    constructor(data?: ICollectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.typeId = _data["typeId"];
            this.parentCollectionId = _data["parentCollectionId"];
            this.entityId = _data["entityId"];
            this.blobEntityId = _data["blobEntityId"];
            this.revision = _data["revision"] ? DocumentRevisionModel.fromJS(_data["revision"]) : undefined as any;
            this.languageValue = _data["languageValue"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.url = _data["url"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(CollectionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CollectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["typeId"] = this.typeId;
        data["parentCollectionId"] = this.parentCollectionId;
        data["entityId"] = this.entityId;
        data["blobEntityId"] = this.blobEntityId;
        data["revision"] = this.revision ? this.revision.toJSON() : undefined as any;
        data["languageValue"] = this.languageValue;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["url"] = this.url;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CollectionModel {
        const json = this.toJSON();
        let result = new CollectionModel();
        result.init(json);
        return result;
    }
}

export interface ICollectionModel {
    id?: string;
    value?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    typeId?: string;
    parentCollectionId?: string | undefined;
    entityId?: string;
    blobEntityId?: string | undefined;
    revision?: DocumentRevisionModel | undefined;
    languageValue?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    url?: string | undefined;
    children?: CollectionModel[] | undefined;
}

export class DocumentRevisionModel implements IDocumentRevisionModel {
    id?: string;
    userId?: string;
    userName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    major?: number;
    minor?: number;
    patch?: number;
    versionString?: string | undefined;
    date?: Date;
    entityId?: string;
    documentId?: string | undefined;
    responsibleUserId?: string;
    responsibleUserName?: string | undefined;
    status?: DocumentRevisionStatus;
    document?: DocumentModel | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IDocumentRevisionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.major = _data["major"];
            this.minor = _data["minor"];
            this.patch = _data["patch"];
            this.versionString = _data["versionString"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.entityId = _data["entityId"];
            this.documentId = _data["documentId"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.responsibleUserName = _data["responsibleUserName"];
            this.status = _data["status"];
            this.document = _data["document"] ? DocumentModel.fromJS(_data["document"]) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): DocumentRevisionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentRevisionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["major"] = this.major;
        data["minor"] = this.minor;
        data["patch"] = this.patch;
        data["versionString"] = this.versionString;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["entityId"] = this.entityId;
        data["documentId"] = this.documentId;
        data["responsibleUserId"] = this.responsibleUserId;
        data["responsibleUserName"] = this.responsibleUserName;
        data["status"] = this.status;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): DocumentRevisionModel {
        const json = this.toJSON();
        let result = new DocumentRevisionModel();
        result.init(json);
        return result;
    }
}

export interface IDocumentRevisionModel {
    id?: string;
    userId?: string;
    userName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    major?: number;
    minor?: number;
    patch?: number;
    versionString?: string | undefined;
    date?: Date;
    entityId?: string;
    documentId?: string | undefined;
    responsibleUserId?: string;
    responsibleUserName?: string | undefined;
    status?: DocumentRevisionStatus;
    document?: DocumentModel | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum DocumentRevisionStatus {
    Created = 0,
    Draft = 1,
    ReadyForReview = 2,
    InReview = 3,
    Rejected = 4,
    Approved = 5,
    Obsolete = 6,
}

export class DocumentModel implements IDocumentModel {
    id?: string;
    userId?: string;
    name?: string | undefined;
    description?: string | undefined;
    documentNumber?: string | undefined;
    type?: string;
    responsibleUserId?: string;
    documentRevisions?: DocumentRevisionModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.documentNumber = _data["documentNumber"];
            this.type = _data["type"];
            this.responsibleUserId = _data["responsibleUserId"];
            if (Array.isArray(_data["documentRevisions"])) {
                this.documentRevisions = [] as any;
                for (let item of _data["documentRevisions"])
                    this.documentRevisions!.push(DocumentRevisionModel.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): DocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["documentNumber"] = this.documentNumber;
        data["type"] = this.type;
        data["responsibleUserId"] = this.responsibleUserId;
        if (Array.isArray(this.documentRevisions)) {
            data["documentRevisions"] = [];
            for (let item of this.documentRevisions)
                data["documentRevisions"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): DocumentModel {
        const json = this.toJSON();
        let result = new DocumentModel();
        result.init(json);
        return result;
    }
}

export interface IDocumentModel {
    id?: string;
    userId?: string;
    name?: string | undefined;
    description?: string | undefined;
    documentNumber?: string | undefined;
    type?: string;
    responsibleUserId?: string;
    documentRevisions?: DocumentRevisionModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ConfigurationItemModelOfString implements IConfigurationItemModelOfString {
    id?: string;
    name?: string | undefined;
    alias?: string | undefined;
    type?: ConfigurationItemType;
    value?: string | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IConfigurationItemModelOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.alias = _data["alias"];
            this.type = _data["type"];
            this.value = _data["value"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ConfigurationItemModelOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationItemModelOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["alias"] = this.alias;
        data["type"] = this.type;
        data["value"] = this.value;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ConfigurationItemModelOfString {
        const json = this.toJSON();
        let result = new ConfigurationItemModelOfString();
        result.init(json);
        return result;
    }
}

export interface IConfigurationItemModelOfString {
    id?: string;
    name?: string | undefined;
    alias?: string | undefined;
    type?: ConfigurationItemType;
    value?: string | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum ConfigurationItemType {
    None = 0,
    HaccpDocuments = 1,
}

export class ContactPersonModel implements IContactPersonModel {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    title?: string | undefined;
    type?: number;
    externalId?: string | undefined;
    customerId?: string;
    supplierId?: string;
    organizationId?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IContactPersonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.externalId = _data["externalId"];
            this.customerId = _data["customerId"];
            this.supplierId = _data["supplierId"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ContactPersonModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactPersonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["title"] = this.title;
        data["type"] = this.type;
        data["externalId"] = this.externalId;
        data["customerId"] = this.customerId;
        data["supplierId"] = this.supplierId;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ContactPersonModel {
        const json = this.toJSON();
        let result = new ContactPersonModel();
        result.init(json);
        return result;
    }
}

export interface IContactPersonModel {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    title?: string | undefined;
    type?: number;
    externalId?: string | undefined;
    customerId?: string;
    supplierId?: string;
    organizationId?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ContractItemModel implements IContractItemModel {
    id?: string;
    name?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    quantity?: number | undefined;
    salesPrice?: number | undefined;
    costPrice?: number | undefined;
    rate?: number | undefined;
    rateType?: RateType | undefined;
    type?: ContractItemType;
    comments?: string | undefined;
    duration?: string | undefined;
    period?: number | undefined;
    contractId?: string | undefined;
    userId?: string | undefined;
    templateId?: string | undefined;
    organizationId?: string | undefined;

    constructor(data?: IContractItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.quantity = _data["quantity"];
            this.salesPrice = _data["salesPrice"];
            this.costPrice = _data["costPrice"];
            this.rate = _data["rate"];
            this.rateType = _data["rateType"];
            this.type = _data["type"];
            this.comments = _data["comments"];
            this.duration = _data["duration"];
            this.period = _data["period"];
            this.contractId = _data["contractId"];
            this.userId = _data["userId"];
            this.templateId = _data["templateId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): ContractItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["quantity"] = this.quantity;
        data["salesPrice"] = this.salesPrice;
        data["costPrice"] = this.costPrice;
        data["rate"] = this.rate;
        data["rateType"] = this.rateType;
        data["type"] = this.type;
        data["comments"] = this.comments;
        data["duration"] = this.duration;
        data["period"] = this.period;
        data["contractId"] = this.contractId;
        data["userId"] = this.userId;
        data["templateId"] = this.templateId;
        data["organizationId"] = this.organizationId;
        return data;
    }

    clone(): ContractItemModel {
        const json = this.toJSON();
        let result = new ContractItemModel();
        result.init(json);
        return result;
    }
}

export interface IContractItemModel {
    id?: string;
    name?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    quantity?: number | undefined;
    salesPrice?: number | undefined;
    costPrice?: number | undefined;
    rate?: number | undefined;
    rateType?: RateType | undefined;
    type?: ContractItemType;
    comments?: string | undefined;
    duration?: string | undefined;
    period?: number | undefined;
    contractId?: string | undefined;
    userId?: string | undefined;
    templateId?: string | undefined;
    organizationId?: string | undefined;
}

export enum RateType {
    Hourly = 0,
    Fixed = 1,
    Monthly = 2,
    Quarterly = 3,
    Yearly = 4,
}

export enum ContractItemType {
    Audit = 0,
    Analysis = 1,
    ComidaQS = 2,
    TemperatureLogging = 3,
    HACCPCourse = 4,
    Other = 99,
}

export class ContractModel implements IContractModel {
    id?: string | undefined;
    name?: string | undefined;
    isDeleted?: boolean;
    created?: Date | undefined;
    updated?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: ContractStatus;
    type?: ContractType;
    organizationId?: string | undefined;
    contractItems?: ContractItemModel[] | undefined;

    constructor(data?: IContractModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.type = _data["type"];
            this.organizationId = _data["organizationId"];
            if (Array.isArray(_data["contractItems"])) {
                this.contractItems = [] as any;
                for (let item of _data["contractItems"])
                    this.contractItems!.push(ContractItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["type"] = this.type;
        data["organizationId"] = this.organizationId;
        if (Array.isArray(this.contractItems)) {
            data["contractItems"] = [];
            for (let item of this.contractItems)
                data["contractItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ContractModel {
        const json = this.toJSON();
        let result = new ContractModel();
        result.init(json);
        return result;
    }
}

export interface IContractModel {
    id?: string | undefined;
    name?: string | undefined;
    isDeleted?: boolean;
    created?: Date | undefined;
    updated?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: ContractStatus;
    type?: ContractType;
    organizationId?: string | undefined;
    contractItems?: ContractItemModel[] | undefined;
}

export enum ContractStatus {
    Draft = 0,
    Sent = 1,
    Approved = 2,
    Rejected = 3,
    Expired = 4,
    Terminated = 5,
}

export enum ContractType {
    FoodSafetySubscription = 0,
    FixedPrice = 1,
}

export class ControlMeasureModel implements IControlMeasureModel {
    id?: string;
    type?: ControlMeasureType;
    controlMeasureNo?: string | undefined;
    name?: string | undefined;
    risk?: string | undefined;
    criticalLimit?: string | undefined;
    monitoring?: string | undefined;
    responsibilityDocumentation?: string | undefined;
    frequency?: string | undefined;
    verification?: string | undefined;
    controllingAction?: string | undefined;
    correctiveAction?: string | undefined;
    departmentId?: string | undefined;
    responsibleUserId?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    language?: string | undefined;
    source?: string | undefined;
    externalSourceId?: string | undefined;
    externalData?: string | undefined;
    organizationId?: string;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    languages?: ControlMeasureLanguageModel[] | undefined;
    riskFactorRelations?: ControlMeasureRelationModel[] | undefined;

    constructor(data?: IControlMeasureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.controlMeasureNo = _data["controlMeasureNo"];
            this.name = _data["name"];
            this.risk = _data["risk"];
            this.criticalLimit = _data["criticalLimit"];
            this.monitoring = _data["monitoring"];
            this.responsibilityDocumentation = _data["responsibilityDocumentation"];
            this.frequency = _data["frequency"];
            this.verification = _data["verification"];
            this.controllingAction = _data["controllingAction"];
            this.correctiveAction = _data["correctiveAction"];
            this.departmentId = _data["departmentId"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.responsibleUser = _data["responsibleUser"] ? IdNameModel.fromJS(_data["responsibleUser"]) : undefined as any;
            this.language = _data["language"];
            this.source = _data["source"];
            this.externalSourceId = _data["externalSourceId"];
            this.externalData = _data["externalData"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(ControlMeasureLanguageModel.fromJS(item));
            }
            if (Array.isArray(_data["riskFactorRelations"])) {
                this.riskFactorRelations = [] as any;
                for (let item of _data["riskFactorRelations"])
                    this.riskFactorRelations!.push(ControlMeasureRelationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ControlMeasureModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControlMeasureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["controlMeasureNo"] = this.controlMeasureNo;
        data["name"] = this.name;
        data["risk"] = this.risk;
        data["criticalLimit"] = this.criticalLimit;
        data["monitoring"] = this.monitoring;
        data["responsibilityDocumentation"] = this.responsibilityDocumentation;
        data["frequency"] = this.frequency;
        data["verification"] = this.verification;
        data["controllingAction"] = this.controllingAction;
        data["correctiveAction"] = this.correctiveAction;
        data["departmentId"] = this.departmentId;
        data["responsibleUserId"] = this.responsibleUserId;
        data["responsibleUser"] = this.responsibleUser ? this.responsibleUser.toJSON() : undefined as any;
        data["language"] = this.language;
        data["source"] = this.source;
        data["externalSourceId"] = this.externalSourceId;
        data["externalData"] = this.externalData;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.riskFactorRelations)) {
            data["riskFactorRelations"] = [];
            for (let item of this.riskFactorRelations)
                data["riskFactorRelations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ControlMeasureModel {
        const json = this.toJSON();
        let result = new ControlMeasureModel();
        result.init(json);
        return result;
    }
}

export interface IControlMeasureModel {
    id?: string;
    type?: ControlMeasureType;
    controlMeasureNo?: string | undefined;
    name?: string | undefined;
    risk?: string | undefined;
    criticalLimit?: string | undefined;
    monitoring?: string | undefined;
    responsibilityDocumentation?: string | undefined;
    frequency?: string | undefined;
    verification?: string | undefined;
    controllingAction?: string | undefined;
    correctiveAction?: string | undefined;
    departmentId?: string | undefined;
    responsibleUserId?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    language?: string | undefined;
    source?: string | undefined;
    externalSourceId?: string | undefined;
    externalData?: string | undefined;
    organizationId?: string;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    languages?: ControlMeasureLanguageModel[] | undefined;
    riskFactorRelations?: ControlMeasureRelationModel[] | undefined;
}

export enum ControlMeasureType {
    CCP = 1,
    OPRP = 2,
    PRP = 3,
}

export class ControlMeasureLanguageModel implements IControlMeasureLanguageModel {
    id?: string;
    controlMeasureId?: string;
    controlMeasureNo?: string | undefined;
    name?: string | undefined;
    risk?: string | undefined;
    criticalLimit?: string | undefined;
    monitoring?: string | undefined;
    responsibilityDocumentation?: string | undefined;
    frequency?: string | undefined;
    verification?: string | undefined;
    controllingAction?: string | undefined;
    correctiveAction?: string | undefined;
    departmentId?: string | undefined;
    responsibleUserId?: string | undefined;
    language?: string | undefined;
    source?: string | undefined;
    externalSourceId?: string | undefined;
    externalData?: string | undefined;
    organizationId?: string;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IControlMeasureLanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.controlMeasureId = _data["controlMeasureId"];
            this.controlMeasureNo = _data["controlMeasureNo"];
            this.name = _data["name"];
            this.risk = _data["risk"];
            this.criticalLimit = _data["criticalLimit"];
            this.monitoring = _data["monitoring"];
            this.responsibilityDocumentation = _data["responsibilityDocumentation"];
            this.frequency = _data["frequency"];
            this.verification = _data["verification"];
            this.controllingAction = _data["controllingAction"];
            this.correctiveAction = _data["correctiveAction"];
            this.departmentId = _data["departmentId"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.language = _data["language"];
            this.source = _data["source"];
            this.externalSourceId = _data["externalSourceId"];
            this.externalData = _data["externalData"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ControlMeasureLanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControlMeasureLanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["controlMeasureId"] = this.controlMeasureId;
        data["controlMeasureNo"] = this.controlMeasureNo;
        data["name"] = this.name;
        data["risk"] = this.risk;
        data["criticalLimit"] = this.criticalLimit;
        data["monitoring"] = this.monitoring;
        data["responsibilityDocumentation"] = this.responsibilityDocumentation;
        data["frequency"] = this.frequency;
        data["verification"] = this.verification;
        data["controllingAction"] = this.controllingAction;
        data["correctiveAction"] = this.correctiveAction;
        data["departmentId"] = this.departmentId;
        data["responsibleUserId"] = this.responsibleUserId;
        data["language"] = this.language;
        data["source"] = this.source;
        data["externalSourceId"] = this.externalSourceId;
        data["externalData"] = this.externalData;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ControlMeasureLanguageModel {
        const json = this.toJSON();
        let result = new ControlMeasureLanguageModel();
        result.init(json);
        return result;
    }
}

export interface IControlMeasureLanguageModel {
    id?: string;
    controlMeasureId?: string;
    controlMeasureNo?: string | undefined;
    name?: string | undefined;
    risk?: string | undefined;
    criticalLimit?: string | undefined;
    monitoring?: string | undefined;
    responsibilityDocumentation?: string | undefined;
    frequency?: string | undefined;
    verification?: string | undefined;
    controllingAction?: string | undefined;
    correctiveAction?: string | undefined;
    departmentId?: string | undefined;
    responsibleUserId?: string | undefined;
    language?: string | undefined;
    source?: string | undefined;
    externalSourceId?: string | undefined;
    externalData?: string | undefined;
    organizationId?: string;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ControlMeasureRelationModel implements IControlMeasureRelationModel {
    id?: string;
    controlMeasureId?: string;
    riskAnalysisId?: string | undefined;
    riskFactorId?: string | undefined;
    sortOrder?: number;
    controlMeasureNo?: string | undefined;
    controlMeasureName?: string | undefined;
    controlMeasureType?: string | undefined;
    riskFactorName?: string | undefined;
    riskFactorType?: RiskFactorType | undefined;
    riskFactorTypeName?: string | undefined;
    processStepId?: string | undefined;
    processStepName?: string | undefined;
    isCCP?: boolean | undefined;
    isOPRP?: boolean | undefined;
    organizationId?: string;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IControlMeasureRelationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.controlMeasureId = _data["controlMeasureId"];
            this.riskAnalysisId = _data["riskAnalysisId"];
            this.riskFactorId = _data["riskFactorId"];
            this.sortOrder = _data["sortOrder"];
            this.controlMeasureNo = _data["controlMeasureNo"];
            this.controlMeasureName = _data["controlMeasureName"];
            this.controlMeasureType = _data["controlMeasureType"];
            this.riskFactorName = _data["riskFactorName"];
            this.riskFactorType = _data["riskFactorType"];
            this.riskFactorTypeName = _data["riskFactorTypeName"];
            this.processStepId = _data["processStepId"];
            this.processStepName = _data["processStepName"];
            this.isCCP = _data["isCCP"];
            this.isOPRP = _data["isOPRP"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ControlMeasureRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControlMeasureRelationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["controlMeasureId"] = this.controlMeasureId;
        data["riskAnalysisId"] = this.riskAnalysisId;
        data["riskFactorId"] = this.riskFactorId;
        data["sortOrder"] = this.sortOrder;
        data["controlMeasureNo"] = this.controlMeasureNo;
        data["controlMeasureName"] = this.controlMeasureName;
        data["controlMeasureType"] = this.controlMeasureType;
        data["riskFactorName"] = this.riskFactorName;
        data["riskFactorType"] = this.riskFactorType;
        data["riskFactorTypeName"] = this.riskFactorTypeName;
        data["processStepId"] = this.processStepId;
        data["processStepName"] = this.processStepName;
        data["isCCP"] = this.isCCP;
        data["isOPRP"] = this.isOPRP;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ControlMeasureRelationModel {
        const json = this.toJSON();
        let result = new ControlMeasureRelationModel();
        result.init(json);
        return result;
    }
}

export interface IControlMeasureRelationModel {
    id?: string;
    controlMeasureId?: string;
    riskAnalysisId?: string | undefined;
    riskFactorId?: string | undefined;
    sortOrder?: number;
    controlMeasureNo?: string | undefined;
    controlMeasureName?: string | undefined;
    controlMeasureType?: string | undefined;
    riskFactorName?: string | undefined;
    riskFactorType?: RiskFactorType | undefined;
    riskFactorTypeName?: string | undefined;
    processStepId?: string | undefined;
    processStepName?: string | undefined;
    isCCP?: boolean | undefined;
    isOPRP?: boolean | undefined;
    organizationId?: string;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum RiskFactorType {
    Other = 0,
    Microbiological = 1,
    Chemical = 2,
    Physical = 3,
}

export class ControlPlanModel implements IControlPlanModel {
    id?: string;
    controlPlanNo?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    departmentId?: string | undefined;
    responsibleUserId?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    language?: string | undefined;
    type?: ControlMeasureType;
    organizationId?: string;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    languages?: ControlPlanLanguageModel[] | undefined;
    controlMeasurePlanRelations?: ControlMeasurePlanRelationModel[] | undefined;

    constructor(data?: IControlPlanModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.controlPlanNo = _data["controlPlanNo"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.departmentId = _data["departmentId"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.responsibleUser = _data["responsibleUser"] ? IdNameModel.fromJS(_data["responsibleUser"]) : undefined as any;
            this.language = _data["language"];
            this.type = _data["type"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(ControlPlanLanguageModel.fromJS(item));
            }
            if (Array.isArray(_data["controlMeasurePlanRelations"])) {
                this.controlMeasurePlanRelations = [] as any;
                for (let item of _data["controlMeasurePlanRelations"])
                    this.controlMeasurePlanRelations!.push(ControlMeasurePlanRelationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ControlPlanModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControlPlanModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["controlPlanNo"] = this.controlPlanNo;
        data["name"] = this.name;
        data["description"] = this.description;
        data["departmentId"] = this.departmentId;
        data["responsibleUserId"] = this.responsibleUserId;
        data["responsibleUser"] = this.responsibleUser ? this.responsibleUser.toJSON() : undefined as any;
        data["language"] = this.language;
        data["type"] = this.type;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.controlMeasurePlanRelations)) {
            data["controlMeasurePlanRelations"] = [];
            for (let item of this.controlMeasurePlanRelations)
                data["controlMeasurePlanRelations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ControlPlanModel {
        const json = this.toJSON();
        let result = new ControlPlanModel();
        result.init(json);
        return result;
    }
}

export interface IControlPlanModel {
    id?: string;
    controlPlanNo?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    departmentId?: string | undefined;
    responsibleUserId?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    language?: string | undefined;
    type?: ControlMeasureType;
    organizationId?: string;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    languages?: ControlPlanLanguageModel[] | undefined;
    controlMeasurePlanRelations?: ControlMeasurePlanRelationModel[] | undefined;
}

export class ControlPlanLanguageModel implements IControlPlanLanguageModel {
    id?: string;
    controlPlanId?: string;
    name?: string | undefined;
    description?: string | undefined;
    language?: string | undefined;
    organizationId?: string;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IControlPlanLanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.controlPlanId = _data["controlPlanId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.language = _data["language"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ControlPlanLanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControlPlanLanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["controlPlanId"] = this.controlPlanId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["language"] = this.language;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ControlPlanLanguageModel {
        const json = this.toJSON();
        let result = new ControlPlanLanguageModel();
        result.init(json);
        return result;
    }
}

export interface IControlPlanLanguageModel {
    id?: string;
    controlPlanId?: string;
    name?: string | undefined;
    description?: string | undefined;
    language?: string | undefined;
    organizationId?: string;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ControlMeasurePlanRelationModel implements IControlMeasurePlanRelationModel {
    id?: string;
    controlMeasureId?: string;
    controlPlanId?: string | undefined;
    sortOrder?: number;
    controlMeasureNo?: string | undefined;
    controlMeasureName?: string | undefined;
    controlMeasureType?: string | undefined;
    controlMeasure?: ControlMeasure | undefined;
    isCCP?: boolean | undefined;
    isOPRP?: boolean | undefined;
    organizationId?: string;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IControlMeasurePlanRelationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.controlMeasureId = _data["controlMeasureId"];
            this.controlPlanId = _data["controlPlanId"];
            this.sortOrder = _data["sortOrder"];
            this.controlMeasureNo = _data["controlMeasureNo"];
            this.controlMeasureName = _data["controlMeasureName"];
            this.controlMeasureType = _data["controlMeasureType"];
            this.controlMeasure = _data["controlMeasure"] ? ControlMeasure.fromJS(_data["controlMeasure"]) : undefined as any;
            this.isCCP = _data["isCCP"];
            this.isOPRP = _data["isOPRP"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ControlMeasurePlanRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControlMeasurePlanRelationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["controlMeasureId"] = this.controlMeasureId;
        data["controlPlanId"] = this.controlPlanId;
        data["sortOrder"] = this.sortOrder;
        data["controlMeasureNo"] = this.controlMeasureNo;
        data["controlMeasureName"] = this.controlMeasureName;
        data["controlMeasureType"] = this.controlMeasureType;
        data["controlMeasure"] = this.controlMeasure ? this.controlMeasure.toJSON() : undefined as any;
        data["isCCP"] = this.isCCP;
        data["isOPRP"] = this.isOPRP;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ControlMeasurePlanRelationModel {
        const json = this.toJSON();
        let result = new ControlMeasurePlanRelationModel();
        result.init(json);
        return result;
    }
}

export interface IControlMeasurePlanRelationModel {
    id?: string;
    controlMeasureId?: string;
    controlPlanId?: string | undefined;
    sortOrder?: number;
    controlMeasureNo?: string | undefined;
    controlMeasureName?: string | undefined;
    controlMeasureType?: string | undefined;
    controlMeasure?: ControlMeasure | undefined;
    isCCP?: boolean | undefined;
    isOPRP?: boolean | undefined;
    organizationId?: string;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ControlMeasure extends BaseEntity implements IControlMeasure {
    controlMeasureNo?: string | undefined;
    name?: string | undefined;
    risk?: string | undefined;
    criticalLimit?: string | undefined;
    monitoring?: string | undefined;
    responsibilityDocumentation?: string | undefined;
    frequency?: string | undefined;
    verification?: string | undefined;
    controllingAction?: string | undefined;
    correctiveAction?: string | undefined;
    type?: ControlMeasureType;
    departmentId?: string | undefined;
    responsibleUserId?: string | undefined;
    language?: string;
    source?: string | undefined;
    externalSourceId?: string | undefined;
    externalData?: string | undefined;

    constructor(data?: IControlMeasure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.controlMeasureNo = _data["controlMeasureNo"];
            this.name = _data["name"];
            this.risk = _data["risk"];
            this.criticalLimit = _data["criticalLimit"];
            this.monitoring = _data["monitoring"];
            this.responsibilityDocumentation = _data["responsibilityDocumentation"];
            this.frequency = _data["frequency"];
            this.verification = _data["verification"];
            this.controllingAction = _data["controllingAction"];
            this.correctiveAction = _data["correctiveAction"];
            this.type = _data["type"];
            this.departmentId = _data["departmentId"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.language = _data["language"];
            this.source = _data["source"];
            this.externalSourceId = _data["externalSourceId"];
            this.externalData = _data["externalData"];
        }
    }

    static override fromJS(data: any): ControlMeasure {
        data = typeof data === 'object' ? data : {};
        let result = new ControlMeasure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlMeasureNo"] = this.controlMeasureNo;
        data["name"] = this.name;
        data["risk"] = this.risk;
        data["criticalLimit"] = this.criticalLimit;
        data["monitoring"] = this.monitoring;
        data["responsibilityDocumentation"] = this.responsibilityDocumentation;
        data["frequency"] = this.frequency;
        data["verification"] = this.verification;
        data["controllingAction"] = this.controllingAction;
        data["correctiveAction"] = this.correctiveAction;
        data["type"] = this.type;
        data["departmentId"] = this.departmentId;
        data["responsibleUserId"] = this.responsibleUserId;
        data["language"] = this.language;
        data["source"] = this.source;
        data["externalSourceId"] = this.externalSourceId;
        data["externalData"] = this.externalData;
        super.toJSON(data);
        return data;
    }

    clone(): ControlMeasure {
        const json = this.toJSON();
        let result = new ControlMeasure();
        result.init(json);
        return result;
    }
}

export interface IControlMeasure extends IBaseEntity {
    controlMeasureNo?: string | undefined;
    name?: string | undefined;
    risk?: string | undefined;
    criticalLimit?: string | undefined;
    monitoring?: string | undefined;
    responsibilityDocumentation?: string | undefined;
    frequency?: string | undefined;
    verification?: string | undefined;
    controllingAction?: string | undefined;
    correctiveAction?: string | undefined;
    type?: ControlMeasureType;
    departmentId?: string | undefined;
    responsibleUserId?: string | undefined;
    language?: string;
    source?: string | undefined;
    externalSourceId?: string | undefined;
    externalData?: string | undefined;
}

export class CounterModel implements ICounterModel {
    counterName?: string | undefined;
    value?: number;
    id?: string;

    constructor(data?: ICounterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counterName = _data["counterName"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CounterModel {
        data = typeof data === 'object' ? data : {};
        let result = new CounterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counterName"] = this.counterName;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }

    clone(): CounterModel {
        const json = this.toJSON();
        let result = new CounterModel();
        result.init(json);
        return result;
    }
}

export interface ICounterModel {
    counterName?: string | undefined;
    value?: number;
    id?: string;
}

export class CustomerComplaintModel implements ICustomerComplaintModel {
    id?: string;
    correctiveAction?: string | undefined;
    preventiveAction?: string | undefined;
    date?: Date | undefined;
    description?: string | undefined;
    productsAffected?: string | undefined;
    rootCause?: string | undefined;
    customerInformation?: string | undefined;
    customerComplaintNumber?: string | undefined;
    responsibleUserId?: string | undefined;
    responsibleUserName?: string | undefined;
    typeId?: string | undefined;
    typeName?: string | undefined;
    status?: CustomerComplaintStatus;
    closedDate?: Date | undefined;
    closedByUserId?: string | undefined;
    openedByUserId?: string | undefined;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: ICustomerComplaintModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.correctiveAction = _data["correctiveAction"];
            this.preventiveAction = _data["preventiveAction"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.description = _data["description"];
            this.productsAffected = _data["productsAffected"];
            this.rootCause = _data["rootCause"];
            this.customerInformation = _data["customerInformation"];
            this.customerComplaintNumber = _data["customerComplaintNumber"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.responsibleUserName = _data["responsibleUserName"];
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
            this.status = _data["status"];
            this.closedDate = _data["closedDate"] ? new Date(_data["closedDate"].toString()) : undefined as any;
            this.closedByUserId = _data["closedByUserId"];
            this.openedByUserId = _data["openedByUserId"];
            this.userId = _data["userId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CustomerComplaintModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerComplaintModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["correctiveAction"] = this.correctiveAction;
        data["preventiveAction"] = this.preventiveAction;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["description"] = this.description;
        data["productsAffected"] = this.productsAffected;
        data["rootCause"] = this.rootCause;
        data["customerInformation"] = this.customerInformation;
        data["customerComplaintNumber"] = this.customerComplaintNumber;
        data["responsibleUserId"] = this.responsibleUserId;
        data["responsibleUserName"] = this.responsibleUserName;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["status"] = this.status;
        data["closedDate"] = this.closedDate ? this.closedDate.toISOString() : undefined as any;
        data["closedByUserId"] = this.closedByUserId;
        data["openedByUserId"] = this.openedByUserId;
        data["userId"] = this.userId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CustomerComplaintModel {
        const json = this.toJSON();
        let result = new CustomerComplaintModel();
        result.init(json);
        return result;
    }
}

export interface ICustomerComplaintModel {
    id?: string;
    correctiveAction?: string | undefined;
    preventiveAction?: string | undefined;
    date?: Date | undefined;
    description?: string | undefined;
    productsAffected?: string | undefined;
    rootCause?: string | undefined;
    customerInformation?: string | undefined;
    customerComplaintNumber?: string | undefined;
    responsibleUserId?: string | undefined;
    responsibleUserName?: string | undefined;
    typeId?: string | undefined;
    typeName?: string | undefined;
    status?: CustomerComplaintStatus;
    closedDate?: Date | undefined;
    closedByUserId?: string | undefined;
    openedByUserId?: string | undefined;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum CustomerComplaintStatus {
    Draft = 0,
    Closed = 1,
    Rejected = 2,
}

export class PagedResultOfCustomerComplaintModel extends PagedResultBase implements IPagedResultOfCustomerComplaintModel {
    results?: CustomerComplaintModel[];

    constructor(data?: IPagedResultOfCustomerComplaintModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CustomerComplaintModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfCustomerComplaintModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfCustomerComplaintModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfCustomerComplaintModel {
        const json = this.toJSON();
        let result = new PagedResultOfCustomerComplaintModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfCustomerComplaintModel extends IPagedResultBase {
    results?: CustomerComplaintModel[];
}

export class CustomerComplaintTypeModel implements ICustomerComplaintTypeModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    isDeleted?: boolean;

    constructor(data?: ICustomerComplaintTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CustomerComplaintTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerComplaintTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CustomerComplaintTypeModel {
        const json = this.toJSON();
        let result = new CustomerComplaintTypeModel();
        result.init(json);
        return result;
    }
}

export interface ICustomerComplaintTypeModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    isDeleted?: boolean;
}

export class CustomerModel implements ICustomerModel {
    id?: string;
    organizationId?: string;
    customerNumber?: string | undefined;
    name?: string | undefined;
    registrationNumber?: string | undefined;
    customerGroupId?: string | undefined;
    priceGroupId?: string | undefined;
    address?: AddressModel | undefined;
    internalNote?: string | undefined;
    publicNote?: string | undefined;
    productionNote?: string | undefined;
    currency?: string | undefined;
    balance?: number;
    dueAmount?: number;
    creditLimit?: number;
    rating?: number;
    financeDepartment?: number;
    isBarred?: boolean;
    language?: string | undefined;
    followUpDate?: Date | undefined;
    gln?: string | undefined;
    inShop?: boolean;
    invoiceFrequency?: number;
    invoiceChannel?: InvoiceChannelType;
    standardDeliveryAddressId?: string | undefined;
    standardContactPersonId?: string | undefined;
    orderConfirmationMail?: string | undefined;
    orderDeliveryMail?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    vatZone?: string | undefined;
    externalId?: string | undefined;
    defaultCarrierId?: string | undefined;
    defaultCarrierName?: string | undefined;
    transportCost?: number;
    orderChannel?: OrderChannelType;

    constructor(data?: ICustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.customerNumber = _data["customerNumber"];
            this.name = _data["name"];
            this.registrationNumber = _data["registrationNumber"];
            this.customerGroupId = _data["customerGroupId"];
            this.priceGroupId = _data["priceGroupId"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : undefined as any;
            this.internalNote = _data["internalNote"];
            this.publicNote = _data["publicNote"];
            this.productionNote = _data["productionNote"];
            this.currency = _data["currency"];
            this.balance = _data["balance"];
            this.dueAmount = _data["dueAmount"];
            this.creditLimit = _data["creditLimit"];
            this.rating = _data["rating"];
            this.financeDepartment = _data["financeDepartment"];
            this.isBarred = _data["isBarred"];
            this.language = _data["language"];
            this.followUpDate = _data["followUpDate"] ? new Date(_data["followUpDate"].toString()) : undefined as any;
            this.gln = _data["gln"];
            this.inShop = _data["inShop"];
            this.invoiceFrequency = _data["invoiceFrequency"];
            this.invoiceChannel = _data["invoiceChannel"];
            this.standardDeliveryAddressId = _data["standardDeliveryAddressId"];
            this.standardContactPersonId = _data["standardContactPersonId"];
            this.orderConfirmationMail = _data["orderConfirmationMail"];
            this.orderDeliveryMail = _data["orderDeliveryMail"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.vatZone = _data["vatZone"];
            this.externalId = _data["externalId"];
            this.defaultCarrierId = _data["defaultCarrierId"];
            this.defaultCarrierName = _data["defaultCarrierName"];
            this.transportCost = _data["transportCost"];
            this.orderChannel = _data["orderChannel"];
        }
    }

    static fromJS(data: any): CustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["customerNumber"] = this.customerNumber;
        data["name"] = this.name;
        data["registrationNumber"] = this.registrationNumber;
        data["customerGroupId"] = this.customerGroupId;
        data["priceGroupId"] = this.priceGroupId;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["internalNote"] = this.internalNote;
        data["publicNote"] = this.publicNote;
        data["productionNote"] = this.productionNote;
        data["currency"] = this.currency;
        data["balance"] = this.balance;
        data["dueAmount"] = this.dueAmount;
        data["creditLimit"] = this.creditLimit;
        data["rating"] = this.rating;
        data["financeDepartment"] = this.financeDepartment;
        data["isBarred"] = this.isBarred;
        data["language"] = this.language;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.toISOString() : undefined as any;
        data["gln"] = this.gln;
        data["inShop"] = this.inShop;
        data["invoiceFrequency"] = this.invoiceFrequency;
        data["invoiceChannel"] = this.invoiceChannel;
        data["standardDeliveryAddressId"] = this.standardDeliveryAddressId;
        data["standardContactPersonId"] = this.standardContactPersonId;
        data["orderConfirmationMail"] = this.orderConfirmationMail;
        data["orderDeliveryMail"] = this.orderDeliveryMail;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["vatZone"] = this.vatZone;
        data["externalId"] = this.externalId;
        data["defaultCarrierId"] = this.defaultCarrierId;
        data["defaultCarrierName"] = this.defaultCarrierName;
        data["transportCost"] = this.transportCost;
        data["orderChannel"] = this.orderChannel;
        return data;
    }

    clone(): CustomerModel {
        const json = this.toJSON();
        let result = new CustomerModel();
        result.init(json);
        return result;
    }
}

export interface ICustomerModel {
    id?: string;
    organizationId?: string;
    customerNumber?: string | undefined;
    name?: string | undefined;
    registrationNumber?: string | undefined;
    customerGroupId?: string | undefined;
    priceGroupId?: string | undefined;
    address?: AddressModel | undefined;
    internalNote?: string | undefined;
    publicNote?: string | undefined;
    productionNote?: string | undefined;
    currency?: string | undefined;
    balance?: number;
    dueAmount?: number;
    creditLimit?: number;
    rating?: number;
    financeDepartment?: number;
    isBarred?: boolean;
    language?: string | undefined;
    followUpDate?: Date | undefined;
    gln?: string | undefined;
    inShop?: boolean;
    invoiceFrequency?: number;
    invoiceChannel?: InvoiceChannelType;
    standardDeliveryAddressId?: string | undefined;
    standardContactPersonId?: string | undefined;
    orderConfirmationMail?: string | undefined;
    orderDeliveryMail?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    vatZone?: string | undefined;
    externalId?: string | undefined;
    defaultCarrierId?: string | undefined;
    defaultCarrierName?: string | undefined;
    transportCost?: number;
    orderChannel?: OrderChannelType;
}

export enum InvoiceChannelType {
    Manual = 0,
    Batch = 1,
    EDI = 2,
    PrePaid = 3,
    CG_CSV = 4,
    CG_DATASTRING = 5,
    CG_VOUCHER = 6,
}

export enum OrderChannelType {
    Manual = 0,
    Email = 1,
    EDI = 2,
    CompassWS = 3,
}

export class SupplierModel implements ISupplierModel {
    id?: string;
    organizationId?: string;
    supplierNumber?: string | undefined;
    name?: string | undefined;
    registrationNumber?: string | undefined;
    authorizationNumber?: string | undefined;
    address?: AddressModel | undefined;
    supplierGroupId?: string | undefined;
    internalNote?: string | undefined;
    publicNote?: string | undefined;
    gln?: string | undefined;
    followUpDate?: Date | undefined;
    ourCustomerNumber?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    orderDeadline?: string | undefined;
    orderChannel?: OrderChannelType;
    orderLeadtime?: number;

    constructor(data?: ISupplierModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.supplierNumber = _data["supplierNumber"];
            this.name = _data["name"];
            this.registrationNumber = _data["registrationNumber"];
            this.authorizationNumber = _data["authorizationNumber"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : undefined as any;
            this.supplierGroupId = _data["supplierGroupId"];
            this.internalNote = _data["internalNote"];
            this.publicNote = _data["publicNote"];
            this.gln = _data["gln"];
            this.followUpDate = _data["followUpDate"] ? new Date(_data["followUpDate"].toString()) : undefined as any;
            this.ourCustomerNumber = _data["ourCustomerNumber"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.orderDeadline = _data["orderDeadline"];
            this.orderChannel = _data["orderChannel"];
            this.orderLeadtime = _data["orderLeadtime"];
        }
    }

    static fromJS(data: any): SupplierModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["supplierNumber"] = this.supplierNumber;
        data["name"] = this.name;
        data["registrationNumber"] = this.registrationNumber;
        data["authorizationNumber"] = this.authorizationNumber;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["supplierGroupId"] = this.supplierGroupId;
        data["internalNote"] = this.internalNote;
        data["publicNote"] = this.publicNote;
        data["gln"] = this.gln;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.toISOString() : undefined as any;
        data["ourCustomerNumber"] = this.ourCustomerNumber;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["orderDeadline"] = this.orderDeadline;
        data["orderChannel"] = this.orderChannel;
        data["orderLeadtime"] = this.orderLeadtime;
        return data;
    }

    clone(): SupplierModel {
        const json = this.toJSON();
        let result = new SupplierModel();
        result.init(json);
        return result;
    }
}

export interface ISupplierModel {
    id?: string;
    organizationId?: string;
    supplierNumber?: string | undefined;
    name?: string | undefined;
    registrationNumber?: string | undefined;
    authorizationNumber?: string | undefined;
    address?: AddressModel | undefined;
    supplierGroupId?: string | undefined;
    internalNote?: string | undefined;
    publicNote?: string | undefined;
    gln?: string | undefined;
    followUpDate?: Date | undefined;
    ourCustomerNumber?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    orderDeadline?: string | undefined;
    orderChannel?: OrderChannelType;
    orderLeadtime?: number;
}

export class PagedResultOfCustomerModel extends PagedResultBase implements IPagedResultOfCustomerModel {
    results?: CustomerModel[];

    constructor(data?: IPagedResultOfCustomerModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CustomerModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfCustomerModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfCustomerModel {
        const json = this.toJSON();
        let result = new PagedResultOfCustomerModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfCustomerModel extends IPagedResultBase {
    results?: CustomerModel[];
}

export class CustomerBulkChangeModel implements ICustomerBulkChangeModel {
    customers?: CustomerModel[] | undefined;
    language?: string | undefined;
    customerGroupId?: string;

    constructor(data?: ICustomerBulkChangeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(CustomerModel.fromJS(item));
            }
            this.language = _data["language"];
            this.customerGroupId = _data["customerGroupId"];
        }
    }

    static fromJS(data: any): CustomerBulkChangeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerBulkChangeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item ? item.toJSON() : undefined as any);
        }
        data["language"] = this.language;
        data["customerGroupId"] = this.customerGroupId;
        return data;
    }

    clone(): CustomerBulkChangeModel {
        const json = this.toJSON();
        let result = new CustomerBulkChangeModel();
        result.init(json);
        return result;
    }
}

export interface ICustomerBulkChangeModel {
    customers?: CustomerModel[] | undefined;
    language?: string | undefined;
    customerGroupId?: string;
}

export class CustomerGroupModel implements ICustomerGroupModel {
    id?: string;
    name?: string | undefined;
    groupNumber?: string | undefined;
    groupType?: number;
    noSynchronization?: boolean;
    customers?: string[] | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: ICustomerGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.groupNumber = _data["groupNumber"];
            this.groupType = _data["groupType"];
            this.noSynchronization = _data["noSynchronization"];
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(item);
            }
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CustomerGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["groupNumber"] = this.groupNumber;
        data["groupType"] = this.groupType;
        data["noSynchronization"] = this.noSynchronization;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item);
        }
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CustomerGroupModel {
        const json = this.toJSON();
        let result = new CustomerGroupModel();
        result.init(json);
        return result;
    }
}

export interface ICustomerGroupModel {
    id?: string;
    name?: string | undefined;
    groupNumber?: string | undefined;
    groupType?: number;
    noSynchronization?: boolean;
    customers?: string[] | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class DashboardWidgetModel implements IDashboardWidgetModel {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    entityId?: string;
    dashboardId?: string;
    sortOrder?: number;
    configuration?: string | undefined;
    layoutOptions?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IDashboardWidgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.entityId = _data["entityId"];
            this.dashboardId = _data["dashboardId"];
            this.sortOrder = _data["sortOrder"];
            this.configuration = _data["configuration"];
            this.layoutOptions = _data["layoutOptions"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): DashboardWidgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardWidgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["entityId"] = this.entityId;
        data["dashboardId"] = this.dashboardId;
        data["sortOrder"] = this.sortOrder;
        data["configuration"] = this.configuration;
        data["layoutOptions"] = this.layoutOptions;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): DashboardWidgetModel {
        const json = this.toJSON();
        let result = new DashboardWidgetModel();
        result.init(json);
        return result;
    }
}

export interface IDashboardWidgetModel {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    entityId?: string;
    dashboardId?: string;
    sortOrder?: number;
    configuration?: string | undefined;
    layoutOptions?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class DepartmentModel implements IDepartmentModel {
    id?: string | undefined;
    userId?: string;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    organizationId?: string | undefined;
    externalSourceId?: string | undefined;
    addressId?: string | undefined;
    responsibleUserId?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    pNr?: string | undefined;

    constructor(data?: IDepartmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.organizationId = _data["organizationId"];
            this.externalSourceId = _data["externalSourceId"];
            this.addressId = _data["addressId"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.pNr = _data["pNr"];
        }
    }

    static fromJS(data: any): DepartmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["organizationId"] = this.organizationId;
        data["externalSourceId"] = this.externalSourceId;
        data["addressId"] = this.addressId;
        data["responsibleUserId"] = this.responsibleUserId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["pNr"] = this.pNr;
        return data;
    }

    clone(): DepartmentModel {
        const json = this.toJSON();
        let result = new DepartmentModel();
        result.init(json);
        return result;
    }
}

export interface IDepartmentModel {
    id?: string | undefined;
    userId?: string;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    organizationId?: string | undefined;
    externalSourceId?: string | undefined;
    addressId?: string | undefined;
    responsibleUserId?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    pNr?: string | undefined;
}

export class DictionaryItemModel implements IDictionaryItemModel {
    id?: string;
    key?: string | undefined;
    value?: string | undefined;
    language?: string | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IDictionaryItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.language = _data["language"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): DictionaryItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new DictionaryItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        data["language"] = this.language;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): DictionaryItemModel {
        const json = this.toJSON();
        let result = new DictionaryItemModel();
        result.init(json);
        return result;
    }
}

export interface IDictionaryItemModel {
    id?: string;
    key?: string | undefined;
    value?: string | undefined;
    language?: string | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class DocumentApprovalModel implements IDocumentApprovalModel {
    id?: string;
    userId?: string;
    organizationId?: string;
    description?: string | undefined;
    entityId?: string;
    status?: DocumentRevisionStatus;
    statusDate?: Date;
    responsibleUserId?: string;
    responsibleUserName?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IDocumentApprovalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.description = _data["description"];
            this.entityId = _data["entityId"];
            this.status = _data["status"];
            this.statusDate = _data["statusDate"] ? new Date(_data["statusDate"].toString()) : undefined as any;
            this.responsibleUserId = _data["responsibleUserId"];
            this.responsibleUserName = _data["responsibleUserName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): DocumentApprovalModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentApprovalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["description"] = this.description;
        data["entityId"] = this.entityId;
        data["status"] = this.status;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : undefined as any;
        data["responsibleUserId"] = this.responsibleUserId;
        data["responsibleUserName"] = this.responsibleUserName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): DocumentApprovalModel {
        const json = this.toJSON();
        let result = new DocumentApprovalModel();
        result.init(json);
        return result;
    }
}

export interface IDocumentApprovalModel {
    id?: string;
    userId?: string;
    organizationId?: string;
    description?: string | undefined;
    entityId?: string;
    status?: DocumentRevisionStatus;
    statusDate?: Date;
    responsibleUserId?: string;
    responsibleUserName?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class DocumentApprovalUserModel implements IDocumentApprovalUserModel {
    id?: string;
    userId?: string;
    organizationId?: string;
    responsibleUserId?: string;
    responsibleOrganizationId?: string;
    documentId?: string;
    name?: string | undefined;
    selected?: boolean;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: IDocumentApprovalUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.responsibleOrganizationId = _data["responsibleOrganizationId"];
            this.documentId = _data["documentId"];
            this.name = _data["name"];
            this.selected = _data["selected"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): DocumentApprovalUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentApprovalUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["responsibleUserId"] = this.responsibleUserId;
        data["responsibleOrganizationId"] = this.responsibleOrganizationId;
        data["documentId"] = this.documentId;
        data["name"] = this.name;
        data["selected"] = this.selected;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): DocumentApprovalUserModel {
        const json = this.toJSON();
        let result = new DocumentApprovalUserModel();
        result.init(json);
        return result;
    }
}

export interface IDocumentApprovalUserModel {
    id?: string;
    userId?: string;
    organizationId?: string;
    responsibleUserId?: string;
    responsibleOrganizationId?: string;
    documentId?: string;
    name?: string | undefined;
    selected?: boolean;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
}

export class DocumentationCollectionModel extends BasicModel implements IDocumentationCollectionModel {
    name?: string | undefined;
    documentationRelations?: DocumentationRelationModel[] | undefined;

    constructor(data?: IDocumentationCollectionModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["documentationRelations"])) {
                this.documentationRelations = [] as any;
                for (let item of _data["documentationRelations"])
                    this.documentationRelations!.push(DocumentationRelationModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DocumentationCollectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentationCollectionModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.documentationRelations)) {
            data["documentationRelations"] = [];
            for (let item of this.documentationRelations)
                data["documentationRelations"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): DocumentationCollectionModel {
        const json = this.toJSON();
        let result = new DocumentationCollectionModel();
        result.init(json);
        return result;
    }
}

export interface IDocumentationCollectionModel extends IBasicModel {
    name?: string | undefined;
    documentationRelations?: DocumentationRelationModel[] | undefined;
}

export class DocumentationRelationModel extends BasicModel implements IDocumentationRelationModel {
    name?: string | undefined;
    nodeId?: string;
    collectionId?: string;

    constructor(data?: IDocumentationRelationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.nodeId = _data["nodeId"];
            this.collectionId = _data["collectionId"];
        }
    }

    static override fromJS(data: any): DocumentationRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentationRelationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nodeId"] = this.nodeId;
        data["collectionId"] = this.collectionId;
        super.toJSON(data);
        return data;
    }

    clone(): DocumentationRelationModel {
        const json = this.toJSON();
        let result = new DocumentationRelationModel();
        result.init(json);
        return result;
    }
}

export interface IDocumentationRelationModel extends IBasicModel {
    name?: string | undefined;
    nodeId?: string;
    collectionId?: string;
}

export class DocumentationRelation extends BaseEntity implements IDocumentationRelation {
    collectionId?: string;
    nodeId?: string;
    sortOrder?: number;
    node?: DocumentationNode | undefined;

    constructor(data?: IDocumentationRelation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.collectionId = _data["collectionId"];
            this.nodeId = _data["nodeId"];
            this.sortOrder = _data["sortOrder"];
            this.node = _data["node"] ? DocumentationNode.fromJS(_data["node"]) : undefined as any;
        }
    }

    static override fromJS(data: any): DocumentationRelation {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentationRelation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionId"] = this.collectionId;
        data["nodeId"] = this.nodeId;
        data["sortOrder"] = this.sortOrder;
        data["node"] = this.node ? this.node.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): DocumentationRelation {
        const json = this.toJSON();
        let result = new DocumentationRelation();
        result.init(json);
        return result;
    }
}

export interface IDocumentationRelation extends IBaseEntity {
    collectionId?: string;
    nodeId?: string;
    sortOrder?: number;
    node?: DocumentationNode | undefined;
}

export class DocumentationNode extends BaseEntity implements IDocumentationNode {
    name?: string;
    tags?: string;
    paths?: string;
    content?: string;

    constructor(data?: IDocumentationNode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.tags = _data["tags"];
            this.paths = _data["paths"];
            this.content = _data["content"];
        }
    }

    static override fromJS(data: any): DocumentationNode {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentationNode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["tags"] = this.tags;
        data["paths"] = this.paths;
        data["content"] = this.content;
        super.toJSON(data);
        return data;
    }

    clone(): DocumentationNode {
        const json = this.toJSON();
        let result = new DocumentationNode();
        result.init(json);
        return result;
    }
}

export interface IDocumentationNode extends IBaseEntity {
    name?: string;
    tags?: string;
    paths?: string;
    content?: string;
}

export class DocumentationNodeModel extends BasicModel implements IDocumentationNodeModel {
    name?: string | undefined;
    tags?: string | undefined;
    paths?: string | undefined;
    content?: string | undefined;

    constructor(data?: IDocumentationNodeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.tags = _data["tags"];
            this.paths = _data["paths"];
            this.content = _data["content"];
        }
    }

    static override fromJS(data: any): DocumentationNodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentationNodeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["tags"] = this.tags;
        data["paths"] = this.paths;
        data["content"] = this.content;
        super.toJSON(data);
        return data;
    }

    clone(): DocumentationNodeModel {
        const json = this.toJSON();
        let result = new DocumentationNodeModel();
        result.init(json);
        return result;
    }
}

export interface IDocumentationNodeModel extends IBasicModel {
    name?: string | undefined;
    tags?: string | undefined;
    paths?: string | undefined;
    content?: string | undefined;
}

export class DocumentResourceModel implements IDocumentResourceModel {
    id?: string;
    organizationId?: string;
    userId?: string;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    language?: string | undefined;
    languages?: DocumentResourceLanguageModel[] | undefined;
    documentId?: string | undefined;
    sectionId?: string | undefined;
    departmentId?: string | undefined;
    created?: Date;
    updated?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: IDocumentResourceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.language = _data["language"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(DocumentResourceLanguageModel.fromJS(item));
            }
            this.documentId = _data["documentId"];
            this.sectionId = _data["sectionId"];
            this.departmentId = _data["departmentId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): DocumentResourceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentResourceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        data["language"] = this.language;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["documentId"] = this.documentId;
        data["sectionId"] = this.sectionId;
        data["departmentId"] = this.departmentId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): DocumentResourceModel {
        const json = this.toJSON();
        let result = new DocumentResourceModel();
        result.init(json);
        return result;
    }
}

export interface IDocumentResourceModel {
    id?: string;
    organizationId?: string;
    userId?: string;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    language?: string | undefined;
    languages?: DocumentResourceLanguageModel[] | undefined;
    documentId?: string | undefined;
    sectionId?: string | undefined;
    departmentId?: string | undefined;
    created?: Date;
    updated?: Date | undefined;
    isDeleted?: boolean;
}

export class DocumentResourceLanguageModel implements IDocumentResourceLanguageModel {
    id?: string;
    documentResourceId?: string;
    organizationId?: string;
    userId?: string;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    language?: string | undefined;
    created?: Date;
    updated?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: IDocumentResourceLanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentResourceId = _data["documentResourceId"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.language = _data["language"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): DocumentResourceLanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentResourceLanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentResourceId"] = this.documentResourceId;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        data["language"] = this.language;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): DocumentResourceLanguageModel {
        const json = this.toJSON();
        let result = new DocumentResourceLanguageModel();
        result.init(json);
        return result;
    }
}

export interface IDocumentResourceLanguageModel {
    id?: string;
    documentResourceId?: string;
    organizationId?: string;
    userId?: string;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    language?: string | undefined;
    created?: Date;
    updated?: Date | undefined;
    isDeleted?: boolean;
}

export class EdiConfigModel extends BasicModel implements IEdiConfigModel {
    name?: string | undefined;
    type?: EdiType;
    remoteId?: string | undefined;
    entityConfigurations?: EdiEntityConfigModel[] | undefined;

    constructor(data?: IEdiConfigModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.remoteId = _data["remoteId"];
            if (Array.isArray(_data["entityConfigurations"])) {
                this.entityConfigurations = [] as any;
                for (let item of _data["entityConfigurations"])
                    this.entityConfigurations!.push(EdiEntityConfigModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EdiConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new EdiConfigModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["remoteId"] = this.remoteId;
        if (Array.isArray(this.entityConfigurations)) {
            data["entityConfigurations"] = [];
            for (let item of this.entityConfigurations)
                data["entityConfigurations"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EdiConfigModel {
        const json = this.toJSON();
        let result = new EdiConfigModel();
        result.init(json);
        return result;
    }
}

export interface IEdiConfigModel extends IBasicModel {
    name?: string | undefined;
    type?: EdiType;
    remoteId?: string | undefined;
    entityConfigurations?: EdiEntityConfigModel[] | undefined;
}

export enum EdiType {
    ComidaQS = 1,
    Economic = 2,
    PedersholmBC = 3,
    GS1 = 4,
    Dinero = 5,
    MySupply = 6,
}

export class EdiEntityConfigModel extends BasicModel implements IEdiEntityConfigModel {
    name?: string | undefined;
    type?: EdiEntityType;
    ediConfigId?: string;
    trigger?: EdiTriggerType;
    triggerExpression?: string | undefined;
    entityFieldConfigurations?: EdiEntityFieldConfigModel[] | undefined;

    constructor(data?: IEdiEntityConfigModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.ediConfigId = _data["ediConfigId"];
            this.trigger = _data["trigger"];
            this.triggerExpression = _data["triggerExpression"];
            if (Array.isArray(_data["entityFieldConfigurations"])) {
                this.entityFieldConfigurations = [] as any;
                for (let item of _data["entityFieldConfigurations"])
                    this.entityFieldConfigurations!.push(EdiEntityFieldConfigModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EdiEntityConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new EdiEntityConfigModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["ediConfigId"] = this.ediConfigId;
        data["trigger"] = this.trigger;
        data["triggerExpression"] = this.triggerExpression;
        if (Array.isArray(this.entityFieldConfigurations)) {
            data["entityFieldConfigurations"] = [];
            for (let item of this.entityFieldConfigurations)
                data["entityFieldConfigurations"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EdiEntityConfigModel {
        const json = this.toJSON();
        let result = new EdiEntityConfigModel();
        result.init(json);
        return result;
    }
}

export interface IEdiEntityConfigModel extends IBasicModel {
    name?: string | undefined;
    type?: EdiEntityType;
    ediConfigId?: string;
    trigger?: EdiTriggerType;
    triggerExpression?: string | undefined;
    entityFieldConfigurations?: EdiEntityFieldConfigModel[] | undefined;
}

export enum EdiEntityType {
    Product = 1,
    PurchaseOrder = 2,
    SalesOrder = 3,
}

export enum EdiTriggerType {
    None = 0,
    OnChange = 1,
    Scheduled = 2,
    WebHook = 3,
    MessageBus = 4,
}

export class EdiEntityFieldConfigModel extends BasicModel implements IEdiEntityFieldConfigModel {
    name?: string | undefined;
    expression?: string | undefined;
    type?: EdiFieldType;
    ediEntityConfigId?: string;

    constructor(data?: IEdiEntityFieldConfigModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.expression = _data["expression"];
            this.type = _data["type"];
            this.ediEntityConfigId = _data["ediEntityConfigId"];
        }
    }

    static override fromJS(data: any): EdiEntityFieldConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new EdiEntityFieldConfigModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["expression"] = this.expression;
        data["type"] = this.type;
        data["ediEntityConfigId"] = this.ediEntityConfigId;
        super.toJSON(data);
        return data;
    }

    clone(): EdiEntityFieldConfigModel {
        const json = this.toJSON();
        let result = new EdiEntityFieldConfigModel();
        result.init(json);
        return result;
    }
}

export interface IEdiEntityFieldConfigModel extends IBasicModel {
    name?: string | undefined;
    expression?: string | undefined;
    type?: EdiFieldType;
    ediEntityConfigId?: string;
}

export enum EdiFieldType {
    Mapping = 1,
    Condition = 2,
}

export class ProductionOrderModel implements IProductionOrderModel {
    id?: string;
    recipeId?: string;
    startTime?: Date | undefined;
    finishTime?: Date | undefined;
    scaling?: number;
    status?: ProductionOrderStatus;
    lot?: string | undefined;
    parentOrderId?: string | undefined;
    salesOrderId?: string | undefined;
    prevOrder?: string;
    nextOrder?: string;
    wantedDate?: Date | undefined;
    plannedDate?: Date | undefined;
    expirationDate?: Date | undefined;
    calculatedQuantity?: number;
    actualQuantity?: number;
    outputUnit?: string | undefined;
    warnings?: string | undefined;
    readyForProduction?: boolean;
    parentInputQuantity?: number;
    internalNote?: string | undefined;
    productionOrderNumber?: string | undefined;
    salesOrderNumber?: string | undefined;
    customerName?: string | undefined;
    plannedWeight?: number;
    shifts?: ProductionShiftModel[] | undefined;
    userId?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
    recipeType?: number;
    recipeName?: string | undefined;
    recipeVersion?: string | undefined;
    processName?: string | undefined;
    processId?: string | undefined;
    recipeGroupName?: string | undefined;
    primaryOutputId?: string;
    primaryOutputSku?: string | undefined;
    primaryOutputQuantity?: number;
    primaryOutputUnit?: string | undefined;

    constructor(data?: IProductionOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipeId = _data["recipeId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : undefined as any;
            this.scaling = _data["scaling"];
            this.status = _data["status"];
            this.lot = _data["lot"];
            this.parentOrderId = _data["parentOrderId"];
            this.salesOrderId = _data["salesOrderId"];
            this.prevOrder = _data["prevOrder"];
            this.nextOrder = _data["nextOrder"];
            this.wantedDate = _data["wantedDate"] ? new Date(_data["wantedDate"].toString()) : undefined as any;
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.calculatedQuantity = _data["calculatedQuantity"];
            this.actualQuantity = _data["actualQuantity"];
            this.outputUnit = _data["outputUnit"];
            this.warnings = _data["warnings"];
            this.readyForProduction = _data["readyForProduction"];
            this.parentInputQuantity = _data["parentInputQuantity"];
            this.internalNote = _data["internalNote"];
            this.productionOrderNumber = _data["productionOrderNumber"];
            this.salesOrderNumber = _data["salesOrderNumber"];
            this.customerName = _data["customerName"];
            this.plannedWeight = _data["plannedWeight"];
            if (Array.isArray(_data["shifts"])) {
                this.shifts = [] as any;
                for (let item of _data["shifts"])
                    this.shifts!.push(ProductionShiftModel.fromJS(item));
            }
            this.userId = _data["userId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.recipeType = _data["recipeType"];
            this.recipeName = _data["recipeName"];
            this.recipeVersion = _data["recipeVersion"];
            this.processName = _data["processName"];
            this.processId = _data["processId"];
            this.recipeGroupName = _data["recipeGroupName"];
            this.primaryOutputId = _data["primaryOutputId"];
            this.primaryOutputSku = _data["primaryOutputSku"];
            this.primaryOutputQuantity = _data["primaryOutputQuantity"];
            this.primaryOutputUnit = _data["primaryOutputUnit"];
        }
    }

    static fromJS(data: any): ProductionOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipeId"] = this.recipeId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : undefined as any;
        data["scaling"] = this.scaling;
        data["status"] = this.status;
        data["lot"] = this.lot;
        data["parentOrderId"] = this.parentOrderId;
        data["salesOrderId"] = this.salesOrderId;
        data["prevOrder"] = this.prevOrder;
        data["nextOrder"] = this.nextOrder;
        data["wantedDate"] = this.wantedDate ? this.wantedDate.toISOString() : undefined as any;
        data["plannedDate"] = this.plannedDate ? this.plannedDate.toISOString() : undefined as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["calculatedQuantity"] = this.calculatedQuantity;
        data["actualQuantity"] = this.actualQuantity;
        data["outputUnit"] = this.outputUnit;
        data["warnings"] = this.warnings;
        data["readyForProduction"] = this.readyForProduction;
        data["parentInputQuantity"] = this.parentInputQuantity;
        data["internalNote"] = this.internalNote;
        data["productionOrderNumber"] = this.productionOrderNumber;
        data["salesOrderNumber"] = this.salesOrderNumber;
        data["customerName"] = this.customerName;
        data["plannedWeight"] = this.plannedWeight;
        if (Array.isArray(this.shifts)) {
            data["shifts"] = [];
            for (let item of this.shifts)
                data["shifts"].push(item ? item.toJSON() : undefined as any);
        }
        data["userId"] = this.userId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["recipeType"] = this.recipeType;
        data["recipeName"] = this.recipeName;
        data["recipeVersion"] = this.recipeVersion;
        data["processName"] = this.processName;
        data["processId"] = this.processId;
        data["recipeGroupName"] = this.recipeGroupName;
        data["primaryOutputId"] = this.primaryOutputId;
        data["primaryOutputSku"] = this.primaryOutputSku;
        data["primaryOutputQuantity"] = this.primaryOutputQuantity;
        data["primaryOutputUnit"] = this.primaryOutputUnit;
        return data;
    }

    clone(): ProductionOrderModel {
        const json = this.toJSON();
        let result = new ProductionOrderModel();
        result.init(json);
        return result;
    }
}

export interface IProductionOrderModel {
    id?: string;
    recipeId?: string;
    startTime?: Date | undefined;
    finishTime?: Date | undefined;
    scaling?: number;
    status?: ProductionOrderStatus;
    lot?: string | undefined;
    parentOrderId?: string | undefined;
    salesOrderId?: string | undefined;
    prevOrder?: string;
    nextOrder?: string;
    wantedDate?: Date | undefined;
    plannedDate?: Date | undefined;
    expirationDate?: Date | undefined;
    calculatedQuantity?: number;
    actualQuantity?: number;
    outputUnit?: string | undefined;
    warnings?: string | undefined;
    readyForProduction?: boolean;
    parentInputQuantity?: number;
    internalNote?: string | undefined;
    productionOrderNumber?: string | undefined;
    salesOrderNumber?: string | undefined;
    customerName?: string | undefined;
    plannedWeight?: number;
    shifts?: ProductionShiftModel[] | undefined;
    userId?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
    recipeType?: number;
    recipeName?: string | undefined;
    recipeVersion?: string | undefined;
    processName?: string | undefined;
    processId?: string | undefined;
    recipeGroupName?: string | undefined;
    primaryOutputId?: string;
    primaryOutputSku?: string | undefined;
    primaryOutputQuantity?: number;
    primaryOutputUnit?: string | undefined;
}

export enum ProductionOrderStatus {
    Draft = 0,
    Planned = 1,
    Started = 2,
    Finished = 3,
    Reserved = 4,
    Estimated = 5,
}

export class ProductionShiftModel extends BasicEntity implements IProductionShiftModel {
    name?: string | undefined;
    productionOrderId?: string;
    startTime?: Date;
    finishTime?: Date;
    actualStartTime?: Date;
    actualFinishTime?: Date;
    scaling?: number;
    actualScaling?: number;
    status?: ProductionOrderStatus;
    allocations?: ResourceAllocationModel[] | undefined;

    constructor(data?: IProductionShiftModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.productionOrderId = _data["productionOrderId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : undefined as any;
            this.actualStartTime = _data["actualStartTime"] ? new Date(_data["actualStartTime"].toString()) : undefined as any;
            this.actualFinishTime = _data["actualFinishTime"] ? new Date(_data["actualFinishTime"].toString()) : undefined as any;
            this.scaling = _data["scaling"];
            this.actualScaling = _data["actualScaling"];
            this.status = _data["status"];
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(ResourceAllocationModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProductionShiftModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionShiftModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["productionOrderId"] = this.productionOrderId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : undefined as any;
        data["actualStartTime"] = this.actualStartTime ? this.actualStartTime.toISOString() : undefined as any;
        data["actualFinishTime"] = this.actualFinishTime ? this.actualFinishTime.toISOString() : undefined as any;
        data["scaling"] = this.scaling;
        data["actualScaling"] = this.actualScaling;
        data["status"] = this.status;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ProductionShiftModel {
        const json = this.toJSON();
        let result = new ProductionShiftModel();
        result.init(json);
        return result;
    }
}

export interface IProductionShiftModel extends IBasicEntity {
    name?: string | undefined;
    productionOrderId?: string;
    startTime?: Date;
    finishTime?: Date;
    actualStartTime?: Date;
    actualFinishTime?: Date;
    scaling?: number;
    actualScaling?: number;
    status?: ProductionOrderStatus;
    allocations?: ResourceAllocationModel[] | undefined;
}

export class ResourceAllocationModel implements IResourceAllocationModel {
    id?: string;
    resourceId?: string;
    productionOrderId?: string;
    productionOrderNumber?: string | undefined;
    productionShiftId?: string | undefined;
    requirementId?: string | undefined;
    processStepId?: string;
    startTime?: Date;
    endTime?: Date;
    status?: ProductionOrderStatus;
    recipeName?: string | undefined;
    lotName?: string | undefined;
    scaling?: number;
    resourceName?: string | undefined;
    requirementName?: string | undefined;
    resourceType?: ResourceType;
    type?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IResourceAllocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourceId = _data["resourceId"];
            this.productionOrderId = _data["productionOrderId"];
            this.productionOrderNumber = _data["productionOrderNumber"];
            this.productionShiftId = _data["productionShiftId"];
            this.requirementId = _data["requirementId"];
            this.processStepId = _data["processStepId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.status = _data["status"];
            this.recipeName = _data["recipeName"];
            this.lotName = _data["lotName"];
            this.scaling = _data["scaling"];
            this.resourceName = _data["resourceName"];
            this.requirementName = _data["requirementName"];
            this.resourceType = _data["resourceType"];
            this.type = _data["type"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ResourceAllocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceAllocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resourceId"] = this.resourceId;
        data["productionOrderId"] = this.productionOrderId;
        data["productionOrderNumber"] = this.productionOrderNumber;
        data["productionShiftId"] = this.productionShiftId;
        data["requirementId"] = this.requirementId;
        data["processStepId"] = this.processStepId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["status"] = this.status;
        data["recipeName"] = this.recipeName;
        data["lotName"] = this.lotName;
        data["scaling"] = this.scaling;
        data["resourceName"] = this.resourceName;
        data["requirementName"] = this.requirementName;
        data["resourceType"] = this.resourceType;
        data["type"] = this.type;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ResourceAllocationModel {
        const json = this.toJSON();
        let result = new ResourceAllocationModel();
        result.init(json);
        return result;
    }
}

export interface IResourceAllocationModel {
    id?: string;
    resourceId?: string;
    productionOrderId?: string;
    productionOrderNumber?: string | undefined;
    productionShiftId?: string | undefined;
    requirementId?: string | undefined;
    processStepId?: string;
    startTime?: Date;
    endTime?: Date;
    status?: ProductionOrderStatus;
    recipeName?: string | undefined;
    lotName?: string | undefined;
    scaling?: number;
    resourceName?: string | undefined;
    requirementName?: string | undefined;
    resourceType?: ResourceType;
    type?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum ResourceType {
    Default = 0,
    Machinery = 1,
    ManPower = 10,
    Indirect = 99,
}

export class FindSmileyDataModel implements IFindSmileyDataModel {
    id?: string;
    navnelbnr?: number;
    cvr?: string | undefined;
    pNr?: string | undefined;
    navn?: string | undefined;
    url?: string | undefined;
    kontrolResultat?: number;
    kontrolDato?: Date;
    isDeleted?: boolean;

    constructor(data?: IFindSmileyDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.navnelbnr = _data["navnelbnr"];
            this.cvr = _data["cvr"];
            this.pNr = _data["pNr"];
            this.navn = _data["navn"];
            this.url = _data["url"];
            this.kontrolResultat = _data["kontrolResultat"];
            this.kontrolDato = _data["kontrolDato"] ? new Date(_data["kontrolDato"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): FindSmileyDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new FindSmileyDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["navnelbnr"] = this.navnelbnr;
        data["cvr"] = this.cvr;
        data["pNr"] = this.pNr;
        data["navn"] = this.navn;
        data["url"] = this.url;
        data["kontrolResultat"] = this.kontrolResultat;
        data["kontrolDato"] = this.kontrolDato ? this.kontrolDato.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): FindSmileyDataModel {
        const json = this.toJSON();
        let result = new FindSmileyDataModel();
        result.init(json);
        return result;
    }
}

export interface IFindSmileyDataModel {
    id?: string;
    navnelbnr?: number;
    cvr?: string | undefined;
    pNr?: string | undefined;
    navn?: string | undefined;
    url?: string | undefined;
    kontrolResultat?: number;
    kontrolDato?: Date;
    isDeleted?: boolean;
}

export class DepartmentFindSmileyDataModel implements IDepartmentFindSmileyDataModel {
    departmentName?: string | undefined;
    reportData?: FindSmileyDataModel[] | undefined;

    constructor(data?: IDepartmentFindSmileyDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentName = _data["departmentName"];
            if (Array.isArray(_data["reportData"])) {
                this.reportData = [] as any;
                for (let item of _data["reportData"])
                    this.reportData!.push(FindSmileyDataModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepartmentFindSmileyDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentFindSmileyDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentName"] = this.departmentName;
        if (Array.isArray(this.reportData)) {
            data["reportData"] = [];
            for (let item of this.reportData)
                data["reportData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): DepartmentFindSmileyDataModel {
        const json = this.toJSON();
        let result = new DepartmentFindSmileyDataModel();
        result.init(json);
        return result;
    }
}

export interface IDepartmentFindSmileyDataModel {
    departmentName?: string | undefined;
    reportData?: FindSmileyDataModel[] | undefined;
}

export class FoodAnalysisModel extends BasicEntity implements IFoodAnalysisModel {
    analysisPersonId?: string | undefined;
    analysisTypeId?: string;
    analysisOrganizationId?: string;
    description?: string | undefined;
    timePlanned?: Date;
    timeTaken?: Date;
    auditVisitId?: string | undefined;
    status?: FoodAnalysisStatus;

    constructor(data?: IFoodAnalysisModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.analysisPersonId = _data["analysisPersonId"];
            this.analysisTypeId = _data["analysisTypeId"];
            this.analysisOrganizationId = _data["analysisOrganizationId"];
            this.description = _data["description"];
            this.timePlanned = _data["timePlanned"] ? new Date(_data["timePlanned"].toString()) : undefined as any;
            this.timeTaken = _data["timeTaken"] ? new Date(_data["timeTaken"].toString()) : undefined as any;
            this.auditVisitId = _data["auditVisitId"];
            this.status = _data["status"];
        }
    }

    static override fromJS(data: any): FoodAnalysisModel {
        data = typeof data === 'object' ? data : {};
        let result = new FoodAnalysisModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["analysisPersonId"] = this.analysisPersonId;
        data["analysisTypeId"] = this.analysisTypeId;
        data["analysisOrganizationId"] = this.analysisOrganizationId;
        data["description"] = this.description;
        data["timePlanned"] = this.timePlanned ? this.timePlanned.toISOString() : undefined as any;
        data["timeTaken"] = this.timeTaken ? this.timeTaken.toISOString() : undefined as any;
        data["auditVisitId"] = this.auditVisitId;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }

    clone(): FoodAnalysisModel {
        const json = this.toJSON();
        let result = new FoodAnalysisModel();
        result.init(json);
        return result;
    }
}

export interface IFoodAnalysisModel extends IBasicEntity {
    analysisPersonId?: string | undefined;
    analysisTypeId?: string;
    analysisOrganizationId?: string;
    description?: string | undefined;
    timePlanned?: Date;
    timeTaken?: Date;
    auditVisitId?: string | undefined;
    status?: FoodAnalysisStatus;
}

export enum FoodAnalysisStatus {
    Draft = 0,
    Planned = 1,
    Done = 2,
    Finished = 3,
}

export class FoodAnalysisViewModel implements IFoodAnalysisViewModel {
    id?: string;
    foodAnalysisId?: string;
    analysisPersonName?: string | undefined;
    analysisTypeName?: string | undefined;
    organizationName?: string | undefined;
    description?: string | undefined;
    timePlanned?: Date;
    timeTaken?: Date;

    constructor(data?: IFoodAnalysisViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.foodAnalysisId = _data["foodAnalysisId"];
            this.analysisPersonName = _data["analysisPersonName"];
            this.analysisTypeName = _data["analysisTypeName"];
            this.organizationName = _data["organizationName"];
            this.description = _data["description"];
            this.timePlanned = _data["timePlanned"] ? new Date(_data["timePlanned"].toString()) : undefined as any;
            this.timeTaken = _data["timeTaken"] ? new Date(_data["timeTaken"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FoodAnalysisViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FoodAnalysisViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["foodAnalysisId"] = this.foodAnalysisId;
        data["analysisPersonName"] = this.analysisPersonName;
        data["analysisTypeName"] = this.analysisTypeName;
        data["organizationName"] = this.organizationName;
        data["description"] = this.description;
        data["timePlanned"] = this.timePlanned ? this.timePlanned.toISOString() : undefined as any;
        data["timeTaken"] = this.timeTaken ? this.timeTaken.toISOString() : undefined as any;
        return data;
    }

    clone(): FoodAnalysisViewModel {
        const json = this.toJSON();
        let result = new FoodAnalysisViewModel();
        result.init(json);
        return result;
    }
}

export interface IFoodAnalysisViewModel {
    id?: string;
    foodAnalysisId?: string;
    analysisPersonName?: string | undefined;
    analysisTypeName?: string | undefined;
    organizationName?: string | undefined;
    description?: string | undefined;
    timePlanned?: Date;
    timeTaken?: Date;
}

export class FoodAnalysisType extends BasicEntity implements IFoodAnalysisType {
    name?: string | undefined;

    constructor(data?: IFoodAnalysisType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static override fromJS(data: any): FoodAnalysisType {
        data = typeof data === 'object' ? data : {};
        let result = new FoodAnalysisType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }

    clone(): FoodAnalysisType {
        const json = this.toJSON();
        let result = new FoodAnalysisType();
        result.init(json);
        return result;
    }
}

export interface IFoodAnalysisType extends IBasicEntity {
    name?: string | undefined;
}

export class FoodStandardModel implements IFoodStandardModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    requirements?: FoodStandardRequirementModel[] | undefined;

    constructor(data?: IFoodStandardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["requirements"])) {
                this.requirements = [] as any;
                for (let item of _data["requirements"])
                    this.requirements!.push(FoodStandardRequirementModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FoodStandardModel {
        data = typeof data === 'object' ? data : {};
        let result = new FoodStandardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.requirements)) {
            data["requirements"] = [];
            for (let item of this.requirements)
                data["requirements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): FoodStandardModel {
        const json = this.toJSON();
        let result = new FoodStandardModel();
        result.init(json);
        return result;
    }
}

export interface IFoodStandardModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    requirements?: FoodStandardRequirementModel[] | undefined;
}

export class FoodStandardRequirementModel implements IFoodStandardRequirementModel {
    id?: string;
    foodStandardId?: string;
    parentRequirementId?: string | undefined;
    name?: string | undefined;
    number?: string | undefined;
    sortOrder?: number;
    childRequirements?: FoodStandardRequirementModel[] | undefined;
    requirementLinks?: FoodStandardRequirementLinkModel[] | undefined;

    constructor(data?: IFoodStandardRequirementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.foodStandardId = _data["foodStandardId"];
            this.parentRequirementId = _data["parentRequirementId"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["childRequirements"])) {
                this.childRequirements = [] as any;
                for (let item of _data["childRequirements"])
                    this.childRequirements!.push(FoodStandardRequirementModel.fromJS(item));
            }
            if (Array.isArray(_data["requirementLinks"])) {
                this.requirementLinks = [] as any;
                for (let item of _data["requirementLinks"])
                    this.requirementLinks!.push(FoodStandardRequirementLinkModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FoodStandardRequirementModel {
        data = typeof data === 'object' ? data : {};
        let result = new FoodStandardRequirementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["foodStandardId"] = this.foodStandardId;
        data["parentRequirementId"] = this.parentRequirementId;
        data["name"] = this.name;
        data["number"] = this.number;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.childRequirements)) {
            data["childRequirements"] = [];
            for (let item of this.childRequirements)
                data["childRequirements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.requirementLinks)) {
            data["requirementLinks"] = [];
            for (let item of this.requirementLinks)
                data["requirementLinks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): FoodStandardRequirementModel {
        const json = this.toJSON();
        let result = new FoodStandardRequirementModel();
        result.init(json);
        return result;
    }
}

export interface IFoodStandardRequirementModel {
    id?: string;
    foodStandardId?: string;
    parentRequirementId?: string | undefined;
    name?: string | undefined;
    number?: string | undefined;
    sortOrder?: number;
    childRequirements?: FoodStandardRequirementModel[] | undefined;
    requirementLinks?: FoodStandardRequirementLinkModel[] | undefined;
}

export class FoodStandardRequirementLinkModel implements IFoodStandardRequirementLinkModel {
    id?: string;
    foodStandardId?: string;
    requirementId?: string;
    entityType?: EntityType;
    riskAnalysisId?: string | undefined;
    riskFactorId?: string | undefined;
    procedureId?: string | undefined;
    procedureStepId?: string | undefined;
    foodStandardName?: string | undefined;
    foodStandardRequirementName?: string | undefined;
    foodStandardRequirementNumber?: string | undefined;
    riskAnalysis?: RiskAnalysisModel | undefined;
    riskFactor?: RiskFactorModel | undefined;
    procedure?: ProcedureModel | undefined;
    procedureStep?: ProcedureStepModel | undefined;

    constructor(data?: IFoodStandardRequirementLinkModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.foodStandardId = _data["foodStandardId"];
            this.requirementId = _data["requirementId"];
            this.entityType = _data["entityType"];
            this.riskAnalysisId = _data["riskAnalysisId"];
            this.riskFactorId = _data["riskFactorId"];
            this.procedureId = _data["procedureId"];
            this.procedureStepId = _data["procedureStepId"];
            this.foodStandardName = _data["foodStandardName"];
            this.foodStandardRequirementName = _data["foodStandardRequirementName"];
            this.foodStandardRequirementNumber = _data["foodStandardRequirementNumber"];
            this.riskAnalysis = _data["riskAnalysis"] ? RiskAnalysisModel.fromJS(_data["riskAnalysis"]) : undefined as any;
            this.riskFactor = _data["riskFactor"] ? RiskFactorModel.fromJS(_data["riskFactor"]) : undefined as any;
            this.procedure = _data["procedure"] ? ProcedureModel.fromJS(_data["procedure"]) : undefined as any;
            this.procedureStep = _data["procedureStep"] ? ProcedureStepModel.fromJS(_data["procedureStep"]) : undefined as any;
        }
    }

    static fromJS(data: any): FoodStandardRequirementLinkModel {
        data = typeof data === 'object' ? data : {};
        let result = new FoodStandardRequirementLinkModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["foodStandardId"] = this.foodStandardId;
        data["requirementId"] = this.requirementId;
        data["entityType"] = this.entityType;
        data["riskAnalysisId"] = this.riskAnalysisId;
        data["riskFactorId"] = this.riskFactorId;
        data["procedureId"] = this.procedureId;
        data["procedureStepId"] = this.procedureStepId;
        data["foodStandardName"] = this.foodStandardName;
        data["foodStandardRequirementName"] = this.foodStandardRequirementName;
        data["foodStandardRequirementNumber"] = this.foodStandardRequirementNumber;
        data["riskAnalysis"] = this.riskAnalysis ? this.riskAnalysis.toJSON() : undefined as any;
        data["riskFactor"] = this.riskFactor ? this.riskFactor.toJSON() : undefined as any;
        data["procedure"] = this.procedure ? this.procedure.toJSON() : undefined as any;
        data["procedureStep"] = this.procedureStep ? this.procedureStep.toJSON() : undefined as any;
        return data;
    }

    clone(): FoodStandardRequirementLinkModel {
        const json = this.toJSON();
        let result = new FoodStandardRequirementLinkModel();
        result.init(json);
        return result;
    }
}

export interface IFoodStandardRequirementLinkModel {
    id?: string;
    foodStandardId?: string;
    requirementId?: string;
    entityType?: EntityType;
    riskAnalysisId?: string | undefined;
    riskFactorId?: string | undefined;
    procedureId?: string | undefined;
    procedureStepId?: string | undefined;
    foodStandardName?: string | undefined;
    foodStandardRequirementName?: string | undefined;
    foodStandardRequirementNumber?: string | undefined;
    riskAnalysis?: RiskAnalysisModel | undefined;
    riskFactor?: RiskFactorModel | undefined;
    procedure?: ProcedureModel | undefined;
    procedureStep?: ProcedureStepModel | undefined;
}

export class RiskAnalysisModel implements IRiskAnalysisModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    language?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    process?: ProcessSimpleModel | undefined;
    riskFactors?: RiskFactorModel[] | undefined;
    riskFactorRelations?: RiskFactorRelationModel[] | undefined;
    riskAnalysisLanguages?: RiskAnalysisLanguageModel[] | undefined;
    departmentId?: string;
    documentVersion?: DocumentRevisionModel | undefined;
    revision?: DocumentRevisionModel | undefined;
    type?: RiskAnalysisType;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IRiskAnalysisModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.language = _data["language"];
            this.responsibleUser = _data["responsibleUser"] ? IdNameModel.fromJS(_data["responsibleUser"]) : undefined as any;
            this.process = _data["process"] ? ProcessSimpleModel.fromJS(_data["process"]) : undefined as any;
            if (Array.isArray(_data["riskFactors"])) {
                this.riskFactors = [] as any;
                for (let item of _data["riskFactors"])
                    this.riskFactors!.push(RiskFactorModel.fromJS(item));
            }
            if (Array.isArray(_data["riskFactorRelations"])) {
                this.riskFactorRelations = [] as any;
                for (let item of _data["riskFactorRelations"])
                    this.riskFactorRelations!.push(RiskFactorRelationModel.fromJS(item));
            }
            if (Array.isArray(_data["riskAnalysisLanguages"])) {
                this.riskAnalysisLanguages = [] as any;
                for (let item of _data["riskAnalysisLanguages"])
                    this.riskAnalysisLanguages!.push(RiskAnalysisLanguageModel.fromJS(item));
            }
            this.departmentId = _data["departmentId"];
            this.documentVersion = _data["documentVersion"] ? DocumentRevisionModel.fromJS(_data["documentVersion"]) : undefined as any;
            this.revision = _data["revision"] ? DocumentRevisionModel.fromJS(_data["revision"]) : undefined as any;
            this.type = _data["type"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RiskAnalysisModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskAnalysisModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["language"] = this.language;
        data["responsibleUser"] = this.responsibleUser ? this.responsibleUser.toJSON() : undefined as any;
        data["process"] = this.process ? this.process.toJSON() : undefined as any;
        if (Array.isArray(this.riskFactors)) {
            data["riskFactors"] = [];
            for (let item of this.riskFactors)
                data["riskFactors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.riskFactorRelations)) {
            data["riskFactorRelations"] = [];
            for (let item of this.riskFactorRelations)
                data["riskFactorRelations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.riskAnalysisLanguages)) {
            data["riskAnalysisLanguages"] = [];
            for (let item of this.riskAnalysisLanguages)
                data["riskAnalysisLanguages"].push(item ? item.toJSON() : undefined as any);
        }
        data["departmentId"] = this.departmentId;
        data["documentVersion"] = this.documentVersion ? this.documentVersion.toJSON() : undefined as any;
        data["revision"] = this.revision ? this.revision.toJSON() : undefined as any;
        data["type"] = this.type;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): RiskAnalysisModel {
        const json = this.toJSON();
        let result = new RiskAnalysisModel();
        result.init(json);
        return result;
    }
}

export interface IRiskAnalysisModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    language?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    process?: ProcessSimpleModel | undefined;
    riskFactors?: RiskFactorModel[] | undefined;
    riskFactorRelations?: RiskFactorRelationModel[] | undefined;
    riskAnalysisLanguages?: RiskAnalysisLanguageModel[] | undefined;
    departmentId?: string;
    documentVersion?: DocumentRevisionModel | undefined;
    revision?: DocumentRevisionModel | undefined;
    type?: RiskAnalysisType;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ProcessSimpleModel implements IProcessSimpleModel {
    id?: string;
    departmentId?: string;
    name?: string | undefined;
    description?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    documentVersion?: DocumentRevisionModel | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: IProcessSimpleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.departmentId = _data["departmentId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.responsibleUser = _data["responsibleUser"] ? IdNameModel.fromJS(_data["responsibleUser"]) : undefined as any;
            this.documentVersion = _data["documentVersion"] ? DocumentRevisionModel.fromJS(_data["documentVersion"]) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProcessSimpleModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessSimpleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["departmentId"] = this.departmentId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["responsibleUser"] = this.responsibleUser ? this.responsibleUser.toJSON() : undefined as any;
        data["documentVersion"] = this.documentVersion ? this.documentVersion.toJSON() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ProcessSimpleModel {
        const json = this.toJSON();
        let result = new ProcessSimpleModel();
        result.init(json);
        return result;
    }
}

export interface IProcessSimpleModel {
    id?: string;
    departmentId?: string;
    name?: string | undefined;
    description?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    documentVersion?: DocumentRevisionModel | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
}

export class RiskFactorModel implements IRiskFactorModel {
    id?: string;
    processStep?: ProcessStepModel | undefined;
    riskAnalysisId?: string;
    name?: string | undefined;
    cause?: string | undefined;
    controllingAction?: string | undefined;
    reasoning?: string | undefined;
    type?: number;
    typeName?: string | undefined;
    probability?: number;
    consequence?: number;
    pcProduct?: number;
    decisionTreeQ1?: boolean | undefined;
    decisionTreeQ1a?: boolean | undefined;
    decisionTreeQ2?: boolean | undefined;
    decisionTreeQ3?: boolean | undefined;
    decisionTreeQ4?: boolean | undefined;
    decisionTreeQ5?: boolean | undefined;
    isCCP?: boolean | undefined;
    isOPRP?: boolean | undefined;
    ccps?: IdNameModel[] | undefined;
    ccpText?: string | undefined;
    riskFactorProcessSteps?: RiskFactorProcessStepModel[] | undefined;
    processId?: string | undefined;
    analysisType?: RiskAnalysisType;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IRiskFactorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processStep = _data["processStep"] ? ProcessStepModel.fromJS(_data["processStep"]) : undefined as any;
            this.riskAnalysisId = _data["riskAnalysisId"];
            this.name = _data["name"];
            this.cause = _data["cause"];
            this.controllingAction = _data["controllingAction"];
            this.reasoning = _data["reasoning"];
            this.type = _data["type"];
            this.typeName = _data["typeName"];
            this.probability = _data["probability"];
            this.consequence = _data["consequence"];
            this.pcProduct = _data["pcProduct"];
            this.decisionTreeQ1 = _data["decisionTreeQ1"];
            this.decisionTreeQ1a = _data["decisionTreeQ1a"];
            this.decisionTreeQ2 = _data["decisionTreeQ2"];
            this.decisionTreeQ3 = _data["decisionTreeQ3"];
            this.decisionTreeQ4 = _data["decisionTreeQ4"];
            this.decisionTreeQ5 = _data["decisionTreeQ5"];
            this.isCCP = _data["isCCP"];
            this.isOPRP = _data["isOPRP"];
            if (Array.isArray(_data["ccps"])) {
                this.ccps = [] as any;
                for (let item of _data["ccps"])
                    this.ccps!.push(IdNameModel.fromJS(item));
            }
            this.ccpText = _data["ccpText"];
            if (Array.isArray(_data["riskFactorProcessSteps"])) {
                this.riskFactorProcessSteps = [] as any;
                for (let item of _data["riskFactorProcessSteps"])
                    this.riskFactorProcessSteps!.push(RiskFactorProcessStepModel.fromJS(item));
            }
            this.processId = _data["processId"];
            this.analysisType = _data["analysisType"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RiskFactorModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskFactorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processStep"] = this.processStep ? this.processStep.toJSON() : undefined as any;
        data["riskAnalysisId"] = this.riskAnalysisId;
        data["name"] = this.name;
        data["cause"] = this.cause;
        data["controllingAction"] = this.controllingAction;
        data["reasoning"] = this.reasoning;
        data["type"] = this.type;
        data["typeName"] = this.typeName;
        data["probability"] = this.probability;
        data["consequence"] = this.consequence;
        data["pcProduct"] = this.pcProduct;
        data["decisionTreeQ1"] = this.decisionTreeQ1;
        data["decisionTreeQ1a"] = this.decisionTreeQ1a;
        data["decisionTreeQ2"] = this.decisionTreeQ2;
        data["decisionTreeQ3"] = this.decisionTreeQ3;
        data["decisionTreeQ4"] = this.decisionTreeQ4;
        data["decisionTreeQ5"] = this.decisionTreeQ5;
        data["isCCP"] = this.isCCP;
        data["isOPRP"] = this.isOPRP;
        if (Array.isArray(this.ccps)) {
            data["ccps"] = [];
            for (let item of this.ccps)
                data["ccps"].push(item ? item.toJSON() : undefined as any);
        }
        data["ccpText"] = this.ccpText;
        if (Array.isArray(this.riskFactorProcessSteps)) {
            data["riskFactorProcessSteps"] = [];
            for (let item of this.riskFactorProcessSteps)
                data["riskFactorProcessSteps"].push(item ? item.toJSON() : undefined as any);
        }
        data["processId"] = this.processId;
        data["analysisType"] = this.analysisType;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): RiskFactorModel {
        const json = this.toJSON();
        let result = new RiskFactorModel();
        result.init(json);
        return result;
    }
}

export interface IRiskFactorModel {
    id?: string;
    processStep?: ProcessStepModel | undefined;
    riskAnalysisId?: string;
    name?: string | undefined;
    cause?: string | undefined;
    controllingAction?: string | undefined;
    reasoning?: string | undefined;
    type?: number;
    typeName?: string | undefined;
    probability?: number;
    consequence?: number;
    pcProduct?: number;
    decisionTreeQ1?: boolean | undefined;
    decisionTreeQ1a?: boolean | undefined;
    decisionTreeQ2?: boolean | undefined;
    decisionTreeQ3?: boolean | undefined;
    decisionTreeQ4?: boolean | undefined;
    decisionTreeQ5?: boolean | undefined;
    isCCP?: boolean | undefined;
    isOPRP?: boolean | undefined;
    ccps?: IdNameModel[] | undefined;
    ccpText?: string | undefined;
    riskFactorProcessSteps?: RiskFactorProcessStepModel[] | undefined;
    processId?: string | undefined;
    analysisType?: RiskAnalysisType;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ProcessStepModel implements IProcessStepModel {
    id?: string;
    processId?: string;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    type?: number;
    capabilityId?: string;
    duration?: number;
    durationExpression?: string | undefined;
    parentProcessStepId?: string | undefined;
    nodeTop?: number;
    nodeLeft?: number;
    nodeWidth?: number;
    nodeHeight?: number;
    nodeType?: string | undefined;
    nodeStyle?: string | undefined;
    nodeTextStyle?: string | undefined;
    displayName?: string | undefined;
    factors?: string[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IProcessStepModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processId = _data["processId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.type = _data["type"];
            this.capabilityId = _data["capabilityId"];
            this.duration = _data["duration"];
            this.durationExpression = _data["durationExpression"];
            this.parentProcessStepId = _data["parentProcessStepId"];
            this.nodeTop = _data["nodeTop"];
            this.nodeLeft = _data["nodeLeft"];
            this.nodeWidth = _data["nodeWidth"];
            this.nodeHeight = _data["nodeHeight"];
            this.nodeType = _data["nodeType"];
            this.nodeStyle = _data["nodeStyle"];
            this.nodeTextStyle = _data["nodeTextStyle"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["factors"])) {
                this.factors = [] as any;
                for (let item of _data["factors"])
                    this.factors!.push(item);
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProcessStepModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessStepModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processId"] = this.processId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["type"] = this.type;
        data["capabilityId"] = this.capabilityId;
        data["duration"] = this.duration;
        data["durationExpression"] = this.durationExpression;
        data["parentProcessStepId"] = this.parentProcessStepId;
        data["nodeTop"] = this.nodeTop;
        data["nodeLeft"] = this.nodeLeft;
        data["nodeWidth"] = this.nodeWidth;
        data["nodeHeight"] = this.nodeHeight;
        data["nodeType"] = this.nodeType;
        data["nodeStyle"] = this.nodeStyle;
        data["nodeTextStyle"] = this.nodeTextStyle;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.factors)) {
            data["factors"] = [];
            for (let item of this.factors)
                data["factors"].push(item);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ProcessStepModel {
        const json = this.toJSON();
        let result = new ProcessStepModel();
        result.init(json);
        return result;
    }
}

export interface IProcessStepModel {
    id?: string;
    processId?: string;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    type?: number;
    capabilityId?: string;
    duration?: number;
    durationExpression?: string | undefined;
    parentProcessStepId?: string | undefined;
    nodeTop?: number;
    nodeLeft?: number;
    nodeWidth?: number;
    nodeHeight?: number;
    nodeType?: string | undefined;
    nodeStyle?: string | undefined;
    nodeTextStyle?: string | undefined;
    displayName?: string | undefined;
    factors?: string[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class RiskFactorProcessStepModel implements IRiskFactorProcessStepModel {
    id?: string;
    name?: string | undefined;
    sortOrder?: number;
    riskFactorId?: string;
    processStepId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IRiskFactorProcessStepModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.riskFactorId = _data["riskFactorId"];
            this.processStepId = _data["processStepId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RiskFactorProcessStepModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskFactorProcessStepModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["riskFactorId"] = this.riskFactorId;
        data["processStepId"] = this.processStepId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): RiskFactorProcessStepModel {
        const json = this.toJSON();
        let result = new RiskFactorProcessStepModel();
        result.init(json);
        return result;
    }
}

export interface IRiskFactorProcessStepModel {
    id?: string;
    name?: string | undefined;
    sortOrder?: number;
    riskFactorId?: string;
    processStepId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum RiskAnalysisType {
    Full = 0,
    Limited = 1,
    FullV2 = 2,
    TACCP = 3,
}

export class RiskFactorRelationModel implements IRiskFactorRelationModel {
    id?: string;
    riskFactor?: RiskFactorModel | undefined;
    originalRiskFactorId?: string;
    sortOrder?: number;
    riskAnalysisId?: string;
    processStepRelationId?: string;
    processId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IRiskFactorRelationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.riskFactor = _data["riskFactor"] ? RiskFactorModel.fromJS(_data["riskFactor"]) : undefined as any;
            this.originalRiskFactorId = _data["originalRiskFactorId"];
            this.sortOrder = _data["sortOrder"];
            this.riskAnalysisId = _data["riskAnalysisId"];
            this.processStepRelationId = _data["processStepRelationId"];
            this.processId = _data["processId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RiskFactorRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskFactorRelationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["riskFactor"] = this.riskFactor ? this.riskFactor.toJSON() : undefined as any;
        data["originalRiskFactorId"] = this.originalRiskFactorId;
        data["sortOrder"] = this.sortOrder;
        data["riskAnalysisId"] = this.riskAnalysisId;
        data["processStepRelationId"] = this.processStepRelationId;
        data["processId"] = this.processId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): RiskFactorRelationModel {
        const json = this.toJSON();
        let result = new RiskFactorRelationModel();
        result.init(json);
        return result;
    }
}

export interface IRiskFactorRelationModel {
    id?: string;
    riskFactor?: RiskFactorModel | undefined;
    originalRiskFactorId?: string;
    sortOrder?: number;
    riskAnalysisId?: string;
    processStepRelationId?: string;
    processId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class RiskAnalysisLanguageModel implements IRiskAnalysisLanguageModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    language?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    riskFactorLanguages?: RiskFactorLanguageModel[] | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IRiskAnalysisLanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.language = _data["language"];
            this.responsibleUser = _data["responsibleUser"] ? IdNameModel.fromJS(_data["responsibleUser"]) : undefined as any;
            if (Array.isArray(_data["riskFactorLanguages"])) {
                this.riskFactorLanguages = [] as any;
                for (let item of _data["riskFactorLanguages"])
                    this.riskFactorLanguages!.push(RiskFactorLanguageModel.fromJS(item));
            }
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RiskAnalysisLanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskAnalysisLanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["language"] = this.language;
        data["responsibleUser"] = this.responsibleUser ? this.responsibleUser.toJSON() : undefined as any;
        if (Array.isArray(this.riskFactorLanguages)) {
            data["riskFactorLanguages"] = [];
            for (let item of this.riskFactorLanguages)
                data["riskFactorLanguages"].push(item ? item.toJSON() : undefined as any);
        }
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): RiskAnalysisLanguageModel {
        const json = this.toJSON();
        let result = new RiskAnalysisLanguageModel();
        result.init(json);
        return result;
    }
}

export interface IRiskAnalysisLanguageModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    language?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    riskFactorLanguages?: RiskFactorLanguageModel[] | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class RiskFactorLanguageModel implements IRiskFactorLanguageModel {
    id?: string;
    riskAnalysisId?: string;
    riskAnalysisLanguageId?: string;
    riskFactorId?: string;
    riskFactor?: RiskFactorModel | undefined;
    name?: string | undefined;
    cause?: string | undefined;
    controllingAction?: string | undefined;
    reasoning?: string | undefined;
    typeName?: string | undefined;
    ccpText?: string | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IRiskFactorLanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.riskAnalysisId = _data["riskAnalysisId"];
            this.riskAnalysisLanguageId = _data["riskAnalysisLanguageId"];
            this.riskFactorId = _data["riskFactorId"];
            this.riskFactor = _data["riskFactor"] ? RiskFactorModel.fromJS(_data["riskFactor"]) : undefined as any;
            this.name = _data["name"];
            this.cause = _data["cause"];
            this.controllingAction = _data["controllingAction"];
            this.reasoning = _data["reasoning"];
            this.typeName = _data["typeName"];
            this.ccpText = _data["ccpText"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RiskFactorLanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskFactorLanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["riskAnalysisId"] = this.riskAnalysisId;
        data["riskAnalysisLanguageId"] = this.riskAnalysisLanguageId;
        data["riskFactorId"] = this.riskFactorId;
        data["riskFactor"] = this.riskFactor ? this.riskFactor.toJSON() : undefined as any;
        data["name"] = this.name;
        data["cause"] = this.cause;
        data["controllingAction"] = this.controllingAction;
        data["reasoning"] = this.reasoning;
        data["typeName"] = this.typeName;
        data["ccpText"] = this.ccpText;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): RiskFactorLanguageModel {
        const json = this.toJSON();
        let result = new RiskFactorLanguageModel();
        result.init(json);
        return result;
    }
}

export interface IRiskFactorLanguageModel {
    id?: string;
    riskAnalysisId?: string;
    riskAnalysisLanguageId?: string;
    riskFactorId?: string;
    riskFactor?: RiskFactorModel | undefined;
    name?: string | undefined;
    cause?: string | undefined;
    controllingAction?: string | undefined;
    reasoning?: string | undefined;
    typeName?: string | undefined;
    ccpText?: string | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ProcedureModel implements IProcedureModel {
    id?: string;
    departmentId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    majorVersion?: number;
    minorVersion?: number;
    status?: DocumentRevisionStatus;
    designId?: string | undefined;
    approvalFlowId?: string;
    type?: number;
    language?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    procedureLanguages?: ProcedureLanguageModel[] | undefined;
    procedureSteps?: ProcedureStep[] | undefined;
    revision?: DocumentRevisionModel | undefined;
    documentVersion?: DocumentRevisionModel | undefined;
    procedureRelationSteps?: string[] | undefined;
    organizationId?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: IProcedureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.departmentId = _data["departmentId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
            this.status = _data["status"];
            this.designId = _data["designId"];
            this.approvalFlowId = _data["approvalFlowId"];
            this.type = _data["type"];
            this.language = _data["language"];
            this.responsibleUser = _data["responsibleUser"] ? IdNameModel.fromJS(_data["responsibleUser"]) : undefined as any;
            if (Array.isArray(_data["procedureLanguages"])) {
                this.procedureLanguages = [] as any;
                for (let item of _data["procedureLanguages"])
                    this.procedureLanguages!.push(ProcedureLanguageModel.fromJS(item));
            }
            if (Array.isArray(_data["procedureSteps"])) {
                this.procedureSteps = [] as any;
                for (let item of _data["procedureSteps"])
                    this.procedureSteps!.push(ProcedureStep.fromJS(item));
            }
            this.revision = _data["revision"] ? DocumentRevisionModel.fromJS(_data["revision"]) : undefined as any;
            this.documentVersion = _data["documentVersion"] ? DocumentRevisionModel.fromJS(_data["documentVersion"]) : undefined as any;
            if (Array.isArray(_data["procedureRelationSteps"])) {
                this.procedureRelationSteps = [] as any;
                for (let item of _data["procedureRelationSteps"])
                    this.procedureRelationSteps!.push(item);
            }
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProcedureModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["departmentId"] = this.departmentId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        data["status"] = this.status;
        data["designId"] = this.designId;
        data["approvalFlowId"] = this.approvalFlowId;
        data["type"] = this.type;
        data["language"] = this.language;
        data["responsibleUser"] = this.responsibleUser ? this.responsibleUser.toJSON() : undefined as any;
        if (Array.isArray(this.procedureLanguages)) {
            data["procedureLanguages"] = [];
            for (let item of this.procedureLanguages)
                data["procedureLanguages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.procedureSteps)) {
            data["procedureSteps"] = [];
            for (let item of this.procedureSteps)
                data["procedureSteps"].push(item ? item.toJSON() : undefined as any);
        }
        data["revision"] = this.revision ? this.revision.toJSON() : undefined as any;
        data["documentVersion"] = this.documentVersion ? this.documentVersion.toJSON() : undefined as any;
        if (Array.isArray(this.procedureRelationSteps)) {
            data["procedureRelationSteps"] = [];
            for (let item of this.procedureRelationSteps)
                data["procedureRelationSteps"].push(item);
        }
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ProcedureModel {
        const json = this.toJSON();
        let result = new ProcedureModel();
        result.init(json);
        return result;
    }
}

export interface IProcedureModel {
    id?: string;
    departmentId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    majorVersion?: number;
    minorVersion?: number;
    status?: DocumentRevisionStatus;
    designId?: string | undefined;
    approvalFlowId?: string;
    type?: number;
    language?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    procedureLanguages?: ProcedureLanguageModel[] | undefined;
    procedureSteps?: ProcedureStep[] | undefined;
    revision?: DocumentRevisionModel | undefined;
    documentVersion?: DocumentRevisionModel | undefined;
    procedureRelationSteps?: string[] | undefined;
    organizationId?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
}

export class ProcedureLanguageModel implements IProcedureLanguageModel {
    id?: string;
    procedureId?: string;
    name?: string | undefined;
    description?: string | undefined;
    responsibleUserId?: string;
    language?: string | undefined;
    status?: DocumentRevisionStatus;
    procedureStepLanguages?: ProcedureStepLanguageModel[] | undefined;

    constructor(data?: IProcedureLanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.procedureId = _data["procedureId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.language = _data["language"];
            this.status = _data["status"];
            if (Array.isArray(_data["procedureStepLanguages"])) {
                this.procedureStepLanguages = [] as any;
                for (let item of _data["procedureStepLanguages"])
                    this.procedureStepLanguages!.push(ProcedureStepLanguageModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcedureLanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureLanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["procedureId"] = this.procedureId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["responsibleUserId"] = this.responsibleUserId;
        data["language"] = this.language;
        data["status"] = this.status;
        if (Array.isArray(this.procedureStepLanguages)) {
            data["procedureStepLanguages"] = [];
            for (let item of this.procedureStepLanguages)
                data["procedureStepLanguages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ProcedureLanguageModel {
        const json = this.toJSON();
        let result = new ProcedureLanguageModel();
        result.init(json);
        return result;
    }
}

export interface IProcedureLanguageModel {
    id?: string;
    procedureId?: string;
    name?: string | undefined;
    description?: string | undefined;
    responsibleUserId?: string;
    language?: string | undefined;
    status?: DocumentRevisionStatus;
    procedureStepLanguages?: ProcedureStepLanguageModel[] | undefined;
}

export class ProcedureStepLanguageModel implements IProcedureStepLanguageModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    procedureId?: string;
    procedureLanguageId?: string | undefined;
    procedureStepId?: string | undefined;
    procedureStep?: ProcedureStepModel | undefined;
    status?: number;

    constructor(data?: IProcedureStepLanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.procedureId = _data["procedureId"];
            this.procedureLanguageId = _data["procedureLanguageId"];
            this.procedureStepId = _data["procedureStepId"];
            this.procedureStep = _data["procedureStep"] ? ProcedureStepModel.fromJS(_data["procedureStep"]) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProcedureStepLanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureStepLanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["procedureId"] = this.procedureId;
        data["procedureLanguageId"] = this.procedureLanguageId;
        data["procedureStepId"] = this.procedureStepId;
        data["procedureStep"] = this.procedureStep ? this.procedureStep.toJSON() : undefined as any;
        data["status"] = this.status;
        return data;
    }

    clone(): ProcedureStepLanguageModel {
        const json = this.toJSON();
        let result = new ProcedureStepLanguageModel();
        result.init(json);
        return result;
    }
}

export interface IProcedureStepLanguageModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    procedureId?: string;
    procedureLanguageId?: string | undefined;
    procedureStepId?: string | undefined;
    procedureStep?: ProcedureStepModel | undefined;
    status?: number;
}

export class ProcedureStepModel implements IProcedureStepModel {
    id?: string | undefined;
    analysisId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    procedureId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IProcedureStepModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.analysisId = _data["analysisId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.procedureId = _data["procedureId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProcedureStepModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureStepModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["analysisId"] = this.analysisId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["procedureId"] = this.procedureId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ProcedureStepModel {
        const json = this.toJSON();
        let result = new ProcedureStepModel();
        result.init(json);
        return result;
    }
}

export interface IProcedureStepModel {
    id?: string | undefined;
    analysisId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    procedureId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class VersionedEntity extends BaseEntity implements IVersionedEntity {
    originalId?: string;
    documentVersionId?: string;
    documentApprovalId?: string;

    constructor(data?: IVersionedEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.originalId = _data["originalId"];
            this.documentVersionId = _data["documentVersionId"];
            this.documentApprovalId = _data["documentApprovalId"];
        }
    }

    static override fromJS(data: any): VersionedEntity {
        data = typeof data === 'object' ? data : {};
        let result = new VersionedEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalId"] = this.originalId;
        data["documentVersionId"] = this.documentVersionId;
        data["documentApprovalId"] = this.documentApprovalId;
        super.toJSON(data);
        return data;
    }

    clone(): VersionedEntity {
        const json = this.toJSON();
        let result = new VersionedEntity();
        result.init(json);
        return result;
    }
}

export interface IVersionedEntity extends IBaseEntity {
    originalId?: string;
    documentVersionId?: string;
    documentApprovalId?: string;
}

export class ProcedureStep extends VersionedEntity implements IProcedureStep {
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    procedureId?: string;

    constructor(data?: IProcedureStep) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.procedureId = _data["procedureId"];
        }
    }

    static override fromJS(data: any): ProcedureStep {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureStep();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["procedureId"] = this.procedureId;
        super.toJSON(data);
        return data;
    }

    clone(): ProcedureStep {
        const json = this.toJSON();
        let result = new ProcedureStep();
        result.init(json);
        return result;
    }
}

export interface IProcedureStep extends IVersionedEntity {
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    procedureId?: string;
}

export class ForecastModel implements IForecastModel {
    id?: string;
    userId?: string;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    forecastType?: ForecastType;
    forecastStatus?: ForecastStatus;
    forecastPeriodType?: ForecastPeriodType;
    forecastLines?: ForecastLineModel[] | undefined;

    constructor(data?: IForecastModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.forecastType = _data["forecastType"];
            this.forecastStatus = _data["forecastStatus"];
            this.forecastPeriodType = _data["forecastPeriodType"];
            if (Array.isArray(_data["forecastLines"])) {
                this.forecastLines = [] as any;
                for (let item of _data["forecastLines"])
                    this.forecastLines!.push(ForecastLineModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ForecastModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["forecastType"] = this.forecastType;
        data["forecastStatus"] = this.forecastStatus;
        data["forecastPeriodType"] = this.forecastPeriodType;
        if (Array.isArray(this.forecastLines)) {
            data["forecastLines"] = [];
            for (let item of this.forecastLines)
                data["forecastLines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ForecastModel {
        const json = this.toJSON();
        let result = new ForecastModel();
        result.init(json);
        return result;
    }
}

export interface IForecastModel {
    id?: string;
    userId?: string;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    forecastType?: ForecastType;
    forecastStatus?: ForecastStatus;
    forecastPeriodType?: ForecastPeriodType;
    forecastLines?: ForecastLineModel[] | undefined;
}

export enum ForecastType {
    Forecast = 1,
    Budget = 2,
    Actual = 3,
}

export enum ForecastStatus {
    Draft = 1,
    Submitted = 2,
    Approved = 3,
}

export enum ForecastPeriodType {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
    Quarterly = 4,
    Yearly = 5,
}

export class ForecastLineModel implements IForecastLineModel {
    id?: string;
    userId?: string;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    forecastId?: string;
    forecastLevel?: ForecastLevel;
    productGroupId?: string | undefined;
    productVariantId?: string | undefined;
    productVariantName?: string | undefined;
    customerGroupId?: string | undefined;
    customerId?: string | undefined;
    productGroup?: ProductGroupModel | undefined;
    customer?: CustomerModel | undefined;
    customerGroup?: CustomerGroupModel | undefined;
    forecastItems?: ForecastItemModel[] | undefined;

    constructor(data?: IForecastLineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.forecastId = _data["forecastId"];
            this.forecastLevel = _data["forecastLevel"];
            this.productGroupId = _data["productGroupId"];
            this.productVariantId = _data["productVariantId"];
            this.productVariantName = _data["productVariantName"];
            this.customerGroupId = _data["customerGroupId"];
            this.customerId = _data["customerId"];
            this.productGroup = _data["productGroup"] ? ProductGroupModel.fromJS(_data["productGroup"]) : undefined as any;
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : undefined as any;
            this.customerGroup = _data["customerGroup"] ? CustomerGroupModel.fromJS(_data["customerGroup"]) : undefined as any;
            if (Array.isArray(_data["forecastItems"])) {
                this.forecastItems = [] as any;
                for (let item of _data["forecastItems"])
                    this.forecastItems!.push(ForecastItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ForecastLineModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastLineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["forecastId"] = this.forecastId;
        data["forecastLevel"] = this.forecastLevel;
        data["productGroupId"] = this.productGroupId;
        data["productVariantId"] = this.productVariantId;
        data["productVariantName"] = this.productVariantName;
        data["customerGroupId"] = this.customerGroupId;
        data["customerId"] = this.customerId;
        data["productGroup"] = this.productGroup ? this.productGroup.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["customerGroup"] = this.customerGroup ? this.customerGroup.toJSON() : undefined as any;
        if (Array.isArray(this.forecastItems)) {
            data["forecastItems"] = [];
            for (let item of this.forecastItems)
                data["forecastItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ForecastLineModel {
        const json = this.toJSON();
        let result = new ForecastLineModel();
        result.init(json);
        return result;
    }
}

export interface IForecastLineModel {
    id?: string;
    userId?: string;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    forecastId?: string;
    forecastLevel?: ForecastLevel;
    productGroupId?: string | undefined;
    productVariantId?: string | undefined;
    productVariantName?: string | undefined;
    customerGroupId?: string | undefined;
    customerId?: string | undefined;
    productGroup?: ProductGroupModel | undefined;
    customer?: CustomerModel | undefined;
    customerGroup?: CustomerGroupModel | undefined;
    forecastItems?: ForecastItemModel[] | undefined;
}

export enum ForecastLevel {
    ProductGroup = 1,
    Product = 2,
    CustomerGroup = 3,
    Customer = 4,
    Total = 5,
}

export class ProductGroupModel implements IProductGroupModel {
    id?: string;
    name?: string | undefined;
    groupNumber?: string | undefined;
    stockLocationId?: string | undefined;
    isDefault?: boolean;
    isHidden?: boolean;
    groupType?: number;
    noSync?: boolean;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    orderDeadline?: string | undefined;

    constructor(data?: IProductGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.groupNumber = _data["groupNumber"];
            this.stockLocationId = _data["stockLocationId"];
            this.isDefault = _data["isDefault"];
            this.isHidden = _data["isHidden"];
            this.groupType = _data["groupType"];
            this.noSync = _data["noSync"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.orderDeadline = _data["orderDeadline"];
        }
    }

    static fromJS(data: any): ProductGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["groupNumber"] = this.groupNumber;
        data["stockLocationId"] = this.stockLocationId;
        data["isDefault"] = this.isDefault;
        data["isHidden"] = this.isHidden;
        data["groupType"] = this.groupType;
        data["noSync"] = this.noSync;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["orderDeadline"] = this.orderDeadline;
        return data;
    }

    clone(): ProductGroupModel {
        const json = this.toJSON();
        let result = new ProductGroupModel();
        result.init(json);
        return result;
    }
}

export interface IProductGroupModel {
    id?: string;
    name?: string | undefined;
    groupNumber?: string | undefined;
    stockLocationId?: string | undefined;
    isDefault?: boolean;
    isHidden?: boolean;
    groupType?: number;
    noSync?: boolean;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    orderDeadline?: string | undefined;
}

export class ForecastItemModel implements IForecastItemModel {
    id?: string;
    userId?: string;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    forecastLineId?: string;
    startDate?: Date;
    quantity?: number;

    constructor(data?: IForecastItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.forecastLineId = _data["forecastLineId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ForecastItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["forecastLineId"] = this.forecastLineId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): ForecastItemModel {
        const json = this.toJSON();
        let result = new ForecastItemModel();
        result.init(json);
        return result;
    }
}

export interface IForecastItemModel {
    id?: string;
    userId?: string;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    forecastLineId?: string;
    startDate?: Date;
    quantity?: number;
}

export class ForecastGridRow implements IForecastGridRow {
    id?: string;
    forecastId?: string | undefined;
    productVariantId?: string | undefined;
    customerGroupId?: string | undefined;
    customerId?: string | undefined;
    productGroupId?: string | undefined;
    forecastLevel?: ForecastLevel | undefined;
    productSKU?: string | undefined;
    productVariantName?: string | undefined;
    customerName?: string | undefined;
    isDeleted?: boolean;
    forecastQuantities?: { [key: string]: number; } | undefined;

    constructor(data?: IForecastGridRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.forecastId = _data["forecastId"];
            this.productVariantId = _data["productVariantId"];
            this.customerGroupId = _data["customerGroupId"];
            this.customerId = _data["customerId"];
            this.productGroupId = _data["productGroupId"];
            this.forecastLevel = _data["forecastLevel"];
            this.productSKU = _data["productSKU"];
            this.productVariantName = _data["productVariantName"];
            this.customerName = _data["customerName"];
            this.isDeleted = _data["isDeleted"];
            if (_data["forecastQuantities"]) {
                this.forecastQuantities = {} as any;
                for (let key in _data["forecastQuantities"]) {
                    if (_data["forecastQuantities"].hasOwnProperty(key))
                        (this.forecastQuantities as any)![key] = _data["forecastQuantities"][key];
                }
            }
        }
    }

    static fromJS(data: any): ForecastGridRow {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastGridRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["forecastId"] = this.forecastId;
        data["productVariantId"] = this.productVariantId;
        data["customerGroupId"] = this.customerGroupId;
        data["customerId"] = this.customerId;
        data["productGroupId"] = this.productGroupId;
        data["forecastLevel"] = this.forecastLevel;
        data["productSKU"] = this.productSKU;
        data["productVariantName"] = this.productVariantName;
        data["customerName"] = this.customerName;
        data["isDeleted"] = this.isDeleted;
        if (this.forecastQuantities) {
            data["forecastQuantities"] = {};
            for (let key in this.forecastQuantities) {
                if (this.forecastQuantities.hasOwnProperty(key))
                    (data["forecastQuantities"] as any)[key] = (this.forecastQuantities as any)[key];
            }
        }
        return data;
    }

    clone(): ForecastGridRow {
        const json = this.toJSON();
        let result = new ForecastGridRow();
        result.init(json);
        return result;
    }
}

export interface IForecastGridRow {
    id?: string;
    forecastId?: string | undefined;
    productVariantId?: string | undefined;
    customerGroupId?: string | undefined;
    customerId?: string | undefined;
    productGroupId?: string | undefined;
    forecastLevel?: ForecastLevel | undefined;
    productSKU?: string | undefined;
    productVariantName?: string | undefined;
    customerName?: string | undefined;
    isDeleted?: boolean;
    forecastQuantities?: { [key: string]: number; } | undefined;
}

export class ForecastDatasource implements IForecastDatasource {
    id?: string;
    title?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    forecastType?: ForecastType;
    forecastStatus?: ForecastStatus;
    forecastPeriodType?: ForecastPeriodType;
    items?: ForecastItemDatasource[] | undefined;

    constructor(data?: IForecastDatasource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.forecastType = _data["forecastType"];
            this.forecastStatus = _data["forecastStatus"];
            this.forecastPeriodType = _data["forecastPeriodType"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ForecastItemDatasource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ForecastDatasource {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastDatasource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["forecastType"] = this.forecastType;
        data["forecastStatus"] = this.forecastStatus;
        data["forecastPeriodType"] = this.forecastPeriodType;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ForecastDatasource {
        const json = this.toJSON();
        let result = new ForecastDatasource();
        result.init(json);
        return result;
    }
}

export interface IForecastDatasource {
    id?: string;
    title?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    forecastType?: ForecastType;
    forecastStatus?: ForecastStatus;
    forecastPeriodType?: ForecastPeriodType;
    items?: ForecastItemDatasource[] | undefined;
}

export class ForecastItemDatasource implements IForecastItemDatasource {
    id?: string;
    forecastId?: string;
    startDate?: Date;
    forecastLevel?: ForecastLevel | undefined;
    costPrice?: number | undefined;
    salesPrice?: number | undefined;
    quantity?: number | undefined;
    sku?: string | undefined;
    productGroupId?: string | undefined;
    productGroupName?: string | undefined;
    productVariantId?: string | undefined;
    productVariantName?: string | undefined;
    customerGroupId?: string | undefined;
    customerGroupName?: string | undefined;
    customerId?: string | undefined;
    customerName?: string | undefined;

    constructor(data?: IForecastItemDatasource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.forecastId = _data["forecastId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.forecastLevel = _data["forecastLevel"];
            this.costPrice = _data["costPrice"];
            this.salesPrice = _data["salesPrice"];
            this.quantity = _data["quantity"];
            this.sku = _data["sku"];
            this.productGroupId = _data["productGroupId"];
            this.productGroupName = _data["productGroupName"];
            this.productVariantId = _data["productVariantId"];
            this.productVariantName = _data["productVariantName"];
            this.customerGroupId = _data["customerGroupId"];
            this.customerGroupName = _data["customerGroupName"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
        }
    }

    static fromJS(data: any): ForecastItemDatasource {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastItemDatasource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["forecastId"] = this.forecastId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["forecastLevel"] = this.forecastLevel;
        data["costPrice"] = this.costPrice;
        data["salesPrice"] = this.salesPrice;
        data["quantity"] = this.quantity;
        data["sku"] = this.sku;
        data["productGroupId"] = this.productGroupId;
        data["productGroupName"] = this.productGroupName;
        data["productVariantId"] = this.productVariantId;
        data["productVariantName"] = this.productVariantName;
        data["customerGroupId"] = this.customerGroupId;
        data["customerGroupName"] = this.customerGroupName;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        return data;
    }

    clone(): ForecastItemDatasource {
        const json = this.toJSON();
        let result = new ForecastItemDatasource();
        result.init(json);
        return result;
    }
}

export interface IForecastItemDatasource {
    id?: string;
    forecastId?: string;
    startDate?: Date;
    forecastLevel?: ForecastLevel | undefined;
    costPrice?: number | undefined;
    salesPrice?: number | undefined;
    quantity?: number | undefined;
    sku?: string | undefined;
    productGroupId?: string | undefined;
    productGroupName?: string | undefined;
    productVariantId?: string | undefined;
    productVariantName?: string | undefined;
    customerGroupId?: string | undefined;
    customerGroupName?: string | undefined;
    customerId?: string | undefined;
    customerName?: string | undefined;
}

export class GroupRelationModel implements IGroupRelationModel {
    id?: string;
    type?: number;
    groupId?: string;
    groupName?: string | undefined;
    entityId?: string;
    sortOrder?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IGroupRelationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.entityId = _data["entityId"];
            this.sortOrder = _data["sortOrder"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GroupRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupRelationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["entityId"] = this.entityId;
        data["sortOrder"] = this.sortOrder;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): GroupRelationModel {
        const json = this.toJSON();
        let result = new GroupRelationModel();
        result.init(json);
        return result;
    }
}

export interface IGroupRelationModel {
    id?: string;
    type?: number;
    groupId?: string;
    groupName?: string | undefined;
    entityId?: string;
    sortOrder?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ShopifyOrderModel implements IShopifyOrderModel {
    id?: number | undefined;
    admin_graphql_api_id?: string | undefined;
    app_id?: any | undefined;
    browser_ip?: any | undefined;
    buyer_accepts_marketing?: boolean | undefined;
    cancel_reason?: string | undefined;
    cancelled_at?: Date | undefined;
    cart_token?: any | undefined;
    checkout_id?: any | undefined;
    checkout_token?: any | undefined;
    client_details?: any | undefined;
    closed_at?: any | undefined;
    confirmed?: boolean | undefined;
    contact_email?: string | undefined;
    created_at?: Date | undefined;
    currency?: string | undefined;
    current_subtotal_price?: string | undefined;
    current_subtotal_price_set?: CurrentSubtotalPriceSet | undefined;
    current_total_additional_fees_set?: any | undefined;
    current_total_discounts?: string | undefined;
    current_total_discounts_set?: CurrentTotalDiscountsSet | undefined;
    current_total_duties_set?: any | undefined;
    current_total_price?: string | undefined;
    current_total_price_set?: CurrentTotalPriceSet | undefined;
    current_total_tax?: string | undefined;
    current_total_tax_set?: CurrentTotalTaxSet | undefined;
    customer_locale?: string | undefined;
    device_id?: any | undefined;
    discount_codes?: any[] | undefined;
    email?: string | undefined;
    estimated_taxes?: boolean | undefined;
    financial_status?: string | undefined;
    fulfillment_status?: string | undefined;
    landing_site?: any | undefined;
    landing_site_ref?: any | undefined;
    location_id?: any | undefined;
    merchant_of_record_app_id?: any | undefined;
    name?: string | undefined;
    note?: any | undefined;
    note_attributes?: any[] | undefined;
    number?: number | undefined;
    order_number?: number | undefined;
    order_status_url?: string | undefined;
    original_total_additional_fees_set?: any | undefined;
    original_total_duties_set?: any | undefined;
    payment_gateway_names?: string[] | undefined;
    phone?: any | undefined;
    po_number?: any | undefined;
    presentment_currency?: string | undefined;
    processed_at?: any | undefined;
    reference?: any | undefined;
    referring_site?: any | undefined;
    source_identifier?: any | undefined;
    source_name?: string | undefined;
    source_url?: any | undefined;
    subtotal_price?: string | undefined;
    subtotal_price_set?: SubtotalPriceSet | undefined;
    tags?: string | undefined;
    tax_lines?: any[] | undefined;
    taxes_included?: boolean | undefined;
    test?: boolean | undefined;
    token?: string | undefined;
    total_discounts?: string | undefined;
    total_discounts_set?: TotalDiscountsSet | undefined;
    total_line_items_price?: string | undefined;
    total_line_items_price_set?: TotalLineItemsPriceSet | undefined;
    total_outstanding?: string | undefined;
    total_price?: string | undefined;
    total_price_set?: TotalPriceSet | undefined;
    total_shipping_price_set?: TotalShippingPriceSet | undefined;
    total_tax?: string | undefined;
    total_tax_set?: TotalTaxSet | undefined;
    total_tip_received?: string | undefined;
    total_weight?: number | undefined;
    updated_at?: Date | undefined;
    user_id?: any | undefined;
    billing_address?: BillingAddress | undefined;
    customer?: Customer | undefined;
    discount_applications?: any[] | undefined;
    fulfillments?: any[] | undefined;
    line_items?: LineItem[] | undefined;
    payment_terms?: any | undefined;
    refunds?: any[] | undefined;
    shipping_address?: ShippingAddress | undefined;
    shipping_lines?: ShippingLine[] | undefined;

    constructor(data?: IShopifyOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.admin_graphql_api_id = _data["admin_graphql_api_id"];
            this.app_id = _data["app_id"];
            this.browser_ip = _data["browser_ip"];
            this.buyer_accepts_marketing = _data["buyer_accepts_marketing"];
            this.cancel_reason = _data["cancel_reason"];
            this.cancelled_at = _data["cancelled_at"] ? new Date(_data["cancelled_at"].toString()) : undefined as any;
            this.cart_token = _data["cart_token"];
            this.checkout_id = _data["checkout_id"];
            this.checkout_token = _data["checkout_token"];
            this.client_details = _data["client_details"];
            this.closed_at = _data["closed_at"];
            this.confirmed = _data["confirmed"];
            this.contact_email = _data["contact_email"];
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : undefined as any;
            this.currency = _data["currency"];
            this.current_subtotal_price = _data["current_subtotal_price"];
            this.current_subtotal_price_set = _data["current_subtotal_price_set"] ? CurrentSubtotalPriceSet.fromJS(_data["current_subtotal_price_set"]) : undefined as any;
            this.current_total_additional_fees_set = _data["current_total_additional_fees_set"];
            this.current_total_discounts = _data["current_total_discounts"];
            this.current_total_discounts_set = _data["current_total_discounts_set"] ? CurrentTotalDiscountsSet.fromJS(_data["current_total_discounts_set"]) : undefined as any;
            this.current_total_duties_set = _data["current_total_duties_set"];
            this.current_total_price = _data["current_total_price"];
            this.current_total_price_set = _data["current_total_price_set"] ? CurrentTotalPriceSet.fromJS(_data["current_total_price_set"]) : undefined as any;
            this.current_total_tax = _data["current_total_tax"];
            this.current_total_tax_set = _data["current_total_tax_set"] ? CurrentTotalTaxSet.fromJS(_data["current_total_tax_set"]) : undefined as any;
            this.customer_locale = _data["customer_locale"];
            this.device_id = _data["device_id"];
            if (Array.isArray(_data["discount_codes"])) {
                this.discount_codes = [] as any;
                for (let item of _data["discount_codes"])
                    this.discount_codes!.push(item);
            }
            this.email = _data["email"];
            this.estimated_taxes = _data["estimated_taxes"];
            this.financial_status = _data["financial_status"];
            this.fulfillment_status = _data["fulfillment_status"];
            this.landing_site = _data["landing_site"];
            this.landing_site_ref = _data["landing_site_ref"];
            this.location_id = _data["location_id"];
            this.merchant_of_record_app_id = _data["merchant_of_record_app_id"];
            this.name = _data["name"];
            this.note = _data["note"];
            if (Array.isArray(_data["note_attributes"])) {
                this.note_attributes = [] as any;
                for (let item of _data["note_attributes"])
                    this.note_attributes!.push(item);
            }
            this.number = _data["number"];
            this.order_number = _data["order_number"];
            this.order_status_url = _data["order_status_url"];
            this.original_total_additional_fees_set = _data["original_total_additional_fees_set"];
            this.original_total_duties_set = _data["original_total_duties_set"];
            if (Array.isArray(_data["payment_gateway_names"])) {
                this.payment_gateway_names = [] as any;
                for (let item of _data["payment_gateway_names"])
                    this.payment_gateway_names!.push(item);
            }
            this.phone = _data["phone"];
            this.po_number = _data["po_number"];
            this.presentment_currency = _data["presentment_currency"];
            this.processed_at = _data["processed_at"];
            this.reference = _data["reference"];
            this.referring_site = _data["referring_site"];
            this.source_identifier = _data["source_identifier"];
            this.source_name = _data["source_name"];
            this.source_url = _data["source_url"];
            this.subtotal_price = _data["subtotal_price"];
            this.subtotal_price_set = _data["subtotal_price_set"] ? SubtotalPriceSet.fromJS(_data["subtotal_price_set"]) : undefined as any;
            this.tags = _data["tags"];
            if (Array.isArray(_data["tax_lines"])) {
                this.tax_lines = [] as any;
                for (let item of _data["tax_lines"])
                    this.tax_lines!.push(item);
            }
            this.taxes_included = _data["taxes_included"];
            this.test = _data["test"];
            this.token = _data["token"];
            this.total_discounts = _data["total_discounts"];
            this.total_discounts_set = _data["total_discounts_set"] ? TotalDiscountsSet.fromJS(_data["total_discounts_set"]) : undefined as any;
            this.total_line_items_price = _data["total_line_items_price"];
            this.total_line_items_price_set = _data["total_line_items_price_set"] ? TotalLineItemsPriceSet.fromJS(_data["total_line_items_price_set"]) : undefined as any;
            this.total_outstanding = _data["total_outstanding"];
            this.total_price = _data["total_price"];
            this.total_price_set = _data["total_price_set"] ? TotalPriceSet.fromJS(_data["total_price_set"]) : undefined as any;
            this.total_shipping_price_set = _data["total_shipping_price_set"] ? TotalShippingPriceSet.fromJS(_data["total_shipping_price_set"]) : undefined as any;
            this.total_tax = _data["total_tax"];
            this.total_tax_set = _data["total_tax_set"] ? TotalTaxSet.fromJS(_data["total_tax_set"]) : undefined as any;
            this.total_tip_received = _data["total_tip_received"];
            this.total_weight = _data["total_weight"];
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : undefined as any;
            this.user_id = _data["user_id"];
            this.billing_address = _data["billing_address"] ? BillingAddress.fromJS(_data["billing_address"]) : undefined as any;
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined as any;
            if (Array.isArray(_data["discount_applications"])) {
                this.discount_applications = [] as any;
                for (let item of _data["discount_applications"])
                    this.discount_applications!.push(item);
            }
            if (Array.isArray(_data["fulfillments"])) {
                this.fulfillments = [] as any;
                for (let item of _data["fulfillments"])
                    this.fulfillments!.push(item);
            }
            if (Array.isArray(_data["line_items"])) {
                this.line_items = [] as any;
                for (let item of _data["line_items"])
                    this.line_items!.push(LineItem.fromJS(item));
            }
            this.payment_terms = _data["payment_terms"];
            if (Array.isArray(_data["refunds"])) {
                this.refunds = [] as any;
                for (let item of _data["refunds"])
                    this.refunds!.push(item);
            }
            this.shipping_address = _data["shipping_address"] ? ShippingAddress.fromJS(_data["shipping_address"]) : undefined as any;
            if (Array.isArray(_data["shipping_lines"])) {
                this.shipping_lines = [] as any;
                for (let item of _data["shipping_lines"])
                    this.shipping_lines!.push(ShippingLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShopifyOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShopifyOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["admin_graphql_api_id"] = this.admin_graphql_api_id;
        data["app_id"] = this.app_id;
        data["browser_ip"] = this.browser_ip;
        data["buyer_accepts_marketing"] = this.buyer_accepts_marketing;
        data["cancel_reason"] = this.cancel_reason;
        data["cancelled_at"] = this.cancelled_at ? this.cancelled_at.toISOString() : undefined as any;
        data["cart_token"] = this.cart_token;
        data["checkout_id"] = this.checkout_id;
        data["checkout_token"] = this.checkout_token;
        data["client_details"] = this.client_details;
        data["closed_at"] = this.closed_at;
        data["confirmed"] = this.confirmed;
        data["contact_email"] = this.contact_email;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : undefined as any;
        data["currency"] = this.currency;
        data["current_subtotal_price"] = this.current_subtotal_price;
        data["current_subtotal_price_set"] = this.current_subtotal_price_set ? this.current_subtotal_price_set.toJSON() : undefined as any;
        data["current_total_additional_fees_set"] = this.current_total_additional_fees_set;
        data["current_total_discounts"] = this.current_total_discounts;
        data["current_total_discounts_set"] = this.current_total_discounts_set ? this.current_total_discounts_set.toJSON() : undefined as any;
        data["current_total_duties_set"] = this.current_total_duties_set;
        data["current_total_price"] = this.current_total_price;
        data["current_total_price_set"] = this.current_total_price_set ? this.current_total_price_set.toJSON() : undefined as any;
        data["current_total_tax"] = this.current_total_tax;
        data["current_total_tax_set"] = this.current_total_tax_set ? this.current_total_tax_set.toJSON() : undefined as any;
        data["customer_locale"] = this.customer_locale;
        data["device_id"] = this.device_id;
        if (Array.isArray(this.discount_codes)) {
            data["discount_codes"] = [];
            for (let item of this.discount_codes)
                data["discount_codes"].push(item);
        }
        data["email"] = this.email;
        data["estimated_taxes"] = this.estimated_taxes;
        data["financial_status"] = this.financial_status;
        data["fulfillment_status"] = this.fulfillment_status;
        data["landing_site"] = this.landing_site;
        data["landing_site_ref"] = this.landing_site_ref;
        data["location_id"] = this.location_id;
        data["merchant_of_record_app_id"] = this.merchant_of_record_app_id;
        data["name"] = this.name;
        data["note"] = this.note;
        if (Array.isArray(this.note_attributes)) {
            data["note_attributes"] = [];
            for (let item of this.note_attributes)
                data["note_attributes"].push(item);
        }
        data["number"] = this.number;
        data["order_number"] = this.order_number;
        data["order_status_url"] = this.order_status_url;
        data["original_total_additional_fees_set"] = this.original_total_additional_fees_set;
        data["original_total_duties_set"] = this.original_total_duties_set;
        if (Array.isArray(this.payment_gateway_names)) {
            data["payment_gateway_names"] = [];
            for (let item of this.payment_gateway_names)
                data["payment_gateway_names"].push(item);
        }
        data["phone"] = this.phone;
        data["po_number"] = this.po_number;
        data["presentment_currency"] = this.presentment_currency;
        data["processed_at"] = this.processed_at;
        data["reference"] = this.reference;
        data["referring_site"] = this.referring_site;
        data["source_identifier"] = this.source_identifier;
        data["source_name"] = this.source_name;
        data["source_url"] = this.source_url;
        data["subtotal_price"] = this.subtotal_price;
        data["subtotal_price_set"] = this.subtotal_price_set ? this.subtotal_price_set.toJSON() : undefined as any;
        data["tags"] = this.tags;
        if (Array.isArray(this.tax_lines)) {
            data["tax_lines"] = [];
            for (let item of this.tax_lines)
                data["tax_lines"].push(item);
        }
        data["taxes_included"] = this.taxes_included;
        data["test"] = this.test;
        data["token"] = this.token;
        data["total_discounts"] = this.total_discounts;
        data["total_discounts_set"] = this.total_discounts_set ? this.total_discounts_set.toJSON() : undefined as any;
        data["total_line_items_price"] = this.total_line_items_price;
        data["total_line_items_price_set"] = this.total_line_items_price_set ? this.total_line_items_price_set.toJSON() : undefined as any;
        data["total_outstanding"] = this.total_outstanding;
        data["total_price"] = this.total_price;
        data["total_price_set"] = this.total_price_set ? this.total_price_set.toJSON() : undefined as any;
        data["total_shipping_price_set"] = this.total_shipping_price_set ? this.total_shipping_price_set.toJSON() : undefined as any;
        data["total_tax"] = this.total_tax;
        data["total_tax_set"] = this.total_tax_set ? this.total_tax_set.toJSON() : undefined as any;
        data["total_tip_received"] = this.total_tip_received;
        data["total_weight"] = this.total_weight;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : undefined as any;
        data["user_id"] = this.user_id;
        data["billing_address"] = this.billing_address ? this.billing_address.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        if (Array.isArray(this.discount_applications)) {
            data["discount_applications"] = [];
            for (let item of this.discount_applications)
                data["discount_applications"].push(item);
        }
        if (Array.isArray(this.fulfillments)) {
            data["fulfillments"] = [];
            for (let item of this.fulfillments)
                data["fulfillments"].push(item);
        }
        if (Array.isArray(this.line_items)) {
            data["line_items"] = [];
            for (let item of this.line_items)
                data["line_items"].push(item ? item.toJSON() : undefined as any);
        }
        data["payment_terms"] = this.payment_terms;
        if (Array.isArray(this.refunds)) {
            data["refunds"] = [];
            for (let item of this.refunds)
                data["refunds"].push(item);
        }
        data["shipping_address"] = this.shipping_address ? this.shipping_address.toJSON() : undefined as any;
        if (Array.isArray(this.shipping_lines)) {
            data["shipping_lines"] = [];
            for (let item of this.shipping_lines)
                data["shipping_lines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ShopifyOrderModel {
        const json = this.toJSON();
        let result = new ShopifyOrderModel();
        result.init(json);
        return result;
    }
}

export interface IShopifyOrderModel {
    id?: number | undefined;
    admin_graphql_api_id?: string | undefined;
    app_id?: any | undefined;
    browser_ip?: any | undefined;
    buyer_accepts_marketing?: boolean | undefined;
    cancel_reason?: string | undefined;
    cancelled_at?: Date | undefined;
    cart_token?: any | undefined;
    checkout_id?: any | undefined;
    checkout_token?: any | undefined;
    client_details?: any | undefined;
    closed_at?: any | undefined;
    confirmed?: boolean | undefined;
    contact_email?: string | undefined;
    created_at?: Date | undefined;
    currency?: string | undefined;
    current_subtotal_price?: string | undefined;
    current_subtotal_price_set?: CurrentSubtotalPriceSet | undefined;
    current_total_additional_fees_set?: any | undefined;
    current_total_discounts?: string | undefined;
    current_total_discounts_set?: CurrentTotalDiscountsSet | undefined;
    current_total_duties_set?: any | undefined;
    current_total_price?: string | undefined;
    current_total_price_set?: CurrentTotalPriceSet | undefined;
    current_total_tax?: string | undefined;
    current_total_tax_set?: CurrentTotalTaxSet | undefined;
    customer_locale?: string | undefined;
    device_id?: any | undefined;
    discount_codes?: any[] | undefined;
    email?: string | undefined;
    estimated_taxes?: boolean | undefined;
    financial_status?: string | undefined;
    fulfillment_status?: string | undefined;
    landing_site?: any | undefined;
    landing_site_ref?: any | undefined;
    location_id?: any | undefined;
    merchant_of_record_app_id?: any | undefined;
    name?: string | undefined;
    note?: any | undefined;
    note_attributes?: any[] | undefined;
    number?: number | undefined;
    order_number?: number | undefined;
    order_status_url?: string | undefined;
    original_total_additional_fees_set?: any | undefined;
    original_total_duties_set?: any | undefined;
    payment_gateway_names?: string[] | undefined;
    phone?: any | undefined;
    po_number?: any | undefined;
    presentment_currency?: string | undefined;
    processed_at?: any | undefined;
    reference?: any | undefined;
    referring_site?: any | undefined;
    source_identifier?: any | undefined;
    source_name?: string | undefined;
    source_url?: any | undefined;
    subtotal_price?: string | undefined;
    subtotal_price_set?: SubtotalPriceSet | undefined;
    tags?: string | undefined;
    tax_lines?: any[] | undefined;
    taxes_included?: boolean | undefined;
    test?: boolean | undefined;
    token?: string | undefined;
    total_discounts?: string | undefined;
    total_discounts_set?: TotalDiscountsSet | undefined;
    total_line_items_price?: string | undefined;
    total_line_items_price_set?: TotalLineItemsPriceSet | undefined;
    total_outstanding?: string | undefined;
    total_price?: string | undefined;
    total_price_set?: TotalPriceSet | undefined;
    total_shipping_price_set?: TotalShippingPriceSet | undefined;
    total_tax?: string | undefined;
    total_tax_set?: TotalTaxSet | undefined;
    total_tip_received?: string | undefined;
    total_weight?: number | undefined;
    updated_at?: Date | undefined;
    user_id?: any | undefined;
    billing_address?: BillingAddress | undefined;
    customer?: Customer | undefined;
    discount_applications?: any[] | undefined;
    fulfillments?: any[] | undefined;
    line_items?: LineItem[] | undefined;
    payment_terms?: any | undefined;
    refunds?: any[] | undefined;
    shipping_address?: ShippingAddress | undefined;
    shipping_lines?: ShippingLine[] | undefined;
}

export class CurrentSubtotalPriceSet implements ICurrentSubtotalPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: ICurrentSubtotalPriceSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): CurrentSubtotalPriceSet {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentSubtotalPriceSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): CurrentSubtotalPriceSet {
        const json = this.toJSON();
        let result = new CurrentSubtotalPriceSet();
        result.init(json);
        return result;
    }
}

export interface ICurrentSubtotalPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class ShopMoney implements IShopMoney {
    amount?: string | undefined;
    currency_code?: string | undefined;

    constructor(data?: IShopMoney) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.currency_code = _data["currency_code"];
        }
    }

    static fromJS(data: any): ShopMoney {
        data = typeof data === 'object' ? data : {};
        let result = new ShopMoney();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["currency_code"] = this.currency_code;
        return data;
    }

    clone(): ShopMoney {
        const json = this.toJSON();
        let result = new ShopMoney();
        result.init(json);
        return result;
    }
}

export interface IShopMoney {
    amount?: string | undefined;
    currency_code?: string | undefined;
}

export class PresentmentMoney implements IPresentmentMoney {
    amount?: string | undefined;
    currency_code?: string | undefined;

    constructor(data?: IPresentmentMoney) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.currency_code = _data["currency_code"];
        }
    }

    static fromJS(data: any): PresentmentMoney {
        data = typeof data === 'object' ? data : {};
        let result = new PresentmentMoney();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["currency_code"] = this.currency_code;
        return data;
    }

    clone(): PresentmentMoney {
        const json = this.toJSON();
        let result = new PresentmentMoney();
        result.init(json);
        return result;
    }
}

export interface IPresentmentMoney {
    amount?: string | undefined;
    currency_code?: string | undefined;
}

export class CurrentTotalDiscountsSet implements ICurrentTotalDiscountsSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: ICurrentTotalDiscountsSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): CurrentTotalDiscountsSet {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentTotalDiscountsSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): CurrentTotalDiscountsSet {
        const json = this.toJSON();
        let result = new CurrentTotalDiscountsSet();
        result.init(json);
        return result;
    }
}

export interface ICurrentTotalDiscountsSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class CurrentTotalPriceSet implements ICurrentTotalPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: ICurrentTotalPriceSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): CurrentTotalPriceSet {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentTotalPriceSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): CurrentTotalPriceSet {
        const json = this.toJSON();
        let result = new CurrentTotalPriceSet();
        result.init(json);
        return result;
    }
}

export interface ICurrentTotalPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class CurrentTotalTaxSet implements ICurrentTotalTaxSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: ICurrentTotalTaxSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): CurrentTotalTaxSet {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentTotalTaxSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): CurrentTotalTaxSet {
        const json = this.toJSON();
        let result = new CurrentTotalTaxSet();
        result.init(json);
        return result;
    }
}

export interface ICurrentTotalTaxSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class SubtotalPriceSet implements ISubtotalPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: ISubtotalPriceSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): SubtotalPriceSet {
        data = typeof data === 'object' ? data : {};
        let result = new SubtotalPriceSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): SubtotalPriceSet {
        const json = this.toJSON();
        let result = new SubtotalPriceSet();
        result.init(json);
        return result;
    }
}

export interface ISubtotalPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class TotalDiscountsSet implements ITotalDiscountsSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: ITotalDiscountsSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): TotalDiscountsSet {
        data = typeof data === 'object' ? data : {};
        let result = new TotalDiscountsSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): TotalDiscountsSet {
        const json = this.toJSON();
        let result = new TotalDiscountsSet();
        result.init(json);
        return result;
    }
}

export interface ITotalDiscountsSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class TotalLineItemsPriceSet implements ITotalLineItemsPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: ITotalLineItemsPriceSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): TotalLineItemsPriceSet {
        data = typeof data === 'object' ? data : {};
        let result = new TotalLineItemsPriceSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): TotalLineItemsPriceSet {
        const json = this.toJSON();
        let result = new TotalLineItemsPriceSet();
        result.init(json);
        return result;
    }
}

export interface ITotalLineItemsPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class TotalPriceSet implements ITotalPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: ITotalPriceSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): TotalPriceSet {
        data = typeof data === 'object' ? data : {};
        let result = new TotalPriceSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): TotalPriceSet {
        const json = this.toJSON();
        let result = new TotalPriceSet();
        result.init(json);
        return result;
    }
}

export interface ITotalPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class TotalShippingPriceSet implements ITotalShippingPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: ITotalShippingPriceSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): TotalShippingPriceSet {
        data = typeof data === 'object' ? data : {};
        let result = new TotalShippingPriceSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): TotalShippingPriceSet {
        const json = this.toJSON();
        let result = new TotalShippingPriceSet();
        result.init(json);
        return result;
    }
}

export interface ITotalShippingPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class TotalTaxSet implements ITotalTaxSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: ITotalTaxSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): TotalTaxSet {
        data = typeof data === 'object' ? data : {};
        let result = new TotalTaxSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): TotalTaxSet {
        const json = this.toJSON();
        let result = new TotalTaxSet();
        result.init(json);
        return result;
    }
}

export interface ITotalTaxSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class BillingAddress implements IBillingAddress {
    first_name?: string | undefined;
    address1?: string | undefined;
    phone?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    province?: string | undefined;
    country?: string | undefined;
    last_name?: string | undefined;
    address2?: any | undefined;
    company?: string | undefined;
    latitude?: any | undefined;
    longitude?: any | undefined;
    name?: string | undefined;
    country_code?: string | undefined;
    province_code?: string | undefined;

    constructor(data?: IBillingAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.first_name = _data["first_name"];
            this.address1 = _data["address1"];
            this.phone = _data["phone"];
            this.city = _data["city"];
            this.zip = _data["zip"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.last_name = _data["last_name"];
            this.address2 = _data["address2"];
            this.company = _data["company"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.name = _data["name"];
            this.country_code = _data["country_code"];
            this.province_code = _data["province_code"];
        }
    }

    static fromJS(data: any): BillingAddress {
        data = typeof data === 'object' ? data : {};
        let result = new BillingAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["first_name"] = this.first_name;
        data["address1"] = this.address1;
        data["phone"] = this.phone;
        data["city"] = this.city;
        data["zip"] = this.zip;
        data["province"] = this.province;
        data["country"] = this.country;
        data["last_name"] = this.last_name;
        data["address2"] = this.address2;
        data["company"] = this.company;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["name"] = this.name;
        data["country_code"] = this.country_code;
        data["province_code"] = this.province_code;
        return data;
    }

    clone(): BillingAddress {
        const json = this.toJSON();
        let result = new BillingAddress();
        result.init(json);
        return result;
    }
}

export interface IBillingAddress {
    first_name?: string | undefined;
    address1?: string | undefined;
    phone?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    province?: string | undefined;
    country?: string | undefined;
    last_name?: string | undefined;
    address2?: any | undefined;
    company?: string | undefined;
    latitude?: any | undefined;
    longitude?: any | undefined;
    name?: string | undefined;
    country_code?: string | undefined;
    province_code?: string | undefined;
}

export class Customer implements ICustomer {
    id?: number | undefined;
    email?: string | undefined;
    accepts_marketing?: boolean | undefined;
    created_at?: any | undefined;
    updated_at?: any | undefined;
    first_name?: string | undefined;
    last_name?: string | undefined;
    state?: string | undefined;
    note?: any | undefined;
    verified_email?: boolean | undefined;
    multipass_identifier?: any | undefined;
    tax_exempt?: boolean | undefined;
    phone?: any | undefined;
    email_marketing_consent?: EmailMarketingConsent | undefined;
    sms_marketing_consent?: any | undefined;
    tags?: string | undefined;
    currency?: string | undefined;
    accepts_marketing_updated_at?: any | undefined;
    marketing_opt_in_level?: any | undefined;
    tax_exemptions?: any[] | undefined;
    admin_graphql_api_id?: string | undefined;
    default_address?: DefaultAddress | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.accepts_marketing = _data["accepts_marketing"];
            this.created_at = _data["created_at"];
            this.updated_at = _data["updated_at"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.state = _data["state"];
            this.note = _data["note"];
            this.verified_email = _data["verified_email"];
            this.multipass_identifier = _data["multipass_identifier"];
            this.tax_exempt = _data["tax_exempt"];
            this.phone = _data["phone"];
            this.email_marketing_consent = _data["email_marketing_consent"] ? EmailMarketingConsent.fromJS(_data["email_marketing_consent"]) : undefined as any;
            this.sms_marketing_consent = _data["sms_marketing_consent"];
            this.tags = _data["tags"];
            this.currency = _data["currency"];
            this.accepts_marketing_updated_at = _data["accepts_marketing_updated_at"];
            this.marketing_opt_in_level = _data["marketing_opt_in_level"];
            if (Array.isArray(_data["tax_exemptions"])) {
                this.tax_exemptions = [] as any;
                for (let item of _data["tax_exemptions"])
                    this.tax_exemptions!.push(item);
            }
            this.admin_graphql_api_id = _data["admin_graphql_api_id"];
            this.default_address = _data["default_address"] ? DefaultAddress.fromJS(_data["default_address"]) : undefined as any;
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["accepts_marketing"] = this.accepts_marketing;
        data["created_at"] = this.created_at;
        data["updated_at"] = this.updated_at;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["state"] = this.state;
        data["note"] = this.note;
        data["verified_email"] = this.verified_email;
        data["multipass_identifier"] = this.multipass_identifier;
        data["tax_exempt"] = this.tax_exempt;
        data["phone"] = this.phone;
        data["email_marketing_consent"] = this.email_marketing_consent ? this.email_marketing_consent.toJSON() : undefined as any;
        data["sms_marketing_consent"] = this.sms_marketing_consent;
        data["tags"] = this.tags;
        data["currency"] = this.currency;
        data["accepts_marketing_updated_at"] = this.accepts_marketing_updated_at;
        data["marketing_opt_in_level"] = this.marketing_opt_in_level;
        if (Array.isArray(this.tax_exemptions)) {
            data["tax_exemptions"] = [];
            for (let item of this.tax_exemptions)
                data["tax_exemptions"].push(item);
        }
        data["admin_graphql_api_id"] = this.admin_graphql_api_id;
        data["default_address"] = this.default_address ? this.default_address.toJSON() : undefined as any;
        return data;
    }

    clone(): Customer {
        const json = this.toJSON();
        let result = new Customer();
        result.init(json);
        return result;
    }
}

export interface ICustomer {
    id?: number | undefined;
    email?: string | undefined;
    accepts_marketing?: boolean | undefined;
    created_at?: any | undefined;
    updated_at?: any | undefined;
    first_name?: string | undefined;
    last_name?: string | undefined;
    state?: string | undefined;
    note?: any | undefined;
    verified_email?: boolean | undefined;
    multipass_identifier?: any | undefined;
    tax_exempt?: boolean | undefined;
    phone?: any | undefined;
    email_marketing_consent?: EmailMarketingConsent | undefined;
    sms_marketing_consent?: any | undefined;
    tags?: string | undefined;
    currency?: string | undefined;
    accepts_marketing_updated_at?: any | undefined;
    marketing_opt_in_level?: any | undefined;
    tax_exemptions?: any[] | undefined;
    admin_graphql_api_id?: string | undefined;
    default_address?: DefaultAddress | undefined;
}

export class EmailMarketingConsent implements IEmailMarketingConsent {
    state?: string | undefined;
    opt_in_level?: any | undefined;
    consent_updated_at?: any | undefined;

    constructor(data?: IEmailMarketingConsent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.opt_in_level = _data["opt_in_level"];
            this.consent_updated_at = _data["consent_updated_at"];
        }
    }

    static fromJS(data: any): EmailMarketingConsent {
        data = typeof data === 'object' ? data : {};
        let result = new EmailMarketingConsent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["opt_in_level"] = this.opt_in_level;
        data["consent_updated_at"] = this.consent_updated_at;
        return data;
    }

    clone(): EmailMarketingConsent {
        const json = this.toJSON();
        let result = new EmailMarketingConsent();
        result.init(json);
        return result;
    }
}

export interface IEmailMarketingConsent {
    state?: string | undefined;
    opt_in_level?: any | undefined;
    consent_updated_at?: any | undefined;
}

export class DefaultAddress implements IDefaultAddress {
    id?: number | undefined;
    customer_id?: number | undefined;
    first_name?: any | undefined;
    last_name?: any | undefined;
    company?: any | undefined;
    address1?: string | undefined;
    address2?: any | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: string | undefined;
    zip?: string | undefined;
    phone?: string | undefined;
    name?: string | undefined;
    province_code?: string | undefined;
    country_code?: string | undefined;
    country_name?: string | undefined;
    default?: boolean | undefined;

    constructor(data?: IDefaultAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customer_id = _data["customer_id"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.company = _data["company"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.zip = _data["zip"];
            this.phone = _data["phone"];
            this.name = _data["name"];
            this.province_code = _data["province_code"];
            this.country_code = _data["country_code"];
            this.country_name = _data["country_name"];
            this.default = _data["default"];
        }
    }

    static fromJS(data: any): DefaultAddress {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customer_id"] = this.customer_id;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["company"] = this.company;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["province"] = this.province;
        data["country"] = this.country;
        data["zip"] = this.zip;
        data["phone"] = this.phone;
        data["name"] = this.name;
        data["province_code"] = this.province_code;
        data["country_code"] = this.country_code;
        data["country_name"] = this.country_name;
        data["default"] = this.default;
        return data;
    }

    clone(): DefaultAddress {
        const json = this.toJSON();
        let result = new DefaultAddress();
        result.init(json);
        return result;
    }
}

export interface IDefaultAddress {
    id?: number | undefined;
    customer_id?: number | undefined;
    first_name?: any | undefined;
    last_name?: any | undefined;
    company?: any | undefined;
    address1?: string | undefined;
    address2?: any | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: string | undefined;
    zip?: string | undefined;
    phone?: string | undefined;
    name?: string | undefined;
    province_code?: string | undefined;
    country_code?: string | undefined;
    country_name?: string | undefined;
    default?: boolean | undefined;
}

export class LineItem implements ILineItem {
    id?: any | undefined;
    admin_graphql_api_id?: string | undefined;
    attributed_staffs?: AttributedStaff[] | undefined;
    fulfillable_quantity?: number | undefined;
    fulfillment_service?: string | undefined;
    fulfillment_status?: any | undefined;
    gift_card?: boolean | undefined;
    grams?: number | undefined;
    name?: string | undefined;
    price?: string | undefined;
    price_set?: PriceSet | undefined;
    product_exists?: boolean | undefined;
    product_id?: any | undefined;
    properties?: any[] | undefined;
    quantity?: number | undefined;
    requires_shipping?: boolean | undefined;
    sku?: string | undefined;
    taxable?: boolean | undefined;
    title?: string | undefined;
    total_discount?: string | undefined;
    total_discount_set?: TotalDiscountSet | undefined;
    variant_id?: any | undefined;
    variant_inventory_management?: string | undefined;
    variant_title?: any | undefined;
    vendor?: any | undefined;
    tax_lines?: any[] | undefined;
    duties?: any[] | undefined;
    discount_allocations?: any[] | undefined;

    constructor(data?: ILineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.admin_graphql_api_id = _data["admin_graphql_api_id"];
            if (Array.isArray(_data["attributed_staffs"])) {
                this.attributed_staffs = [] as any;
                for (let item of _data["attributed_staffs"])
                    this.attributed_staffs!.push(AttributedStaff.fromJS(item));
            }
            this.fulfillable_quantity = _data["fulfillable_quantity"];
            this.fulfillment_service = _data["fulfillment_service"];
            this.fulfillment_status = _data["fulfillment_status"];
            this.gift_card = _data["gift_card"];
            this.grams = _data["grams"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.price_set = _data["price_set"] ? PriceSet.fromJS(_data["price_set"]) : undefined as any;
            this.product_exists = _data["product_exists"];
            this.product_id = _data["product_id"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(item);
            }
            this.quantity = _data["quantity"];
            this.requires_shipping = _data["requires_shipping"];
            this.sku = _data["sku"];
            this.taxable = _data["taxable"];
            this.title = _data["title"];
            this.total_discount = _data["total_discount"];
            this.total_discount_set = _data["total_discount_set"] ? TotalDiscountSet.fromJS(_data["total_discount_set"]) : undefined as any;
            this.variant_id = _data["variant_id"];
            this.variant_inventory_management = _data["variant_inventory_management"];
            this.variant_title = _data["variant_title"];
            this.vendor = _data["vendor"];
            if (Array.isArray(_data["tax_lines"])) {
                this.tax_lines = [] as any;
                for (let item of _data["tax_lines"])
                    this.tax_lines!.push(item);
            }
            if (Array.isArray(_data["duties"])) {
                this.duties = [] as any;
                for (let item of _data["duties"])
                    this.duties!.push(item);
            }
            if (Array.isArray(_data["discount_allocations"])) {
                this.discount_allocations = [] as any;
                for (let item of _data["discount_allocations"])
                    this.discount_allocations!.push(item);
            }
        }
    }

    static fromJS(data: any): LineItem {
        data = typeof data === 'object' ? data : {};
        let result = new LineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["admin_graphql_api_id"] = this.admin_graphql_api_id;
        if (Array.isArray(this.attributed_staffs)) {
            data["attributed_staffs"] = [];
            for (let item of this.attributed_staffs)
                data["attributed_staffs"].push(item ? item.toJSON() : undefined as any);
        }
        data["fulfillable_quantity"] = this.fulfillable_quantity;
        data["fulfillment_service"] = this.fulfillment_service;
        data["fulfillment_status"] = this.fulfillment_status;
        data["gift_card"] = this.gift_card;
        data["grams"] = this.grams;
        data["name"] = this.name;
        data["price"] = this.price;
        data["price_set"] = this.price_set ? this.price_set.toJSON() : undefined as any;
        data["product_exists"] = this.product_exists;
        data["product_id"] = this.product_id;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item);
        }
        data["quantity"] = this.quantity;
        data["requires_shipping"] = this.requires_shipping;
        data["sku"] = this.sku;
        data["taxable"] = this.taxable;
        data["title"] = this.title;
        data["total_discount"] = this.total_discount;
        data["total_discount_set"] = this.total_discount_set ? this.total_discount_set.toJSON() : undefined as any;
        data["variant_id"] = this.variant_id;
        data["variant_inventory_management"] = this.variant_inventory_management;
        data["variant_title"] = this.variant_title;
        data["vendor"] = this.vendor;
        if (Array.isArray(this.tax_lines)) {
            data["tax_lines"] = [];
            for (let item of this.tax_lines)
                data["tax_lines"].push(item);
        }
        if (Array.isArray(this.duties)) {
            data["duties"] = [];
            for (let item of this.duties)
                data["duties"].push(item);
        }
        if (Array.isArray(this.discount_allocations)) {
            data["discount_allocations"] = [];
            for (let item of this.discount_allocations)
                data["discount_allocations"].push(item);
        }
        return data;
    }

    clone(): LineItem {
        const json = this.toJSON();
        let result = new LineItem();
        result.init(json);
        return result;
    }
}

export interface ILineItem {
    id?: any | undefined;
    admin_graphql_api_id?: string | undefined;
    attributed_staffs?: AttributedStaff[] | undefined;
    fulfillable_quantity?: number | undefined;
    fulfillment_service?: string | undefined;
    fulfillment_status?: any | undefined;
    gift_card?: boolean | undefined;
    grams?: number | undefined;
    name?: string | undefined;
    price?: string | undefined;
    price_set?: PriceSet | undefined;
    product_exists?: boolean | undefined;
    product_id?: any | undefined;
    properties?: any[] | undefined;
    quantity?: number | undefined;
    requires_shipping?: boolean | undefined;
    sku?: string | undefined;
    taxable?: boolean | undefined;
    title?: string | undefined;
    total_discount?: string | undefined;
    total_discount_set?: TotalDiscountSet | undefined;
    variant_id?: any | undefined;
    variant_inventory_management?: string | undefined;
    variant_title?: any | undefined;
    vendor?: any | undefined;
    tax_lines?: any[] | undefined;
    duties?: any[] | undefined;
    discount_allocations?: any[] | undefined;
}

export class AttributedStaff implements IAttributedStaff {
    id?: string | undefined;
    quantity?: number | undefined;

    constructor(data?: IAttributedStaff) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): AttributedStaff {
        data = typeof data === 'object' ? data : {};
        let result = new AttributedStaff();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): AttributedStaff {
        const json = this.toJSON();
        let result = new AttributedStaff();
        result.init(json);
        return result;
    }
}

export interface IAttributedStaff {
    id?: string | undefined;
    quantity?: number | undefined;
}

export class PriceSet implements IPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: IPriceSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): PriceSet {
        data = typeof data === 'object' ? data : {};
        let result = new PriceSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): PriceSet {
        const json = this.toJSON();
        let result = new PriceSet();
        result.init(json);
        return result;
    }
}

export interface IPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class TotalDiscountSet implements ITotalDiscountSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: ITotalDiscountSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): TotalDiscountSet {
        data = typeof data === 'object' ? data : {};
        let result = new TotalDiscountSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): TotalDiscountSet {
        const json = this.toJSON();
        let result = new TotalDiscountSet();
        result.init(json);
        return result;
    }
}

export interface ITotalDiscountSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class ShippingAddress implements IShippingAddress {
    first_name?: string | undefined;
    address1?: string | undefined;
    phone?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    province?: string | undefined;
    country?: string | undefined;
    last_name?: string | undefined;
    address2?: any | undefined;
    company?: string | undefined;
    latitude?: any | undefined;
    longitude?: any | undefined;
    name?: string | undefined;
    country_code?: string | undefined;
    province_code?: string | undefined;

    constructor(data?: IShippingAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.first_name = _data["first_name"];
            this.address1 = _data["address1"];
            this.phone = _data["phone"];
            this.city = _data["city"];
            this.zip = _data["zip"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.last_name = _data["last_name"];
            this.address2 = _data["address2"];
            this.company = _data["company"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.name = _data["name"];
            this.country_code = _data["country_code"];
            this.province_code = _data["province_code"];
        }
    }

    static fromJS(data: any): ShippingAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["first_name"] = this.first_name;
        data["address1"] = this.address1;
        data["phone"] = this.phone;
        data["city"] = this.city;
        data["zip"] = this.zip;
        data["province"] = this.province;
        data["country"] = this.country;
        data["last_name"] = this.last_name;
        data["address2"] = this.address2;
        data["company"] = this.company;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["name"] = this.name;
        data["country_code"] = this.country_code;
        data["province_code"] = this.province_code;
        return data;
    }

    clone(): ShippingAddress {
        const json = this.toJSON();
        let result = new ShippingAddress();
        result.init(json);
        return result;
    }
}

export interface IShippingAddress {
    first_name?: string | undefined;
    address1?: string | undefined;
    phone?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    province?: string | undefined;
    country?: string | undefined;
    last_name?: string | undefined;
    address2?: any | undefined;
    company?: string | undefined;
    latitude?: any | undefined;
    longitude?: any | undefined;
    name?: string | undefined;
    country_code?: string | undefined;
    province_code?: string | undefined;
}

export class ShippingLine implements IShippingLine {
    id?: number | undefined;
    carrier_identifier?: any | undefined;
    code?: any | undefined;
    delivery_category?: any | undefined;
    discounted_price?: string | undefined;
    discounted_price_set?: DiscountedPriceSet | undefined;
    phone?: any | undefined;
    price?: string | undefined;
    price_set?: PriceSet | undefined;
    requested_fulfillment_service_id?: any | undefined;
    source?: string | undefined;
    title?: string | undefined;
    tax_lines?: any[] | undefined;
    discount_allocations?: any[] | undefined;

    constructor(data?: IShippingLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.carrier_identifier = _data["carrier_identifier"];
            this.code = _data["code"];
            this.delivery_category = _data["delivery_category"];
            this.discounted_price = _data["discounted_price"];
            this.discounted_price_set = _data["discounted_price_set"] ? DiscountedPriceSet.fromJS(_data["discounted_price_set"]) : undefined as any;
            this.phone = _data["phone"];
            this.price = _data["price"];
            this.price_set = _data["price_set"] ? PriceSet.fromJS(_data["price_set"]) : undefined as any;
            this.requested_fulfillment_service_id = _data["requested_fulfillment_service_id"];
            this.source = _data["source"];
            this.title = _data["title"];
            if (Array.isArray(_data["tax_lines"])) {
                this.tax_lines = [] as any;
                for (let item of _data["tax_lines"])
                    this.tax_lines!.push(item);
            }
            if (Array.isArray(_data["discount_allocations"])) {
                this.discount_allocations = [] as any;
                for (let item of _data["discount_allocations"])
                    this.discount_allocations!.push(item);
            }
        }
    }

    static fromJS(data: any): ShippingLine {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["carrier_identifier"] = this.carrier_identifier;
        data["code"] = this.code;
        data["delivery_category"] = this.delivery_category;
        data["discounted_price"] = this.discounted_price;
        data["discounted_price_set"] = this.discounted_price_set ? this.discounted_price_set.toJSON() : undefined as any;
        data["phone"] = this.phone;
        data["price"] = this.price;
        data["price_set"] = this.price_set ? this.price_set.toJSON() : undefined as any;
        data["requested_fulfillment_service_id"] = this.requested_fulfillment_service_id;
        data["source"] = this.source;
        data["title"] = this.title;
        if (Array.isArray(this.tax_lines)) {
            data["tax_lines"] = [];
            for (let item of this.tax_lines)
                data["tax_lines"].push(item);
        }
        if (Array.isArray(this.discount_allocations)) {
            data["discount_allocations"] = [];
            for (let item of this.discount_allocations)
                data["discount_allocations"].push(item);
        }
        return data;
    }

    clone(): ShippingLine {
        const json = this.toJSON();
        let result = new ShippingLine();
        result.init(json);
        return result;
    }
}

export interface IShippingLine {
    id?: number | undefined;
    carrier_identifier?: any | undefined;
    code?: any | undefined;
    delivery_category?: any | undefined;
    discounted_price?: string | undefined;
    discounted_price_set?: DiscountedPriceSet | undefined;
    phone?: any | undefined;
    price?: string | undefined;
    price_set?: PriceSet | undefined;
    requested_fulfillment_service_id?: any | undefined;
    source?: string | undefined;
    title?: string | undefined;
    tax_lines?: any[] | undefined;
    discount_allocations?: any[] | undefined;
}

export class DiscountedPriceSet implements IDiscountedPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;

    constructor(data?: IDiscountedPriceSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shop_money = _data["shop_money"] ? ShopMoney.fromJS(_data["shop_money"]) : undefined as any;
            this.presentment_money = _data["presentment_money"] ? PresentmentMoney.fromJS(_data["presentment_money"]) : undefined as any;
        }
    }

    static fromJS(data: any): DiscountedPriceSet {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountedPriceSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shop_money"] = this.shop_money ? this.shop_money.toJSON() : undefined as any;
        data["presentment_money"] = this.presentment_money ? this.presentment_money.toJSON() : undefined as any;
        return data;
    }

    clone(): DiscountedPriceSet {
        const json = this.toJSON();
        let result = new DiscountedPriceSet();
        result.init(json);
        return result;
    }
}

export interface IDiscountedPriceSet {
    shop_money?: ShopMoney | undefined;
    presentment_money?: PresentmentMoney | undefined;
}

export class VirkCompanyModel implements IVirkCompanyModel {
    timeStamp?: Date;
    companyId?: string;
    cvr?: number;
    name?: string | undefined;
    otherCompanyNames?: string | undefined;
    email?: string | undefined;
    websiteUrl?: string | undefined;
    description?: string | undefined;
    status?: CvrVirkStatus;
    street?: string | undefined;
    streetNo?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    adBan?: number;
    nace?: string | undefined;
    manYears?: number | undefined;
    establishedDate?: Date | undefined;

    constructor(data?: IVirkCompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : undefined as any;
            this.companyId = _data["companyId"];
            this.cvr = _data["cvr"];
            this.name = _data["name"];
            this.otherCompanyNames = _data["otherCompanyNames"];
            this.email = _data["email"];
            this.websiteUrl = _data["websiteUrl"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.street = _data["street"];
            this.streetNo = _data["streetNo"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.adBan = _data["adBan"];
            this.nace = _data["nace"];
            this.manYears = _data["manYears"];
            this.establishedDate = _data["establishedDate"] ? new Date(_data["establishedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): VirkCompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new VirkCompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : undefined as any;
        data["companyId"] = this.companyId;
        data["cvr"] = this.cvr;
        data["name"] = this.name;
        data["otherCompanyNames"] = this.otherCompanyNames;
        data["email"] = this.email;
        data["websiteUrl"] = this.websiteUrl;
        data["description"] = this.description;
        data["status"] = this.status;
        data["street"] = this.street;
        data["streetNo"] = this.streetNo;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["adBan"] = this.adBan;
        data["nace"] = this.nace;
        data["manYears"] = this.manYears;
        data["establishedDate"] = this.establishedDate ? this.establishedDate.toISOString() : undefined as any;
        return data;
    }

    clone(): VirkCompanyModel {
        const json = this.toJSON();
        let result = new VirkCompanyModel();
        result.init(json);
        return result;
    }
}

export interface IVirkCompanyModel {
    timeStamp?: Date;
    companyId?: string;
    cvr?: number;
    name?: string | undefined;
    otherCompanyNames?: string | undefined;
    email?: string | undefined;
    websiteUrl?: string | undefined;
    description?: string | undefined;
    status?: CvrVirkStatus;
    street?: string | undefined;
    streetNo?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    adBan?: number;
    nace?: string | undefined;
    manYears?: number | undefined;
    establishedDate?: Date | undefined;
}

export enum CvrVirkStatus {
    Normal = 0,
    Underkonkurs = 1,
    Konkurs = 2,
    Likvidation = 3,
    Tvungenopløsning = 4,
    Frivilligopløsning = 5,
    PauseIdrift = 6,
    Rekonstruktion = 7,
    Ukendt = 8,
}

export class MaintenanceTaskModel implements IMaintenanceTaskModel {
    id?: string;
    date?: Date | undefined;
    name?: string | undefined;
    description?: string | undefined;
    maintenanceNumber?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    type?: MaintenanceTaskType;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IMaintenanceTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.maintenanceNumber = _data["maintenanceNumber"];
            this.responsibleUser = _data["responsibleUser"] ? IdNameModel.fromJS(_data["responsibleUser"]) : undefined as any;
            this.type = _data["type"];
            this.userId = _data["userId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): MaintenanceTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        data["maintenanceNumber"] = this.maintenanceNumber;
        data["responsibleUser"] = this.responsibleUser ? this.responsibleUser.toJSON() : undefined as any;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): MaintenanceTaskModel {
        const json = this.toJSON();
        let result = new MaintenanceTaskModel();
        result.init(json);
        return result;
    }
}

export interface IMaintenanceTaskModel {
    id?: string;
    date?: Date | undefined;
    name?: string | undefined;
    description?: string | undefined;
    maintenanceNumber?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    type?: MaintenanceTaskType;
    userId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum MaintenanceTaskType {
    CCP = 0,
    Raw = 1,
    Product = 2,
    Cleaning = 3,
    Maintenance = 4,
    PestControl = 5,
    Packaging = 6,
    Labels = 7,
    Other = 99,
}

export class PagedResultOfMaintenanceTaskModel extends PagedResultBase implements IPagedResultOfMaintenanceTaskModel {
    results?: MaintenanceTaskModel[];

    constructor(data?: IPagedResultOfMaintenanceTaskModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MaintenanceTaskModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfMaintenanceTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfMaintenanceTaskModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfMaintenanceTaskModel {
        const json = this.toJSON();
        let result = new PagedResultOfMaintenanceTaskModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfMaintenanceTaskModel extends IPagedResultBase {
    results?: MaintenanceTaskModel[];
}

export class SignalRConnectionDetails implements ISignalRConnectionDetails {
    activeConnections?: number;
    groups?: string[] | undefined;

    constructor(data?: ISignalRConnectionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeConnections = _data["activeConnections"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
        }
    }

    static fromJS(data: any): SignalRConnectionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SignalRConnectionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeConnections"] = this.activeConnections;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        return data;
    }

    clone(): SignalRConnectionDetails {
        const json = this.toJSON();
        let result = new SignalRConnectionDetails();
        result.init(json);
        return result;
    }
}

export interface ISignalRConnectionDetails {
    activeConnections?: number;
    groups?: string[] | undefined;
}

export class NotificationSubscriptionModel implements INotificationSubscriptionModel {
    id?: string;
    type?: number;
    entityId?: string;
    notificationUserId?: string;
    notificationUserName?: string | undefined;
    channels?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: INotificationSubscriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.entityId = _data["entityId"];
            this.notificationUserId = _data["notificationUserId"];
            this.notificationUserName = _data["notificationUserName"];
            this.channels = _data["channels"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["entityId"] = this.entityId;
        data["notificationUserId"] = this.notificationUserId;
        data["notificationUserName"] = this.notificationUserName;
        data["channels"] = this.channels;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): NotificationSubscriptionModel {
        const json = this.toJSON();
        let result = new NotificationSubscriptionModel();
        result.init(json);
        return result;
    }
}

export interface INotificationSubscriptionModel {
    id?: string;
    type?: number;
    entityId?: string;
    notificationUserId?: string;
    notificationUserName?: string | undefined;
    channels?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class NotificationModel implements INotificationModel {
    id?: string;
    type?: NotificationType;
    entityId?: string | undefined;
    message?: string | undefined;
    exception?: string | undefined;
    notificationUser?: string | undefined;
    status?: NotificationStatus;
    created?: Date;
    organizationId?: string | undefined;

    constructor(data?: INotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.entityId = _data["entityId"];
            this.message = _data["message"];
            this.exception = _data["exception"];
            this.notificationUser = _data["notificationUser"];
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): NotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["entityId"] = this.entityId;
        data["message"] = this.message;
        data["exception"] = this.exception;
        data["notificationUser"] = this.notificationUser;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["organizationId"] = this.organizationId;
        return data;
    }

    clone(): NotificationModel {
        const json = this.toJSON();
        let result = new NotificationModel();
        result.init(json);
        return result;
    }
}

export interface INotificationModel {
    id?: string;
    type?: NotificationType;
    entityId?: string | undefined;
    message?: string | undefined;
    exception?: string | undefined;
    notificationUser?: string | undefined;
    status?: NotificationStatus;
    created?: Date;
    organizationId?: string | undefined;
}

export enum NotificationType {
    IntegrationPurchaseOrder = 1,
    IntegrationSalesOrder = 2,
    IntegrationCustomer = 3,
    IntegrationSupplier = 4,
    IntegrationProduct = 5,
    News = 6,
}

export enum NotificationStatus {
    New = 0,
    Read = 1,
    Dismissed = 2,
}

export enum EventGroup {
    User = 0,
    Organization = 1,
}

export class OrderModel implements IOrderModel {
    id?: string;
    organizationId?: string;
    name?: string | undefined;
    type?: OrderType;
    userId?: string;
    supplier?: IdNameModel | undefined;
    customer?: IdNameModel | undefined;
    comments?: string | undefined;
    voucherId?: string | undefined;
    deliveryDate?: Date;
    wantedDate?: Date | undefined;
    plannedDate?: Date | undefined;
    shippingDate?: Date | undefined;
    orderLines?: OrderlineModel[] | undefined;
    orderNumber?: string | undefined;
    invoiceNumber?: string | undefined;
    orderStatus?: OrderStatus;
    warnings?: string | undefined;
    internalNote?: string | undefined;
    stockLocationId?: string | undefined;
    stockLocationName?: string | undefined;
    totalPrice?: number | undefined;
    totalLines?: number | undefined;
    totalPriceInvoiced?: number;
    deliveryAddressId?: string | undefined;
    deliveryAddressText?: string | undefined;
    invoiceAddressId?: string | undefined;
    internalRef?: string | undefined;
    internalRefName?: string | undefined;
    externalRef?: string | undefined;
    externalRefName?: string | undefined;
    responsibleUser?: string | undefined;
    responsibleUserName?: string | undefined;
    externalId?: string | undefined;
    externalSource?: string | undefined;
    financeStatus?: FinanceStatus;
    bookedInvoiceNumber?: string | undefined;
    financeWarnings?: string | undefined;
    otherCosts?: number;
    currency?: string | undefined;
    vatRate?: number;
    carrierId?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    updated?: Date;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    carrierName?: string | undefined;
    transportBookingId?: string | undefined;
    transportStatus?: number;

    constructor(data?: IOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.userId = _data["userId"];
            this.supplier = _data["supplier"] ? IdNameModel.fromJS(_data["supplier"]) : undefined as any;
            this.customer = _data["customer"] ? IdNameModel.fromJS(_data["customer"]) : undefined as any;
            this.comments = _data["comments"];
            this.voucherId = _data["voucherId"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : undefined as any;
            this.wantedDate = _data["wantedDate"] ? new Date(_data["wantedDate"].toString()) : undefined as any;
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.shippingDate = _data["shippingDate"] ? new Date(_data["shippingDate"].toString()) : undefined as any;
            if (Array.isArray(_data["orderLines"])) {
                this.orderLines = [] as any;
                for (let item of _data["orderLines"])
                    this.orderLines!.push(OrderlineModel.fromJS(item));
            }
            this.orderNumber = _data["orderNumber"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.orderStatus = _data["orderStatus"];
            this.warnings = _data["warnings"];
            this.internalNote = _data["internalNote"];
            this.stockLocationId = _data["stockLocationId"];
            this.stockLocationName = _data["stockLocationName"];
            this.totalPrice = _data["totalPrice"];
            this.totalLines = _data["totalLines"];
            this.totalPriceInvoiced = _data["totalPriceInvoiced"];
            this.deliveryAddressId = _data["deliveryAddressId"];
            this.deliveryAddressText = _data["deliveryAddressText"];
            this.invoiceAddressId = _data["invoiceAddressId"];
            this.internalRef = _data["internalRef"];
            this.internalRefName = _data["internalRefName"];
            this.externalRef = _data["externalRef"];
            this.externalRefName = _data["externalRefName"];
            this.responsibleUser = _data["responsibleUser"];
            this.responsibleUserName = _data["responsibleUserName"];
            this.externalId = _data["externalId"];
            this.externalSource = _data["externalSource"];
            this.financeStatus = _data["financeStatus"];
            this.bookedInvoiceNumber = _data["bookedInvoiceNumber"];
            this.financeWarnings = _data["financeWarnings"];
            this.otherCosts = _data["otherCosts"];
            this.currency = _data["currency"];
            this.vatRate = _data["vatRate"];
            this.carrierId = _data["carrierId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.carrierName = _data["carrierName"];
            this.transportBookingId = _data["transportBookingId"];
            this.transportStatus = _data["transportStatus"];
        }
    }

    static fromJS(data: any): OrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["comments"] = this.comments;
        data["voucherId"] = this.voucherId;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined as any;
        data["wantedDate"] = this.wantedDate ? this.wantedDate.toISOString() : undefined as any;
        data["plannedDate"] = this.plannedDate ? this.plannedDate.toISOString() : undefined as any;
        data["shippingDate"] = this.shippingDate ? this.shippingDate.toISOString() : undefined as any;
        if (Array.isArray(this.orderLines)) {
            data["orderLines"] = [];
            for (let item of this.orderLines)
                data["orderLines"].push(item ? item.toJSON() : undefined as any);
        }
        data["orderNumber"] = this.orderNumber;
        data["invoiceNumber"] = this.invoiceNumber;
        data["orderStatus"] = this.orderStatus;
        data["warnings"] = this.warnings;
        data["internalNote"] = this.internalNote;
        data["stockLocationId"] = this.stockLocationId;
        data["stockLocationName"] = this.stockLocationName;
        data["totalPrice"] = this.totalPrice;
        data["totalLines"] = this.totalLines;
        data["totalPriceInvoiced"] = this.totalPriceInvoiced;
        data["deliveryAddressId"] = this.deliveryAddressId;
        data["deliveryAddressText"] = this.deliveryAddressText;
        data["invoiceAddressId"] = this.invoiceAddressId;
        data["internalRef"] = this.internalRef;
        data["internalRefName"] = this.internalRefName;
        data["externalRef"] = this.externalRef;
        data["externalRefName"] = this.externalRefName;
        data["responsibleUser"] = this.responsibleUser;
        data["responsibleUserName"] = this.responsibleUserName;
        data["externalId"] = this.externalId;
        data["externalSource"] = this.externalSource;
        data["financeStatus"] = this.financeStatus;
        data["bookedInvoiceNumber"] = this.bookedInvoiceNumber;
        data["financeWarnings"] = this.financeWarnings;
        data["otherCosts"] = this.otherCosts;
        data["currency"] = this.currency;
        data["vatRate"] = this.vatRate;
        data["carrierId"] = this.carrierId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["carrierName"] = this.carrierName;
        data["transportBookingId"] = this.transportBookingId;
        data["transportStatus"] = this.transportStatus;
        return data;
    }

    clone(): OrderModel {
        const json = this.toJSON();
        let result = new OrderModel();
        result.init(json);
        return result;
    }
}

export interface IOrderModel {
    id?: string;
    organizationId?: string;
    name?: string | undefined;
    type?: OrderType;
    userId?: string;
    supplier?: IdNameModel | undefined;
    customer?: IdNameModel | undefined;
    comments?: string | undefined;
    voucherId?: string | undefined;
    deliveryDate?: Date;
    wantedDate?: Date | undefined;
    plannedDate?: Date | undefined;
    shippingDate?: Date | undefined;
    orderLines?: OrderlineModel[] | undefined;
    orderNumber?: string | undefined;
    invoiceNumber?: string | undefined;
    orderStatus?: OrderStatus;
    warnings?: string | undefined;
    internalNote?: string | undefined;
    stockLocationId?: string | undefined;
    stockLocationName?: string | undefined;
    totalPrice?: number | undefined;
    totalLines?: number | undefined;
    totalPriceInvoiced?: number;
    deliveryAddressId?: string | undefined;
    deliveryAddressText?: string | undefined;
    invoiceAddressId?: string | undefined;
    internalRef?: string | undefined;
    internalRefName?: string | undefined;
    externalRef?: string | undefined;
    externalRefName?: string | undefined;
    responsibleUser?: string | undefined;
    responsibleUserName?: string | undefined;
    externalId?: string | undefined;
    externalSource?: string | undefined;
    financeStatus?: FinanceStatus;
    bookedInvoiceNumber?: string | undefined;
    financeWarnings?: string | undefined;
    otherCosts?: number;
    currency?: string | undefined;
    vatRate?: number;
    carrierId?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    updated?: Date;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    carrierName?: string | undefined;
    transportBookingId?: string | undefined;
    transportStatus?: number;
}

export enum OrderType {
    Purchase = 1,
    Sale = 2,
    Production = 3,
    StockTake = 5,
    StockAdjustment = 6,
    StockLoss = 7,
    StockScrap = 8,
    StockOpening = 9,
    StockMove = 10,
    StockTransfer = 11,
    StockPicking = 20,
    CreditNote = 50,
    PurchaseCreditNote = 51,
    PurchaseTemplate = 101,
    SaleTemplate = 102,
    Basket = 200,
    SalesQuote = 202,
    ExternalShopOrder = 302,
}

export class OrderlineModel implements IOrderlineModel {
    id?: string;
    quantity?: number;
    actualQuantity?: number;
    unitPrice?: number;
    price?: number;
    unit?: string | undefined;
    name?: string | undefined;
    sku?: string | undefined;
    ean?: string | undefined;
    caseEan?: string | undefined;
    orderId?: string;
    productVariantId?: string | undefined;
    productName?: string | undefined;
    productVariantName?: string | undefined;
    caseTypeName?: string | undefined;
    productType?: string | undefined;
    bundle?: string | undefined;
    isBundlePart?: boolean | undefined;
    comments?: string | undefined;
    remaining?: boolean | undefined;
    type?: OrderlineType;
    status?: OrderlineStatus;
    date?: Date;
    unitCostPrice?: number;
    actualUnitPrice?: number;
    actualUnitCostPrice?: number;
    lot?: LotModel | undefined;
    referenceEntityId?: string | undefined;
    organicCheck?: boolean | undefined;
    externalId?: string | undefined;
    productionOrderId?: string | undefined;
    sortOrder?: number | undefined;
    internalNote?: string | undefined;
    stockLocationId?: string | undefined;
    stockPositionId?: string | undefined;
    cost?: number;
    currency?: string | undefined;
    discount?: number;
    stockLevel?: number;
    stockAvailable?: number;
    unitCount?: number;
    caseCount?: number;
    netWeight?: number;
    grossWeight?: number;
    sscc?: string | undefined;
    warnings?: string | undefined;
    supplierSku?: string | undefined;
    supplierProductName?: string | undefined;
    lineText?: string | undefined;
    lotName?: string | undefined;
    deliveredQuantity?: number;
    profitMargin?: number;
    orderDeadline?: Date | undefined;
    palletNumber?: number;
    palletSortOrder?: number;
    palletCount?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IOrderlineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.actualQuantity = _data["actualQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.price = _data["price"];
            this.unit = _data["unit"];
            this.name = _data["name"];
            this.sku = _data["sku"];
            this.ean = _data["ean"];
            this.caseEan = _data["caseEan"];
            this.orderId = _data["orderId"];
            this.productVariantId = _data["productVariantId"];
            this.productName = _data["productName"];
            this.productVariantName = _data["productVariantName"];
            this.caseTypeName = _data["caseTypeName"];
            this.productType = _data["productType"];
            this.bundle = _data["bundle"];
            this.isBundlePart = _data["isBundlePart"];
            this.comments = _data["comments"];
            this.remaining = _data["remaining"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.unitCostPrice = _data["unitCostPrice"];
            this.actualUnitPrice = _data["actualUnitPrice"];
            this.actualUnitCostPrice = _data["actualUnitCostPrice"];
            this.lot = _data["lot"] ? LotModel.fromJS(_data["lot"]) : undefined as any;
            this.referenceEntityId = _data["referenceEntityId"];
            this.organicCheck = _data["organicCheck"];
            this.externalId = _data["externalId"];
            this.productionOrderId = _data["productionOrderId"];
            this.sortOrder = _data["sortOrder"];
            this.internalNote = _data["internalNote"];
            this.stockLocationId = _data["stockLocationId"];
            this.stockPositionId = _data["stockPositionId"];
            this.cost = _data["cost"];
            this.currency = _data["currency"];
            this.discount = _data["discount"];
            this.stockLevel = _data["stockLevel"];
            this.stockAvailable = _data["stockAvailable"];
            this.unitCount = _data["unitCount"];
            this.caseCount = _data["caseCount"];
            this.netWeight = _data["netWeight"];
            this.grossWeight = _data["grossWeight"];
            this.sscc = _data["sscc"];
            this.warnings = _data["warnings"];
            this.supplierSku = _data["supplierSku"];
            this.supplierProductName = _data["supplierProductName"];
            this.lineText = _data["lineText"];
            this.lotName = _data["lotName"];
            this.deliveredQuantity = _data["deliveredQuantity"];
            this.profitMargin = _data["profitMargin"];
            this.orderDeadline = _data["orderDeadline"] ? new Date(_data["orderDeadline"].toString()) : undefined as any;
            this.palletNumber = _data["palletNumber"];
            this.palletSortOrder = _data["palletSortOrder"];
            this.palletCount = _data["palletCount"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): OrderlineModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderlineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["actualQuantity"] = this.actualQuantity;
        data["unitPrice"] = this.unitPrice;
        data["price"] = this.price;
        data["unit"] = this.unit;
        data["name"] = this.name;
        data["sku"] = this.sku;
        data["ean"] = this.ean;
        data["caseEan"] = this.caseEan;
        data["orderId"] = this.orderId;
        data["productVariantId"] = this.productVariantId;
        data["productName"] = this.productName;
        data["productVariantName"] = this.productVariantName;
        data["caseTypeName"] = this.caseTypeName;
        data["productType"] = this.productType;
        data["bundle"] = this.bundle;
        data["isBundlePart"] = this.isBundlePart;
        data["comments"] = this.comments;
        data["remaining"] = this.remaining;
        data["type"] = this.type;
        data["status"] = this.status;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["unitCostPrice"] = this.unitCostPrice;
        data["actualUnitPrice"] = this.actualUnitPrice;
        data["actualUnitCostPrice"] = this.actualUnitCostPrice;
        data["lot"] = this.lot ? this.lot.toJSON() : undefined as any;
        data["referenceEntityId"] = this.referenceEntityId;
        data["organicCheck"] = this.organicCheck;
        data["externalId"] = this.externalId;
        data["productionOrderId"] = this.productionOrderId;
        data["sortOrder"] = this.sortOrder;
        data["internalNote"] = this.internalNote;
        data["stockLocationId"] = this.stockLocationId;
        data["stockPositionId"] = this.stockPositionId;
        data["cost"] = this.cost;
        data["currency"] = this.currency;
        data["discount"] = this.discount;
        data["stockLevel"] = this.stockLevel;
        data["stockAvailable"] = this.stockAvailable;
        data["unitCount"] = this.unitCount;
        data["caseCount"] = this.caseCount;
        data["netWeight"] = this.netWeight;
        data["grossWeight"] = this.grossWeight;
        data["sscc"] = this.sscc;
        data["warnings"] = this.warnings;
        data["supplierSku"] = this.supplierSku;
        data["supplierProductName"] = this.supplierProductName;
        data["lineText"] = this.lineText;
        data["lotName"] = this.lotName;
        data["deliveredQuantity"] = this.deliveredQuantity;
        data["profitMargin"] = this.profitMargin;
        data["orderDeadline"] = this.orderDeadline ? this.orderDeadline.toISOString() : undefined as any;
        data["palletNumber"] = this.palletNumber;
        data["palletSortOrder"] = this.palletSortOrder;
        data["palletCount"] = this.palletCount;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): OrderlineModel {
        const json = this.toJSON();
        let result = new OrderlineModel();
        result.init(json);
        return result;
    }
}

export interface IOrderlineModel {
    id?: string;
    quantity?: number;
    actualQuantity?: number;
    unitPrice?: number;
    price?: number;
    unit?: string | undefined;
    name?: string | undefined;
    sku?: string | undefined;
    ean?: string | undefined;
    caseEan?: string | undefined;
    orderId?: string;
    productVariantId?: string | undefined;
    productName?: string | undefined;
    productVariantName?: string | undefined;
    caseTypeName?: string | undefined;
    productType?: string | undefined;
    bundle?: string | undefined;
    isBundlePart?: boolean | undefined;
    comments?: string | undefined;
    remaining?: boolean | undefined;
    type?: OrderlineType;
    status?: OrderlineStatus;
    date?: Date;
    unitCostPrice?: number;
    actualUnitPrice?: number;
    actualUnitCostPrice?: number;
    lot?: LotModel | undefined;
    referenceEntityId?: string | undefined;
    organicCheck?: boolean | undefined;
    externalId?: string | undefined;
    productionOrderId?: string | undefined;
    sortOrder?: number | undefined;
    internalNote?: string | undefined;
    stockLocationId?: string | undefined;
    stockPositionId?: string | undefined;
    cost?: number;
    currency?: string | undefined;
    discount?: number;
    stockLevel?: number;
    stockAvailable?: number;
    unitCount?: number;
    caseCount?: number;
    netWeight?: number;
    grossWeight?: number;
    sscc?: string | undefined;
    warnings?: string | undefined;
    supplierSku?: string | undefined;
    supplierProductName?: string | undefined;
    lineText?: string | undefined;
    lotName?: string | undefined;
    deliveredQuantity?: number;
    profitMargin?: number;
    orderDeadline?: Date | undefined;
    palletNumber?: number;
    palletSortOrder?: number;
    palletCount?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum OrderlineType {
    None = 0,
    Purchase = 1,
    Sale = 2,
    Production = 3,
    ProductionAlternative = 4,
    StockTake = 5,
    StockAdjustment = 6,
    StockLoss = 7,
    StockScrap = 8,
    StockOpening = 9,
    ProductionOutput = 10,
    ProductionLossWater = 11,
    StockTakeLot = 12,
    StockMoveFrom = 13,
    StockMoveTo = 14,
    StockTransferFrom = 15,
    StockTransferTo = 16,
    CreditNote = 50,
    PurchaseCreditNote = 51,
    PurchaseTemplate = 101,
    SaleTemplate = 102,
    Basket = 200,
    SalesQuote = 202,
    ExternalShopOrderline = 302,
}

export enum OrderlineStatus {
    Draft = 0,
    Planned = 1,
    Started = 2,
    Finished = 3,
    Approved = 5,
    Delivered = 6,
    Invoiced = 7,
    Reserved = 8,
    Estimated = 9,
    ReadyForDelivery = 10,
    ReadyForPicking = 11,
    Picked = 12,
    Overdue = 13,
}

export class LotModel implements ILotModel {
    id?: string;
    productVariantId?: string;
    name?: string | undefined;
    status?: OrderlineLotStatus;
    transactionCount?: number;
    productionDate?: Date | undefined;
    expirationDate?: Date | undefined;
    origin?: string | undefined;
    supplierId?: string | undefined;
    available?: number;
    availableWeightVolume?: number;
    reserved?: number;
    reservedWeightVolume?: number | undefined;
    quantity?: number | undefined;
    totalWeightVolume?: number | undefined;
    stockLocationName?: string | undefined;
    stockLocationId?: string | undefined;
    stockPositions?: StockPositionModel[] | undefined;
    unit?: string | undefined;
    supplierLotName?: string | undefined;
    created?: Date | undefined;

    constructor(data?: ILotModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productVariantId = _data["productVariantId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.transactionCount = _data["transactionCount"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : undefined as any;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.origin = _data["origin"];
            this.supplierId = _data["supplierId"];
            this.available = _data["available"];
            this.availableWeightVolume = _data["availableWeightVolume"];
            this.reserved = _data["reserved"];
            this.reservedWeightVolume = _data["reservedWeightVolume"];
            this.quantity = _data["quantity"];
            this.totalWeightVolume = _data["totalWeightVolume"];
            this.stockLocationName = _data["stockLocationName"];
            this.stockLocationId = _data["stockLocationId"];
            if (Array.isArray(_data["stockPositions"])) {
                this.stockPositions = [] as any;
                for (let item of _data["stockPositions"])
                    this.stockPositions!.push(StockPositionModel.fromJS(item));
            }
            this.unit = _data["unit"];
            this.supplierLotName = _data["supplierLotName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LotModel {
        data = typeof data === 'object' ? data : {};
        let result = new LotModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productVariantId"] = this.productVariantId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["transactionCount"] = this.transactionCount;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : undefined as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["origin"] = this.origin;
        data["supplierId"] = this.supplierId;
        data["available"] = this.available;
        data["availableWeightVolume"] = this.availableWeightVolume;
        data["reserved"] = this.reserved;
        data["reservedWeightVolume"] = this.reservedWeightVolume;
        data["quantity"] = this.quantity;
        data["totalWeightVolume"] = this.totalWeightVolume;
        data["stockLocationName"] = this.stockLocationName;
        data["stockLocationId"] = this.stockLocationId;
        if (Array.isArray(this.stockPositions)) {
            data["stockPositions"] = [];
            for (let item of this.stockPositions)
                data["stockPositions"].push(item ? item.toJSON() : undefined as any);
        }
        data["unit"] = this.unit;
        data["supplierLotName"] = this.supplierLotName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        return data;
    }

    clone(): LotModel {
        const json = this.toJSON();
        let result = new LotModel();
        result.init(json);
        return result;
    }
}

export interface ILotModel {
    id?: string;
    productVariantId?: string;
    name?: string | undefined;
    status?: OrderlineLotStatus;
    transactionCount?: number;
    productionDate?: Date | undefined;
    expirationDate?: Date | undefined;
    origin?: string | undefined;
    supplierId?: string | undefined;
    available?: number;
    availableWeightVolume?: number;
    reserved?: number;
    reservedWeightVolume?: number | undefined;
    quantity?: number | undefined;
    totalWeightVolume?: number | undefined;
    stockLocationName?: string | undefined;
    stockLocationId?: string | undefined;
    stockPositions?: StockPositionModel[] | undefined;
    unit?: string | undefined;
    supplierLotName?: string | undefined;
    created?: Date | undefined;
}

export enum OrderlineLotStatus {
    Created = 0,
    Updated = 1,
    Completed = 2,
    Barred = 3,
}

export class StockPositionModel implements IStockPositionModel {
    id?: string;
    name?: string | undefined;
    stockLocationId?: string;
    parentId?: string | undefined;
    positionTypeId?: string;
    positionTypeName?: string | undefined;
    positionText?: string | undefined;
    stockLocationName?: string | undefined;
    sortOrder?: number;
    children?: StockPositionModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IStockPositionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.stockLocationId = _data["stockLocationId"];
            this.parentId = _data["parentId"];
            this.positionTypeId = _data["positionTypeId"];
            this.positionTypeName = _data["positionTypeName"];
            this.positionText = _data["positionText"];
            this.stockLocationName = _data["stockLocationName"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(StockPositionModel.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): StockPositionModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockPositionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["stockLocationId"] = this.stockLocationId;
        data["parentId"] = this.parentId;
        data["positionTypeId"] = this.positionTypeId;
        data["positionTypeName"] = this.positionTypeName;
        data["positionText"] = this.positionText;
        data["stockLocationName"] = this.stockLocationName;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): StockPositionModel {
        const json = this.toJSON();
        let result = new StockPositionModel();
        result.init(json);
        return result;
    }
}

export interface IStockPositionModel {
    id?: string;
    name?: string | undefined;
    stockLocationId?: string;
    parentId?: string | undefined;
    positionTypeId?: string;
    positionTypeName?: string | undefined;
    positionText?: string | undefined;
    stockLocationName?: string | undefined;
    sortOrder?: number;
    children?: StockPositionModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum OrderStatus {
    Draft = 0,
    Sent = 1,
    Confirmed = 2,
    Fulfilled = 3,
    DirectFulfill = 4,
    Approved = 5,
    Invoiced = 6,
    Reserved = 7,
    ReadyForDelivery = 8,
    ReadyForPicking = 9,
    Picked = 10,
}

export enum FinanceStatus {
    None = 0,
    Invoiced = 1,
    Booked = 2,
    Payed = 3,
}

export class PagedResultOfOrderModel extends PagedResultBase implements IPagedResultOfOrderModel {
    results?: OrderModel[];

    constructor(data?: IPagedResultOfOrderModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(OrderModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfOrderModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfOrderModel {
        const json = this.toJSON();
        let result = new PagedResultOfOrderModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfOrderModel extends IPagedResultBase {
    results?: OrderModel[];
}

export class LabelInfoModel implements ILabelInfoModel {
    quantity?: number;
    productVariantId?: string;
    name?: string | undefined;
    sku?: string | undefined;
    productionDate?: Date | undefined;
    bestBeforeDate?: Date | undefined;
    lotName?: string | undefined;
    orderlineId?: string | undefined;
    labelId?: string;

    constructor(data?: ILabelInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.productVariantId = _data["productVariantId"];
            this.name = _data["name"];
            this.sku = _data["sku"];
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : undefined as any;
            this.bestBeforeDate = _data["bestBeforeDate"] ? new Date(_data["bestBeforeDate"].toString()) : undefined as any;
            this.lotName = _data["lotName"];
            this.orderlineId = _data["orderlineId"];
            this.labelId = _data["labelId"];
        }
    }

    static fromJS(data: any): LabelInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new LabelInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["productVariantId"] = this.productVariantId;
        data["name"] = this.name;
        data["sku"] = this.sku;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : undefined as any;
        data["bestBeforeDate"] = this.bestBeforeDate ? this.bestBeforeDate.toISOString() : undefined as any;
        data["lotName"] = this.lotName;
        data["orderlineId"] = this.orderlineId;
        data["labelId"] = this.labelId;
        return data;
    }

    clone(): LabelInfoModel {
        const json = this.toJSON();
        let result = new LabelInfoModel();
        result.init(json);
        return result;
    }
}

export interface ILabelInfoModel {
    quantity?: number;
    productVariantId?: string;
    name?: string | undefined;
    sku?: string | undefined;
    productionDate?: Date | undefined;
    bestBeforeDate?: Date | undefined;
    lotName?: string | undefined;
    orderlineId?: string | undefined;
    labelId?: string;
}

export class SendNotificationModel implements ISendNotificationModel {
    orderId?: string;
    emails?: AddressModel[] | undefined;
    bccEmails?: AddressModel[] | undefined;
    templateId?: string;
    orderStatus?: OrderStatus;
    emailSubject?: string | undefined;
    emailBody?: string | undefined;
    lines?: string | undefined;

    constructor(data?: ISendNotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(AddressModel.fromJS(item));
            }
            if (Array.isArray(_data["bccEmails"])) {
                this.bccEmails = [] as any;
                for (let item of _data["bccEmails"])
                    this.bccEmails!.push(AddressModel.fromJS(item));
            }
            this.templateId = _data["templateId"];
            this.orderStatus = _data["orderStatus"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.lines = _data["lines"];
        }
    }

    static fromJS(data: any): SendNotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bccEmails)) {
            data["bccEmails"] = [];
            for (let item of this.bccEmails)
                data["bccEmails"].push(item ? item.toJSON() : undefined as any);
        }
        data["templateId"] = this.templateId;
        data["orderStatus"] = this.orderStatus;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["lines"] = this.lines;
        return data;
    }

    clone(): SendNotificationModel {
        const json = this.toJSON();
        let result = new SendNotificationModel();
        result.init(json);
        return result;
    }
}

export interface ISendNotificationModel {
    orderId?: string;
    emails?: AddressModel[] | undefined;
    bccEmails?: AddressModel[] | undefined;
    templateId?: string;
    orderStatus?: OrderStatus;
    emailSubject?: string | undefined;
    emailBody?: string | undefined;
    lines?: string | undefined;
}

export class CreatePurchaseOrdersModel implements ICreatePurchaseOrdersModel {
    items?: StockItemModel[] | undefined;
    id?: string;
    noStockLevels?: boolean;

    constructor(data?: ICreatePurchaseOrdersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StockItemModel.fromJS(item));
            }
            this.id = _data["id"];
            this.noStockLevels = _data["noStockLevels"];
        }
    }

    static fromJS(data: any): CreatePurchaseOrdersModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrdersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["noStockLevels"] = this.noStockLevels;
        return data;
    }

    clone(): CreatePurchaseOrdersModel {
        const json = this.toJSON();
        let result = new CreatePurchaseOrdersModel();
        result.init(json);
        return result;
    }
}

export interface ICreatePurchaseOrdersModel {
    items?: StockItemModel[] | undefined;
    id?: string;
    noStockLevels?: boolean;
}

export class StockItemModel implements IStockItemModel {
    id?: string;
    quantity?: number;
    quantityCount?: number | undefined;
    quantityIn?: number;
    quantityOut?: number;
    quantityPlannedIn?: number;
    quantityPlannedOut?: number;
    quantityStart?: number;
    quantityReserved?: number;
    quantityOrdered?: number;
    quantityAvailable?: number;
    totalWeightVolume?: number;
    totalWeightVolumeCount?: number | undefined;
    totalWeightVolumeIn?: number;
    totalWeightVolumeOut?: number;
    totalWeightVolumeStart?: number;
    totalWeightVolumeReserved?: number;
    totalWeightVolumeOrdered?: number;
    totalWeightVolumeAvailable?: number;
    unitCostPrice?: number;
    totalCostPrice?: number;
    totalSalesPrice?: number;
    profit?: number;
    contributionMarginRatio?: number;
    minimumStockLevel?: number;
    lotName?: string | undefined;
    lastStockTake?: Date | undefined;
    startDate?: Date;
    expirationDate?: Date | undefined;
    unit?: string | undefined;
    unitQuantity?: number;
    colliSize?: number;
    productVariantId?: string;
    productId?: string;
    productGroupId?: string;
    stockTransactions?: StockTransactionModel[] | undefined;
    stockItemLots?: LotModel[] | undefined;
    productName?: string | undefined;
    productVariantName?: string | undefined;
    supplier?: IdNameModel | undefined;
    sku?: string | undefined;
    ean?: string | undefined;
    isOrganic?: boolean;
    isTraceable?: boolean;
    comments?: string | undefined;
    salesOrderId?: string | undefined;
    salesOrderlineIds?: string[] | undefined;
    type?: string | undefined;
    variantType?: VariantType;
    hasRecipe?: boolean;
    deliveryRatio?: number;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: IStockItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.quantityCount = _data["quantityCount"];
            this.quantityIn = _data["quantityIn"];
            this.quantityOut = _data["quantityOut"];
            this.quantityPlannedIn = _data["quantityPlannedIn"];
            this.quantityPlannedOut = _data["quantityPlannedOut"];
            this.quantityStart = _data["quantityStart"];
            this.quantityReserved = _data["quantityReserved"];
            this.quantityOrdered = _data["quantityOrdered"];
            this.quantityAvailable = _data["quantityAvailable"];
            this.totalWeightVolume = _data["totalWeightVolume"];
            this.totalWeightVolumeCount = _data["totalWeightVolumeCount"];
            this.totalWeightVolumeIn = _data["totalWeightVolumeIn"];
            this.totalWeightVolumeOut = _data["totalWeightVolumeOut"];
            this.totalWeightVolumeStart = _data["totalWeightVolumeStart"];
            this.totalWeightVolumeReserved = _data["totalWeightVolumeReserved"];
            this.totalWeightVolumeOrdered = _data["totalWeightVolumeOrdered"];
            this.totalWeightVolumeAvailable = _data["totalWeightVolumeAvailable"];
            this.unitCostPrice = _data["unitCostPrice"];
            this.totalCostPrice = _data["totalCostPrice"];
            this.totalSalesPrice = _data["totalSalesPrice"];
            this.profit = _data["profit"];
            this.contributionMarginRatio = _data["contributionMarginRatio"];
            this.minimumStockLevel = _data["minimumStockLevel"];
            this.lotName = _data["lotName"];
            this.lastStockTake = _data["lastStockTake"] ? new Date(_data["lastStockTake"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.unit = _data["unit"];
            this.unitQuantity = _data["unitQuantity"];
            this.colliSize = _data["colliSize"];
            this.productVariantId = _data["productVariantId"];
            this.productId = _data["productId"];
            this.productGroupId = _data["productGroupId"];
            if (Array.isArray(_data["stockTransactions"])) {
                this.stockTransactions = [] as any;
                for (let item of _data["stockTransactions"])
                    this.stockTransactions!.push(StockTransactionModel.fromJS(item));
            }
            if (Array.isArray(_data["stockItemLots"])) {
                this.stockItemLots = [] as any;
                for (let item of _data["stockItemLots"])
                    this.stockItemLots!.push(LotModel.fromJS(item));
            }
            this.productName = _data["productName"];
            this.productVariantName = _data["productVariantName"];
            this.supplier = _data["supplier"] ? IdNameModel.fromJS(_data["supplier"]) : undefined as any;
            this.sku = _data["sku"];
            this.ean = _data["ean"];
            this.isOrganic = _data["isOrganic"];
            this.isTraceable = _data["isTraceable"];
            this.comments = _data["comments"];
            this.salesOrderId = _data["salesOrderId"];
            if (Array.isArray(_data["salesOrderlineIds"])) {
                this.salesOrderlineIds = [] as any;
                for (let item of _data["salesOrderlineIds"])
                    this.salesOrderlineIds!.push(item);
            }
            this.type = _data["type"];
            this.variantType = _data["variantType"];
            this.hasRecipe = _data["hasRecipe"];
            this.deliveryRatio = _data["deliveryRatio"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): StockItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["quantityCount"] = this.quantityCount;
        data["quantityIn"] = this.quantityIn;
        data["quantityOut"] = this.quantityOut;
        data["quantityPlannedIn"] = this.quantityPlannedIn;
        data["quantityPlannedOut"] = this.quantityPlannedOut;
        data["quantityStart"] = this.quantityStart;
        data["quantityReserved"] = this.quantityReserved;
        data["quantityOrdered"] = this.quantityOrdered;
        data["quantityAvailable"] = this.quantityAvailable;
        data["totalWeightVolume"] = this.totalWeightVolume;
        data["totalWeightVolumeCount"] = this.totalWeightVolumeCount;
        data["totalWeightVolumeIn"] = this.totalWeightVolumeIn;
        data["totalWeightVolumeOut"] = this.totalWeightVolumeOut;
        data["totalWeightVolumeStart"] = this.totalWeightVolumeStart;
        data["totalWeightVolumeReserved"] = this.totalWeightVolumeReserved;
        data["totalWeightVolumeOrdered"] = this.totalWeightVolumeOrdered;
        data["totalWeightVolumeAvailable"] = this.totalWeightVolumeAvailable;
        data["unitCostPrice"] = this.unitCostPrice;
        data["totalCostPrice"] = this.totalCostPrice;
        data["totalSalesPrice"] = this.totalSalesPrice;
        data["profit"] = this.profit;
        data["contributionMarginRatio"] = this.contributionMarginRatio;
        data["minimumStockLevel"] = this.minimumStockLevel;
        data["lotName"] = this.lotName;
        data["lastStockTake"] = this.lastStockTake ? this.lastStockTake.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["unit"] = this.unit;
        data["unitQuantity"] = this.unitQuantity;
        data["colliSize"] = this.colliSize;
        data["productVariantId"] = this.productVariantId;
        data["productId"] = this.productId;
        data["productGroupId"] = this.productGroupId;
        if (Array.isArray(this.stockTransactions)) {
            data["stockTransactions"] = [];
            for (let item of this.stockTransactions)
                data["stockTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.stockItemLots)) {
            data["stockItemLots"] = [];
            for (let item of this.stockItemLots)
                data["stockItemLots"].push(item ? item.toJSON() : undefined as any);
        }
        data["productName"] = this.productName;
        data["productVariantName"] = this.productVariantName;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined as any;
        data["sku"] = this.sku;
        data["ean"] = this.ean;
        data["isOrganic"] = this.isOrganic;
        data["isTraceable"] = this.isTraceable;
        data["comments"] = this.comments;
        data["salesOrderId"] = this.salesOrderId;
        if (Array.isArray(this.salesOrderlineIds)) {
            data["salesOrderlineIds"] = [];
            for (let item of this.salesOrderlineIds)
                data["salesOrderlineIds"].push(item);
        }
        data["type"] = this.type;
        data["variantType"] = this.variantType;
        data["hasRecipe"] = this.hasRecipe;
        data["deliveryRatio"] = this.deliveryRatio;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): StockItemModel {
        const json = this.toJSON();
        let result = new StockItemModel();
        result.init(json);
        return result;
    }
}

export interface IStockItemModel {
    id?: string;
    quantity?: number;
    quantityCount?: number | undefined;
    quantityIn?: number;
    quantityOut?: number;
    quantityPlannedIn?: number;
    quantityPlannedOut?: number;
    quantityStart?: number;
    quantityReserved?: number;
    quantityOrdered?: number;
    quantityAvailable?: number;
    totalWeightVolume?: number;
    totalWeightVolumeCount?: number | undefined;
    totalWeightVolumeIn?: number;
    totalWeightVolumeOut?: number;
    totalWeightVolumeStart?: number;
    totalWeightVolumeReserved?: number;
    totalWeightVolumeOrdered?: number;
    totalWeightVolumeAvailable?: number;
    unitCostPrice?: number;
    totalCostPrice?: number;
    totalSalesPrice?: number;
    profit?: number;
    contributionMarginRatio?: number;
    minimumStockLevel?: number;
    lotName?: string | undefined;
    lastStockTake?: Date | undefined;
    startDate?: Date;
    expirationDate?: Date | undefined;
    unit?: string | undefined;
    unitQuantity?: number;
    colliSize?: number;
    productVariantId?: string;
    productId?: string;
    productGroupId?: string;
    stockTransactions?: StockTransactionModel[] | undefined;
    stockItemLots?: LotModel[] | undefined;
    productName?: string | undefined;
    productVariantName?: string | undefined;
    supplier?: IdNameModel | undefined;
    sku?: string | undefined;
    ean?: string | undefined;
    isOrganic?: boolean;
    isTraceable?: boolean;
    comments?: string | undefined;
    salesOrderId?: string | undefined;
    salesOrderlineIds?: string[] | undefined;
    type?: string | undefined;
    variantType?: VariantType;
    hasRecipe?: boolean;
    deliveryRatio?: number;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
}

export class StockTransactionModel implements IStockTransactionModel {
    id?: string;
    quantity?: number;
    actualUnitCost?: number;
    totalWeightVolume?: number;
    plannedQuantity?: number;
    plannedTotalWeightVolume?: number;
    stockId?: string;
    stockLocationId?: string | undefined;
    stockLocationName?: string | undefined;
    stockPositionId?: string | undefined;
    stockPositionName?: string | undefined;
    type?: OrderlineType;
    typeText?: string | undefined;
    transactionId?: string;
    transactionDate?: Date;
    lotName?: string | undefined;
    lotId?: string;
    orderName?: string | undefined;
    orderId?: string;
    unit?: string | undefined;
    status?: OrderlineStatus;
    statusText?: string | undefined;
    calculatedUnitCost?: number;
    quantityBalance?: number;
    actualUnitSalesPrice?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IStockTransactionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.actualUnitCost = _data["actualUnitCost"];
            this.totalWeightVolume = _data["totalWeightVolume"];
            this.plannedQuantity = _data["plannedQuantity"];
            this.plannedTotalWeightVolume = _data["plannedTotalWeightVolume"];
            this.stockId = _data["stockId"];
            this.stockLocationId = _data["stockLocationId"];
            this.stockLocationName = _data["stockLocationName"];
            this.stockPositionId = _data["stockPositionId"];
            this.stockPositionName = _data["stockPositionName"];
            this.type = _data["type"];
            this.typeText = _data["typeText"];
            this.transactionId = _data["transactionId"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : undefined as any;
            this.lotName = _data["lotName"];
            this.lotId = _data["lotId"];
            this.orderName = _data["orderName"];
            this.orderId = _data["orderId"];
            this.unit = _data["unit"];
            this.status = _data["status"];
            this.statusText = _data["statusText"];
            this.calculatedUnitCost = _data["calculatedUnitCost"];
            this.quantityBalance = _data["quantityBalance"];
            this.actualUnitSalesPrice = _data["actualUnitSalesPrice"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): StockTransactionModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockTransactionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["actualUnitCost"] = this.actualUnitCost;
        data["totalWeightVolume"] = this.totalWeightVolume;
        data["plannedQuantity"] = this.plannedQuantity;
        data["plannedTotalWeightVolume"] = this.plannedTotalWeightVolume;
        data["stockId"] = this.stockId;
        data["stockLocationId"] = this.stockLocationId;
        data["stockLocationName"] = this.stockLocationName;
        data["stockPositionId"] = this.stockPositionId;
        data["stockPositionName"] = this.stockPositionName;
        data["type"] = this.type;
        data["typeText"] = this.typeText;
        data["transactionId"] = this.transactionId;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : undefined as any;
        data["lotName"] = this.lotName;
        data["lotId"] = this.lotId;
        data["orderName"] = this.orderName;
        data["orderId"] = this.orderId;
        data["unit"] = this.unit;
        data["status"] = this.status;
        data["statusText"] = this.statusText;
        data["calculatedUnitCost"] = this.calculatedUnitCost;
        data["quantityBalance"] = this.quantityBalance;
        data["actualUnitSalesPrice"] = this.actualUnitSalesPrice;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): StockTransactionModel {
        const json = this.toJSON();
        let result = new StockTransactionModel();
        result.init(json);
        return result;
    }
}

export interface IStockTransactionModel {
    id?: string;
    quantity?: number;
    actualUnitCost?: number;
    totalWeightVolume?: number;
    plannedQuantity?: number;
    plannedTotalWeightVolume?: number;
    stockId?: string;
    stockLocationId?: string | undefined;
    stockLocationName?: string | undefined;
    stockPositionId?: string | undefined;
    stockPositionName?: string | undefined;
    type?: OrderlineType;
    typeText?: string | undefined;
    transactionId?: string;
    transactionDate?: Date;
    lotName?: string | undefined;
    lotId?: string;
    orderName?: string | undefined;
    orderId?: string;
    unit?: string | undefined;
    status?: OrderlineStatus;
    statusText?: string | undefined;
    calculatedUnitCost?: number;
    quantityBalance?: number;
    actualUnitSalesPrice?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum VariantType {
    Each = 0,
    Case = 1,
    Pallet = 2,
}

export class CreatePurchaseOrdersFromForecastModel implements ICreatePurchaseOrdersFromForecastModel {
    items?: PurchaseForecastItem[] | undefined;
    id?: string;
    noStockLevels?: boolean;

    constructor(data?: ICreatePurchaseOrdersFromForecastModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PurchaseForecastItem.fromJS(item));
            }
            this.id = _data["id"];
            this.noStockLevels = _data["noStockLevels"];
        }
    }

    static fromJS(data: any): CreatePurchaseOrdersFromForecastModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrdersFromForecastModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["noStockLevels"] = this.noStockLevels;
        return data;
    }

    clone(): CreatePurchaseOrdersFromForecastModel {
        const json = this.toJSON();
        let result = new CreatePurchaseOrdersFromForecastModel();
        result.init(json);
        return result;
    }
}

export interface ICreatePurchaseOrdersFromForecastModel {
    items?: PurchaseForecastItem[] | undefined;
    id?: string;
    noStockLevels?: boolean;
}

export class PurchaseForecastItem implements IPurchaseForecastItem {
    productVariantId?: string;
    sku?: string | undefined;
    productName?: string | undefined;
    supplierId?: string;
    supplierName?: string | undefined;
    minimumLevel?: number;
    forecastLevels?: number[] | undefined;
    consumption?: number[] | undefined;
    purchases?: number[] | undefined;
    startTime?: Date;
    endTime?: Date;
    daysPerPeriod?: number;
    quantityToOrder?: number;

    constructor(data?: IPurchaseForecastItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productVariantId = _data["productVariantId"];
            this.sku = _data["sku"];
            this.productName = _data["productName"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.minimumLevel = _data["minimumLevel"];
            if (Array.isArray(_data["forecastLevels"])) {
                this.forecastLevels = [] as any;
                for (let item of _data["forecastLevels"])
                    this.forecastLevels!.push(item);
            }
            if (Array.isArray(_data["consumption"])) {
                this.consumption = [] as any;
                for (let item of _data["consumption"])
                    this.consumption!.push(item);
            }
            if (Array.isArray(_data["purchases"])) {
                this.purchases = [] as any;
                for (let item of _data["purchases"])
                    this.purchases!.push(item);
            }
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.daysPerPeriod = _data["daysPerPeriod"];
            this.quantityToOrder = _data["quantityToOrder"];
        }
    }

    static fromJS(data: any): PurchaseForecastItem {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseForecastItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productVariantId"] = this.productVariantId;
        data["sku"] = this.sku;
        data["productName"] = this.productName;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["minimumLevel"] = this.minimumLevel;
        if (Array.isArray(this.forecastLevels)) {
            data["forecastLevels"] = [];
            for (let item of this.forecastLevels)
                data["forecastLevels"].push(item);
        }
        if (Array.isArray(this.consumption)) {
            data["consumption"] = [];
            for (let item of this.consumption)
                data["consumption"].push(item);
        }
        if (Array.isArray(this.purchases)) {
            data["purchases"] = [];
            for (let item of this.purchases)
                data["purchases"].push(item);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["daysPerPeriod"] = this.daysPerPeriod;
        data["quantityToOrder"] = this.quantityToOrder;
        return data;
    }

    clone(): PurchaseForecastItem {
        const json = this.toJSON();
        let result = new PurchaseForecastItem();
        result.init(json);
        return result;
    }
}

export interface IPurchaseForecastItem {
    productVariantId?: string;
    sku?: string | undefined;
    productName?: string | undefined;
    supplierId?: string;
    supplierName?: string | undefined;
    minimumLevel?: number;
    forecastLevels?: number[] | undefined;
    consumption?: number[] | undefined;
    purchases?: number[] | undefined;
    startTime?: Date;
    endTime?: Date;
    daysPerPeriod?: number;
    quantityToOrder?: number;
}

export class BulkInvoiceModel implements IBulkInvoiceModel {
    orders?: OrderModel[] | undefined;
    userId?: string;

    constructor(data?: IBulkInvoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderModel.fromJS(item));
            }
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): BulkInvoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new BulkInvoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : undefined as any);
        }
        data["userId"] = this.userId;
        return data;
    }

    clone(): BulkInvoiceModel {
        const json = this.toJSON();
        let result = new BulkInvoiceModel();
        result.init(json);
        return result;
    }
}

export interface IBulkInvoiceModel {
    orders?: OrderModel[] | undefined;
    userId?: string;
}

export class BulkSendNotificationModel implements IBulkSendNotificationModel {
    orders?: OrderModel[] | undefined;
    templateId?: string;
    emailSubject?: string | undefined;
    emailBody?: string | undefined;

    constructor(data?: IBulkSendNotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderModel.fromJS(item));
            }
            this.templateId = _data["templateId"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
        }
    }

    static fromJS(data: any): BulkSendNotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new BulkSendNotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : undefined as any);
        }
        data["templateId"] = this.templateId;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        return data;
    }

    clone(): BulkSendNotificationModel {
        const json = this.toJSON();
        let result = new BulkSendNotificationModel();
        result.init(json);
        return result;
    }
}

export interface IBulkSendNotificationModel {
    orders?: OrderModel[] | undefined;
    templateId?: string;
    emailSubject?: string | undefined;
    emailBody?: string | undefined;
}

export class SalesMatrixModel implements ISalesMatrixModel {
    products?: SalesMatrixProductModel[] | undefined;
    customers?: SalesMatrixLineModel[] | undefined;
    total?: number;
    matrix?: number[][] | undefined;

    constructor(data?: ISalesMatrixModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(SalesMatrixProductModel.fromJS(item));
            }
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(SalesMatrixLineModel.fromJS(item));
            }
            this.total = _data["total"];
            if (Array.isArray(_data["matrix"])) {
                this.matrix = [] as any;
                for (let item of _data["matrix"])
                    this.matrix!.push(item);
            }
        }
    }

    static fromJS(data: any): SalesMatrixModel {
        data = typeof data === 'object' ? data : {};
        let result = new SalesMatrixModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        if (Array.isArray(this.matrix)) {
            data["matrix"] = [];
            for (let item of this.matrix)
                data["matrix"].push(item);
        }
        return data;
    }

    clone(): SalesMatrixModel {
        const json = this.toJSON();
        let result = new SalesMatrixModel();
        result.init(json);
        return result;
    }
}

export interface ISalesMatrixModel {
    products?: SalesMatrixProductModel[] | undefined;
    customers?: SalesMatrixLineModel[] | undefined;
    total?: number;
    matrix?: number[][] | undefined;
}

export class SalesMatrixProductModel implements ISalesMatrixProductModel {
    id?: string;
    name?: string | undefined;
    total?: number;

    constructor(data?: ISalesMatrixProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): SalesMatrixProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new SalesMatrixProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["total"] = this.total;
        return data;
    }

    clone(): SalesMatrixProductModel {
        const json = this.toJSON();
        let result = new SalesMatrixProductModel();
        result.init(json);
        return result;
    }
}

export interface ISalesMatrixProductModel {
    id?: string;
    name?: string | undefined;
    total?: number;
}

export class SalesMatrixLineModel implements ISalesMatrixLineModel {
    id?: string;
    orderId?: string;
    name?: string | undefined;
    total?: number;
    productCount?: number[] | undefined;

    constructor(data?: ISalesMatrixLineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.name = _data["name"];
            this.total = _data["total"];
            if (Array.isArray(_data["productCount"])) {
                this.productCount = [] as any;
                for (let item of _data["productCount"])
                    this.productCount!.push(item);
            }
        }
    }

    static fromJS(data: any): SalesMatrixLineModel {
        data = typeof data === 'object' ? data : {};
        let result = new SalesMatrixLineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["name"] = this.name;
        data["total"] = this.total;
        if (Array.isArray(this.productCount)) {
            data["productCount"] = [];
            for (let item of this.productCount)
                data["productCount"].push(item);
        }
        return data;
    }

    clone(): SalesMatrixLineModel {
        const json = this.toJSON();
        let result = new SalesMatrixLineModel();
        result.init(json);
        return result;
    }
}

export interface ISalesMatrixLineModel {
    id?: string;
    orderId?: string;
    name?: string | undefined;
    total?: number;
    productCount?: number[] | undefined;
}

export class PagedResultOfOrderlineModel extends PagedResultBase implements IPagedResultOfOrderlineModel {
    results?: OrderlineModel[];

    constructor(data?: IPagedResultOfOrderlineModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(OrderlineModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfOrderlineModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfOrderlineModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfOrderlineModel {
        const json = this.toJSON();
        let result = new PagedResultOfOrderlineModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfOrderlineModel extends IPagedResultBase {
    results?: OrderlineModel[];
}

export class OrganizationModel implements IOrganizationModel {
    id?: string;
    name?: string | undefined;
    users?: UserModel[] | undefined;
    address?: AddressModel | undefined;
    cvr?: string | undefined;
    bankReg?: string | undefined;
    bankAccount?: string | undefined;
    shopPrefix?: string | undefined;
    logo?: string | undefined;
    source?: string | undefined;
    externalSourceId?: string | undefined;
    timeRegId?: string;
    externalContractNumber?: string | undefined;
    externalCustomerNumber?: string | undefined;
    contractStartDate?: Date | undefined;
    contractEndDate?: Date | undefined;
    contractYearlySum?: number;
    contractUnits?: FsModules;
    contractAuditsQ1?: number;
    contractAuditsQ2?: number;
    contractAuditsQ3?: number;
    contractAuditsQ4?: number;
    contractAnalysisQ1?: number;
    contractAnalysisQ2?: number;
    contractAnalysisQ3?: number;
    contractAnalysisQ4?: number;
    contractTemperatureLogging?: number;
    contractComments?: string | undefined;
    contractPrimaryUserId?: string;
    contractPrimaryUserName?: string | undefined;
    contractSecondaryUserId?: string;
    contractAuditDuration?: string;
    contractUnannouncedAudits?: number;
    contractYearlyRevision?: number;
    contractYearlyRevisionAnalysisPlan?: number;
    contractCustomerTier?: number;
    drivingTime?: number;
    drivingDistance?: number;
    drivingToll?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    pNr?: string | undefined;
    websiteUrl?: string | undefined;

    constructor(data?: IOrganizationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserModel.fromJS(item));
            }
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : undefined as any;
            this.cvr = _data["cvr"];
            this.bankReg = _data["bankReg"];
            this.bankAccount = _data["bankAccount"];
            this.shopPrefix = _data["shopPrefix"];
            this.logo = _data["logo"];
            this.source = _data["source"];
            this.externalSourceId = _data["externalSourceId"];
            this.timeRegId = _data["timeRegId"];
            this.externalContractNumber = _data["externalContractNumber"];
            this.externalCustomerNumber = _data["externalCustomerNumber"];
            this.contractStartDate = _data["contractStartDate"] ? new Date(_data["contractStartDate"].toString()) : undefined as any;
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : undefined as any;
            this.contractYearlySum = _data["contractYearlySum"];
            this.contractUnits = _data["contractUnits"];
            this.contractAuditsQ1 = _data["contractAuditsQ1"];
            this.contractAuditsQ2 = _data["contractAuditsQ2"];
            this.contractAuditsQ3 = _data["contractAuditsQ3"];
            this.contractAuditsQ4 = _data["contractAuditsQ4"];
            this.contractAnalysisQ1 = _data["contractAnalysisQ1"];
            this.contractAnalysisQ2 = _data["contractAnalysisQ2"];
            this.contractAnalysisQ3 = _data["contractAnalysisQ3"];
            this.contractAnalysisQ4 = _data["contractAnalysisQ4"];
            this.contractTemperatureLogging = _data["contractTemperatureLogging"];
            this.contractComments = _data["contractComments"];
            this.contractPrimaryUserId = _data["contractPrimaryUserId"];
            this.contractPrimaryUserName = _data["contractPrimaryUserName"];
            this.contractSecondaryUserId = _data["contractSecondaryUserId"];
            this.contractAuditDuration = _data["contractAuditDuration"];
            this.contractUnannouncedAudits = _data["contractUnannouncedAudits"];
            this.contractYearlyRevision = _data["contractYearlyRevision"];
            this.contractYearlyRevisionAnalysisPlan = _data["contractYearlyRevisionAnalysisPlan"];
            this.contractCustomerTier = _data["contractCustomerTier"];
            this.drivingTime = _data["drivingTime"];
            this.drivingDistance = _data["drivingDistance"];
            this.drivingToll = _data["drivingToll"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.pNr = _data["pNr"];
            this.websiteUrl = _data["websiteUrl"];
        }
    }

    static fromJS(data: any): OrganizationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["cvr"] = this.cvr;
        data["bankReg"] = this.bankReg;
        data["bankAccount"] = this.bankAccount;
        data["shopPrefix"] = this.shopPrefix;
        data["logo"] = this.logo;
        data["source"] = this.source;
        data["externalSourceId"] = this.externalSourceId;
        data["timeRegId"] = this.timeRegId;
        data["externalContractNumber"] = this.externalContractNumber;
        data["externalCustomerNumber"] = this.externalCustomerNumber;
        data["contractStartDate"] = this.contractStartDate ? this.contractStartDate.toISOString() : undefined as any;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : undefined as any;
        data["contractYearlySum"] = this.contractYearlySum;
        data["contractUnits"] = this.contractUnits;
        data["contractAuditsQ1"] = this.contractAuditsQ1;
        data["contractAuditsQ2"] = this.contractAuditsQ2;
        data["contractAuditsQ3"] = this.contractAuditsQ3;
        data["contractAuditsQ4"] = this.contractAuditsQ4;
        data["contractAnalysisQ1"] = this.contractAnalysisQ1;
        data["contractAnalysisQ2"] = this.contractAnalysisQ2;
        data["contractAnalysisQ3"] = this.contractAnalysisQ3;
        data["contractAnalysisQ4"] = this.contractAnalysisQ4;
        data["contractTemperatureLogging"] = this.contractTemperatureLogging;
        data["contractComments"] = this.contractComments;
        data["contractPrimaryUserId"] = this.contractPrimaryUserId;
        data["contractPrimaryUserName"] = this.contractPrimaryUserName;
        data["contractSecondaryUserId"] = this.contractSecondaryUserId;
        data["contractAuditDuration"] = this.contractAuditDuration;
        data["contractUnannouncedAudits"] = this.contractUnannouncedAudits;
        data["contractYearlyRevision"] = this.contractYearlyRevision;
        data["contractYearlyRevisionAnalysisPlan"] = this.contractYearlyRevisionAnalysisPlan;
        data["contractCustomerTier"] = this.contractCustomerTier;
        data["drivingTime"] = this.drivingTime;
        data["drivingDistance"] = this.drivingDistance;
        data["drivingToll"] = this.drivingToll;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["pNr"] = this.pNr;
        data["websiteUrl"] = this.websiteUrl;
        return data;
    }

    clone(): OrganizationModel {
        const json = this.toJSON();
        let result = new OrganizationModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationModel {
    id?: string;
    name?: string | undefined;
    users?: UserModel[] | undefined;
    address?: AddressModel | undefined;
    cvr?: string | undefined;
    bankReg?: string | undefined;
    bankAccount?: string | undefined;
    shopPrefix?: string | undefined;
    logo?: string | undefined;
    source?: string | undefined;
    externalSourceId?: string | undefined;
    timeRegId?: string;
    externalContractNumber?: string | undefined;
    externalCustomerNumber?: string | undefined;
    contractStartDate?: Date | undefined;
    contractEndDate?: Date | undefined;
    contractYearlySum?: number;
    contractUnits?: FsModules;
    contractAuditsQ1?: number;
    contractAuditsQ2?: number;
    contractAuditsQ3?: number;
    contractAuditsQ4?: number;
    contractAnalysisQ1?: number;
    contractAnalysisQ2?: number;
    contractAnalysisQ3?: number;
    contractAnalysisQ4?: number;
    contractTemperatureLogging?: number;
    contractComments?: string | undefined;
    contractPrimaryUserId?: string;
    contractPrimaryUserName?: string | undefined;
    contractSecondaryUserId?: string;
    contractAuditDuration?: string;
    contractUnannouncedAudits?: number;
    contractYearlyRevision?: number;
    contractYearlyRevisionAnalysisPlan?: number;
    contractCustomerTier?: number;
    drivingTime?: number;
    drivingDistance?: number;
    drivingToll?: number;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    pNr?: string | undefined;
    websiteUrl?: string | undefined;
}

export class UserModel implements IUserModel {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
    address?: AddressModel | undefined;
    organizations?: IdNameModel[] | undefined;
    picture?: string | undefined;
    permissions?: string[] | undefined;
    noLogin?: boolean;
    latestRegistration?: TimeRegistrationModel | undefined;
    employeeNumber?: string | undefined;
    pin?: string | undefined;
    customerId?: string | undefined;
    settings?: PropertyGroupDataModel[] | undefined;
    username?: string | undefined;
    noNotificationMail?: boolean;
    activationCode?: string | undefined;
    subscriptionType?: UserSubscriptionType;
    logo?: string | undefined;
    source?: string | undefined;
    externalSourceId?: string | undefined;
    timeRegId?: string;
    azureB2CStatus?: number | undefined;
    dismissedNotifications?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.mobile = _data["mobile"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : undefined as any;
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(IdNameModel.fromJS(item));
            }
            this.picture = _data["picture"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.noLogin = _data["noLogin"];
            this.latestRegistration = _data["latestRegistration"] ? TimeRegistrationModel.fromJS(_data["latestRegistration"]) : undefined as any;
            this.employeeNumber = _data["employeeNumber"];
            this.pin = _data["pin"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(PropertyGroupDataModel.fromJS(item));
            }
            this.username = _data["username"];
            this.noNotificationMail = _data["noNotificationMail"];
            this.activationCode = _data["activationCode"];
            this.subscriptionType = _data["subscriptionType"];
            this.logo = _data["logo"];
            this.source = _data["source"];
            this.externalSourceId = _data["externalSourceId"];
            this.timeRegId = _data["timeRegId"];
            this.azureB2CStatus = _data["azureB2CStatus"];
            this.dismissedNotifications = _data["dismissedNotifications"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["mobile"] = this.mobile;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item ? item.toJSON() : undefined as any);
        }
        data["picture"] = this.picture;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["noLogin"] = this.noLogin;
        data["latestRegistration"] = this.latestRegistration ? this.latestRegistration.toJSON() : undefined as any;
        data["employeeNumber"] = this.employeeNumber;
        data["pin"] = this.pin;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item ? item.toJSON() : undefined as any);
        }
        data["username"] = this.username;
        data["noNotificationMail"] = this.noNotificationMail;
        data["activationCode"] = this.activationCode;
        data["subscriptionType"] = this.subscriptionType;
        data["logo"] = this.logo;
        data["source"] = this.source;
        data["externalSourceId"] = this.externalSourceId;
        data["timeRegId"] = this.timeRegId;
        data["azureB2CStatus"] = this.azureB2CStatus;
        data["dismissedNotifications"] = this.dismissedNotifications;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): UserModel {
        const json = this.toJSON();
        let result = new UserModel();
        result.init(json);
        return result;
    }
}

export interface IUserModel {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
    address?: AddressModel | undefined;
    organizations?: IdNameModel[] | undefined;
    picture?: string | undefined;
    permissions?: string[] | undefined;
    noLogin?: boolean;
    latestRegistration?: TimeRegistrationModel | undefined;
    employeeNumber?: string | undefined;
    pin?: string | undefined;
    customerId?: string | undefined;
    settings?: PropertyGroupDataModel[] | undefined;
    username?: string | undefined;
    noNotificationMail?: boolean;
    activationCode?: string | undefined;
    subscriptionType?: UserSubscriptionType;
    logo?: string | undefined;
    source?: string | undefined;
    externalSourceId?: string | undefined;
    timeRegId?: string;
    azureB2CStatus?: number | undefined;
    dismissedNotifications?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class TimeRegistrationModel implements ITimeRegistrationModel {
    id?: string;
    entityId?: string;
    type?: TimeRegistrationType;
    date?: Date;
    pin?: string | undefined;
    break1?: string;
    break2?: string;
    breaksTotal?: string;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    roundedStartTime?: Date | undefined;
    roundedEndTime?: Date | undefined;
    hoursRate1?: string;
    hoursRate2?: string;
    hoursRate3?: string;
    hoursRate4?: string;
    hoursTotal?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: ITimeRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.type = _data["type"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.pin = _data["pin"];
            this.break1 = _data["break1"];
            this.break2 = _data["break2"];
            this.breaksTotal = _data["breaksTotal"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.roundedStartTime = _data["roundedStartTime"] ? new Date(_data["roundedStartTime"].toString()) : undefined as any;
            this.roundedEndTime = _data["roundedEndTime"] ? new Date(_data["roundedEndTime"].toString()) : undefined as any;
            this.hoursRate1 = _data["hoursRate1"];
            this.hoursRate2 = _data["hoursRate2"];
            this.hoursRate3 = _data["hoursRate3"];
            this.hoursRate4 = _data["hoursRate4"];
            this.hoursTotal = _data["hoursTotal"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): TimeRegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeRegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["type"] = this.type;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["pin"] = this.pin;
        data["break1"] = this.break1;
        data["break2"] = this.break2;
        data["breaksTotal"] = this.breaksTotal;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["roundedStartTime"] = this.roundedStartTime ? this.roundedStartTime.toISOString() : undefined as any;
        data["roundedEndTime"] = this.roundedEndTime ? this.roundedEndTime.toISOString() : undefined as any;
        data["hoursRate1"] = this.hoursRate1;
        data["hoursRate2"] = this.hoursRate2;
        data["hoursRate3"] = this.hoursRate3;
        data["hoursRate4"] = this.hoursRate4;
        data["hoursTotal"] = this.hoursTotal;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): TimeRegistrationModel {
        const json = this.toJSON();
        let result = new TimeRegistrationModel();
        result.init(json);
        return result;
    }
}

export interface ITimeRegistrationModel {
    id?: string;
    entityId?: string;
    type?: TimeRegistrationType;
    date?: Date;
    pin?: string | undefined;
    break1?: string;
    break2?: string;
    breaksTotal?: string;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    roundedStartTime?: Date | undefined;
    roundedEndTime?: Date | undefined;
    hoursRate1?: string;
    hoursRate2?: string;
    hoursRate3?: string;
    hoursRate4?: string;
    hoursTotal?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum TimeRegistrationType {
    CheckIn = 1,
    CheckOut = 2,
    VacationStart = 3,
    VacationEnd = 4,
    SickStart = 5,
    SickEnd = 6,
}

export enum UserSubscriptionType {
    FullUser = 0,
    RegistrationUser = 1,
    TimeRegistrationUser = 2,
    ShopUser = 3,
    DemoUser = 4,
    FreeUser = 5,
    Anticimex = 6,
}

export enum FsModules {
    None = 0,
    Basic = 1,
    Heating = 2,
    Cooling = 4,
    FishStorage = 8,
    FishHeating = 16,
    HotHolding = 32,
    English = 64,
}

export class PagedResultOfOrganizationModel extends PagedResultBase implements IPagedResultOfOrganizationModel {
    results?: OrganizationModel[];

    constructor(data?: IPagedResultOfOrganizationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(OrganizationModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfOrganizationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfOrganizationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfOrganizationModel {
        const json = this.toJSON();
        let result = new PagedResultOfOrganizationModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfOrganizationModel extends IPagedResultBase {
    results?: OrganizationModel[];
}

export class QsAddress extends BaseEntity implements IQsAddress {
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    type?: AddressType;
    entityId?: string;
    sortOrder?: number;
    externalId?: string | undefined;
    gln?: string | undefined;
    endpoint?: string | undefined;

    constructor(data?: IQsAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.type = _data["type"];
            this.entityId = _data["entityId"];
            this.sortOrder = _data["sortOrder"];
            this.externalId = _data["externalId"];
            this.gln = _data["gln"];
            this.endpoint = _data["endpoint"];
        }
    }

    static override fromJS(data: any): QsAddress {
        data = typeof data === 'object' ? data : {};
        let result = new QsAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["type"] = this.type;
        data["entityId"] = this.entityId;
        data["sortOrder"] = this.sortOrder;
        data["externalId"] = this.externalId;
        data["gln"] = this.gln;
        data["endpoint"] = this.endpoint;
        super.toJSON(data);
        return data;
    }

    clone(): QsAddress {
        const json = this.toJSON();
        let result = new QsAddress();
        result.init(json);
        return result;
    }
}

export interface IQsAddress extends IBaseEntity {
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    type?: AddressType;
    entityId?: string;
    sortOrder?: number;
    externalId?: string | undefined;
    gln?: string | undefined;
    endpoint?: string | undefined;
}

export class OrganizationPriceModel implements IOrganizationPriceModel {
    name?: string | undefined;
    quantity?: number;
    unit?: string | undefined;
    unitPrice?: number;
    costPrice?: number;
    salesPrice?: number;
    totalPrice?: number;

    constructor(data?: IOrganizationPriceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.unitPrice = _data["unitPrice"];
            this.costPrice = _data["costPrice"];
            this.salesPrice = _data["salesPrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): OrganizationPriceModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationPriceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["unitPrice"] = this.unitPrice;
        data["costPrice"] = this.costPrice;
        data["salesPrice"] = this.salesPrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }

    clone(): OrganizationPriceModel {
        const json = this.toJSON();
        let result = new OrganizationPriceModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationPriceModel {
    name?: string | undefined;
    quantity?: number;
    unit?: string | undefined;
    unitPrice?: number;
    costPrice?: number;
    salesPrice?: number;
    totalPrice?: number;
}

export class QsOrganization extends BaseEntity implements IQsOrganization {
    name?: string | undefined;
    addressId?: string | undefined;
    address?: QsAddress | undefined;
    cvr?: string | undefined;
    bankReg?: string | undefined;
    bankAccount?: string | undefined;
    shopPrefix?: string | undefined;
    timeRegId?: string;
    externalContractNumber?: string | undefined;
    externalCustomerNumber?: string | undefined;
    contractStartDate?: Date | undefined;
    contractEndDate?: Date | undefined;
    contractYearlySum?: number;
    contractUnits?: FsModules;
    contractAuditsQ1?: number;
    contractAuditsQ2?: number;
    contractAuditsQ3?: number;
    contractAuditsQ4?: number;
    contractAnalysisQ1?: number;
    contractAnalysisQ2?: number;
    contractAnalysisQ3?: number;
    contractAnalysisQ4?: number;
    contractTemperatureLogging?: number;
    contractComments?: string | undefined;
    contractPrimaryUserId?: string;
    contractSecondaryUserId?: string;
    contractAuditDuration?: string;
    contractUnannouncedAudits?: number;
    contractYearlyRevision?: number;
    contractYearlyRevisionAnalysisPlan?: number;
    contractCustomerTier?: number;
    drivingTime?: number;
    drivingDistance?: number;
    drivingToll?: number;
    source?: string;
    externalSourceId?: string;
    lastExternalSync?: Date;
    pNr?: string | undefined;
    websiteUrl?: string | undefined;

    constructor(data?: IQsOrganization) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? QsAddress.fromJS(_data["address"]) : undefined as any;
            this.cvr = _data["cvr"];
            this.bankReg = _data["bankReg"];
            this.bankAccount = _data["bankAccount"];
            this.shopPrefix = _data["shopPrefix"];
            this.timeRegId = _data["timeRegId"];
            this.externalContractNumber = _data["externalContractNumber"];
            this.externalCustomerNumber = _data["externalCustomerNumber"];
            this.contractStartDate = _data["contractStartDate"] ? new Date(_data["contractStartDate"].toString()) : undefined as any;
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : undefined as any;
            this.contractYearlySum = _data["contractYearlySum"];
            this.contractUnits = _data["contractUnits"];
            this.contractAuditsQ1 = _data["contractAuditsQ1"];
            this.contractAuditsQ2 = _data["contractAuditsQ2"];
            this.contractAuditsQ3 = _data["contractAuditsQ3"];
            this.contractAuditsQ4 = _data["contractAuditsQ4"];
            this.contractAnalysisQ1 = _data["contractAnalysisQ1"];
            this.contractAnalysisQ2 = _data["contractAnalysisQ2"];
            this.contractAnalysisQ3 = _data["contractAnalysisQ3"];
            this.contractAnalysisQ4 = _data["contractAnalysisQ4"];
            this.contractTemperatureLogging = _data["contractTemperatureLogging"];
            this.contractComments = _data["contractComments"];
            this.contractPrimaryUserId = _data["contractPrimaryUserId"];
            this.contractSecondaryUserId = _data["contractSecondaryUserId"];
            this.contractAuditDuration = _data["contractAuditDuration"];
            this.contractUnannouncedAudits = _data["contractUnannouncedAudits"];
            this.contractYearlyRevision = _data["contractYearlyRevision"];
            this.contractYearlyRevisionAnalysisPlan = _data["contractYearlyRevisionAnalysisPlan"];
            this.contractCustomerTier = _data["contractCustomerTier"];
            this.drivingTime = _data["drivingTime"];
            this.drivingDistance = _data["drivingDistance"];
            this.drivingToll = _data["drivingToll"];
            this.source = _data["source"];
            this.externalSourceId = _data["externalSourceId"];
            this.lastExternalSync = _data["lastExternalSync"] ? new Date(_data["lastExternalSync"].toString()) : undefined as any;
            this.pNr = _data["pNr"];
            this.websiteUrl = _data["websiteUrl"];
        }
    }

    static override fromJS(data: any): QsOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new QsOrganization();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["cvr"] = this.cvr;
        data["bankReg"] = this.bankReg;
        data["bankAccount"] = this.bankAccount;
        data["shopPrefix"] = this.shopPrefix;
        data["timeRegId"] = this.timeRegId;
        data["externalContractNumber"] = this.externalContractNumber;
        data["externalCustomerNumber"] = this.externalCustomerNumber;
        data["contractStartDate"] = this.contractStartDate ? this.contractStartDate.toISOString() : undefined as any;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : undefined as any;
        data["contractYearlySum"] = this.contractYearlySum;
        data["contractUnits"] = this.contractUnits;
        data["contractAuditsQ1"] = this.contractAuditsQ1;
        data["contractAuditsQ2"] = this.contractAuditsQ2;
        data["contractAuditsQ3"] = this.contractAuditsQ3;
        data["contractAuditsQ4"] = this.contractAuditsQ4;
        data["contractAnalysisQ1"] = this.contractAnalysisQ1;
        data["contractAnalysisQ2"] = this.contractAnalysisQ2;
        data["contractAnalysisQ3"] = this.contractAnalysisQ3;
        data["contractAnalysisQ4"] = this.contractAnalysisQ4;
        data["contractTemperatureLogging"] = this.contractTemperatureLogging;
        data["contractComments"] = this.contractComments;
        data["contractPrimaryUserId"] = this.contractPrimaryUserId;
        data["contractSecondaryUserId"] = this.contractSecondaryUserId;
        data["contractAuditDuration"] = this.contractAuditDuration;
        data["contractUnannouncedAudits"] = this.contractUnannouncedAudits;
        data["contractYearlyRevision"] = this.contractYearlyRevision;
        data["contractYearlyRevisionAnalysisPlan"] = this.contractYearlyRevisionAnalysisPlan;
        data["contractCustomerTier"] = this.contractCustomerTier;
        data["drivingTime"] = this.drivingTime;
        data["drivingDistance"] = this.drivingDistance;
        data["drivingToll"] = this.drivingToll;
        data["source"] = this.source;
        data["externalSourceId"] = this.externalSourceId;
        data["lastExternalSync"] = this.lastExternalSync ? this.lastExternalSync.toISOString() : undefined as any;
        data["pNr"] = this.pNr;
        data["websiteUrl"] = this.websiteUrl;
        super.toJSON(data);
        return data;
    }

    clone(): QsOrganization {
        const json = this.toJSON();
        let result = new QsOrganization();
        result.init(json);
        return result;
    }
}

export interface IQsOrganization extends IBaseEntity {
    name?: string | undefined;
    addressId?: string | undefined;
    address?: QsAddress | undefined;
    cvr?: string | undefined;
    bankReg?: string | undefined;
    bankAccount?: string | undefined;
    shopPrefix?: string | undefined;
    timeRegId?: string;
    externalContractNumber?: string | undefined;
    externalCustomerNumber?: string | undefined;
    contractStartDate?: Date | undefined;
    contractEndDate?: Date | undefined;
    contractYearlySum?: number;
    contractUnits?: FsModules;
    contractAuditsQ1?: number;
    contractAuditsQ2?: number;
    contractAuditsQ3?: number;
    contractAuditsQ4?: number;
    contractAnalysisQ1?: number;
    contractAnalysisQ2?: number;
    contractAnalysisQ3?: number;
    contractAnalysisQ4?: number;
    contractTemperatureLogging?: number;
    contractComments?: string | undefined;
    contractPrimaryUserId?: string;
    contractSecondaryUserId?: string;
    contractAuditDuration?: string;
    contractUnannouncedAudits?: number;
    contractYearlyRevision?: number;
    contractYearlyRevisionAnalysisPlan?: number;
    contractCustomerTier?: number;
    drivingTime?: number;
    drivingDistance?: number;
    drivingToll?: number;
    source?: string;
    externalSourceId?: string;
    lastExternalSync?: Date;
    pNr?: string | undefined;
    websiteUrl?: string | undefined;
}

export class OverviewModel implements IOverviewModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    collectionId?: string;
    collection?: CollectionModel | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IOverviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.collectionId = _data["collectionId"];
            this.collection = _data["collection"] ? CollectionModel.fromJS(_data["collection"]) : undefined as any;
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): OverviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OverviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["collectionId"] = this.collectionId;
        data["collection"] = this.collection ? this.collection.toJSON() : undefined as any;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): OverviewModel {
        const json = this.toJSON();
        let result = new OverviewModel();
        result.init(json);
        return result;
    }
}

export interface IOverviewModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    collectionId?: string;
    collection?: CollectionModel | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class PermissionModel implements IPermissionModel {
    id?: string;
    name?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IPermissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): PermissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): PermissionModel {
        const json = this.toJSON();
        let result = new PermissionModel();
        result.init(json);
        return result;
    }
}

export interface IPermissionModel {
    id?: string;
    name?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class PriceModel implements IPriceModel {
    id?: string;
    productVariantId?: string | undefined;
    productGroupId?: string | undefined;
    productName?: string | undefined;
    productNumber?: string | undefined;
    customerId?: string | undefined;
    customerName?: string | undefined;
    groupId?: string | undefined;
    price?: number;
    discount?: number;
    currency?: string | undefined;
    quantity?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    priceType?: PriceType;
    ruleType?: PriceRuleType;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IPriceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productVariantId = _data["productVariantId"];
            this.productGroupId = _data["productGroupId"];
            this.productName = _data["productName"];
            this.productNumber = _data["productNumber"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.groupId = _data["groupId"];
            this.price = _data["price"];
            this.discount = _data["discount"];
            this.currency = _data["currency"];
            this.quantity = _data["quantity"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.priceType = _data["priceType"];
            this.ruleType = _data["ruleType"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): PriceModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productVariantId"] = this.productVariantId;
        data["productGroupId"] = this.productGroupId;
        data["productName"] = this.productName;
        data["productNumber"] = this.productNumber;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["groupId"] = this.groupId;
        data["price"] = this.price;
        data["discount"] = this.discount;
        data["currency"] = this.currency;
        data["quantity"] = this.quantity;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["priceType"] = this.priceType;
        data["ruleType"] = this.ruleType;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): PriceModel {
        const json = this.toJSON();
        let result = new PriceModel();
        result.init(json);
        return result;
    }
}

export interface IPriceModel {
    id?: string;
    productVariantId?: string | undefined;
    productGroupId?: string | undefined;
    productName?: string | undefined;
    productNumber?: string | undefined;
    customerId?: string | undefined;
    customerName?: string | undefined;
    groupId?: string | undefined;
    price?: number;
    discount?: number;
    currency?: string | undefined;
    quantity?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    priceType?: PriceType;
    ruleType?: PriceRuleType;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum PriceType {
    SalesPrice = 0,
    PurchasePrice = 1,
    ExchangeRate = 2,
}

export enum PriceRuleType {
    Price = 0,
    CustomerSpecificPrice = 1,
    CustomerSpecificDiscount = 2,
    PriceGroupPrice = 3,
    PriceGroupDiscount = 4,
    ProductGroupSpecificPrice = 5,
    ProductGroupSpecificDiscount = 6,
    CustomerGlobalDiscount = 7,
}

export class PriceDiscountModel implements IPriceDiscountModel {
    price?: number;
    discount?: number;

    constructor(data?: IPriceDiscountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
            this.discount = _data["discount"];
        }
    }

    static fromJS(data: any): PriceDiscountModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceDiscountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["discount"] = this.discount;
        return data;
    }

    clone(): PriceDiscountModel {
        const json = this.toJSON();
        let result = new PriceDiscountModel();
        result.init(json);
        return result;
    }
}

export interface IPriceDiscountModel {
    price?: number;
    discount?: number;
}

export class ProcedureStepRelationModel implements IProcedureStepRelationModel {
    id?: string | undefined;
    procedureStep?: ProcedureStepModel | undefined;
    originalStepId?: string | undefined;
    sortOrder?: number;
    procedureId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IProcedureStepRelationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.procedureStep = _data["procedureStep"] ? ProcedureStepModel.fromJS(_data["procedureStep"]) : undefined as any;
            this.originalStepId = _data["originalStepId"];
            this.sortOrder = _data["sortOrder"];
            this.procedureId = _data["procedureId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProcedureStepRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureStepRelationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["procedureStep"] = this.procedureStep ? this.procedureStep.toJSON() : undefined as any;
        data["originalStepId"] = this.originalStepId;
        data["sortOrder"] = this.sortOrder;
        data["procedureId"] = this.procedureId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ProcedureStepRelationModel {
        const json = this.toJSON();
        let result = new ProcedureStepRelationModel();
        result.init(json);
        return result;
    }
}

export interface IProcedureStepRelationModel {
    id?: string | undefined;
    procedureStep?: ProcedureStepModel | undefined;
    originalStepId?: string | undefined;
    sortOrder?: number;
    procedureId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ProcessModel implements IProcessModel {
    id?: string;
    departmentId?: string;
    name?: string | undefined;
    description?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    language?: string | undefined;
    type?: number;
    factors?: string[] | undefined;
    processSteps?: ProcessStepModel[] | undefined;
    processStepDependencies?: ProcessStepDependencyModel[] | undefined;
    processLanguages?: ProcessLanguageModel[] | undefined;
    processStepRelations?: ProcessStepRelationModel[] | undefined;
    processStepDependencyRelations?: ProcessStepDependencyRelationModel[] | undefined;
    diagramSvg?: string | undefined;
    documentVersion?: DocumentRevisionModel | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: IProcessModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.departmentId = _data["departmentId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.responsibleUser = _data["responsibleUser"] ? IdNameModel.fromJS(_data["responsibleUser"]) : undefined as any;
            this.language = _data["language"];
            this.type = _data["type"];
            if (Array.isArray(_data["factors"])) {
                this.factors = [] as any;
                for (let item of _data["factors"])
                    this.factors!.push(item);
            }
            if (Array.isArray(_data["processSteps"])) {
                this.processSteps = [] as any;
                for (let item of _data["processSteps"])
                    this.processSteps!.push(ProcessStepModel.fromJS(item));
            }
            if (Array.isArray(_data["processStepDependencies"])) {
                this.processStepDependencies = [] as any;
                for (let item of _data["processStepDependencies"])
                    this.processStepDependencies!.push(ProcessStepDependencyModel.fromJS(item));
            }
            if (Array.isArray(_data["processLanguages"])) {
                this.processLanguages = [] as any;
                for (let item of _data["processLanguages"])
                    this.processLanguages!.push(ProcessLanguageModel.fromJS(item));
            }
            if (Array.isArray(_data["processStepRelations"])) {
                this.processStepRelations = [] as any;
                for (let item of _data["processStepRelations"])
                    this.processStepRelations!.push(ProcessStepRelationModel.fromJS(item));
            }
            if (Array.isArray(_data["processStepDependencyRelations"])) {
                this.processStepDependencyRelations = [] as any;
                for (let item of _data["processStepDependencyRelations"])
                    this.processStepDependencyRelations!.push(ProcessStepDependencyRelationModel.fromJS(item));
            }
            this.diagramSvg = _data["diagramSvg"];
            this.documentVersion = _data["documentVersion"] ? DocumentRevisionModel.fromJS(_data["documentVersion"]) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProcessModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["departmentId"] = this.departmentId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["responsibleUser"] = this.responsibleUser ? this.responsibleUser.toJSON() : undefined as any;
        data["language"] = this.language;
        data["type"] = this.type;
        if (Array.isArray(this.factors)) {
            data["factors"] = [];
            for (let item of this.factors)
                data["factors"].push(item);
        }
        if (Array.isArray(this.processSteps)) {
            data["processSteps"] = [];
            for (let item of this.processSteps)
                data["processSteps"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processStepDependencies)) {
            data["processStepDependencies"] = [];
            for (let item of this.processStepDependencies)
                data["processStepDependencies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processLanguages)) {
            data["processLanguages"] = [];
            for (let item of this.processLanguages)
                data["processLanguages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processStepRelations)) {
            data["processStepRelations"] = [];
            for (let item of this.processStepRelations)
                data["processStepRelations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.processStepDependencyRelations)) {
            data["processStepDependencyRelations"] = [];
            for (let item of this.processStepDependencyRelations)
                data["processStepDependencyRelations"].push(item ? item.toJSON() : undefined as any);
        }
        data["diagramSvg"] = this.diagramSvg;
        data["documentVersion"] = this.documentVersion ? this.documentVersion.toJSON() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ProcessModel {
        const json = this.toJSON();
        let result = new ProcessModel();
        result.init(json);
        return result;
    }
}

export interface IProcessModel {
    id?: string;
    departmentId?: string;
    name?: string | undefined;
    description?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    language?: string | undefined;
    type?: number;
    factors?: string[] | undefined;
    processSteps?: ProcessStepModel[] | undefined;
    processStepDependencies?: ProcessStepDependencyModel[] | undefined;
    processLanguages?: ProcessLanguageModel[] | undefined;
    processStepRelations?: ProcessStepRelationModel[] | undefined;
    processStepDependencyRelations?: ProcessStepDependencyRelationModel[] | undefined;
    diagramSvg?: string | undefined;
    documentVersion?: DocumentRevisionModel | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
}

export class ProcessStepDependencyModel implements IProcessStepDependencyModel {
    id?: string;
    processId?: string | undefined;
    processStepId?: string;
    dependencyId?: string;
    weight?: number;
    deltaX?: number;
    deltaY?: number;
    edgeText?: string | undefined;
    edgeFromPointIndex?: number;
    edgeToPointIndex?: number;
    lineType?: string | undefined;
    linePoints?: string | undefined;
    lineStyle?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IProcessStepDependencyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processId = _data["processId"];
            this.processStepId = _data["processStepId"];
            this.dependencyId = _data["dependencyId"];
            this.weight = _data["weight"];
            this.deltaX = _data["deltaX"];
            this.deltaY = _data["deltaY"];
            this.edgeText = _data["edgeText"];
            this.edgeFromPointIndex = _data["edgeFromPointIndex"];
            this.edgeToPointIndex = _data["edgeToPointIndex"];
            this.lineType = _data["lineType"];
            this.linePoints = _data["linePoints"];
            this.lineStyle = _data["lineStyle"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProcessStepDependencyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessStepDependencyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processId"] = this.processId;
        data["processStepId"] = this.processStepId;
        data["dependencyId"] = this.dependencyId;
        data["weight"] = this.weight;
        data["deltaX"] = this.deltaX;
        data["deltaY"] = this.deltaY;
        data["edgeText"] = this.edgeText;
        data["edgeFromPointIndex"] = this.edgeFromPointIndex;
        data["edgeToPointIndex"] = this.edgeToPointIndex;
        data["lineType"] = this.lineType;
        data["linePoints"] = this.linePoints;
        data["lineStyle"] = this.lineStyle;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ProcessStepDependencyModel {
        const json = this.toJSON();
        let result = new ProcessStepDependencyModel();
        result.init(json);
        return result;
    }
}

export interface IProcessStepDependencyModel {
    id?: string;
    processId?: string | undefined;
    processStepId?: string;
    dependencyId?: string;
    weight?: number;
    deltaX?: number;
    deltaY?: number;
    edgeText?: string | undefined;
    edgeFromPointIndex?: number;
    edgeToPointIndex?: number;
    lineType?: string | undefined;
    linePoints?: string | undefined;
    lineStyle?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ProcessLanguageModel implements IProcessLanguageModel {
    id?: string;
    processId?: string;
    name?: string | undefined;
    description?: string | undefined;
    responsibleUserId?: string;
    language?: string | undefined;
    status?: DocumentRevisionStatus;
    processStepLanguages?: ProcessStepLanguageModel[] | undefined;

    constructor(data?: IProcessLanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processId = _data["processId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.language = _data["language"];
            this.status = _data["status"];
            if (Array.isArray(_data["processStepLanguages"])) {
                this.processStepLanguages = [] as any;
                for (let item of _data["processStepLanguages"])
                    this.processStepLanguages!.push(ProcessStepLanguageModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessLanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessLanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processId"] = this.processId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["responsibleUserId"] = this.responsibleUserId;
        data["language"] = this.language;
        data["status"] = this.status;
        if (Array.isArray(this.processStepLanguages)) {
            data["processStepLanguages"] = [];
            for (let item of this.processStepLanguages)
                data["processStepLanguages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ProcessLanguageModel {
        const json = this.toJSON();
        let result = new ProcessLanguageModel();
        result.init(json);
        return result;
    }
}

export interface IProcessLanguageModel {
    id?: string;
    processId?: string;
    name?: string | undefined;
    description?: string | undefined;
    responsibleUserId?: string;
    language?: string | undefined;
    status?: DocumentRevisionStatus;
    processStepLanguages?: ProcessStepLanguageModel[] | undefined;
}

export class ProcessStepLanguageModel implements IProcessStepLanguageModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    processId?: string;
    processLanguageId?: string | undefined;
    processStepId?: string | undefined;
    processStep?: ProcessStepModel | undefined;
    status?: number;

    constructor(data?: IProcessStepLanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.processId = _data["processId"];
            this.processLanguageId = _data["processLanguageId"];
            this.processStepId = _data["processStepId"];
            this.processStep = _data["processStep"] ? ProcessStepModel.fromJS(_data["processStep"]) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProcessStepLanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessStepLanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["processId"] = this.processId;
        data["processLanguageId"] = this.processLanguageId;
        data["processStepId"] = this.processStepId;
        data["processStep"] = this.processStep ? this.processStep.toJSON() : undefined as any;
        data["status"] = this.status;
        return data;
    }

    clone(): ProcessStepLanguageModel {
        const json = this.toJSON();
        let result = new ProcessStepLanguageModel();
        result.init(json);
        return result;
    }
}

export interface IProcessStepLanguageModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    processId?: string;
    processLanguageId?: string | undefined;
    processStepId?: string | undefined;
    processStep?: ProcessStepModel | undefined;
    status?: number;
}

export class ProcessStepRelationModel implements IProcessStepRelationModel {
    id?: string;
    processStep?: ProcessStepModel | undefined;
    originalStepId?: string;
    sortOrder?: number;
    processId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IProcessStepRelationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processStep = _data["processStep"] ? ProcessStepModel.fromJS(_data["processStep"]) : undefined as any;
            this.originalStepId = _data["originalStepId"];
            this.sortOrder = _data["sortOrder"];
            this.processId = _data["processId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProcessStepRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessStepRelationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processStep"] = this.processStep ? this.processStep.toJSON() : undefined as any;
        data["originalStepId"] = this.originalStepId;
        data["sortOrder"] = this.sortOrder;
        data["processId"] = this.processId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ProcessStepRelationModel {
        const json = this.toJSON();
        let result = new ProcessStepRelationModel();
        result.init(json);
        return result;
    }
}

export interface IProcessStepRelationModel {
    id?: string;
    processStep?: ProcessStepModel | undefined;
    originalStepId?: string;
    sortOrder?: number;
    processId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ProcessStepDependencyRelationModel implements IProcessStepDependencyRelationModel {
    id?: string;
    processStepDependency?: ProcessStepDependencyModel | undefined;
    originalStepDependencyId?: string;
    sortOrder?: number;
    processId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IProcessStepDependencyRelationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processStepDependency = _data["processStepDependency"] ? ProcessStepDependencyModel.fromJS(_data["processStepDependency"]) : undefined as any;
            this.originalStepDependencyId = _data["originalStepDependencyId"];
            this.sortOrder = _data["sortOrder"];
            this.processId = _data["processId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProcessStepDependencyRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessStepDependencyRelationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processStepDependency"] = this.processStepDependency ? this.processStepDependency.toJSON() : undefined as any;
        data["originalStepDependencyId"] = this.originalStepDependencyId;
        data["sortOrder"] = this.sortOrder;
        data["processId"] = this.processId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ProcessStepDependencyRelationModel {
        const json = this.toJSON();
        let result = new ProcessStepDependencyRelationModel();
        result.init(json);
        return result;
    }
}

export interface IProcessStepDependencyRelationModel {
    id?: string;
    processStepDependency?: ProcessStepDependencyModel | undefined;
    originalStepDependencyId?: string;
    sortOrder?: number;
    processId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ProductModel implements IProductModel {
    id?: string;
    productGroupId?: string;
    productGroupName?: string | undefined;
    productGroupNumber?: string | undefined;
    name?: string | undefined;
    productVariants?: ProductVariantModel[] | undefined;
    supplierId?: string;
    supplierName?: string | undefined;
    supplierNumber?: string | undefined;
    supplierProductName?: string | undefined;
    recipeId?: string | undefined;
    type?: string | undefined;
    extraText1?: string | undefined;
    extraText2?: string | undefined;
    extraText3?: string | undefined;
    extraText4?: string | undefined;
    isBarred?: boolean;
    warningText?: string | undefined;
    skuText?: string | undefined;
    revision?: DocumentRevisionModel | undefined;
    stockLocationId?: string;
    stockLocationName?: string | undefined;
    manufacturer?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productGroupId = _data["productGroupId"];
            this.productGroupName = _data["productGroupName"];
            this.productGroupNumber = _data["productGroupNumber"];
            this.name = _data["name"];
            if (Array.isArray(_data["productVariants"])) {
                this.productVariants = [] as any;
                for (let item of _data["productVariants"])
                    this.productVariants!.push(ProductVariantModel.fromJS(item));
            }
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.supplierNumber = _data["supplierNumber"];
            this.supplierProductName = _data["supplierProductName"];
            this.recipeId = _data["recipeId"];
            this.type = _data["type"];
            this.extraText1 = _data["extraText1"];
            this.extraText2 = _data["extraText2"];
            this.extraText3 = _data["extraText3"];
            this.extraText4 = _data["extraText4"];
            this.isBarred = _data["isBarred"];
            this.warningText = _data["warningText"];
            this.skuText = _data["skuText"];
            this.revision = _data["revision"] ? DocumentRevisionModel.fromJS(_data["revision"]) : undefined as any;
            this.stockLocationId = _data["stockLocationId"];
            this.stockLocationName = _data["stockLocationName"];
            this.manufacturer = _data["manufacturer"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productGroupId"] = this.productGroupId;
        data["productGroupName"] = this.productGroupName;
        data["productGroupNumber"] = this.productGroupNumber;
        data["name"] = this.name;
        if (Array.isArray(this.productVariants)) {
            data["productVariants"] = [];
            for (let item of this.productVariants)
                data["productVariants"].push(item ? item.toJSON() : undefined as any);
        }
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["supplierNumber"] = this.supplierNumber;
        data["supplierProductName"] = this.supplierProductName;
        data["recipeId"] = this.recipeId;
        data["type"] = this.type;
        data["extraText1"] = this.extraText1;
        data["extraText2"] = this.extraText2;
        data["extraText3"] = this.extraText3;
        data["extraText4"] = this.extraText4;
        data["isBarred"] = this.isBarred;
        data["warningText"] = this.warningText;
        data["skuText"] = this.skuText;
        data["revision"] = this.revision ? this.revision.toJSON() : undefined as any;
        data["stockLocationId"] = this.stockLocationId;
        data["stockLocationName"] = this.stockLocationName;
        data["manufacturer"] = this.manufacturer;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ProductModel {
        const json = this.toJSON();
        let result = new ProductModel();
        result.init(json);
        return result;
    }
}

export interface IProductModel {
    id?: string;
    productGroupId?: string;
    productGroupName?: string | undefined;
    productGroupNumber?: string | undefined;
    name?: string | undefined;
    productVariants?: ProductVariantModel[] | undefined;
    supplierId?: string;
    supplierName?: string | undefined;
    supplierNumber?: string | undefined;
    supplierProductName?: string | undefined;
    recipeId?: string | undefined;
    type?: string | undefined;
    extraText1?: string | undefined;
    extraText2?: string | undefined;
    extraText3?: string | undefined;
    extraText4?: string | undefined;
    isBarred?: boolean;
    warningText?: string | undefined;
    skuText?: string | undefined;
    revision?: DocumentRevisionModel | undefined;
    stockLocationId?: string;
    stockLocationName?: string | undefined;
    manufacturer?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ProductVariantModel implements IProductVariantModel {
    id?: string;
    productId?: string;
    name?: string | undefined;
    productName?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    salesPrice?: number;
    density?: number;
    sku?: string | undefined;
    supplierName?: string | undefined;
    supplierProductName?: string | undefined;
    supplierSku?: string | undefined;
    bundleId?: string | undefined;
    isBundle?: boolean | undefined;
    isTraceable?: boolean;
    isOrganic?: boolean;
    isBarred?: boolean;
    noStockKeeping?: boolean;
    noPicking?: boolean;
    durabilityType?: number;
    durability?: number;
    durabilityFrozen?: number;
    durabilityRefrigerated?: number;
    durabilityOpen?: number;
    durabilityUnit?: TimeUnitType;
    lotExpiration?: boolean;
    hasOrigin?: boolean;
    unitsPerCase?: number;
    caseTypeName?: string | undefined;
    processId?: string | undefined;
    languages?: string | undefined;
    labelType?: string | undefined;
    labelLogo?: string | undefined;
    nutritionQuantity?: number;
    emarked?: boolean;
    ingredientListType?: string | undefined;
    ean?: string | undefined;
    stockLocationId?: string | undefined;
    stockLocationName?: string | undefined;
    stockLocationPlace?: string | undefined;
    stockPositionTypeId?: string | undefined;
    stockOwnerId?: string | undefined;
    orderLeadtime?: number;
    genericLoss?: number;
    orderUnit?: string | undefined;
    orderQuantity?: number | undefined;
    orderFraction?: number | undefined;
    minimumOrderQuantity?: number | undefined;
    minimumStockLevel?: number | undefined;
    maximumStockLevel?: number | undefined;
    stockUnit?: string | undefined;
    recipeUnit?: string | undefined;
    variantType?: VariantType;
    variantNextLowerLevel?: string | undefined;
    organicPercentage?: number;
    nonAgriculturalPercentage?: number;
    intrastat?: string | undefined;
    depth?: number | undefined;
    height?: number | undefined;
    width?: number | undefined;
    depthUnit?: string | undefined;
    heightUnit?: string | undefined;
    widthUnit?: string | undefined;
    grossWeight?: number | undefined;
    grossWeightUnit?: string | undefined;
    netWeight?: number | undefined;
    netWeightUnit?: string | undefined;
    storageMinimumTemperature?: number | undefined;
    storageMaximumTemperature?: number | undefined;
    gpcCategoryCode?: string | undefined;
    gpcCategoryName?: string | undefined;
    minimumTradeItemLifespanFromTimeOfProduction?: number | undefined;
    minimumTradeItemLifespanFromTimeOfArrival?: number | undefined;
    productImage?: string | undefined;
    layersPerPallet?: number | undefined;
    casesPerPalletLayer?: number | undefined;
    palletGrossWeight?: number | undefined;
    palletGrossWeightUnit?: string | undefined;
    palletHeight?: number | undefined;
    palletHeightUnit?: string | undefined;
    defaultOrigin?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    stockQuantity?: number;
    amount?: number;
    caseEan?: string | undefined;
    description?: string | undefined;
    externalId?: string | undefined;
    co2?: number;
    co2source?: string | undefined;
    isVegan?: boolean;
    isVegatarian?: boolean;
    isNoeglehul?: boolean;
    isFuldkorn?: boolean;
    isMsc?: boolean;
    isAsc?: boolean;
    isHalal?: boolean;
    isGlutenFree?: boolean;
    isLactoseFree?: boolean;
    customerId?: string | undefined;
    customerContactId?: string | undefined;
    wantedProfitMargin?: number | undefined;
    manufacturer?: string | undefined;

    constructor(data?: IProductVariantModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.productName = _data["productName"];
            this.unit = _data["unit"];
            this.unitPrice = _data["unitPrice"];
            this.salesPrice = _data["salesPrice"];
            this.density = _data["density"];
            this.sku = _data["sku"];
            this.supplierName = _data["supplierName"];
            this.supplierProductName = _data["supplierProductName"];
            this.supplierSku = _data["supplierSku"];
            this.bundleId = _data["bundleId"];
            this.isBundle = _data["isBundle"];
            this.isTraceable = _data["isTraceable"];
            this.isOrganic = _data["isOrganic"];
            this.isBarred = _data["isBarred"];
            this.noStockKeeping = _data["noStockKeeping"];
            this.noPicking = _data["noPicking"];
            this.durabilityType = _data["durabilityType"];
            this.durability = _data["durability"];
            this.durabilityFrozen = _data["durabilityFrozen"];
            this.durabilityRefrigerated = _data["durabilityRefrigerated"];
            this.durabilityOpen = _data["durabilityOpen"];
            this.durabilityUnit = _data["durabilityUnit"];
            this.lotExpiration = _data["lotExpiration"];
            this.hasOrigin = _data["hasOrigin"];
            this.unitsPerCase = _data["unitsPerCase"];
            this.caseTypeName = _data["caseTypeName"];
            this.processId = _data["processId"];
            this.languages = _data["languages"];
            this.labelType = _data["labelType"];
            this.labelLogo = _data["labelLogo"];
            this.nutritionQuantity = _data["nutritionQuantity"];
            this.emarked = _data["emarked"];
            this.ingredientListType = _data["ingredientListType"];
            this.ean = _data["ean"];
            this.stockLocationId = _data["stockLocationId"];
            this.stockLocationName = _data["stockLocationName"];
            this.stockLocationPlace = _data["stockLocationPlace"];
            this.stockPositionTypeId = _data["stockPositionTypeId"];
            this.stockOwnerId = _data["stockOwnerId"];
            this.orderLeadtime = _data["orderLeadtime"];
            this.genericLoss = _data["genericLoss"];
            this.orderUnit = _data["orderUnit"];
            this.orderQuantity = _data["orderQuantity"];
            this.orderFraction = _data["orderFraction"];
            this.minimumOrderQuantity = _data["minimumOrderQuantity"];
            this.minimumStockLevel = _data["minimumStockLevel"];
            this.maximumStockLevel = _data["maximumStockLevel"];
            this.stockUnit = _data["stockUnit"];
            this.recipeUnit = _data["recipeUnit"];
            this.variantType = _data["variantType"];
            this.variantNextLowerLevel = _data["variantNextLowerLevel"];
            this.organicPercentage = _data["organicPercentage"];
            this.nonAgriculturalPercentage = _data["nonAgriculturalPercentage"];
            this.intrastat = _data["intrastat"];
            this.depth = _data["depth"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.depthUnit = _data["depthUnit"];
            this.heightUnit = _data["heightUnit"];
            this.widthUnit = _data["widthUnit"];
            this.grossWeight = _data["grossWeight"];
            this.grossWeightUnit = _data["grossWeightUnit"];
            this.netWeight = _data["netWeight"];
            this.netWeightUnit = _data["netWeightUnit"];
            this.storageMinimumTemperature = _data["storageMinimumTemperature"];
            this.storageMaximumTemperature = _data["storageMaximumTemperature"];
            this.gpcCategoryCode = _data["gpcCategoryCode"];
            this.gpcCategoryName = _data["gpcCategoryName"];
            this.minimumTradeItemLifespanFromTimeOfProduction = _data["minimumTradeItemLifespanFromTimeOfProduction"];
            this.minimumTradeItemLifespanFromTimeOfArrival = _data["minimumTradeItemLifespanFromTimeOfArrival"];
            this.productImage = _data["productImage"];
            this.layersPerPallet = _data["layersPerPallet"];
            this.casesPerPalletLayer = _data["casesPerPalletLayer"];
            this.palletGrossWeight = _data["palletGrossWeight"];
            this.palletGrossWeightUnit = _data["palletGrossWeightUnit"];
            this.palletHeight = _data["palletHeight"];
            this.palletHeightUnit = _data["palletHeightUnit"];
            this.defaultOrigin = _data["defaultOrigin"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.stockQuantity = _data["stockQuantity"];
            this.amount = _data["amount"];
            this.caseEan = _data["caseEan"];
            this.description = _data["description"];
            this.externalId = _data["externalId"];
            this.co2 = _data["co2"];
            this.co2source = _data["co2source"];
            this.isVegan = _data["isVegan"];
            this.isVegatarian = _data["isVegatarian"];
            this.isNoeglehul = _data["isNoeglehul"];
            this.isFuldkorn = _data["isFuldkorn"];
            this.isMsc = _data["isMsc"];
            this.isAsc = _data["isAsc"];
            this.isHalal = _data["isHalal"];
            this.isGlutenFree = _data["isGlutenFree"];
            this.isLactoseFree = _data["isLactoseFree"];
            this.customerId = _data["customerId"];
            this.customerContactId = _data["customerContactId"];
            this.wantedProfitMargin = _data["wantedProfitMargin"];
            this.manufacturer = _data["manufacturer"];
        }
    }

    static fromJS(data: any): ProductVariantModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductVariantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["productName"] = this.productName;
        data["unit"] = this.unit;
        data["unitPrice"] = this.unitPrice;
        data["salesPrice"] = this.salesPrice;
        data["density"] = this.density;
        data["sku"] = this.sku;
        data["supplierName"] = this.supplierName;
        data["supplierProductName"] = this.supplierProductName;
        data["supplierSku"] = this.supplierSku;
        data["bundleId"] = this.bundleId;
        data["isBundle"] = this.isBundle;
        data["isTraceable"] = this.isTraceable;
        data["isOrganic"] = this.isOrganic;
        data["isBarred"] = this.isBarred;
        data["noStockKeeping"] = this.noStockKeeping;
        data["noPicking"] = this.noPicking;
        data["durabilityType"] = this.durabilityType;
        data["durability"] = this.durability;
        data["durabilityFrozen"] = this.durabilityFrozen;
        data["durabilityRefrigerated"] = this.durabilityRefrigerated;
        data["durabilityOpen"] = this.durabilityOpen;
        data["durabilityUnit"] = this.durabilityUnit;
        data["lotExpiration"] = this.lotExpiration;
        data["hasOrigin"] = this.hasOrigin;
        data["unitsPerCase"] = this.unitsPerCase;
        data["caseTypeName"] = this.caseTypeName;
        data["processId"] = this.processId;
        data["languages"] = this.languages;
        data["labelType"] = this.labelType;
        data["labelLogo"] = this.labelLogo;
        data["nutritionQuantity"] = this.nutritionQuantity;
        data["emarked"] = this.emarked;
        data["ingredientListType"] = this.ingredientListType;
        data["ean"] = this.ean;
        data["stockLocationId"] = this.stockLocationId;
        data["stockLocationName"] = this.stockLocationName;
        data["stockLocationPlace"] = this.stockLocationPlace;
        data["stockPositionTypeId"] = this.stockPositionTypeId;
        data["stockOwnerId"] = this.stockOwnerId;
        data["orderLeadtime"] = this.orderLeadtime;
        data["genericLoss"] = this.genericLoss;
        data["orderUnit"] = this.orderUnit;
        data["orderQuantity"] = this.orderQuantity;
        data["orderFraction"] = this.orderFraction;
        data["minimumOrderQuantity"] = this.minimumOrderQuantity;
        data["minimumStockLevel"] = this.minimumStockLevel;
        data["maximumStockLevel"] = this.maximumStockLevel;
        data["stockUnit"] = this.stockUnit;
        data["recipeUnit"] = this.recipeUnit;
        data["variantType"] = this.variantType;
        data["variantNextLowerLevel"] = this.variantNextLowerLevel;
        data["organicPercentage"] = this.organicPercentage;
        data["nonAgriculturalPercentage"] = this.nonAgriculturalPercentage;
        data["intrastat"] = this.intrastat;
        data["depth"] = this.depth;
        data["height"] = this.height;
        data["width"] = this.width;
        data["depthUnit"] = this.depthUnit;
        data["heightUnit"] = this.heightUnit;
        data["widthUnit"] = this.widthUnit;
        data["grossWeight"] = this.grossWeight;
        data["grossWeightUnit"] = this.grossWeightUnit;
        data["netWeight"] = this.netWeight;
        data["netWeightUnit"] = this.netWeightUnit;
        data["storageMinimumTemperature"] = this.storageMinimumTemperature;
        data["storageMaximumTemperature"] = this.storageMaximumTemperature;
        data["gpcCategoryCode"] = this.gpcCategoryCode;
        data["gpcCategoryName"] = this.gpcCategoryName;
        data["minimumTradeItemLifespanFromTimeOfProduction"] = this.minimumTradeItemLifespanFromTimeOfProduction;
        data["minimumTradeItemLifespanFromTimeOfArrival"] = this.minimumTradeItemLifespanFromTimeOfArrival;
        data["productImage"] = this.productImage;
        data["layersPerPallet"] = this.layersPerPallet;
        data["casesPerPalletLayer"] = this.casesPerPalletLayer;
        data["palletGrossWeight"] = this.palletGrossWeight;
        data["palletGrossWeightUnit"] = this.palletGrossWeightUnit;
        data["palletHeight"] = this.palletHeight;
        data["palletHeightUnit"] = this.palletHeightUnit;
        data["defaultOrigin"] = this.defaultOrigin;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["stockQuantity"] = this.stockQuantity;
        data["amount"] = this.amount;
        data["caseEan"] = this.caseEan;
        data["description"] = this.description;
        data["externalId"] = this.externalId;
        data["co2"] = this.co2;
        data["co2source"] = this.co2source;
        data["isVegan"] = this.isVegan;
        data["isVegatarian"] = this.isVegatarian;
        data["isNoeglehul"] = this.isNoeglehul;
        data["isFuldkorn"] = this.isFuldkorn;
        data["isMsc"] = this.isMsc;
        data["isAsc"] = this.isAsc;
        data["isHalal"] = this.isHalal;
        data["isGlutenFree"] = this.isGlutenFree;
        data["isLactoseFree"] = this.isLactoseFree;
        data["customerId"] = this.customerId;
        data["customerContactId"] = this.customerContactId;
        data["wantedProfitMargin"] = this.wantedProfitMargin;
        data["manufacturer"] = this.manufacturer;
        return data;
    }

    clone(): ProductVariantModel {
        const json = this.toJSON();
        let result = new ProductVariantModel();
        result.init(json);
        return result;
    }
}

export interface IProductVariantModel {
    id?: string;
    productId?: string;
    name?: string | undefined;
    productName?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    salesPrice?: number;
    density?: number;
    sku?: string | undefined;
    supplierName?: string | undefined;
    supplierProductName?: string | undefined;
    supplierSku?: string | undefined;
    bundleId?: string | undefined;
    isBundle?: boolean | undefined;
    isTraceable?: boolean;
    isOrganic?: boolean;
    isBarred?: boolean;
    noStockKeeping?: boolean;
    noPicking?: boolean;
    durabilityType?: number;
    durability?: number;
    durabilityFrozen?: number;
    durabilityRefrigerated?: number;
    durabilityOpen?: number;
    durabilityUnit?: TimeUnitType;
    lotExpiration?: boolean;
    hasOrigin?: boolean;
    unitsPerCase?: number;
    caseTypeName?: string | undefined;
    processId?: string | undefined;
    languages?: string | undefined;
    labelType?: string | undefined;
    labelLogo?: string | undefined;
    nutritionQuantity?: number;
    emarked?: boolean;
    ingredientListType?: string | undefined;
    ean?: string | undefined;
    stockLocationId?: string | undefined;
    stockLocationName?: string | undefined;
    stockLocationPlace?: string | undefined;
    stockPositionTypeId?: string | undefined;
    stockOwnerId?: string | undefined;
    orderLeadtime?: number;
    genericLoss?: number;
    orderUnit?: string | undefined;
    orderQuantity?: number | undefined;
    orderFraction?: number | undefined;
    minimumOrderQuantity?: number | undefined;
    minimumStockLevel?: number | undefined;
    maximumStockLevel?: number | undefined;
    stockUnit?: string | undefined;
    recipeUnit?: string | undefined;
    variantType?: VariantType;
    variantNextLowerLevel?: string | undefined;
    organicPercentage?: number;
    nonAgriculturalPercentage?: number;
    intrastat?: string | undefined;
    depth?: number | undefined;
    height?: number | undefined;
    width?: number | undefined;
    depthUnit?: string | undefined;
    heightUnit?: string | undefined;
    widthUnit?: string | undefined;
    grossWeight?: number | undefined;
    grossWeightUnit?: string | undefined;
    netWeight?: number | undefined;
    netWeightUnit?: string | undefined;
    storageMinimumTemperature?: number | undefined;
    storageMaximumTemperature?: number | undefined;
    gpcCategoryCode?: string | undefined;
    gpcCategoryName?: string | undefined;
    minimumTradeItemLifespanFromTimeOfProduction?: number | undefined;
    minimumTradeItemLifespanFromTimeOfArrival?: number | undefined;
    productImage?: string | undefined;
    layersPerPallet?: number | undefined;
    casesPerPalletLayer?: number | undefined;
    palletGrossWeight?: number | undefined;
    palletGrossWeightUnit?: string | undefined;
    palletHeight?: number | undefined;
    palletHeightUnit?: string | undefined;
    defaultOrigin?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    stockQuantity?: number;
    amount?: number;
    caseEan?: string | undefined;
    description?: string | undefined;
    externalId?: string | undefined;
    co2?: number;
    co2source?: string | undefined;
    isVegan?: boolean;
    isVegatarian?: boolean;
    isNoeglehul?: boolean;
    isFuldkorn?: boolean;
    isMsc?: boolean;
    isAsc?: boolean;
    isHalal?: boolean;
    isGlutenFree?: boolean;
    isLactoseFree?: boolean;
    customerId?: string | undefined;
    customerContactId?: string | undefined;
    wantedProfitMargin?: number | undefined;
    manufacturer?: string | undefined;
}

export enum TimeUnitType {
    Second = 1,
    Minute = 2,
    Hour = 3,
    Day = 4,
    Week = 5,
    Month = 6,
    Year = 7,
}

export class PagedResultOfProductModel extends PagedResultBase implements IPagedResultOfProductModel {
    results?: ProductModel[];

    constructor(data?: IPagedResultOfProductModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProductModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfProductModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfProductModel {
        const json = this.toJSON();
        let result = new PagedResultOfProductModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfProductModel extends IPagedResultBase {
    results?: ProductModel[];
}

export class BulkChangeModel implements IBulkChangeModel {
    items?: IdNameModel[] | undefined;
    id?: string | undefined;
    number?: string | undefined;
    date?: Date | undefined;

    constructor(data?: IBulkChangeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IdNameModel.fromJS(item));
            }
            this.id = _data["id"];
            this.number = _data["number"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BulkChangeModel {
        data = typeof data === 'object' ? data : {};
        let result = new BulkChangeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }

    clone(): BulkChangeModel {
        const json = this.toJSON();
        let result = new BulkChangeModel();
        result.init(json);
        return result;
    }
}

export interface IBulkChangeModel {
    items?: IdNameModel[] | undefined;
    id?: string | undefined;
    number?: string | undefined;
    date?: Date | undefined;
}

export class ProductionOrderWithRecipeModel implements IProductionOrderWithRecipeModel {
    id?: string;
    recipeId?: string;
    recipe?: RecipeModel | undefined;
    startTime?: Date | undefined;
    finishTime?: Date | undefined;
    scaling?: number;
    status?: ProductionOrderStatus;
    lot?: string | undefined;
    parentOrderId?: string | undefined;
    salesOrderId?: string | undefined;
    prevOrder?: string;
    nextOrder?: string;
    wantedDate?: Date | undefined;
    plannedDate?: Date | undefined;
    expirationDate?: Date | undefined;
    calculatedQuantity?: number;
    actualQuantity?: number;
    outputUnit?: string | undefined;
    warnings?: string | undefined;
    readyForProduction?: boolean;
    parentInputQuantity?: number;
    internalNote?: string | undefined;
    productionOrderNumber?: string | undefined;
    salesOrderNumber?: string | undefined;
    customerName?: string | undefined;
    plannedWeight?: number;
    shifts?: ProductionShiftModel[] | undefined;
    userId?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
    recipeType?: number;
    recipeName?: string | undefined;
    recipeVersion?: string | undefined;
    processName?: string | undefined;

    constructor(data?: IProductionOrderWithRecipeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipeId = _data["recipeId"];
            this.recipe = _data["recipe"] ? RecipeModel.fromJS(_data["recipe"]) : undefined as any;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : undefined as any;
            this.scaling = _data["scaling"];
            this.status = _data["status"];
            this.lot = _data["lot"];
            this.parentOrderId = _data["parentOrderId"];
            this.salesOrderId = _data["salesOrderId"];
            this.prevOrder = _data["prevOrder"];
            this.nextOrder = _data["nextOrder"];
            this.wantedDate = _data["wantedDate"] ? new Date(_data["wantedDate"].toString()) : undefined as any;
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.calculatedQuantity = _data["calculatedQuantity"];
            this.actualQuantity = _data["actualQuantity"];
            this.outputUnit = _data["outputUnit"];
            this.warnings = _data["warnings"];
            this.readyForProduction = _data["readyForProduction"];
            this.parentInputQuantity = _data["parentInputQuantity"];
            this.internalNote = _data["internalNote"];
            this.productionOrderNumber = _data["productionOrderNumber"];
            this.salesOrderNumber = _data["salesOrderNumber"];
            this.customerName = _data["customerName"];
            this.plannedWeight = _data["plannedWeight"];
            if (Array.isArray(_data["shifts"])) {
                this.shifts = [] as any;
                for (let item of _data["shifts"])
                    this.shifts!.push(ProductionShiftModel.fromJS(item));
            }
            this.userId = _data["userId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.recipeType = _data["recipeType"];
            this.recipeName = _data["recipeName"];
            this.recipeVersion = _data["recipeVersion"];
            this.processName = _data["processName"];
        }
    }

    static fromJS(data: any): ProductionOrderWithRecipeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderWithRecipeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipeId"] = this.recipeId;
        data["recipe"] = this.recipe ? this.recipe.toJSON() : undefined as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : undefined as any;
        data["scaling"] = this.scaling;
        data["status"] = this.status;
        data["lot"] = this.lot;
        data["parentOrderId"] = this.parentOrderId;
        data["salesOrderId"] = this.salesOrderId;
        data["prevOrder"] = this.prevOrder;
        data["nextOrder"] = this.nextOrder;
        data["wantedDate"] = this.wantedDate ? this.wantedDate.toISOString() : undefined as any;
        data["plannedDate"] = this.plannedDate ? this.plannedDate.toISOString() : undefined as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["calculatedQuantity"] = this.calculatedQuantity;
        data["actualQuantity"] = this.actualQuantity;
        data["outputUnit"] = this.outputUnit;
        data["warnings"] = this.warnings;
        data["readyForProduction"] = this.readyForProduction;
        data["parentInputQuantity"] = this.parentInputQuantity;
        data["internalNote"] = this.internalNote;
        data["productionOrderNumber"] = this.productionOrderNumber;
        data["salesOrderNumber"] = this.salesOrderNumber;
        data["customerName"] = this.customerName;
        data["plannedWeight"] = this.plannedWeight;
        if (Array.isArray(this.shifts)) {
            data["shifts"] = [];
            for (let item of this.shifts)
                data["shifts"].push(item ? item.toJSON() : undefined as any);
        }
        data["userId"] = this.userId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["recipeType"] = this.recipeType;
        data["recipeName"] = this.recipeName;
        data["recipeVersion"] = this.recipeVersion;
        data["processName"] = this.processName;
        return data;
    }

    clone(): ProductionOrderWithRecipeModel {
        const json = this.toJSON();
        let result = new ProductionOrderWithRecipeModel();
        result.init(json);
        return result;
    }
}

export interface IProductionOrderWithRecipeModel {
    id?: string;
    recipeId?: string;
    recipe?: RecipeModel | undefined;
    startTime?: Date | undefined;
    finishTime?: Date | undefined;
    scaling?: number;
    status?: ProductionOrderStatus;
    lot?: string | undefined;
    parentOrderId?: string | undefined;
    salesOrderId?: string | undefined;
    prevOrder?: string;
    nextOrder?: string;
    wantedDate?: Date | undefined;
    plannedDate?: Date | undefined;
    expirationDate?: Date | undefined;
    calculatedQuantity?: number;
    actualQuantity?: number;
    outputUnit?: string | undefined;
    warnings?: string | undefined;
    readyForProduction?: boolean;
    parentInputQuantity?: number;
    internalNote?: string | undefined;
    productionOrderNumber?: string | undefined;
    salesOrderNumber?: string | undefined;
    customerName?: string | undefined;
    plannedWeight?: number;
    shifts?: ProductionShiftModel[] | undefined;
    userId?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
    recipeType?: number;
    recipeName?: string | undefined;
    recipeVersion?: string | undefined;
    processName?: string | undefined;
}

export class RecipeModel implements IRecipeModel {
    id?: string;
    name?: string | undefined;
    userId?: string;
    servings?: number;
    finishedWeight?: number;
    description?: string | undefined;
    processGroupId?: string | undefined;
    processId?: string | undefined;
    processName?: string | undefined;
    parentRecipeId?: string | undefined;
    parentRecipeName?: string | undefined;
    setupRecipeId?: string | undefined;
    setupRecipeName?: string | undefined;
    cleaningRecipeId?: string | undefined;
    cleaningRecipeName?: string | undefined;
    revision?: DocumentRevisionModel | undefined;
    recipeGroupId?: string | undefined;
    recipeGroupName?: string | undefined;
    duration?: number;
    durationExpression?: string | undefined;
    productionNoteTemplate?: string | undefined;
    type?: number;
    hasChildren?: boolean;
    stepSize?: number;
    isOrganic?: boolean;
    primaryOutput?: string;
    primaryOutputSku?: string | undefined;
    primaryOutputQuantity?: number;
    primaryOutputUnit?: string | undefined;
    warningText?: string | undefined;
    backgroundColor?: string | undefined;
    recipeNumber?: string | undefined;
    priority?: number;
    lastCalculated?: Date | undefined;
    calculationDirty?: boolean;
    categories?: ProcessModel[] | undefined;
    ingredients?: RecipeIngredientsModel[] | undefined;
    output?: RecipeIngredientsModel[] | undefined;
    nutrition?: NutritionModel | undefined;
    nutrition100G?: NutritionModel | undefined;
    ingredientList?: string | undefined;
    children?: RecipeModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IRecipeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.servings = _data["servings"];
            this.finishedWeight = _data["finishedWeight"];
            this.description = _data["description"];
            this.processGroupId = _data["processGroupId"];
            this.processId = _data["processId"];
            this.processName = _data["processName"];
            this.parentRecipeId = _data["parentRecipeId"];
            this.parentRecipeName = _data["parentRecipeName"];
            this.setupRecipeId = _data["setupRecipeId"];
            this.setupRecipeName = _data["setupRecipeName"];
            this.cleaningRecipeId = _data["cleaningRecipeId"];
            this.cleaningRecipeName = _data["cleaningRecipeName"];
            this.revision = _data["revision"] ? DocumentRevisionModel.fromJS(_data["revision"]) : undefined as any;
            this.recipeGroupId = _data["recipeGroupId"];
            this.recipeGroupName = _data["recipeGroupName"];
            this.duration = _data["duration"];
            this.durationExpression = _data["durationExpression"];
            this.productionNoteTemplate = _data["productionNoteTemplate"];
            this.type = _data["type"];
            this.hasChildren = _data["hasChildren"];
            this.stepSize = _data["stepSize"];
            this.isOrganic = _data["isOrganic"];
            this.primaryOutput = _data["primaryOutput"];
            this.primaryOutputSku = _data["primaryOutputSku"];
            this.primaryOutputQuantity = _data["primaryOutputQuantity"];
            this.primaryOutputUnit = _data["primaryOutputUnit"];
            this.warningText = _data["warningText"];
            this.backgroundColor = _data["backgroundColor"];
            this.recipeNumber = _data["recipeNumber"];
            this.priority = _data["priority"];
            this.lastCalculated = _data["lastCalculated"] ? new Date(_data["lastCalculated"].toString()) : undefined as any;
            this.calculationDirty = _data["calculationDirty"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ProcessModel.fromJS(item));
            }
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(RecipeIngredientsModel.fromJS(item));
            }
            if (Array.isArray(_data["output"])) {
                this.output = [] as any;
                for (let item of _data["output"])
                    this.output!.push(RecipeIngredientsModel.fromJS(item));
            }
            this.nutrition = _data["nutrition"] ? NutritionModel.fromJS(_data["nutrition"]) : undefined as any;
            this.nutrition100G = _data["nutrition100G"] ? NutritionModel.fromJS(_data["nutrition100G"]) : undefined as any;
            this.ingredientList = _data["ingredientList"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(RecipeModel.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RecipeModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["servings"] = this.servings;
        data["finishedWeight"] = this.finishedWeight;
        data["description"] = this.description;
        data["processGroupId"] = this.processGroupId;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        data["parentRecipeId"] = this.parentRecipeId;
        data["parentRecipeName"] = this.parentRecipeName;
        data["setupRecipeId"] = this.setupRecipeId;
        data["setupRecipeName"] = this.setupRecipeName;
        data["cleaningRecipeId"] = this.cleaningRecipeId;
        data["cleaningRecipeName"] = this.cleaningRecipeName;
        data["revision"] = this.revision ? this.revision.toJSON() : undefined as any;
        data["recipeGroupId"] = this.recipeGroupId;
        data["recipeGroupName"] = this.recipeGroupName;
        data["duration"] = this.duration;
        data["durationExpression"] = this.durationExpression;
        data["productionNoteTemplate"] = this.productionNoteTemplate;
        data["type"] = this.type;
        data["hasChildren"] = this.hasChildren;
        data["stepSize"] = this.stepSize;
        data["isOrganic"] = this.isOrganic;
        data["primaryOutput"] = this.primaryOutput;
        data["primaryOutputSku"] = this.primaryOutputSku;
        data["primaryOutputQuantity"] = this.primaryOutputQuantity;
        data["primaryOutputUnit"] = this.primaryOutputUnit;
        data["warningText"] = this.warningText;
        data["backgroundColor"] = this.backgroundColor;
        data["recipeNumber"] = this.recipeNumber;
        data["priority"] = this.priority;
        data["lastCalculated"] = this.lastCalculated ? this.lastCalculated.toISOString() : undefined as any;
        data["calculationDirty"] = this.calculationDirty;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.output)) {
            data["output"] = [];
            for (let item of this.output)
                data["output"].push(item ? item.toJSON() : undefined as any);
        }
        data["nutrition"] = this.nutrition ? this.nutrition.toJSON() : undefined as any;
        data["nutrition100G"] = this.nutrition100G ? this.nutrition100G.toJSON() : undefined as any;
        data["ingredientList"] = this.ingredientList;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): RecipeModel {
        const json = this.toJSON();
        let result = new RecipeModel();
        result.init(json);
        return result;
    }
}

export interface IRecipeModel {
    id?: string;
    name?: string | undefined;
    userId?: string;
    servings?: number;
    finishedWeight?: number;
    description?: string | undefined;
    processGroupId?: string | undefined;
    processId?: string | undefined;
    processName?: string | undefined;
    parentRecipeId?: string | undefined;
    parentRecipeName?: string | undefined;
    setupRecipeId?: string | undefined;
    setupRecipeName?: string | undefined;
    cleaningRecipeId?: string | undefined;
    cleaningRecipeName?: string | undefined;
    revision?: DocumentRevisionModel | undefined;
    recipeGroupId?: string | undefined;
    recipeGroupName?: string | undefined;
    duration?: number;
    durationExpression?: string | undefined;
    productionNoteTemplate?: string | undefined;
    type?: number;
    hasChildren?: boolean;
    stepSize?: number;
    isOrganic?: boolean;
    primaryOutput?: string;
    primaryOutputSku?: string | undefined;
    primaryOutputQuantity?: number;
    primaryOutputUnit?: string | undefined;
    warningText?: string | undefined;
    backgroundColor?: string | undefined;
    recipeNumber?: string | undefined;
    priority?: number;
    lastCalculated?: Date | undefined;
    calculationDirty?: boolean;
    categories?: ProcessModel[] | undefined;
    ingredients?: RecipeIngredientsModel[] | undefined;
    output?: RecipeIngredientsModel[] | undefined;
    nutrition?: NutritionModel | undefined;
    nutrition100G?: NutritionModel | undefined;
    ingredientList?: string | undefined;
    children?: RecipeModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class RecipeIngredientsModel implements IRecipeIngredientsModel {
    id?: string;
    recipeId?: string;
    ingredient?: IngredientModel | undefined;
    alternativeToId?: string;
    amount?: number;
    unit?: string | undefined;
    sortOrder?: number;
    density?: number;
    productUnit?: string | undefined;
    productUnitQuantity?: number;
    processStep?: IdNameModel | undefined;
    orderlines?: OrderlineModel[] | undefined;
    lossQuantity?: number;
    lossUnit?: string | undefined;
    unitsPerCase?: number;
    isQuid?: boolean;
    ignoreInDeclaration?: boolean;
    declarationGroup?: string | undefined;
    nutrition?: NutritionModel | undefined;
    categories?: ProcessModel[] | undefined;
    type?: string | undefined;
    actualAmount?: number;
    price?: number;
    quantityExpression?: string | undefined;
    bomOption?: BomOptionType;
    lots?: IdNameModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IRecipeIngredientsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipeId = _data["recipeId"];
            this.ingredient = _data["ingredient"] ? IngredientModel.fromJS(_data["ingredient"]) : undefined as any;
            this.alternativeToId = _data["alternativeToId"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
            this.sortOrder = _data["sortOrder"];
            this.density = _data["density"];
            this.productUnit = _data["productUnit"];
            this.productUnitQuantity = _data["productUnitQuantity"];
            this.processStep = _data["processStep"] ? IdNameModel.fromJS(_data["processStep"]) : undefined as any;
            if (Array.isArray(_data["orderlines"])) {
                this.orderlines = [] as any;
                for (let item of _data["orderlines"])
                    this.orderlines!.push(OrderlineModel.fromJS(item));
            }
            this.lossQuantity = _data["lossQuantity"];
            this.lossUnit = _data["lossUnit"];
            this.unitsPerCase = _data["unitsPerCase"];
            this.isQuid = _data["isQuid"];
            this.ignoreInDeclaration = _data["ignoreInDeclaration"];
            this.declarationGroup = _data["declarationGroup"];
            this.nutrition = _data["nutrition"] ? NutritionModel.fromJS(_data["nutrition"]) : undefined as any;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ProcessModel.fromJS(item));
            }
            this.type = _data["type"];
            this.actualAmount = _data["actualAmount"];
            this.price = _data["price"];
            this.quantityExpression = _data["quantityExpression"];
            this.bomOption = _data["bomOption"];
            if (Array.isArray(_data["lots"])) {
                this.lots = [] as any;
                for (let item of _data["lots"])
                    this.lots!.push(IdNameModel.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RecipeIngredientsModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeIngredientsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipeId"] = this.recipeId;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : undefined as any;
        data["alternativeToId"] = this.alternativeToId;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        data["sortOrder"] = this.sortOrder;
        data["density"] = this.density;
        data["productUnit"] = this.productUnit;
        data["productUnitQuantity"] = this.productUnitQuantity;
        data["processStep"] = this.processStep ? this.processStep.toJSON() : undefined as any;
        if (Array.isArray(this.orderlines)) {
            data["orderlines"] = [];
            for (let item of this.orderlines)
                data["orderlines"].push(item ? item.toJSON() : undefined as any);
        }
        data["lossQuantity"] = this.lossQuantity;
        data["lossUnit"] = this.lossUnit;
        data["unitsPerCase"] = this.unitsPerCase;
        data["isQuid"] = this.isQuid;
        data["ignoreInDeclaration"] = this.ignoreInDeclaration;
        data["declarationGroup"] = this.declarationGroup;
        data["nutrition"] = this.nutrition ? this.nutrition.toJSON() : undefined as any;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        data["type"] = this.type;
        data["actualAmount"] = this.actualAmount;
        data["price"] = this.price;
        data["quantityExpression"] = this.quantityExpression;
        data["bomOption"] = this.bomOption;
        if (Array.isArray(this.lots)) {
            data["lots"] = [];
            for (let item of this.lots)
                data["lots"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): RecipeIngredientsModel {
        const json = this.toJSON();
        let result = new RecipeIngredientsModel();
        result.init(json);
        return result;
    }
}

export interface IRecipeIngredientsModel {
    id?: string;
    recipeId?: string;
    ingredient?: IngredientModel | undefined;
    alternativeToId?: string;
    amount?: number;
    unit?: string | undefined;
    sortOrder?: number;
    density?: number;
    productUnit?: string | undefined;
    productUnitQuantity?: number;
    processStep?: IdNameModel | undefined;
    orderlines?: OrderlineModel[] | undefined;
    lossQuantity?: number;
    lossUnit?: string | undefined;
    unitsPerCase?: number;
    isQuid?: boolean;
    ignoreInDeclaration?: boolean;
    declarationGroup?: string | undefined;
    nutrition?: NutritionModel | undefined;
    categories?: ProcessModel[] | undefined;
    type?: string | undefined;
    actualAmount?: number;
    price?: number;
    quantityExpression?: string | undefined;
    bomOption?: BomOptionType;
    lots?: IdNameModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class IngredientModel implements IIngredientModel {
    id?: string;
    name?: string | undefined;
    sku?: string | undefined;
    productGroupId?: string;
    productId?: string;
    productName?: string | undefined;
    productVariantName?: string | undefined;
    productVariantUnitPrice?: number;
    supplierName?: string | undefined;
    productType?: string | undefined;
    productExtraText?: string | undefined;
    productRevision?: DocumentRevisionModel | undefined;
    isDeleted?: boolean;
    isTraceable?: boolean;
    isOrganic?: boolean;
    isNonAgricultural?: boolean;
    organicPercentage?: number;
    nonAgriculturalPercentage?: number;
    producingRecipeId?: string | undefined;
    producingRecipeIngredients?: RecipeIngredientsModel[] | undefined;

    constructor(data?: IIngredientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sku = _data["sku"];
            this.productGroupId = _data["productGroupId"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productVariantName = _data["productVariantName"];
            this.productVariantUnitPrice = _data["productVariantUnitPrice"];
            this.supplierName = _data["supplierName"];
            this.productType = _data["productType"];
            this.productExtraText = _data["productExtraText"];
            this.productRevision = _data["productRevision"] ? DocumentRevisionModel.fromJS(_data["productRevision"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.isTraceable = _data["isTraceable"];
            this.isOrganic = _data["isOrganic"];
            this.isNonAgricultural = _data["isNonAgricultural"];
            this.organicPercentage = _data["organicPercentage"];
            this.nonAgriculturalPercentage = _data["nonAgriculturalPercentage"];
            this.producingRecipeId = _data["producingRecipeId"];
            if (Array.isArray(_data["producingRecipeIngredients"])) {
                this.producingRecipeIngredients = [] as any;
                for (let item of _data["producingRecipeIngredients"])
                    this.producingRecipeIngredients!.push(RecipeIngredientsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IngredientModel {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sku"] = this.sku;
        data["productGroupId"] = this.productGroupId;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productVariantName"] = this.productVariantName;
        data["productVariantUnitPrice"] = this.productVariantUnitPrice;
        data["supplierName"] = this.supplierName;
        data["productType"] = this.productType;
        data["productExtraText"] = this.productExtraText;
        data["productRevision"] = this.productRevision ? this.productRevision.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["isTraceable"] = this.isTraceable;
        data["isOrganic"] = this.isOrganic;
        data["isNonAgricultural"] = this.isNonAgricultural;
        data["organicPercentage"] = this.organicPercentage;
        data["nonAgriculturalPercentage"] = this.nonAgriculturalPercentage;
        data["producingRecipeId"] = this.producingRecipeId;
        if (Array.isArray(this.producingRecipeIngredients)) {
            data["producingRecipeIngredients"] = [];
            for (let item of this.producingRecipeIngredients)
                data["producingRecipeIngredients"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): IngredientModel {
        const json = this.toJSON();
        let result = new IngredientModel();
        result.init(json);
        return result;
    }
}

export interface IIngredientModel {
    id?: string;
    name?: string | undefined;
    sku?: string | undefined;
    productGroupId?: string;
    productId?: string;
    productName?: string | undefined;
    productVariantName?: string | undefined;
    productVariantUnitPrice?: number;
    supplierName?: string | undefined;
    productType?: string | undefined;
    productExtraText?: string | undefined;
    productRevision?: DocumentRevisionModel | undefined;
    isDeleted?: boolean;
    isTraceable?: boolean;
    isOrganic?: boolean;
    isNonAgricultural?: boolean;
    organicPercentage?: number;
    nonAgriculturalPercentage?: number;
    producingRecipeId?: string | undefined;
    producingRecipeIngredients?: RecipeIngredientsModel[] | undefined;
}

export class NutritionModel implements INutritionModel {
    entityId?: string;
    weight?: number;
    volume?: number;
    energyKcal?: number | undefined;
    energyKj?: number | undefined;
    fat?: number | undefined;
    fatSaturated?: number | undefined;
    fatUnsaturated?: number | undefined;
    fatPolyUnsaturated?: number | undefined;
    protein?: number | undefined;
    carboHydrates?: number | undefined;
    sugars?: number | undefined;
    alcohol?: number | undefined;
    organicAcid?: number | undefined;
    fiber?: number | undefined;
    salt?: number | undefined;
    sugarAlcohol?: number | undefined;
    taurin?: number | undefined;
    moisture?: number | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    comment?: string | undefined;
    quantityType?: number;
    warning?: string | undefined;
    nutritionQuantity?: number;
    organicPercentage?: number;
    nonAgriculturalPercentage?: number;
    vitaminA?: number | undefined;
    vitaminB1?: number | undefined;
    vitaminB2?: number | undefined;
    vitaminB3?: number | undefined;
    vitaminB5?: number | undefined;
    vitaminB6?: number | undefined;
    vitaminB7?: number | undefined;
    vitaminB9?: number | undefined;
    vitaminB12?: number | undefined;
    vitaminC?: number | undefined;
    vitaminD?: number | undefined;
    vitaminE?: number | undefined;
    vitaminK?: number | undefined;
    potassium?: number | undefined;
    chlorine?: number | undefined;
    calcium?: number | undefined;
    phosphorus?: number | undefined;
    magnesium?: number | undefined;
    iron?: number | undefined;
    zinc?: number | undefined;
    copper?: number | undefined;
    manganese?: number | undefined;
    flourine?: number | undefined;
    selenium?: number | undefined;
    chromium?: number | undefined;
    molybdenum?: number | undefined;
    iodine?: number | undefined;
    milkSolids?: number | undefined;
    cocoaSolids?: number | undefined;
    inorganicMatter?: number | undefined;
    energyKcalOperator?: string | undefined;
    energyKjOperator?: string | undefined;
    fatOperator?: string | undefined;
    fatSaturatedOperator?: string | undefined;
    fatUnsaturatedOperator?: string | undefined;
    fatPolyUnsaturatedOperator?: string | undefined;
    proteinOperator?: string | undefined;
    carboHydratesOperator?: string | undefined;
    sugarsOperator?: string | undefined;
    alcoholOperator?: string | undefined;
    organicAcidOperator?: string | undefined;
    fiberOperator?: string | undefined;
    saltOperator?: string | undefined;
    sugarAlcoholOperator?: string | undefined;
    taurinOperator?: string | undefined;
    moistureOperator?: string | undefined;
    vitaminAOperator?: string | undefined;
    vitaminB1Operator?: string | undefined;
    vitaminB2Operator?: string | undefined;
    vitaminB3Operator?: string | undefined;
    vitaminB5Operator?: string | undefined;
    vitaminB6Operator?: string | undefined;
    vitaminB7Operator?: string | undefined;
    vitaminB9Operator?: string | undefined;
    vitaminB12Operator?: string | undefined;
    vitaminCOperator?: string | undefined;
    vitaminDOperator?: string | undefined;
    vitaminEOperator?: string | undefined;
    vitaminKOperator?: string | undefined;
    potassiumOperator?: string | undefined;
    chlorineOperator?: string | undefined;
    calciumOperator?: string | undefined;
    phosphorusOperator?: string | undefined;
    magnesiumOperator?: string | undefined;
    ironOperator?: string | undefined;
    zincOperator?: string | undefined;
    copperOperator?: string | undefined;
    manganeseOperator?: string | undefined;
    flourineOperator?: string | undefined;
    seleniumOperator?: string | undefined;
    chromiumOperator?: string | undefined;
    molybdenumOperator?: string | undefined;
    iodineOperator?: string | undefined;
    milkSolidsOperator?: string | undefined;
    cocoaSolidsOperator?: string | undefined;
    inorganicMatterOperator?: string | undefined;
    lglutamin?: number | undefined;
    larginin?: number | undefined;
    lleucin?: number | undefined;
    lisoleucin?: number | undefined;
    lvalin?: number | undefined;
    bromelain?: number | undefined;
    papain?: number | undefined;
    creatin?: number | undefined;
    inulin?: number | undefined;
    wheyProtein?: number | undefined;
    caffeine?: number | undefined;
    fatTrans?: number | undefined;
    fatCholesterol?: number | undefined;
    addedSugar?: number | undefined;
    lglutaminOpertor?: string | undefined;
    largininOperator?: string | undefined;
    lleucinOperator?: string | undefined;
    lisoleucinOperator?: string | undefined;
    lvalinOperator?: string | undefined;
    bromelainOperator?: string | undefined;
    papainOperator?: string | undefined;
    creatinOperator?: string | undefined;
    inulinOperator?: string | undefined;
    wheyProteinOperator?: string | undefined;
    caffeineOperator?: string | undefined;
    fatTransOperator?: string | undefined;
    fatCholesterolOperator?: string | undefined;
    addedSugarOperator?: string | undefined;
    adi?: string | undefined;

    constructor(data?: INutritionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.weight = _data["weight"];
            this.volume = _data["volume"];
            this.energyKcal = _data["energyKcal"];
            this.energyKj = _data["energyKj"];
            this.fat = _data["fat"];
            this.fatSaturated = _data["fatSaturated"];
            this.fatUnsaturated = _data["fatUnsaturated"];
            this.fatPolyUnsaturated = _data["fatPolyUnsaturated"];
            this.protein = _data["protein"];
            this.carboHydrates = _data["carboHydrates"];
            this.sugars = _data["sugars"];
            this.alcohol = _data["alcohol"];
            this.organicAcid = _data["organicAcid"];
            this.fiber = _data["fiber"];
            this.salt = _data["salt"];
            this.sugarAlcohol = _data["sugarAlcohol"];
            this.taurin = _data["taurin"];
            this.moisture = _data["moisture"];
            this.source = _data["source"];
            this.sourceType = _data["sourceType"];
            this.comment = _data["comment"];
            this.quantityType = _data["quantityType"];
            this.warning = _data["warning"];
            this.nutritionQuantity = _data["nutritionQuantity"];
            this.organicPercentage = _data["organicPercentage"];
            this.nonAgriculturalPercentage = _data["nonAgriculturalPercentage"];
            this.vitaminA = _data["vitaminA"];
            this.vitaminB1 = _data["vitaminB1"];
            this.vitaminB2 = _data["vitaminB2"];
            this.vitaminB3 = _data["vitaminB3"];
            this.vitaminB5 = _data["vitaminB5"];
            this.vitaminB6 = _data["vitaminB6"];
            this.vitaminB7 = _data["vitaminB7"];
            this.vitaminB9 = _data["vitaminB9"];
            this.vitaminB12 = _data["vitaminB12"];
            this.vitaminC = _data["vitaminC"];
            this.vitaminD = _data["vitaminD"];
            this.vitaminE = _data["vitaminE"];
            this.vitaminK = _data["vitaminK"];
            this.potassium = _data["potassium"];
            this.chlorine = _data["chlorine"];
            this.calcium = _data["calcium"];
            this.phosphorus = _data["phosphorus"];
            this.magnesium = _data["magnesium"];
            this.iron = _data["iron"];
            this.zinc = _data["zinc"];
            this.copper = _data["copper"];
            this.manganese = _data["manganese"];
            this.flourine = _data["flourine"];
            this.selenium = _data["selenium"];
            this.chromium = _data["chromium"];
            this.molybdenum = _data["molybdenum"];
            this.iodine = _data["iodine"];
            this.milkSolids = _data["milkSolids"];
            this.cocoaSolids = _data["cocoaSolids"];
            this.inorganicMatter = _data["inorganicMatter"];
            this.energyKcalOperator = _data["energyKcalOperator"];
            this.energyKjOperator = _data["energyKjOperator"];
            this.fatOperator = _data["fatOperator"];
            this.fatSaturatedOperator = _data["fatSaturatedOperator"];
            this.fatUnsaturatedOperator = _data["fatUnsaturatedOperator"];
            this.fatPolyUnsaturatedOperator = _data["fatPolyUnsaturatedOperator"];
            this.proteinOperator = _data["proteinOperator"];
            this.carboHydratesOperator = _data["carboHydratesOperator"];
            this.sugarsOperator = _data["sugarsOperator"];
            this.alcoholOperator = _data["alcoholOperator"];
            this.organicAcidOperator = _data["organicAcidOperator"];
            this.fiberOperator = _data["fiberOperator"];
            this.saltOperator = _data["saltOperator"];
            this.sugarAlcoholOperator = _data["sugarAlcoholOperator"];
            this.taurinOperator = _data["taurinOperator"];
            this.moistureOperator = _data["moistureOperator"];
            this.vitaminAOperator = _data["vitaminAOperator"];
            this.vitaminB1Operator = _data["vitaminB1Operator"];
            this.vitaminB2Operator = _data["vitaminB2Operator"];
            this.vitaminB3Operator = _data["vitaminB3Operator"];
            this.vitaminB5Operator = _data["vitaminB5Operator"];
            this.vitaminB6Operator = _data["vitaminB6Operator"];
            this.vitaminB7Operator = _data["vitaminB7Operator"];
            this.vitaminB9Operator = _data["vitaminB9Operator"];
            this.vitaminB12Operator = _data["vitaminB12Operator"];
            this.vitaminCOperator = _data["vitaminCOperator"];
            this.vitaminDOperator = _data["vitaminDOperator"];
            this.vitaminEOperator = _data["vitaminEOperator"];
            this.vitaminKOperator = _data["vitaminKOperator"];
            this.potassiumOperator = _data["potassiumOperator"];
            this.chlorineOperator = _data["chlorineOperator"];
            this.calciumOperator = _data["calciumOperator"];
            this.phosphorusOperator = _data["phosphorusOperator"];
            this.magnesiumOperator = _data["magnesiumOperator"];
            this.ironOperator = _data["ironOperator"];
            this.zincOperator = _data["zincOperator"];
            this.copperOperator = _data["copperOperator"];
            this.manganeseOperator = _data["manganeseOperator"];
            this.flourineOperator = _data["flourineOperator"];
            this.seleniumOperator = _data["seleniumOperator"];
            this.chromiumOperator = _data["chromiumOperator"];
            this.molybdenumOperator = _data["molybdenumOperator"];
            this.iodineOperator = _data["iodineOperator"];
            this.milkSolidsOperator = _data["milkSolidsOperator"];
            this.cocoaSolidsOperator = _data["cocoaSolidsOperator"];
            this.inorganicMatterOperator = _data["inorganicMatterOperator"];
            this.lglutamin = _data["lglutamin"];
            this.larginin = _data["larginin"];
            this.lleucin = _data["lleucin"];
            this.lisoleucin = _data["lisoleucin"];
            this.lvalin = _data["lvalin"];
            this.bromelain = _data["bromelain"];
            this.papain = _data["papain"];
            this.creatin = _data["creatin"];
            this.inulin = _data["inulin"];
            this.wheyProtein = _data["wheyProtein"];
            this.caffeine = _data["caffeine"];
            this.fatTrans = _data["fatTrans"];
            this.fatCholesterol = _data["fatCholesterol"];
            this.addedSugar = _data["addedSugar"];
            this.lglutaminOpertor = _data["lglutaminOpertor"];
            this.largininOperator = _data["largininOperator"];
            this.lleucinOperator = _data["lleucinOperator"];
            this.lisoleucinOperator = _data["lisoleucinOperator"];
            this.lvalinOperator = _data["lvalinOperator"];
            this.bromelainOperator = _data["bromelainOperator"];
            this.papainOperator = _data["papainOperator"];
            this.creatinOperator = _data["creatinOperator"];
            this.inulinOperator = _data["inulinOperator"];
            this.wheyProteinOperator = _data["wheyProteinOperator"];
            this.caffeineOperator = _data["caffeineOperator"];
            this.fatTransOperator = _data["fatTransOperator"];
            this.fatCholesterolOperator = _data["fatCholesterolOperator"];
            this.addedSugarOperator = _data["addedSugarOperator"];
            this.adi = _data["adi"];
        }
    }

    static fromJS(data: any): NutritionModel {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["weight"] = this.weight;
        data["volume"] = this.volume;
        data["energyKcal"] = this.energyKcal;
        data["energyKj"] = this.energyKj;
        data["fat"] = this.fat;
        data["fatSaturated"] = this.fatSaturated;
        data["fatUnsaturated"] = this.fatUnsaturated;
        data["fatPolyUnsaturated"] = this.fatPolyUnsaturated;
        data["protein"] = this.protein;
        data["carboHydrates"] = this.carboHydrates;
        data["sugars"] = this.sugars;
        data["alcohol"] = this.alcohol;
        data["organicAcid"] = this.organicAcid;
        data["fiber"] = this.fiber;
        data["salt"] = this.salt;
        data["sugarAlcohol"] = this.sugarAlcohol;
        data["taurin"] = this.taurin;
        data["moisture"] = this.moisture;
        data["source"] = this.source;
        data["sourceType"] = this.sourceType;
        data["comment"] = this.comment;
        data["quantityType"] = this.quantityType;
        data["warning"] = this.warning;
        data["nutritionQuantity"] = this.nutritionQuantity;
        data["organicPercentage"] = this.organicPercentage;
        data["nonAgriculturalPercentage"] = this.nonAgriculturalPercentage;
        data["vitaminA"] = this.vitaminA;
        data["vitaminB1"] = this.vitaminB1;
        data["vitaminB2"] = this.vitaminB2;
        data["vitaminB3"] = this.vitaminB3;
        data["vitaminB5"] = this.vitaminB5;
        data["vitaminB6"] = this.vitaminB6;
        data["vitaminB7"] = this.vitaminB7;
        data["vitaminB9"] = this.vitaminB9;
        data["vitaminB12"] = this.vitaminB12;
        data["vitaminC"] = this.vitaminC;
        data["vitaminD"] = this.vitaminD;
        data["vitaminE"] = this.vitaminE;
        data["vitaminK"] = this.vitaminK;
        data["potassium"] = this.potassium;
        data["chlorine"] = this.chlorine;
        data["calcium"] = this.calcium;
        data["phosphorus"] = this.phosphorus;
        data["magnesium"] = this.magnesium;
        data["iron"] = this.iron;
        data["zinc"] = this.zinc;
        data["copper"] = this.copper;
        data["manganese"] = this.manganese;
        data["flourine"] = this.flourine;
        data["selenium"] = this.selenium;
        data["chromium"] = this.chromium;
        data["molybdenum"] = this.molybdenum;
        data["iodine"] = this.iodine;
        data["milkSolids"] = this.milkSolids;
        data["cocoaSolids"] = this.cocoaSolids;
        data["inorganicMatter"] = this.inorganicMatter;
        data["energyKcalOperator"] = this.energyKcalOperator;
        data["energyKjOperator"] = this.energyKjOperator;
        data["fatOperator"] = this.fatOperator;
        data["fatSaturatedOperator"] = this.fatSaturatedOperator;
        data["fatUnsaturatedOperator"] = this.fatUnsaturatedOperator;
        data["fatPolyUnsaturatedOperator"] = this.fatPolyUnsaturatedOperator;
        data["proteinOperator"] = this.proteinOperator;
        data["carboHydratesOperator"] = this.carboHydratesOperator;
        data["sugarsOperator"] = this.sugarsOperator;
        data["alcoholOperator"] = this.alcoholOperator;
        data["organicAcidOperator"] = this.organicAcidOperator;
        data["fiberOperator"] = this.fiberOperator;
        data["saltOperator"] = this.saltOperator;
        data["sugarAlcoholOperator"] = this.sugarAlcoholOperator;
        data["taurinOperator"] = this.taurinOperator;
        data["moistureOperator"] = this.moistureOperator;
        data["vitaminAOperator"] = this.vitaminAOperator;
        data["vitaminB1Operator"] = this.vitaminB1Operator;
        data["vitaminB2Operator"] = this.vitaminB2Operator;
        data["vitaminB3Operator"] = this.vitaminB3Operator;
        data["vitaminB5Operator"] = this.vitaminB5Operator;
        data["vitaminB6Operator"] = this.vitaminB6Operator;
        data["vitaminB7Operator"] = this.vitaminB7Operator;
        data["vitaminB9Operator"] = this.vitaminB9Operator;
        data["vitaminB12Operator"] = this.vitaminB12Operator;
        data["vitaminCOperator"] = this.vitaminCOperator;
        data["vitaminDOperator"] = this.vitaminDOperator;
        data["vitaminEOperator"] = this.vitaminEOperator;
        data["vitaminKOperator"] = this.vitaminKOperator;
        data["potassiumOperator"] = this.potassiumOperator;
        data["chlorineOperator"] = this.chlorineOperator;
        data["calciumOperator"] = this.calciumOperator;
        data["phosphorusOperator"] = this.phosphorusOperator;
        data["magnesiumOperator"] = this.magnesiumOperator;
        data["ironOperator"] = this.ironOperator;
        data["zincOperator"] = this.zincOperator;
        data["copperOperator"] = this.copperOperator;
        data["manganeseOperator"] = this.manganeseOperator;
        data["flourineOperator"] = this.flourineOperator;
        data["seleniumOperator"] = this.seleniumOperator;
        data["chromiumOperator"] = this.chromiumOperator;
        data["molybdenumOperator"] = this.molybdenumOperator;
        data["iodineOperator"] = this.iodineOperator;
        data["milkSolidsOperator"] = this.milkSolidsOperator;
        data["cocoaSolidsOperator"] = this.cocoaSolidsOperator;
        data["inorganicMatterOperator"] = this.inorganicMatterOperator;
        data["lglutamin"] = this.lglutamin;
        data["larginin"] = this.larginin;
        data["lleucin"] = this.lleucin;
        data["lisoleucin"] = this.lisoleucin;
        data["lvalin"] = this.lvalin;
        data["bromelain"] = this.bromelain;
        data["papain"] = this.papain;
        data["creatin"] = this.creatin;
        data["inulin"] = this.inulin;
        data["wheyProtein"] = this.wheyProtein;
        data["caffeine"] = this.caffeine;
        data["fatTrans"] = this.fatTrans;
        data["fatCholesterol"] = this.fatCholesterol;
        data["addedSugar"] = this.addedSugar;
        data["lglutaminOpertor"] = this.lglutaminOpertor;
        data["largininOperator"] = this.largininOperator;
        data["lleucinOperator"] = this.lleucinOperator;
        data["lisoleucinOperator"] = this.lisoleucinOperator;
        data["lvalinOperator"] = this.lvalinOperator;
        data["bromelainOperator"] = this.bromelainOperator;
        data["papainOperator"] = this.papainOperator;
        data["creatinOperator"] = this.creatinOperator;
        data["inulinOperator"] = this.inulinOperator;
        data["wheyProteinOperator"] = this.wheyProteinOperator;
        data["caffeineOperator"] = this.caffeineOperator;
        data["fatTransOperator"] = this.fatTransOperator;
        data["fatCholesterolOperator"] = this.fatCholesterolOperator;
        data["addedSugarOperator"] = this.addedSugarOperator;
        data["adi"] = this.adi;
        return data;
    }

    clone(): NutritionModel {
        const json = this.toJSON();
        let result = new NutritionModel();
        result.init(json);
        return result;
    }
}

export interface INutritionModel {
    entityId?: string;
    weight?: number;
    volume?: number;
    energyKcal?: number | undefined;
    energyKj?: number | undefined;
    fat?: number | undefined;
    fatSaturated?: number | undefined;
    fatUnsaturated?: number | undefined;
    fatPolyUnsaturated?: number | undefined;
    protein?: number | undefined;
    carboHydrates?: number | undefined;
    sugars?: number | undefined;
    alcohol?: number | undefined;
    organicAcid?: number | undefined;
    fiber?: number | undefined;
    salt?: number | undefined;
    sugarAlcohol?: number | undefined;
    taurin?: number | undefined;
    moisture?: number | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    comment?: string | undefined;
    quantityType?: number;
    warning?: string | undefined;
    nutritionQuantity?: number;
    organicPercentage?: number;
    nonAgriculturalPercentage?: number;
    vitaminA?: number | undefined;
    vitaminB1?: number | undefined;
    vitaminB2?: number | undefined;
    vitaminB3?: number | undefined;
    vitaminB5?: number | undefined;
    vitaminB6?: number | undefined;
    vitaminB7?: number | undefined;
    vitaminB9?: number | undefined;
    vitaminB12?: number | undefined;
    vitaminC?: number | undefined;
    vitaminD?: number | undefined;
    vitaminE?: number | undefined;
    vitaminK?: number | undefined;
    potassium?: number | undefined;
    chlorine?: number | undefined;
    calcium?: number | undefined;
    phosphorus?: number | undefined;
    magnesium?: number | undefined;
    iron?: number | undefined;
    zinc?: number | undefined;
    copper?: number | undefined;
    manganese?: number | undefined;
    flourine?: number | undefined;
    selenium?: number | undefined;
    chromium?: number | undefined;
    molybdenum?: number | undefined;
    iodine?: number | undefined;
    milkSolids?: number | undefined;
    cocoaSolids?: number | undefined;
    inorganicMatter?: number | undefined;
    energyKcalOperator?: string | undefined;
    energyKjOperator?: string | undefined;
    fatOperator?: string | undefined;
    fatSaturatedOperator?: string | undefined;
    fatUnsaturatedOperator?: string | undefined;
    fatPolyUnsaturatedOperator?: string | undefined;
    proteinOperator?: string | undefined;
    carboHydratesOperator?: string | undefined;
    sugarsOperator?: string | undefined;
    alcoholOperator?: string | undefined;
    organicAcidOperator?: string | undefined;
    fiberOperator?: string | undefined;
    saltOperator?: string | undefined;
    sugarAlcoholOperator?: string | undefined;
    taurinOperator?: string | undefined;
    moistureOperator?: string | undefined;
    vitaminAOperator?: string | undefined;
    vitaminB1Operator?: string | undefined;
    vitaminB2Operator?: string | undefined;
    vitaminB3Operator?: string | undefined;
    vitaminB5Operator?: string | undefined;
    vitaminB6Operator?: string | undefined;
    vitaminB7Operator?: string | undefined;
    vitaminB9Operator?: string | undefined;
    vitaminB12Operator?: string | undefined;
    vitaminCOperator?: string | undefined;
    vitaminDOperator?: string | undefined;
    vitaminEOperator?: string | undefined;
    vitaminKOperator?: string | undefined;
    potassiumOperator?: string | undefined;
    chlorineOperator?: string | undefined;
    calciumOperator?: string | undefined;
    phosphorusOperator?: string | undefined;
    magnesiumOperator?: string | undefined;
    ironOperator?: string | undefined;
    zincOperator?: string | undefined;
    copperOperator?: string | undefined;
    manganeseOperator?: string | undefined;
    flourineOperator?: string | undefined;
    seleniumOperator?: string | undefined;
    chromiumOperator?: string | undefined;
    molybdenumOperator?: string | undefined;
    iodineOperator?: string | undefined;
    milkSolidsOperator?: string | undefined;
    cocoaSolidsOperator?: string | undefined;
    inorganicMatterOperator?: string | undefined;
    lglutamin?: number | undefined;
    larginin?: number | undefined;
    lleucin?: number | undefined;
    lisoleucin?: number | undefined;
    lvalin?: number | undefined;
    bromelain?: number | undefined;
    papain?: number | undefined;
    creatin?: number | undefined;
    inulin?: number | undefined;
    wheyProtein?: number | undefined;
    caffeine?: number | undefined;
    fatTrans?: number | undefined;
    fatCholesterol?: number | undefined;
    addedSugar?: number | undefined;
    lglutaminOpertor?: string | undefined;
    largininOperator?: string | undefined;
    lleucinOperator?: string | undefined;
    lisoleucinOperator?: string | undefined;
    lvalinOperator?: string | undefined;
    bromelainOperator?: string | undefined;
    papainOperator?: string | undefined;
    creatinOperator?: string | undefined;
    inulinOperator?: string | undefined;
    wheyProteinOperator?: string | undefined;
    caffeineOperator?: string | undefined;
    fatTransOperator?: string | undefined;
    fatCholesterolOperator?: string | undefined;
    addedSugarOperator?: string | undefined;
    adi?: string | undefined;
}

export enum BomOptionType {
    Normal = 0,
    BomStop = 1,
    BomCollapse = 2,
}

export class OrderlineWarningModel implements IOrderlineWarningModel {
    id?: string;
    orderId?: string;
    orderlineId?: string;
    productVariantId?: string;
    status?: WarningStatus;
    type?: WarningType;
    demandDate?: Date | undefined;
    expectedDate?: Date | undefined;
    requiredQuantity?: number;
    availableQuantity?: number;
    orderedQuantity?: number;
    message?: string | undefined;
    note?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IOrderlineWarningModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.orderlineId = _data["orderlineId"];
            this.productVariantId = _data["productVariantId"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.demandDate = _data["demandDate"] ? new Date(_data["demandDate"].toString()) : undefined as any;
            this.expectedDate = _data["expectedDate"] ? new Date(_data["expectedDate"].toString()) : undefined as any;
            this.requiredQuantity = _data["requiredQuantity"];
            this.availableQuantity = _data["availableQuantity"];
            this.orderedQuantity = _data["orderedQuantity"];
            this.message = _data["message"];
            this.note = _data["note"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): OrderlineWarningModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderlineWarningModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["orderlineId"] = this.orderlineId;
        data["productVariantId"] = this.productVariantId;
        data["status"] = this.status;
        data["type"] = this.type;
        data["demandDate"] = this.demandDate ? this.demandDate.toISOString() : undefined as any;
        data["expectedDate"] = this.expectedDate ? this.expectedDate.toISOString() : undefined as any;
        data["requiredQuantity"] = this.requiredQuantity;
        data["availableQuantity"] = this.availableQuantity;
        data["orderedQuantity"] = this.orderedQuantity;
        data["message"] = this.message;
        data["note"] = this.note;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): OrderlineWarningModel {
        const json = this.toJSON();
        let result = new OrderlineWarningModel();
        result.init(json);
        return result;
    }
}

export interface IOrderlineWarningModel {
    id?: string;
    orderId?: string;
    orderlineId?: string;
    productVariantId?: string;
    status?: WarningStatus;
    type?: WarningType;
    demandDate?: Date | undefined;
    expectedDate?: Date | undefined;
    requiredQuantity?: number;
    availableQuantity?: number;
    orderedQuantity?: number;
    message?: string | undefined;
    note?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum WarningStatus {
    New = 1,
    Acknowledged = 2,
    Resolved = 3,
}

export enum WarningType {
    PurchaseOrder = 1,
    PurchaseOrderline = 2,
    SalesOrder = 3,
    SalesOrderline = 4,
    ProductionOrder = 5,
    ProductionOrderline = 6,
    MissingRaw = 7,
    MissingSemiFinished = 8,
    MissingPackaging = 9,
    RecipeInput = 10,
    RecipeOutput = 11,
    RecipeNutrition = 12,
    RecipeAllergens = 13,
    StockOrder = 14,
}

export class PagedResultOfProductionOrderModel extends PagedResultBase implements IPagedResultOfProductionOrderModel {
    results?: ProductionOrderModel[];

    constructor(data?: IPagedResultOfProductionOrderModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProductionOrderModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfProductionOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfProductionOrderModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfProductionOrderModel {
        const json = this.toJSON();
        let result = new PagedResultOfProductionOrderModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfProductionOrderModel extends IPagedResultBase {
    results?: ProductionOrderModel[];
}

export class ProductionOrderPlanningModel implements IProductionOrderPlanningModel {
    id?: string;
    recipeId?: string;
    startTime?: Date | undefined;
    finishTime?: Date | undefined;
    actualStartTime?: Date | undefined;
    actualFinishTime?: Date | undefined;
    scaling?: number;
    status?: ProductionOrderStatus;
    lot?: string | undefined;
    parentOrderId?: string | undefined;
    salesOrderId?: string | undefined;
    prevOrder?: string;
    nextOrder?: string;
    wantedDate?: Date | undefined;
    plannedDate?: Date | undefined;
    expirationDate?: Date | undefined;
    calculatedQuantity?: number;
    actualQuantity?: number;
    outputUnit?: string | undefined;
    warnings?: string | undefined;
    readyForProduction?: boolean;
    parentInputQuantity?: number;
    internalNote?: string | undefined;
    productionOrderNumber?: string | undefined;
    salesOrderNumber?: string | undefined;
    customerName?: string | undefined;
    plannedWeight?: number;
    actualWeight?: number;
    shifts?: ProductionShiftModel[] | undefined;
    userId?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
    recipeType?: number;
    recipeName?: string | undefined;
    recipeVersion?: string | undefined;
    processName?: string | undefined;
    processId?: string | undefined;
    responsibleUserId?: string;
    responsibleUserName?: string | undefined;
    manPowerText?: string | undefined;
    machineryText?: string | undefined;
    recipeTypeText?: string | undefined;
    allocations?: ResourceAllocationModel[] | undefined;

    constructor(data?: IProductionOrderPlanningModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipeId = _data["recipeId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : undefined as any;
            this.actualStartTime = _data["actualStartTime"] ? new Date(_data["actualStartTime"].toString()) : undefined as any;
            this.actualFinishTime = _data["actualFinishTime"] ? new Date(_data["actualFinishTime"].toString()) : undefined as any;
            this.scaling = _data["scaling"];
            this.status = _data["status"];
            this.lot = _data["lot"];
            this.parentOrderId = _data["parentOrderId"];
            this.salesOrderId = _data["salesOrderId"];
            this.prevOrder = _data["prevOrder"];
            this.nextOrder = _data["nextOrder"];
            this.wantedDate = _data["wantedDate"] ? new Date(_data["wantedDate"].toString()) : undefined as any;
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.calculatedQuantity = _data["calculatedQuantity"];
            this.actualQuantity = _data["actualQuantity"];
            this.outputUnit = _data["outputUnit"];
            this.warnings = _data["warnings"];
            this.readyForProduction = _data["readyForProduction"];
            this.parentInputQuantity = _data["parentInputQuantity"];
            this.internalNote = _data["internalNote"];
            this.productionOrderNumber = _data["productionOrderNumber"];
            this.salesOrderNumber = _data["salesOrderNumber"];
            this.customerName = _data["customerName"];
            this.plannedWeight = _data["plannedWeight"];
            this.actualWeight = _data["actualWeight"];
            if (Array.isArray(_data["shifts"])) {
                this.shifts = [] as any;
                for (let item of _data["shifts"])
                    this.shifts!.push(ProductionShiftModel.fromJS(item));
            }
            this.userId = _data["userId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.recipeType = _data["recipeType"];
            this.recipeName = _data["recipeName"];
            this.recipeVersion = _data["recipeVersion"];
            this.processName = _data["processName"];
            this.processId = _data["processId"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.responsibleUserName = _data["responsibleUserName"];
            this.manPowerText = _data["manPowerText"];
            this.machineryText = _data["machineryText"];
            this.recipeTypeText = _data["recipeTypeText"];
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(ResourceAllocationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductionOrderPlanningModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderPlanningModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipeId"] = this.recipeId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : undefined as any;
        data["actualStartTime"] = this.actualStartTime ? this.actualStartTime.toISOString() : undefined as any;
        data["actualFinishTime"] = this.actualFinishTime ? this.actualFinishTime.toISOString() : undefined as any;
        data["scaling"] = this.scaling;
        data["status"] = this.status;
        data["lot"] = this.lot;
        data["parentOrderId"] = this.parentOrderId;
        data["salesOrderId"] = this.salesOrderId;
        data["prevOrder"] = this.prevOrder;
        data["nextOrder"] = this.nextOrder;
        data["wantedDate"] = this.wantedDate ? this.wantedDate.toISOString() : undefined as any;
        data["plannedDate"] = this.plannedDate ? this.plannedDate.toISOString() : undefined as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["calculatedQuantity"] = this.calculatedQuantity;
        data["actualQuantity"] = this.actualQuantity;
        data["outputUnit"] = this.outputUnit;
        data["warnings"] = this.warnings;
        data["readyForProduction"] = this.readyForProduction;
        data["parentInputQuantity"] = this.parentInputQuantity;
        data["internalNote"] = this.internalNote;
        data["productionOrderNumber"] = this.productionOrderNumber;
        data["salesOrderNumber"] = this.salesOrderNumber;
        data["customerName"] = this.customerName;
        data["plannedWeight"] = this.plannedWeight;
        data["actualWeight"] = this.actualWeight;
        if (Array.isArray(this.shifts)) {
            data["shifts"] = [];
            for (let item of this.shifts)
                data["shifts"].push(item ? item.toJSON() : undefined as any);
        }
        data["userId"] = this.userId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["recipeType"] = this.recipeType;
        data["recipeName"] = this.recipeName;
        data["recipeVersion"] = this.recipeVersion;
        data["processName"] = this.processName;
        data["processId"] = this.processId;
        data["responsibleUserId"] = this.responsibleUserId;
        data["responsibleUserName"] = this.responsibleUserName;
        data["manPowerText"] = this.manPowerText;
        data["machineryText"] = this.machineryText;
        data["recipeTypeText"] = this.recipeTypeText;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ProductionOrderPlanningModel {
        const json = this.toJSON();
        let result = new ProductionOrderPlanningModel();
        result.init(json);
        return result;
    }
}

export interface IProductionOrderPlanningModel {
    id?: string;
    recipeId?: string;
    startTime?: Date | undefined;
    finishTime?: Date | undefined;
    actualStartTime?: Date | undefined;
    actualFinishTime?: Date | undefined;
    scaling?: number;
    status?: ProductionOrderStatus;
    lot?: string | undefined;
    parentOrderId?: string | undefined;
    salesOrderId?: string | undefined;
    prevOrder?: string;
    nextOrder?: string;
    wantedDate?: Date | undefined;
    plannedDate?: Date | undefined;
    expirationDate?: Date | undefined;
    calculatedQuantity?: number;
    actualQuantity?: number;
    outputUnit?: string | undefined;
    warnings?: string | undefined;
    readyForProduction?: boolean;
    parentInputQuantity?: number;
    internalNote?: string | undefined;
    productionOrderNumber?: string | undefined;
    salesOrderNumber?: string | undefined;
    customerName?: string | undefined;
    plannedWeight?: number;
    actualWeight?: number;
    shifts?: ProductionShiftModel[] | undefined;
    userId?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
    recipeType?: number;
    recipeName?: string | undefined;
    recipeVersion?: string | undefined;
    processName?: string | undefined;
    processId?: string | undefined;
    responsibleUserId?: string;
    responsibleUserName?: string | undefined;
    manPowerText?: string | undefined;
    machineryText?: string | undefined;
    recipeTypeText?: string | undefined;
    allocations?: ResourceAllocationModel[] | undefined;
}

export class ProductionOrderBulkChangeModel implements IProductionOrderBulkChangeModel {
    items?: StockItemModel[] | undefined;
    id?: string;
    number?: string | undefined;
    date?: Date | undefined;

    constructor(data?: IProductionOrderBulkChangeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StockItemModel.fromJS(item));
            }
            this.id = _data["id"];
            this.number = _data["number"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ProductionOrderBulkChangeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderBulkChangeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }

    clone(): ProductionOrderBulkChangeModel {
        const json = this.toJSON();
        let result = new ProductionOrderBulkChangeModel();
        result.init(json);
        return result;
    }
}

export interface IProductionOrderBulkChangeModel {
    items?: StockItemModel[] | undefined;
    id?: string;
    number?: string | undefined;
    date?: Date | undefined;
}

export class AllocateOrderModel implements IAllocateOrderModel {
    orderId?: string;
    startDate?: Date;
    allocations?: ResourceRequirementAllocationModel[] | undefined;
    calendarId?: string;
    numberOfShifts?: number;
    productionNote?: string | undefined;

    constructor(data?: IAllocateOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(ResourceRequirementAllocationModel.fromJS(item));
            }
            this.calendarId = _data["calendarId"];
            this.numberOfShifts = _data["numberOfShifts"];
            this.productionNote = _data["productionNote"];
        }
    }

    static fromJS(data: any): AllocateOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllocateOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item ? item.toJSON() : undefined as any);
        }
        data["calendarId"] = this.calendarId;
        data["numberOfShifts"] = this.numberOfShifts;
        data["productionNote"] = this.productionNote;
        return data;
    }

    clone(): AllocateOrderModel {
        const json = this.toJSON();
        let result = new AllocateOrderModel();
        result.init(json);
        return result;
    }
}

export interface IAllocateOrderModel {
    orderId?: string;
    startDate?: Date;
    allocations?: ResourceRequirementAllocationModel[] | undefined;
    calendarId?: string;
    numberOfShifts?: number;
    productionNote?: string | undefined;
}

export class ResourceRequirementAllocationModel implements IResourceRequirementAllocationModel {
    id?: string;
    resourceId?: string;
    productionOrderId?: string;
    requirementId?: string | undefined;
    resourceName?: string | undefined;
    requirementName?: string | undefined;
    resourceType?: ResourceType;
    type?: number;
    requirement?: ResourceRequirementModel | undefined;
    resource?: ResourceModel | undefined;
    availableResources?: ResourceModel[] | undefined;

    constructor(data?: IResourceRequirementAllocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourceId = _data["resourceId"];
            this.productionOrderId = _data["productionOrderId"];
            this.requirementId = _data["requirementId"];
            this.resourceName = _data["resourceName"];
            this.requirementName = _data["requirementName"];
            this.resourceType = _data["resourceType"];
            this.type = _data["type"];
            this.requirement = _data["requirement"] ? ResourceRequirementModel.fromJS(_data["requirement"]) : undefined as any;
            this.resource = _data["resource"] ? ResourceModel.fromJS(_data["resource"]) : undefined as any;
            if (Array.isArray(_data["availableResources"])) {
                this.availableResources = [] as any;
                for (let item of _data["availableResources"])
                    this.availableResources!.push(ResourceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResourceRequirementAllocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceRequirementAllocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resourceId"] = this.resourceId;
        data["productionOrderId"] = this.productionOrderId;
        data["requirementId"] = this.requirementId;
        data["resourceName"] = this.resourceName;
        data["requirementName"] = this.requirementName;
        data["resourceType"] = this.resourceType;
        data["type"] = this.type;
        data["requirement"] = this.requirement ? this.requirement.toJSON() : undefined as any;
        data["resource"] = this.resource ? this.resource.toJSON() : undefined as any;
        if (Array.isArray(this.availableResources)) {
            data["availableResources"] = [];
            for (let item of this.availableResources)
                data["availableResources"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ResourceRequirementAllocationModel {
        const json = this.toJSON();
        let result = new ResourceRequirementAllocationModel();
        result.init(json);
        return result;
    }
}

export interface IResourceRequirementAllocationModel {
    id?: string;
    resourceId?: string;
    productionOrderId?: string;
    requirementId?: string | undefined;
    resourceName?: string | undefined;
    requirementName?: string | undefined;
    resourceType?: ResourceType;
    type?: number;
    requirement?: ResourceRequirementModel | undefined;
    resource?: ResourceModel | undefined;
    availableResources?: ResourceModel[] | undefined;
}

export class ResourceRequirementModel implements IResourceRequirementModel {
    id?: string;
    name?: string | undefined;
    processId?: string | undefined;
    processStepId?: string | undefined;
    recipeId?: string | undefined;
    capabilityId?: string;
    capabilityName?: string | undefined;
    quantity?: number;
    preferredResource?: string | undefined;
    preferredResourceName?: string | undefined;
    type?: number;
    parentRequirementId?: string | undefined;
    isOptional?: boolean;
    sortOrder?: number;
    durationExpression?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    departmentId?: string | undefined;

    constructor(data?: IResourceRequirementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.processId = _data["processId"];
            this.processStepId = _data["processStepId"];
            this.recipeId = _data["recipeId"];
            this.capabilityId = _data["capabilityId"];
            this.capabilityName = _data["capabilityName"];
            this.quantity = _data["quantity"];
            this.preferredResource = _data["preferredResource"];
            this.preferredResourceName = _data["preferredResourceName"];
            this.type = _data["type"];
            this.parentRequirementId = _data["parentRequirementId"];
            this.isOptional = _data["isOptional"];
            this.sortOrder = _data["sortOrder"];
            this.durationExpression = _data["durationExpression"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): ResourceRequirementModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceRequirementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["processId"] = this.processId;
        data["processStepId"] = this.processStepId;
        data["recipeId"] = this.recipeId;
        data["capabilityId"] = this.capabilityId;
        data["capabilityName"] = this.capabilityName;
        data["quantity"] = this.quantity;
        data["preferredResource"] = this.preferredResource;
        data["preferredResourceName"] = this.preferredResourceName;
        data["type"] = this.type;
        data["parentRequirementId"] = this.parentRequirementId;
        data["isOptional"] = this.isOptional;
        data["sortOrder"] = this.sortOrder;
        data["durationExpression"] = this.durationExpression;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["departmentId"] = this.departmentId;
        return data;
    }

    clone(): ResourceRequirementModel {
        const json = this.toJSON();
        let result = new ResourceRequirementModel();
        result.init(json);
        return result;
    }
}

export interface IResourceRequirementModel {
    id?: string;
    name?: string | undefined;
    processId?: string | undefined;
    processStepId?: string | undefined;
    recipeId?: string | undefined;
    capabilityId?: string;
    capabilityName?: string | undefined;
    quantity?: number;
    preferredResource?: string | undefined;
    preferredResourceName?: string | undefined;
    type?: number;
    parentRequirementId?: string | undefined;
    isOptional?: boolean;
    sortOrder?: number;
    durationExpression?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    departmentId?: string | undefined;
}

export class ResourceModel implements IResourceModel {
    id?: string;
    name?: string | undefined;
    type?: ResourceType;
    costPerUnit?: number;
    costPerHour?: number;
    costPerKg?: number;
    costFixed?: number;
    co2PerUnit?: number;
    co2PerHour?: number;
    co2PerKg?: number;
    co2Fixed?: number;
    organizationId?: string;
    capabilities?: ResourceCapabilityModel[] | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
    departmentId?: string | undefined;

    constructor(data?: IResourceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.costPerUnit = _data["costPerUnit"];
            this.costPerHour = _data["costPerHour"];
            this.costPerKg = _data["costPerKg"];
            this.costFixed = _data["costFixed"];
            this.co2PerUnit = _data["co2PerUnit"];
            this.co2PerHour = _data["co2PerHour"];
            this.co2PerKg = _data["co2PerKg"];
            this.co2Fixed = _data["co2Fixed"];
            this.organizationId = _data["organizationId"];
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(ResourceCapabilityModel.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): ResourceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["costPerUnit"] = this.costPerUnit;
        data["costPerHour"] = this.costPerHour;
        data["costPerKg"] = this.costPerKg;
        data["costFixed"] = this.costFixed;
        data["co2PerUnit"] = this.co2PerUnit;
        data["co2PerHour"] = this.co2PerHour;
        data["co2PerKg"] = this.co2PerKg;
        data["co2Fixed"] = this.co2Fixed;
        data["organizationId"] = this.organizationId;
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["departmentId"] = this.departmentId;
        return data;
    }

    clone(): ResourceModel {
        const json = this.toJSON();
        let result = new ResourceModel();
        result.init(json);
        return result;
    }
}

export interface IResourceModel {
    id?: string;
    name?: string | undefined;
    type?: ResourceType;
    costPerUnit?: number;
    costPerHour?: number;
    costPerKg?: number;
    costFixed?: number;
    co2PerUnit?: number;
    co2PerHour?: number;
    co2PerKg?: number;
    co2Fixed?: number;
    organizationId?: string;
    capabilities?: ResourceCapabilityModel[] | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
    departmentId?: string | undefined;
}

export class ResourceCapabilityModel implements IResourceCapabilityModel {
    id?: string;
    resourceId?: string;
    capabilityId?: string;
    capabilityName?: string | undefined;
    capacity?: number;
    capacityScaling?: number;
    capacityUnit?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    departmentId?: string | undefined;

    constructor(data?: IResourceCapabilityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourceId = _data["resourceId"];
            this.capabilityId = _data["capabilityId"];
            this.capabilityName = _data["capabilityName"];
            this.capacity = _data["capacity"];
            this.capacityScaling = _data["capacityScaling"];
            this.capacityUnit = _data["capacityUnit"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): ResourceCapabilityModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceCapabilityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resourceId"] = this.resourceId;
        data["capabilityId"] = this.capabilityId;
        data["capabilityName"] = this.capabilityName;
        data["capacity"] = this.capacity;
        data["capacityScaling"] = this.capacityScaling;
        data["capacityUnit"] = this.capacityUnit;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["departmentId"] = this.departmentId;
        return data;
    }

    clone(): ResourceCapabilityModel {
        const json = this.toJSON();
        let result = new ResourceCapabilityModel();
        result.init(json);
        return result;
    }
}

export interface IResourceCapabilityModel {
    id?: string;
    resourceId?: string;
    capabilityId?: string;
    capabilityName?: string | undefined;
    capacity?: number;
    capacityScaling?: number;
    capacityUnit?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    departmentId?: string | undefined;
}

export class FillLotModel implements IFillLotModel {
    orders?: ProductionOrderModel[] | undefined;
    lot?: LotModel | undefined;

    constructor(data?: IFillLotModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(ProductionOrderModel.fromJS(item));
            }
            this.lot = _data["lot"] ? LotModel.fromJS(_data["lot"]) : undefined as any;
        }
    }

    static fromJS(data: any): FillLotModel {
        data = typeof data === 'object' ? data : {};
        let result = new FillLotModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : undefined as any);
        }
        data["lot"] = this.lot ? this.lot.toJSON() : undefined as any;
        return data;
    }

    clone(): FillLotModel {
        const json = this.toJSON();
        let result = new FillLotModel();
        result.init(json);
        return result;
    }
}

export interface IFillLotModel {
    orders?: ProductionOrderModel[] | undefined;
    lot?: LotModel | undefined;
}

export class ProductionOrderlineModel implements IProductionOrderlineModel {
    id?: string;
    productionOrderId?: string;
    productionOrderlineId?: string;
    productVariantId?: string;
    recipeIngredientId?: string;
    actualAmount?: number;
    unit?: string | undefined;
    date?: Date;
    lot?: IdNameModel | undefined;
    type?: OrderlineType;

    constructor(data?: IProductionOrderlineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productionOrderId = _data["productionOrderId"];
            this.productionOrderlineId = _data["productionOrderlineId"];
            this.productVariantId = _data["productVariantId"];
            this.recipeIngredientId = _data["recipeIngredientId"];
            this.actualAmount = _data["actualAmount"];
            this.unit = _data["unit"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.lot = _data["lot"] ? IdNameModel.fromJS(_data["lot"]) : undefined as any;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ProductionOrderlineModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderlineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productionOrderId"] = this.productionOrderId;
        data["productionOrderlineId"] = this.productionOrderlineId;
        data["productVariantId"] = this.productVariantId;
        data["recipeIngredientId"] = this.recipeIngredientId;
        data["actualAmount"] = this.actualAmount;
        data["unit"] = this.unit;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["lot"] = this.lot ? this.lot.toJSON() : undefined as any;
        data["type"] = this.type;
        return data;
    }

    clone(): ProductionOrderlineModel {
        const json = this.toJSON();
        let result = new ProductionOrderlineModel();
        result.init(json);
        return result;
    }
}

export interface IProductionOrderlineModel {
    id?: string;
    productionOrderId?: string;
    productionOrderlineId?: string;
    productVariantId?: string;
    recipeIngredientId?: string;
    actualAmount?: number;
    unit?: string | undefined;
    date?: Date;
    lot?: IdNameModel | undefined;
    type?: OrderlineType;
}

export class ProductionPlannerModel implements IProductionPlannerModel {
    orders?: PlanningOrder[] | undefined;
    resources?: PlanningResource[] | undefined;
    capabilities?: PlanningCapability[] | undefined;
    calendars?: PlanningCalendar[] | undefined;
    orderDependencies?: PlanningOrderDependency[] | undefined;

    constructor(data?: IProductionPlannerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(PlanningOrder.fromJS(item));
            }
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(PlanningResource.fromJS(item));
            }
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(PlanningCapability.fromJS(item));
            }
            if (Array.isArray(_data["calendars"])) {
                this.calendars = [] as any;
                for (let item of _data["calendars"])
                    this.calendars!.push(PlanningCalendar.fromJS(item));
            }
            if (Array.isArray(_data["orderDependencies"])) {
                this.orderDependencies = [] as any;
                for (let item of _data["orderDependencies"])
                    this.orderDependencies!.push(PlanningOrderDependency.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductionPlannerModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlannerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.calendars)) {
            data["calendars"] = [];
            for (let item of this.calendars)
                data["calendars"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.orderDependencies)) {
            data["orderDependencies"] = [];
            for (let item of this.orderDependencies)
                data["orderDependencies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ProductionPlannerModel {
        const json = this.toJSON();
        let result = new ProductionPlannerModel();
        result.init(json);
        return result;
    }
}

export interface IProductionPlannerModel {
    orders?: PlanningOrder[] | undefined;
    resources?: PlanningResource[] | undefined;
    capabilities?: PlanningCapability[] | undefined;
    calendars?: PlanningCalendar[] | undefined;
    orderDependencies?: PlanningOrderDependency[] | undefined;
}

export class PlanningOrder implements IPlanningOrder {
    id?: string;
    deadline?: Date;
    startTime?: Date | undefined;
    finishTime?: Date | undefined;
    productionOrderNumber?: string | undefined;
    recipeName?: string | undefined;
    recipeId?: string;
    duration?: string;
    requiredCapabilities?: string[] | undefined;

    constructor(data?: IPlanningOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : undefined as any;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.finishTime = _data["finishTime"] ? new Date(_data["finishTime"].toString()) : undefined as any;
            this.productionOrderNumber = _data["productionOrderNumber"];
            this.recipeName = _data["recipeName"];
            this.recipeId = _data["recipeId"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["requiredCapabilities"])) {
                this.requiredCapabilities = [] as any;
                for (let item of _data["requiredCapabilities"])
                    this.requiredCapabilities!.push(item);
            }
        }
    }

    static fromJS(data: any): PlanningOrder {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : undefined as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : undefined as any;
        data["productionOrderNumber"] = this.productionOrderNumber;
        data["recipeName"] = this.recipeName;
        data["recipeId"] = this.recipeId;
        data["duration"] = this.duration;
        if (Array.isArray(this.requiredCapabilities)) {
            data["requiredCapabilities"] = [];
            for (let item of this.requiredCapabilities)
                data["requiredCapabilities"].push(item);
        }
        return data;
    }

    clone(): PlanningOrder {
        const json = this.toJSON();
        let result = new PlanningOrder();
        result.init(json);
        return result;
    }
}

export interface IPlanningOrder {
    id?: string;
    deadline?: Date;
    startTime?: Date | undefined;
    finishTime?: Date | undefined;
    productionOrderNumber?: string | undefined;
    recipeName?: string | undefined;
    recipeId?: string;
    duration?: string;
    requiredCapabilities?: string[] | undefined;
}

export class PlanningResource implements IPlanningResource {
    id?: string;
    name?: string | undefined;
    capabilities?: string[] | undefined;

    constructor(data?: IPlanningResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(item);
            }
        }
    }

    static fromJS(data: any): PlanningResource {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item);
        }
        return data;
    }

    clone(): PlanningResource {
        const json = this.toJSON();
        let result = new PlanningResource();
        result.init(json);
        return result;
    }
}

export interface IPlanningResource {
    id?: string;
    name?: string | undefined;
    capabilities?: string[] | undefined;
}

export class PlanningCapability implements IPlanningCapability {
    id?: string;
    name?: string | undefined;

    constructor(data?: IPlanningCapability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PlanningCapability {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningCapability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PlanningCapability {
        const json = this.toJSON();
        let result = new PlanningCapability();
        result.init(json);
        return result;
    }
}

export interface IPlanningCapability {
    id?: string;
    name?: string | undefined;
}

export class PlanningCalendar implements IPlanningCalendar {
    id?: string;

    constructor(data?: IPlanningCalendar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PlanningCalendar {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningCalendar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): PlanningCalendar {
        const json = this.toJSON();
        let result = new PlanningCalendar();
        result.init(json);
        return result;
    }
}

export interface IPlanningCalendar {
    id?: string;
}

export class PlanningOrderDependency implements IPlanningOrderDependency {
    id?: string;
    order1?: string;
    order2?: string;
    dependencyType?: number;

    constructor(data?: IPlanningOrderDependency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order1 = _data["order1"];
            this.order2 = _data["order2"];
            this.dependencyType = _data["dependencyType"];
        }
    }

    static fromJS(data: any): PlanningOrderDependency {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningOrderDependency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order1"] = this.order1;
        data["order2"] = this.order2;
        data["dependencyType"] = this.dependencyType;
        return data;
    }

    clone(): PlanningOrderDependency {
        const json = this.toJSON();
        let result = new PlanningOrderDependency();
        result.init(json);
        return result;
    }
}

export interface IPlanningOrderDependency {
    id?: string;
    order1?: string;
    order2?: string;
    dependencyType?: number;
}

export class EdiResponseOfString implements IEdiResponseOfString {
    data?: string | undefined;
    reference?: string | undefined;
    statusCode?: HttpStatusCode;
    errors?: string[] | undefined;
    warnings?: string[] | undefined;

    constructor(data?: IEdiResponseOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.reference = _data["reference"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
        }
    }

    static fromJS(data: any): EdiResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EdiResponseOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["reference"] = this.reference;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        return data;
    }

    clone(): EdiResponseOfString {
        const json = this.toJSON();
        let result = new EdiResponseOfString();
        result.init(json);
        return result;
    }
}

export interface IEdiResponseOfString {
    data?: string | undefined;
    reference?: string | undefined;
    statusCode?: HttpStatusCode;
    errors?: string[] | undefined;
    warnings?: string[] | undefined;
}

/** 包含針對 HTTP 所定義的狀態碼值。 */
export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 300,
    MovedPermanently = 301,
    Moved = 301,
    Found = 302,
    Redirect = 302,
    SeeOther = 303,
    RedirectMethod = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    TemporaryRedirect = 307,
    RedirectKeepVerb = 307,
    PermanentRedirect = 308,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    RequestEntityTooLarge = 413,
    RequestUriTooLong = 414,
    UnsupportedMediaType = 415,
    RequestedRangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    MisdirectedRequest = 421,
    UnprocessableEntity = 422,
    UnprocessableContent = 422,
    Locked = 423,
    FailedDependency = 424,
    UpgradeRequired = 426,
    PreconditionRequired = 428,
    TooManyRequests = 429,
    RequestHeaderFieldsTooLarge = 431,
    UnavailableForLegalReasons = 451,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
    VariantAlsoNegotiates = 506,
    InsufficientStorage = 507,
    LoopDetected = 508,
    NotExtended = 510,
    NetworkAuthenticationRequired = 511,
}

export class NutritionDataModel implements INutritionDataModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: INutritionDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): NutritionDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): NutritionDataModel {
        const json = this.toJSON();
        let result = new NutritionDataModel();
        result.init(json);
        return result;
    }
}

export interface INutritionDataModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class CharacteristicsModel implements ICharacteristicsModel {
    entityId?: string;
    water?: number | undefined;
    aw?: number | undefined;
    ph?: number | undefined;
    preservatives?: string | undefined;
    readyToEat?: boolean | undefined;
    limits?: string | undefined;
    durability?: string | undefined;
    storageTemperature?: string | undefined;
    consumerGroups?: string | undefined;
    mealSize?: string | undefined;
    packaging?: string | undefined;
    extraordinaryConditions?: string | undefined;

    constructor(data?: ICharacteristicsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.water = _data["water"];
            this.aw = _data["aw"];
            this.ph = _data["ph"];
            this.preservatives = _data["preservatives"];
            this.readyToEat = _data["readyToEat"];
            this.limits = _data["limits"];
            this.durability = _data["durability"];
            this.storageTemperature = _data["storageTemperature"];
            this.consumerGroups = _data["consumerGroups"];
            this.mealSize = _data["mealSize"];
            this.packaging = _data["packaging"];
            this.extraordinaryConditions = _data["extraordinaryConditions"];
        }
    }

    static fromJS(data: any): CharacteristicsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["water"] = this.water;
        data["aw"] = this.aw;
        data["ph"] = this.ph;
        data["preservatives"] = this.preservatives;
        data["readyToEat"] = this.readyToEat;
        data["limits"] = this.limits;
        data["durability"] = this.durability;
        data["storageTemperature"] = this.storageTemperature;
        data["consumerGroups"] = this.consumerGroups;
        data["mealSize"] = this.mealSize;
        data["packaging"] = this.packaging;
        data["extraordinaryConditions"] = this.extraordinaryConditions;
        return data;
    }

    clone(): CharacteristicsModel {
        const json = this.toJSON();
        let result = new CharacteristicsModel();
        result.init(json);
        return result;
    }
}

export interface ICharacteristicsModel {
    entityId?: string;
    water?: number | undefined;
    aw?: number | undefined;
    ph?: number | undefined;
    preservatives?: string | undefined;
    readyToEat?: boolean | undefined;
    limits?: string | undefined;
    durability?: string | undefined;
    storageTemperature?: string | undefined;
    consumerGroups?: string | undefined;
    mealSize?: string | undefined;
    packaging?: string | undefined;
    extraordinaryConditions?: string | undefined;
}

export class ProductDescriptionModel implements IProductDescriptionModel {
    entityId?: string;
    language?: string | undefined;
    brand?: string | undefined;
    functionalName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    ingredients?: string | undefined;
    ingredientsType?: string | undefined;
    ingredientsIncludeName?: boolean;
    allergenText?: string | undefined;
    labelType?: string | undefined;
    preparation?: string | undefined;
    storage?: string | undefined;
    bestBefore?: string | undefined;
    producedBy?: string | undefined;
    eMarked?: boolean;
    weightDescription?: string | undefined;
    originDescription?: string | undefined;

    constructor(data?: IProductDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.language = _data["language"];
            this.brand = _data["brand"];
            this.functionalName = _data["functionalName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ingredients = _data["ingredients"];
            this.ingredientsType = _data["ingredientsType"];
            this.ingredientsIncludeName = _data["ingredientsIncludeName"];
            this.allergenText = _data["allergenText"];
            this.labelType = _data["labelType"];
            this.preparation = _data["preparation"];
            this.storage = _data["storage"];
            this.bestBefore = _data["bestBefore"];
            this.producedBy = _data["producedBy"];
            this.eMarked = _data["eMarked"];
            this.weightDescription = _data["weightDescription"];
            this.originDescription = _data["originDescription"];
        }
    }

    static fromJS(data: any): ProductDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["language"] = this.language;
        data["brand"] = this.brand;
        data["functionalName"] = this.functionalName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ingredients"] = this.ingredients;
        data["ingredientsType"] = this.ingredientsType;
        data["ingredientsIncludeName"] = this.ingredientsIncludeName;
        data["allergenText"] = this.allergenText;
        data["labelType"] = this.labelType;
        data["preparation"] = this.preparation;
        data["storage"] = this.storage;
        data["bestBefore"] = this.bestBefore;
        data["producedBy"] = this.producedBy;
        data["eMarked"] = this.eMarked;
        data["weightDescription"] = this.weightDescription;
        data["originDescription"] = this.originDescription;
        return data;
    }

    clone(): ProductDescriptionModel {
        const json = this.toJSON();
        let result = new ProductDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface IProductDescriptionModel {
    entityId?: string;
    language?: string | undefined;
    brand?: string | undefined;
    functionalName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    ingredients?: string | undefined;
    ingredientsType?: string | undefined;
    ingredientsIncludeName?: boolean;
    allergenText?: string | undefined;
    labelType?: string | undefined;
    preparation?: string | undefined;
    storage?: string | undefined;
    bestBefore?: string | undefined;
    producedBy?: string | undefined;
    eMarked?: boolean;
    weightDescription?: string | undefined;
    originDescription?: string | undefined;
}

export class AllergensModel implements IAllergensModel {
    entityId?: string;
    gluten?: number | undefined;
    crustacean?: number | undefined;
    egg?: number | undefined;
    fish?: number | undefined;
    peanuts?: number | undefined;
    soy?: number | undefined;
    milk?: number | undefined;
    nuts?: number | undefined;
    almonds?: number | undefined;
    brazilNut?: number | undefined;
    pecanNut?: number | undefined;
    cashewNut?: number | undefined;
    hazelnut?: number | undefined;
    walnut?: number | undefined;
    pistachioNut?: number | undefined;
    macadamiaNut?: number | undefined;
    otherNuts?: number | undefined;
    celary?: number | undefined;
    mustard?: number | undefined;
    sesameSeeds?: number | undefined;
    sulfurDioxideSulfits?: number | undefined;
    lupine?: number | undefined;
    molluscs?: number | undefined;
    sourceType?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IAllergensModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.gluten = _data["gluten"];
            this.crustacean = _data["crustacean"];
            this.egg = _data["egg"];
            this.fish = _data["fish"];
            this.peanuts = _data["peanuts"];
            this.soy = _data["soy"];
            this.milk = _data["milk"];
            this.nuts = _data["nuts"];
            this.almonds = _data["almonds"];
            this.brazilNut = _data["brazilNut"];
            this.pecanNut = _data["pecanNut"];
            this.cashewNut = _data["cashewNut"];
            this.hazelnut = _data["hazelnut"];
            this.walnut = _data["walnut"];
            this.pistachioNut = _data["pistachioNut"];
            this.macadamiaNut = _data["macadamiaNut"];
            this.otherNuts = _data["otherNuts"];
            this.celary = _data["celary"];
            this.mustard = _data["mustard"];
            this.sesameSeeds = _data["sesameSeeds"];
            this.sulfurDioxideSulfits = _data["sulfurDioxideSulfits"];
            this.lupine = _data["lupine"];
            this.molluscs = _data["molluscs"];
            this.sourceType = _data["sourceType"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): AllergensModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllergensModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["gluten"] = this.gluten;
        data["crustacean"] = this.crustacean;
        data["egg"] = this.egg;
        data["fish"] = this.fish;
        data["peanuts"] = this.peanuts;
        data["soy"] = this.soy;
        data["milk"] = this.milk;
        data["nuts"] = this.nuts;
        data["almonds"] = this.almonds;
        data["brazilNut"] = this.brazilNut;
        data["pecanNut"] = this.pecanNut;
        data["cashewNut"] = this.cashewNut;
        data["hazelnut"] = this.hazelnut;
        data["walnut"] = this.walnut;
        data["pistachioNut"] = this.pistachioNut;
        data["macadamiaNut"] = this.macadamiaNut;
        data["otherNuts"] = this.otherNuts;
        data["celary"] = this.celary;
        data["mustard"] = this.mustard;
        data["sesameSeeds"] = this.sesameSeeds;
        data["sulfurDioxideSulfits"] = this.sulfurDioxideSulfits;
        data["lupine"] = this.lupine;
        data["molluscs"] = this.molluscs;
        data["sourceType"] = this.sourceType;
        data["comment"] = this.comment;
        return data;
    }

    clone(): AllergensModel {
        const json = this.toJSON();
        let result = new AllergensModel();
        result.init(json);
        return result;
    }
}

export interface IAllergensModel {
    entityId?: string;
    gluten?: number | undefined;
    crustacean?: number | undefined;
    egg?: number | undefined;
    fish?: number | undefined;
    peanuts?: number | undefined;
    soy?: number | undefined;
    milk?: number | undefined;
    nuts?: number | undefined;
    almonds?: number | undefined;
    brazilNut?: number | undefined;
    pecanNut?: number | undefined;
    cashewNut?: number | undefined;
    hazelnut?: number | undefined;
    walnut?: number | undefined;
    pistachioNut?: number | undefined;
    macadamiaNut?: number | undefined;
    otherNuts?: number | undefined;
    celary?: number | undefined;
    mustard?: number | undefined;
    sesameSeeds?: number | undefined;
    sulfurDioxideSulfits?: number | undefined;
    lupine?: number | undefined;
    molluscs?: number | undefined;
    sourceType?: string | undefined;
    comment?: string | undefined;
}

export class ClaimsModel implements IClaimsModel {
    entityId?: string;
    euOrganic?: boolean | undefined;
    organicOrigin?: number | undefined;
    organicOriginText?: string | undefined;
    organicCountry?: string | undefined;
    organicCode?: string | undefined;
    dkOrganic?: boolean | undefined;
    noeglehullet?: boolean | undefined;
    wholemeal?: boolean | undefined;
    vegan?: boolean | undefined;
    gmo?: boolean | undefined;
    gmoCotton?: boolean | undefined;
    gmoRape?: boolean | undefined;
    gmoCorn?: boolean | undefined;
    gmoSoybean?: boolean | undefined;
    gmoSugarbeet?: boolean | undefined;
    hyperActivity?: boolean | undefined;
    phenylalanin?: boolean | undefined;
    protectedAtmosphere?: boolean | undefined;
    laxative?: boolean | undefined;
    sugarSweeteners?: boolean | undefined;
    sweeteners?: boolean | undefined;
    plantSterols?: boolean | undefined;
    plantStanols?: boolean | undefined;
    highCaffeine?: boolean | undefined;
    caffeine?: boolean | undefined;
    liquorice?: boolean | undefined;
    otherVegetableFat?: boolean | undefined;
    antioxidantsAnimal?: boolean | undefined;
    coloursAnimal?: boolean | undefined;

    constructor(data?: IClaimsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.euOrganic = _data["euOrganic"];
            this.organicOrigin = _data["organicOrigin"];
            this.organicOriginText = _data["organicOriginText"];
            this.organicCountry = _data["organicCountry"];
            this.organicCode = _data["organicCode"];
            this.dkOrganic = _data["dkOrganic"];
            this.noeglehullet = _data["noeglehullet"];
            this.wholemeal = _data["wholemeal"];
            this.vegan = _data["vegan"];
            this.gmo = _data["gmo"];
            this.gmoCotton = _data["gmoCotton"];
            this.gmoRape = _data["gmoRape"];
            this.gmoCorn = _data["gmoCorn"];
            this.gmoSoybean = _data["gmoSoybean"];
            this.gmoSugarbeet = _data["gmoSugarbeet"];
            this.hyperActivity = _data["hyperActivity"];
            this.phenylalanin = _data["phenylalanin"];
            this.protectedAtmosphere = _data["protectedAtmosphere"];
            this.laxative = _data["laxative"];
            this.sugarSweeteners = _data["sugarSweeteners"];
            this.sweeteners = _data["sweeteners"];
            this.plantSterols = _data["plantSterols"];
            this.plantStanols = _data["plantStanols"];
            this.highCaffeine = _data["highCaffeine"];
            this.caffeine = _data["caffeine"];
            this.liquorice = _data["liquorice"];
            this.otherVegetableFat = _data["otherVegetableFat"];
            this.antioxidantsAnimal = _data["antioxidantsAnimal"];
            this.coloursAnimal = _data["coloursAnimal"];
        }
    }

    static fromJS(data: any): ClaimsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["euOrganic"] = this.euOrganic;
        data["organicOrigin"] = this.organicOrigin;
        data["organicOriginText"] = this.organicOriginText;
        data["organicCountry"] = this.organicCountry;
        data["organicCode"] = this.organicCode;
        data["dkOrganic"] = this.dkOrganic;
        data["noeglehullet"] = this.noeglehullet;
        data["wholemeal"] = this.wholemeal;
        data["vegan"] = this.vegan;
        data["gmo"] = this.gmo;
        data["gmoCotton"] = this.gmoCotton;
        data["gmoRape"] = this.gmoRape;
        data["gmoCorn"] = this.gmoCorn;
        data["gmoSoybean"] = this.gmoSoybean;
        data["gmoSugarbeet"] = this.gmoSugarbeet;
        data["hyperActivity"] = this.hyperActivity;
        data["phenylalanin"] = this.phenylalanin;
        data["protectedAtmosphere"] = this.protectedAtmosphere;
        data["laxative"] = this.laxative;
        data["sugarSweeteners"] = this.sugarSweeteners;
        data["sweeteners"] = this.sweeteners;
        data["plantSterols"] = this.plantSterols;
        data["plantStanols"] = this.plantStanols;
        data["highCaffeine"] = this.highCaffeine;
        data["caffeine"] = this.caffeine;
        data["liquorice"] = this.liquorice;
        data["otherVegetableFat"] = this.otherVegetableFat;
        data["antioxidantsAnimal"] = this.antioxidantsAnimal;
        data["coloursAnimal"] = this.coloursAnimal;
        return data;
    }

    clone(): ClaimsModel {
        const json = this.toJSON();
        let result = new ClaimsModel();
        result.init(json);
        return result;
    }
}

export interface IClaimsModel {
    entityId?: string;
    euOrganic?: boolean | undefined;
    organicOrigin?: number | undefined;
    organicOriginText?: string | undefined;
    organicCountry?: string | undefined;
    organicCode?: string | undefined;
    dkOrganic?: boolean | undefined;
    noeglehullet?: boolean | undefined;
    wholemeal?: boolean | undefined;
    vegan?: boolean | undefined;
    gmo?: boolean | undefined;
    gmoCotton?: boolean | undefined;
    gmoRape?: boolean | undefined;
    gmoCorn?: boolean | undefined;
    gmoSoybean?: boolean | undefined;
    gmoSugarbeet?: boolean | undefined;
    hyperActivity?: boolean | undefined;
    phenylalanin?: boolean | undefined;
    protectedAtmosphere?: boolean | undefined;
    laxative?: boolean | undefined;
    sugarSweeteners?: boolean | undefined;
    sweeteners?: boolean | undefined;
    plantSterols?: boolean | undefined;
    plantStanols?: boolean | undefined;
    highCaffeine?: boolean | undefined;
    caffeine?: boolean | undefined;
    liquorice?: boolean | undefined;
    otherVegetableFat?: boolean | undefined;
    antioxidantsAnimal?: boolean | undefined;
    coloursAnimal?: boolean | undefined;
}

export class ProductVariantSupplierModel implements IProductVariantSupplierModel {
    id?: string;
    productVariantId?: string;
    supplierId?: string;
    unitPrice?: number;
    supplierProductName?: string | undefined;
    supplierSku?: string | undefined;
    orderLeadtime?: number;
    orderUnit?: string | undefined;
    orderQuantity?: number | undefined;
    minimumOrderQuantity?: number | undefined;
    productVariant?: ProductVariantModel | undefined;
    supplier?: SupplierModel | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IProductVariantSupplierModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productVariantId = _data["productVariantId"];
            this.supplierId = _data["supplierId"];
            this.unitPrice = _data["unitPrice"];
            this.supplierProductName = _data["supplierProductName"];
            this.supplierSku = _data["supplierSku"];
            this.orderLeadtime = _data["orderLeadtime"];
            this.orderUnit = _data["orderUnit"];
            this.orderQuantity = _data["orderQuantity"];
            this.minimumOrderQuantity = _data["minimumOrderQuantity"];
            this.productVariant = _data["productVariant"] ? ProductVariantModel.fromJS(_data["productVariant"]) : undefined as any;
            this.supplier = _data["supplier"] ? SupplierModel.fromJS(_data["supplier"]) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProductVariantSupplierModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductVariantSupplierModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productVariantId"] = this.productVariantId;
        data["supplierId"] = this.supplierId;
        data["unitPrice"] = this.unitPrice;
        data["supplierProductName"] = this.supplierProductName;
        data["supplierSku"] = this.supplierSku;
        data["orderLeadtime"] = this.orderLeadtime;
        data["orderUnit"] = this.orderUnit;
        data["orderQuantity"] = this.orderQuantity;
        data["minimumOrderQuantity"] = this.minimumOrderQuantity;
        data["productVariant"] = this.productVariant ? this.productVariant.toJSON() : undefined as any;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ProductVariantSupplierModel {
        const json = this.toJSON();
        let result = new ProductVariantSupplierModel();
        result.init(json);
        return result;
    }
}

export interface IProductVariantSupplierModel {
    id?: string;
    productVariantId?: string;
    supplierId?: string;
    unitPrice?: number;
    supplierProductName?: string | undefined;
    supplierSku?: string | undefined;
    orderLeadtime?: number;
    orderUnit?: string | undefined;
    orderQuantity?: number | undefined;
    minimumOrderQuantity?: number | undefined;
    productVariant?: ProductVariantModel | undefined;
    supplier?: SupplierModel | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class GetDatasheetsModel implements IGetDatasheetsModel {
    products?: ProductModel[] | undefined;
    type?: string | undefined;

    constructor(data?: IGetDatasheetsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductModel.fromJS(item));
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetDatasheetsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatasheetsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        data["type"] = this.type;
        return data;
    }

    clone(): GetDatasheetsModel {
        const json = this.toJSON();
        let result = new GetDatasheetsModel();
        result.init(json);
        return result;
    }
}

export interface IGetDatasheetsModel {
    products?: ProductModel[] | undefined;
    type?: string | undefined;
}

export class DatasheetModel implements IDatasheetModel {
    id?: string;
    name?: string | undefined;
    nutritionType?: string | undefined;
    ingredientType?: string | undefined;
    labelType?: string | undefined;

    constructor(data?: IDatasheetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nutritionType = _data["nutritionType"];
            this.ingredientType = _data["ingredientType"];
            this.labelType = _data["labelType"];
        }
    }

    static fromJS(data: any): DatasheetModel {
        data = typeof data === 'object' ? data : {};
        let result = new DatasheetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nutritionType"] = this.nutritionType;
        data["ingredientType"] = this.ingredientType;
        data["labelType"] = this.labelType;
        return data;
    }

    clone(): DatasheetModel {
        const json = this.toJSON();
        let result = new DatasheetModel();
        result.init(json);
        return result;
    }
}

export interface IDatasheetModel {
    id?: string;
    name?: string | undefined;
    nutritionType?: string | undefined;
    ingredientType?: string | undefined;
    labelType?: string | undefined;
}

export class PropertyTypeGroupModel extends BasicModel implements IPropertyTypeGroupModel {
    name?: string | undefined;
    alias?: string | undefined;
    language?: string | undefined;
    sortOrder?: number;
    isVisible?: boolean;
    isGlobal?: boolean;
    propertyTypes?: PropertyTypeModel[] | undefined;

    constructor(data?: IPropertyTypeGroupModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.alias = _data["alias"];
            this.language = _data["language"];
            this.sortOrder = _data["sortOrder"];
            this.isVisible = _data["isVisible"];
            this.isGlobal = _data["isGlobal"];
            if (Array.isArray(_data["propertyTypes"])) {
                this.propertyTypes = [] as any;
                for (let item of _data["propertyTypes"])
                    this.propertyTypes!.push(PropertyTypeModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PropertyTypeGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyTypeGroupModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["alias"] = this.alias;
        data["language"] = this.language;
        data["sortOrder"] = this.sortOrder;
        data["isVisible"] = this.isVisible;
        data["isGlobal"] = this.isGlobal;
        if (Array.isArray(this.propertyTypes)) {
            data["propertyTypes"] = [];
            for (let item of this.propertyTypes)
                data["propertyTypes"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PropertyTypeGroupModel {
        const json = this.toJSON();
        let result = new PropertyTypeGroupModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyTypeGroupModel extends IBasicModel {
    name?: string | undefined;
    alias?: string | undefined;
    language?: string | undefined;
    sortOrder?: number;
    isVisible?: boolean;
    isGlobal?: boolean;
    propertyTypes?: PropertyTypeModel[] | undefined;
}

export class PagedResultOfRecipeModel extends PagedResultBase implements IPagedResultOfRecipeModel {
    results?: RecipeModel[];

    constructor(data?: IPagedResultOfRecipeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(RecipeModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfRecipeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfRecipeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfRecipeModel {
        const json = this.toJSON();
        let result = new PagedResultOfRecipeModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfRecipeModel extends IPagedResultBase {
    results?: RecipeModel[];
}

export class RecipeBulkModel implements IRecipeBulkModel {
    recipes?: IdNameModel[] | undefined;

    constructor(data?: IRecipeBulkModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recipes"])) {
                this.recipes = [] as any;
                for (let item of _data["recipes"])
                    this.recipes!.push(IdNameModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecipeBulkModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeBulkModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recipes)) {
            data["recipes"] = [];
            for (let item of this.recipes)
                data["recipes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): RecipeBulkModel {
        const json = this.toJSON();
        let result = new RecipeBulkModel();
        result.init(json);
        return result;
    }
}

export interface IRecipeBulkModel {
    recipes?: IdNameModel[] | undefined;
}

export class RecipeCalculationModel implements IRecipeCalculationModel {
    id?: string;
    ingredients?: RecipeCalculationIngredientModel[] | undefined;
    packaging?: RecipeCalculationIngredientModel[] | undefined;
    outputs?: RecipeCalculationIngredientModel[] | undefined;
    resources?: RecipeCalculationResourceModel[] | undefined;
    indirect?: RecipeCalculationResourceModel[] | undefined;
    totalIngredientCost?: number;
    totalPackagingCost?: number;
    totalResourceCost?: number;
    totalIndirectCost?: number;
    totalCost?: number;
    totalIngredientCo2?: number;
    totalPackagingCo2?: number;
    totalResourceCo2?: number;
    totalIndirectCo2?: number;
    totalCo2?: number;
    unitCo2?: number;
    unitCost?: number;
    profitMargin?: number;
    sellingPrice?: number;
    totalWeight?: number;
    totalLoss?: number;
    calculationRatio?: number;

    constructor(data?: IRecipeCalculationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(RecipeCalculationIngredientModel.fromJS(item));
            }
            if (Array.isArray(_data["packaging"])) {
                this.packaging = [] as any;
                for (let item of _data["packaging"])
                    this.packaging!.push(RecipeCalculationIngredientModel.fromJS(item));
            }
            if (Array.isArray(_data["outputs"])) {
                this.outputs = [] as any;
                for (let item of _data["outputs"])
                    this.outputs!.push(RecipeCalculationIngredientModel.fromJS(item));
            }
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(RecipeCalculationResourceModel.fromJS(item));
            }
            if (Array.isArray(_data["indirect"])) {
                this.indirect = [] as any;
                for (let item of _data["indirect"])
                    this.indirect!.push(RecipeCalculationResourceModel.fromJS(item));
            }
            this.totalIngredientCost = _data["totalIngredientCost"];
            this.totalPackagingCost = _data["totalPackagingCost"];
            this.totalResourceCost = _data["totalResourceCost"];
            this.totalIndirectCost = _data["totalIndirectCost"];
            this.totalCost = _data["totalCost"];
            this.totalIngredientCo2 = _data["totalIngredientCo2"];
            this.totalPackagingCo2 = _data["totalPackagingCo2"];
            this.totalResourceCo2 = _data["totalResourceCo2"];
            this.totalIndirectCo2 = _data["totalIndirectCo2"];
            this.totalCo2 = _data["totalCo2"];
            this.unitCo2 = _data["unitCo2"];
            this.unitCost = _data["unitCost"];
            this.profitMargin = _data["profitMargin"];
            this.sellingPrice = _data["sellingPrice"];
            this.totalWeight = _data["totalWeight"];
            this.totalLoss = _data["totalLoss"];
            this.calculationRatio = _data["calculationRatio"];
        }
    }

    static fromJS(data: any): RecipeCalculationModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeCalculationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.packaging)) {
            data["packaging"] = [];
            for (let item of this.packaging)
                data["packaging"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.outputs)) {
            data["outputs"] = [];
            for (let item of this.outputs)
                data["outputs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.indirect)) {
            data["indirect"] = [];
            for (let item of this.indirect)
                data["indirect"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalIngredientCost"] = this.totalIngredientCost;
        data["totalPackagingCost"] = this.totalPackagingCost;
        data["totalResourceCost"] = this.totalResourceCost;
        data["totalIndirectCost"] = this.totalIndirectCost;
        data["totalCost"] = this.totalCost;
        data["totalIngredientCo2"] = this.totalIngredientCo2;
        data["totalPackagingCo2"] = this.totalPackagingCo2;
        data["totalResourceCo2"] = this.totalResourceCo2;
        data["totalIndirectCo2"] = this.totalIndirectCo2;
        data["totalCo2"] = this.totalCo2;
        data["unitCo2"] = this.unitCo2;
        data["unitCost"] = this.unitCost;
        data["profitMargin"] = this.profitMargin;
        data["sellingPrice"] = this.sellingPrice;
        data["totalWeight"] = this.totalWeight;
        data["totalLoss"] = this.totalLoss;
        data["calculationRatio"] = this.calculationRatio;
        return data;
    }

    clone(): RecipeCalculationModel {
        const json = this.toJSON();
        let result = new RecipeCalculationModel();
        result.init(json);
        return result;
    }
}

export interface IRecipeCalculationModel {
    id?: string;
    ingredients?: RecipeCalculationIngredientModel[] | undefined;
    packaging?: RecipeCalculationIngredientModel[] | undefined;
    outputs?: RecipeCalculationIngredientModel[] | undefined;
    resources?: RecipeCalculationResourceModel[] | undefined;
    indirect?: RecipeCalculationResourceModel[] | undefined;
    totalIngredientCost?: number;
    totalPackagingCost?: number;
    totalResourceCost?: number;
    totalIndirectCost?: number;
    totalCost?: number;
    totalIngredientCo2?: number;
    totalPackagingCo2?: number;
    totalResourceCo2?: number;
    totalIndirectCo2?: number;
    totalCo2?: number;
    unitCo2?: number;
    unitCost?: number;
    profitMargin?: number;
    sellingPrice?: number;
    totalWeight?: number;
    totalLoss?: number;
    calculationRatio?: number;
}

export class RecipeCalculationIngredientModel implements IRecipeCalculationIngredientModel {
    id?: string;
    recipeId?: string;
    ingredient?: IngredientModel | undefined;
    alternativeToId?: string;
    amount?: number;
    unit?: string | undefined;
    sortOrder?: number;
    density?: number;
    productUnit?: string | undefined;
    productUnitQuantity?: number;
    processStep?: IdNameModel | undefined;
    orderlines?: OrderlineModel[] | undefined;
    lossQuantity?: number;
    lossUnit?: string | undefined;
    unitsPerCase?: number;
    isQuid?: boolean;
    ignoreInDeclaration?: boolean;
    declarationGroup?: string | undefined;
    nutrition?: NutritionModel | undefined;
    categories?: ProcessModel[] | undefined;
    type?: string | undefined;
    actualAmount?: number;
    price?: number;
    costPerUnit?: number;
    costShare?: number;
    quantityExpression?: string | undefined;
    bomOption?: BomOptionType;
    co2?: number;
    co2Source?: string | undefined;
    childRecipe?: RecipeCalculationModel | undefined;
    lots?: IdNameModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IRecipeCalculationIngredientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipeId = _data["recipeId"];
            this.ingredient = _data["ingredient"] ? IngredientModel.fromJS(_data["ingredient"]) : undefined as any;
            this.alternativeToId = _data["alternativeToId"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
            this.sortOrder = _data["sortOrder"];
            this.density = _data["density"];
            this.productUnit = _data["productUnit"];
            this.productUnitQuantity = _data["productUnitQuantity"];
            this.processStep = _data["processStep"] ? IdNameModel.fromJS(_data["processStep"]) : undefined as any;
            if (Array.isArray(_data["orderlines"])) {
                this.orderlines = [] as any;
                for (let item of _data["orderlines"])
                    this.orderlines!.push(OrderlineModel.fromJS(item));
            }
            this.lossQuantity = _data["lossQuantity"];
            this.lossUnit = _data["lossUnit"];
            this.unitsPerCase = _data["unitsPerCase"];
            this.isQuid = _data["isQuid"];
            this.ignoreInDeclaration = _data["ignoreInDeclaration"];
            this.declarationGroup = _data["declarationGroup"];
            this.nutrition = _data["nutrition"] ? NutritionModel.fromJS(_data["nutrition"]) : undefined as any;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ProcessModel.fromJS(item));
            }
            this.type = _data["type"];
            this.actualAmount = _data["actualAmount"];
            this.price = _data["price"];
            this.costPerUnit = _data["costPerUnit"];
            this.costShare = _data["costShare"];
            this.quantityExpression = _data["quantityExpression"];
            this.bomOption = _data["bomOption"];
            this.co2 = _data["co2"];
            this.co2Source = _data["co2Source"];
            this.childRecipe = _data["childRecipe"] ? RecipeCalculationModel.fromJS(_data["childRecipe"]) : undefined as any;
            if (Array.isArray(_data["lots"])) {
                this.lots = [] as any;
                for (let item of _data["lots"])
                    this.lots!.push(IdNameModel.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RecipeCalculationIngredientModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeCalculationIngredientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipeId"] = this.recipeId;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : undefined as any;
        data["alternativeToId"] = this.alternativeToId;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        data["sortOrder"] = this.sortOrder;
        data["density"] = this.density;
        data["productUnit"] = this.productUnit;
        data["productUnitQuantity"] = this.productUnitQuantity;
        data["processStep"] = this.processStep ? this.processStep.toJSON() : undefined as any;
        if (Array.isArray(this.orderlines)) {
            data["orderlines"] = [];
            for (let item of this.orderlines)
                data["orderlines"].push(item ? item.toJSON() : undefined as any);
        }
        data["lossQuantity"] = this.lossQuantity;
        data["lossUnit"] = this.lossUnit;
        data["unitsPerCase"] = this.unitsPerCase;
        data["isQuid"] = this.isQuid;
        data["ignoreInDeclaration"] = this.ignoreInDeclaration;
        data["declarationGroup"] = this.declarationGroup;
        data["nutrition"] = this.nutrition ? this.nutrition.toJSON() : undefined as any;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        data["type"] = this.type;
        data["actualAmount"] = this.actualAmount;
        data["price"] = this.price;
        data["costPerUnit"] = this.costPerUnit;
        data["costShare"] = this.costShare;
        data["quantityExpression"] = this.quantityExpression;
        data["bomOption"] = this.bomOption;
        data["co2"] = this.co2;
        data["co2Source"] = this.co2Source;
        data["childRecipe"] = this.childRecipe ? this.childRecipe.toJSON() : undefined as any;
        if (Array.isArray(this.lots)) {
            data["lots"] = [];
            for (let item of this.lots)
                data["lots"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): RecipeCalculationIngredientModel {
        const json = this.toJSON();
        let result = new RecipeCalculationIngredientModel();
        result.init(json);
        return result;
    }
}

export interface IRecipeCalculationIngredientModel {
    id?: string;
    recipeId?: string;
    ingredient?: IngredientModel | undefined;
    alternativeToId?: string;
    amount?: number;
    unit?: string | undefined;
    sortOrder?: number;
    density?: number;
    productUnit?: string | undefined;
    productUnitQuantity?: number;
    processStep?: IdNameModel | undefined;
    orderlines?: OrderlineModel[] | undefined;
    lossQuantity?: number;
    lossUnit?: string | undefined;
    unitsPerCase?: number;
    isQuid?: boolean;
    ignoreInDeclaration?: boolean;
    declarationGroup?: string | undefined;
    nutrition?: NutritionModel | undefined;
    categories?: ProcessModel[] | undefined;
    type?: string | undefined;
    actualAmount?: number;
    price?: number;
    costPerUnit?: number;
    costShare?: number;
    quantityExpression?: string | undefined;
    bomOption?: BomOptionType;
    co2?: number;
    co2Source?: string | undefined;
    childRecipe?: RecipeCalculationModel | undefined;
    lots?: IdNameModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class RecipeCalculationResourceModel implements IRecipeCalculationResourceModel {
    id?: string;
    recipeId?: string;
    label?: string | undefined;
    ingredient?: IngredientModel | undefined;
    alternativeToId?: string;
    amount?: number;
    unit?: string | undefined;
    sortOrder?: number;
    density?: number;
    productUnit?: string | undefined;
    productUnitQuantity?: number;
    processStep?: IdNameModel | undefined;
    orderlines?: OrderlineModel[] | undefined;
    lossQuantity?: number;
    lossUnit?: string | undefined;
    unitsPerCase?: number;
    isQuid?: boolean;
    ignoreInDeclaration?: boolean;
    declarationGroup?: string | undefined;
    nutrition?: NutritionModel | undefined;
    categories?: ProcessModel[] | undefined;
    type?: string | undefined;
    actualAmount?: number;
    price?: number;
    costPerUnit?: number;
    costShare?: number;
    quantityExpression?: string | undefined;
    bomOption?: BomOptionType;
    co2?: number;
    lots?: IdNameModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IRecipeCalculationResourceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipeId = _data["recipeId"];
            this.label = _data["label"];
            this.ingredient = _data["ingredient"] ? IngredientModel.fromJS(_data["ingredient"]) : undefined as any;
            this.alternativeToId = _data["alternativeToId"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
            this.sortOrder = _data["sortOrder"];
            this.density = _data["density"];
            this.productUnit = _data["productUnit"];
            this.productUnitQuantity = _data["productUnitQuantity"];
            this.processStep = _data["processStep"] ? IdNameModel.fromJS(_data["processStep"]) : undefined as any;
            if (Array.isArray(_data["orderlines"])) {
                this.orderlines = [] as any;
                for (let item of _data["orderlines"])
                    this.orderlines!.push(OrderlineModel.fromJS(item));
            }
            this.lossQuantity = _data["lossQuantity"];
            this.lossUnit = _data["lossUnit"];
            this.unitsPerCase = _data["unitsPerCase"];
            this.isQuid = _data["isQuid"];
            this.ignoreInDeclaration = _data["ignoreInDeclaration"];
            this.declarationGroup = _data["declarationGroup"];
            this.nutrition = _data["nutrition"] ? NutritionModel.fromJS(_data["nutrition"]) : undefined as any;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ProcessModel.fromJS(item));
            }
            this.type = _data["type"];
            this.actualAmount = _data["actualAmount"];
            this.price = _data["price"];
            this.costPerUnit = _data["costPerUnit"];
            this.costShare = _data["costShare"];
            this.quantityExpression = _data["quantityExpression"];
            this.bomOption = _data["bomOption"];
            this.co2 = _data["co2"];
            if (Array.isArray(_data["lots"])) {
                this.lots = [] as any;
                for (let item of _data["lots"])
                    this.lots!.push(IdNameModel.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RecipeCalculationResourceModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeCalculationResourceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipeId"] = this.recipeId;
        data["label"] = this.label;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : undefined as any;
        data["alternativeToId"] = this.alternativeToId;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        data["sortOrder"] = this.sortOrder;
        data["density"] = this.density;
        data["productUnit"] = this.productUnit;
        data["productUnitQuantity"] = this.productUnitQuantity;
        data["processStep"] = this.processStep ? this.processStep.toJSON() : undefined as any;
        if (Array.isArray(this.orderlines)) {
            data["orderlines"] = [];
            for (let item of this.orderlines)
                data["orderlines"].push(item ? item.toJSON() : undefined as any);
        }
        data["lossQuantity"] = this.lossQuantity;
        data["lossUnit"] = this.lossUnit;
        data["unitsPerCase"] = this.unitsPerCase;
        data["isQuid"] = this.isQuid;
        data["ignoreInDeclaration"] = this.ignoreInDeclaration;
        data["declarationGroup"] = this.declarationGroup;
        data["nutrition"] = this.nutrition ? this.nutrition.toJSON() : undefined as any;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        data["type"] = this.type;
        data["actualAmount"] = this.actualAmount;
        data["price"] = this.price;
        data["costPerUnit"] = this.costPerUnit;
        data["costShare"] = this.costShare;
        data["quantityExpression"] = this.quantityExpression;
        data["bomOption"] = this.bomOption;
        data["co2"] = this.co2;
        if (Array.isArray(this.lots)) {
            data["lots"] = [];
            for (let item of this.lots)
                data["lots"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): RecipeCalculationResourceModel {
        const json = this.toJSON();
        let result = new RecipeCalculationResourceModel();
        result.init(json);
        return result;
    }
}

export interface IRecipeCalculationResourceModel {
    id?: string;
    recipeId?: string;
    label?: string | undefined;
    ingredient?: IngredientModel | undefined;
    alternativeToId?: string;
    amount?: number;
    unit?: string | undefined;
    sortOrder?: number;
    density?: number;
    productUnit?: string | undefined;
    productUnitQuantity?: number;
    processStep?: IdNameModel | undefined;
    orderlines?: OrderlineModel[] | undefined;
    lossQuantity?: number;
    lossUnit?: string | undefined;
    unitsPerCase?: number;
    isQuid?: boolean;
    ignoreInDeclaration?: boolean;
    declarationGroup?: string | undefined;
    nutrition?: NutritionModel | undefined;
    categories?: ProcessModel[] | undefined;
    type?: string | undefined;
    actualAmount?: number;
    price?: number;
    costPerUnit?: number;
    costShare?: number;
    quantityExpression?: string | undefined;
    bomOption?: BomOptionType;
    co2?: number;
    lots?: IdNameModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class RecipeBulkChangeModel implements IRecipeBulkChangeModel {
    recipes?: IdNameModel[] | undefined;
    id?: string | undefined;
    number?: number | undefined;

    constructor(data?: IRecipeBulkChangeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recipes"])) {
                this.recipes = [] as any;
                for (let item of _data["recipes"])
                    this.recipes!.push(IdNameModel.fromJS(item));
            }
            this.id = _data["id"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): RecipeBulkChangeModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeBulkChangeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recipes)) {
            data["recipes"] = [];
            for (let item of this.recipes)
                data["recipes"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["number"] = this.number;
        return data;
    }

    clone(): RecipeBulkChangeModel {
        const json = this.toJSON();
        let result = new RecipeBulkChangeModel();
        result.init(json);
        return result;
    }
}

export interface IRecipeBulkChangeModel {
    recipes?: IdNameModel[] | undefined;
    id?: string | undefined;
    number?: number | undefined;
}

export class RecipeGroupModel implements IRecipeGroupModel {
    id?: string;
    name?: string | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IRecipeGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RecipeGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): RecipeGroupModel {
        const json = this.toJSON();
        let result = new RecipeGroupModel();
        result.init(json);
        return result;
    }
}

export interface IRecipeGroupModel {
    id?: string;
    name?: string | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ReportModel implements IReportModel {
    id?: string;
    displayName?: string | undefined;
    layoutData?: string | undefined;
    reportType?: string | undefined;
    organizationId?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: IReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.layoutData = _data["layoutData"];
            this.reportType = _data["reportType"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["layoutData"] = this.layoutData;
        data["reportType"] = this.reportType;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ReportModel {
        const json = this.toJSON();
        let result = new ReportModel();
        result.init(json);
        return result;
    }
}

export interface IReportModel {
    id?: string;
    displayName?: string | undefined;
    layoutData?: string | undefined;
    reportType?: string | undefined;
    organizationId?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
}

export class RiskAnalysisSimpleModel implements IRiskAnalysisSimpleModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    language?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    process?: ProcessSimpleModel | undefined;
    departmentId?: string;
    documentVersion?: DocumentRevisionModel | undefined;
    type?: RiskAnalysisType;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IRiskAnalysisSimpleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.language = _data["language"];
            this.responsibleUser = _data["responsibleUser"] ? IdNameModel.fromJS(_data["responsibleUser"]) : undefined as any;
            this.process = _data["process"] ? ProcessSimpleModel.fromJS(_data["process"]) : undefined as any;
            this.departmentId = _data["departmentId"];
            this.documentVersion = _data["documentVersion"] ? DocumentRevisionModel.fromJS(_data["documentVersion"]) : undefined as any;
            this.type = _data["type"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RiskAnalysisSimpleModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskAnalysisSimpleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["language"] = this.language;
        data["responsibleUser"] = this.responsibleUser ? this.responsibleUser.toJSON() : undefined as any;
        data["process"] = this.process ? this.process.toJSON() : undefined as any;
        data["departmentId"] = this.departmentId;
        data["documentVersion"] = this.documentVersion ? this.documentVersion.toJSON() : undefined as any;
        data["type"] = this.type;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): RiskAnalysisSimpleModel {
        const json = this.toJSON();
        let result = new RiskAnalysisSimpleModel();
        result.init(json);
        return result;
    }
}

export interface IRiskAnalysisSimpleModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    language?: string | undefined;
    responsibleUser?: IdNameModel | undefined;
    process?: ProcessSimpleModel | undefined;
    departmentId?: string;
    documentVersion?: DocumentRevisionModel | undefined;
    type?: RiskAnalysisType;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class RiskAnalysisReportModel implements IRiskAnalysisReportModel {
    riskAnalysis?: RiskAnalysisModel | undefined;
    riskFactors?: RiskFactorRelationModel[] | undefined;
    organization?: OrganizationModel | undefined;
    header?: HaccpHeaderModel | undefined;

    constructor(data?: IRiskAnalysisReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riskAnalysis = _data["riskAnalysis"] ? RiskAnalysisModel.fromJS(_data["riskAnalysis"]) : undefined as any;
            if (Array.isArray(_data["riskFactors"])) {
                this.riskFactors = [] as any;
                for (let item of _data["riskFactors"])
                    this.riskFactors!.push(RiskFactorRelationModel.fromJS(item));
            }
            this.organization = _data["organization"] ? OrganizationModel.fromJS(_data["organization"]) : undefined as any;
            this.header = _data["header"] ? HaccpHeaderModel.fromJS(_data["header"]) : undefined as any;
        }
    }

    static fromJS(data: any): RiskAnalysisReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskAnalysisReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riskAnalysis"] = this.riskAnalysis ? this.riskAnalysis.toJSON() : undefined as any;
        if (Array.isArray(this.riskFactors)) {
            data["riskFactors"] = [];
            for (let item of this.riskFactors)
                data["riskFactors"].push(item ? item.toJSON() : undefined as any);
        }
        data["organization"] = this.organization ? this.organization.toJSON() : undefined as any;
        data["header"] = this.header ? this.header.toJSON() : undefined as any;
        return data;
    }

    clone(): RiskAnalysisReportModel {
        const json = this.toJSON();
        let result = new RiskAnalysisReportModel();
        result.init(json);
        return result;
    }
}

export interface IRiskAnalysisReportModel {
    riskAnalysis?: RiskAnalysisModel | undefined;
    riskFactors?: RiskFactorRelationModel[] | undefined;
    organization?: OrganizationModel | undefined;
    header?: HaccpHeaderModel | undefined;
}

export class HaccpHeaderModel implements IHaccpHeaderModel {
    documentTypeName?: string | undefined;
    documentNumber?: string | undefined;
    documentName?: string | undefined;
    documentResponsibleUserName?: string | undefined;
    documentValidityDate?: string | undefined;
    documentStatusName?: string | undefined;
    organizationName?: string | undefined;
    logoUrl?: string | undefined;
    sharedDocument?: boolean;
    subjectLabel?: string | undefined;
    documentNumberLabel?: string | undefined;
    validFromLabel?: string | undefined;
    responsibleLabel?: string | undefined;
    versionLabel?: string | undefined;
    processStepLabel?: string | undefined;
    riskLabel?: string | undefined;
    assessmentLabel?: string | undefined;
    controlMeasuresLabel?: string | undefined;
    justificationLabel?: string | undefined;
    severityLabel?: string | undefined;
    likelihoodLabel?: string | undefined;
    criticalLimitLabel?: string | undefined;
    methodLabel?: string | undefined;
    frequencyLabel?: string | undefined;
    verificationLabel?: string | undefined;
    correctiveActionLabel?: string | undefined;
    controllingActionLabel?: string | undefined;
    questionsDescription?: string | undefined;
    ccpOprpDecisionsLabel?: string | undefined;
    noLabel?: string | undefined;
    yesLabel?: string | undefined;
    validFrom?: string | undefined;
    responsible?: string | undefined;
    version?: string | undefined;

    constructor(data?: IHaccpHeaderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeName = _data["documentTypeName"];
            this.documentNumber = _data["documentNumber"];
            this.documentName = _data["documentName"];
            this.documentResponsibleUserName = _data["documentResponsibleUserName"];
            this.documentValidityDate = _data["documentValidityDate"];
            this.documentStatusName = _data["documentStatusName"];
            this.organizationName = _data["organizationName"];
            this.logoUrl = _data["logoUrl"];
            this.sharedDocument = _data["sharedDocument"];
            this.subjectLabel = _data["subjectLabel"];
            this.documentNumberLabel = _data["documentNumberLabel"];
            this.validFromLabel = _data["validFromLabel"];
            this.responsibleLabel = _data["responsibleLabel"];
            this.versionLabel = _data["versionLabel"];
            this.processStepLabel = _data["processStepLabel"];
            this.riskLabel = _data["riskLabel"];
            this.assessmentLabel = _data["assessmentLabel"];
            this.controlMeasuresLabel = _data["controlMeasuresLabel"];
            this.justificationLabel = _data["justificationLabel"];
            this.severityLabel = _data["severityLabel"];
            this.likelihoodLabel = _data["likelihoodLabel"];
            this.criticalLimitLabel = _data["criticalLimitLabel"];
            this.methodLabel = _data["methodLabel"];
            this.frequencyLabel = _data["frequencyLabel"];
            this.verificationLabel = _data["verificationLabel"];
            this.correctiveActionLabel = _data["correctiveActionLabel"];
            this.controllingActionLabel = _data["controllingActionLabel"];
            this.questionsDescription = _data["questionsDescription"];
            this.ccpOprpDecisionsLabel = _data["ccpOprpDecisionsLabel"];
            this.noLabel = _data["noLabel"];
            this.yesLabel = _data["yesLabel"];
            this.validFrom = _data["validFrom"];
            this.responsible = _data["responsible"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): HaccpHeaderModel {
        data = typeof data === 'object' ? data : {};
        let result = new HaccpHeaderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeName"] = this.documentTypeName;
        data["documentNumber"] = this.documentNumber;
        data["documentName"] = this.documentName;
        data["documentResponsibleUserName"] = this.documentResponsibleUserName;
        data["documentValidityDate"] = this.documentValidityDate;
        data["documentStatusName"] = this.documentStatusName;
        data["organizationName"] = this.organizationName;
        data["logoUrl"] = this.logoUrl;
        data["sharedDocument"] = this.sharedDocument;
        data["subjectLabel"] = this.subjectLabel;
        data["documentNumberLabel"] = this.documentNumberLabel;
        data["validFromLabel"] = this.validFromLabel;
        data["responsibleLabel"] = this.responsibleLabel;
        data["versionLabel"] = this.versionLabel;
        data["processStepLabel"] = this.processStepLabel;
        data["riskLabel"] = this.riskLabel;
        data["assessmentLabel"] = this.assessmentLabel;
        data["controlMeasuresLabel"] = this.controlMeasuresLabel;
        data["justificationLabel"] = this.justificationLabel;
        data["severityLabel"] = this.severityLabel;
        data["likelihoodLabel"] = this.likelihoodLabel;
        data["criticalLimitLabel"] = this.criticalLimitLabel;
        data["methodLabel"] = this.methodLabel;
        data["frequencyLabel"] = this.frequencyLabel;
        data["verificationLabel"] = this.verificationLabel;
        data["correctiveActionLabel"] = this.correctiveActionLabel;
        data["controllingActionLabel"] = this.controllingActionLabel;
        data["questionsDescription"] = this.questionsDescription;
        data["ccpOprpDecisionsLabel"] = this.ccpOprpDecisionsLabel;
        data["noLabel"] = this.noLabel;
        data["yesLabel"] = this.yesLabel;
        data["validFrom"] = this.validFrom;
        data["responsible"] = this.responsible;
        data["version"] = this.version;
        return data;
    }

    clone(): HaccpHeaderModel {
        const json = this.toJSON();
        let result = new HaccpHeaderModel();
        result.init(json);
        return result;
    }
}

export interface IHaccpHeaderModel {
    documentTypeName?: string | undefined;
    documentNumber?: string | undefined;
    documentName?: string | undefined;
    documentResponsibleUserName?: string | undefined;
    documentValidityDate?: string | undefined;
    documentStatusName?: string | undefined;
    organizationName?: string | undefined;
    logoUrl?: string | undefined;
    sharedDocument?: boolean;
    subjectLabel?: string | undefined;
    documentNumberLabel?: string | undefined;
    validFromLabel?: string | undefined;
    responsibleLabel?: string | undefined;
    versionLabel?: string | undefined;
    processStepLabel?: string | undefined;
    riskLabel?: string | undefined;
    assessmentLabel?: string | undefined;
    controlMeasuresLabel?: string | undefined;
    justificationLabel?: string | undefined;
    severityLabel?: string | undefined;
    likelihoodLabel?: string | undefined;
    criticalLimitLabel?: string | undefined;
    methodLabel?: string | undefined;
    frequencyLabel?: string | undefined;
    verificationLabel?: string | undefined;
    correctiveActionLabel?: string | undefined;
    controllingActionLabel?: string | undefined;
    questionsDescription?: string | undefined;
    ccpOprpDecisionsLabel?: string | undefined;
    noLabel?: string | undefined;
    yesLabel?: string | undefined;
    validFrom?: string | undefined;
    responsible?: string | undefined;
    version?: string | undefined;
}

export class ControlPlanReportModel implements IControlPlanReportModel {
    riskAnalysis?: RiskAnalysisModel | undefined;
    ccps?: CcpModel[] | undefined;
    organization?: OrganizationModel | undefined;
    header?: HaccpHeaderModel | undefined;
    cpHeading?: string | undefined;

    constructor(data?: IControlPlanReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riskAnalysis = _data["riskAnalysis"] ? RiskAnalysisModel.fromJS(_data["riskAnalysis"]) : undefined as any;
            if (Array.isArray(_data["ccps"])) {
                this.ccps = [] as any;
                for (let item of _data["ccps"])
                    this.ccps!.push(CcpModel.fromJS(item));
            }
            this.organization = _data["organization"] ? OrganizationModel.fromJS(_data["organization"]) : undefined as any;
            this.header = _data["header"] ? HaccpHeaderModel.fromJS(_data["header"]) : undefined as any;
            this.cpHeading = _data["cpHeading"];
        }
    }

    static fromJS(data: any): ControlPlanReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControlPlanReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riskAnalysis"] = this.riskAnalysis ? this.riskAnalysis.toJSON() : undefined as any;
        if (Array.isArray(this.ccps)) {
            data["ccps"] = [];
            for (let item of this.ccps)
                data["ccps"].push(item ? item.toJSON() : undefined as any);
        }
        data["organization"] = this.organization ? this.organization.toJSON() : undefined as any;
        data["header"] = this.header ? this.header.toJSON() : undefined as any;
        data["cpHeading"] = this.cpHeading;
        return data;
    }

    clone(): ControlPlanReportModel {
        const json = this.toJSON();
        let result = new ControlPlanReportModel();
        result.init(json);
        return result;
    }
}

export interface IControlPlanReportModel {
    riskAnalysis?: RiskAnalysisModel | undefined;
    ccps?: CcpModel[] | undefined;
    organization?: OrganizationModel | undefined;
    header?: HaccpHeaderModel | undefined;
    cpHeading?: string | undefined;
}

export class PagedResultOfRiskFactorRelationModel extends PagedResultBase implements IPagedResultOfRiskFactorRelationModel {
    results?: RiskFactorRelationModel[];

    constructor(data?: IPagedResultOfRiskFactorRelationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(RiskFactorRelationModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfRiskFactorRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfRiskFactorRelationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfRiskFactorRelationModel {
        const json = this.toJSON();
        let result = new PagedResultOfRiskFactorRelationModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfRiskFactorRelationModel extends IPagedResultBase {
    results?: RiskFactorRelationModel[];
}

export class PagedResultOfScheduledProductionOrderModel extends PagedResultBase implements IPagedResultOfScheduledProductionOrderModel {
    results?: ScheduledProductionOrderModel[];

    constructor(data?: IPagedResultOfScheduledProductionOrderModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ScheduledProductionOrderModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfScheduledProductionOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfScheduledProductionOrderModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfScheduledProductionOrderModel {
        const json = this.toJSON();
        let result = new PagedResultOfScheduledProductionOrderModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfScheduledProductionOrderModel extends IPagedResultBase {
    results?: ScheduledProductionOrderModel[];
}

export class ScheduledProductionOrderModel implements IScheduledProductionOrderModel {
    id?: string;
    name?: string | undefined;
    recipeId?: string;
    recipeName?: string | undefined;
    groupId?: string;
    groupName?: string | undefined;
    processId?: string;
    processName?: string | undefined;
    scaling?: number;
    cronSchedule?: string | undefined;
    cronScheduleHuman?: string | undefined;
    cronFirstOccurence?: Date;
    cronLastOccurence?: Date;
    cronRepeatEvery?: number;

    constructor(data?: IScheduledProductionOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.recipeId = _data["recipeId"];
            this.recipeName = _data["recipeName"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.processId = _data["processId"];
            this.processName = _data["processName"];
            this.scaling = _data["scaling"];
            this.cronSchedule = _data["cronSchedule"];
            this.cronScheduleHuman = _data["cronScheduleHuman"];
            this.cronFirstOccurence = _data["cronFirstOccurence"] ? new Date(_data["cronFirstOccurence"].toString()) : undefined as any;
            this.cronLastOccurence = _data["cronLastOccurence"] ? new Date(_data["cronLastOccurence"].toString()) : undefined as any;
            this.cronRepeatEvery = _data["cronRepeatEvery"];
        }
    }

    static fromJS(data: any): ScheduledProductionOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledProductionOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["recipeId"] = this.recipeId;
        data["recipeName"] = this.recipeName;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        data["scaling"] = this.scaling;
        data["cronSchedule"] = this.cronSchedule;
        data["cronScheduleHuman"] = this.cronScheduleHuman;
        data["cronFirstOccurence"] = this.cronFirstOccurence ? this.cronFirstOccurence.toISOString() : undefined as any;
        data["cronLastOccurence"] = this.cronLastOccurence ? this.cronLastOccurence.toISOString() : undefined as any;
        data["cronRepeatEvery"] = this.cronRepeatEvery;
        return data;
    }

    clone(): ScheduledProductionOrderModel {
        const json = this.toJSON();
        let result = new ScheduledProductionOrderModel();
        result.init(json);
        return result;
    }
}

export interface IScheduledProductionOrderModel {
    id?: string;
    name?: string | undefined;
    recipeId?: string;
    recipeName?: string | undefined;
    groupId?: string;
    groupName?: string | undefined;
    processId?: string;
    processName?: string | undefined;
    scaling?: number;
    cronSchedule?: string | undefined;
    cronScheduleHuman?: string | undefined;
    cronFirstOccurence?: Date;
    cronLastOccurence?: Date;
    cronRepeatEvery?: number;
}

export class PagedResultOfScheduledProductionOrderOccurenceModel extends PagedResultBase implements IPagedResultOfScheduledProductionOrderOccurenceModel {
    results?: ScheduledProductionOrderOccurenceModel[];

    constructor(data?: IPagedResultOfScheduledProductionOrderOccurenceModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ScheduledProductionOrderOccurenceModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfScheduledProductionOrderOccurenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfScheduledProductionOrderOccurenceModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfScheduledProductionOrderOccurenceModel {
        const json = this.toJSON();
        let result = new PagedResultOfScheduledProductionOrderOccurenceModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfScheduledProductionOrderOccurenceModel extends IPagedResultBase {
    results?: ScheduledProductionOrderOccurenceModel[];
}

export class ScheduledProductionOrderOccurenceModel implements IScheduledProductionOrderOccurenceModel {
    id?: string;
    name?: string | undefined;
    recipeId?: string;
    recipeName?: string | undefined;
    scaling?: number;
    cronSchedule?: string | undefined;
    cronRepeatEvery?: number;
    cronScheduleHuman?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    statusColor?: string | undefined;
    productSku?: string | undefined;
    productName?: string | undefined;
    productVariantId?: string | undefined;

    constructor(data?: IScheduledProductionOrderOccurenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.recipeId = _data["recipeId"];
            this.recipeName = _data["recipeName"];
            this.scaling = _data["scaling"];
            this.cronSchedule = _data["cronSchedule"];
            this.cronRepeatEvery = _data["cronRepeatEvery"];
            this.cronScheduleHuman = _data["cronScheduleHuman"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.statusColor = _data["statusColor"];
            this.productSku = _data["productSku"];
            this.productName = _data["productName"];
            this.productVariantId = _data["productVariantId"];
        }
    }

    static fromJS(data: any): ScheduledProductionOrderOccurenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledProductionOrderOccurenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["recipeId"] = this.recipeId;
        data["recipeName"] = this.recipeName;
        data["scaling"] = this.scaling;
        data["cronSchedule"] = this.cronSchedule;
        data["cronRepeatEvery"] = this.cronRepeatEvery;
        data["cronScheduleHuman"] = this.cronScheduleHuman;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["statusColor"] = this.statusColor;
        data["productSku"] = this.productSku;
        data["productName"] = this.productName;
        data["productVariantId"] = this.productVariantId;
        return data;
    }

    clone(): ScheduledProductionOrderOccurenceModel {
        const json = this.toJSON();
        let result = new ScheduledProductionOrderOccurenceModel();
        result.init(json);
        return result;
    }
}

export interface IScheduledProductionOrderOccurenceModel {
    id?: string;
    name?: string | undefined;
    recipeId?: string;
    recipeName?: string | undefined;
    scaling?: number;
    cronSchedule?: string | undefined;
    cronRepeatEvery?: number;
    cronScheduleHuman?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    statusColor?: string | undefined;
    productSku?: string | undefined;
    productName?: string | undefined;
    productVariantId?: string | undefined;
}

export class CcpSchedulePauseModel implements ICcpSchedulePauseModel {
    id?: string;
    entityType?: EntityType;
    entityId?: string;
    comment?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: ICcpSchedulePauseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.comment = _data["comment"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CcpSchedulePauseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CcpSchedulePauseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["comment"] = this.comment;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CcpSchedulePauseModel {
        const json = this.toJSON();
        let result = new CcpSchedulePauseModel();
        result.init(json);
        return result;
    }
}

export interface ICcpSchedulePauseModel {
    id?: string;
    entityType?: EntityType;
    entityId?: string;
    comment?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class MeasurementData implements IMeasurementData {
    id?: string | undefined;
    partitionKey?: string | undefined;
    device?: string | undefined;
    timestamp?: number;
    rawdata?: string | undefined;
    values?: Value[] | undefined;

    constructor(data?: IMeasurementData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partitionKey = _data["partitionKey"];
            this.device = _data["device"];
            this.timestamp = _data["timestamp"];
            this.rawdata = _data["rawdata"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(Value.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeasurementData {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partitionKey"] = this.partitionKey;
        data["device"] = this.device;
        data["timestamp"] = this.timestamp;
        data["rawdata"] = this.rawdata;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MeasurementData {
        const json = this.toJSON();
        let result = new MeasurementData();
        result.init(json);
        return result;
    }
}

export interface IMeasurementData {
    id?: string | undefined;
    partitionKey?: string | undefined;
    device?: string | undefined;
    timestamp?: number;
    rawdata?: string | undefined;
    values?: Value[] | undefined;
}

export class Value implements IValue {
    label?: string | undefined;
    value?: number;

    constructor(data?: IValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Value {
        data = typeof data === 'object' ? data : {};
        let result = new Value();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }

    clone(): Value {
        const json = this.toJSON();
        let result = new Value();
        result.init(json);
        return result;
    }
}

export interface IValue {
    label?: string | undefined;
    value?: number;
}

export class SensorMeasurementModel implements ISensorMeasurementModel {
    id?: string | undefined;
    sensorId?: string;
    timestamp?: Date;
    measurementValue1?: number;
    measurementValue2?: number;
    measurementValue3?: number;
    measurementValue4?: number;
    measurementValue5?: number;

    constructor(data?: ISensorMeasurementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sensorId = _data["sensorId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            this.measurementValue1 = _data["measurementValue1"];
            this.measurementValue2 = _data["measurementValue2"];
            this.measurementValue3 = _data["measurementValue3"];
            this.measurementValue4 = _data["measurementValue4"];
            this.measurementValue5 = _data["measurementValue5"];
        }
    }

    static fromJS(data: any): SensorMeasurementModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensorMeasurementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sensorId"] = this.sensorId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        data["measurementValue1"] = this.measurementValue1;
        data["measurementValue2"] = this.measurementValue2;
        data["measurementValue3"] = this.measurementValue3;
        data["measurementValue4"] = this.measurementValue4;
        data["measurementValue5"] = this.measurementValue5;
        return data;
    }

    clone(): SensorMeasurementModel {
        const json = this.toJSON();
        let result = new SensorMeasurementModel();
        result.init(json);
        return result;
    }
}

export interface ISensorMeasurementModel {
    id?: string | undefined;
    sensorId?: string;
    timestamp?: Date;
    measurementValue1?: number;
    measurementValue2?: number;
    measurementValue3?: number;
    measurementValue4?: number;
    measurementValue5?: number;
}

export class SensorModel implements ISensorModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    alias?: string | undefined;
    latestMeasurementTime?: Date;
    latestTemperature?: number;
    batteryStatus?: number;
    type?: string | undefined;
    externalSensorId?: string | undefined;
    warnings?: string | undefined;
    minTemperature?: number | undefined;
    maxTemperature?: number | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: ISensorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.alias = _data["alias"];
            this.latestMeasurementTime = _data["latestMeasurementTime"] ? new Date(_data["latestMeasurementTime"].toString()) : undefined as any;
            this.latestTemperature = _data["latestTemperature"];
            this.batteryStatus = _data["batteryStatus"];
            this.type = _data["type"];
            this.externalSensorId = _data["externalSensorId"];
            this.warnings = _data["warnings"];
            this.minTemperature = _data["minTemperature"];
            this.maxTemperature = _data["maxTemperature"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): SensorModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["alias"] = this.alias;
        data["latestMeasurementTime"] = this.latestMeasurementTime ? this.latestMeasurementTime.toISOString() : undefined as any;
        data["latestTemperature"] = this.latestTemperature;
        data["batteryStatus"] = this.batteryStatus;
        data["type"] = this.type;
        data["externalSensorId"] = this.externalSensorId;
        data["warnings"] = this.warnings;
        data["minTemperature"] = this.minTemperature;
        data["maxTemperature"] = this.maxTemperature;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): SensorModel {
        const json = this.toJSON();
        let result = new SensorModel();
        result.init(json);
        return result;
    }
}

export interface ISensorModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    alias?: string | undefined;
    latestMeasurementTime?: Date;
    latestTemperature?: number;
    batteryStatus?: number;
    type?: string | undefined;
    externalSensorId?: string | undefined;
    warnings?: string | undefined;
    minTemperature?: number | undefined;
    maxTemperature?: number | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class ThermItDepartment implements IThermItDepartment {
    companyID?: number;
    industryID?: number;
    countryID?: number;
    departmentID?: number;
    departmentName?: string | undefined;
    departmentName2?: any | undefined;
    address?: any | undefined;
    address2?: any | undefined;
    zipcode?: any | undefined;
    city?: any | undefined;
    phone?: any | undefined;
    email?: any | undefined;
    dailyCheck?: any | undefined;
    companyName?: string | undefined;
    sendDeviceWarningEmail?: boolean;
    sendDeviceWarningSms?: boolean;
    deviceTimeout?: number;

    constructor(data?: IThermItDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyID = _data["companyID"];
            this.industryID = _data["industryID"];
            this.countryID = _data["countryID"];
            this.departmentID = _data["departmentID"];
            this.departmentName = _data["departmentName"];
            this.departmentName2 = _data["departmentName2"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.zipcode = _data["zipcode"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.dailyCheck = _data["dailyCheck"];
            this.companyName = _data["companyName"];
            this.sendDeviceWarningEmail = _data["sendDeviceWarningEmail"];
            this.sendDeviceWarningSms = _data["sendDeviceWarningSms"];
            this.deviceTimeout = _data["deviceTimeout"];
        }
    }

    static fromJS(data: any): ThermItDepartment {
        data = typeof data === 'object' ? data : {};
        let result = new ThermItDepartment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyID"] = this.companyID;
        data["industryID"] = this.industryID;
        data["countryID"] = this.countryID;
        data["departmentID"] = this.departmentID;
        data["departmentName"] = this.departmentName;
        data["departmentName2"] = this.departmentName2;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["zipcode"] = this.zipcode;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["dailyCheck"] = this.dailyCheck;
        data["companyName"] = this.companyName;
        data["sendDeviceWarningEmail"] = this.sendDeviceWarningEmail;
        data["sendDeviceWarningSms"] = this.sendDeviceWarningSms;
        data["deviceTimeout"] = this.deviceTimeout;
        return data;
    }

    clone(): ThermItDepartment {
        const json = this.toJSON();
        let result = new ThermItDepartment();
        result.init(json);
        return result;
    }
}

export interface IThermItDepartment {
    companyID?: number;
    industryID?: number;
    countryID?: number;
    departmentID?: number;
    departmentName?: string | undefined;
    departmentName2?: any | undefined;
    address?: any | undefined;
    address2?: any | undefined;
    zipcode?: any | undefined;
    city?: any | undefined;
    phone?: any | undefined;
    email?: any | undefined;
    dailyCheck?: any | undefined;
    companyName?: string | undefined;
    sendDeviceWarningEmail?: boolean;
    sendDeviceWarningSms?: boolean;
    deviceTimeout?: number;
}

export class ThermItArea implements IThermItArea {
    areaID?: number;
    departmentID?: number;
    areaName?: string | undefined;
    areaTypeName?: string | undefined;
    warnings?: number;

    constructor(data?: IThermItArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaID = _data["areaID"];
            this.departmentID = _data["departmentID"];
            this.areaName = _data["areaName"];
            this.areaTypeName = _data["areaTypeName"];
            this.warnings = _data["warnings"];
        }
    }

    static fromJS(data: any): ThermItArea {
        data = typeof data === 'object' ? data : {};
        let result = new ThermItArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaID"] = this.areaID;
        data["departmentID"] = this.departmentID;
        data["areaName"] = this.areaName;
        data["areaTypeName"] = this.areaTypeName;
        data["warnings"] = this.warnings;
        return data;
    }

    clone(): ThermItArea {
        const json = this.toJSON();
        let result = new ThermItArea();
        result.init(json);
        return result;
    }
}

export interface IThermItArea {
    areaID?: number;
    departmentID?: number;
    areaName?: string | undefined;
    areaTypeName?: string | undefined;
    warnings?: number;
}

export class ThermITSensor implements IThermITSensor {
    id?: number;
    deviceId?: number;
    sensorTypeId?: number;
    departmentSensorId?: number;
    sensorNo?: number;
    unit?: string | undefined;
    lastValueTime?: Date;
    lastValue?: number;
    activeRecordingId?: any | undefined;
    recordingType?: number;
    recordingDurationInMin?: number;
    recordingTargetTemp?: number;

    constructor(data?: IThermITSensor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deviceId = _data["deviceId"];
            this.sensorTypeId = _data["sensorTypeId"];
            this.departmentSensorId = _data["departmentSensorId"];
            this.sensorNo = _data["sensorNo"];
            this.unit = _data["unit"];
            this.lastValueTime = _data["lastValueTime"] ? new Date(_data["lastValueTime"].toString()) : undefined as any;
            this.lastValue = _data["lastValue"];
            this.activeRecordingId = _data["activeRecordingId"];
            this.recordingType = _data["recordingType"];
            this.recordingDurationInMin = _data["recordingDurationInMin"];
            this.recordingTargetTemp = _data["recordingTargetTemp"];
        }
    }

    static fromJS(data: any): ThermITSensor {
        data = typeof data === 'object' ? data : {};
        let result = new ThermITSensor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceId"] = this.deviceId;
        data["sensorTypeId"] = this.sensorTypeId;
        data["departmentSensorId"] = this.departmentSensorId;
        data["sensorNo"] = this.sensorNo;
        data["unit"] = this.unit;
        data["lastValueTime"] = this.lastValueTime ? this.lastValueTime.toISOString() : undefined as any;
        data["lastValue"] = this.lastValue;
        data["activeRecordingId"] = this.activeRecordingId;
        data["recordingType"] = this.recordingType;
        data["recordingDurationInMin"] = this.recordingDurationInMin;
        data["recordingTargetTemp"] = this.recordingTargetTemp;
        return data;
    }

    clone(): ThermITSensor {
        const json = this.toJSON();
        let result = new ThermITSensor();
        result.init(json);
        return result;
    }
}

export interface IThermITSensor {
    id?: number;
    deviceId?: number;
    sensorTypeId?: number;
    departmentSensorId?: number;
    sensorNo?: number;
    unit?: string | undefined;
    lastValueTime?: Date;
    lastValue?: number;
    activeRecordingId?: any | undefined;
    recordingType?: number;
    recordingDurationInMin?: number;
    recordingTargetTemp?: number;
}

export class ShopSubscriptionModel extends BasicEntity implements IShopSubscriptionModel {
    customerId?: string;
    customerName?: string | undefined;
    salesTemplateId?: string;
    cronSchedule?: string | undefined;
    cronScheduleHuman?: string | undefined;
    cronRepeatEvery?: number;
    firstDeliveryDate?: Date;
    leadTimeDays?: number;
    isActive?: boolean;
    internalRef?: string | undefined;
    internalRefName?: string | undefined;
    externalRef?: string | undefined;
    externalRefName?: string | undefined;

    constructor(data?: IShopSubscriptionModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.salesTemplateId = _data["salesTemplateId"];
            this.cronSchedule = _data["cronSchedule"];
            this.cronScheduleHuman = _data["cronScheduleHuman"];
            this.cronRepeatEvery = _data["cronRepeatEvery"];
            this.firstDeliveryDate = _data["firstDeliveryDate"] ? new Date(_data["firstDeliveryDate"].toString()) : undefined as any;
            this.leadTimeDays = _data["leadTimeDays"];
            this.isActive = _data["isActive"];
            this.internalRef = _data["internalRef"];
            this.internalRefName = _data["internalRefName"];
            this.externalRef = _data["externalRef"];
            this.externalRefName = _data["externalRefName"];
        }
    }

    static override fromJS(data: any): ShopSubscriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShopSubscriptionModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["salesTemplateId"] = this.salesTemplateId;
        data["cronSchedule"] = this.cronSchedule;
        data["cronScheduleHuman"] = this.cronScheduleHuman;
        data["cronRepeatEvery"] = this.cronRepeatEvery;
        data["firstDeliveryDate"] = this.firstDeliveryDate ? this.firstDeliveryDate.toISOString() : undefined as any;
        data["leadTimeDays"] = this.leadTimeDays;
        data["isActive"] = this.isActive;
        data["internalRef"] = this.internalRef;
        data["internalRefName"] = this.internalRefName;
        data["externalRef"] = this.externalRef;
        data["externalRefName"] = this.externalRefName;
        super.toJSON(data);
        return data;
    }

    clone(): ShopSubscriptionModel {
        const json = this.toJSON();
        let result = new ShopSubscriptionModel();
        result.init(json);
        return result;
    }
}

export interface IShopSubscriptionModel extends IBasicEntity {
    customerId?: string;
    customerName?: string | undefined;
    salesTemplateId?: string;
    cronSchedule?: string | undefined;
    cronScheduleHuman?: string | undefined;
    cronRepeatEvery?: number;
    firstDeliveryDate?: Date;
    leadTimeDays?: number;
    isActive?: boolean;
    internalRef?: string | undefined;
    internalRefName?: string | undefined;
    externalRef?: string | undefined;
    externalRefName?: string | undefined;
}

export class ShopCategoryModel implements IShopCategoryModel {
    id?: string;
    name?: string | undefined;
    type?: number;
    products?: ShopProductModel[] | undefined;

    constructor(data?: IShopCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ShopProductModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShopCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShopCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ShopCategoryModel {
        const json = this.toJSON();
        let result = new ShopCategoryModel();
        result.init(json);
        return result;
    }
}

export interface IShopCategoryModel {
    id?: string;
    name?: string | undefined;
    type?: number;
    products?: ShopProductModel[] | undefined;
}

export class ShopProductModel implements IShopProductModel {
    id?: string;
    productVariantId?: string;
    variantName?: string | undefined;
    productName?: string | undefined;
    unit?: string | undefined;
    salesPrice?: number;
    sku?: string | undefined;
    quantity?: number;
    isOrganic?: boolean;
    caseTypeName?: string | undefined;
    pricePerKg?: number;
    leadtime?: number;
    sortOrder?: number;

    constructor(data?: IShopProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productVariantId = _data["productVariantId"];
            this.variantName = _data["variantName"];
            this.productName = _data["productName"];
            this.unit = _data["unit"];
            this.salesPrice = _data["salesPrice"];
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.isOrganic = _data["isOrganic"];
            this.caseTypeName = _data["caseTypeName"];
            this.pricePerKg = _data["pricePerKg"];
            this.leadtime = _data["leadtime"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ShopProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShopProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productVariantId"] = this.productVariantId;
        data["variantName"] = this.variantName;
        data["productName"] = this.productName;
        data["unit"] = this.unit;
        data["salesPrice"] = this.salesPrice;
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["isOrganic"] = this.isOrganic;
        data["caseTypeName"] = this.caseTypeName;
        data["pricePerKg"] = this.pricePerKg;
        data["leadtime"] = this.leadtime;
        data["sortOrder"] = this.sortOrder;
        return data;
    }

    clone(): ShopProductModel {
        const json = this.toJSON();
        let result = new ShopProductModel();
        result.init(json);
        return result;
    }
}

export interface IShopProductModel {
    id?: string;
    productVariantId?: string;
    variantName?: string | undefined;
    productName?: string | undefined;
    unit?: string | undefined;
    salesPrice?: number;
    sku?: string | undefined;
    quantity?: number;
    isOrganic?: boolean;
    caseTypeName?: string | undefined;
    pricePerKg?: number;
    leadtime?: number;
    sortOrder?: number;
}

export class ShopDeliveryDeadlineModel implements IShopDeliveryDeadlineModel {
    id?: string;
    customerId?: string | undefined;
    customerGroupId?: string | undefined;
    orderDeadline?: string;
    orderWeekDay?: DayOfWeek;
    deliveryWeekDay?: DayOfWeek;
    salesOrderTemplateId?: string | undefined;
    automaticOrder?: boolean;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IShopDeliveryDeadlineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customerGroupId = _data["customerGroupId"];
            this.orderDeadline = _data["orderDeadline"];
            this.orderWeekDay = _data["orderWeekDay"];
            this.deliveryWeekDay = _data["deliveryWeekDay"];
            this.salesOrderTemplateId = _data["salesOrderTemplateId"];
            this.automaticOrder = _data["automaticOrder"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ShopDeliveryDeadlineModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShopDeliveryDeadlineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customerGroupId"] = this.customerGroupId;
        data["orderDeadline"] = this.orderDeadline;
        data["orderWeekDay"] = this.orderWeekDay;
        data["deliveryWeekDay"] = this.deliveryWeekDay;
        data["salesOrderTemplateId"] = this.salesOrderTemplateId;
        data["automaticOrder"] = this.automaticOrder;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ShopDeliveryDeadlineModel {
        const json = this.toJSON();
        let result = new ShopDeliveryDeadlineModel();
        result.init(json);
        return result;
    }
}

export interface IShopDeliveryDeadlineModel {
    id?: string;
    customerId?: string | undefined;
    customerGroupId?: string | undefined;
    orderDeadline?: string;
    orderWeekDay?: DayOfWeek;
    deliveryWeekDay?: DayOfWeek;
    salesOrderTemplateId?: string | undefined;
    automaticOrder?: boolean;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class ShopCustomerRelationModel extends BasicEntity implements IShopCustomerRelationModel {
    customerId?: string;
    customerName?: string | undefined;
    customerNumber?: string | undefined;
    shopUserId?: string;
    userName?: string | undefined;
    userEmail?: string | undefined;

    constructor(data?: IShopCustomerRelationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.customerNumber = _data["customerNumber"];
            this.shopUserId = _data["shopUserId"];
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
        }
    }

    static override fromJS(data: any): ShopCustomerRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShopCustomerRelationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["customerNumber"] = this.customerNumber;
        data["shopUserId"] = this.shopUserId;
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        super.toJSON(data);
        return data;
    }

    clone(): ShopCustomerRelationModel {
        const json = this.toJSON();
        let result = new ShopCustomerRelationModel();
        result.init(json);
        return result;
    }
}

export interface IShopCustomerRelationModel extends IBasicEntity {
    customerId?: string;
    customerName?: string | undefined;
    customerNumber?: string | undefined;
    shopUserId?: string;
    userName?: string | undefined;
    userEmail?: string | undefined;
}

export class StockOrderModel implements IStockOrderModel {
    id?: string;
    startTime?: Date | undefined;
    type?: OrderType;
    status?: OrderStatus;
    name?: string | undefined;
    comment?: string | undefined;
    stockLocationId?: string | undefined;
    stockLocationName?: string | undefined;
    totalStockValue?: number;

    constructor(data?: IStockOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.type = _data["type"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.stockLocationId = _data["stockLocationId"];
            this.stockLocationName = _data["stockLocationName"];
            this.totalStockValue = _data["totalStockValue"];
        }
    }

    static fromJS(data: any): StockOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["type"] = this.type;
        data["status"] = this.status;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["stockLocationId"] = this.stockLocationId;
        data["stockLocationName"] = this.stockLocationName;
        data["totalStockValue"] = this.totalStockValue;
        return data;
    }

    clone(): StockOrderModel {
        const json = this.toJSON();
        let result = new StockOrderModel();
        result.init(json);
        return result;
    }
}

export interface IStockOrderModel {
    id?: string;
    startTime?: Date | undefined;
    type?: OrderType;
    status?: OrderStatus;
    name?: string | undefined;
    comment?: string | undefined;
    stockLocationId?: string | undefined;
    stockLocationName?: string | undefined;
    totalStockValue?: number;
}

export class PagedResultOfStockItemModel extends PagedResultBase implements IPagedResultOfStockItemModel {
    results?: StockItemModel[];

    constructor(data?: IPagedResultOfStockItemModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(StockItemModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfStockItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfStockItemModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfStockItemModel {
        const json = this.toJSON();
        let result = new PagedResultOfStockItemModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfStockItemModel extends IPagedResultBase {
    results?: StockItemModel[];
}

export class ChartValue implements IChartValue {
    group?: string | undefined;
    argument?: string | undefined;
    value?: number;

    constructor(data?: IChartValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.argument = _data["argument"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ChartValue {
        data = typeof data === 'object' ? data : {};
        let result = new ChartValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["argument"] = this.argument;
        data["value"] = this.value;
        return data;
    }

    clone(): ChartValue {
        const json = this.toJSON();
        let result = new ChartValue();
        result.init(json);
        return result;
    }
}

export interface IChartValue {
    group?: string | undefined;
    argument?: string | undefined;
    value?: number;
}

export class StockBalanceModel implements IStockBalanceModel {
    id?: string;
    type?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    primo?: number;
    ultimo?: number;
    purchase?: number;
    production?: number;
    sale?: number;
    rawCalculated?: number;
    inputOutputCalculated?: number;
    registered?: number;
    scrap?: number;
    available?: number;
    rawDifference?: number;
    rawDeviation?: number;
    inputOutputDifference?: number;
    inputOutputDeviation?: number;
    productVariantId?: string;
    productId?: string;
    productGroupId?: string;
    productName?: string | undefined;
    productVariantName?: string | undefined;
    productQuantity?: number;
    productUnit?: string | undefined;
    supplier?: IdNameModel | undefined;
    sku?: string | undefined;
    comments?: string | undefined;
    inputOutputDetails?: string | undefined;
    stockLocationId?: string | undefined;
    transactions?: StockTransactionModel[] | undefined;

    constructor(data?: IStockBalanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.primo = _data["primo"];
            this.ultimo = _data["ultimo"];
            this.purchase = _data["purchase"];
            this.production = _data["production"];
            this.sale = _data["sale"];
            this.rawCalculated = _data["rawCalculated"];
            this.inputOutputCalculated = _data["inputOutputCalculated"];
            this.registered = _data["registered"];
            this.scrap = _data["scrap"];
            this.available = _data["available"];
            this.rawDifference = _data["rawDifference"];
            this.rawDeviation = _data["rawDeviation"];
            this.inputOutputDifference = _data["inputOutputDifference"];
            this.inputOutputDeviation = _data["inputOutputDeviation"];
            this.productVariantId = _data["productVariantId"];
            this.productId = _data["productId"];
            this.productGroupId = _data["productGroupId"];
            this.productName = _data["productName"];
            this.productVariantName = _data["productVariantName"];
            this.productQuantity = _data["productQuantity"];
            this.productUnit = _data["productUnit"];
            this.supplier = _data["supplier"] ? IdNameModel.fromJS(_data["supplier"]) : undefined as any;
            this.sku = _data["sku"];
            this.comments = _data["comments"];
            this.inputOutputDetails = _data["inputOutputDetails"];
            this.stockLocationId = _data["stockLocationId"];
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(StockTransactionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockBalanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockBalanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["primo"] = this.primo;
        data["ultimo"] = this.ultimo;
        data["purchase"] = this.purchase;
        data["production"] = this.production;
        data["sale"] = this.sale;
        data["rawCalculated"] = this.rawCalculated;
        data["inputOutputCalculated"] = this.inputOutputCalculated;
        data["registered"] = this.registered;
        data["scrap"] = this.scrap;
        data["available"] = this.available;
        data["rawDifference"] = this.rawDifference;
        data["rawDeviation"] = this.rawDeviation;
        data["inputOutputDifference"] = this.inputOutputDifference;
        data["inputOutputDeviation"] = this.inputOutputDeviation;
        data["productVariantId"] = this.productVariantId;
        data["productId"] = this.productId;
        data["productGroupId"] = this.productGroupId;
        data["productName"] = this.productName;
        data["productVariantName"] = this.productVariantName;
        data["productQuantity"] = this.productQuantity;
        data["productUnit"] = this.productUnit;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined as any;
        data["sku"] = this.sku;
        data["comments"] = this.comments;
        data["inputOutputDetails"] = this.inputOutputDetails;
        data["stockLocationId"] = this.stockLocationId;
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): StockBalanceModel {
        const json = this.toJSON();
        let result = new StockBalanceModel();
        result.init(json);
        return result;
    }
}

export interface IStockBalanceModel {
    id?: string;
    type?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    primo?: number;
    ultimo?: number;
    purchase?: number;
    production?: number;
    sale?: number;
    rawCalculated?: number;
    inputOutputCalculated?: number;
    registered?: number;
    scrap?: number;
    available?: number;
    rawDifference?: number;
    rawDeviation?: number;
    inputOutputDifference?: number;
    inputOutputDeviation?: number;
    productVariantId?: string;
    productId?: string;
    productGroupId?: string;
    productName?: string | undefined;
    productVariantName?: string | undefined;
    productQuantity?: number;
    productUnit?: string | undefined;
    supplier?: IdNameModel | undefined;
    sku?: string | undefined;
    comments?: string | undefined;
    inputOutputDetails?: string | undefined;
    stockLocationId?: string | undefined;
    transactions?: StockTransactionModel[] | undefined;
}

export class SpisemaerkeBalanceModel implements ISpisemaerkeBalanceModel {
    startDate?: Date;
    endDate?: Date;
    organicPercent?: number;
    totalValue?: number;
    totalNonfoodValue?: number;
    totalOrganicValue?: number;
    invoices?: SpisemaerkeInvoiceModel[] | undefined;

    constructor(data?: ISpisemaerkeBalanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.organicPercent = _data["organicPercent"];
            this.totalValue = _data["totalValue"];
            this.totalNonfoodValue = _data["totalNonfoodValue"];
            this.totalOrganicValue = _data["totalOrganicValue"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(SpisemaerkeInvoiceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpisemaerkeBalanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpisemaerkeBalanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["organicPercent"] = this.organicPercent;
        data["totalValue"] = this.totalValue;
        data["totalNonfoodValue"] = this.totalNonfoodValue;
        data["totalOrganicValue"] = this.totalOrganicValue;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): SpisemaerkeBalanceModel {
        const json = this.toJSON();
        let result = new SpisemaerkeBalanceModel();
        result.init(json);
        return result;
    }
}

export interface ISpisemaerkeBalanceModel {
    startDate?: Date;
    endDate?: Date;
    organicPercent?: number;
    totalValue?: number;
    totalNonfoodValue?: number;
    totalOrganicValue?: number;
    invoices?: SpisemaerkeInvoiceModel[] | undefined;
}

export class SpisemaerkeInvoiceModel implements ISpisemaerkeInvoiceModel {
    id?: string;
    invoiceNumber?: string | undefined;
    supplierName?: string | undefined;
    date?: Date;
    totalValue?: number;
    totalNonfoodValue?: number;
    totalOrganicValue?: number;

    constructor(data?: ISpisemaerkeInvoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.supplierName = _data["supplierName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.totalValue = _data["totalValue"];
            this.totalNonfoodValue = _data["totalNonfoodValue"];
            this.totalOrganicValue = _data["totalOrganicValue"];
        }
    }

    static fromJS(data: any): SpisemaerkeInvoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpisemaerkeInvoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["supplierName"] = this.supplierName;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["totalValue"] = this.totalValue;
        data["totalNonfoodValue"] = this.totalNonfoodValue;
        data["totalOrganicValue"] = this.totalOrganicValue;
        return data;
    }

    clone(): SpisemaerkeInvoiceModel {
        const json = this.toJSON();
        let result = new SpisemaerkeInvoiceModel();
        result.init(json);
        return result;
    }
}

export interface ISpisemaerkeInvoiceModel {
    id?: string;
    invoiceNumber?: string | undefined;
    supplierName?: string | undefined;
    date?: Date;
    totalValue?: number;
    totalNonfoodValue?: number;
    totalOrganicValue?: number;
}

export class AddLotModel implements IAddLotModel {
    stockItemId?: string;
    newLot?: string | undefined;
    expirationDate?: Date | undefined;
    productionDate?: Date | undefined;

    constructor(data?: IAddLotModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockItemId = _data["stockItemId"];
            this.newLot = _data["newLot"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
            this.productionDate = _data["productionDate"] ? new Date(_data["productionDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AddLotModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddLotModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockItemId"] = this.stockItemId;
        data["newLot"] = this.newLot;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        data["productionDate"] = this.productionDate ? this.productionDate.toISOString() : undefined as any;
        return data;
    }

    clone(): AddLotModel {
        const json = this.toJSON();
        let result = new AddLotModel();
        result.init(json);
        return result;
    }
}

export interface IAddLotModel {
    stockItemId?: string;
    newLot?: string | undefined;
    expirationDate?: Date | undefined;
    productionDate?: Date | undefined;
}

export class StockItemModels implements IStockItemModels {
    stockItems?: StockItemModel[] | undefined;
    transactionDate?: Date;
    isQuantityControlled?: boolean;
    comments?: string | undefined;
    stockLocationId?: string;
    orderId?: string;

    constructor(data?: IStockItemModels) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stockItems"])) {
                this.stockItems = [] as any;
                for (let item of _data["stockItems"])
                    this.stockItems!.push(StockItemModel.fromJS(item));
            }
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : undefined as any;
            this.isQuantityControlled = _data["isQuantityControlled"];
            this.comments = _data["comments"];
            this.stockLocationId = _data["stockLocationId"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): StockItemModels {
        data = typeof data === 'object' ? data : {};
        let result = new StockItemModels();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stockItems)) {
            data["stockItems"] = [];
            for (let item of this.stockItems)
                data["stockItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : undefined as any;
        data["isQuantityControlled"] = this.isQuantityControlled;
        data["comments"] = this.comments;
        data["stockLocationId"] = this.stockLocationId;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): StockItemModels {
        const json = this.toJSON();
        let result = new StockItemModels();
        result.init(json);
        return result;
    }
}

export interface IStockItemModels {
    stockItems?: StockItemModel[] | undefined;
    transactionDate?: Date;
    isQuantityControlled?: boolean;
    comments?: string | undefined;
    stockLocationId?: string;
    orderId?: string;
}

export class StockLocationModel implements IStockLocationModel {
    id?: string;
    name?: string | undefined;
    groupNumber?: string | undefined;
    isDefault?: boolean;
    excludeFromStockCount?: boolean;
    products?: string[] | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IStockLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.groupNumber = _data["groupNumber"];
            this.isDefault = _data["isDefault"];
            this.excludeFromStockCount = _data["excludeFromStockCount"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(item);
            }
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): StockLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockLocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["groupNumber"] = this.groupNumber;
        data["isDefault"] = this.isDefault;
        data["excludeFromStockCount"] = this.excludeFromStockCount;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item);
        }
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): StockLocationModel {
        const json = this.toJSON();
        let result = new StockLocationModel();
        result.init(json);
        return result;
    }
}

export interface IStockLocationModel {
    id?: string;
    name?: string | undefined;
    groupNumber?: string | undefined;
    isDefault?: boolean;
    excludeFromStockCount?: boolean;
    products?: string[] | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class StockPositionTypeModel implements IStockPositionTypeModel {
    id?: string;
    name?: string | undefined;
    sortOrder?: number;
    children?: StockPositionModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: IStockPositionTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(StockPositionModel.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): StockPositionTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockPositionTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): StockPositionTypeModel {
        const json = this.toJSON();
        let result = new StockPositionTypeModel();
        result.init(json);
        return result;
    }
}

export interface IStockPositionTypeModel {
    id?: string;
    name?: string | undefined;
    sortOrder?: number;
    children?: StockPositionModel[] | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class PagedResultOfSupplierModel extends PagedResultBase implements IPagedResultOfSupplierModel {
    results?: SupplierModel[];

    constructor(data?: IPagedResultOfSupplierModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SupplierModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PagedResultOfSupplierModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfSupplierModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultOfSupplierModel {
        const json = this.toJSON();
        let result = new PagedResultOfSupplierModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfSupplierModel extends IPagedResultBase {
    results?: SupplierModel[];
}

export class SupplierGroupModel implements ISupplierGroupModel {
    id?: string;
    name?: string | undefined;
    groupNumber?: string | undefined;
    suppliers?: string[] | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;

    constructor(data?: ISupplierGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.groupNumber = _data["groupNumber"];
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(item);
            }
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): SupplierGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["groupNumber"] = this.groupNumber;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item);
        }
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): SupplierGroupModel {
        const json = this.toJSON();
        let result = new SupplierGroupModel();
        result.init(json);
        return result;
    }
}

export interface ISupplierGroupModel {
    id?: string;
    name?: string | undefined;
    groupNumber?: string | undefined;
    suppliers?: string[] | undefined;
    organizationId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
}

export class SupportSessionModel implements ISupportSessionModel {
    id?: string | undefined;
    title?: string | undefined;
    status?: SupportSessionStatusEnum | undefined;
    category?: SupportSessionCategoryEnum | undefined;
    priority?: SupportSessionPriorityEnum | undefined;
    description?: string | undefined;
    uriRoute?: string | undefined;
    userAgent?: string | undefined;
    browserLanguage?: string | undefined;
    screenWidth?: number | undefined;
    screenHeight?: number | undefined;
    windowWidth?: number | undefined;
    windowHeight?: number | undefined;
    platform?: string | undefined;
    ipAddress?: string | undefined;
    referrer?: string | undefined;
    userId?: string;
    responsibleUserId?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
    userName?: string | undefined;
    responsibleUserName?: string | undefined;
    isDeleted?: boolean;
    created?: Date;
    updated?: Date;

    constructor(data?: ISupportSessionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.category = _data["category"];
            this.priority = _data["priority"];
            this.description = _data["description"];
            this.uriRoute = _data["uriRoute"];
            this.userAgent = _data["userAgent"];
            this.browserLanguage = _data["browserLanguage"];
            this.screenWidth = _data["screenWidth"];
            this.screenHeight = _data["screenHeight"];
            this.windowWidth = _data["windowWidth"];
            this.windowHeight = _data["windowHeight"];
            this.platform = _data["platform"];
            this.ipAddress = _data["ipAddress"];
            this.referrer = _data["referrer"];
            this.userId = _data["userId"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.userName = _data["userName"];
            this.responsibleUserName = _data["responsibleUserName"];
            this.isDeleted = _data["isDeleted"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SupportSessionModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupportSessionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["status"] = this.status;
        data["category"] = this.category;
        data["priority"] = this.priority;
        data["description"] = this.description;
        data["uriRoute"] = this.uriRoute;
        data["userAgent"] = this.userAgent;
        data["browserLanguage"] = this.browserLanguage;
        data["screenWidth"] = this.screenWidth;
        data["screenHeight"] = this.screenHeight;
        data["windowWidth"] = this.windowWidth;
        data["windowHeight"] = this.windowHeight;
        data["platform"] = this.platform;
        data["ipAddress"] = this.ipAddress;
        data["referrer"] = this.referrer;
        data["userId"] = this.userId;
        data["responsibleUserId"] = this.responsibleUserId;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["userName"] = this.userName;
        data["responsibleUserName"] = this.responsibleUserName;
        data["isDeleted"] = this.isDeleted;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        return data;
    }

    clone(): SupportSessionModel {
        const json = this.toJSON();
        let result = new SupportSessionModel();
        result.init(json);
        return result;
    }
}

export interface ISupportSessionModel {
    id?: string | undefined;
    title?: string | undefined;
    status?: SupportSessionStatusEnum | undefined;
    category?: SupportSessionCategoryEnum | undefined;
    priority?: SupportSessionPriorityEnum | undefined;
    description?: string | undefined;
    uriRoute?: string | undefined;
    userAgent?: string | undefined;
    browserLanguage?: string | undefined;
    screenWidth?: number | undefined;
    screenHeight?: number | undefined;
    windowWidth?: number | undefined;
    windowHeight?: number | undefined;
    platform?: string | undefined;
    ipAddress?: string | undefined;
    referrer?: string | undefined;
    userId?: string;
    responsibleUserId?: string | undefined;
    organizationId?: string;
    organizationName?: string | undefined;
    userName?: string | undefined;
    responsibleUserName?: string | undefined;
    isDeleted?: boolean;
    created?: Date;
    updated?: Date;
}

export enum SupportSessionStatusEnum {
    Open = 0,
    Closed = 1,
}

export enum SupportSessionCategoryEnum {
    Error = 0,
    Functionality = 1,
    Help = 2,
}

export enum SupportSessionPriorityEnum {
    Low = 0,
    Medium = 1,
    High = 2,
}

export class SupportSessionActivityModel implements ISupportSessionActivityModel {
    id?: string;
    message?: string | undefined;
    supportSessionid?: string;
    userId?: string;
    organizationid?: string;

    constructor(data?: ISupportSessionActivityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
            this.supportSessionid = _data["supportSessionid"];
            this.userId = _data["userId"];
            this.organizationid = _data["organizationid"];
        }
    }

    static fromJS(data: any): SupportSessionActivityModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupportSessionActivityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["supportSessionid"] = this.supportSessionid;
        data["userId"] = this.userId;
        data["organizationid"] = this.organizationid;
        return data;
    }

    clone(): SupportSessionActivityModel {
        const json = this.toJSON();
        let result = new SupportSessionActivityModel();
        result.init(json);
        return result;
    }
}

export interface ISupportSessionActivityModel {
    id?: string;
    message?: string | undefined;
    supportSessionid?: string;
    userId?: string;
    organizationid?: string;
}

export class SurveyResultModel implements ISurveyResultModel {
    id?: string;
    surveyId?: string;
    surveyDate?: Date | undefined;
    filledBy?: string | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    status?: SurveyAnswerStatusType;
    answers?: SurveyAnswerModel[] | undefined;
    created?: Date;
    updated?: Date;
    organizationId?: string;

    constructor(data?: ISurveyResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyId = _data["surveyId"];
            this.surveyDate = _data["surveyDate"] ? new Date(_data["surveyDate"].toString()) : undefined as any;
            this.filledBy = _data["filledBy"];
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.status = _data["status"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(SurveyAnswerModel.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): SurveyResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyId"] = this.surveyId;
        data["surveyDate"] = this.surveyDate ? this.surveyDate.toISOString() : undefined as any;
        data["filledBy"] = this.filledBy;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["status"] = this.status;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["organizationId"] = this.organizationId;
        return data;
    }

    clone(): SurveyResultModel {
        const json = this.toJSON();
        let result = new SurveyResultModel();
        result.init(json);
        return result;
    }
}

export interface ISurveyResultModel {
    id?: string;
    surveyId?: string;
    surveyDate?: Date | undefined;
    filledBy?: string | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    status?: SurveyAnswerStatusType;
    answers?: SurveyAnswerModel[] | undefined;
    created?: Date;
    updated?: Date;
    organizationId?: string;
}

export enum SurveyAnswerStatusType {
    Started = 0,
    Done = 1,
}

export class SurveyAnswerModel extends BasicModel implements ISurveyAnswerModel {
    surveyId?: string;
    surveyQuestionId?: string;
    title?: string | undefined;
    value?: string | undefined;
    choiceValue?: number | undefined;
    choiceReportText?: string | undefined;
    displayValue?: string | undefined;
    isNode?: boolean;
    reportText?: string | undefined;

    constructor(data?: ISurveyAnswerModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyQuestionId = _data["surveyQuestionId"];
            this.title = _data["title"];
            this.value = _data["value"];
            this.choiceValue = _data["choiceValue"];
            this.choiceReportText = _data["choiceReportText"];
            this.displayValue = _data["displayValue"];
            this.isNode = _data["isNode"];
            this.reportText = _data["reportText"];
        }
    }

    static override fromJS(data: any): SurveyAnswerModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyQuestionId"] = this.surveyQuestionId;
        data["title"] = this.title;
        data["value"] = this.value;
        data["choiceValue"] = this.choiceValue;
        data["choiceReportText"] = this.choiceReportText;
        data["displayValue"] = this.displayValue;
        data["isNode"] = this.isNode;
        data["reportText"] = this.reportText;
        super.toJSON(data);
        return data;
    }

    clone(): SurveyAnswerModel {
        const json = this.toJSON();
        let result = new SurveyAnswerModel();
        result.init(json);
        return result;
    }
}

export interface ISurveyAnswerModel extends IBasicModel {
    surveyId?: string;
    surveyQuestionId?: string;
    title?: string | undefined;
    value?: string | undefined;
    choiceValue?: number | undefined;
    choiceReportText?: string | undefined;
    displayValue?: string | undefined;
    isNode?: boolean;
    reportText?: string | undefined;
}

export class QsBasicEntity extends BaseEntity implements IQsBasicEntity {
    user?: QsUser | undefined;
    organization?: QsOrganization | undefined;

    constructor(data?: IQsBasicEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? QsUser.fromJS(_data["user"]) : undefined as any;
            this.organization = _data["organization"] ? QsOrganization.fromJS(_data["organization"]) : undefined as any;
        }
    }

    static override fromJS(data: any): QsBasicEntity {
        data = typeof data === 'object' ? data : {};
        let result = new QsBasicEntity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["organization"] = this.organization ? this.organization.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): QsBasicEntity {
        const json = this.toJSON();
        let result = new QsBasicEntity();
        result.init(json);
        return result;
    }
}

export interface IQsBasicEntity extends IBaseEntity {
    user?: QsUser | undefined;
    organization?: QsOrganization | undefined;
}

export class QsSurveyAnswer extends QsBasicEntity implements IQsSurveyAnswer {
    surveyId?: string;
    surveyQuestionId?: string;
    title?: string | undefined;
    value?: string | undefined;
    choiceValue?: number | undefined;
    choiceReportText?: string | undefined;
    displayValue?: string | undefined;
    reportText?: string | undefined;
    isNode?: boolean;

    constructor(data?: IQsSurveyAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyQuestionId = _data["surveyQuestionId"];
            this.title = _data["title"];
            this.value = _data["value"];
            this.choiceValue = _data["choiceValue"];
            this.choiceReportText = _data["choiceReportText"];
            this.displayValue = _data["displayValue"];
            this.reportText = _data["reportText"];
            this.isNode = _data["isNode"];
        }
    }

    static override fromJS(data: any): QsSurveyAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new QsSurveyAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyQuestionId"] = this.surveyQuestionId;
        data["title"] = this.title;
        data["value"] = this.value;
        data["choiceValue"] = this.choiceValue;
        data["choiceReportText"] = this.choiceReportText;
        data["displayValue"] = this.displayValue;
        data["reportText"] = this.reportText;
        data["isNode"] = this.isNode;
        super.toJSON(data);
        return data;
    }

    clone(): QsSurveyAnswer {
        const json = this.toJSON();
        let result = new QsSurveyAnswer();
        result.init(json);
        return result;
    }
}

export interface IQsSurveyAnswer extends IQsBasicEntity {
    surveyId?: string;
    surveyQuestionId?: string;
    title?: string | undefined;
    value?: string | undefined;
    choiceValue?: number | undefined;
    choiceReportText?: string | undefined;
    displayValue?: string | undefined;
    reportText?: string | undefined;
    isNode?: boolean;
}

export class QsUser implements IQsUser {
    id?: string;
    name?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    organizationId?: string;
    addressId?: string | undefined;
    pin?: string | undefined;
    employeeNumber?: string | undefined;
    customerId?: string | undefined;
    subscriptionType?: UserSubscriptionType;
    source?: string;
    externalSourceId?: string;
    timeRegId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    azureB2CStatus?: number;
    dismissedNotifications?: string;

    constructor(data?: IQsUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.mobile = _data["mobile"];
            this.organizationId = _data["organizationId"];
            this.addressId = _data["addressId"];
            this.pin = _data["pin"];
            this.employeeNumber = _data["employeeNumber"];
            this.customerId = _data["customerId"];
            this.subscriptionType = _data["subscriptionType"];
            this.source = _data["source"];
            this.externalSourceId = _data["externalSourceId"];
            this.timeRegId = _data["timeRegId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.azureB2CStatus = _data["azureB2CStatus"];
            this.dismissedNotifications = _data["dismissedNotifications"];
        }
    }

    static fromJS(data: any): QsUser {
        data = typeof data === 'object' ? data : {};
        let result = new QsUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["username"] = this.username;
        data["email"] = this.email;
        data["mobile"] = this.mobile;
        data["organizationId"] = this.organizationId;
        data["addressId"] = this.addressId;
        data["pin"] = this.pin;
        data["employeeNumber"] = this.employeeNumber;
        data["customerId"] = this.customerId;
        data["subscriptionType"] = this.subscriptionType;
        data["source"] = this.source;
        data["externalSourceId"] = this.externalSourceId;
        data["timeRegId"] = this.timeRegId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["azureB2CStatus"] = this.azureB2CStatus;
        data["dismissedNotifications"] = this.dismissedNotifications;
        return data;
    }

    clone(): QsUser {
        const json = this.toJSON();
        let result = new QsUser();
        result.init(json);
        return result;
    }
}

export interface IQsUser {
    id?: string;
    name?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    organizationId?: string;
    addressId?: string | undefined;
    pin?: string | undefined;
    employeeNumber?: string | undefined;
    customerId?: string | undefined;
    subscriptionType?: UserSubscriptionType;
    source?: string;
    externalSourceId?: string;
    timeRegId?: string;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    azureB2CStatus?: number;
    dismissedNotifications?: string;
}

export class SurveyModel implements ISurveyModel {
    id?: string;
    displayName?: string | undefined;
    surveyType?: string | undefined;
    sections?: SurveySectionModel[] | undefined;
    showQuestionNumbers?: string | undefined;
    locale?: string | undefined;
    organizationId?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: ISurveyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.surveyType = _data["surveyType"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SurveySectionModel.fromJS(item));
            }
            this.showQuestionNumbers = _data["showQuestionNumbers"];
            this.locale = _data["locale"];
            this.organizationId = _data["organizationId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): SurveyModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["surveyType"] = this.surveyType;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        data["showQuestionNumbers"] = this.showQuestionNumbers;
        data["locale"] = this.locale;
        data["organizationId"] = this.organizationId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): SurveyModel {
        const json = this.toJSON();
        let result = new SurveyModel();
        result.init(json);
        return result;
    }
}

export interface ISurveyModel {
    id?: string;
    displayName?: string | undefined;
    surveyType?: string | undefined;
    sections?: SurveySectionModel[] | undefined;
    showQuestionNumbers?: string | undefined;
    locale?: string | undefined;
    organizationId?: string;
    created?: Date | undefined;
    updated?: Date | undefined;
    isDeleted?: boolean;
}

export class SurveySectionModel implements ISurveySectionModel {
    id?: string;
    surveyId?: string;
    name?: string | undefined;
    questions?: SurveyQuestionModel[] | undefined;
    sortOrder?: number;
    showQuestionNumbers?: string | undefined;
    reportText?: string | undefined;
    visibleIf?: string | undefined;

    constructor(data?: ISurveySectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyId = _data["surveyId"];
            this.name = _data["name"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(SurveyQuestionModel.fromJS(item));
            }
            this.sortOrder = _data["sortOrder"];
            this.showQuestionNumbers = _data["showQuestionNumbers"];
            this.reportText = _data["reportText"];
            this.visibleIf = _data["visibleIf"];
        }
    }

    static fromJS(data: any): SurveySectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveySectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyId"] = this.surveyId;
        data["name"] = this.name;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        data["sortOrder"] = this.sortOrder;
        data["showQuestionNumbers"] = this.showQuestionNumbers;
        data["reportText"] = this.reportText;
        data["visibleIf"] = this.visibleIf;
        return data;
    }

    clone(): SurveySectionModel {
        const json = this.toJSON();
        let result = new SurveySectionModel();
        result.init(json);
        return result;
    }
}

export interface ISurveySectionModel {
    id?: string;
    surveyId?: string;
    name?: string | undefined;
    questions?: SurveyQuestionModel[] | undefined;
    sortOrder?: number;
    showQuestionNumbers?: string | undefined;
    reportText?: string | undefined;
    visibleIf?: string | undefined;
}

export class SurveyQuestionModel implements ISurveyQuestionModel {
    id?: string;
    surveySectionId?: string;
    sortOrder?: number;
    name?: string | undefined;
    type?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    isRequired?: boolean | undefined;
    choices?: string[] | undefined;
    choicesReportText?: string[] | undefined;
    showSelectAllItem?: boolean | undefined;
    showNoneItem?: boolean | undefined;
    showOtherItem?: boolean | undefined;
    visibleIf?: string | undefined;
    reportText?: string | undefined;

    constructor(data?: ISurveyQuestionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveySectionId = _data["surveySectionId"];
            this.sortOrder = _data["sortOrder"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.isRequired = _data["isRequired"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(item);
            }
            if (Array.isArray(_data["choicesReportText"])) {
                this.choicesReportText = [] as any;
                for (let item of _data["choicesReportText"])
                    this.choicesReportText!.push(item);
            }
            this.showSelectAllItem = _data["showSelectAllItem"];
            this.showNoneItem = _data["showNoneItem"];
            this.showOtherItem = _data["showOtherItem"];
            this.visibleIf = _data["visibleIf"];
            this.reportText = _data["reportText"];
        }
    }

    static fromJS(data: any): SurveyQuestionModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveySectionId"] = this.surveySectionId;
        data["sortOrder"] = this.sortOrder;
        data["name"] = this.name;
        data["type"] = this.type;
        data["title"] = this.title;
        data["description"] = this.description;
        data["isRequired"] = this.isRequired;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item);
        }
        if (Array.isArray(this.choicesReportText)) {
            data["choicesReportText"] = [];
            for (let item of this.choicesReportText)
                data["choicesReportText"].push(item);
        }
        data["showSelectAllItem"] = this.showSelectAllItem;
        data["showNoneItem"] = this.showNoneItem;
        data["showOtherItem"] = this.showOtherItem;
        data["visibleIf"] = this.visibleIf;
        data["reportText"] = this.reportText;
        return data;
    }

    clone(): SurveyQuestionModel {
        const json = this.toJSON();
        let result = new SurveyQuestionModel();
        result.init(json);
        return result;
    }
}

export interface ISurveyQuestionModel {
    id?: string;
    surveySectionId?: string;
    sortOrder?: number;
    name?: string | undefined;
    type?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    isRequired?: boolean | undefined;
    choices?: string[] | undefined;
    choicesReportText?: string[] | undefined;
    showSelectAllItem?: boolean | undefined;
    showNoneItem?: boolean | undefined;
    showOtherItem?: boolean | undefined;
    visibleIf?: string | undefined;
    reportText?: string | undefined;
}

export class SurveyUIModel implements ISurveyUIModel {
    title?: string | undefined;
    pages?: SurveyPageModel[] | undefined;
    showQuestionNumbers?: string | undefined;
    locale?: string | undefined;

    constructor(data?: ISurveyUIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(SurveyPageModel.fromJS(item));
            }
            this.showQuestionNumbers = _data["showQuestionNumbers"];
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): SurveyUIModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyUIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        data["showQuestionNumbers"] = this.showQuestionNumbers;
        data["locale"] = this.locale;
        return data;
    }

    clone(): SurveyUIModel {
        const json = this.toJSON();
        let result = new SurveyUIModel();
        result.init(json);
        return result;
    }
}

export interface ISurveyUIModel {
    title?: string | undefined;
    pages?: SurveyPageModel[] | undefined;
    showQuestionNumbers?: string | undefined;
    locale?: string | undefined;
}

export class SurveyPageModel implements ISurveyPageModel {
    name?: string | undefined;
    title?: string | undefined;
    type?: string | undefined;
    elements?: SurveyElementModel[] | undefined;
    showQuestionNumbers?: string | undefined;
    reportText?: string | undefined;
    visibleIf?: string | undefined;

    constructor(data?: ISurveyPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"];
            this.type = _data["type"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(SurveyElementModel.fromJS(item));
            }
            this.showQuestionNumbers = _data["showQuestionNumbers"];
            this.reportText = _data["reportText"];
            this.visibleIf = _data["visibleIf"];
        }
    }

    static fromJS(data: any): SurveyPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title;
        data["type"] = this.type;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        data["showQuestionNumbers"] = this.showQuestionNumbers;
        data["reportText"] = this.reportText;
        data["visibleIf"] = this.visibleIf;
        return data;
    }

    clone(): SurveyPageModel {
        const json = this.toJSON();
        let result = new SurveyPageModel();
        result.init(json);
        return result;
    }
}

export interface ISurveyPageModel {
    name?: string | undefined;
    title?: string | undefined;
    type?: string | undefined;
    elements?: SurveyElementModel[] | undefined;
    showQuestionNumbers?: string | undefined;
    reportText?: string | undefined;
    visibleIf?: string | undefined;
}

export class SurveyElementModel implements ISurveyElementModel {
    name?: string | undefined;
    title?: string | undefined;
    type?: string | undefined;
    description?: string | undefined;
    choices?: string[] | undefined;
    isRequired?: boolean | undefined;
    showSelectAllItem?: boolean | undefined;
    showNoneItem?: boolean | undefined;
    showOtherItem?: boolean | undefined;
    storeDataAsText?: boolean | undefined;
    visibleIf?: string | undefined;
    waitForUpload?: boolean | undefined;
    sourceType?: string | undefined;
    allowMultiple?: boolean | undefined;
    templateElements?: SurveyElementModel[] | undefined;
    templateTabTitle?: string | undefined;
    panelCount?: number;
    maxPanelCount?: number;
    confirmDelete?: boolean | undefined;
    renderMode?: string | undefined;
    allowAddPanel?: boolean | undefined;
    readOnly?: boolean | undefined;

    constructor(data?: ISurveyElementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.description = _data["description"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(item);
            }
            this.isRequired = _data["isRequired"];
            this.showSelectAllItem = _data["showSelectAllItem"];
            this.showNoneItem = _data["showNoneItem"];
            this.showOtherItem = _data["showOtherItem"];
            this.storeDataAsText = _data["storeDataAsText"];
            this.visibleIf = _data["visibleIf"];
            this.waitForUpload = _data["waitForUpload"];
            this.sourceType = _data["sourceType"];
            this.allowMultiple = _data["allowMultiple"];
            if (Array.isArray(_data["templateElements"])) {
                this.templateElements = [] as any;
                for (let item of _data["templateElements"])
                    this.templateElements!.push(SurveyElementModel.fromJS(item));
            }
            this.templateTabTitle = _data["templateTabTitle"];
            this.panelCount = _data["panelCount"];
            this.maxPanelCount = _data["maxPanelCount"];
            this.confirmDelete = _data["confirmDelete"];
            this.renderMode = _data["renderMode"];
            this.allowAddPanel = _data["allowAddPanel"];
            this.readOnly = _data["readOnly"];
        }
    }

    static fromJS(data: any): SurveyElementModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyElementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title;
        data["type"] = this.type;
        data["description"] = this.description;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item);
        }
        data["isRequired"] = this.isRequired;
        data["showSelectAllItem"] = this.showSelectAllItem;
        data["showNoneItem"] = this.showNoneItem;
        data["showOtherItem"] = this.showOtherItem;
        data["storeDataAsText"] = this.storeDataAsText;
        data["visibleIf"] = this.visibleIf;
        data["waitForUpload"] = this.waitForUpload;
        data["sourceType"] = this.sourceType;
        data["allowMultiple"] = this.allowMultiple;
        if (Array.isArray(this.templateElements)) {
            data["templateElements"] = [];
            for (let item of this.templateElements)
                data["templateElements"].push(item ? item.toJSON() : undefined as any);
        }
        data["templateTabTitle"] = this.templateTabTitle;
        data["panelCount"] = this.panelCount;
        data["maxPanelCount"] = this.maxPanelCount;
        data["confirmDelete"] = this.confirmDelete;
        data["renderMode"] = this.renderMode;
        data["allowAddPanel"] = this.allowAddPanel;
        data["readOnly"] = this.readOnly;
        return data;
    }

    clone(): SurveyElementModel {
        const json = this.toJSON();
        let result = new SurveyElementModel();
        result.init(json);
        return result;
    }
}

export interface ISurveyElementModel {
    name?: string | undefined;
    title?: string | undefined;
    type?: string | undefined;
    description?: string | undefined;
    choices?: string[] | undefined;
    isRequired?: boolean | undefined;
    showSelectAllItem?: boolean | undefined;
    showNoneItem?: boolean | undefined;
    showOtherItem?: boolean | undefined;
    storeDataAsText?: boolean | undefined;
    visibleIf?: string | undefined;
    waitForUpload?: boolean | undefined;
    sourceType?: string | undefined;
    allowMultiple?: boolean | undefined;
    templateElements?: SurveyElementModel[] | undefined;
    templateTabTitle?: string | undefined;
    panelCount?: number;
    maxPanelCount?: number;
    confirmDelete?: boolean | undefined;
    renderMode?: string | undefined;
    allowAddPanel?: boolean | undefined;
    readOnly?: boolean | undefined;
}

export class UnitModel extends BasicModel implements IUnitModel {
    name?: string | undefined;
    externalId?: string | undefined;
    baseUnit?: string | undefined;
    baseMultiplier?: number;
    type?: string | undefined;

    constructor(data?: IUnitModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.baseUnit = _data["baseUnit"];
            this.baseMultiplier = _data["baseMultiplier"];
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): UnitModel {
        data = typeof data === 'object' ? data : {};
        let result = new UnitModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["baseUnit"] = this.baseUnit;
        data["baseMultiplier"] = this.baseMultiplier;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }

    clone(): UnitModel {
        const json = this.toJSON();
        let result = new UnitModel();
        result.init(json);
        return result;
    }
}

export interface IUnitModel extends IBasicModel {
    name?: string | undefined;
    externalId?: string | undefined;
    baseUnit?: string | undefined;
    baseMultiplier?: number;
    type?: string | undefined;
}

export class UserPermissionsModel implements IUserPermissionsModel {
    id?: string;
    organizationId?: string;
    userId?: string;
    permissionId?: string;
    access?: string | undefined;
    name?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    permissionUserId?: string;
    permissionOrganizationId?: string;

    constructor(data?: IUserPermissionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.permissionId = _data["permissionId"];
            this.access = _data["access"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.permissionUserId = _data["permissionUserId"];
            this.permissionOrganizationId = _data["permissionOrganizationId"];
        }
    }

    static fromJS(data: any): UserPermissionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["permissionId"] = this.permissionId;
        data["access"] = this.access;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["permissionUserId"] = this.permissionUserId;
        data["permissionOrganizationId"] = this.permissionOrganizationId;
        return data;
    }

    clone(): UserPermissionsModel {
        const json = this.toJSON();
        let result = new UserPermissionsModel();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionsModel {
    id?: string;
    organizationId?: string;
    userId?: string;
    permissionId?: string;
    access?: string | undefined;
    name?: string | undefined;
    created?: Date;
    updated?: Date;
    isDeleted?: boolean;
    permissionUserId?: string;
    permissionOrganizationId?: string;
}

export class VisitOverviewModel implements IVisitOverviewModel {
    contractName?: string | undefined;
    contractNumber?: string | undefined;
    department?: string | undefined;
    address?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    controlRevision?: boolean | undefined;
    contactPersonName?: string | undefined;
    contactPersonPhone?: string | undefined;
    contactPersonEmail?: string | undefined;
    responsibleUserName?: string | undefined;
    organizationId?: string | undefined;
    lastVisit?: Date | undefined;
    q1AuditVisit?: number | undefined;
    q2AuditVisit?: number | undefined;
    q3AuditVisit?: number | undefined;
    q4AuditVisit?: number | undefined;
    totalAuditVisits?: number | undefined;
    completedAuditVisits?: number | undefined;
    missingAuditVisits?: number | undefined;
    q1Sample?: number | undefined;
    q2Sample?: number | undefined;
    q3Sample?: number | undefined;
    q4Sample?: number | undefined;
    drivingDistance?: number;
    drivingTime?: number;
    drivingToll?: number;
    drivingCost?: number;
    auditDuration?: number;
    auditCost?: number;
    contractYearlySum?: number;
    contractYearlyFee?: number;
    contractYearlyCostPrice?: number;
    contractYearlySalesPrice?: number;
    contractYearlyEarningsCostPrice?: number;
    contractYearlyEarningsSalesPrice?: number;
    contractYearlyRevisionAnalysisPlan?: number | undefined;
    contractYearlyRevision?: number | undefined;
    contractUnannouncedAudits?: number | undefined;

    constructor(data?: IVisitOverviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractName = _data["contractName"];
            this.contractNumber = _data["contractNumber"];
            this.department = _data["department"];
            this.address = _data["address"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.controlRevision = _data["controlRevision"];
            this.contactPersonName = _data["contactPersonName"];
            this.contactPersonPhone = _data["contactPersonPhone"];
            this.contactPersonEmail = _data["contactPersonEmail"];
            this.responsibleUserName = _data["responsibleUserName"];
            this.organizationId = _data["organizationId"];
            this.lastVisit = _data["lastVisit"] ? new Date(_data["lastVisit"].toString()) : undefined as any;
            this.q1AuditVisit = _data["q1AuditVisit"];
            this.q2AuditVisit = _data["q2AuditVisit"];
            this.q3AuditVisit = _data["q3AuditVisit"];
            this.q4AuditVisit = _data["q4AuditVisit"];
            this.totalAuditVisits = _data["totalAuditVisits"];
            this.completedAuditVisits = _data["completedAuditVisits"];
            this.missingAuditVisits = _data["missingAuditVisits"];
            this.q1Sample = _data["q1Sample"];
            this.q2Sample = _data["q2Sample"];
            this.q3Sample = _data["q3Sample"];
            this.q4Sample = _data["q4Sample"];
            this.drivingDistance = _data["drivingDistance"];
            this.drivingTime = _data["drivingTime"];
            this.drivingToll = _data["drivingToll"];
            this.drivingCost = _data["drivingCost"];
            this.auditDuration = _data["auditDuration"];
            this.auditCost = _data["auditCost"];
            this.contractYearlySum = _data["contractYearlySum"];
            this.contractYearlyFee = _data["contractYearlyFee"];
            this.contractYearlyCostPrice = _data["contractYearlyCostPrice"];
            this.contractYearlySalesPrice = _data["contractYearlySalesPrice"];
            this.contractYearlyEarningsCostPrice = _data["contractYearlyEarningsCostPrice"];
            this.contractYearlyEarningsSalesPrice = _data["contractYearlyEarningsSalesPrice"];
            this.contractYearlyRevisionAnalysisPlan = _data["contractYearlyRevisionAnalysisPlan"];
            this.contractYearlyRevision = _data["contractYearlyRevision"];
            this.contractUnannouncedAudits = _data["contractUnannouncedAudits"];
        }
    }

    static fromJS(data: any): VisitOverviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VisitOverviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractName"] = this.contractName;
        data["contractNumber"] = this.contractNumber;
        data["department"] = this.department;
        data["address"] = this.address;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["controlRevision"] = this.controlRevision;
        data["contactPersonName"] = this.contactPersonName;
        data["contactPersonPhone"] = this.contactPersonPhone;
        data["contactPersonEmail"] = this.contactPersonEmail;
        data["responsibleUserName"] = this.responsibleUserName;
        data["organizationId"] = this.organizationId;
        data["lastVisit"] = this.lastVisit ? this.lastVisit.toISOString() : undefined as any;
        data["q1AuditVisit"] = this.q1AuditVisit;
        data["q2AuditVisit"] = this.q2AuditVisit;
        data["q3AuditVisit"] = this.q3AuditVisit;
        data["q4AuditVisit"] = this.q4AuditVisit;
        data["totalAuditVisits"] = this.totalAuditVisits;
        data["completedAuditVisits"] = this.completedAuditVisits;
        data["missingAuditVisits"] = this.missingAuditVisits;
        data["q1Sample"] = this.q1Sample;
        data["q2Sample"] = this.q2Sample;
        data["q3Sample"] = this.q3Sample;
        data["q4Sample"] = this.q4Sample;
        data["drivingDistance"] = this.drivingDistance;
        data["drivingTime"] = this.drivingTime;
        data["drivingToll"] = this.drivingToll;
        data["drivingCost"] = this.drivingCost;
        data["auditDuration"] = this.auditDuration;
        data["auditCost"] = this.auditCost;
        data["contractYearlySum"] = this.contractYearlySum;
        data["contractYearlyFee"] = this.contractYearlyFee;
        data["contractYearlyCostPrice"] = this.contractYearlyCostPrice;
        data["contractYearlySalesPrice"] = this.contractYearlySalesPrice;
        data["contractYearlyEarningsCostPrice"] = this.contractYearlyEarningsCostPrice;
        data["contractYearlyEarningsSalesPrice"] = this.contractYearlyEarningsSalesPrice;
        data["contractYearlyRevisionAnalysisPlan"] = this.contractYearlyRevisionAnalysisPlan;
        data["contractYearlyRevision"] = this.contractYearlyRevision;
        data["contractUnannouncedAudits"] = this.contractUnannouncedAudits;
        return data;
    }

    clone(): VisitOverviewModel {
        const json = this.toJSON();
        let result = new VisitOverviewModel();
        result.init(json);
        return result;
    }
}

export interface IVisitOverviewModel {
    contractName?: string | undefined;
    contractNumber?: string | undefined;
    department?: string | undefined;
    address?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    controlRevision?: boolean | undefined;
    contactPersonName?: string | undefined;
    contactPersonPhone?: string | undefined;
    contactPersonEmail?: string | undefined;
    responsibleUserName?: string | undefined;
    organizationId?: string | undefined;
    lastVisit?: Date | undefined;
    q1AuditVisit?: number | undefined;
    q2AuditVisit?: number | undefined;
    q3AuditVisit?: number | undefined;
    q4AuditVisit?: number | undefined;
    totalAuditVisits?: number | undefined;
    completedAuditVisits?: number | undefined;
    missingAuditVisits?: number | undefined;
    q1Sample?: number | undefined;
    q2Sample?: number | undefined;
    q3Sample?: number | undefined;
    q4Sample?: number | undefined;
    drivingDistance?: number;
    drivingTime?: number;
    drivingToll?: number;
    drivingCost?: number;
    auditDuration?: number;
    auditCost?: number;
    contractYearlySum?: number;
    contractYearlyFee?: number;
    contractYearlyCostPrice?: number;
    contractYearlySalesPrice?: number;
    contractYearlyEarningsCostPrice?: number;
    contractYearlyEarningsSalesPrice?: number;
    contractYearlyRevisionAnalysisPlan?: number | undefined;
    contractYearlyRevision?: number | undefined;
    contractUnannouncedAudits?: number | undefined;
}

export class CtrContactPersonModel implements ICtrContactPersonModel {
    id?: string;
    name?: string | undefined;
    customerContactNumber?: number;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICtrContactPersonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.customerContactNumber = _data["customerContactNumber"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CtrContactPersonModel {
        data = typeof data === 'object' ? data : {};
        let result = new CtrContactPersonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["customerContactNumber"] = this.customerContactNumber;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }

    clone(): CtrContactPersonModel {
        const json = this.toJSON();
        let result = new CtrContactPersonModel();
        result.init(json);
        return result;
    }
}

export interface ICtrContactPersonModel {
    id?: string;
    name?: string | undefined;
    customerContactNumber?: number;
    phone?: string | undefined;
    email?: string | undefined;
}

export class CtrSubscriptionHostingModel implements ICtrSubscriptionHostingModel {
    id?: string;
    customerId?: string;
    customer?: CtrCustomerModel | undefined;
    billingMonth?: number;
    billingPeriod?: number;
    billedUntil?: Date;
    monthlyHostingFee?: number;
    yearlyCertificateFee?: number;
    cookieFee?: number;
    paymentGatewayFee?: number;
    mailchimpFee?: number;
    specialFeature1Count?: number;
    specialFeature1Text?: string | undefined;
    specialFeature1Price?: number;
    specialFeature2Count?: number;
    specialFeature2Text?: string | undefined;
    specialFeature2Price?: number;

    constructor(data?: ICtrSubscriptionHostingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CtrCustomerModel.fromJS(_data["customer"]) : undefined as any;
            this.billingMonth = _data["billingMonth"];
            this.billingPeriod = _data["billingPeriod"];
            this.billedUntil = _data["billedUntil"] ? new Date(_data["billedUntil"].toString()) : undefined as any;
            this.monthlyHostingFee = _data["monthlyHostingFee"];
            this.yearlyCertificateFee = _data["yearlyCertificateFee"];
            this.cookieFee = _data["cookieFee"];
            this.paymentGatewayFee = _data["paymentGatewayFee"];
            this.mailchimpFee = _data["mailchimpFee"];
            this.specialFeature1Count = _data["specialFeature1Count"];
            this.specialFeature1Text = _data["specialFeature1Text"];
            this.specialFeature1Price = _data["specialFeature1Price"];
            this.specialFeature2Count = _data["specialFeature2Count"];
            this.specialFeature2Text = _data["specialFeature2Text"];
            this.specialFeature2Price = _data["specialFeature2Price"];
        }
    }

    static fromJS(data: any): CtrSubscriptionHostingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CtrSubscriptionHostingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["billingMonth"] = this.billingMonth;
        data["billingPeriod"] = this.billingPeriod;
        data["billedUntil"] = this.billedUntil ? this.billedUntil.toISOString() : undefined as any;
        data["monthlyHostingFee"] = this.monthlyHostingFee;
        data["yearlyCertificateFee"] = this.yearlyCertificateFee;
        data["cookieFee"] = this.cookieFee;
        data["paymentGatewayFee"] = this.paymentGatewayFee;
        data["mailchimpFee"] = this.mailchimpFee;
        data["specialFeature1Count"] = this.specialFeature1Count;
        data["specialFeature1Text"] = this.specialFeature1Text;
        data["specialFeature1Price"] = this.specialFeature1Price;
        data["specialFeature2Count"] = this.specialFeature2Count;
        data["specialFeature2Text"] = this.specialFeature2Text;
        data["specialFeature2Price"] = this.specialFeature2Price;
        return data;
    }

    clone(): CtrSubscriptionHostingModel {
        const json = this.toJSON();
        let result = new CtrSubscriptionHostingModel();
        result.init(json);
        return result;
    }
}

export interface ICtrSubscriptionHostingModel {
    id?: string;
    customerId?: string;
    customer?: CtrCustomerModel | undefined;
    billingMonth?: number;
    billingPeriod?: number;
    billedUntil?: Date;
    monthlyHostingFee?: number;
    yearlyCertificateFee?: number;
    cookieFee?: number;
    paymentGatewayFee?: number;
    mailchimpFee?: number;
    specialFeature1Count?: number;
    specialFeature1Text?: string | undefined;
    specialFeature1Price?: number;
    specialFeature2Count?: number;
    specialFeature2Text?: string | undefined;
    specialFeature2Price?: number;
}

export class CtrSubscriptionQSModel implements ICtrSubscriptionQSModel {
    id?: string;
    customerId?: string;
    customer?: CtrCustomerModel | undefined;
    billingMonth?: number;
    billingPeriod?: number;
    billedUntil?: Date;
    fullCount?: number;
    haccpCount?: number;
    productionCount?: number;
    basisCount?: number;
    shopCount?: number;
    extraBasicUserCount?: number;
    extraFullUserCount?: number;
    specialFeature1Count?: number;
    specialFeature1Text?: string | undefined;
    specialFeature1Price?: number;
    specialFeature2Count?: number;
    specialFeature2Text?: string | undefined;
    specialFeature2Price?: number;
    monthlyPrice?: number;

    constructor(data?: ICtrSubscriptionQSModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CtrCustomerModel.fromJS(_data["customer"]) : undefined as any;
            this.billingMonth = _data["billingMonth"];
            this.billingPeriod = _data["billingPeriod"];
            this.billedUntil = _data["billedUntil"] ? new Date(_data["billedUntil"].toString()) : undefined as any;
            this.fullCount = _data["fullCount"];
            this.haccpCount = _data["haccpCount"];
            this.productionCount = _data["productionCount"];
            this.basisCount = _data["basisCount"];
            this.shopCount = _data["shopCount"];
            this.extraBasicUserCount = _data["extraBasicUserCount"];
            this.extraFullUserCount = _data["extraFullUserCount"];
            this.specialFeature1Count = _data["specialFeature1Count"];
            this.specialFeature1Text = _data["specialFeature1Text"];
            this.specialFeature1Price = _data["specialFeature1Price"];
            this.specialFeature2Count = _data["specialFeature2Count"];
            this.specialFeature2Text = _data["specialFeature2Text"];
            this.specialFeature2Price = _data["specialFeature2Price"];
            this.monthlyPrice = _data["monthlyPrice"];
        }
    }

    static fromJS(data: any): CtrSubscriptionQSModel {
        data = typeof data === 'object' ? data : {};
        let result = new CtrSubscriptionQSModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["billingMonth"] = this.billingMonth;
        data["billingPeriod"] = this.billingPeriod;
        data["billedUntil"] = this.billedUntil ? this.billedUntil.toISOString() : undefined as any;
        data["fullCount"] = this.fullCount;
        data["haccpCount"] = this.haccpCount;
        data["productionCount"] = this.productionCount;
        data["basisCount"] = this.basisCount;
        data["shopCount"] = this.shopCount;
        data["extraBasicUserCount"] = this.extraBasicUserCount;
        data["extraFullUserCount"] = this.extraFullUserCount;
        data["specialFeature1Count"] = this.specialFeature1Count;
        data["specialFeature1Text"] = this.specialFeature1Text;
        data["specialFeature1Price"] = this.specialFeature1Price;
        data["specialFeature2Count"] = this.specialFeature2Count;
        data["specialFeature2Text"] = this.specialFeature2Text;
        data["specialFeature2Price"] = this.specialFeature2Price;
        data["monthlyPrice"] = this.monthlyPrice;
        return data;
    }

    clone(): CtrSubscriptionQSModel {
        const json = this.toJSON();
        let result = new CtrSubscriptionQSModel();
        result.init(json);
        return result;
    }
}

export interface ICtrSubscriptionQSModel {
    id?: string;
    customerId?: string;
    customer?: CtrCustomerModel | undefined;
    billingMonth?: number;
    billingPeriod?: number;
    billedUntil?: Date;
    fullCount?: number;
    haccpCount?: number;
    productionCount?: number;
    basisCount?: number;
    shopCount?: number;
    extraBasicUserCount?: number;
    extraFullUserCount?: number;
    specialFeature1Count?: number;
    specialFeature1Text?: string | undefined;
    specialFeature1Price?: number;
    specialFeature2Count?: number;
    specialFeature2Text?: string | undefined;
    specialFeature2Price?: number;
    monthlyPrice?: number;
}

export class VlBoardDto implements IVlBoardDto {
    id?: string | undefined;
    customerId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    taskTypes?: string | undefined;
    taskListTypes?: string | undefined;
    organizationId?: string;
    isDeleted?: boolean;
    relations?: VlTaskBoardRelation[] | undefined;

    constructor(data?: IVlBoardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.taskTypes = _data["taskTypes"];
            this.taskListTypes = _data["taskListTypes"];
            this.organizationId = _data["organizationId"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["relations"])) {
                this.relations = [] as any;
                for (let item of _data["relations"])
                    this.relations!.push(VlTaskBoardRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VlBoardDto {
        data = typeof data === 'object' ? data : {};
        let result = new VlBoardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["taskTypes"] = this.taskTypes;
        data["taskListTypes"] = this.taskListTypes;
        data["organizationId"] = this.organizationId;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.relations)) {
            data["relations"] = [];
            for (let item of this.relations)
                data["relations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): VlBoardDto {
        const json = this.toJSON();
        let result = new VlBoardDto();
        result.init(json);
        return result;
    }
}

export interface IVlBoardDto {
    id?: string | undefined;
    customerId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    taskTypes?: string | undefined;
    taskListTypes?: string | undefined;
    organizationId?: string;
    isDeleted?: boolean;
    relations?: VlTaskBoardRelation[] | undefined;
}

export class VlTaskBoardRelation extends QsBasicEntity implements IVlTaskBoardRelation {
    taskId?: string | undefined;
    boardId?: string | undefined;
    sortOrder?: number;
    task?: VlTask;
    board?: VlBoard;

    constructor(data?: IVlTaskBoardRelation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskId = _data["taskId"];
            this.boardId = _data["boardId"];
            this.sortOrder = _data["sortOrder"];
            this.task = _data["task"] ? VlTask.fromJS(_data["task"]) : undefined as any;
            this.board = _data["board"] ? VlBoard.fromJS(_data["board"]) : undefined as any;
        }
    }

    static override fromJS(data: any): VlTaskBoardRelation {
        data = typeof data === 'object' ? data : {};
        let result = new VlTaskBoardRelation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["boardId"] = this.boardId;
        data["sortOrder"] = this.sortOrder;
        data["task"] = this.task ? this.task.toJSON() : undefined as any;
        data["board"] = this.board ? this.board.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): VlTaskBoardRelation {
        const json = this.toJSON();
        let result = new VlTaskBoardRelation();
        result.init(json);
        return result;
    }
}

export interface IVlTaskBoardRelation extends IQsBasicEntity {
    taskId?: string | undefined;
    boardId?: string | undefined;
    sortOrder?: number;
    task?: VlTask;
    board?: VlBoard;
}

export class VlTask extends QsBasicEntity implements IVlTask {
    name?: string | undefined;
    description?: string | undefined;
    memberId?: number;
    customerId?: string | undefined;
    contactPersonId?: string | undefined;
    resposibleMember?: string | undefined;
    departmentId?: string | undefined;
    type?: CtrTaskType;
    status?: CtrTaskStatus;
    sortOrder?: number;
    priority?: number;
    estimatedHours?: number;
    deadline?: Date | undefined;
    gitHubIssue?: string | undefined;
    entityId?: string | undefined;
    taskState?: CtrTaskState;
    tags?: VlTaskTagRelation[] | undefined;
    vlTimeRegistrations?: VlTimeRegistration[];
    customer?: VlCustomer | undefined;

    constructor(data?: IVlTask) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.memberId = _data["memberId"];
            this.customerId = _data["customerId"];
            this.contactPersonId = _data["contactPersonId"];
            this.resposibleMember = _data["resposibleMember"];
            this.departmentId = _data["departmentId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.sortOrder = _data["sortOrder"];
            this.priority = _data["priority"];
            this.estimatedHours = _data["estimatedHours"];
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : undefined as any;
            this.gitHubIssue = _data["gitHubIssue"];
            this.entityId = _data["entityId"];
            this.taskState = _data["taskState"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(VlTaskTagRelation.fromJS(item));
            }
            if (Array.isArray(_data["vlTimeRegistrations"])) {
                this.vlTimeRegistrations = [] as any;
                for (let item of _data["vlTimeRegistrations"])
                    this.vlTimeRegistrations!.push(VlTimeRegistration.fromJS(item));
            }
            this.customer = _data["customer"] ? VlCustomer.fromJS(_data["customer"]) : undefined as any;
        }
    }

    static override fromJS(data: any): VlTask {
        data = typeof data === 'object' ? data : {};
        let result = new VlTask();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["memberId"] = this.memberId;
        data["customerId"] = this.customerId;
        data["contactPersonId"] = this.contactPersonId;
        data["resposibleMember"] = this.resposibleMember;
        data["departmentId"] = this.departmentId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["sortOrder"] = this.sortOrder;
        data["priority"] = this.priority;
        data["estimatedHours"] = this.estimatedHours;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : undefined as any;
        data["gitHubIssue"] = this.gitHubIssue;
        data["entityId"] = this.entityId;
        data["taskState"] = this.taskState;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.vlTimeRegistrations)) {
            data["vlTimeRegistrations"] = [];
            for (let item of this.vlTimeRegistrations)
                data["vlTimeRegistrations"].push(item ? item.toJSON() : undefined as any);
        }
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): VlTask {
        const json = this.toJSON();
        let result = new VlTask();
        result.init(json);
        return result;
    }
}

export interface IVlTask extends IQsBasicEntity {
    name?: string | undefined;
    description?: string | undefined;
    memberId?: number;
    customerId?: string | undefined;
    contactPersonId?: string | undefined;
    resposibleMember?: string | undefined;
    departmentId?: string | undefined;
    type?: CtrTaskType;
    status?: CtrTaskStatus;
    sortOrder?: number;
    priority?: number;
    estimatedHours?: number;
    deadline?: Date | undefined;
    gitHubIssue?: string | undefined;
    entityId?: string | undefined;
    taskState?: CtrTaskState;
    tags?: VlTaskTagRelation[] | undefined;
    vlTimeRegistrations?: VlTimeRegistration[];
    customer?: VlCustomer | undefined;
}

export class VlTaskTagRelation extends QsBasicEntity implements IVlTaskTagRelation {
    taskId?: string;
    task?: VlTask;
    tagId?: string;
    tag?: VlTag;

    constructor(data?: IVlTaskTagRelation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskId = _data["taskId"];
            this.task = _data["task"] ? VlTask.fromJS(_data["task"]) : undefined as any;
            this.tagId = _data["tagId"];
            this.tag = _data["tag"] ? VlTag.fromJS(_data["tag"]) : undefined as any;
        }
    }

    static override fromJS(data: any): VlTaskTagRelation {
        data = typeof data === 'object' ? data : {};
        let result = new VlTaskTagRelation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["task"] = this.task ? this.task.toJSON() : undefined as any;
        data["tagId"] = this.tagId;
        data["tag"] = this.tag ? this.tag.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): VlTaskTagRelation {
        const json = this.toJSON();
        let result = new VlTaskTagRelation();
        result.init(json);
        return result;
    }
}

export interface IVlTaskTagRelation extends IQsBasicEntity {
    taskId?: string;
    task?: VlTask;
    tagId?: string;
    tag?: VlTag;
}

export class VlTag extends QsBasicEntity implements IVlTag {
    name?: string;
    githubId?: number | undefined;
    githubColor?: string | undefined;
    tasks?: VlTaskTagRelation[] | undefined;

    constructor(data?: IVlTag) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.githubId = _data["githubId"];
            this.githubColor = _data["githubColor"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(VlTaskTagRelation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): VlTag {
        data = typeof data === 'object' ? data : {};
        let result = new VlTag();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["githubId"] = this.githubId;
        data["githubColor"] = this.githubColor;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): VlTag {
        const json = this.toJSON();
        let result = new VlTag();
        result.init(json);
        return result;
    }
}

export interface IVlTag extends IQsBasicEntity {
    name?: string;
    githubId?: number | undefined;
    githubColor?: string | undefined;
    tasks?: VlTaskTagRelation[] | undefined;
}

export class VlTimeRegistration extends QsBasicEntity implements IVlTimeRegistration {
    taskDescription?: string | undefined;
    duration?: number | undefined;
    startDate?: Date | undefined;
    memberId?: number;
    customerId?: string;
    contactPersonId?: string | undefined;
    taskId?: string;
    isInvoiced?: boolean;
    isFixedPrice?: boolean;
    notBillable?: boolean;
    transportDistance?: number | undefined;
    transportSku?: number | undefined;
    transportTime?: number | undefined;
    notBillableTime?: number | undefined;
    expenses?: number | undefined;
    expenseDescription?: string | undefined;
    contactPerson?: VlContactPerson | undefined;
    customer?: VlCustomer;
    task?: VlTask;

    constructor(data?: IVlTimeRegistration) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskDescription = _data["taskDescription"];
            this.duration = _data["duration"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.memberId = _data["memberId"];
            this.customerId = _data["customerId"];
            this.contactPersonId = _data["contactPersonId"];
            this.taskId = _data["taskId"];
            this.isInvoiced = _data["isInvoiced"];
            this.isFixedPrice = _data["isFixedPrice"];
            this.notBillable = _data["notBillable"];
            this.transportDistance = _data["transportDistance"];
            this.transportSku = _data["transportSku"];
            this.transportTime = _data["transportTime"];
            this.notBillableTime = _data["notBillableTime"];
            this.expenses = _data["expenses"];
            this.expenseDescription = _data["expenseDescription"];
            this.contactPerson = _data["contactPerson"] ? VlContactPerson.fromJS(_data["contactPerson"]) : undefined as any;
            this.customer = _data["customer"] ? VlCustomer.fromJS(_data["customer"]) : undefined as any;
            this.task = _data["task"] ? VlTask.fromJS(_data["task"]) : undefined as any;
        }
    }

    static override fromJS(data: any): VlTimeRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new VlTimeRegistration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskDescription"] = this.taskDescription;
        data["duration"] = this.duration;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["memberId"] = this.memberId;
        data["customerId"] = this.customerId;
        data["contactPersonId"] = this.contactPersonId;
        data["taskId"] = this.taskId;
        data["isInvoiced"] = this.isInvoiced;
        data["isFixedPrice"] = this.isFixedPrice;
        data["notBillable"] = this.notBillable;
        data["transportDistance"] = this.transportDistance;
        data["transportSku"] = this.transportSku;
        data["transportTime"] = this.transportTime;
        data["notBillableTime"] = this.notBillableTime;
        data["expenses"] = this.expenses;
        data["expenseDescription"] = this.expenseDescription;
        data["contactPerson"] = this.contactPerson ? this.contactPerson.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["task"] = this.task ? this.task.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): VlTimeRegistration {
        const json = this.toJSON();
        let result = new VlTimeRegistration();
        result.init(json);
        return result;
    }
}

export interface IVlTimeRegistration extends IQsBasicEntity {
    taskDescription?: string | undefined;
    duration?: number | undefined;
    startDate?: Date | undefined;
    memberId?: number;
    customerId?: string;
    contactPersonId?: string | undefined;
    taskId?: string;
    isInvoiced?: boolean;
    isFixedPrice?: boolean;
    notBillable?: boolean;
    transportDistance?: number | undefined;
    transportSku?: number | undefined;
    transportTime?: number | undefined;
    notBillableTime?: number | undefined;
    expenses?: number | undefined;
    expenseDescription?: string | undefined;
    contactPerson?: VlContactPerson | undefined;
    customer?: VlCustomer;
    task?: VlTask;
}

export class VlContactPerson extends QsBasicEntity implements IVlContactPerson {
    name?: string;
    customerId?: string;
    customerContactNumber?: number | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    customer?: VlCustomer;
    vlTimeRegistrations?: VlTimeRegistration[];

    constructor(data?: IVlContactPerson) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.customerContactNumber = _data["customerContactNumber"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.customer = _data["customer"] ? VlCustomer.fromJS(_data["customer"]) : undefined as any;
            if (Array.isArray(_data["vlTimeRegistrations"])) {
                this.vlTimeRegistrations = [] as any;
                for (let item of _data["vlTimeRegistrations"])
                    this.vlTimeRegistrations!.push(VlTimeRegistration.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): VlContactPerson {
        data = typeof data === 'object' ? data : {};
        let result = new VlContactPerson();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["customerContactNumber"] = this.customerContactNumber;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        if (Array.isArray(this.vlTimeRegistrations)) {
            data["vlTimeRegistrations"] = [];
            for (let item of this.vlTimeRegistrations)
                data["vlTimeRegistrations"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): VlContactPerson {
        const json = this.toJSON();
        let result = new VlContactPerson();
        result.init(json);
        return result;
    }
}

export interface IVlContactPerson extends IQsBasicEntity {
    name?: string;
    customerId?: string;
    customerContactNumber?: number | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    customer?: VlCustomer;
    vlTimeRegistrations?: VlTimeRegistration[];
}

export class VlCustomer extends QsBasicEntity implements IVlCustomer {
    customerNumber?: number | undefined;
    customerName?: string;
    isActive?: boolean;
    standardSku?: number | undefined;
    customerGroupNumber?: number | undefined;
    transportDistance?: number | undefined;
    transportSku?: number | undefined;
    transportFixedPrice?: number;
    invoiceEmail?: string | undefined;
    invoiceEmailCC?: string | undefined;
    standardHeadingText?: string | undefined;
    reference?: string | undefined;
    address1?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    cvr?: string | undefined;
    invoiceFrequency?: number;
    lastInvoiceDate?: Date | undefined;
    vlContactPeople?: VlContactPerson[];
    vlTimeRegistrations?: VlTimeRegistration[];
    vlTasks?: VlTask[];

    constructor(data?: IVlCustomer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerNumber = _data["customerNumber"];
            this.customerName = _data["customerName"];
            this.isActive = _data["isActive"];
            this.standardSku = _data["standardSku"];
            this.customerGroupNumber = _data["customerGroupNumber"];
            this.transportDistance = _data["transportDistance"];
            this.transportSku = _data["transportSku"];
            this.transportFixedPrice = _data["transportFixedPrice"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.invoiceEmailCC = _data["invoiceEmailCC"];
            this.standardHeadingText = _data["standardHeadingText"];
            this.reference = _data["reference"];
            this.address1 = _data["address1"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.cvr = _data["cvr"];
            this.invoiceFrequency = _data["invoiceFrequency"];
            this.lastInvoiceDate = _data["lastInvoiceDate"] ? new Date(_data["lastInvoiceDate"].toString()) : undefined as any;
            if (Array.isArray(_data["vlContactPeople"])) {
                this.vlContactPeople = [] as any;
                for (let item of _data["vlContactPeople"])
                    this.vlContactPeople!.push(VlContactPerson.fromJS(item));
            }
            if (Array.isArray(_data["vlTimeRegistrations"])) {
                this.vlTimeRegistrations = [] as any;
                for (let item of _data["vlTimeRegistrations"])
                    this.vlTimeRegistrations!.push(VlTimeRegistration.fromJS(item));
            }
            if (Array.isArray(_data["vlTasks"])) {
                this.vlTasks = [] as any;
                for (let item of _data["vlTasks"])
                    this.vlTasks!.push(VlTask.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): VlCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new VlCustomer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerNumber"] = this.customerNumber;
        data["customerName"] = this.customerName;
        data["isActive"] = this.isActive;
        data["standardSku"] = this.standardSku;
        data["customerGroupNumber"] = this.customerGroupNumber;
        data["transportDistance"] = this.transportDistance;
        data["transportSku"] = this.transportSku;
        data["transportFixedPrice"] = this.transportFixedPrice;
        data["invoiceEmail"] = this.invoiceEmail;
        data["invoiceEmailCC"] = this.invoiceEmailCC;
        data["standardHeadingText"] = this.standardHeadingText;
        data["reference"] = this.reference;
        data["address1"] = this.address1;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["country"] = this.country;
        data["cvr"] = this.cvr;
        data["invoiceFrequency"] = this.invoiceFrequency;
        data["lastInvoiceDate"] = this.lastInvoiceDate ? this.lastInvoiceDate.toISOString() : undefined as any;
        if (Array.isArray(this.vlContactPeople)) {
            data["vlContactPeople"] = [];
            for (let item of this.vlContactPeople)
                data["vlContactPeople"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.vlTimeRegistrations)) {
            data["vlTimeRegistrations"] = [];
            for (let item of this.vlTimeRegistrations)
                data["vlTimeRegistrations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.vlTasks)) {
            data["vlTasks"] = [];
            for (let item of this.vlTasks)
                data["vlTasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): VlCustomer {
        const json = this.toJSON();
        let result = new VlCustomer();
        result.init(json);
        return result;
    }
}

export interface IVlCustomer extends IQsBasicEntity {
    customerNumber?: number | undefined;
    customerName?: string;
    isActive?: boolean;
    standardSku?: number | undefined;
    customerGroupNumber?: number | undefined;
    transportDistance?: number | undefined;
    transportSku?: number | undefined;
    transportFixedPrice?: number;
    invoiceEmail?: string | undefined;
    invoiceEmailCC?: string | undefined;
    standardHeadingText?: string | undefined;
    reference?: string | undefined;
    address1?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    cvr?: string | undefined;
    invoiceFrequency?: number;
    lastInvoiceDate?: Date | undefined;
    vlContactPeople?: VlContactPerson[];
    vlTimeRegistrations?: VlTimeRegistration[];
    vlTasks?: VlTask[];
}

export class VlBoard extends QsBasicEntity implements IVlBoard {
    customerId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    taskTypes?: string | undefined;
    taskListTypes?: string | undefined;
    customer?: VlCustomer;
    relations?: VlTaskBoardRelation[] | undefined;

    constructor(data?: IVlBoard) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.taskTypes = _data["taskTypes"];
            this.taskListTypes = _data["taskListTypes"];
            this.customer = _data["customer"] ? VlCustomer.fromJS(_data["customer"]) : undefined as any;
            if (Array.isArray(_data["relations"])) {
                this.relations = [] as any;
                for (let item of _data["relations"])
                    this.relations!.push(VlTaskBoardRelation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): VlBoard {
        data = typeof data === 'object' ? data : {};
        let result = new VlBoard();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["taskTypes"] = this.taskTypes;
        data["taskListTypes"] = this.taskListTypes;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        if (Array.isArray(this.relations)) {
            data["relations"] = [];
            for (let item of this.relations)
                data["relations"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): VlBoard {
        const json = this.toJSON();
        let result = new VlBoard();
        result.init(json);
        return result;
    }
}

export interface IVlBoard extends IQsBasicEntity {
    customerId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    taskTypes?: string | undefined;
    taskListTypes?: string | undefined;
    customer?: VlCustomer;
    relations?: VlTaskBoardRelation[] | undefined;
}

export class VlRelationDto implements IVlRelationDto {
    id?: string;
    taskId?: string | undefined;
    boardId?: string | undefined;
    sortOrder?: number;

    constructor(data?: IVlRelationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.boardId = _data["boardId"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): VlRelationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VlRelationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["boardId"] = this.boardId;
        data["sortOrder"] = this.sortOrder;
        return data;
    }

    clone(): VlRelationDto {
        const json = this.toJSON();
        let result = new VlRelationDto();
        result.init(json);
        return result;
    }
}

export interface IVlRelationDto {
    id?: string;
    taskId?: string | undefined;
    boardId?: string | undefined;
    sortOrder?: number;
}

export class CtrRegistrationModel implements ICtrRegistrationModel {
    id?: string;
    customer?: CtrCustomerModel | undefined;
    contactPerson?: CtrContactPersonModel | undefined;
    task?: CtrTaskModel | undefined;
    contactPersonId?: string | undefined;
    taskDescription?: string | undefined;
    duration?: number | undefined;
    isInvoiced?: boolean;
    isFixedPrice?: boolean;
    transportDistance?: number | undefined;
    transportTime?: number | undefined;
    notBillableTime?: number | undefined;
    expenses?: number | undefined;
    expenseDescription?: string | undefined;
    startDate?: Date | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    memberId?: number;
    memberName?: string | undefined;

    constructor(data?: ICtrRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customer = _data["customer"] ? CtrCustomerModel.fromJS(_data["customer"]) : undefined as any;
            this.contactPerson = _data["contactPerson"] ? CtrContactPersonModel.fromJS(_data["contactPerson"]) : undefined as any;
            this.task = _data["task"] ? CtrTaskModel.fromJS(_data["task"]) : undefined as any;
            this.contactPersonId = _data["contactPersonId"];
            this.taskDescription = _data["taskDescription"];
            this.duration = _data["duration"];
            this.isInvoiced = _data["isInvoiced"];
            this.isFixedPrice = _data["isFixedPrice"];
            this.transportDistance = _data["transportDistance"];
            this.transportTime = _data["transportTime"];
            this.notBillableTime = _data["notBillableTime"];
            this.expenses = _data["expenses"];
            this.expenseDescription = _data["expenseDescription"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.memberId = _data["memberId"];
            this.memberName = _data["memberName"];
        }
    }

    static fromJS(data: any): CtrRegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CtrRegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["contactPerson"] = this.contactPerson ? this.contactPerson.toJSON() : undefined as any;
        data["task"] = this.task ? this.task.toJSON() : undefined as any;
        data["contactPersonId"] = this.contactPersonId;
        data["taskDescription"] = this.taskDescription;
        data["duration"] = this.duration;
        data["isInvoiced"] = this.isInvoiced;
        data["isFixedPrice"] = this.isFixedPrice;
        data["transportDistance"] = this.transportDistance;
        data["transportTime"] = this.transportTime;
        data["notBillableTime"] = this.notBillableTime;
        data["expenses"] = this.expenses;
        data["expenseDescription"] = this.expenseDescription;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["memberId"] = this.memberId;
        data["memberName"] = this.memberName;
        return data;
    }

    clone(): CtrRegistrationModel {
        const json = this.toJSON();
        let result = new CtrRegistrationModel();
        result.init(json);
        return result;
    }
}

export interface ICtrRegistrationModel {
    id?: string;
    customer?: CtrCustomerModel | undefined;
    contactPerson?: CtrContactPersonModel | undefined;
    task?: CtrTaskModel | undefined;
    contactPersonId?: string | undefined;
    taskDescription?: string | undefined;
    duration?: number | undefined;
    isInvoiced?: boolean;
    isFixedPrice?: boolean;
    transportDistance?: number | undefined;
    transportTime?: number | undefined;
    notBillableTime?: number | undefined;
    expenses?: number | undefined;
    expenseDescription?: string | undefined;
    startDate?: Date | undefined;
    created?: Date | undefined;
    updated?: Date | undefined;
    memberId?: number;
    memberName?: string | undefined;
}

export class CtrRegistrationGroupModel implements ICtrRegistrationGroupModel {
    date?: Date;
    name?: string | undefined;
    total?: number;
    registrations?: CtrRegistrationModel[] | undefined;
    registrationGroups?: CtrRegistrationGroupModel[] | undefined;

    constructor(data?: ICtrRegistrationGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.name = _data["name"];
            this.total = _data["total"];
            if (Array.isArray(_data["registrations"])) {
                this.registrations = [] as any;
                for (let item of _data["registrations"])
                    this.registrations!.push(CtrRegistrationModel.fromJS(item));
            }
            if (Array.isArray(_data["registrationGroups"])) {
                this.registrationGroups = [] as any;
                for (let item of _data["registrationGroups"])
                    this.registrationGroups!.push(CtrRegistrationGroupModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CtrRegistrationGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new CtrRegistrationGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["name"] = this.name;
        data["total"] = this.total;
        if (Array.isArray(this.registrations)) {
            data["registrations"] = [];
            for (let item of this.registrations)
                data["registrations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.registrationGroups)) {
            data["registrationGroups"] = [];
            for (let item of this.registrationGroups)
                data["registrationGroups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CtrRegistrationGroupModel {
        const json = this.toJSON();
        let result = new CtrRegistrationGroupModel();
        result.init(json);
        return result;
    }
}

export interface ICtrRegistrationGroupModel {
    date?: Date;
    name?: string | undefined;
    total?: number;
    registrations?: CtrRegistrationModel[] | undefined;
    registrationGroups?: CtrRegistrationGroupModel[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();

            // Is this a "real" file? In other words, is this an instance of the original `File` class (not the one overriden by cordova-plugin-file).
            // If so, then we need to use the "real" FileReader (not the one overriden by cordova-plugin-file).
            if (blob instanceof Blob) {
                const realFileReader = (reader as any)._realReader;
                if (realFileReader) {
                reader = realFileReader;
                }
            }

            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };

            reader.readAsText(blob);
        }
    });
}